/*! jQuery v3.4.1 | (c) JS Foundation and other contributors | jquery.org/license */
/*!
 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
 *
 * @version 1.0.3
 * @codingstandard ftlabs-jsv2
 * @copyright The Financial Times Limited [All Rights Reserved]
 * @license MIT License (see LICENSE.txt)
 */
//function t(e,n){var o;if(n=n||{},this.trackingClick=!1,this.trackingClickStart=0,this.targetElement=null,this.touchStartX=0,this.touchStartY=0,this.lastTouchIdentifier=0,this.touchBoundary=n.touchBoundary||10,this.layer=e,this.tapDelay=n.tapDelay||200,!t.notNeeded(e)){for(var r=["onMouse","onClick","onTouchStart","onTouchMove","onTouchEnd","onTouchCancel"],s=this,a=0,l=r.length;a<l;a++)s[r[a]]=function(t,e){return function(){return t.apply(e,arguments)}}(s[r[a]],s);i&&(e.addEventListener("mouseover",this.onMouse,!0),e.addEventListener("mousedown",this.onMouse,!0),e.addEventListener("mouseup",this.onMouse,!0)),e.addEventListener("click",this.onClick,!0),e.addEventListener("touchstart",this.onTouchStart,!1),e.addEventListener("touchmove",this.onTouchMove,!1),e.addEventListener("touchend",this.onTouchEnd,!1),e.addEventListener("touchcancel",this.onTouchCancel,!1),Event.prototype.stopImmediatePropagation||(e.removeEventListener=function(t,n,i){var o=Node.prototype.removeEventListener;"click"===t?o.call(e,t,n.hijacked||n,i):o.call(e,t,n,i)},e.addEventListener=function(t,n,i){var o=Node.prototype.addEventListener;"click"===t?o.call(e,t,n.hijacked||(n.hijacked=function(t){t.propagationStopped||n(t)}),i):o.call(e,t,n,i)}),"function"==typeof e.onclick&&(o=e.onclick,e.addEventListener("click",(function(t){o(t)}),!1),e.onclick=null)}}var e,n;e="undefined"!=typeof window?window:this,n=function(t,e){function n(t,e,n){var i,o,r=(n=n||K).createElement("script");if(r.text=t,e)for(i in pt)(o=e[i]||e.getAttribute&&e.getAttribute(i))&&r.setAttribute(i,o);n.head.appendChild(r).parentNode.removeChild(r)}function i(t){return null==t?t+"":"object"==typeof t||"function"==typeof t?ot[rt.call(t)]||"object":typeof t}function o(t){var e=!!t&&"length"in t&&t.length,n=i(t);return!ct(t)&&!dt(t)&&("array"===n||0===e||"number"==typeof e&&0<e&&e-1 in t)}function r(t,e){return t.nodeName&&t.nodeName.toLowerCase()===e.toLowerCase()}function s(t,e,n){return ct(e)?ft.grep(t,(function(t,i){return!!e.call(t,i,t)!==n})):e.nodeType?ft.grep(t,(function(t){return t===e!==n})):"string"!=typeof e?ft.grep(t,(function(t){return-1<it.call(e,t)!==n})):ft.filter(e,t,n)}function a(t,e){for(;(t=t[e])&&1!==t.nodeType;);return t}function l(t){return t}function u(t){throw t}function c(t,e,n,i){var o;try{t&&ct(o=t.promise)?o.call(t).done(e).fail(n):t&&ct(o=t.then)?o.call(t,e,n):e.apply(void 0,[t].slice(i))}catch(t){n.apply(void 0,[t])}}function d(){K.removeEventListener("DOMContentLoaded",d),t.removeEventListener("load",d),ft.ready()}function p(t,e){return e.toUpperCase()}function h(t){return t.replace(Pt,"ms-").replace(Lt,p)}function f(){this.expando=ft.expando+f.uid++}function m(t,e,n){var i,o;if(void 0===n&&1===t.nodeType)if(i="data-"+e.replace(Nt,"-$&").toLowerCase(),"string"==typeof(n=t.getAttribute(i))){try{n="true"===(o=n)||"false"!==o&&("null"===o?null:o===+o+""?+o:jt.test(o)?JSON.parse(o):o)}catch(t){}Ot.set(t,e,n)}else n=void 0;return n}function g(t,e,n,i){var o,r,s=20,a=i?function(){return i.cur()}:function(){return ft.css(t,e,"")},l=a(),u=n&&n[3]||(ft.cssNumber[e]?"":"px"),c=t.nodeType&&(ft.cssNumber[e]||"px"!==u&&+l)&&Ht.exec(ft.css(t,e));if(c&&c[3]!==u){for(l/=2,u=u||c[3],c=+l||1;s--;)ft.style(t,e,c+u),(1-r)*(1-(r=a()/l||.5))<=0&&(s=0),c/=r;c*=2,ft.style(t,e,c+u),n=n||[]}return n&&(c=+c||+l||0,o=n[1]?c+(n[1]+1)*n[2]:+n[2],i&&(i.unit=u,i.start=c,i.end=o)),o}function v(t,e){for(var n,i,o,r,s,a,l,u=[],c=0,d=t.length;c<d;c++)(i=t[c]).style&&(n=i.style.display,e?("none"===n&&(u[c]=$t.get(i,"display")||null,u[c]||(i.style.display="")),""===i.style.display&&qt(i)&&(u[c]=(l=s=r=void 0,s=(o=i).ownerDocument,a=o.nodeName,(l=Wt[a])||(r=s.body.appendChild(s.createElement(a)),l=ft.css(r,"display"),r.parentNode.removeChild(r),"none"===l&&(l="block"),Wt[a]=l)))):"none"!==n&&(u[c]="none",$t.set(i,"display",n)));for(c=0;c<d;c++)null!=u[c]&&(t[c].style.display=u[c]);return t}function y(t,e){var n;return n=void 0!==t.getElementsByTagName?t.getElementsByTagName(e||"*"):void 0!==t.querySelectorAll?t.querySelectorAll(e||"*"):[],void 0===e||e&&r(t,e)?ft.merge([t],n):n}function w(t,e){for(var n=0,i=t.length;n<i;n++)$t.set(t[n],"globalEval",!e||$t.get(e[n],"globalEval"))}function b(t,e,n,o,r){for(var s,a,l,u,c,d,p=e.createDocumentFragment(),h=[],f=0,m=t.length;f<m;f++)if((s=t[f])||0===s)if("object"===i(s))ft.merge(h,s.nodeType?[s]:s);else if(Jt.test(s)){for(a=a||p.appendChild(e.createElement("div")),l=(Yt.exec(s)||["",""])[1].toLowerCase(),u=Ut[l]||Ut._default,a.innerHTML=u[1]+ft.htmlPrefilter(s)+u[2],d=u[0];d--;)a=a.lastChild;ft.merge(h,a.childNodes),(a=p.firstChild).textContent=""}else h.push(e.createTextNode(s));for(p.textContent="",f=0;s=h[f++];)if(o&&-1<ft.inArray(s,o))r&&r.push(s);else if(c=zt(s),a=y(p.appendChild(s),"script"),c&&w(a),n)for(d=0;s=a[d++];)Xt.test(s.type||"")&&n.push(s);return p}function x(){return!0}function _(){return!1}function C(t,e){return t===function(){try{return K.activeElement}catch(t){}}()==("focus"===e)}function k(t,e,n,i,o,r){var s,a;if("object"==typeof e){for(a in"string"!=typeof n&&(i=i||n,n=void 0),e)k(t,a,n,i,e[a],r);return t}if(null==i&&null==o?(o=n,i=n=void 0):null==o&&("string"==typeof n?(o=i,i=void 0):(o=i,i=n,n=void 0)),!1===o)o=_;else if(!o)return t;return 1===r&&(s=o,(o=function(t){return ft().off(t),s.apply(this,arguments)}).guid=s.guid||(s.guid=ft.guid++)),t.each((function(){ft.event.add(this,e,o,i,n)}))}function T(t,e,n){n?($t.set(t,e,!1),ft.event.add(t,e,{namespace:!1,handler:function(t){var i,o,r=$t.get(this,e);if(1&t.isTrigger&&this[e]){if(r.length)(ft.event.special[e]||{}).delegateType&&t.stopPropagation();else if(r=tt.call(arguments),$t.set(this,e,r),i=n(this,e),this[e](),r!==(o=$t.get(this,e))||i?$t.set(this,e,!1):o={},r!==o)return t.stopImmediatePropagation(),t.preventDefault(),o.value}else r.length&&($t.set(this,e,{value:ft.event.trigger(ft.extend(r[0],ft.Event.prototype),r.slice(1),this)}),t.stopImmediatePropagation())}})):void 0===$t.get(t,e)&&ft.event.add(t,e,x)}function S(t,e){return r(t,"table")&&r(11!==e.nodeType?e:e.firstChild,"tr")&&ft(t).children("tbody")[0]||t}function E(t){return t.type=(null!==t.getAttribute("type"))+"/"+t.type,t}function I(t){return"true/"===(t.type||"").slice(0,5)?t.type=t.type.slice(5):t.removeAttribute("type"),t}function P(t,e){var n,i,o,r,s,a,l,u;if(1===e.nodeType){if($t.hasData(t)&&(r=$t.access(t),s=$t.set(e,r),u=r.events))for(o in delete s.handle,s.events={},u)for(n=0,i=u[o].length;n<i;n++)ft.event.add(e,o,u[o][n]);Ot.hasData(t)&&(a=Ot.access(t),l=ft.extend({},a),Ot.set(e,l))}}function L(t,e,i,o){e=et.apply([],e);var r,s,a,l,u,c,d=0,p=t.length,h=p-1,f=e[0],m=ct(f);if(m||1<p&&"string"==typeof f&&!ut.checkClone&&ie.test(f))return t.each((function(n){var r=t.eq(n);m&&(e[0]=f.call(this,n,r.html())),L(r,e,i,o)}));if(p&&(s=(r=b(e,t[0].ownerDocument,!1,t,o)).firstChild,1===r.childNodes.length&&(r=s),s||o)){for(l=(a=ft.map(y(r,"script"),E)).length;d<p;d++)u=r,d!==h&&(u=ft.clone(u,!0,!0),l&&ft.merge(a,y(u,"script"))),i.call(t[d],u,d);if(l)for(c=a[a.length-1].ownerDocument,ft.map(a,I),d=0;d<l;d++)u=a[d],Xt.test(u.type||"")&&!$t.access(u,"globalEval")&&ft.contains(c,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?ft._evalUrl&&!u.noModule&&ft._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")}):n(u.textContent.replace(oe,""),u,c))}return t}function A(t,e,n){for(var i,o=e?ft.filter(e,t):t,r=0;null!=(i=o[r]);r++)n||1!==i.nodeType||ft.cleanData(y(i)),i.parentNode&&(n&&zt(i)&&w(y(i,"script")),i.parentNode.removeChild(i));return t}function $(t,e,n){var i,o,r,s,a=t.style;return(n=n||se(t))&&(""!==(s=n.getPropertyValue(e)||n[e])||zt(t)||(s=ft.style(t,e)),!ut.pixelBoxStyles()&&re.test(s)&&ae.test(e)&&(i=a.width,o=a.minWidth,r=a.maxWidth,a.minWidth=a.maxWidth=a.width=s,s=n.width,a.width=i,a.minWidth=o,a.maxWidth=r)),void 0!==s?s+"":s}function O(t,e){return{get:function(){if(!t())return(this.get=e).apply(this,arguments);delete this.get}}}function j(t){return ft.cssProps[t]||ce[t]||(t in ue?t:ce[t]=function(t){for(var e=t[0].toUpperCase()+t.slice(1),n=le.length;n--;)if((t=le[n]+e)in ue)return t}(t)||t)}function N(t,e,n){var i=Ht.exec(e);return i?Math.max(0,i[2]-(n||0))+(i[3]||"px"):e}function M(t,e,n,i,o,r){var s="width"===e?1:0,a=0,l=0;if(n===(i?"border":"content"))return 0;for(;s<4;s+=2)"margin"===n&&(l+=ft.css(t,n+Ft[s],!0,o)),i?("content"===n&&(l-=ft.css(t,"padding"+Ft[s],!0,o)),"margin"!==n&&(l-=ft.css(t,"border"+Ft[s]+"Width",!0,o))):(l+=ft.css(t,"padding"+Ft[s],!0,o),"padding"!==n?l+=ft.css(t,"border"+Ft[s]+"Width",!0,o):a+=ft.css(t,"border"+Ft[s]+"Width",!0,o));return!i&&0<=r&&(l+=Math.max(0,Math.ceil(t["offset"+e[0].toUpperCase()+e.slice(1)]-r-l-a-.5))||0),l}function H(t,e,n){var i=se(t),o=(!ut.boxSizingReliable()||n)&&"border-box"===ft.css(t,"boxSizing",!1,i),r=o,s=$(t,e,i),a="offset"+e[0].toUpperCase()+e.slice(1);if(re.test(s)){if(!n)return s;s="auto"}return(!ut.boxSizingReliable()&&o||"auto"===s||!parseFloat(s)&&"inline"===ft.css(t,"display",!1,i))&&t.getClientRects().length&&(o="border-box"===ft.css(t,"boxSizing",!1,i),(r=a in t)&&(s=t[a])),(s=parseFloat(s)||0)+M(t,e,n||(o?"border":"content"),r,i,s)+"px"}function F(t,e,n,i,o){return new F.prototype.init(t,e,n,i,o)}function D(){ge&&(!1===K.hidden&&t.requestAnimationFrame?t.requestAnimationFrame(D):t.setTimeout(D,ft.fx.interval),ft.fx.tick())}function z(){return t.setTimeout((function(){me=void 0})),me=Date.now()}function V(t,e){var n,i=0,o={height:t};for(e=e?1:0;i<4;i+=2-e)o["margin"+(n=Ft[i])]=o["padding"+n]=t;return e&&(o.opacity=o.width=t),o}function q(t,e,n){for(var i,o=(R.tweeners[e]||[]).concat(R.tweeners["*"]),r=0,s=o.length;r<s;r++)if(i=o[r].call(n,e,t))return i}function R(t,e,n){var i,o,r=0,s=R.prefilters.length,a=ft.Deferred().always((function(){delete l.elem})),l=function(){if(o)return!1;for(var e=me||z(),n=Math.max(0,u.startTime+u.duration-e),i=1-(n/u.duration||0),r=0,s=u.tweens.length;r<s;r++)u.tweens[r].run(i);return a.notifyWith(t,[u,i,n]),i<1&&s?n:(s||a.notifyWith(t,[u,1,0]),a.resolveWith(t,[u]),!1)},u=a.promise({elem:t,props:ft.extend({},e),opts:ft.extend(!0,{specialEasing:{},easing:ft.easing._default},n),originalProperties:e,originalOptions:n,startTime:me||z(),duration:n.duration,tweens:[],createTween:function(e,n){var i=ft.Tween(t,u.opts,e,n,u.opts.specialEasing[e]||u.opts.easing);return u.tweens.push(i),i},stop:function(e){var n=0,i=e?u.tweens.length:0;if(o)return this;for(o=!0;n<i;n++)u.tweens[n].run(1);return e?(a.notifyWith(t,[u,1,0]),a.resolveWith(t,[u,e])):a.rejectWith(t,[u,e]),this}}),c=u.props;for(function(t,e){var n,i,o,r,s;for(n in t)if(o=e[i=h(n)],r=t[n],Array.isArray(r)&&(o=r[1],r=t[n]=r[0]),n!==i&&(t[i]=r,delete t[n]),(s=ft.cssHooks[i])&&"expand"in s)for(n in r=s.expand(r),delete t[i],r)n in t||(t[n]=r[n],e[n]=o);else e[i]=o}(c,u.opts.specialEasing);r<s;r++)if(i=R.prefilters[r].call(u,t,c,u.opts))return ct(i.stop)&&(ft._queueHooks(u.elem,u.opts.queue).stop=i.stop.bind(i)),i;return ft.map(c,q,u),ct(u.opts.start)&&u.opts.start.call(t,u),u.progress(u.opts.progress).done(u.opts.done,u.opts.complete).fail(u.opts.fail).always(u.opts.always),ft.fx.timer(ft.extend(l,{elem:t,anim:u,queue:u.opts.queue})),u}function W(t){return(t.match(Tt)||[]).join(" ")}function B(t){return t.getAttribute&&t.getAttribute("class")||""}function Y(t){return Array.isArray(t)?t:"string"==typeof t&&t.match(Tt)||[]}function X(t,e,n,o){var r;if(Array.isArray(e))ft.each(e,(function(e,i){n||Ae.test(t)?o(t,i):X(t+"["+("object"==typeof i&&null!=i?e:"")+"]",i,n,o)}));else if(n||"object"!==i(e))o(t,e);else for(r in e)X(t+"["+r+"]",e[r],n,o)}function U(t){return function(e,n){"string"!=typeof e&&(n=e,e="*");var i,o=0,r=e.toLowerCase().match(Tt)||[];if(ct(n))for(;i=r[o++];)"+"===i[0]?(i=i.slice(1)||"*",(t[i]=t[i]||[]).unshift(n)):(t[i]=t[i]||[]).push(n)}}function G(t,e,n,i){function o(a){var l;return r[a]=!0,ft.each(t[a]||[],(function(t,a){var u=a(e,n,i);return"string"!=typeof u||s||r[u]?s?!(l=u):void 0:(e.dataTypes.unshift(u),o(u),!1)})),l}var r={},s=t===qe;return o(e.dataTypes[0])||!r["*"]&&o("*")}function Q(t,e){var n,i,o=ft.ajaxSettings.flatOptions||{};for(n in e)void 0!==e[n]&&((o[n]?t:i||(i={}))[n]=e[n]);return i&&ft.extend(!0,t,i),t}var J=[],K=t.document,Z=Object.getPrototypeOf,tt=J.slice,et=J.concat,nt=J.push,it=J.indexOf,ot={},rt=ot.toString,st=ot.hasOwnProperty,at=st.toString,lt=at.call(Object),ut={},ct=function(t){return"function"==typeof t&&"number"!=typeof t.nodeType},dt=function(t){return null!=t&&t===t.window},pt={type:!0,src:!0,nonce:!0,noModule:!0},ht="3.4.1",ft=function(t,e){return new ft.fn.init(t,e)},mt=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;ft.fn=ft.prototype={jquery:ht,constructor:ft,length:0,toArray:function(){return tt.call(this)},get:function(t){return null==t?tt.call(this):t<0?this[t+this.length]:this[t]},pushStack:function(t){var e=ft.merge(this.constructor(),t);return e.prevObject=this,e},each:function(t){return ft.each(this,t)},map:function(t){return this.pushStack(ft.map(this,(function(e,n){return t.call(e,n,e)})))},slice:function(){return this.pushStack(tt.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(t){var e=this.length,n=+t+(t<0?e:0);return this.pushStack(0<=n&&n<e?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:nt,sort:J.sort,splice:J.splice},ft.extend=ft.fn.extend=function(){var t,e,n,i,o,r,s=arguments[0]||{},a=1,l=arguments.length,u=!1;for("boolean"==typeof s&&(u=s,s=arguments[a]||{},a++),"object"==typeof s||ct(s)||(s={}),a===l&&(s=this,a--);a<l;a++)if(null!=(t=arguments[a]))for(e in t)i=t[e],"__proto__"!==e&&s!==i&&(u&&i&&(ft.isPlainObject(i)||(o=Array.isArray(i)))?(n=s[e],r=o&&!Array.isArray(n)?[]:o||ft.isPlainObject(n)?n:{},o=!1,s[e]=ft.extend(u,r,i)):void 0!==i&&(s[e]=i));return s},ft.extend({expando:"jQuery"+(ht+Math.random()).replace(/\D/g,""),isReady:!0,error:function(t){throw new Error(t)},noop:function(){},isPlainObject:function(t){var e,n;return!(!t||"[object Object]"!==rt.call(t)||(e=Z(t))&&("function"!=typeof(n=st.call(e,"constructor")&&e.constructor)||at.call(n)!==lt))},isEmptyObject:function(t){var e;for(e in t)return!1;return!0},globalEval:function(t,e){n(t,{nonce:e&&e.nonce})},each:function(t,e){var n,i=0;if(o(t))for(n=t.length;i<n&&!1!==e.call(t[i],i,t[i]);i++);else for(i in t)if(!1===e.call(t[i],i,t[i]))break;return t},trim:function(t){return null==t?"":(t+"").replace(mt,"")},makeArray:function(t,e){var n=e||[];return null!=t&&(o(Object(t))?ft.merge(n,"string"==typeof t?[t]:t):nt.call(n,t)),n},inArray:function(t,e,n){return null==e?-1:it.call(e,t,n)},merge:function(t,e){for(var n=+e.length,i=0,o=t.length;i<n;i++)t[o++]=e[i];return t.length=o,t},grep:function(t,e,n){for(var i=[],o=0,r=t.length,s=!n;o<r;o++)!e(t[o],o)!==s&&i.push(t[o]);return i},map:function(t,e,n){var i,r,s=0,a=[];if(o(t))for(i=t.length;s<i;s++)null!=(r=e(t[s],s,n))&&a.push(r);else for(s in t)null!=(r=e(t[s],s,n))&&a.push(r);return et.apply([],a)},guid:1,support:ut}),"function"==typeof Symbol&&(ft.fn[Symbol.iterator]=J[Symbol.iterator]),ft.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),(function(t,e){ot["[object "+e+"]"]=e.toLowerCase()}));var gt=function(t){function e(t,e,n,i){var o,r,s,a,l,c,p,h=e&&e.ownerDocument,f=e?e.nodeType:9;if(n=n||[],"string"!=typeof t||!t||1!==f&&9!==f&&11!==f)return n;if(!i&&((e?e.ownerDocument||e:H)!==P&&I(e),e=e||P,A)){if(11!==f&&(l=mt.exec(t)))if(o=l[1]){if(9===f){if(!(s=e.getElementById(o)))return n;if(s.id===o)return n.push(s),n}else if(h&&(s=h.getElementById(o))&&N(e,s)&&s.id===o)return n.push(s),n}else{if(l[2])return G.apply(n,e.getElementsByTagName(t)),n;if((o=l[3])&&y.getElementsByClassName&&e.getElementsByClassName)return G.apply(n,e.getElementsByClassName(o)),n}if(y.qsa&&!R[t+" "]&&(!$||!$.test(t))&&(1!==f||"object"!==e.nodeName.toLowerCase())){if(p=t,h=e,1===f&&at.test(t)){for((a=e.getAttribute("id"))?a=a.replace(wt,bt):e.setAttribute("id",a=M),r=(c=_(t)).length;r--;)c[r]="#"+a+" "+d(c[r]);p=c.join(","),h=gt.test(t)&&u(e.parentNode)||e}try{return G.apply(n,h.querySelectorAll(p)),n}catch(e){R(t,!0)}finally{a===M&&e.removeAttribute("id")}}}return k(t.replace(ot,"$1"),e,n,i)}function n(){var t=[];return function e(n,i){return t.push(n+" ")>w.cacheLength&&delete e[t.shift()],e[n+" "]=i}}function i(t){return t[M]=!0,t}function o(t){var e=P.createElement("fieldset");try{return!!t(e)}catch(t){return!1}finally{e.parentNode&&e.parentNode.removeChild(e),e=null}}function r(t,e){for(var n=t.split("|"),i=n.length;i--;)w.attrHandle[n[i]]=e}function s(t,e){var n=e&&t,i=n&&1===t.nodeType&&1===e.nodeType&&t.sourceIndex-e.sourceIndex;if(i)return i;if(n)for(;n=n.nextSibling;)if(n===e)return-1;return t?1:-1}function a(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&_t(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function l(t){return i((function(e){return e=+e,i((function(n,i){for(var o,r=t([],n.length,e),s=r.length;s--;)n[o=r[s]]&&(n[o]=!(i[o]=n[o]))}))}))}function u(t){return t&&void 0!==t.getElementsByTagName&&t}function c(){}function d(t){for(var e=0,n=t.length,i="";e<n;e++)i+=t[e].value;return i}function p(t,e,n){var i=e.dir,o=e.next,r=o||i,s=n&&"parentNode"===r,a=D++;return e.first?function(e,n,o){for(;e=e[i];)if(1===e.nodeType||s)return t(e,n,o);return!1}:function(e,n,l){var u,c,d,p=[F,a];if(l){for(;e=e[i];)if((1===e.nodeType||s)&&t(e,n,l))return!0}else for(;e=e[i];)if(1===e.nodeType||s)if(c=(d=e[M]||(e[M]={}))[e.uniqueID]||(d[e.uniqueID]={}),o&&o===e.nodeName.toLowerCase())e=e[i]||e;else{if((u=c[r])&&u[0]===F&&u[1]===a)return p[2]=u[2];if((c[r]=p)[2]=t(e,n,l))return!0}return!1}}function h(t){return 1<t.length?function(e,n,i){for(var o=t.length;o--;)if(!t[o](e,n,i))return!1;return!0}:t[0]}function f(t,e,n,i,o){for(var r,s=[],a=0,l=t.length,u=null!=e;a<l;a++)(r=t[a])&&(n&&!n(r,i,o)||(s.push(r),u&&e.push(a)));return s}function m(t,n,o,r,s,a){return r&&!r[M]&&(r=m(r)),s&&!s[M]&&(s=m(s,a)),i((function(i,a,l,u){var c,d,p,h=[],m=[],g=a.length,v=i||function(t,n,i){for(var o=0,r=n.length;o<r;o++)e(t,n[o],i);return i}(n||"*",l.nodeType?[l]:l,[]),y=!t||!i&&n?v:f(v,h,t,l,u),w=o?s||(i?t:g||r)?[]:a:y;if(o&&o(y,w,l,u),r)for(c=f(w,m),r(c,[],l,u),d=c.length;d--;)(p=c[d])&&(w[m[d]]=!(y[m[d]]=p));if(i){if(s||t){if(s){for(c=[],d=w.length;d--;)(p=w[d])&&c.push(y[d]=p);s(null,w=[],c,u)}for(d=w.length;d--;)(p=w[d])&&-1<(c=s?J(i,p):h[d])&&(i[c]=!(a[c]=p))}}else w=f(w===a?w.splice(g,w.length):w),s?s(null,a,w,u):G.apply(a,w)}))}function g(t){for(var e,n,i,o=t.length,r=w.relative[t[0].type],s=r||w.relative[" "],a=r?1:0,l=p((function(t){return t===e}),s,!0),u=p((function(t){return-1<J(e,t)}),s,!0),c=[function(t,n,i){var o=!r&&(i||n!==T)||((e=n).nodeType?l(t,n,i):u(t,n,i));return e=null,o}];a<o;a++)if(n=w.relative[t[a].type])c=[p(h(c),n)];else{if((n=w.filter[t[a].type].apply(null,t[a].matches))[M]){for(i=++a;i<o&&!w.relative[t[i].type];i++);return m(1<a&&h(c),1<a&&d(t.slice(0,a-1).concat({value:" "===t[a-2].type?"*":""})).replace(ot,"$1"),n,a<i&&g(t.slice(a,i)),i<o&&g(t=t.slice(i)),i<o&&d(t))}c.push(n)}return h(c)}var v,y,w,b,x,_,C,k,T,S,E,I,P,L,A,$,O,j,N,M="sizzle"+1*new Date,H=t.document,F=0,D=0,z=n(),V=n(),q=n(),R=n(),W=function(t,e){return t===e&&(E=!0),0},B={}.hasOwnProperty,Y=[],X=Y.pop,U=Y.push,G=Y.push,Q=Y.slice,J=function(t,e){for(var n=0,i=t.length;n<i;n++)if(t[n]===e)return n;return-1},K="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",Z="[\\x20\\t\\r\\n\\f]",tt="(?:\\\\.|[\\w-]|[^\0-\\xa0])+",et="\\["+Z+"*("+tt+")(?:"+Z+"*([*^$|!~]?=)"+Z+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+tt+"))|)"+Z+"*\\]",nt=":("+tt+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+et+")*)|.*)\\)|)",it=new RegExp(Z+"+","g"),ot=new RegExp("^"+Z+"+|((?:^|[^\\\\])(?:\\\\.)*)"+Z+"+$","g"),rt=new RegExp("^"+Z+"*,"+Z+"*"),st=new RegExp("^"+Z+"*([>+~]|"+Z+")"+Z+"*"),at=new RegExp(Z+"|>"),lt=new RegExp(nt),ut=new RegExp("^"+tt+"$"),ct={ID:new RegExp("^#("+tt+")"),CLASS:new RegExp("^\\.("+tt+")"),TAG:new RegExp("^("+tt+"|[*])"),ATTR:new RegExp("^"+et),PSEUDO:new RegExp("^"+nt),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+Z+"*(even|odd|(([+-]|)(\\d*)n|)"+Z+"*(?:([+-]|)"+Z+"*(\\d+)|))"+Z+"*\\)|)","i"),bool:new RegExp("^(?:"+K+")$","i"),needsContext:new RegExp("^"+Z+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+Z+"*((?:-\\d)?\\d*)"+Z+"*\\)|)(?=[^-]|$)","i")},dt=/HTML$/i,pt=/^(?:input|select|textarea|button)$/i,ht=/^h\d$/i,ft=/^[^{]+\{\s*\[native \w/,mt=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,gt=/[+~]/,vt=new RegExp("\\\\([\\da-f]{1,6}"+Z+"?|("+Z+")|.)","ig"),yt=function(t,e,n){var i="0x"+e-65536;return i!=i||n?e:i<0?String.fromCharCode(i+65536):String.fromCharCode(i>>10|55296,1023&i|56320)},wt=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,bt=function(t,e){return e?"\0"===t?"�":t.slice(0,-1)+"\\"+t.charCodeAt(t.length-1).toString(16)+" ":"\\"+t},xt=function(){I()},_t=p((function(t){return!0===t.disabled&&"fieldset"===t.nodeName.toLowerCase()}),{dir:"parentNode",next:"legend"});try{G.apply(Y=Q.call(H.childNodes),H.childNodes),Y[H.childNodes.length].nodeType}catch(v){G={apply:Y.length?function(t,e){U.apply(t,Q.call(e))}:function(t,e){for(var n=t.length,i=0;t[n++]=e[i++];);t.length=n-1}}}for(v in y=e.support={},x=e.isXML=function(t){var e=t.namespaceURI,n=(t.ownerDocument||t).documentElement;return!dt.test(e||n&&n.nodeName||"HTML")},I=e.setDocument=function(t){var e,n,i=t?t.ownerDocument||t:H;return i!==P&&9===i.nodeType&&i.documentElement&&(L=(P=i).documentElement,A=!x(P),H!==P&&(n=P.defaultView)&&n.top!==n&&(n.addEventListener?n.addEventListener("unload",xt,!1):n.attachEvent&&n.attachEvent("onunload",xt)),y.attributes=o((function(t){return t.className="i",!t.getAttribute("className")})),y.getElementsByTagName=o((function(t){return t.appendChild(P.createComment("")),!t.getElementsByTagName("*").length})),y.getElementsByClassName=ft.test(P.getElementsByClassName),y.getById=o((function(t){return L.appendChild(t).id=M,!P.getElementsByName||!P.getElementsByName(M).length})),y.getById?(w.filter.ID=function(t){var e=t.replace(vt,yt);return function(t){return t.getAttribute("id")===e}},w.find.ID=function(t,e){if(void 0!==e.getElementById&&A){var n=e.getElementById(t);return n?[n]:[]}}):(w.filter.ID=function(t){var e=t.replace(vt,yt);return function(t){var n=void 0!==t.getAttributeNode&&t.getAttributeNode("id");return n&&n.value===e}},w.find.ID=function(t,e){if(void 0!==e.getElementById&&A){var n,i,o,r=e.getElementById(t);if(r){if((n=r.getAttributeNode("id"))&&n.value===t)return[r];for(o=e.getElementsByName(t),i=0;r=o[i++];)if((n=r.getAttributeNode("id"))&&n.value===t)return[r]}return[]}}),w.find.TAG=y.getElementsByTagName?function(t,e){return void 0!==e.getElementsByTagName?e.getElementsByTagName(t):y.qsa?e.querySelectorAll(t):void 0}:function(t,e){var n,i=[],o=0,r=e.getElementsByTagName(t);if("*"===t){for(;n=r[o++];)1===n.nodeType&&i.push(n);return i}return r},w.find.CLASS=y.getElementsByClassName&&function(t,e){if(void 0!==e.getElementsByClassName&&A)return e.getElementsByClassName(t)},O=[],$=[],(y.qsa=ft.test(P.querySelectorAll))&&(o((function(t){L.appendChild(t).innerHTML="<a id='"+M+"'></a><select id='"+M+"-\r\\' msallowcapture=''><option selected=''></option></select>",t.querySelectorAll("[msallowcapture^='']").length&&$.push("[*^$]="+Z+"*(?:''|\"\")"),t.querySelectorAll("[selected]").length||$.push("\\["+Z+"*(?:value|"+K+")"),t.querySelectorAll("[id~="+M+"-]").length||$.push("~="),t.querySelectorAll(":checked").length||$.push(":checked"),t.querySelectorAll("a#"+M+"+*").length||$.push(".#.+[+~]")})),o((function(t){t.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var e=P.createElement("input");e.setAttribute("type","hidden"),t.appendChild(e).setAttribute("name","D"),t.querySelectorAll("[name=d]").length&&$.push("name"+Z+"*[*^$|!~]?="),2!==t.querySelectorAll(":enabled").length&&$.push(":enabled",":disabled"),L.appendChild(t).disabled=!0,2!==t.querySelectorAll(":disabled").length&&$.push(":enabled",":disabled"),t.querySelectorAll("*,:x"),$.push(",.*:")}))),(y.matchesSelector=ft.test(j=L.matches||L.webkitMatchesSelector||L.mozMatchesSelector||L.oMatchesSelector||L.msMatchesSelector))&&o((function(t){y.disconnectedMatch=j.call(t,"*"),j.call(t,"[s!='']:x"),O.push("!=",nt)})),$=$.length&&new RegExp($.join("|")),O=O.length&&new RegExp(O.join("|")),e=ft.test(L.compareDocumentPosition),N=e||ft.test(L.contains)?function(t,e){var n=9===t.nodeType?t.documentElement:t,i=e&&e.parentNode;return t===i||!(!i||1!==i.nodeType||!(n.contains?n.contains(i):t.compareDocumentPosition&&16&t.compareDocumentPosition(i)))}:function(t,e){if(e)for(;e=e.parentNode;)if(e===t)return!0;return!1},W=e?function(t,e){if(t===e)return E=!0,0;var n=!t.compareDocumentPosition-!e.compareDocumentPosition;return n||(1&(n=(t.ownerDocument||t)===(e.ownerDocument||e)?t.compareDocumentPosition(e):1)||!y.sortDetached&&e.compareDocumentPosition(t)===n?t===P||t.ownerDocument===H&&N(H,t)?-1:e===P||e.ownerDocument===H&&N(H,e)?1:S?J(S,t)-J(S,e):0:4&n?-1:1)}:function(t,e){if(t===e)return E=!0,0;var n,i=0,o=t.parentNode,r=e.parentNode,a=[t],l=[e];if(!o||!r)return t===P?-1:e===P?1:o?-1:r?1:S?J(S,t)-J(S,e):0;if(o===r)return s(t,e);for(n=t;n=n.parentNode;)a.unshift(n);for(n=e;n=n.parentNode;)l.unshift(n);for(;a[i]===l[i];)i++;return i?s(a[i],l[i]):a[i]===H?-1:l[i]===H?1:0}),P},e.matches=function(t,n){return e(t,null,null,n)},e.matchesSelector=function(t,n){if((t.ownerDocument||t)!==P&&I(t),y.matchesSelector&&A&&!R[n+" "]&&(!O||!O.test(n))&&(!$||!$.test(n)))try{var i=j.call(t,n);if(i||y.disconnectedMatch||t.document&&11!==t.document.nodeType)return i}catch(t){R(n,!0)}return 0<e(n,P,null,[t]).length},e.contains=function(t,e){return(t.ownerDocument||t)!==P&&I(t),N(t,e)},e.attr=function(t,e){(t.ownerDocument||t)!==P&&I(t);var n=w.attrHandle[e.toLowerCase()],i=n&&B.call(w.attrHandle,e.toLowerCase())?n(t,e,!A):void 0;return void 0!==i?i:y.attributes||!A?t.getAttribute(e):(i=t.getAttributeNode(e))&&i.specified?i.value:null},e.escape=function(t){return(t+"").replace(wt,bt)},e.error=function(t){throw new Error("Syntax error, unrecognized expression: "+t)},e.uniqueSort=function(t){var e,n=[],i=0,o=0;if(E=!y.detectDuplicates,S=!y.sortStable&&t.slice(0),t.sort(W),E){for(;e=t[o++];)e===t[o]&&(i=n.push(o));for(;i--;)t.splice(n[i],1)}return S=null,t},b=e.getText=function(t){var e,n="",i=0,o=t.nodeType;if(o){if(1===o||9===o||11===o){if("string"==typeof t.textContent)return t.textContent;for(t=t.firstChild;t;t=t.nextSibling)n+=b(t)}else if(3===o||4===o)return t.nodeValue}else for(;e=t[i++];)n+=b(e);return n},(w=e.selectors={cacheLength:50,createPseudo:i,match:ct,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(t){return t[1]=t[1].replace(vt,yt),t[3]=(t[3]||t[4]||t[5]||"").replace(vt,yt),"~="===t[2]&&(t[3]=" "+t[3]+" "),t.slice(0,4)},CHILD:function(t){return t[1]=t[1].toLowerCase(),"nth"===t[1].slice(0,3)?(t[3]||e.error(t[0]),t[4]=+(t[4]?t[5]+(t[6]||1):2*("even"===t[3]||"odd"===t[3])),t[5]=+(t[7]+t[8]||"odd"===t[3])):t[3]&&e.error(t[0]),t},PSEUDO:function(t){var e,n=!t[6]&&t[2];return ct.CHILD.test(t[0])?null:(t[3]?t[2]=t[4]||t[5]||"":n&&lt.test(n)&&(e=_(n,!0))&&(e=n.indexOf(")",n.length-e)-n.length)&&(t[0]=t[0].slice(0,e),t[2]=n.slice(0,e)),t.slice(0,3))}},filter:{TAG:function(t){var e=t.replace(vt,yt).toLowerCase();return"*"===t?function(){return!0}:function(t){return t.nodeName&&t.nodeName.toLowerCase()===e}},CLASS:function(t){var e=z[t+" "];return e||(e=new RegExp("(^|"+Z+")"+t+"("+Z+"|$)"))&&z(t,(function(t){return e.test("string"==typeof t.className&&t.className||void 0!==t.getAttribute&&t.getAttribute("class")||"")}))},ATTR:function(t,n,i){return function(o){var r=e.attr(o,t);return null==r?"!="===n:!n||(r+="","="===n?r===i:"!="===n?r!==i:"^="===n?i&&0===r.indexOf(i):"*="===n?i&&-1<r.indexOf(i):"$="===n?i&&r.slice(-i.length)===i:"~="===n?-1<(" "+r.replace(it," ")+" ").indexOf(i):"|="===n&&(r===i||r.slice(0,i.length+1)===i+"-"))}},CHILD:function(t,e,n,i,o){var r="nth"!==t.slice(0,3),s="last"!==t.slice(-4),a="of-type"===e;return 1===i&&0===o?function(t){return!!t.parentNode}:function(e,n,l){var u,c,d,p,h,f,m=r!==s?"nextSibling":"previousSibling",g=e.parentNode,v=a&&e.nodeName.toLowerCase(),y=!l&&!a,w=!1;if(g){if(r){for(;m;){for(p=e;p=p[m];)if(a?p.nodeName.toLowerCase()===v:1===p.nodeType)return!1;f=m="only"===t&&!f&&"nextSibling"}return!0}if(f=[s?g.firstChild:g.lastChild],s&&y){for(w=(h=(u=(c=(d=(p=g)[M]||(p[M]={}))[p.uniqueID]||(d[p.uniqueID]={}))[t]||[])[0]===F&&u[1])&&u[2],p=h&&g.childNodes[h];p=++h&&p&&p[m]||(w=h=0)||f.pop();)if(1===p.nodeType&&++w&&p===e){c[t]=[F,h,w];break}}else if(y&&(w=h=(u=(c=(d=(p=e)[M]||(p[M]={}))[p.uniqueID]||(d[p.uniqueID]={}))[t]||[])[0]===F&&u[1]),!1===w)for(;(p=++h&&p&&p[m]||(w=h=0)||f.pop())&&((a?p.nodeName.toLowerCase()!==v:1!==p.nodeType)||!++w||(y&&((c=(d=p[M]||(p[M]={}))[p.uniqueID]||(d[p.uniqueID]={}))[t]=[F,w]),p!==e)););return(w-=o)===i||w%i==0&&0<=w/i}}},PSEUDO:function(t,n){var o,r=w.pseudos[t]||w.setFilters[t.toLowerCase()]||e.error("unsupported pseudo: "+t);return r[M]?r(n):1<r.length?(o=[t,t,"",n],w.setFilters.hasOwnProperty(t.toLowerCase())?i((function(t,e){for(var i,o=r(t,n),s=o.length;s--;)t[i=J(t,o[s])]=!(e[i]=o[s])})):function(t){return r(t,0,o)}):r}},pseudos:{not:i((function(t){var e=[],n=[],o=C(t.replace(ot,"$1"));return o[M]?i((function(t,e,n,i){for(var r,s=o(t,null,i,[]),a=t.length;a--;)(r=s[a])&&(t[a]=!(e[a]=r))})):function(t,i,r){return e[0]=t,o(e,null,r,n),e[0]=null,!n.pop()}})),has:i((function(t){return function(n){return 0<e(t,n).length}})),contains:i((function(t){return t=t.replace(vt,yt),function(e){return-1<(e.textContent||b(e)).indexOf(t)}})),lang:i((function(t){return ut.test(t||"")||e.error("unsupported lang: "+t),t=t.replace(vt,yt).toLowerCase(),function(e){var n;do{if(n=A?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(n=n.toLowerCase())===t||0===n.indexOf(t+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}})),target:function(e){var n=t.location&&t.location.hash;return n&&n.slice(1)===e.id},root:function(t){return t===L},focus:function(t){return t===P.activeElement&&(!P.hasFocus||P.hasFocus())&&!!(t.type||t.href||~t.tabIndex)},enabled:a(!1),disabled:a(!0),checked:function(t){var e=t.nodeName.toLowerCase();return"input"===e&&!!t.checked||"option"===e&&!!t.selected},selected:function(t){return t.parentNode&&t.parentNode.selectedIndex,!0===t.selected},empty:function(t){for(t=t.firstChild;t;t=t.nextSibling)if(t.nodeType<6)return!1;return!0},parent:function(t){return!w.pseudos.empty(t)},header:function(t){return ht.test(t.nodeName)},input:function(t){return pt.test(t.nodeName)},button:function(t){var e=t.nodeName.toLowerCase();return"input"===e&&"button"===t.type||"button"===e},text:function(t){var e;return"input"===t.nodeName.toLowerCase()&&"text"===t.type&&(null==(e=t.getAttribute("type"))||"text"===e.toLowerCase())},first:l((function(){return[0]})),last:l((function(t,e){return[e-1]})),eq:l((function(t,e,n){return[n<0?n+e:n]})),even:l((function(t,e){for(var n=0;n<e;n+=2)t.push(n);return t})),odd:l((function(t,e){for(var n=1;n<e;n+=2)t.push(n);return t})),lt:l((function(t,e,n){for(var i=n<0?n+e:e<n?e:n;0<=--i;)t.push(i);return t})),gt:l((function(t,e,n){for(var i=n<0?n+e:n;++i<e;)t.push(i);return t}))}}).pseudos.nth=w.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})w.pseudos[v]=function(t){return function(e){return"input"===e.nodeName.toLowerCase()&&e.type===t}}(v);for(v in{submit:!0,reset:!0})w.pseudos[v]=function(t){return function(e){var n=e.nodeName.toLowerCase();return("input"===n||"button"===n)&&e.type===t}}(v);return c.prototype=w.filters=w.pseudos,w.setFilters=new c,_=e.tokenize=function(t,n){var i,o,r,s,a,l,u,c=V[t+" "];if(c)return n?0:c.slice(0);for(a=t,l=[],u=w.preFilter;a;){for(s in i&&!(o=rt.exec(a))||(o&&(a=a.slice(o[0].length)||a),l.push(r=[])),i=!1,(o=st.exec(a))&&(i=o.shift(),r.push({value:i,type:o[0].replace(ot," ")}),a=a.slice(i.length)),w.filter)!(o=ct[s].exec(a))||u[s]&&!(o=u[s](o))||(i=o.shift(),r.push({value:i,type:s,matches:o}),a=a.slice(i.length));if(!i)break}return n?a.length:a?e.error(t):V(t,l).slice(0)},C=e.compile=function(t,n){var o,r,s,a,l,u,c=[],d=[],p=q[t+" "];if(!p){for(n||(n=_(t)),o=n.length;o--;)(p=g(n[o]))[M]?c.push(p):d.push(p);(p=q(t,(r=d,a=0<(s=c).length,l=0<r.length,u=function(t,n,i,o,u){var c,d,p,h=0,m="0",g=t&&[],v=[],y=T,b=t||l&&w.find.TAG("*",u),x=F+=null==y?1:Math.random()||.1,_=b.length;for(u&&(T=n===P||n||u);m!==_&&null!=(c=b[m]);m++){if(l&&c){for(d=0,n||c.ownerDocument===P||(I(c),i=!A);p=r[d++];)if(p(c,n||P,i)){o.push(c);break}u&&(F=x)}a&&((c=!p&&c)&&h--,t&&g.push(c))}if(h+=m,a&&m!==h){for(d=0;p=s[d++];)p(g,v,n,i);if(t){if(0<h)for(;m--;)g[m]||v[m]||(v[m]=X.call(o));v=f(v)}G.apply(o,v),u&&!t&&0<v.length&&1<h+s.length&&e.uniqueSort(o)}return u&&(F=x,T=y),g},a?i(u):u))).selector=t}return p},k=e.select=function(t,e,n,i){var o,r,s,a,l,c="function"==typeof t&&t,p=!i&&_(t=c.selector||t);if(n=n||[],1===p.length){if(2<(r=p[0]=p[0].slice(0)).length&&"ID"===(s=r[0]).type&&9===e.nodeType&&A&&w.relative[r[1].type]){if(!(e=(w.find.ID(s.matches[0].replace(vt,yt),e)||[])[0]))return n;c&&(e=e.parentNode),t=t.slice(r.shift().value.length)}for(o=ct.needsContext.test(t)?0:r.length;o--&&(s=r[o],!w.relative[a=s.type]);)if((l=w.find[a])&&(i=l(s.matches[0].replace(vt,yt),gt.test(r[0].type)&&u(e.parentNode)||e))){if(r.splice(o,1),!(t=i.length&&d(r)))return G.apply(n,i),n;break}}return(c||C(t,p))(i,e,!A,n,!e||gt.test(t)&&u(e.parentNode)||e),n},y.sortStable=M.split("").sort(W).join("")===M,y.detectDuplicates=!!E,I(),y.sortDetached=o((function(t){return 1&t.compareDocumentPosition(P.createElement("fieldset"))})),o((function(t){return t.innerHTML="<a href='#'></a>","#"===t.firstChild.getAttribute("href")}))||r("type|href|height|width",(function(t,e,n){if(!n)return t.getAttribute(e,"type"===e.toLowerCase()?1:2)})),y.attributes&&o((function(t){return t.innerHTML="<input/>",t.firstChild.setAttribute("value",""),""===t.firstChild.getAttribute("value")}))||r("value",(function(t,e,n){if(!n&&"input"===t.nodeName.toLowerCase())return t.defaultValue})),o((function(t){return null==t.getAttribute("disabled")}))||r(K,(function(t,e,n){var i;if(!n)return!0===t[e]?e.toLowerCase():(i=t.getAttributeNode(e))&&i.specified?i.value:null})),e}(t);ft.find=gt,ft.expr=gt.selectors,ft.expr[":"]=ft.expr.pseudos,ft.uniqueSort=ft.unique=gt.uniqueSort,ft.text=gt.getText,ft.isXMLDoc=gt.isXML,ft.contains=gt.contains,ft.escapeSelector=gt.escape;var vt=function(t,e,n){for(var i=[],o=void 0!==n;(t=t[e])&&9!==t.nodeType;)if(1===t.nodeType){if(o&&ft(t).is(n))break;i.push(t)}return i},yt=function(t,e){for(var n=[];t;t=t.nextSibling)1===t.nodeType&&t!==e&&n.push(t);return n},wt=ft.expr.match.needsContext,bt=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;ft.filter=function(t,e,n){var i=e[0];return n&&(t=":not("+t+")"),1===e.length&&1===i.nodeType?ft.find.matchesSelector(i,t)?[i]:[]:ft.find.matches(t,ft.grep(e,(function(t){return 1===t.nodeType})))},ft.fn.extend({find:function(t){var e,n,i=this.length,o=this;if("string"!=typeof t)return this.pushStack(ft(t).filter((function(){for(e=0;e<i;e++)if(ft.contains(o[e],this))return!0})));for(n=this.pushStack([]),e=0;e<i;e++)ft.find(t,o[e],n);return 1<i?ft.uniqueSort(n):n},filter:function(t){return this.pushStack(s(this,t||[],!1))},not:function(t){return this.pushStack(s(this,t||[],!0))},is:function(t){return!!s(this,"string"==typeof t&&wt.test(t)?ft(t):t||[],!1).length}});var xt,_t=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(ft.fn.init=function(t,e,n){var i,o;if(!t)return this;if(n=n||xt,"string"==typeof t){if(!(i="<"===t[0]&&">"===t[t.length-1]&&3<=t.length?[null,t,null]:_t.exec(t))||!i[1]&&e)return!e||e.jquery?(e||n).find(t):this.constructor(e).find(t);if(i[1]){if(e=e instanceof ft?e[0]:e,ft.merge(this,ft.parseHTML(i[1],e&&e.nodeType?e.ownerDocument||e:K,!0)),bt.test(i[1])&&ft.isPlainObject(e))for(i in e)ct(this[i])?this[i](e[i]):this.attr(i,e[i]);return this}return(o=K.getElementById(i[2]))&&(this[0]=o,this.length=1),this}return t.nodeType?(this[0]=t,this.length=1,this):ct(t)?void 0!==n.ready?n.ready(t):t(ft):ft.makeArray(t,this)}).prototype=ft.fn,xt=ft(K);var Ct=/^(?:parents|prev(?:Until|All))/,kt={children:!0,contents:!0,next:!0,prev:!0};ft.fn.extend({has:function(t){var e=ft(t,this),n=e.length;return this.filter((function(){for(var t=0;t<n;t++)if(ft.contains(this,e[t]))return!0}))},closest:function(t,e){var n,i=0,o=this.length,r=[],s="string"!=typeof t&&ft(t);if(!wt.test(t))for(;i<o;i++)for(n=this[i];n&&n!==e;n=n.parentNode)if(n.nodeType<11&&(s?-1<s.index(n):1===n.nodeType&&ft.find.matchesSelector(n,t))){r.push(n);break}return this.pushStack(1<r.length?ft.uniqueSort(r):r)},index:function(t){return t?"string"==typeof t?it.call(ft(t),this[0]):it.call(this,t.jquery?t[0]:t):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(t,e){return this.pushStack(ft.uniqueSort(ft.merge(this.get(),ft(t,e))))},addBack:function(t){return this.add(null==t?this.prevObject:this.prevObject.filter(t))}}),ft.each({parent:function(t){var e=t.parentNode;return e&&11!==e.nodeType?e:null},parents:function(t){return vt(t,"parentNode")},parentsUntil:function(t,e,n){return vt(t,"parentNode",n)},next:function(t){return a(t,"nextSibling")},prev:function(t){return a(t,"previousSibling")},nextAll:function(t){return vt(t,"nextSibling")},prevAll:function(t){return vt(t,"previousSibling")},nextUntil:function(t,e,n){return vt(t,"nextSibling",n)},prevUntil:function(t,e,n){return vt(t,"previousSibling",n)},siblings:function(t){return yt((t.parentNode||{}).firstChild,t)},children:function(t){return yt(t.firstChild)},contents:function(t){return void 0!==t.contentDocument?t.contentDocument:(r(t,"template")&&(t=t.content||t),ft.merge([],t.childNodes))}},(function(t,e){ft.fn[t]=function(n,i){var o=ft.map(this,e,n);return"Until"!==t.slice(-5)&&(i=n),i&&"string"==typeof i&&(o=ft.filter(i,o)),1<this.length&&(kt[t]||ft.uniqueSort(o),Ct.test(t)&&o.reverse()),this.pushStack(o)}}));var Tt=/[^\x20\t\r\n\f]+/g;ft.Callbacks=function(t){var e,n;t="string"==typeof t?(e=t,n={},ft.each(e.match(Tt)||[],(function(t,e){n[e]=!0})),n):ft.extend({},t);var o,r,s,a,l=[],u=[],c=-1,d=function(){for(a=a||t.once,s=o=!0;u.length;c=-1)for(r=u.shift();++c<l.length;)!1===l[c].apply(r[0],r[1])&&t.stopOnFalse&&(c=l.length,r=!1);t.memory||(r=!1),o=!1,a&&(l=r?[]:"")},p={add:function(){return l&&(r&&!o&&(c=l.length-1,u.push(r)),function e(n){ft.each(n,(function(n,o){ct(o)?t.unique&&p.has(o)||l.push(o):o&&o.length&&"string"!==i(o)&&e(o)}))}(arguments),r&&!o&&d()),this},remove:function(){return ft.each(arguments,(function(t,e){for(var n;-1<(n=ft.inArray(e,l,n));)l.splice(n,1),n<=c&&c--})),this},has:function(t){return t?-1<ft.inArray(t,l):0<l.length},empty:function(){return l&&(l=[]),this},disable:function(){return a=u=[],l=r="",this},disabled:function(){return!l},lock:function(){return a=u=[],r||o||(l=r=""),this},locked:function(){return!!a},fireWith:function(t,e){return a||(e=[t,(e=e||[]).slice?e.slice():e],u.push(e),o||d()),this},fire:function(){return p.fireWith(this,arguments),this},fired:function(){return!!s}};return p},ft.extend({Deferred:function(e){var n=[["notify","progress",ft.Callbacks("memory"),ft.Callbacks("memory"),2],["resolve","done",ft.Callbacks("once memory"),ft.Callbacks("once memory"),0,"resolved"],["reject","fail",ft.Callbacks("once memory"),ft.Callbacks("once memory"),1,"rejected"]],i="pending",o={state:function(){return i},always:function(){return r.done(arguments).fail(arguments),this},catch:function(t){return o.then(null,t)},pipe:function(){var t=arguments;return ft.Deferred((function(e){ft.each(n,(function(n,i){var o=ct(t[i[4]])&&t[i[4]];r[i[1]]((function(){var t=o&&o.apply(this,arguments);t&&ct(t.promise)?t.promise().progress(e.notify).done(e.resolve).fail(e.reject):e[i[0]+"With"](this,o?[t]:arguments)}))})),t=null})).promise()},then:function(e,i,o){function r(e,n,i,o){return function(){var a=this,c=arguments,d=function(){var t,d;if(!(e<s)){if((t=i.apply(a,c))===n.promise())throw new TypeError("Thenable self-resolution");d=t&&("object"==typeof t||"function"==typeof t)&&t.then,ct(d)?o?d.call(t,r(s,n,l,o),r(s,n,u,o)):(s++,d.call(t,r(s,n,l,o),r(s,n,u,o),r(s,n,l,n.notifyWith))):(i!==l&&(a=void 0,c=[t]),(o||n.resolveWith)(a,c))}},p=o?d:function(){try{d()}catch(t){ft.Deferred.exceptionHook&&ft.Deferred.exceptionHook(t,p.stackTrace),s<=e+1&&(i!==u&&(a=void 0,c=[t]),n.rejectWith(a,c))}};e?p():(ft.Deferred.getStackHook&&(p.stackTrace=ft.Deferred.getStackHook()),t.setTimeout(p))}}var s=0;return ft.Deferred((function(t){n[0][3].add(r(0,t,ct(o)?o:l,t.notifyWith)),n[1][3].add(r(0,t,ct(e)?e:l)),n[2][3].add(r(0,t,ct(i)?i:u))})).promise()},promise:function(t){return null!=t?ft.extend(t,o):o}},r={};return ft.each(n,(function(t,e){var s=e[2],a=e[5];o[e[1]]=s.add,a&&s.add((function(){i=a}),n[3-t][2].disable,n[3-t][3].disable,n[0][2].lock,n[0][3].lock),s.add(e[3].fire),r[e[0]]=function(){return r[e[0]+"With"](this===r?void 0:this,arguments),this},r[e[0]+"With"]=s.fireWith})),o.promise(r),e&&e.call(r,r),r},when:function(t){var e=arguments.length,n=e,i=Array(n),o=tt.call(arguments),r=ft.Deferred(),s=function(t){return function(n){i[t]=this,o[t]=1<arguments.length?tt.call(arguments):n,--e||r.resolveWith(i,o)}};if(e<=1&&(c(t,r.done(s(n)).resolve,r.reject,!e),"pending"===r.state()||ct(o[n]&&o[n].then)))return r.then();for(;n--;)c(o[n],s(n),r.reject);return r.promise()}});var St=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;ft.Deferred.exceptionHook=function(e,n){t.console&&t.console.warn&&e&&St.test(e.name)&&t.console.warn("jQuery.Deferred exception: "+e.message,e.stack,n)},ft.readyException=function(e){t.setTimeout((function(){throw e}))};var Et=ft.Deferred();ft.fn.ready=function(t){return Et.then(t).catch((function(t){ft.readyException(t)})),this},ft.extend({isReady:!1,readyWait:1,ready:function(t){(!0===t?--ft.readyWait:ft.isReady)||(ft.isReady=!0)!==t&&0<--ft.readyWait||Et.resolveWith(K,[ft])}}),ft.ready.then=Et.then,"complete"===K.readyState||"loading"!==K.readyState&&!K.documentElement.doScroll?t.setTimeout(ft.ready):(K.addEventListener("DOMContentLoaded",d),t.addEventListener("load",d));var It=function(t,e,n,o,r,s,a){var l=0,u=t.length,c=null==n;if("object"===i(n))for(l in r=!0,n)It(t,e,l,n[l],!0,s,a);else if(void 0!==o&&(r=!0,ct(o)||(a=!0),c&&(a?(e.call(t,o),e=null):(c=e,e=function(t,e,n){return c.call(ft(t),n)})),e))for(;l<u;l++)e(t[l],n,a?o:o.call(t[l],l,e(t[l],n)));return r?t:c?e.call(t):u?e(t[0],n):s},Pt=/^-ms-/,Lt=/-([a-z])/g,At=function(t){return 1===t.nodeType||9===t.nodeType||!+t.nodeType};f.uid=1,f.prototype={cache:function(t){var e=t[this.expando];return e||(e={},At(t)&&(t.nodeType?t[this.expando]=e:Object.defineProperty(t,this.expando,{value:e,configurable:!0}))),e},set:function(t,e,n){var i,o=this.cache(t);if("string"==typeof e)o[h(e)]=n;else for(i in e)o[h(i)]=e[i];return o},get:function(t,e){return void 0===e?this.cache(t):t[this.expando]&&t[this.expando][h(e)]},access:function(t,e,n){return void 0===e||e&&"string"==typeof e&&void 0===n?this.get(t,e):(this.set(t,e,n),void 0!==n?n:e)},remove:function(t,e){var n,i=t[this.expando];if(void 0!==i){if(void 0!==e){n=(e=Array.isArray(e)?e.map(h):(e=h(e))in i?[e]:e.match(Tt)||[]).length;for(;n--;)delete i[e[n]]}(void 0===e||ft.isEmptyObject(i))&&(t.nodeType?t[this.expando]=void 0:delete t[this.expando])}},hasData:function(t){var e=t[this.expando];return void 0!==e&&!ft.isEmptyObject(e)}};var $t=new f,Ot=new f,jt=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,Nt=/[A-Z]/g;ft.extend({hasData:function(t){return Ot.hasData(t)||$t.hasData(t)},data:function(t,e,n){return Ot.access(t,e,n)},removeData:function(t,e){Ot.remove(t,e)},_data:function(t,e,n){return $t.access(t,e,n)},_removeData:function(t,e){$t.remove(t,e)}}),ft.fn.extend({data:function(t,e){var n,i,o,r=this[0],s=r&&r.attributes;if(void 0===t){if(this.length&&(o=Ot.get(r),1===r.nodeType&&!$t.get(r,"hasDataAttrs"))){for(n=s.length;n--;)s[n]&&0===(i=s[n].name).indexOf("data-")&&(i=h(i.slice(5)),m(r,i,o[i]));$t.set(r,"hasDataAttrs",!0)}return o}return"object"==typeof t?this.each((function(){Ot.set(this,t)})):It(this,(function(e){var n;if(r&&void 0===e)return void 0!==(n=Ot.get(r,t))||void 0!==(n=m(r,t))?n:void 0;this.each((function(){Ot.set(this,t,e)}))}),null,e,1<arguments.length,null,!0)},removeData:function(t){return this.each((function(){Ot.remove(this,t)}))}}),ft.extend({queue:function(t,e,n){var i;if(t)return e=(e||"fx")+"queue",i=$t.get(t,e),n&&(!i||Array.isArray(n)?i=$t.access(t,e,ft.makeArray(n)):i.push(n)),i||[]},dequeue:function(t,e){e=e||"fx";var n=ft.queue(t,e),i=n.length,o=n.shift(),r=ft._queueHooks(t,e);"inprogress"===o&&(o=n.shift(),i--),o&&("fx"===e&&n.unshift("inprogress"),delete r.stop,o.call(t,(function(){ft.dequeue(t,e)}),r)),!i&&r&&r.empty.fire()},_queueHooks:function(t,e){var n=e+"queueHooks";return $t.get(t,n)||$t.access(t,n,{empty:ft.Callbacks("once memory").add((function(){$t.remove(t,[e+"queue",n])}))})}}),ft.fn.extend({queue:function(t,e){var n=2;return"string"!=typeof t&&(e=t,t="fx",n--),arguments.length<n?ft.queue(this[0],t):void 0===e?this:this.each((function(){var n=ft.queue(this,t,e);ft._queueHooks(this,t),"fx"===t&&"inprogress"!==n[0]&&ft.dequeue(this,t)}))},dequeue:function(t){return this.each((function(){ft.dequeue(this,t)}))},clearQueue:function(t){return this.queue(t||"fx",[])},promise:function(t,e){var n,i=1,o=ft.Deferred(),r=this,s=this.length,a=function(){--i||o.resolveWith(r,[r])};for("string"!=typeof t&&(e=t,t=void 0),t=t||"fx";s--;)(n=$t.get(r[s],t+"queueHooks"))&&n.empty&&(i++,n.empty.add(a));return a(),o.promise(e)}});var Mt=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,Ht=new RegExp("^(?:([+-])=|)("+Mt+")([a-z%]*)$","i"),Ft=["Top","Right","Bottom","Left"],Dt=K.documentElement,zt=function(t){return ft.contains(t.ownerDocument,t)},Vt={composed:!0};Dt.getRootNode&&(zt=function(t){return ft.contains(t.ownerDocument,t)||t.getRootNode(Vt)===t.ownerDocument});var qt=function(t,e){return"none"===(t=e||t).style.display||""===t.style.display&&zt(t)&&"none"===ft.css(t,"display")},Rt=function(t,e,n,i){var o,r,s={};for(r in e)s[r]=t.style[r],t.style[r]=e[r];for(r in o=n.apply(t,i||[]),e)t.style[r]=s[r];return o},Wt={};ft.fn.extend({show:function(){return v(this,!0)},hide:function(){return v(this)},toggle:function(t){return"boolean"==typeof t?t?this.show():this.hide():this.each((function(){qt(this)?ft(this).show():ft(this).hide()}))}});var Bt=/^(?:checkbox|radio)$/i,Yt=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,Xt=/^$|^module$|\/(?:java|ecma)script/i,Ut={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};Ut.optgroup=Ut.option,Ut.tbody=Ut.tfoot=Ut.colgroup=Ut.caption=Ut.thead,Ut.th=Ut.td;var Gt,Qt,Jt=/<|&#?\w+;/;Gt=K.createDocumentFragment().appendChild(K.createElement("div")),(Qt=K.createElement("input")).setAttribute("type","radio"),Qt.setAttribute("checked","checked"),Qt.setAttribute("name","t"),Gt.appendChild(Qt),ut.checkClone=Gt.cloneNode(!0).cloneNode(!0).lastChild.checked,Gt.innerHTML="<textarea>x</textarea>",ut.noCloneChecked=!!Gt.cloneNode(!0).lastChild.defaultValue;var Kt=/^key/,Zt=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,te=/^([^.]*)(?:\.(.+)|)/;ft.event={global:{},add:function(t,e,n,i,o){var r,s,a,l,u,c,d,p,h,f,m,g=$t.get(t);if(g)for(n.handler&&(n=(r=n).handler,o=r.selector),o&&ft.find.matchesSelector(Dt,o),n.guid||(n.guid=ft.guid++),(l=g.events)||(l=g.events={}),(s=g.handle)||(s=g.handle=function(e){return void 0!==ft&&ft.event.triggered!==e.type?ft.event.dispatch.apply(t,arguments):void 0}),u=(e=(e||"").match(Tt)||[""]).length;u--;)h=m=(a=te.exec(e[u])||[])[1],f=(a[2]||"").split(".").sort(),h&&(d=ft.event.special[h]||{},h=(o?d.delegateType:d.bindType)||h,d=ft.event.special[h]||{},c=ft.extend({type:h,origType:m,data:i,handler:n,guid:n.guid,selector:o,needsContext:o&&ft.expr.match.needsContext.test(o),namespace:f.join(".")},r),(p=l[h])||((p=l[h]=[]).delegateCount=0,d.setup&&!1!==d.setup.call(t,i,f,s)||t.addEventListener&&t.addEventListener(h,s)),d.add&&(d.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),o?p.splice(p.delegateCount++,0,c):p.push(c),ft.event.global[h]=!0)},remove:function(t,e,n,i,o){var r,s,a,l,u,c,d,p,h,f,m,g=$t.hasData(t)&&$t.get(t);if(g&&(l=g.events)){for(u=(e=(e||"").match(Tt)||[""]).length;u--;)if(h=m=(a=te.exec(e[u])||[])[1],f=(a[2]||"").split(".").sort(),h){for(d=ft.event.special[h]||{},p=l[h=(i?d.delegateType:d.bindType)||h]||[],a=a[2]&&new RegExp("(^|\\.)"+f.join("\\.(?:.*\\.|)")+"(\\.|$)"),s=r=p.length;r--;)c=p[r],!o&&m!==c.origType||n&&n.guid!==c.guid||a&&!a.test(c.namespace)||i&&i!==c.selector&&("**"!==i||!c.selector)||(p.splice(r,1),c.selector&&p.delegateCount--,d.remove&&d.remove.call(t,c));s&&!p.length&&(d.teardown&&!1!==d.teardown.call(t,f,g.handle)||ft.removeEvent(t,h,g.handle),delete l[h])}else for(h in l)ft.event.remove(t,h+e[u],n,i,!0);ft.isEmptyObject(l)&&$t.remove(t,"handle events")}},dispatch:function(t){var e,n,i,o,r,s,a=ft.event.fix(t),l=new Array(arguments.length),u=($t.get(this,"events")||{})[a.type]||[],c=ft.event.special[a.type]||{};for(l[0]=a,e=1;e<arguments.length;e++)l[e]=arguments[e];if(a.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,a)){for(s=ft.event.handlers.call(this,a,u),e=0;(o=s[e++])&&!a.isPropagationStopped();)for(a.currentTarget=o.elem,n=0;(r=o.handlers[n++])&&!a.isImmediatePropagationStopped();)a.rnamespace&&!1!==r.namespace&&!a.rnamespace.test(r.namespace)||(a.handleObj=r,a.data=r.data,void 0!==(i=((ft.event.special[r.origType]||{}).handle||r.handler).apply(o.elem,l))&&!1===(a.result=i)&&(a.preventDefault(),a.stopPropagation()));return c.postDispatch&&c.postDispatch.call(this,a),a.result}},handlers:function(t,e){var n,i,o,r,s,a=[],l=e.delegateCount,u=t.target;if(l&&u.nodeType&&!("click"===t.type&&1<=t.button))for(;u!==this;u=u.parentNode||this)if(1===u.nodeType&&("click"!==t.type||!0!==u.disabled)){for(r=[],s={},n=0;n<l;n++)void 0===s[o=(i=e[n]).selector+" "]&&(s[o]=i.needsContext?-1<ft(o,this).index(u):ft.find(o,this,null,[u]).length),s[o]&&r.push(i);r.length&&a.push({elem:u,handlers:r})}return u=this,l<e.length&&a.push({elem:u,handlers:e.slice(l)}),a},addProp:function(t,e){Object.defineProperty(ft.Event.prototype,t,{enumerable:!0,configurable:!0,get:ct(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(t){return t[ft.expando]?t:new ft.Event(t)},special:{load:{noBubble:!0},click:{setup:function(t){var e=this||t;return Bt.test(e.type)&&e.click&&r(e,"input")&&T(e,"click",x),!1},trigger:function(t){var e=this||t;return Bt.test(e.type)&&e.click&&r(e,"input")&&T(e,"click"),!0},_default:function(t){var e=t.target;return Bt.test(e.type)&&e.click&&r(e,"input")&&$t.get(e,"click")||r(e,"a")}},beforeunload:{postDispatch:function(t){void 0!==t.result&&t.originalEvent&&(t.originalEvent.returnValue=t.result)}}}},ft.removeEvent=function(t,e,n){t.removeEventListener&&t.removeEventListener(e,n)},ft.Event=function(t,e){if(!(this instanceof ft.Event))return new ft.Event(t,e);t&&t.type?(this.originalEvent=t,this.type=t.type,this.isDefaultPrevented=t.defaultPrevented||void 0===t.defaultPrevented&&!1===t.returnValue?x:_,this.target=t.target&&3===t.target.nodeType?t.target.parentNode:t.target,this.currentTarget=t.currentTarget,this.relatedTarget=t.relatedTarget):this.type=t,e&&ft.extend(this,e),this.timeStamp=t&&t.timeStamp||Date.now(),this[ft.expando]=!0},ft.Event.prototype={constructor:ft.Event,isDefaultPrevented:_,isPropagationStopped:_,isImmediatePropagationStopped:_,isSimulated:!1,preventDefault:function(){var t=this.originalEvent;this.isDefaultPrevented=x,t&&!this.isSimulated&&t.preventDefault()},stopPropagation:function(){var t=this.originalEvent;this.isPropagationStopped=x,t&&!this.isSimulated&&t.stopPropagation()},stopImmediatePropagation:function(){var t=this.originalEvent;this.isImmediatePropagationStopped=x,t&&!this.isSimulated&&t.stopImmediatePropagation(),this.stopPropagation()}},ft.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,char:!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:function(t){var e=t.button;return null==t.which&&Kt.test(t.type)?null!=t.charCode?t.charCode:t.keyCode:!t.which&&void 0!==e&&Zt.test(t.type)?1&e?1:2&e?3:4&e?2:0:t.which}},ft.event.addProp),ft.each({focus:"focusin",blur:"focusout"},(function(t,e){ft.event.special[t]={setup:function(){return T(this,t,C),!1},trigger:function(){return T(this,t),!0},delegateType:e}})),ft.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},(function(t,e){ft.event.special[t]={delegateType:e,bindType:e,handle:function(t){var n,i=t.relatedTarget,o=t.handleObj;return i&&(i===this||ft.contains(this,i))||(t.type=o.origType,n=o.handler.apply(this,arguments),t.type=e),n}}})),ft.fn.extend({on:function(t,e,n,i){return k(this,t,e,n,i)},one:function(t,e,n,i){return k(this,t,e,n,i,1)},off:function(t,e,n){var i,o;if(t&&t.preventDefault&&t.handleObj)return i=t.handleObj,ft(t.delegateTarget).off(i.namespace?i.origType+"."+i.namespace:i.origType,i.selector,i.handler),this;if("object"==typeof t){for(o in t)this.off(o,e,t[o]);return this}return!1!==e&&"function"!=typeof e||(n=e,e=void 0),!1===n&&(n=_),this.each((function(){ft.event.remove(this,t,n,e)}))}});var ee=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,ne=/<script|<style|<link/i,ie=/checked\s*(?:[^=]|=\s*.checked.)/i,oe=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;ft.extend({htmlPrefilter:function(t){return t.replace(ee,"<$1></$2>")},clone:function(t,e,n){var i,o,r,s,a,l,u,c=t.cloneNode(!0),d=zt(t);if(!(ut.noCloneChecked||1!==t.nodeType&&11!==t.nodeType||ft.isXMLDoc(t)))for(s=y(c),i=0,o=(r=y(t)).length;i<o;i++)a=r[i],"input"===(u=(l=s[i]).nodeName.toLowerCase())&&Bt.test(a.type)?l.checked=a.checked:"input"!==u&&"textarea"!==u||(l.defaultValue=a.defaultValue);if(e)if(n)for(r=r||y(t),s=s||y(c),i=0,o=r.length;i<o;i++)P(r[i],s[i]);else P(t,c);return 0<(s=y(c,"script")).length&&w(s,!d&&y(t,"script")),c},cleanData:function(t){for(var e,n,i,o=ft.event.special,r=0;void 0!==(n=t[r]);r++)if(At(n)){if(e=n[$t.expando]){if(e.events)for(i in e.events)o[i]?ft.event.remove(n,i):ft.removeEvent(n,i,e.handle);n[$t.expando]=void 0}n[Ot.expando]&&(n[Ot.expando]=void 0)}}}),ft.fn.extend({detach:function(t){return A(this,t,!0)},remove:function(t){return A(this,t)},text:function(t){return It(this,(function(t){return void 0===t?ft.text(this):this.empty().each((function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=t)}))}),null,t,arguments.length)},append:function(){return L(this,arguments,(function(t){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||S(this,t).appendChild(t)}))},prepend:function(){return L(this,arguments,(function(t){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var e=S(this,t);e.insertBefore(t,e.firstChild)}}))},before:function(){return L(this,arguments,(function(t){this.parentNode&&this.parentNode.insertBefore(t,this)}))},after:function(){return L(this,arguments,(function(t){this.parentNode&&this.parentNode.insertBefore(t,this.nextSibling)}))},empty:function(){for(var t,e=0;null!=(t=this[e]);e++)1===t.nodeType&&(ft.cleanData(y(t,!1)),t.textContent="");return this},clone:function(t,e){return t=null!=t&&t,e=null==e?t:e,this.map((function(){return ft.clone(this,t,e)}))},html:function(t){return It(this,(function(t){var e=this[0]||{},n=0,i=this.length;if(void 0===t&&1===e.nodeType)return e.innerHTML;if("string"==typeof t&&!ne.test(t)&&!Ut[(Yt.exec(t)||["",""])[1].toLowerCase()]){t=ft.htmlPrefilter(t);try{for(;n<i;n++)1===(e=this[n]||{}).nodeType&&(ft.cleanData(y(e,!1)),e.innerHTML=t);e=0}catch(t){}}e&&this.empty().append(t)}),null,t,arguments.length)},replaceWith:function(){var t=[];return L(this,arguments,(function(e){var n=this.parentNode;ft.inArray(this,t)<0&&(ft.cleanData(y(this)),n&&n.replaceChild(e,this))}),t)}}),ft.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},(function(t,e){ft.fn[t]=function(t){for(var n,i=[],o=ft(t),r=o.length-1,s=0;s<=r;s++)n=s===r?this:this.clone(!0),ft(o[s])[e](n),nt.apply(i,n.get());return this.pushStack(i)}}));var re=new RegExp("^("+Mt+")(?!px)[a-z%]+$","i"),se=function(e){var n=e.ownerDocument.defaultView;return n&&n.opener||(n=t),n.getComputedStyle(e)},ae=new RegExp(Ft.join("|"),"i");!function(){function e(){if(u){l.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",u.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",Dt.appendChild(l).appendChild(u);var e=t.getComputedStyle(u);i="1%"!==e.top,a=12===n(e.marginLeft),u.style.right="60%",s=36===n(e.right),o=36===n(e.width),u.style.position="absolute",r=12===n(u.offsetWidth/3),Dt.removeChild(l),u=null}}function n(t){return Math.round(parseFloat(t))}var i,o,r,s,a,l=K.createElement("div"),u=K.createElement("div");u.style&&(u.style.backgroundClip="content-box",u.cloneNode(!0).style.backgroundClip="",ut.clearCloneStyle="content-box"===u.style.backgroundClip,ft.extend(ut,{boxSizingReliable:function(){return e(),o},pixelBoxStyles:function(){return e(),s},pixelPosition:function(){return e(),i},reliableMarginLeft:function(){return e(),a},scrollboxSize:function(){return e(),r}}))}();var le=["Webkit","Moz","ms"],ue=K.createElement("div").style,ce={},de=/^(none|table(?!-c[ea]).+)/,pe=/^--/,he={position:"absolute",visibility:"hidden",display:"block"},fe={letterSpacing:"0",fontWeight:"400"};ft.extend({cssHooks:{opacity:{get:function(t,e){if(e){var n=$(t,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{},style:function(t,e,n,i){if(t&&3!==t.nodeType&&8!==t.nodeType&&t.style){var o,r,s,a=h(e),l=pe.test(e),u=t.style;if(l||(e=j(a)),s=ft.cssHooks[e]||ft.cssHooks[a],void 0===n)return s&&"get"in s&&void 0!==(o=s.get(t,!1,i))?o:u[e];"string"==(r=typeof n)&&(o=Ht.exec(n))&&o[1]&&(n=g(t,e,o),r="number"),null!=n&&n==n&&("number"!==r||l||(n+=o&&o[3]||(ft.cssNumber[a]?"":"px")),ut.clearCloneStyle||""!==n||0!==e.indexOf("background")||(u[e]="inherit"),s&&"set"in s&&void 0===(n=s.set(t,n,i))||(l?u.setProperty(e,n):u[e]=n))}},css:function(t,e,n,i){var o,r,s,a=h(e);return pe.test(e)||(e=j(a)),(s=ft.cssHooks[e]||ft.cssHooks[a])&&"get"in s&&(o=s.get(t,!0,n)),void 0===o&&(o=$(t,e,i)),"normal"===o&&e in fe&&(o=fe[e]),""===n||n?(r=parseFloat(o),!0===n||isFinite(r)?r||0:o):o}}),ft.each(["height","width"],(function(t,e){ft.cssHooks[e]={get:function(t,n,i){if(n)return!de.test(ft.css(t,"display"))||t.getClientRects().length&&t.getBoundingClientRect().width?H(t,e,i):Rt(t,he,(function(){return H(t,e,i)}))},set:function(t,n,i){var o,r=se(t),s=!ut.scrollboxSize()&&"absolute"===r.position,a=(s||i)&&"border-box"===ft.css(t,"boxSizing",!1,r),l=i?M(t,e,i,a,r):0;return a&&s&&(l-=Math.ceil(t["offset"+e[0].toUpperCase()+e.slice(1)]-parseFloat(r[e])-M(t,e,"border",!1,r)-.5)),l&&(o=Ht.exec(n))&&"px"!==(o[3]||"px")&&(t.style[e]=n,n=ft.css(t,e)),N(0,n,l)}}})),ft.cssHooks.marginLeft=O(ut.reliableMarginLeft,(function(t,e){if(e)return(parseFloat($(t,"marginLeft"))||t.getBoundingClientRect().left-Rt(t,{marginLeft:0},(function(){return t.getBoundingClientRect().left})))+"px"})),ft.each({margin:"",padding:"",border:"Width"},(function(t,e){ft.cssHooks[t+e]={expand:function(n){for(var i=0,o={},r="string"==typeof n?n.split(" "):[n];i<4;i++)o[t+Ft[i]+e]=r[i]||r[i-2]||r[0];return o}},"margin"!==t&&(ft.cssHooks[t+e].set=N)})),ft.fn.extend({css:function(t,e){return It(this,(function(t,e,n){var i,o,r={},s=0;if(Array.isArray(e)){for(i=se(t),o=e.length;s<o;s++)r[e[s]]=ft.css(t,e[s],!1,i);return r}return void 0!==n?ft.style(t,e,n):ft.css(t,e)}),t,e,1<arguments.length)}}),((ft.Tween=F).prototype={constructor:F,init:function(t,e,n,i,o,r){this.elem=t,this.prop=n,this.easing=o||ft.easing._default,this.options=e,this.start=this.now=this.cur(),this.end=i,this.unit=r||(ft.cssNumber[n]?"":"px")},cur:function(){var t=F.propHooks[this.prop];return t&&t.get?t.get(this):F.propHooks._default.get(this)},run:function(t){var e,n=F.propHooks[this.prop];return this.options.duration?this.pos=e=ft.easing[this.easing](t,this.options.duration*t,0,1,this.options.duration):this.pos=e=t,this.now=(this.end-this.start)*e+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):F.propHooks._default.set(this),this}}).init.prototype=F.prototype,(F.propHooks={_default:{get:function(t){var e;return 1!==t.elem.nodeType||null!=t.elem[t.prop]&&null==t.elem.style[t.prop]?t.elem[t.prop]:(e=ft.css(t.elem,t.prop,""))&&"auto"!==e?e:0},set:function(t){ft.fx.step[t.prop]?ft.fx.step[t.prop](t):1!==t.elem.nodeType||!ft.cssHooks[t.prop]&&null==t.elem.style[j(t.prop)]?t.elem[t.prop]=t.now:ft.style(t.elem,t.prop,t.now+t.unit)}}}).scrollTop=F.propHooks.scrollLeft={set:function(t){t.elem.nodeType&&t.elem.parentNode&&(t.elem[t.prop]=t.now)}},ft.easing={linear:function(t){return t},swing:function(t){return.5-Math.cos(t*Math.PI)/2},_default:"swing"},ft.fx=F.prototype.init,ft.fx.step={};var me,ge,ve,ye,we=/^(?:toggle|show|hide)$/,be=/queueHooks$/;ft.Animation=ft.extend(R,{tweeners:{"*":[function(t,e){var n=this.createTween(t,e);return g(n.elem,t,Ht.exec(e),n),n}]},tweener:function(t,e){ct(t)?(e=t,t=["*"]):t=t.match(Tt);for(var n,i=0,o=t.length;i<o;i++)n=t[i],R.tweeners[n]=R.tweeners[n]||[],R.tweeners[n].unshift(e)},prefilters:[function(t,e,n){var i,o,r,s,a,l,u,c,d="width"in e||"height"in e,p=this,h={},f=t.style,m=t.nodeType&&qt(t),g=$t.get(t,"fxshow");for(i in n.queue||(null==(s=ft._queueHooks(t,"fx")).unqueued&&(s.unqueued=0,a=s.empty.fire,s.empty.fire=function(){s.unqueued||a()}),s.unqueued++,p.always((function(){p.always((function(){s.unqueued--,ft.queue(t,"fx").length||s.empty.fire()}))}))),e)if(o=e[i],we.test(o)){if(delete e[i],r=r||"toggle"===o,o===(m?"hide":"show")){if("show"!==o||!g||void 0===g[i])continue;m=!0}h[i]=g&&g[i]||ft.style(t,i)}if((l=!ft.isEmptyObject(e))||!ft.isEmptyObject(h))for(i in d&&1===t.nodeType&&(n.overflow=[f.overflow,f.overflowX,f.overflowY],null==(u=g&&g.display)&&(u=$t.get(t,"display")),"none"===(c=ft.css(t,"display"))&&(u?c=u:(v([t],!0),u=t.style.display||u,c=ft.css(t,"display"),v([t]))),("inline"===c||"inline-block"===c&&null!=u)&&"none"===ft.css(t,"float")&&(l||(p.done((function(){f.display=u})),null==u&&(c=f.display,u="none"===c?"":c)),f.display="inline-block")),n.overflow&&(f.overflow="hidden",p.always((function(){f.overflow=n.overflow[0],f.overflowX=n.overflow[1],f.overflowY=n.overflow[2]}))),l=!1,h)l||(g?"hidden"in g&&(m=g.hidden):g=$t.access(t,"fxshow",{display:u}),r&&(g.hidden=!m),m&&v([t],!0),p.done((function(){for(i in m||v([t]),$t.remove(t,"fxshow"),h)ft.style(t,i,h[i])}))),l=q(m?g[i]:0,i,p),i in g||(g[i]=l.start,m&&(l.end=l.start,l.start=0))}],prefilter:function(t,e){e?R.prefilters.unshift(t):R.prefilters.push(t)}}),ft.speed=function(t,e,n){var i=t&&"object"==typeof t?ft.extend({},t):{complete:n||!n&&e||ct(t)&&t,duration:t,easing:n&&e||e&&!ct(e)&&e};return ft.fx.off?i.duration=0:"number"!=typeof i.duration&&(i.duration in ft.fx.speeds?i.duration=ft.fx.speeds[i.duration]:i.duration=ft.fx.speeds._default),null!=i.queue&&!0!==i.queue||(i.queue="fx"),i.old=i.complete,i.complete=function(){ct(i.old)&&i.old.call(this),i.queue&&ft.dequeue(this,i.queue)},i},ft.fn.extend({fadeTo:function(t,e,n,i){return this.filter(qt).css("opacity",0).show().end().animate({opacity:e},t,n,i)},animate:function(t,e,n,i){var o=ft.isEmptyObject(t),r=ft.speed(e,n,i),s=function(){var e=R(this,ft.extend({},t),r);(o||$t.get(this,"finish"))&&e.stop(!0)};return s.finish=s,o||!1===r.queue?this.each(s):this.queue(r.queue,s)},stop:function(t,e,n){var i=function(t){var e=t.stop;delete t.stop,e(n)};return"string"!=typeof t&&(n=e,e=t,t=void 0),e&&!1!==t&&this.queue(t||"fx",[]),this.each((function(){var e=!0,o=null!=t&&t+"queueHooks",r=ft.timers,s=$t.get(this);if(o)s[o]&&s[o].stop&&i(s[o]);else for(o in s)s[o]&&s[o].stop&&be.test(o)&&i(s[o]);for(o=r.length;o--;)r[o].elem!==this||null!=t&&r[o].queue!==t||(r[o].anim.stop(n),e=!1,r.splice(o,1));!e&&n||ft.dequeue(this,t)}))},finish:function(t){return!1!==t&&(t=t||"fx"),this.each((function(){var e,n=$t.get(this),i=n[t+"queue"],o=n[t+"queueHooks"],r=ft.timers,s=i?i.length:0;for(n.finish=!0,ft.queue(this,t,[]),o&&o.stop&&o.stop.call(this,!0),e=r.length;e--;)r[e].elem===this&&r[e].queue===t&&(r[e].anim.stop(!0),r.splice(e,1));for(e=0;e<s;e++)i[e]&&i[e].finish&&i[e].finish.call(this);delete n.finish}))}}),ft.each(["toggle","show","hide"],(function(t,e){var n=ft.fn[e];ft.fn[e]=function(t,i,o){return null==t||"boolean"==typeof t?n.apply(this,arguments):this.animate(V(e,!0),t,i,o)}})),ft.each({slideDown:V("show"),slideUp:V("hide"),slideToggle:V("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},(function(t,e){ft.fn[t]=function(t,n,i){return this.animate(e,t,n,i)}})),ft.timers=[],ft.fx.tick=function(){var t,e=0,n=ft.timers;for(me=Date.now();e<n.length;e++)(t=n[e])()||n[e]!==t||n.splice(e--,1);n.length||ft.fx.stop(),me=void 0},ft.fx.timer=function(t){ft.timers.push(t),ft.fx.start()},ft.fx.interval=13,ft.fx.start=function(){ge||(ge=!0,D())},ft.fx.stop=function(){ge=null},ft.fx.speeds={slow:600,fast:200,_default:400},ft.fn.delay=function(e,n){return e=ft.fx&&ft.fx.speeds[e]||e,n=n||"fx",this.queue(n,(function(n,i){var o=t.setTimeout(n,e);i.stop=function(){t.clearTimeout(o)}}))},ve=K.createElement("input"),ye=K.createElement("select").appendChild(K.createElement("option")),ve.type="checkbox",ut.checkOn=""!==ve.value,ut.optSelected=ye.selected,(ve=K.createElement("input")).value="t",ve.type="radio",ut.radioValue="t"===ve.value;var xe,_e=ft.expr.attrHandle;ft.fn.extend({attr:function(t,e){return It(this,ft.attr,t,e,1<arguments.length)},removeAttr:function(t){return this.each((function(){ft.removeAttr(this,t)}))}}),ft.extend({attr:function(t,e,n){var i,o,r=t.nodeType;if(3!==r&&8!==r&&2!==r)return void 0===t.getAttribute?ft.prop(t,e,n):(1===r&&ft.isXMLDoc(t)||(o=ft.attrHooks[e.toLowerCase()]||(ft.expr.match.bool.test(e)?xe:void 0)),void 0!==n?null===n?void ft.removeAttr(t,e):o&&"set"in o&&void 0!==(i=o.set(t,n,e))?i:(t.setAttribute(e,n+""),n):o&&"get"in o&&null!==(i=o.get(t,e))?i:null==(i=ft.find.attr(t,e))?void 0:i)},attrHooks:{type:{set:function(t,e){if(!ut.radioValue&&"radio"===e&&r(t,"input")){var n=t.value;return t.setAttribute("type",e),n&&(t.value=n),e}}}},removeAttr:function(t,e){var n,i=0,o=e&&e.match(Tt);if(o&&1===t.nodeType)for(;n=o[i++];)t.removeAttribute(n)}}),xe={set:function(t,e,n){return!1===e?ft.removeAttr(t,n):t.setAttribute(n,n),n}},ft.each(ft.expr.match.bool.source.match(/\w+/g),(function(t,e){var n=_e[e]||ft.find.attr;_e[e]=function(t,e,i){var o,r,s=e.toLowerCase();return i||(r=_e[s],_e[s]=o,o=null!=n(t,e,i)?s:null,_e[s]=r),o}}));var Ce=/^(?:input|select|textarea|button)$/i,ke=/^(?:a|area)$/i;ft.fn.extend({prop:function(t,e){return It(this,ft.prop,t,e,1<arguments.length)},removeProp:function(t){return this.each((function(){delete this[ft.propFix[t]||t]}))}}),ft.extend({prop:function(t,e,n){var i,o,r=t.nodeType;if(3!==r&&8!==r&&2!==r)return 1===r&&ft.isXMLDoc(t)||(e=ft.propFix[e]||e,o=ft.propHooks[e]),void 0!==n?o&&"set"in o&&void 0!==(i=o.set(t,n,e))?i:t[e]=n:o&&"get"in o&&null!==(i=o.get(t,e))?i:t[e]},propHooks:{tabIndex:{get:function(t){var e=ft.find.attr(t,"tabindex");return e?parseInt(e,10):Ce.test(t.nodeName)||ke.test(t.nodeName)&&t.href?0:-1}}},propFix:{for:"htmlFor",class:"className"}}),ut.optSelected||(ft.propHooks.selected={get:function(t){var e=t.parentNode;return e&&e.parentNode&&e.parentNode.selectedIndex,null},set:function(t){var e=t.parentNode;e&&(e.selectedIndex,e.parentNode&&e.parentNode.selectedIndex)}}),ft.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],(function(){ft.propFix[this.toLowerCase()]=this})),ft.fn.extend({addClass:function(t){var e,n,i,o,r,s,a,l=0;if(ct(t))return this.each((function(e){ft(this).addClass(t.call(this,e,B(this)))}));if((e=Y(t)).length)for(;n=this[l++];)if(o=B(n),i=1===n.nodeType&&" "+W(o)+" "){for(s=0;r=e[s++];)i.indexOf(" "+r+" ")<0&&(i+=r+" ");o!==(a=W(i))&&n.setAttribute("class",a)}return this},removeClass:function(t){var e,n,i,o,r,s,a,l=0;if(ct(t))return this.each((function(e){ft(this).removeClass(t.call(this,e,B(this)))}));if(!arguments.length)return this.attr("class","");if((e=Y(t)).length)for(;n=this[l++];)if(o=B(n),i=1===n.nodeType&&" "+W(o)+" "){for(s=0;r=e[s++];)for(;-1<i.indexOf(" "+r+" ");)i=i.replace(" "+r+" "," ");o!==(a=W(i))&&n.setAttribute("class",a)}return this},toggleClass:function(t,e){var n=typeof t,i="string"===n||Array.isArray(t);return"boolean"==typeof e&&i?e?this.addClass(t):this.removeClass(t):ct(t)?this.each((function(n){ft(this).toggleClass(t.call(this,n,B(this),e),e)})):this.each((function(){var e,o,r,s;if(i)for(o=0,r=ft(this),s=Y(t);e=s[o++];)r.hasClass(e)?r.removeClass(e):r.addClass(e);else void 0!==t&&"boolean"!==n||((e=B(this))&&$t.set(this,"__className__",e),this.setAttribute&&this.setAttribute("class",e||!1===t?"":$t.get(this,"__className__")||""))}))},hasClass:function(t){var e,n,i=0;for(e=" "+t+" ";n=this[i++];)if(1===n.nodeType&&-1<(" "+W(B(n))+" ").indexOf(e))return!0;return!1}});var Te=/\r/g;ft.fn.extend({val:function(t){var e,n,i,o=this[0];return arguments.length?(i=ct(t),this.each((function(n){var o;1===this.nodeType&&(null==(o=i?t.call(this,n,ft(this).val()):t)?o="":"number"==typeof o?o+="":Array.isArray(o)&&(o=ft.map(o,(function(t){return null==t?"":t+""}))),(e=ft.valHooks[this.type]||ft.valHooks[this.nodeName.toLowerCase()])&&"set"in e&&void 0!==e.set(this,o,"value")||(this.value=o))}))):o?(e=ft.valHooks[o.type]||ft.valHooks[o.nodeName.toLowerCase()])&&"get"in e&&void 0!==(n=e.get(o,"value"))?n:"string"==typeof(n=o.value)?n.replace(Te,""):null==n?"":n:void 0}}),ft.extend({valHooks:{option:{get:function(t){var e=ft.find.attr(t,"value");return null!=e?e:W(ft.text(t))}},select:{get:function(t){var e,n,i,o=t.options,s=t.selectedIndex,a="select-one"===t.type,l=a?null:[],u=a?s+1:o.length;for(i=s<0?u:a?s:0;i<u;i++)if(((n=o[i]).selected||i===s)&&!n.disabled&&(!n.parentNode.disabled||!r(n.parentNode,"optgroup"))){if(e=ft(n).val(),a)return e;l.push(e)}return l},set:function(t,e){for(var n,i,o=t.options,r=ft.makeArray(e),s=o.length;s--;)((i=o[s]).selected=-1<ft.inArray(ft.valHooks.option.get(i),r))&&(n=!0);return n||(t.selectedIndex=-1),r}}}}),ft.each(["radio","checkbox"],(function(){ft.valHooks[this]={set:function(t,e){if(Array.isArray(e))return t.checked=-1<ft.inArray(ft(t).val(),e)}},ut.checkOn||(ft.valHooks[this].get=function(t){return null===t.getAttribute("value")?"on":t.value})})),ut.focusin="onfocusin"in t;var Se=/^(?:focusinfocus|focusoutblur)$/,Ee=function(t){t.stopPropagation()};ft.extend(ft.event,{trigger:function(e,n,i,o){var r,s,a,l,u,c,d,p,h=[i||K],f=st.call(e,"type")?e.type:e,m=st.call(e,"namespace")?e.namespace.split("."):[];if(s=p=a=i=i||K,3!==i.nodeType&&8!==i.nodeType&&!Se.test(f+ft.event.triggered)&&(-1<f.indexOf(".")&&(f=(m=f.split(".")).shift(),m.sort()),u=f.indexOf(":")<0&&"on"+f,(e=e[ft.expando]?e:new ft.Event(f,"object"==typeof e&&e)).isTrigger=o?2:3,e.namespace=m.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+m.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=i),n=null==n?[e]:ft.makeArray(n,[e]),d=ft.event.special[f]||{},o||!d.trigger||!1!==d.trigger.apply(i,n))){if(!o&&!d.noBubble&&!dt(i)){for(l=d.delegateType||f,Se.test(l+f)||(s=s.parentNode);s;s=s.parentNode)h.push(s),a=s;a===(i.ownerDocument||K)&&h.push(a.defaultView||a.parentWindow||t)}for(r=0;(s=h[r++])&&!e.isPropagationStopped();)p=s,e.type=1<r?l:d.bindType||f,(c=($t.get(s,"events")||{})[e.type]&&$t.get(s,"handle"))&&c.apply(s,n),(c=u&&s[u])&&c.apply&&At(s)&&(e.result=c.apply(s,n),!1===e.result&&e.preventDefault());return e.type=f,o||e.isDefaultPrevented()||d._default&&!1!==d._default.apply(h.pop(),n)||!At(i)||u&&ct(i[f])&&!dt(i)&&((a=i[u])&&(i[u]=null),ft.event.triggered=f,e.isPropagationStopped()&&p.addEventListener(f,Ee),i[f](),e.isPropagationStopped()&&p.removeEventListener(f,Ee),ft.event.triggered=void 0,a&&(i[u]=a)),e.result}},simulate:function(t,e,n){var i=ft.extend(new ft.Event,n,{type:t,isSimulated:!0});ft.event.trigger(i,null,e)}}),ft.fn.extend({trigger:function(t,e){return this.each((function(){ft.event.trigger(t,e,this)}))},triggerHandler:function(t,e){var n=this[0];if(n)return ft.event.trigger(t,e,n,!0)}}),ut.focusin||ft.each({focus:"focusin",blur:"focusout"},(function(t,e){var n=function(t){ft.event.simulate(e,t.target,ft.event.fix(t))};ft.event.special[e]={setup:function(){var i=this.ownerDocument||this,o=$t.access(i,e);o||i.addEventListener(t,n,!0),$t.access(i,e,(o||0)+1)},teardown:function(){var i=this.ownerDocument||this,o=$t.access(i,e)-1;o?$t.access(i,e,o):(i.removeEventListener(t,n,!0),$t.remove(i,e))}}}));var Ie=t.location,Pe=Date.now(),Le=/\?/;ft.parseXML=function(e){var n;if(!e||"string"!=typeof e)return null;try{n=(new t.DOMParser).parseFromString(e,"text/xml")}catch(e){n=void 0}return n&&!n.getElementsByTagName("parsererror").length||ft.error("Invalid XML: "+e),n};var Ae=/\[\]$/,$e=/\r?\n/g,Oe=/^(?:submit|button|image|reset|file)$/i,je=/^(?:input|select|textarea|keygen)/i;ft.param=function(t,e){var n,i=[],o=function(t,e){var n=ct(e)?e():e;i[i.length]=encodeURIComponent(t)+"="+encodeURIComponent(null==n?"":n)};if(null==t)return"";if(Array.isArray(t)||t.jquery&&!ft.isPlainObject(t))ft.each(t,(function(){o(this.name,this.value)}));else for(n in t)X(n,t[n],e,o);return i.join("&")},ft.fn.extend({serialize:function(){return ft.param(this.serializeArray())},serializeArray:function(){return this.map((function(){var t=ft.prop(this,"elements");return t?ft.makeArray(t):this})).filter((function(){var t=this.type;return this.name&&!ft(this).is(":disabled")&&je.test(this.nodeName)&&!Oe.test(t)&&(this.checked||!Bt.test(t))})).map((function(t,e){var n=ft(this).val();return null==n?null:Array.isArray(n)?ft.map(n,(function(t){return{name:e.name,value:t.replace($e,"\r\n")}})):{name:e.name,value:n.replace($e,"\r\n")}})).get()}});var Ne=/%20/g,Me=/#.*$/,He=/([?&])_=[^&]*/,Fe=/^(.*?):[ \t]*([^\r\n]*)$/gm,De=/^(?:GET|HEAD)$/,ze=/^\/\//,Ve={},qe={},Re="*/".concat("*"),We=K.createElement("a");We.href=Ie.href,ft.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Ie.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Ie.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Re,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":ft.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(t,e){return e?Q(Q(t,ft.ajaxSettings),e):Q(ft.ajaxSettings,t)},ajaxPrefilter:U(Ve),ajaxTransport:U(qe),ajax:function(e,n){function i(e,n,i,a){var u,p,h,b,x,_=n;c||(c=!0,l&&t.clearTimeout(l),o=void 0,s=a||"",C.readyState=0<e?4:0,u=200<=e&&e<300||304===e,i&&(b=function(t,e,n){for(var i,o,r,s,a=t.contents,l=t.dataTypes;"*"===l[0];)l.shift(),void 0===i&&(i=t.mimeType||e.getResponseHeader("Content-Type"));if(i)for(o in a)if(a[o]&&a[o].test(i)){l.unshift(o);break}if(l[0]in n)r=l[0];else{for(o in n){if(!l[0]||t.converters[o+" "+l[0]]){r=o;break}s||(s=o)}r=r||s}if(r)return r!==l[0]&&l.unshift(r),n[r]}(f,C,i)),b=function(t,e,n,i){var o,r,s,a,l,u={},c=t.dataTypes.slice();if(c[1])for(s in t.converters)u[s.toLowerCase()]=t.converters[s];for(r=c.shift();r;)if(t.responseFields[r]&&(n[t.responseFields[r]]=e),!l&&i&&t.dataFilter&&(e=t.dataFilter(e,t.dataType)),l=r,r=c.shift())if("*"===r)r=l;else if("*"!==l&&l!==r){if(!(s=u[l+" "+r]||u["* "+r]))for(o in u)if((a=o.split(" "))[1]===r&&(s=u[l+" "+a[0]]||u["* "+a[0]])){!0===s?s=u[o]:!0!==u[o]&&(r=a[0],c.unshift(a[1]));break}if(!0!==s)if(s&&t.throws)e=s(e);else try{e=s(e)}catch(t){return{state:"parsererror",error:s?t:"No conversion from "+l+" to "+r}}}return{state:"success",data:e}}(f,b,C,u),u?(f.ifModified&&((x=C.getResponseHeader("Last-Modified"))&&(ft.lastModified[r]=x),(x=C.getResponseHeader("etag"))&&(ft.etag[r]=x)),204===e||"HEAD"===f.type?_="nocontent":304===e?_="notmodified":(_=b.state,p=b.data,u=!(h=b.error))):(h=_,!e&&_||(_="error",e<0&&(e=0))),C.status=e,C.statusText=(n||_)+"",u?v.resolveWith(m,[p,_,C]):v.rejectWith(m,[C,_,h]),C.statusCode(w),w=void 0,d&&g.trigger(u?"ajaxSuccess":"ajaxError",[C,f,u?p:h]),y.fireWith(m,[C,_]),d&&(g.trigger("ajaxComplete",[C,f]),--ft.active||ft.event.trigger("ajaxStop")))}"object"==typeof e&&(n=e,e=void 0),n=n||{};var o,r,s,a,l,u,c,d,p,h,f=ft.ajaxSetup({},n),m=f.context||f,g=f.context&&(m.nodeType||m.jquery)?ft(m):ft.event,v=ft.Deferred(),y=ft.Callbacks("once memory"),w=f.statusCode||{},b={},x={},_="canceled",C={readyState:0,getResponseHeader:function(t){var e;if(c){if(!a)for(a={};e=Fe.exec(s);)a[e[1].toLowerCase()+" "]=(a[e[1].toLowerCase()+" "]||[]).concat(e[2]);e=a[t.toLowerCase()+" "]}return null==e?null:e.join(", ")},getAllResponseHeaders:function(){return c?s:null},setRequestHeader:function(t,e){return null==c&&(t=x[t.toLowerCase()]=x[t.toLowerCase()]||t,b[t]=e),this},overrideMimeType:function(t){return null==c&&(f.mimeType=t),this},statusCode:function(t){var e;if(t)if(c)C.always(t[C.status]);else for(e in t)w[e]=[w[e],t[e]];return this},abort:function(t){var e=t||_;return o&&o.abort(e),i(0,e),this}};if(v.promise(C),f.url=((e||f.url||Ie.href)+"").replace(ze,Ie.protocol+"//"),f.type=n.method||n.type||f.method||f.type,f.dataTypes=(f.dataType||"*").toLowerCase().match(Tt)||[""],null==f.crossDomain){u=K.createElement("a");try{u.href=f.url,u.href=u.href,f.crossDomain=We.protocol+"//"+We.host!=u.protocol+"//"+u.host}catch(e){f.crossDomain=!0}}if(f.data&&f.processData&&"string"!=typeof f.data&&(f.data=ft.param(f.data,f.traditional)),G(Ve,f,n,C),c)return C;for(p in(d=ft.event&&f.global)&&0==ft.active++&&ft.event.trigger("ajaxStart"),f.type=f.type.toUpperCase(),f.hasContent=!De.test(f.type),r=f.url.replace(Me,""),f.hasContent?f.data&&f.processData&&0===(f.contentType||"").indexOf("application/x-www-form-urlencoded")&&(f.data=f.data.replace(Ne,"+")):(h=f.url.slice(r.length),f.data&&(f.processData||"string"==typeof f.data)&&(r+=(Le.test(r)?"&":"?")+f.data,delete f.data),!1===f.cache&&(r=r.replace(He,"$1"),h=(Le.test(r)?"&":"?")+"_="+Pe+++h),f.url=r+h),f.ifModified&&(ft.lastModified[r]&&C.setRequestHeader("If-Modified-Since",ft.lastModified[r]),ft.etag[r]&&C.setRequestHeader("If-None-Match",ft.etag[r])),(f.data&&f.hasContent&&!1!==f.contentType||n.contentType)&&C.setRequestHeader("Content-Type",f.contentType),C.setRequestHeader("Accept",f.dataTypes[0]&&f.accepts[f.dataTypes[0]]?f.accepts[f.dataTypes[0]]+("*"!==f.dataTypes[0]?", "+Re+"; q=0.01":""):f.accepts["*"]),f.headers)C.setRequestHeader(p,f.headers[p]);if(f.beforeSend&&(!1===f.beforeSend.call(m,C,f)||c))return C.abort();if(_="abort",y.add(f.complete),C.done(f.success),C.fail(f.error),o=G(qe,f,n,C)){if(C.readyState=1,d&&g.trigger("ajaxSend",[C,f]),c)return C;f.async&&0<f.timeout&&(l=t.setTimeout((function(){C.abort("timeout")}),f.timeout));try{c=!1,o.send(b,i)}catch(e){if(c)throw e;i(-1,e)}}else i(-1,"No Transport");return C},getJSON:function(t,e,n){return ft.get(t,e,n,"json")},getScript:function(t,e){return ft.get(t,void 0,e,"script")}}),ft.each(["get","post"],(function(t,e){ft[e]=function(t,n,i,o){return ct(n)&&(o=o||i,i=n,n=void 0),ft.ajax(ft.extend({url:t,type:e,dataType:o,data:n,success:i},ft.isPlainObject(t)&&t))}})),ft._evalUrl=function(t,e){return ft.ajax({url:t,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(t){ft.globalEval(t,e)}})},ft.fn.extend({wrapAll:function(t){var e;return this[0]&&(ct(t)&&(t=t.call(this[0])),e=ft(t,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&e.insertBefore(this[0]),e.map((function(){for(var t=this;t.firstElementChild;)t=t.firstElementChild;return t})).append(this)),this},wrapInner:function(t){return ct(t)?this.each((function(e){ft(this).wrapInner(t.call(this,e))})):this.each((function(){var e=ft(this),n=e.contents();n.length?n.wrapAll(t):e.append(t)}))},wrap:function(t){var e=ct(t);return this.each((function(n){ft(this).wrapAll(e?t.call(this,n):t)}))},unwrap:function(t){return this.parent(t).not("body").each((function(){ft(this).replaceWith(this.childNodes)})),this}}),ft.expr.pseudos.hidden=function(t){return!ft.expr.pseudos.visible(t)},ft.expr.pseudos.visible=function(t){return!!(t.offsetWidth||t.offsetHeight||t.getClientRects().length)},ft.ajaxSettings.xhr=function(){try{return new t.XMLHttpRequest}catch(t){}};var Be={0:200,1223:204},Ye=ft.ajaxSettings.xhr();ut.cors=!!Ye&&"withCredentials"in Ye,ut.ajax=Ye=!!Ye,ft.ajaxTransport((function(e){var n,i;if(ut.cors||Ye&&!e.crossDomain)return{send:function(o,r){var s,a=e.xhr();if(a.open(e.type,e.url,e.async,e.username,e.password),e.xhrFields)for(s in e.xhrFields)a[s]=e.xhrFields[s];for(s in e.mimeType&&a.overrideMimeType&&a.overrideMimeType(e.mimeType),e.crossDomain||o["X-Requested-With"]||(o["X-Requested-With"]="XMLHttpRequest"),o)a.setRequestHeader(s,o[s]);n=function(t){return function(){n&&(n=i=a.onload=a.onerror=a.onabort=a.ontimeout=a.onreadystatechange=null,"abort"===t?a.abort():"error"===t?"number"!=typeof a.status?r(0,"error"):r(a.status,a.statusText):r(Be[a.status]||a.status,a.statusText,"text"!==(a.responseType||"text")||"string"!=typeof a.responseText?{binary:a.response}:{text:a.responseText},a.getAllResponseHeaders()))}},a.onload=n(),i=a.onerror=a.ontimeout=n("error"),void 0!==a.onabort?a.onabort=i:a.onreadystatechange=function(){4===a.readyState&&t.setTimeout((function(){n&&i()}))},n=n("abort");try{a.send(e.hasContent&&e.data||null)}catch(o){if(n)throw o}},abort:function(){n&&n()}}})),ft.ajaxPrefilter((function(t){t.crossDomain&&(t.contents.script=!1)})),ft.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(t){return ft.globalEval(t),t}}}),ft.ajaxPrefilter("script",(function(t){void 0===t.cache&&(t.cache=!1),t.crossDomain&&(t.type="GET")})),ft.ajaxTransport("script",(function(t){var e,n;if(t.crossDomain||t.scriptAttrs)return{send:function(i,o){e=ft("<script>").attr(t.scriptAttrs||{}).prop({charset:t.scriptCharset,src:t.url}).on("load error",n=function(t){e.remove(),n=null,t&&o("error"===t.type?404:200,t.type)}),K.head.appendChild(e[0])},abort:function(){n&&n()}}}));var Xe,Ue=[],Ge=/(=)\?(?=&|$)|\?\?/;ft.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var t=Ue.pop()||ft.expando+"_"+Pe++;return this[t]=!0,t}}),ft.ajaxPrefilter("json jsonp",(function(e,n,i){var o,r,s,a=!1!==e.jsonp&&(Ge.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Ge.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return o=e.jsonpCallback=ct(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Ge,"$1"+o):!1!==e.jsonp&&(e.url+=(Le.test(e.url)?"&":"?")+e.jsonp+"="+o),e.converters["script json"]=function(){return s||ft.error(o+" was not called"),s[0]},e.dataTypes[0]="json",r=t[o],t[o]=function(){s=arguments},i.always((function(){void 0===r?ft(t).removeProp(o):t[o]=r,e[o]&&(e.jsonpCallback=n.jsonpCallback,Ue.push(o)),s&&ct(r)&&r(s[0]),s=r=void 0})),"script"})),ut.createHTMLDocument=((Xe=K.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===Xe.childNodes.length),ft.parseHTML=function(t,e,n){return"string"!=typeof t?[]:("boolean"==typeof e&&(n=e,e=!1),e||(ut.createHTMLDocument?((i=(e=K.implementation.createHTMLDocument("")).createElement("base")).href=K.location.href,e.head.appendChild(i)):e=K),r=!n&&[],(o=bt.exec(t))?[e.createElement(o[1])]:(o=b([t],e,r),r&&r.length&&ft(r).remove(),ft.merge([],o.childNodes)));var i,o,r},ft.fn.load=function(t,e,n){var i,o,r,s=this,a=t.indexOf(" ");return-1<a&&(i=W(t.slice(a)),t=t.slice(0,a)),ct(e)?(n=e,e=void 0):e&&"object"==typeof e&&(o="POST"),0<s.length&&ft.ajax({url:t,type:o||"GET",dataType:"html",data:e}).done((function(t){r=arguments,s.html(i?ft("<div>").append(ft.parseHTML(t)).find(i):t)})).always(n&&function(t,e){s.each((function(){n.apply(this,r||[t.responseText,e,t])}))}),this},ft.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],(function(t,e){ft.fn[e]=function(t){return this.on(e,t)}})),ft.expr.pseudos.animated=function(t){return ft.grep(ft.timers,(function(e){return t===e.elem})).length},ft.offset={setOffset:function(t,e,n){var i,o,r,s,a,l,u=ft.css(t,"position"),c=ft(t),d={};"static"===u&&(t.style.position="relative"),a=c.offset(),r=ft.css(t,"top"),l=ft.css(t,"left"),("absolute"===u||"fixed"===u)&&-1<(r+l).indexOf("auto")?(s=(i=c.position()).top,o=i.left):(s=parseFloat(r)||0,o=parseFloat(l)||0),ct(e)&&(e=e.call(t,n,ft.extend({},a))),null!=e.top&&(d.top=e.top-a.top+s),null!=e.left&&(d.left=e.left-a.left+o),"using"in e?e.using.call(t,d):c.css(d)}},ft.fn.extend({offset:function(t){if(arguments.length)return void 0===t?this:this.each((function(e){ft.offset.setOffset(this,t,e)}));var e,n,i=this[0];return i?i.getClientRects().length?(e=i.getBoundingClientRect(),n=i.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var t,e,n,i=this[0],o={top:0,left:0};if("fixed"===ft.css(i,"position"))e=i.getBoundingClientRect();else{for(e=this.offset(),n=i.ownerDocument,t=i.offsetParent||n.documentElement;t&&(t===n.body||t===n.documentElement)&&"static"===ft.css(t,"position");)t=t.parentNode;t&&t!==i&&1===t.nodeType&&((o=ft(t).offset()).top+=ft.css(t,"borderTopWidth",!0),o.left+=ft.css(t,"borderLeftWidth",!0))}return{top:e.top-o.top-ft.css(i,"marginTop",!0),left:e.left-o.left-ft.css(i,"marginLeft",!0)}}},offsetParent:function(){return this.map((function(){for(var t=this.offsetParent;t&&"static"===ft.css(t,"position");)t=t.offsetParent;return t||Dt}))}}),ft.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},(function(t,e){var n="pageYOffset"===e;ft.fn[t]=function(i){return It(this,(function(t,i,o){var r;if(dt(t)?r=t:9===t.nodeType&&(r=t.defaultView),void 0===o)return r?r[e]:t[i];r?r.scrollTo(n?r.pageXOffset:o,n?o:r.pageYOffset):t[i]=o}),t,i,arguments.length)}})),ft.each(["top","left"],(function(t,e){ft.cssHooks[e]=O(ut.pixelPosition,(function(t,n){if(n)return n=$(t,e),re.test(n)?ft(t).position()[e]+"px":n}))})),ft.each({Height:"height",Width:"width"},(function(t,e){ft.each({padding:"inner"+t,content:e,"":"outer"+t},(function(n,i){ft.fn[i]=function(o,r){var s=arguments.length&&(n||"boolean"!=typeof o),a=n||(!0===o||!0===r?"margin":"border");return It(this,(function(e,n,o){var r;return dt(e)?0===i.indexOf("outer")?e["inner"+t]:e.document.documentElement["client"+t]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+t],r["scroll"+t],e.body["offset"+t],r["offset"+t],r["client"+t])):void 0===o?ft.css(e,n,a):ft.style(e,n,o,a)}),e,s?o:void 0,s)}}))})),ft.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),(function(t,e){ft.fn[e]=function(t,n){return 0<arguments.length?this.on(e,null,t,n):this.trigger(e)}})),ft.fn.extend({hover:function(t,e){return this.mouseenter(t).mouseleave(e||t)}}),ft.fn.extend({bind:function(t,e,n){return this.on(t,null,e,n)},unbind:function(t,e){return this.off(t,null,e)},delegate:function(t,e,n,i){return this.on(e,t,n,i)},undelegate:function(t,e,n){return 1===arguments.length?this.off(t,"**"):this.off(e,t||"**",n)}}),ft.proxy=function(t,e){var n,i,o;if("string"==typeof e&&(n=t[e],e=t,t=n),ct(t))return i=tt.call(arguments,2),(o=function(){return t.apply(e||this,i.concat(tt.call(arguments)))}).guid=t.guid=t.guid||ft.guid++,o},ft.holdReady=function(t){t?ft.readyWait++:ft.ready(!0)},ft.isArray=Array.isArray,ft.parseJSON=JSON.parse,ft.nodeName=r,ft.isFunction=ct,ft.isWindow=dt,ft.camelCase=h,ft.type=i,ft.now=Date.now,ft.isNumeric=function(t){var e=ft.type(t);return("number"===e||"string"===e)&&!isNaN(t-parseFloat(t))},"function"==typeof define&&define.amd&&define("jquery",[],(function(){return ft}));var Qe=t.jQuery,Je=t.$;return ft.noConflict=function(e){return t.$===ft&&(t.$=Je),e&&t.jQuery===ft&&(t.jQuery=Qe),ft},e||(t.jQuery=t.$=ft),ft},"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?n(e,!0):function(t){if(!t.document)throw new Error("jQuery requires a window with a document");return n(t)}:n(e);var i=navigator.userAgent.indexOf("Android")>0,o=/iP(ad|hone|od)/.test(navigator.userAgent),r=o&&/OS 4_\d(_\d)?/.test(navigator.userAgent),s=o&&/OS ([6-9]|\d{2})_\d/.test(navigator.userAgent),a=navigator.userAgent.indexOf("BB10")>0;t.prototype.needsClick=function(t){switch(t.nodeName.toLowerCase()){case"button":case"select":case"textarea":if(t.disabled)return!0;break;case"input":if(o&&"file"===t.type||t.disabled)return!0;break;case"label":case"video":return!0}return/\bneedsclick\b/.test(t.className)},t.prototype.needsFocus=function(t){switch(t.nodeName.toLowerCase()){case"textarea":return!0;case"select":return!i;case"input":switch(t.type){case"button":case"checkbox":case"file":case"image":case"radio":case"submit":return!1}return!t.disabled&&!t.readOnly;default:return/\bneedsfocus\b/.test(t.className)}},t.prototype.sendClick=function(t,e){var n,i;document.activeElement&&document.activeElement!==t&&document.activeElement.blur(),i=e.changedTouches[0],(n=document.createEvent("MouseEvents")).initMouseEvent(this.determineEventType(t),!0,!0,window,1,i.screenX,i.screenY,i.clientX,i.clientY,!1,!1,!1,!1,0,null),n.forwardedTouchEvent=!0,t.dispatchEvent(n)},t.prototype.determineEventType=function(t){return i&&"select"===t.tagName.toLowerCase()?"mousedown":"click"},t.prototype.focus=function(t){var e;o&&t.setSelectionRange&&0!==t.type.indexOf("date")&&"time"!==t.type?(e=t.value.length,t.setSelectionRange(e,e)):t.focus()},t.prototype.updateScrollParent=function(t){var e,n;if(!(e=t.fastClickScrollParent)||!e.contains(t)){n=t;do{if(n.scrollHeight>n.offsetHeight){e=n,t.fastClickScrollParent=n;break}n=n.parentElement}while(n)}e&&(e.fastClickLastScrollTop=e.scrollTop)},t.prototype.getTargetElementFromEventTarget=function(t){return t.nodeType===Node.TEXT_NODE?t.parentNode:t},t.prototype.onTouchStart=function(t){var e,n,i;if(t.targetTouches.length>1)return!0;if(e=this.getTargetElementFromEventTarget(t.target),n=t.targetTouches[0],o){if((i=window.getSelection()).rangeCount&&!i.isCollapsed)return!0;if(!r){if(n.identifier&&n.identifier===this.lastTouchIdentifier)return t.preventDefault(),!1;this.lastTouchIdentifier=n.identifier,this.updateScrollParent(e)}}return this.trackingClick=!0,this.trackingClickStart=t.timeStamp,this.targetElement=e,this.touchStartX=n.pageX,this.touchStartY=n.pageY,t.timeStamp-this.lastClickTime<this.tapDelay&&t.preventDefault(),!0},t.prototype.touchHasMoved=function(t){var e=t.changedTouches[0],n=this.touchBoundary;return Math.abs(e.pageX-this.touchStartX)>n||Math.abs(e.pageY-this.touchStartY)>n},t.prototype.onTouchMove=function(t){return!this.trackingClick||((this.targetElement!==this.getTargetElementFromEventTarget(t.target)||this.touchHasMoved(t))&&(this.trackingClick=!1,this.targetElement=null),!0)},t.prototype.findControl=function(t){return void 0!==t.control?t.control:t.htmlFor?document.getElementById(t.htmlFor):t.querySelector("button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea")},t.prototype.onTouchEnd=function(t){var e,n,a,l,u,c=this.targetElement;if(!this.trackingClick)return!0;if(t.timeStamp-this.lastClickTime<this.tapDelay)return this.cancelNextClick=!0,!0;if(this.cancelNextClick=!1,this.lastClickTime=t.timeStamp,n=this.trackingClickStart,this.trackingClick=!1,this.trackingClickStart=0,s&&(u=t.changedTouches[0],(c=document.elementFromPoint(u.pageX-window.pageXOffset,u.pageY-window.pageYOffset)||c).fastClickScrollParent=this.targetElement.fastClickScrollParent),"label"===(a=c.tagName.toLowerCase())){if(e=this.findControl(c)){if(this.focus(c),i)return!1;c=e}}else if(this.needsFocus(c))return t.timeStamp-n>100||o&&window.top!==window&&"input"===a?(this.targetElement=null,!1):(this.focus(c),this.sendClick(c,t),o&&"select"===a||(this.targetElement=null,t.preventDefault()),!1);return!(!o||r||!(l=c.fastClickScrollParent)||l.fastClickLastScrollTop===l.scrollTop)||(this.needsClick(c)||(t.preventDefault(),this.sendClick(c,t)),!1)},t.prototype.onTouchCancel=function(){this.trackingClick=!1,this.targetElement=null},t.prototype.onMouse=function(t){return!(this.targetElement&&!t.forwardedTouchEvent&&t.cancelable&&(!this.needsClick(this.targetElement)||this.cancelNextClick)&&(t.stopImmediatePropagation?t.stopImmediatePropagation():t.propagationStopped=!0,t.stopPropagation(),t.preventDefault(),1))},t.prototype.onClick=function(t){var e;return this.trackingClick?(this.targetElement=null,this.trackingClick=!1,!0):"submit"===t.target.type&&0===t.detail||((e=this.onMouse(t))||(this.targetElement=null),e)},t.prototype.destroy=function(){var t=this.layer;i&&(t.removeEventListener("mouseover",this.onMouse,!0),t.removeEventListener("mousedown",this.onMouse,!0),t.removeEventListener("mouseup",this.onMouse,!0)),t.removeEventListener("click",this.onClick,!0),t.removeEventListener("touchstart",this.onTouchStart,!1),t.removeEventListener("touchmove",this.onTouchMove,!1),t.removeEventListener("touchend",this.onTouchEnd,!1),t.removeEventListener("touchcancel",this.onTouchCancel,!1)},t.notNeeded=function(t){var e,n,o;if(void 0===window.ontouchstart)return!0;if(n=+(/Chrome\/([0-9]+)/.exec(navigator.userAgent)||[,0])[1]){if(!i)return!0;if(e=document.querySelector("meta[name=viewport]")){if(-1!==e.content.indexOf("user-scalable=no"))return!0;if(n>31&&document.documentElement.scrollWidth<=window.outerWidth)return!0}}if(a&&((o=navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/))[1]>=10&&o[2]>=3&&(e=document.querySelector("meta[name=viewport]")))){if(-1!==e.content.indexOf("user-scalable=no"))return!0;if(document.documentElement.scrollWidth<=window.outerWidth)return!0}return"none"===t.style.msTouchAction},t.attach=function(e,n){return new t(e,n)},"function"==typeof define&&"object"==typeof define.amd&&define.amd?define((function(){return t})):"undefined"!=typeof module&&module.exports?(module.exports=t.attach,module.exports.FastClick=t):window.FastClick=t,
/*!
 *  jQuery OwlCarousel v1.3.2
 *
 *  Copyright (c) 2013 Bartosz Wojciechowski
 *  http://www.owlgraphic.com/owlcarousel/
 *
 *  Licensed under MIT
 *
 */
//"function"!=typeof Object.create&&(Object.create=function(t){function e(){}return e.prototype=t,new e}),function(t,e,n){var i={init:function(e,n){var i=this;i.$elem=t(n),i.options=t.extend({},t.fn.owlCarousel.options,i.$elem.data(),e),i.userOptions=e,i.loadContent()},loadContent:function(){var e,n=this;"function"==typeof n.options.beforeInit&&n.options.beforeInit.apply(this,[n.$elem]),"string"==typeof n.options.jsonPath?(e=n.options.jsonPath,t.getJSON(e,(function(t){var e,i="";if("function"==typeof n.options.jsonSuccess)n.options.jsonSuccess.apply(this,[t]);else{for(e in t.owl)t.owl.hasOwnProperty(e)&&(i+=t.owl[e].item);n.$elem.html(i)}n.logIn()}))):n.logIn()},logIn:function(){var t=this;t.$elem.data("owl-originalStyles",t.$elem.attr("style")).data("owl-originalClasses",t.$elem.attr("class")),t.$elem.css({opacity:0}),t.orignalItems=t.options.items,t.checkBrowser(),t.wrapperWidth=0,t.checkVisible=null,t.setVars()},setVars:function(){var t=this;if(0===t.$elem.children().length)return!1;t.baseClass(),t.eventTypes(),t.$userItems=t.$elem.children(),t.itemsAmount=t.$userItems.length,t.wrapItems(),t.$owlItems=t.$elem.find(".owl-item"),t.$owlWrapper=t.$elem.find(".owl-wrapper"),t.playDirection="next",t.prevItem=0,t.prevArr=[0],t.currentItem=0,t.customEvents(),t.onStartup()},onStartup:function(){var t=this;t.updateItems(),t.calculateAll(),t.buildControls(),t.updateControls(),t.response(),t.moveEvents(),t.stopOnHover(),t.owlStatus(),!1!==t.options.transitionStyle&&t.transitionTypes(t.options.transitionStyle),!0===t.options.autoPlay&&(t.options.autoPlay=5e3),t.play(),t.$elem.find(".owl-wrapper").css("display","block"),t.$elem.is(":visible")?t.$elem.css("opacity",1):t.watchVisibility(),t.onstartup=!1,t.eachMoveUpdate(),"function"==typeof t.options.afterInit&&t.options.afterInit.apply(this,[t.$elem])},eachMoveUpdate:function(){var t=this;!0===t.options.lazyLoad&&t.lazyLoad(),!0===t.options.autoHeight&&t.autoHeight(),t.onVisibleItems(),"function"==typeof t.options.afterAction&&t.options.afterAction.apply(this,[t.$elem])},updateVars:function(){var t=this;"function"==typeof t.options.beforeUpdate&&t.options.beforeUpdate.apply(this,[t.$elem]),t.watchVisibility(),t.updateItems(),t.calculateAll(),t.updatePosition(),t.updateControls(),t.eachMoveUpdate(),"function"==typeof t.options.afterUpdate&&t.options.afterUpdate.apply(this,[t.$elem])},reload:function(){var t=this;e.setTimeout((function(){t.updateVars()}),0)},watchVisibility:function(){var t=this;if(!1!==t.$elem.is(":visible"))return!1;t.$elem.css({opacity:0}),e.clearInterval(t.autoPlayInterval),e.clearInterval(t.checkVisible),t.checkVisible=e.setInterval((function(){t.$elem.is(":visible")&&(t.reload(),t.$elem.animate({opacity:1},200),e.clearInterval(t.checkVisible))}),500)},wrapItems:function(){var t=this;t.$userItems.wrapAll('<div class="owl-wrapper">').wrap('<div class="owl-item"></div>'),t.$elem.find(".owl-wrapper").wrap('<div class="owl-wrapper-outer">'),t.wrapperOuter=t.$elem.find(".owl-wrapper-outer"),t.$elem.css("display","block")},baseClass:function(){var t=this,e=t.$elem.hasClass(t.options.baseClass),n=t.$elem.hasClass(t.options.theme);e||t.$elem.addClass(t.options.baseClass),n||t.$elem.addClass(t.options.theme)},updateItems:function(){var e,n,i=this;if(!1===i.options.responsive)return!1;if(!0===i.options.singleItem)return i.options.items=i.orignalItems=1,i.options.itemsCustom=!1,i.options.itemsDesktop=!1,i.options.itemsDesktopSmall=!1,i.options.itemsTablet=!1,i.options.itemsTabletSmall=!1,i.options.itemsMobile=!1,!1;if((e=t(i.options.responsiveBaseWidth).width())>(i.options.itemsDesktop[0]||i.orignalItems)&&(i.options.items=i.orignalItems),!1!==i.options.itemsCustom)for(i.options.itemsCustom.sort((function(t,e){return t[0]-e[0]})),n=0;n<i.options.itemsCustom.length;n+=1)i.options.itemsCustom[n][0]<=e&&(i.options.items=i.options.itemsCustom[n][1]);else e<=i.options.itemsDesktop[0]&&!1!==i.options.itemsDesktop&&(i.options.items=i.options.itemsDesktop[1]),e<=i.options.itemsDesktopSmall[0]&&!1!==i.options.itemsDesktopSmall&&(i.options.items=i.options.itemsDesktopSmall[1]),e<=i.options.itemsTablet[0]&&!1!==i.options.itemsTablet&&(i.options.items=i.options.itemsTablet[1]),e<=i.options.itemsTabletSmall[0]&&!1!==i.options.itemsTabletSmall&&(i.options.items=i.options.itemsTabletSmall[1]),e<=i.options.itemsMobile[0]&&!1!==i.options.itemsMobile&&(i.options.items=i.options.itemsMobile[1]);i.options.items>i.itemsAmount&&!0===i.options.itemsScaleUp&&(i.options.items=i.itemsAmount)},response:function(){var n,i,o=this;if(!0!==o.options.responsive)return!1;i=t(e).width(),o.resizer=function(){t(e).width()!==i&&(!1!==o.options.autoPlay&&e.clearInterval(o.autoPlayInterval),e.clearTimeout(n),n=e.setTimeout((function(){i=t(e).width(),o.updateVars()}),o.options.responsiveRefreshRate))},t(e).resize(o.resizer)},updatePosition:function(){var t=this;t.jumpTo(t.currentItem),!1!==t.options.autoPlay&&t.checkAp()},appendItemsSizes:function(){var e=this,n=0,i=e.itemsAmount-e.options.items;e.$owlItems.each((function(o){var r=t(this);r.css({width:e.itemWidth}).data("owl-item",Number(o)),o%e.options.items!=0&&o!==i||o>i||(n+=1),r.data("owl-roundPages",n)}))},appendWrapperSizes:function(){var t=this,e=t.$owlItems.length*t.itemWidth;t.$owlWrapper.css({width:2*e,left:0}),t.appendItemsSizes()},calculateAll:function(){var t=this;t.calculateWidth(),t.appendWrapperSizes(),t.loops(),t.max()},calculateWidth:function(){var t=this;t.itemWidth=Math.round(t.$elem.width()/t.options.items)},max:function(){var t=this,e=-1*(t.itemsAmount*t.itemWidth-t.options.items*t.itemWidth);return t.options.items>t.itemsAmount?(t.maximumItem=0,e=0,t.maximumPixels=0):(t.maximumItem=t.itemsAmount-t.options.items,t.maximumPixels=e),e},min:function(){return 0},loops:function(){var e,n,i=this,o=0,r=0;for(i.positionsInArray=[0],i.pagesInArray=[],e=0;e<i.itemsAmount;e+=1)r+=i.itemWidth,i.positionsInArray.push(-r),!0===i.options.scrollPerPage&&((n=t(i.$owlItems[e]).data("owl-roundPages"))!==o&&(i.pagesInArray[o]=i.positionsInArray[e],o=n))},buildControls:function(){var e=this;!0!==e.options.navigation&&!0!==e.options.pagination||(e.owlControls=t('<div class="owl-controls"/>').toggleClass("clickable",!e.browser.isTouch).appendTo(e.$elem)),!0===e.options.pagination&&e.buildPagination(),!0===e.options.navigation&&e.buildButtons()},buildButtons:function(){var e=this,n=t('<div class="owl-buttons"/>');e.owlControls.append(n),e.buttonPrev=t("<div/>",{class:"owl-prev",html:e.options.navigationText[0]||""}),e.buttonNext=t("<div/>",{class:"owl-next",html:e.options.navigationText[1]||""}),n.append(e.buttonPrev).append(e.buttonNext),n.on("touchstart.owlControls mousedown.owlControls",'div[class^="owl"]',(function(t){t.preventDefault()})),n.on("touchend.owlControls mouseup.owlControls",'div[class^="owl"]',(function(n){n.preventDefault(),t(this).hasClass("owl-next")?e.next():e.prev()}))},buildPagination:function(){var e=this;e.paginationWrapper=t('<div class="owl-pagination"/>'),e.owlControls.append(e.paginationWrapper),e.paginationWrapper.on("touchend.owlControls mouseup.owlControls",".owl-page",(function(n){n.preventDefault(),Number(t(this).data("owl-page"))!==e.currentItem&&e.goTo(Number(t(this).data("owl-page")),!0)}))},updatePagination:function(){var e,n,i,o,r,s,a=this;if(!1===a.options.pagination)return!1;for(a.paginationWrapper.html(""),e=0,n=a.itemsAmount-a.itemsAmount%a.options.items,o=0;o<a.itemsAmount;o+=1)o%a.options.items==0&&(e+=1,n===o&&(i=a.itemsAmount-a.options.items),r=t("<div/>",{class:"owl-page"}),s=t("<span></span>",{text:!0===a.options.paginationNumbers?e:"",class:!0===a.options.paginationNumbers?"owl-numbers":""}),r.append(s),r.data("owl-page",n===o?i:o),r.data("owl-roundPages",e),a.paginationWrapper.append(r));a.checkPagination()},checkPagination:function(){var e=this;if(!1===e.options.pagination)return!1;e.paginationWrapper.find(".owl-page").each((function(){t(this).data("owl-roundPages")===t(e.$owlItems[e.currentItem]).data("owl-roundPages")&&(e.paginationWrapper.find(".owl-page").removeClass("active"),t(this).addClass("active"))}))},checkNavigation:function(){var t=this;if(!1===t.options.navigation)return!1;!1===t.options.rewindNav&&(0===t.currentItem&&0===t.maximumItem?(t.buttonPrev.addClass("disabled"),t.buttonNext.addClass("disabled")):0===t.currentItem&&0!==t.maximumItem?(t.buttonPrev.addClass("disabled"),t.buttonNext.removeClass("disabled")):t.currentItem===t.maximumItem?(t.buttonPrev.removeClass("disabled"),t.buttonNext.addClass("disabled")):0!==t.currentItem&&t.currentItem!==t.maximumItem&&(t.buttonPrev.removeClass("disabled"),t.buttonNext.removeClass("disabled")))},updateControls:function(){var t=this;t.updatePagination(),t.checkNavigation(),t.owlControls&&(t.options.items>=t.itemsAmount?t.owlControls.hide():t.owlControls.show())},destroyControls:function(){this.owlControls&&this.owlControls.remove()},next:function(t){var e=this;if(e.isTransition)return!1;if(e.currentItem+=!0===e.options.scrollPerPage?e.options.items:1,e.currentItem>e.maximumItem+(!0===e.options.scrollPerPage?e.options.items-1:0)){if(!0!==e.options.rewindNav)return e.currentItem=e.maximumItem,!1;e.currentItem=0,t="rewind"}e.goTo(e.currentItem,t)},prev:function(t){var e=this;if(e.isTransition)return!1;if(!0===e.options.scrollPerPage&&e.currentItem>0&&e.currentItem<e.options.items?e.currentItem=0:e.currentItem-=!0===e.options.scrollPerPage?e.options.items:1,e.currentItem<0){if(!0!==e.options.rewindNav)return e.currentItem=0,!1;e.currentItem=e.maximumItem,t="rewind"}e.goTo(e.currentItem,t)},goTo:function(t,n,i){var o,r=this;return!r.isTransition&&("function"==typeof r.options.beforeMove&&r.options.beforeMove.apply(this,[r.$elem]),t>=r.maximumItem?t=r.maximumItem:t<=0&&(t=0),r.currentItem=r.owl.currentItem=t,!1!==r.options.transitionStyle&&"drag"!==i&&1===r.options.items&&!0===r.browser.support3d?(r.swapSpeed(0),!0===r.browser.support3d?r.transition3d(r.positionsInArray[t]):r.css2slide(r.positionsInArray[t],1),r.afterGo(),r.singleItemTransition(),!1):(o=r.positionsInArray[t],!0===r.browser.support3d?(r.isCss3Finish=!1,!0===n?(r.swapSpeed("paginationSpeed"),e.setTimeout((function(){r.isCss3Finish=!0}),r.options.paginationSpeed)):"rewind"===n?(r.swapSpeed(r.options.rewindSpeed),e.setTimeout((function(){r.isCss3Finish=!0}),r.options.rewindSpeed)):(r.swapSpeed("slideSpeed"),e.setTimeout((function(){r.isCss3Finish=!0}),r.options.slideSpeed)),r.transition3d(o)):!0===n?r.css2slide(o,r.options.paginationSpeed):"rewind"===n?r.css2slide(o,r.options.rewindSpeed):r.css2slide(o,r.options.slideSpeed),void r.afterGo()))},jumpTo:function(t){var e=this;"function"==typeof e.options.beforeMove&&e.options.beforeMove.apply(this,[e.$elem]),t>=e.maximumItem||-1===t?t=e.maximumItem:t<=0&&(t=0),e.swapSpeed(0),!0===e.browser.support3d?e.transition3d(e.positionsInArray[t]):e.css2slide(e.positionsInArray[t],1),e.currentItem=e.owl.currentItem=t,e.afterGo()},afterGo:function(){var t=this;t.prevArr.push(t.currentItem),t.prevItem=t.owl.prevItem=t.prevArr[t.prevArr.length-2],t.prevArr.shift(0),t.prevItem!==t.currentItem&&(t.checkPagination(),t.checkNavigation(),t.eachMoveUpdate(),!1!==t.options.autoPlay&&t.checkAp()),"function"==typeof t.options.afterMove&&t.prevItem!==t.currentItem&&t.options.afterMove.apply(this,[t.$elem])},stop:function(){this.apStatus="stop",e.clearInterval(this.autoPlayInterval)},checkAp:function(){"stop"!==this.apStatus&&this.play()},play:function(){var t=this;if(t.apStatus="play",!1===t.options.autoPlay)return!1;e.clearInterval(t.autoPlayInterval),t.autoPlayInterval=e.setInterval((function(){t.next(!0)}),t.options.autoPlay)},swapSpeed:function(t){var e=this;"slideSpeed"===t?e.$owlWrapper.css(e.addCssSpeed(e.options.slideSpeed)):"paginationSpeed"===t?e.$owlWrapper.css(e.addCssSpeed(e.options.paginationSpeed)):"string"!=typeof t&&e.$owlWrapper.css(e.addCssSpeed(t))},addCssSpeed:function(t){return{"-webkit-transition":"all "+t+"ms ease","-moz-transition":"all "+t+"ms ease","-o-transition":"all "+t+"ms ease",transition:"all "+t+"ms ease"}},removeTransition:function(){return{"-webkit-transition":"","-moz-transition":"","-o-transition":"",transition:""}},doTranslate:function(t){return{"-webkit-transform":"translate3d("+t+"px, 0px, 0px)","-moz-transform":"translate3d("+t+"px, 0px, 0px)","-o-transform":"translate3d("+t+"px, 0px, 0px)","-ms-transform":"translate3d("+t+"px, 0px, 0px)",transform:"translate3d("+t+"px, 0px,0px)"}},transition3d:function(t){this.$owlWrapper.css(this.doTranslate(t))},css2move:function(t){this.$owlWrapper.css({left:t})},css2slide:function(t,e){var n=this;n.isCssFinish=!1,n.$owlWrapper.stop(!0,!0).animate({left:t},{duration:e||n.options.slideSpeed,complete:function(){n.isCssFinish=!0}})},checkBrowser:function(){var t,i,o,r,s="translate3d(0px, 0px, 0px)",a=n.createElement("div");a.style.cssText="  -moz-transform:"+s+"; -ms-transform:"+s+"; -o-transform:"+s+"; -webkit-transform:"+s+"; transform:"+s,t=/translate3d\(0px, 0px, 0px\)/g,o=null!==(i=a.style.cssText.match(t))&&1===i.length,r="ontouchstart"in e||e.navigator.msMaxTouchPoints,this.browser={support3d:o,isTouch:r}},moveEvents:function(){var t=this;!1===t.options.mouseDrag&&!1===t.options.touchDrag||(t.gestures(),t.disabledEvents())},eventTypes:function(){var t=this,e=["s","e","x"];t.ev_types={},!0===t.options.mouseDrag&&!0===t.options.touchDrag?e=["touchstart.owl mousedown.owl","touchmove.owl mousemove.owl","touchend.owl touchcancel.owl mouseup.owl"]:!1===t.options.mouseDrag&&!0===t.options.touchDrag?e=["touchstart.owl","touchmove.owl","touchend.owl touchcancel.owl"]:!0===t.options.mouseDrag&&!1===t.options.touchDrag&&(e=["mousedown.owl","mousemove.owl","mouseup.owl"]),t.ev_types.start=e[0],t.ev_types.move=e[1],t.ev_types.end=e[2]},disabledEvents:function(){this.$elem.on("dragstart.owl",(function(t){t.preventDefault()})),this.$elem.on("mousedown.disableTextSelect",(function(e){return t(e.target).is("input, textarea, select, option")}))},gestures:function(){function i(t){if(void 0!==t.touches)return{x:t.touches[0].pageX,y:t.touches[0].pageY};if(void 0===t.touches){if(void 0!==t.pageX)return{x:t.pageX,y:t.pageY};if(void 0===t.pageX)return{x:t.clientX,y:t.clientY}}}function o(e){"on"===e?(t(n).on(a.ev_types.move,r),t(n).on(a.ev_types.end,s)):"off"===e&&(t(n).off(a.ev_types.move),t(n).off(a.ev_types.end))}function r(o){var r,s,u=o.originalEvent||o||e.event;a.newPosX=i(u).x-l.offsetX,a.newPosY=i(u).y-l.offsetY,a.newRelativeX=a.newPosX-l.relativePos,"function"==typeof a.options.startDragging&&!0!==l.dragging&&0!==a.newRelativeX&&(l.dragging=!0,a.options.startDragging.apply(a,[a.$elem])),(a.newRelativeX>8||a.newRelativeX<-8)&&!0===a.browser.isTouch&&(void 0!==u.preventDefault?u.preventDefault():u.returnValue=!1,l.sliding=!0),(a.newPosY>10||a.newPosY<-10)&&!1===l.sliding&&t(n).off("touchmove.owl"),r=function(){return a.newRelativeX/5},s=function(){return a.maximumPixels+a.newRelativeX/5},a.newPosX=Math.max(Math.min(a.newPosX,r()),s()),!0===a.browser.support3d?a.transition3d(a.newPosX):a.css2move(a.newPosX)}function s(n){var i,r,s,u=n.originalEvent||n||e.event;u.target=u.target||u.srcElement,l.dragging=!1,!0!==a.browser.isTouch&&a.$owlWrapper.removeClass("grabbing"),a.newRelativeX<0?a.dragDirection=a.owl.dragDirection="left":a.dragDirection=a.owl.dragDirection="right",0!==a.newRelativeX&&(i=a.getNewPosition(),a.goTo(i,!1,"drag"),l.targetElement===u.target&&!0!==a.browser.isTouch&&(t(u.target).on("click.disable",(function(e){e.stopImmediatePropagation(),e.stopPropagation(),e.preventDefault(),t(e.target).off("click.disable")})),s=(r=t._data(u.target,"events").click).pop(),r.splice(0,0,s))),o("off")}var a=this,l={offsetX:0,offsetY:0,baseElWidth:0,relativePos:0,position:null,minSwipe:null,maxSwipe:null,sliding:null,dargging:null,targetElement:null};a.isCssFinish=!0,a.$elem.on(a.ev_types.start,".owl-wrapper",(function(n){var r,s=n.originalEvent||n||e.event;if(3===s.which)return!1;if(!(a.itemsAmount<=a.options.items)){if(!1===a.isCssFinish&&!a.options.dragBeforeAnimFinish)return!1;if(!1===a.isCss3Finish&&!a.options.dragBeforeAnimFinish)return!1;!1!==a.options.autoPlay&&e.clearInterval(a.autoPlayInterval),!0===a.browser.isTouch||a.$owlWrapper.hasClass("grabbing")||a.$owlWrapper.addClass("grabbing"),a.newPosX=0,a.newRelativeX=0,t(this).css(a.removeTransition()),r=t(this).position(),l.relativePos=r.left,l.offsetX=i(s).x-r.left,l.offsetY=i(s).y-r.top,o("on"),l.sliding=!1,l.targetElement=s.target||s.srcElement}}))},getNewPosition:function(){var t=this,e=t.closestItem();return e>t.maximumItem?(t.currentItem=t.maximumItem,e=t.maximumItem):t.newPosX>=0&&(e=0,t.currentItem=0),e},closestItem:function(){var e=this,n=!0===e.options.scrollPerPage?e.pagesInArray:e.positionsInArray,i=e.newPosX,o=null;return t.each(n,(function(r,s){i-e.itemWidth/20>n[r+1]&&i-e.itemWidth/20<s&&"left"===e.moveDirection()?(o=s,!0===e.options.scrollPerPage?e.currentItem=t.inArray(o,e.positionsInArray):e.currentItem=r):i+e.itemWidth/20<s&&i+e.itemWidth/20>(n[r+1]||n[r]-e.itemWidth)&&"right"===e.moveDirection()&&(!0===e.options.scrollPerPage?(o=n[r+1]||n[n.length-1],e.currentItem=t.inArray(o,e.positionsInArray)):(o=n[r+1],e.currentItem=r+1))})),e.currentItem},moveDirection:function(){var t,e=this;return e.newRelativeX<0?(t="right",e.playDirection="next"):(t="left",e.playDirection="prev"),t},customEvents:function(){var t=this;t.$elem.on("owl.next",(function(){t.next()})),t.$elem.on("owl.prev",(function(){t.prev()})),t.$elem.on("owl.play",(function(e,n){t.options.autoPlay=n,t.play(),t.hoverStatus="play"})),t.$elem.on("owl.stop",(function(){t.stop(),t.hoverStatus="stop"})),t.$elem.on("owl.goTo",(function(e,n){t.goTo(n)})),t.$elem.on("owl.jumpTo",(function(e,n){t.jumpTo(n)}))},stopOnHover:function(){var t=this;!0===t.options.stopOnHover&&!0!==t.browser.isTouch&&!1!==t.options.autoPlay&&(t.$elem.on("mouseover",(function(){t.stop()})),t.$elem.on("mouseout",(function(){"stop"!==t.hoverStatus&&t.play()})))},lazyLoad:function(){var e,n,i,o,r=this;if(!1===r.options.lazyLoad)return!1;for(e=0;e<r.itemsAmount;e+=1)"loaded"!==(n=t(r.$owlItems[e])).data("owl-loaded")&&(i=n.data("owl-item"),"string"==typeof(o=n.find(".lazyOwl")).data("src")?(void 0===n.data("owl-loaded")&&(o.hide(),n.addClass("loading").data("owl-loaded","checked")),(!0!==r.options.lazyFollow||i>=r.currentItem)&&i<r.currentItem+r.options.items&&o.length&&r.lazyPreload(n,o)):n.data("owl-loaded","loaded"))},lazyPreload:function(t,n){function i(){t.data("owl-loaded","loaded").removeClass("loading"),n.removeAttr("data-src"),"fade"===r.options.lazyEffect?n.fadeIn(400):n.show(),"function"==typeof r.options.afterLazyLoad&&r.options.afterLazyLoad.apply(this,[r.$elem])}var o,r=this,s=0;"DIV"===n.prop("tagName")?(n.css("background-image","url("+n.data("src")+")"),o=!0):n[0].src=n.data("src"),function t(){s+=1,r.completeImg(n.get(0))||!0===o?i():s<=100?e.setTimeout(t,100):i()}()},autoHeight:function(){function n(){var n=t(o.$owlItems[o.currentItem]).height();o.wrapperOuter.css("height",n+"px"),o.wrapperOuter.hasClass("autoHeight")||e.setTimeout((function(){o.wrapperOuter.addClass("autoHeight")}),0)}var i,o=this,r=t(o.$owlItems[o.currentItem]).find("img");void 0!==r.get(0)?(i=0,function t(){i+=1,o.completeImg(r.get(0))?n():i<=100?e.setTimeout(t,100):o.wrapperOuter.css("height","")}()):n()},completeImg:function(t){return!!t.complete&&(void 0===t.naturalWidth||0!==t.naturalWidth)},onVisibleItems:function(){var e,n=this;for(!0===n.options.addClassActive&&n.$owlItems.removeClass("active"),n.visibleItems=[],e=n.currentItem;e<n.currentItem+n.options.items;e+=1)n.visibleItems.push(e),!0===n.options.addClassActive&&t(n.$owlItems[e]).addClass("active");n.owl.visibleItems=n.visibleItems},transitionTypes:function(t){this.outClass="owl-"+t+"-out",this.inClass="owl-"+t+"-in"},singleItemTransition:function(){var t=this,e=t.outClass,n=t.inClass,i=t.$owlItems.eq(t.currentItem),o=t.$owlItems.eq(t.prevItem),r=Math.abs(t.positionsInArray[t.currentItem])+t.positionsInArray[t.prevItem],s=Math.abs(t.positionsInArray[t.currentItem])+t.itemWidth/2,a="webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend";t.isTransition=!0,t.$owlWrapper.addClass("owl-origin").css({"-webkit-transform-origin":s+"px","-moz-perspective-origin":s+"px","perspective-origin":s+"px"}),o.css(function(t){return{position:"relative",left:t+"px"}}(r)).addClass(e).on(a,(function(){t.endPrev=!0,o.off(a),t.clearTransStyle(o,e)})),i.addClass(n).on(a,(function(){t.endCurrent=!0,i.off(a),t.clearTransStyle(i,n)}))},clearTransStyle:function(t,e){var n=this;t.css({position:"",left:""}).removeClass(e),n.endPrev&&n.endCurrent&&(n.$owlWrapper.removeClass("owl-origin"),n.endPrev=!1,n.endCurrent=!1,n.isTransition=!1)},owlStatus:function(){var t=this;t.owl={userOptions:t.userOptions,baseElement:t.$elem,userItems:t.$userItems,owlItems:t.$owlItems,currentItem:t.currentItem,prevItem:t.prevItem,visibleItems:t.visibleItems,isTouch:t.browser.isTouch,browser:t.browser,dragDirection:t.dragDirection}},clearEvents:function(){this.$elem.off(".owl owl mousedown.disableTextSelect"),t(n).off(".owl owl"),t(e).off("resize",this.resizer)},unWrap:function(){var t=this;0!==t.$elem.children().length&&(t.$owlWrapper.unwrap(),t.$userItems.unwrap().unwrap(),t.owlControls&&t.owlControls.remove()),t.clearEvents(),t.$elem.attr("style",t.$elem.data("owl-originalStyles")||"").attr("class",t.$elem.data("owl-originalClasses"))},destroy:function(){var t=this;t.stop(),e.clearInterval(t.checkVisible),t.unWrap(),t.$elem.removeData()},reinit:function(e){var n=this,i=t.extend({},n.userOptions,e);n.unWrap(),n.init(i,n.$elem)},addItem:function(t,e){var n,i=this;return!!t&&(0===i.$elem.children().length?(i.$elem.append(t),i.setVars(),!1):(i.unWrap(),(n=void 0===e||-1===e?-1:e)>=i.$userItems.length||-1===n?i.$userItems.eq(-1).after(t):i.$userItems.eq(n).before(t),void i.setVars()))},removeItem:function(t){var e,n=this;if(0===n.$elem.children().length)return!1;e=void 0===t||-1===t?-1:t,n.unWrap(),n.$userItems.eq(e).remove(),n.setVars()}};t.fn.owlCarousel=function(e){return this.each((function(){if(!0===t(this).data("owl-init"))return!1;t(this).data("owl-init",!0);var n=Object.create(i);n.init(e,this),t.data(this,"owlCarousel",n)}))},t.fn.owlCarousel.options={items:5,itemsCustom:!1,itemsDesktop:[1199,4],itemsDesktopSmall:[979,3],itemsTablet:[768,2],itemsTabletSmall:!1,itemsMobile:[479,1],singleItem:!1,itemsScaleUp:!1,slideSpeed:200,paginationSpeed:800,rewindSpeed:1e3,autoPlay:!1,stopOnHover:!1,navigation:!1,navigationText:["prev","next"],rewindNav:!0,scrollPerPage:!1,pagination:!0,paginationNumbers:!1,responsive:!0,responsiveRefreshRate:200,responsiveBaseWidth:e,baseClass:"owl-carousel",theme:"owl-theme",lazyLoad:!1,lazyFollow:!0,lazyEffect:"fade",autoHeight:!1,jsonPath:!1,jsonSuccess:!1,dragBeforeAnimFinish:!0,mouseDrag:!0,touchDrag:!0,addClassActive:!1,transitionStyle:!1,beforeUpdate:!1,afterUpdate:!1,beforeInit:!1,afterInit:!1,beforeMove:!1,afterMove:!1,afterAction:!1,startDragging:!1,afterLazyLoad:!1}}(jQuery,window,document),
/*!
 * Spin.js
 * Copyright (c) 2011-2014 Felix Gnass
 * Licensed under the MIT license
 */
//function(t,e){"object"==typeof exports?module.exports=e():"function"==typeof define&&define.amd?define(e):t.Spinner=e()}(this,(function(){function t(t,e){var n,i=document.createElement(t||"div");for(n in e)i[n]=e[n];return i}function e(t){for(var e=1,n=arguments.length;e<n;e++)t.appendChild(arguments[e]);return t}function n(t,e,n,i){var o=["opacity",e,~~(100*t),n,i].join("-"),r=.01+n/i*100,s=Math.max(1-(1-t)/e*(100-r),t),a=l.substring(0,l.indexOf("Animation")).toLowerCase(),u=a&&"-"+a+"-"||"";return c[o]||(d.insertRule("@"+u+"keyframes "+o+"{0%{opacity:"+s+"}"+r+"%{opacity:"+t+"}"+(r+.01)+"%{opacity:1}"+(r+e)%100+"%{opacity:"+t+"}100%{opacity:"+s+"}}",d.cssRules.length),c[o]=1),o}function i(t,e){var n,i,o=t.style;for(e=e.charAt(0).toUpperCase()+e.slice(1),i=0;i<u.length;i++)if(void 0!==o[n=u[i]+e])return n;if(void 0!==o[e])return e}function o(t,e){for(var n in e)t.style[i(t,n)||n]=e[n];return t}function r(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var i in n)void 0===t[i]&&(t[i]=n[i])}return t}function s(t,e){return"string"==typeof t?t:t[e%t.length]}function a(t){this.opts=r(t||{},a.defaults,p)}var l,u=["webkit","Moz","ms","O"],c={},d=function(){var n=t("style",{type:"text/css"});return e(document.getElementsByTagName("head")[0],n),n.sheet||n.styleSheet}(),p={lines:12,length:7,width:5,radius:10,rotate:0,corners:1,color:"#000",direction:1,speed:1,trail:100,opacity:.25,fps:20,zIndex:2e9,className:"spinner",top:"50%",left:"50%",position:"absolute"};a.defaults={},r(a.prototype,{spin:function(e){this.stop();var n=this,i=n.opts,r=n.el=o(t(0,{className:i.className}),{position:i.position,width:0,zIndex:i.zIndex});if(i.radius,i.length,i.width,o(r,{left:i.left,top:i.top}),e&&e.insertBefore(r,e.firstChild||null),r.setAttribute("role","progressbar"),n.lines(r,n.opts),!l){var s,a=0,u=(i.lines-1)*(1-i.direction)/2,c=i.fps,d=c/i.speed,p=(1-i.opacity)/(d*i.trail/100),h=d/i.lines;!function t(){a++;for(var e=0;e<i.lines;e++)s=Math.max(1-(a+(i.lines-e)*h)%d*p,i.opacity),n.opacity(r,e*i.direction+u,s,i);n.timeout=n.el&&setTimeout(t,~~(1e3/c))}()}return n},stop:function(){var t=this.el;return t&&(clearTimeout(this.timeout),t.parentNode&&t.parentNode.removeChild(t),this.el=void 0),this},lines:function(i,r){function a(e,n){return o(t(),{position:"absolute",width:r.length+r.width+"px",height:r.width+"px",background:e,boxShadow:n,transformOrigin:"left",transform:"rotate("+~~(360/r.lines*c+r.rotate)+"deg) translate("+r.radius+"px,0)",borderRadius:(r.corners*r.width>>1)+"px"})}for(var u,c=0,d=(r.lines-1)*(1-r.direction)/2;c<r.lines;c++)u=o(t(),{position:"absolute",top:1+~(r.width/2)+"px",transform:r.hwaccel?"translate3d(0,0,0)":"",opacity:r.opacity,animation:l&&n(r.opacity,r.trail,d+c*r.direction,r.lines)+" "+1/r.speed+"s linear infinite"}),r.shadow&&e(u,o(a("#000","0 0 4px #000"),{top:"2px"})),e(i,e(u,a(s(r.color,c),"0 0 1px rgba(0,0,0,.1)")));return i},opacity:function(t,e,n){e<t.childNodes.length&&(t.childNodes[e].style.opacity=n)}});var h=o(t("group"),{behavior:"url(#default#VML)"});return!i(h,"transform")&&h.adj?function(){function n(e,n){return t("<"+e+' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">',n)}d.addRule(".spin-vml","behavior:url(#default#VML)"),a.prototype.lines=function(t,i){function r(){return o(n("group",{coordsize:c+" "+c,coordorigin:-u+" "+-u}),{width:c,height:c})}function a(t,a,l){e(p,e(o(r(),{rotation:360/i.lines*t+"deg",left:~~a}),e(o(n("roundrect",{arcsize:i.corners}),{width:u,height:i.width,left:i.radius,top:-i.width>>1,filter:l}),n("fill",{color:s(i.color,t),opacity:i.opacity}),n("stroke",{opacity:0}))))}var l,u=i.length+i.width,c=2*u,d=2*-(i.width+i.length)+"px",p=o(r(),{position:"absolute",top:d,left:d});if(i.shadow)for(l=1;l<=i.lines;l++)a(l,-2,"progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)");for(l=1;l<=i.lines;l++)a(l);return e(t,p)},a.prototype.opacity=function(t,e,n,i){var o=t.firstChild;i=i.shadow&&i.lines||0,o&&e+i<o.childNodes.length&&((o=(o=(o=o.childNodes[e+i])&&o.firstChild)&&o.firstChild)&&(o.opacity=n))}}():l=i(h,"animation"),a})),function(t){if("object"==typeof exports)t(require("jquery"),require("spin"));else if("function"==typeof define&&define.amd)define(["jquery","spin"],t);else{if(!window.Spinner)throw new Error("Spin.js not present");t(window.jQuery,window.Spinner)}}((function(t,e){t.fn.spin=function(n,i){return this.each((function(){var o=t(this),r=o.data();r.spinner&&(r.spinner.stop(),delete r.spinner),!1!==n&&(n=t.extend({color:i||o.css("color")},t.fn.spin.presets[n]||n),r.spinner=new e(n).spin(this))}))},t.fn.spin.presets={tiny:{lines:8,length:2,width:2,radius:3},small:{lines:8,length:4,width:3,radius:5},large:{lines:10,length:8,width:4,radius:8}}})),function(t){function e(t){var e=t.length,i=n.type(t);return"function"!==i&&!n.isWindow(t)&&(!(1!==t.nodeType||!e)||"array"===i||0===e||"number"==typeof e&&e>0&&e-1 in t)}if(!t.jQuery){var n=function(t,e){return new n.fn.init(t,e)};n.isWindow=function(t){return null!=t&&t==t.window},n.type=function(t){return null==t?t+"":"object"==typeof t||"function"==typeof t?o[s.call(t)]||"object":typeof t},n.isArray=Array.isArray||function(t){return"array"===n.type(t)},n.isPlainObject=function(t){var e;if(!t||"object"!==n.type(t)||t.nodeType||n.isWindow(t))return!1;try{if(t.constructor&&!r.call(t,"constructor")&&!r.call(t.constructor.prototype,"isPrototypeOf"))return!1}catch(t){return!1}for(e in t);return void 0===e||r.call(t,e)},n.each=function(t,n,i){var o=0,r=t.length,s=e(t);if(i){if(s)for(;o<r&&!1!==n.apply(t[o],i);o++);else for(o in t)if(!1===n.apply(t[o],i))break}else if(s)for(;o<r&&!1!==n.call(t[o],o,t[o]);o++);else for(o in t)if(!1===n.call(t[o],o,t[o]))break;return t},n.data=function(t,e,o){if(void 0===o){var r=(s=t[n.expando])&&i[s];if(void 0===e)return r;if(r&&e in r)return r[e]}else if(void 0!==e){var s=t[n.expando]||(t[n.expando]=++n.uuid);return i[s]=i[s]||{},i[s][e]=o,o}},n.removeData=function(t,e){var o=t[n.expando],r=o&&i[o];r&&n.each(e,(function(t,e){delete r[e]}))},n.extend=function(){var t,e,i,o,r,s,a=arguments[0]||{},l=1,u=arguments.length,c=!1;for("boolean"==typeof a&&(c=a,a=arguments[l]||{},l++),"object"!=typeof a&&"function"!==n.type(a)&&(a={}),l===u&&(a=this,l--);l<u;l++)if(null!=(r=arguments[l]))for(o in r)t=a[o],a!==(i=r[o])&&(c&&i&&(n.isPlainObject(i)||(e=n.isArray(i)))?(e?(e=!1,s=t&&n.isArray(t)?t:[]):s=t&&n.isPlainObject(t)?t:{},a[o]=n.extend(c,s,i)):void 0!==i&&(a[o]=i));return a},n.queue=function(t,i,o){if(t){i=(i||"fx")+"queue";var r=n.data(t,i);return o?(!r||n.isArray(o)?r=n.data(t,i,function(t,n){var i=[];return null!=t&&(e(Object(t))?function(t,e){for(var n=+e.length,i=0,o=t.length;i<n;)t[o++]=e[i++];if(n!=n)for(;void 0!==e[i];)t[o++]=e[i++];t.length=o}(i,"string"==typeof t?[t]:t):[].push.call(i,t)),i}(o)):r.push(o),r):r||[]}},n.dequeue=function(t,e){n.each(t.nodeType?[t]:t,(function(t,i){e=e||"fx";var o=n.queue(i,e),r=o.shift();"inprogress"===r&&(r=o.shift()),r&&("fx"===e&&o.unshift("inprogress"),r.call(i,(function(){n.dequeue(i,e)})))}))},n.fn=n.prototype={init:function(t){if(t.nodeType)return this[0]=t,this;throw new Error("Not a DOM node.")},offset:function(){var e=this[0].getBoundingClientRect?this[0].getBoundingClientRect():{top:0,left:0};return{top:e.top+(t.pageYOffset||document.scrollTop||0)-(document.clientTop||0),left:e.left+(t.pageXOffset||document.scrollLeft||0)-(document.clientLeft||0)}},position:function(){function t(){for(var t=this.offsetParent||document;t&&"html"===!t.nodeType.toLowerCase&&"static"===t.style.position;)t=t.offsetParent;return t||document}var e=this[0],t=t.apply(e),i=this.offset(),o=/^(?:body|html)$/i.test(t.nodeName)?{top:0,left:0}:n(t).offset();return i.top-=parseFloat(e.style.marginTop)||0,i.left-=parseFloat(e.style.marginLeft)||0,t.style&&(o.top+=parseFloat(t.style.borderTopWidth)||0,o.left+=parseFloat(t.style.borderLeftWidth)||0),{top:i.top-o.top,left:i.left-o.left}}};var i={};n.expando="velocity"+(new Date).getTime(),n.uuid=0;for(var o={},r=o.hasOwnProperty,s=o.toString,a="Boolean Number String Function Array Date RegExp Object Error".split(" "),l=0;l<a.length;l++)o["[object "+a[l]+"]"]=a[l].toLowerCase();n.fn.init.prototype=n.fn,t.Velocity={Utilities:n}}}(window),function(t){"object"==typeof module&&"object"==typeof module.exports?module.exports=t():"function"==typeof define&&define.amd?define(t):t()}((function(){return function(t,e,n,i){function o(t){return f.isWrapped(t)?t=[].slice.call(t):f.isNode(t)&&(t=[t]),t}function r(t){var e=d.data(t,"velocity");return null===e?i:e}function s(t){return function(e){return Math.round(e*t)*(1/t)}}function a(t,n,i,o){function r(t,e){return 1-3*e+3*t}function s(t,e){return 3*e-6*t}function a(t){return 3*t}function l(t,e,n){return((r(e,n)*t+s(e,n))*t+a(e))*t}function u(t,e,n){return 3*r(e,n)*t*t+2*s(e,n)*t+a(e)}function c(e,n){for(var o=0;o<h;++o){var r=u(n,t,i);if(0===r)return n;n-=(l(n,t,i)-e)/r}return n}function d(e,n,o){var r,s,a=0;do{(r=l(s=n+(o-n)/2,t,i)-e)>0?o=s:n=s}while(Math.abs(r)>m&&++a<g);return s}function p(){_=!0,t==n&&i==o||function(){for(var e=0;e<v;++e)x[e]=l(e*y,t,i)}()}var h=4,f=.001,m=1e-7,g=10,v=11,y=1/(v-1),w="Float32Array"in e;if(4!==arguments.length)return!1;for(var b=0;b<4;++b)if("number"!=typeof arguments[b]||isNaN(arguments[b])||!isFinite(arguments[b]))return!1;t=Math.min(t,1),i=Math.min(i,1),t=Math.max(t,0),i=Math.max(i,0);var x=w?new Float32Array(v):new Array(v),_=!1,C=function(e){return _||p(),t===n&&i===o?e:0===e?0:1===e?1:l(function(e){for(var n=0,o=1,r=v-1;o!=r&&x[o]<=e;++o)n+=y;--o;var s=n+(e-x[o])/(x[o+1]-x[o])*y,a=u(s,t,i);return a>=f?c(e,s):0==a?s:d(e,n,n+y)}(e),n,o)};C.getControlPoints=function(){return[{x:t,y:n},{x:i,y:o}]};var k="generateBezier("+[t,n,i,o]+")";return C.toString=function(){return k},C}function l(t,e){var n=t;return f.isString(t)?v.Easings[t]||(n=!1):n=f.isArray(t)&&1===t.length?s.apply(null,t):f.isArray(t)&&2===t.length?y.apply(null,t.concat([e])):!(!f.isArray(t)||4!==t.length)&&a.apply(null,t),!1===n&&(n=v.Easings[v.defaults.easing]?v.defaults.easing:g),n}function u(t){if(t)for(var e=(new Date).getTime(),n=0,o=v.State.calls.length;n<o;n++)if(v.State.calls[n]){var s=v.State.calls[n],a=s[0],l=s[2],p=s[3],h=!!p;p||(p=v.State.calls[n][3]=e-16);for(var m=Math.min((e-p)/l.duration,1),g=0,y=a.length;g<y;g++){var b=a[g],_=b.element;if(r(_)){var C=!1;if(l.display!==i&&null!==l.display&&"none"!==l.display){if("flex"===l.display){d.each(["-webkit-box","-moz-box","-ms-flexbox","-webkit-flex"],(function(t,e){w.setPropertyValue(_,"display",e)}))}w.setPropertyValue(_,"display",l.display)}for(var k in l.visibility!==i&&"hidden"!==l.visibility&&w.setPropertyValue(_,"visibility",l.visibility),b)if("element"!==k){var T,S=b[k],E=f.isString(S.easing)?v.Easings[S.easing]:S.easing;if(1===m)T=S.endValue;else if(T=S.startValue+(S.endValue-S.startValue)*E(m),!h&&T===S.currentValue)continue;if(S.currentValue=T,w.Hooks.registered[k]){var I=w.Hooks.getRoot(k),P=r(_).rootPropertyValueCache[I];P&&(S.rootPropertyValue=P)}var L=w.setPropertyValue(_,k,S.currentValue+(0===parseFloat(T)?"":S.unitType),S.rootPropertyValue,S.scrollData);w.Hooks.registered[k]&&(w.Normalizations.registered[I]?r(_).rootPropertyValueCache[I]=w.Normalizations.registered[I]("extract",null,L[1]):r(_).rootPropertyValueCache[I]=L[1]),"transform"===L[0]&&(C=!0)}l.mobileHA&&r(_).transformCache.translate3d===i&&(r(_).transformCache.translate3d="(0px, 0px, 0px)",C=!0),C&&w.flushTransformCache(_)}}l.display!==i&&"none"!==l.display&&(v.State.calls[n][2].display=!1),l.visibility!==i&&"hidden"!==l.visibility&&(v.State.calls[n][2].visibility=!1),l.progress&&l.progress.call(s[1],s[1],m,Math.max(0,p+l.duration-e),p),1===m&&c(n)}v.State.isTicking&&x(u)}function c(t,e){if(!v.State.calls[t])return!1;for(var n=v.State.calls[t][0],o=v.State.calls[t][1],s=v.State.calls[t][2],a=v.State.calls[t][4],l=!1,u=0,c=n.length;u<c;u++){var p=n[u].element;if(e||s.loop||("none"===s.display&&w.setPropertyValue(p,"display",s.display),"hidden"===s.visibility&&w.setPropertyValue(p,"visibility",s.visibility)),!0!==s.loop&&(d.queue(p)[1]===i||!/\.velocityQueueEntryFlag/i.test(d.queue(p)[1]))&&r(p)){r(p).isAnimating=!1,r(p).rootPropertyValueCache={};var h=!1;d.each(w.Lists.transforms3D,(function(t,e){var n=/^scale/.test(e)?1:0,o=r(p).transformCache[e];r(p).transformCache[e]!==i&&new RegExp("^\\("+n+"[^.]").test(o)&&(h=!0,delete r(p).transformCache[e])})),s.mobileHA&&(h=!0,delete r(p).transformCache.translate3d),h&&w.flushTransformCache(p),w.Values.removeClass(p,"velocity-animating")}if(!e&&s.complete&&!s.loop&&u===c-1)try{s.complete.call(o,o)}catch(t){setTimeout((function(){throw t}),1)}a&&!0!==s.loop&&a(o),!0!==s.loop||e||(d.each(r(p).tweensContainer,(function(t,e){/^rotate/.test(t)&&360===parseFloat(e.endValue)&&(e.endValue=0,e.startValue=360)})),v(p,"reverse",{loop:!0,delay:s.delay})),!1!==s.queue&&d.dequeue(p,s.queue)}v.State.calls[t]=!1;for(var f=0,m=v.State.calls.length;f<m;f++)if(!1!==v.State.calls[f]){l=!0;break}!1===l&&(v.State.isTicking=!1,delete v.State.calls,v.State.calls=[])}var d,p=function(){if(n.documentMode)return n.documentMode;for(var t=7;t>4;t--){var e=n.createElement("div");if(e.innerHTML="\x3c!--[if IE "+t+"]><span></span><![endif]--\x3e",e.getElementsByTagName("span").length)return e=null,t}return i}(),h=function(){var t=0;return e.webkitRequestAnimationFrame||e.mozRequestAnimationFrame||function(e){var n,i=(new Date).getTime();return n=Math.max(0,16-(i-t)),t=i+n,setTimeout((function(){e(i+n)}),n)}}(),f={isString:function(t){return"string"==typeof t},isArray:Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)},isFunction:function(t){return"[object Function]"===Object.prototype.toString.call(t)},isNode:function(t){return t&&t.nodeType},isNodeList:function(t){return"object"==typeof t&&/^\[object (HTMLCollection|NodeList|Object)\]$/.test(Object.prototype.toString.call(t))&&t.length!==i&&(0===t.length||"object"==typeof t[0]&&t[0].nodeType>0)},isWrapped:function(t){return t&&(t.jquery||e.Zepto&&e.Zepto.zepto.isZ(t))},isSVG:function(t){return e.SVGElement&&t instanceof e.SVGElement},isEmptyObject:function(t){for(var e in t)return!1;return!0}},m=!1;if(t.fn&&t.fn.jquery?(d=t,m=!0):d=e.Velocity.Utilities,p<=8&&!m)throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");if(!(p<=7)){var g="swing",v={State:{isMobile:/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),isAndroid:/Android/i.test(navigator.userAgent),isGingerbread:/Android 2\.3\.[3-7]/i.test(navigator.userAgent),isChrome:e.chrome,isFirefox:/Firefox/i.test(navigator.userAgent),prefixElement:n.createElement("div"),prefixMatches:{},scrollAnchor:null,scrollPropertyLeft:null,scrollPropertyTop:null,isTicking:!1,calls:[]},CSS:{},Utilities:d,Redirects:{},Easings:{},Promise:e.Promise,defaults:{queue:"",duration:400,easing:g,begin:i,complete:i,progress:i,display:i,visibility:i,loop:!1,delay:!1,mobileHA:!0,_cacheValues:!0},init:function(t){d.data(t,"velocity",{isSVG:f.isSVG(t),isAnimating:!1,computedStyle:null,tweensContainer:null,rootPropertyValueCache:{},transformCache:{}})},hook:null,mock:!1,version:{major:1,minor:1,patch:0},debug:!1};e.pageYOffset!==i?(v.State.scrollAnchor=e,v.State.scrollPropertyLeft="pageXOffset",v.State.scrollPropertyTop="pageYOffset"):(v.State.scrollAnchor=n.documentElement||n.body.parentNode||n.body,v.State.scrollPropertyLeft="scrollLeft",v.State.scrollPropertyTop="scrollTop");var y=function(){function t(t){return-t.tension*t.x-t.friction*t.v}function e(e,n,i){var o={x:e.x+i.dx*n,v:e.v+i.dv*n,tension:e.tension,friction:e.friction};return{dx:o.v,dv:t(o)}}function n(n,i){var o={dx:n.v,dv:t(n)},r=e(n,.5*i,o),s=e(n,.5*i,r),a=e(n,i,s),l=1/6*(o.dx+2*(r.dx+s.dx)+a.dx),u=1/6*(o.dv+2*(r.dv+s.dv)+a.dv);return n.x=n.x+l*i,n.v=n.v+u*i,n}return function t(e,i,o){var r,s,a,l={x:-1,v:0,tension:null,friction:null},u=[0],c=0;for(e=parseFloat(e)||500,i=parseFloat(i)||20,o=o||null,l.tension=e,l.friction=i,(r=null!==o)?s=(c=t(e,i))/o*.016:s=.016;a=n(a||l,s),u.push(1+a.x),c+=16,Math.abs(a.x)>1e-4&&Math.abs(a.v)>1e-4;);return r?function(t){return u[t*(u.length-1)|0]}:c}}();v.Easings={linear:function(t){return t},swing:function(t){return.5-Math.cos(t*Math.PI)/2},spring:function(t){return 1-Math.cos(4.5*t*Math.PI)*Math.exp(6*-t)}},d.each([["ease",[.25,.1,.25,1]],["ease-in",[.42,0,1,1]],["ease-out",[0,0,.58,1]],["ease-in-out",[.42,0,.58,1]],["easeInSine",[.47,0,.745,.715]],["easeOutSine",[.39,.575,.565,1]],["easeInOutSine",[.445,.05,.55,.95]],["easeInQuad",[.55,.085,.68,.53]],["easeOutQuad",[.25,.46,.45,.94]],["easeInOutQuad",[.455,.03,.515,.955]],["easeInCubic",[.55,.055,.675,.19]],["easeOutCubic",[.215,.61,.355,1]],["easeInOutCubic",[.645,.045,.355,1]],["easeInQuart",[.895,.03,.685,.22]],["easeOutQuart",[.165,.84,.44,1]],["easeInOutQuart",[.77,0,.175,1]],["easeInQuint",[.755,.05,.855,.06]],["easeOutQuint",[.23,1,.32,1]],["easeInOutQuint",[.86,0,.07,1]],["easeInExpo",[.95,.05,.795,.035]],["easeOutExpo",[.19,1,.22,1]],["easeInOutExpo",[1,0,0,1]],["easeInCirc",[.6,.04,.98,.335]],["easeOutCirc",[.075,.82,.165,1]],["easeInOutCirc",[.785,.135,.15,.86]]],(function(t,e){v.Easings[e[0]]=a.apply(null,e[1])}));var w=v.CSS={RegEx:{isHex:/^#([A-f\d]{3}){1,2}$/i,valueUnwrap:/^[A-z]+\((.*)\)$/i,wrappedValueAlreadyExtracted:/[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,valueSplit:/([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/gi},Lists:{colors:["fill","stroke","stopColor","color","backgroundColor","borderColor","borderTopColor","borderRightColor","borderBottomColor","borderLeftColor","outlineColor"],transformsBase:["translateX","translateY","scale","scaleX","scaleY","skewX","skewY","rotateZ"],transforms3D:["transformPerspective","translateZ","scaleZ","rotateX","rotateY"]},Hooks:{templates:{textShadow:["Color X Y Blur","black 0px 0px 0px"],boxShadow:["Color X Y Blur Spread","black 0px 0px 0px 0px"],clip:["Top Right Bottom Left","0px 0px 0px 0px"],backgroundPosition:["X Y","0% 0%"],transformOrigin:["X Y Z","50% 50% 0px"],perspectiveOrigin:["X Y","50% 50%"]},registered:{},register:function(){for(var t=0;t<w.Lists.colors.length;t++){var e="color"===w.Lists.colors[t]?"0 0 0 1":"255 255 255 1";w.Hooks.templates[w.Lists.colors[t]]=["Red Green Blue Alpha",e]}var n,i,o;if(p)for(n in w.Hooks.templates){o=(i=w.Hooks.templates[n])[0].split(" ");var r=i[1].match(w.RegEx.valueSplit);"Color"===o[0]&&(o.push(o.shift()),r.push(r.shift()),w.Hooks.templates[n]=[o.join(" "),r.join(" ")])}for(n in w.Hooks.templates)for(var t in o=(i=w.Hooks.templates[n])[0].split(" ")){var s=n+o[t],a=t;w.Hooks.registered[s]=[n,a]}},getRoot:function(t){var e=w.Hooks.registered[t];return e?e[0]:t},cleanRootPropertyValue:function(t,e){return w.RegEx.valueUnwrap.test(e)&&(e=e.match(w.RegEx.valueUnwrap)[1]),w.Values.isCSSNullValue(e)&&(e=w.Hooks.templates[t][1]),e},extractValue:function(t,e){var n=w.Hooks.registered[t];if(n){var i=n[0],o=n[1];return(e=w.Hooks.cleanRootPropertyValue(i,e)).toString().match(w.RegEx.valueSplit)[o]}return e},injectValue:function(t,e,n){var i=w.Hooks.registered[t];if(i){var o,r=i[0],s=i[1];return(o=(n=w.Hooks.cleanRootPropertyValue(r,n)).toString().match(w.RegEx.valueSplit))[s]=e,o.join(" ")}return n}},Normalizations:{registered:{clip:function(t,e,n){switch(t){case"name":return"clip";case"extract":var i;return w.RegEx.wrappedValueAlreadyExtracted.test(n)?i=n:i=(i=n.toString().match(w.RegEx.valueUnwrap))?i[1].replace(/,(\s+)?/g," "):n,i;case"inject":return"rect("+n+")"}},blur:function(t,e,n){switch(t){case"name":return"-webkit-filter";case"extract":var i=parseFloat(n);if(!i&&0!==i){var o=n.toString().match(/blur\(([0-9]+[A-z]+)\)/i);i=o?o[1]:0}return i;case"inject":return parseFloat(n)?"blur("+n+")":"none"}},opacity:function(t,e,n){if(p<=8)switch(t){case"name":return"filter";case"extract":var i=n.toString().match(/alpha\(opacity=(.*)\)/i);return i?i[1]/100:1;case"inject":return e.style.zoom=1,parseFloat(n)>=1?"":"alpha(opacity="+parseInt(100*parseFloat(n),10)+")"}else switch(t){case"name":return"opacity";case"extract":case"inject":return n}}},register:function(){p<=9||v.State.isGingerbread||(w.Lists.transformsBase=w.Lists.transformsBase.concat(w.Lists.transforms3D));for(var t=0;t<w.Lists.transformsBase.length;t++)!function(){var e=w.Lists.transformsBase[t];w.Normalizations.registered[e]=function(t,n,o){switch(t){case"name":return"transform";case"extract":return r(n)===i||r(n).transformCache[e]===i?/^scale/i.test(e)?1:0:r(n).transformCache[e].replace(/[()]/g,"");case"inject":var s=!1;switch(e.substr(0,e.length-1)){case"translate":s=!/(%|px|em|rem|vw|vh|\d)$/i.test(o);break;case"scal":case"scale":v.State.isAndroid&&r(n).transformCache[e]===i&&o<1&&(o=1),s=!/(\d)$/i.test(o);break;case"skew":case"rotate":s=!/(deg|\d)$/i.test(o)}return s||(r(n).transformCache[e]="("+o+")"),r(n).transformCache[e]}}}();for(t=0;t<w.Lists.colors.length;t++)!function(){var e=w.Lists.colors[t];w.Normalizations.registered[e]=function(t,n,o){switch(t){case"name":return e;case"extract":var r;if(w.RegEx.wrappedValueAlreadyExtracted.test(o))r=o;else{var s,a={black:"rgb(0, 0, 0)",blue:"rgb(0, 0, 255)",gray:"rgb(128, 128, 128)",green:"rgb(0, 128, 0)",red:"rgb(255, 0, 0)",white:"rgb(255, 255, 255)"};/^[A-z]+$/i.test(o)?s=a[o]!==i?a[o]:a.black:w.RegEx.isHex.test(o)?s="rgb("+w.Values.hexToRgb(o).join(" ")+")":/^rgba?\(/i.test(o)||(s=a.black),r=(s||o).toString().match(w.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g," ")}return p<=8||3!==r.split(" ").length||(r+=" 1"),r;case"inject":return p<=8?4===o.split(" ").length&&(o=o.split(/\s+/).slice(0,3).join(" ")):3===o.split(" ").length&&(o+=" 1"),(p<=8?"rgb":"rgba")+"("+o.replace(/\s+/g,",").replace(/\.(\d)+(?=,)/g,"")+")"}}}()}},Names:{camelCase:function(t){return t.replace(/-(\w)/g,(function(t,e){return e.toUpperCase()}))},SVGAttribute:function(t){var e="width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";return(p||v.State.isAndroid&&!v.State.isChrome)&&(e+="|transform"),new RegExp("^("+e+")$","i").test(t)},prefixCheck:function(t){if(v.State.prefixMatches[t])return[v.State.prefixMatches[t],!0];for(var e=["","Webkit","Moz","ms","O"],n=0,i=e.length;n<i;n++){var o;if(o=0===n?t:e[n]+t.replace(/^\w/,(function(t){return t.toUpperCase()})),f.isString(v.State.prefixElement.style[o]))return v.State.prefixMatches[t]=o,[o,!0]}return[t,!1]}},Values:{hexToRgb:function(t){var e;return t=t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i,(function(t,e,n,i){return e+e+n+n+i+i})),(e=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t))?[parseInt(e[1],16),parseInt(e[2],16),parseInt(e[3],16)]:[0,0,0]},isCSSNullValue:function(t){return 0==t||/^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(t)},getUnitType:function(t){return/^(rotate|skew)/i.test(t)?"deg":/(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(t)?"":"px"},getDisplayType:function(t){var e=t&&t.tagName.toString().toLowerCase();return/^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(e)?"inline":/^(li)$/i.test(e)?"list-item":/^(tr)$/i.test(e)?"table-row":"block"},addClass:function(t,e){t.classList?t.classList.add(e):t.className+=(t.className.length?" ":"")+e},removeClass:function(t,e){t.classList?t.classList.remove(e):t.className=t.className.toString().replace(new RegExp("(^|\\s)"+e.split(" ").join("|")+"(\\s|$)","gi")," ")}},getPropertyValue:function(t,n,o,s){function a(t,n){function o(){c&&w.setPropertyValue(t,"display","none")}var l=0;if(p<=8)l=d.css(t,n);else{var u,c=!1;if(/^(width|height)$/.test(n)&&0===w.getPropertyValue(t,"display")&&(c=!0,w.setPropertyValue(t,"display",w.Values.getDisplayType(t))),!s){if("height"===n&&"border-box"!==w.getPropertyValue(t,"boxSizing").toString().toLowerCase()){var h=t.offsetHeight-(parseFloat(w.getPropertyValue(t,"borderTopWidth"))||0)-(parseFloat(w.getPropertyValue(t,"borderBottomWidth"))||0)-(parseFloat(w.getPropertyValue(t,"paddingTop"))||0)-(parseFloat(w.getPropertyValue(t,"paddingBottom"))||0);return o(),h}if("width"===n&&"border-box"!==w.getPropertyValue(t,"boxSizing").toString().toLowerCase()){var f=t.offsetWidth-(parseFloat(w.getPropertyValue(t,"borderLeftWidth"))||0)-(parseFloat(w.getPropertyValue(t,"borderRightWidth"))||0)-(parseFloat(w.getPropertyValue(t,"paddingLeft"))||0)-(parseFloat(w.getPropertyValue(t,"paddingRight"))||0);return o(),f}}u=r(t)===i?e.getComputedStyle(t,null):r(t).computedStyle?r(t).computedStyle:r(t).computedStyle=e.getComputedStyle(t,null),(p||v.State.isFirefox)&&"borderColor"===n&&(n="borderTopColor"),""!==(l=9===p&&"filter"===n?u.getPropertyValue(n):u[n])&&null!==l||(l=t.style[n]),o()}if("auto"===l&&/^(top|right|bottom|left)$/i.test(n)){var m=a(t,"position");("fixed"===m||"absolute"===m&&/top|left/i.test(n))&&(l=d(t).position()[n]+"px")}return l}var l;if(w.Hooks.registered[n]){var u=n,c=w.Hooks.getRoot(u);o===i&&(o=w.getPropertyValue(t,w.Names.prefixCheck(c)[0])),w.Normalizations.registered[c]&&(o=w.Normalizations.registered[c]("extract",t,o)),l=w.Hooks.extractValue(u,o)}else if(w.Normalizations.registered[n]){var h,f;"transform"!==(h=w.Normalizations.registered[n]("name",t))&&(f=a(t,w.Names.prefixCheck(h)[0]),w.Values.isCSSNullValue(f)&&w.Hooks.templates[n]&&(f=w.Hooks.templates[n][1])),l=w.Normalizations.registered[n]("extract",t,f)}return/^[\d-]/.test(l)||(l=r(t)&&r(t).isSVG&&w.Names.SVGAttribute(n)?/^(height|width)$/i.test(n)?t.getBBox()[n]:t.getAttribute(n):a(t,w.Names.prefixCheck(n)[0])),w.Values.isCSSNullValue(l)&&(l=0),v.debug>=2&&console.log("Get "+n+": "+l),l},setPropertyValue:function(t,n,i,o,s){var a=n;if("scroll"===n)s.container?s.container["scroll"+s.direction]=i:"Left"===s.direction?e.scrollTo(i,s.alternateValue):e.scrollTo(s.alternateValue,i);else if(w.Normalizations.registered[n]&&"transform"===w.Normalizations.registered[n]("name",t))w.Normalizations.registered[n]("inject",t,i),a="transform",i=r(t).transformCache[n];else{if(w.Hooks.registered[n]){var l=n,u=w.Hooks.getRoot(n);o=o||w.getPropertyValue(t,u),i=w.Hooks.injectValue(l,i,o),n=u}if(w.Normalizations.registered[n]&&(i=w.Normalizations.registered[n]("inject",t,i),n=w.Normalizations.registered[n]("name",t)),a=w.Names.prefixCheck(n)[0],p<=8)try{t.style[a]=i}catch(t){v.debug&&console.log("Browser does not support ["+i+"] for ["+a+"]")}else r(t)&&r(t).isSVG&&w.Names.SVGAttribute(n)?t.setAttribute(n,i):t.style[a]=i;v.debug>=2&&console.log("Set "+n+" ("+a+"): "+i)}return[a,i]},flushTransformCache:function(t){function e(e){return parseFloat(w.getPropertyValue(t,e))}var n="";if((p||v.State.isAndroid&&!v.State.isChrome)&&r(t).isSVG){var i={translate:[e("translateX"),e("translateY")],skewX:[e("skewX")],skewY:[e("skewY")],scale:1!==e("scale")?[e("scale"),e("scale")]:[e("scaleX"),e("scaleY")],rotate:[e("rotateZ"),0,0]};d.each(r(t).transformCache,(function(t){/^translate/i.test(t)?t="translate":/^scale/i.test(t)?t="scale":/^rotate/i.test(t)&&(t="rotate"),i[t]&&(n+=t+"("+i[t].join(" ")+") ",delete i[t])}))}else{var o,s;d.each(r(t).transformCache,(function(e){if(o=r(t).transformCache[e],"transformPerspective"===e)return s=o,!0;9===p&&"rotateZ"===e&&(e="rotate"),n+=e+o+" "})),s&&(n="perspective"+s+" "+n)}w.setPropertyValue(t,"transform",n)}};w.Hooks.register(),w.Normalizations.register(),v.hook=function(t,e,n){var s=i;return t=o(t),d.each(t,(function(t,o){if(r(o)===i&&v.init(o),n===i)s===i&&(s=v.CSS.getPropertyValue(o,e));else{var a=v.CSS.setPropertyValue(o,e,n);"transform"===a[0]&&v.CSS.flushTransformCache(o),s=a}})),s};var b=function(){function t(){return a?S.promise||null:p}function s(){function t(t){function p(t,e){var n=i,o=i,r=i;return f.isArray(t)?(n=t[0],!f.isArray(t[1])&&/^[\d-]/.test(t[1])||f.isFunction(t[1])||w.RegEx.isHex.test(t[1])?r=t[1]:(f.isString(t[1])&&!w.RegEx.isHex.test(t[1])||f.isArray(t[1]))&&(o=e?t[1]:l(t[1],a.duration),t[2]!==i&&(r=t[2]))):n=t,e||(o=o||a.easing),f.isFunction(n)&&(n=n.call(s,C,_)),f.isFunction(r)&&(r=r.call(s,C,_)),[n||0,o,r]}function h(t,e){var n,i;return i=(e||"0").toString().toLowerCase().replace(/[%A-z]+$/,(function(t){return n=t,""})),n||(n=w.Values.getUnitType(t)),[i,n]}if(a.begin&&0===C)try{a.begin.call(m,m)}catch(t){setTimeout((function(){throw t}),1)}if("scroll"===T){var b,x,k,E=/^x$/i.test(a.axis)?"Left":"Top",I=parseFloat(a.offset)||0;a.container?f.isWrapped(a.container)||f.isNode(a.container)?(a.container=a.container[0]||a.container,k=(b=a.container["scroll"+E])+d(s).position()[E.toLowerCase()]+I):a.container=null:(b=v.State.scrollAnchor[v.State["scrollProperty"+E]],x=v.State.scrollAnchor[v.State["scrollProperty"+("Left"===E?"Top":"Left")]],k=d(s).offset()[E.toLowerCase()]+I),c={scroll:{rootPropertyValue:!1,startValue:b,currentValue:b,endValue:k,unitType:"",easing:a.easing,scrollData:{container:a.container,direction:E,alternateValue:x}},element:s},v.debug&&console.log("tweensContainer (scroll): ",c.scroll,s)}else if("reverse"===T){if(!r(s).tweensContainer)return void d.dequeue(s,a.queue);"none"===r(s).opts.display&&(r(s).opts.display="auto"),"hidden"===r(s).opts.visibility&&(r(s).opts.visibility="visible"),r(s).opts.loop=!1,r(s).opts.begin=null,r(s).opts.complete=null,y.easing||delete a.easing,y.duration||delete a.duration,a=d.extend({},r(s).opts,a);var P=d.extend(!0,{},r(s).tweensContainer);for(var L in P)if("element"!==L){var A=P[L].startValue;P[L].startValue=P[L].currentValue=P[L].endValue,P[L].endValue=A,f.isEmptyObject(y)||(P[L].easing=a.easing),v.debug&&console.log("reverse tweensContainer ("+L+"): "+JSON.stringify(P[L]),s)}c=P}else if("start"===T){for(var $ in r(s).tweensContainer&&!0===r(s).isAnimating&&(P=r(s).tweensContainer),d.each(g,(function(t,e){if(RegExp("^"+w.Lists.colors.join("$|^")+"$").test(t)){var n=p(e,!0),o=n[0],r=n[1],s=n[2];if(w.RegEx.isHex.test(o)){for(var a=["Red","Green","Blue"],l=w.Values.hexToRgb(o),u=s?w.Values.hexToRgb(s):i,c=0;c<a.length;c++){var d=[l[c]];r&&d.push(r),u!==i&&d.push(u[c]),g[t+a[c]]=d}delete g[t]}}})),g){var N=p(g[$]),M=N[0],H=N[1],F=N[2];$=w.Names.camelCase($);var D=w.Hooks.getRoot($),z=!1;if(r(s).isSVG||!1!==w.Names.prefixCheck(D)[1]||w.Normalizations.registered[D]!==i){(a.display!==i&&null!==a.display&&"none"!==a.display||a.visibility!==i&&"hidden"!==a.visibility)&&/opacity|filter/.test($)&&!F&&0!==M&&(F=0),a._cacheValues&&P&&P[$]?(F===i&&(F=P[$].endValue+P[$].unitType),z=r(s).rootPropertyValueCache[D]):w.Hooks.registered[$]?F===i?(z=w.getPropertyValue(s,D),F=w.getPropertyValue(s,$,z)):z=w.Hooks.templates[D][1]:F===i&&(F=w.getPropertyValue(s,$));var V,q,R,W=!1;if(F=(V=h($,F))[0],R=V[1],M=(V=h($,M))[0].replace(/^([+-\/*])=/,(function(t,e){return W=e,""})),q=V[1],F=parseFloat(F)||0,M=parseFloat(M)||0,"%"===q&&(/^(fontSize|lineHeight)$/.test($)?(M/=100,q="em"):/^scale/.test($)?(M/=100,q=""):/(Red|Green|Blue)$/i.test($)&&(M=M/100*255,q="")),/[\/*]/.test(W))q=R;else if(R!==q&&0!==F)if(0===M)q=R;else{o=o||function(){var t={myParent:s.parentNode||n.body,position:w.getPropertyValue(s,"position"),fontSize:w.getPropertyValue(s,"fontSize")},i=t.position===O.lastPosition&&t.myParent===O.lastParent,o=t.fontSize===O.lastFontSize;O.lastParent=t.myParent,O.lastPosition=t.position,O.lastFontSize=t.fontSize;var a={};if(o&&i)a.emToPx=O.lastEmToPx,a.percentToPxWidth=O.lastPercentToPxWidth,a.percentToPxHeight=O.lastPercentToPxHeight;else{var l=r(s).isSVG?n.createElementNS("http://www.w3.org/2000/svg","rect"):n.createElement("div");v.init(l),t.myParent.appendChild(l),d.each(["overflow","overflowX","overflowY"],(function(t,e){v.CSS.setPropertyValue(l,e,"hidden")})),v.CSS.setPropertyValue(l,"position",t.position),v.CSS.setPropertyValue(l,"fontSize",t.fontSize),v.CSS.setPropertyValue(l,"boxSizing","content-box"),d.each(["minWidth","maxWidth","width","minHeight","maxHeight","height"],(function(t,e){v.CSS.setPropertyValue(l,e,"100%")})),v.CSS.setPropertyValue(l,"paddingLeft","100em"),a.percentToPxWidth=O.lastPercentToPxWidth=(parseFloat(w.getPropertyValue(l,"width",null,!0))||1)/100,a.percentToPxHeight=O.lastPercentToPxHeight=(parseFloat(w.getPropertyValue(l,"height",null,!0))||1)/100,a.emToPx=O.lastEmToPx=(parseFloat(w.getPropertyValue(l,"paddingLeft"))||1)/100,t.myParent.removeChild(l)}return null===O.remToPx&&(O.remToPx=parseFloat(w.getPropertyValue(n.body,"fontSize"))||16),null===O.vwToPx&&(O.vwToPx=parseFloat(e.innerWidth)/100,O.vhToPx=parseFloat(e.innerHeight)/100),a.remToPx=O.remToPx,a.vwToPx=O.vwToPx,a.vhToPx=O.vhToPx,v.debug>=1&&console.log("Unit ratios: "+JSON.stringify(a),s),a}();var B=/margin|padding|left|right|width|text|word|letter/i.test($)||/X$/.test($)||"x"===$?"x":"y";switch(R){case"%":F*="x"===B?o.percentToPxWidth:o.percentToPxHeight;break;case"px":break;default:F*=o[R+"ToPx"]}switch(q){case"%":F*=1/("x"===B?o.percentToPxWidth:o.percentToPxHeight);break;case"px":break;default:F*=1/o[q+"ToPx"]}}switch(W){case"+":M=F+M;break;case"-":M=F-M;break;case"*":M*=F;break;case"/":M=F/M}c[$]={rootPropertyValue:z,startValue:F,currentValue:F,endValue:M,unitType:q,easing:H},v.debug&&console.log("tweensContainer ("+$+"): "+JSON.stringify(c[$]),s)}else v.debug&&console.log("Skipping ["+D+"] due to a lack of browser support.")}c.element=s}c.element&&(w.Values.addClass(s,"velocity-animating"),j.push(c),""===a.queue&&(r(s).tweensContainer=c,r(s).opts=a),r(s).isAnimating=!0,C===_-1?(v.State.calls.length>1e4&&(v.State.calls=function(t){for(var e=-1,n=t?t.length:0,i=[];++e<n;){var o=t[e];o&&i.push(o)}return i}(v.State.calls)),v.State.calls.push([j,m,a,null,S.resolver]),!1===v.State.isTicking&&(v.State.isTicking=!0,u())):C++)}var o,s=this,a=d.extend({},v.defaults,y),c={};switch(r(s)===i&&v.init(s),parseFloat(a.delay)&&!1!==a.queue&&d.queue(s,a.queue,(function(t){v.velocityQueueEntryFlag=!0,r(s).delayTimer={setTimeout:setTimeout(t,parseFloat(a.delay)),next:t}})),a.duration.toString().toLowerCase()){case"fast":a.duration=200;break;case"normal":a.duration=400;break;case"slow":a.duration=600;break;default:a.duration=parseFloat(a.duration)||1}!1!==v.mock&&(!0===v.mock?a.duration=a.delay=1:(a.duration*=parseFloat(v.mock)||1,a.delay*=parseFloat(v.mock)||1)),a.easing=l(a.easing,a.duration),a.begin&&!f.isFunction(a.begin)&&(a.begin=null),a.progress&&!f.isFunction(a.progress)&&(a.progress=null),a.complete&&!f.isFunction(a.complete)&&(a.complete=null),a.display!==i&&null!==a.display&&(a.display=a.display.toString().toLowerCase(),"auto"===a.display&&(a.display=v.CSS.Values.getDisplayType(s))),a.visibility!==i&&null!==a.visibility&&(a.visibility=a.visibility.toString().toLowerCase()),a.mobileHA=a.mobileHA&&v.State.isMobile&&!v.State.isGingerbread,!1===a.queue?a.delay?setTimeout(t,a.delay):t():d.queue(s,a.queue,(function(e,n){if(!0===n)return S.promise&&S.resolver(m),!0;v.velocityQueueEntryFlag=!0,t(e)})),""!==a.queue&&"fx"!==a.queue||"inprogress"===d.queue(s)[0]||d.dequeue(s)}var a,p,h,m,g,y,x=arguments[0]&&(d.isPlainObject(arguments[0].properties)&&!arguments[0].properties.names||f.isString(arguments[0].properties));if(f.isWrapped(this)?(a=!1,h=0,m=this,p=this):(a=!0,h=1,m=x?arguments[0].elements:arguments[0]),m=o(m)){x?(g=arguments[0].properties,y=arguments[0].options):(g=arguments[h],y=arguments[h+1]);var _=m.length,C=0;if("stop"!==g&&!d.isPlainObject(y)){y={};for(var k=h+1;k<arguments.length;k++)f.isArray(arguments[k])||!/^(fast|normal|slow)$/i.test(arguments[k])&&!/^\d/.test(arguments[k])?f.isString(arguments[k])||f.isArray(arguments[k])?y.easing=arguments[k]:f.isFunction(arguments[k])&&(y.complete=arguments[k]):y.duration=arguments[k]}var T,S={promise:null,resolver:null,rejecter:null};switch(a&&v.Promise&&(S.promise=new v.Promise((function(t,e){S.resolver=t,S.rejecter=e}))),g){case"scroll":T="scroll";break;case"reverse":T="reverse";break;case"stop":d.each(m,(function(t,e){r(e)&&r(e).delayTimer&&(clearTimeout(r(e).delayTimer.setTimeout),r(e).delayTimer.next&&r(e).delayTimer.next(),delete r(e).delayTimer)}));var E=[];return d.each(v.State.calls,(function(t,e){e&&d.each(e[1],(function(n,o){var s=f.isString(y)?y:"";if(y!==i&&e[2].queue!==s)return!0;d.each(m,(function(e,n){n===o&&(y!==i&&(d.each(d.queue(n,s),(function(t,e){f.isFunction(e)&&e(null,!0)})),d.queue(n,s,[])),r(n)&&""===s&&d.each(r(n).tweensContainer,(function(t,e){e.endValue=e.currentValue})),E.push(t))}))}))})),d.each(E,(function(t,e){c(e,!0)})),S.promise&&S.resolver(m),t();default:if(!d.isPlainObject(g)||f.isEmptyObject(g)){if(f.isString(g)&&v.Redirects[g]){var I=($=d.extend({},y)).duration,P=$.delay||0;return!0===$.backwards&&(m=d.extend(!0,[],m).reverse()),d.each(m,(function(t,e){parseFloat($.stagger)?$.delay=P+parseFloat($.stagger)*t:f.isFunction($.stagger)&&($.delay=P+$.stagger.call(e,t,_)),$.drag&&($.duration=parseFloat(I)||(/^(callout|transition)/.test(g)?1e3:400),$.duration=Math.max($.duration*($.backwards?1-t/_:(t+1)/_),.75*$.duration,200)),v.Redirects[g].call(e,e,$||{},t,_,m,S.promise?S:i)})),t()}var L="Velocity: First argument ("+g+") was not a property map, a known action, or a registered redirect. Aborting.";return S.promise?S.rejecter(new Error(L)):console.log(L),t()}T="start"}var A,$,O={lastParent:null,lastPosition:null,lastFontSize:null,lastPercentToPxWidth:null,lastPercentToPxHeight:null,lastEmToPx:null,remToPx:null,vwToPx:null,vhToPx:null},j=[];if(d.each(m,(function(t,e){f.isNode(e)&&s.call(e)})),($=d.extend({},v.defaults,y)).loop=parseInt($.loop),A=2*$.loop-1,$.loop)for(var N=0;N<A;N++){var M={delay:$.delay,progress:$.progress};N===A-1&&(M.display=$.display,M.visibility=$.visibility,M.complete=$.complete),b(m,"reverse",M)}return t()}};(v=d.extend(b,v)).animate=b;var x=e.requestAnimationFrame||h;return v.State.isMobile||n.hidden===i||n.addEventListener("visibilitychange",(function(){n.hidden?(x=function(t){return setTimeout((function(){t(!0)}),16)},u()):x=e.requestAnimationFrame||h})),t.Velocity=v,t!==e&&(t.fn.velocity=b,t.fn.velocity.defaults=v.defaults),d.each(["Down","Up"],(function(t,e){v.Redirects["slide"+e]=function(t,n,o,r,s,a){var l=d.extend({},n),u=l.begin,c=l.complete,p={height:"",marginTop:"",marginBottom:"",paddingTop:"",paddingBottom:""},h={};l.display===i&&(l.display="Down"===e?"inline"===v.CSS.Values.getDisplayType(t)?"inline-block":"block":"none"),l.begin=function(){for(var n in u&&u.call(s,s),p){h[n]=t.style[n];var i=v.CSS.getPropertyValue(t,n);p[n]="Down"===e?[i,0]:[0,i]}h.overflow=t.style.overflow,t.style.overflow="hidden"},l.complete=function(){for(var e in h)t.style[e]=h[e];c&&c.call(s,s),a&&a.resolver(s)},v(t,p,l)}})),d.each(["In","Out"],(function(t,e){v.Redirects["fade"+e]=function(t,n,o,r,s,a){var l=d.extend({},n),u={opacity:"In"===e?1:0},c=l.complete;l.complete=o!==r-1?l.begin=null:function(){c&&c.call(s,s),a&&a.resolver(s)},l.display===i&&(l.display="In"===e?"auto":"none"),v(this,u,l)}})),v}jQuery.fn.velocity=jQuery.fn.animate}(window.jQuery||window.Zepto||window,window,document)})),function(t){t.fn.fitVids=function(e){var n={customSelector:null,ignore:null};if(!document.getElementById("fit-vids-style")){var i=document.head||document.getElementsByTagName("head")[0],o=document.createElement("div");o.innerHTML='<p>x</p><style id="fit-vids-style">.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}</style>',i.appendChild(o.childNodes[1])}return e&&t.extend(n,e),this.each((function(){var e=['iframe[src*="player.vimeo.com"]','iframe[src*="youtube.com"]','iframe[src*="youtube-nocookie.com"]','iframe[src*="kickstarter.com"][src*="video.html"]',"object","embed"];n.customSelector&&e.push(n.customSelector);var i=".fitvidsignore";n.ignore&&(i=i+", "+n.ignore);var o=t(this).find(e.join(","));(o=(o=o.not("object object")).not(i)).each((function(){var e=t(this);if(!(e.parents(i).length>0||"embed"===this.tagName.toLowerCase()&&e.parent("object").length||e.parent(".fluid-width-video-wrapper").length)){e.css("height")||e.css("width")||!isNaN(e.attr("height"))&&!isNaN(e.attr("width"))||(e.attr("height",9),e.attr("width",16));var n=("object"===this.tagName.toLowerCase()||e.attr("height")&&!isNaN(parseInt(e.attr("height"),10))?parseInt(e.attr("height"),10):e.height())/(isNaN(parseInt(e.attr("width"),10))?e.width():parseInt(e.attr("width"),10));if(!e.attr("name")){var o="fitvid"+t.fn.fitVids._count;e.attr("name",o),t.fn.fitVids._count++}e.wrap('<div class="fluid-width-video-wrapper"></div>').parent(".fluid-width-video-wrapper").css("padding-top",100*n+"%"),e.removeAttr("height").removeAttr("width")}}))}))},t.fn.fitVids._count=0}(window.jQuery||window.Zepto),function(t,e){function n(e,r,s,a,l){var u=!1,c=function(t){l&&t[t.is("table, thead, tbody, tfoot, tr, col, colgroup, object, embed, param, ol, ul, dl, blockquote, select, optgroup, option, textarea, script, style")?"after":"append"](l)};return e.contents().detach().each((function(){var d=this,p=t(d);if(void 0===d||3==d.nodeType&&0==t.trim(d.data).length)return!0;if(p.is("script, .dotdotdot-keep"))e.append(p);else{if(u)return!0;e.append(p),c(e),o(s,a)&&((u=3==d.nodeType?i(p,r,s,a,l):n(p,r,s,a,l))||(c(t(e.contents().last())),u=!0)),u||l&&l.detach()}})),u}function i(e,n,i,s,u){var d=e[0];if(!d)return!1;var p=l(d),h=-1!==p.indexOf(" ")?" ":"　",f="letter"==s.wrap?"":h,m=p.split(f),g=-1,v=-1,y=0,w=m.length-1;for(s.fallbackToLetter&&0==y&&0==w&&(f="",w=(m=p.split(f)).length-1);y<=w&&(0!=y||0!=w);){var b=Math.floor((y+w)/2);if(b==v)break;v=b,a(d,m.slice(0,v+1).join(f)+s.ellipsis),o(i,s)?(w=v,s.fallbackToLetter&&0==y&&0==w&&(f="",g=-1,v=-1,y=0,w=(m=m[0].split(f)).length-1)):(g=v,y=v)}if(-1==g||1==m.length&&0==m[0].length){var x=e.parent();e.detach();var _=u&&u.closest(x).length?u.length:0;x.contents().length>_?d=c(x.contents().eq(-1-_),n):(d=c(x,n,!0),_||x.detach()),d&&(a(d,p=r(l(d),s)),_&&u&&t(d).parent().append(u))}else a(d,p=r(m.slice(0,g+1).join(f),s));return!0}function o(t,e){return t.innerHeight()>e.maxHeight}function r(e,n){for(;t.inArray(e.slice(-1),n.lastCharacter.remove)>-1;)e=e.slice(0,-1);return t.inArray(e.slice(-1),n.lastCharacter.noEllipsis)<0&&(e+=n.ellipsis),e}function s(t){return{width:t.innerWidth(),height:t.innerHeight()}}function a(t,e){t.innerText?t.innerText=e:t.nodeValue?t.nodeValue=e:t.textContent&&(t.textContent=e)}function l(t){return t.innerText?t.innerText:t.nodeValue?t.nodeValue:t.textContent?t.textContent:""}function u(t){do{t=t.previousSibling}while(t&&1!==t.nodeType&&3!==t.nodeType);return t}function c(e,n,i){var o,r=e&&e[0];if(r){if(!i){if(3===r.nodeType)return r;if(t.trim(e.text()))return c(e.contents().last(),n)}for(o=u(r);!o;){if((e=e.parent()).is(n)||!e.length)return!1;o=u(e[0])}if(o)return c(t(o),n)}return!1}if(!t.fn.dotdotdot){t.fn.dotdotdot=function(e){if(0==this.length)return t.fn.dotdotdot.debug('No element found for "'+this.selector+'".'),this;if(this.length>1)return this.each((function(){t(this).dotdotdot(e)}));var i=this;i.data("dotdotdot")&&i.trigger("destroy.dot"),i.data("dotdotdot-style",i.attr("style")||""),i.css("word-wrap","break-word"),"nowrap"===i.css("white-space")&&i.css("white-space","normal"),i.bind_events=function(){return i.bind("update.dot",(function(e,s){e.preventDefault(),e.stopPropagation(),a.maxHeight="number"==typeof a.height?a.height:function(t){for(var e=t.innerHeight(),n=["paddingTop","paddingBottom"],i=0,o=n.length;i<o;i++){var r=parseInt(t.css(n[i]),10);isNaN(r)&&(r=0),e-=r}return e}(i),a.maxHeight+=a.tolerance,void 0!==s&&(("string"==typeof s||s instanceof HTMLElement)&&(s=t("<div />").append(s).contents()),s instanceof t&&(r=s)),(p=i.wrapInner('<div class="dotdotdot" />').children()).contents().detach().end().append(r.clone(!0)).find("br").replaceWith("  <br />  ").end().css({height:"auto",width:"auto",border:"none",padding:0,margin:0});var u=!1,c=!1;return l.afterElement&&((u=l.afterElement.clone(!0)).show(),l.afterElement.detach()),o(p,a)&&(c="children"==a.wrap?function(t,e,n){var i=t.children(),r=!1;t.empty();for(var s=0,a=i.length;s<a;s++){var l=i.eq(s);if(t.append(l),n&&t.append(n),o(t,e)){l.remove(),r=!0;break}n&&n.detach()}return r}(p,a,u):n(p,i,p,a,u)),p.replaceWith(p.contents()),p=null,t.isFunction(a.callback)&&a.callback.call(i[0],c,r),l.isTruncated=c,c})).bind("isTruncated.dot",(function(t,e){return t.preventDefault(),t.stopPropagation(),"function"==typeof e&&e.call(i[0],l.isTruncated),l.isTruncated})).bind("originalContent.dot",(function(t,e){return t.preventDefault(),t.stopPropagation(),"function"==typeof e&&e.call(i[0],r),r})).bind("destroy.dot",(function(t){t.preventDefault(),t.stopPropagation(),i.unwatch().unbind_events().contents().detach().end().append(r).attr("style",i.data("dotdotdot-style")||"").data("dotdotdot",!1)})),i},i.unbind_events=function(){return i.unbind(".dot"),i},i.watch=function(){if(i.unwatch(),"window"==a.watch){var e=t(window),n=e.width(),o=e.height();e.bind("resize.dot"+l.dotId,(function(){n==e.width()&&o==e.height()&&a.windowResizeFix||(n=e.width(),o=e.height(),c&&clearInterval(c),c=setTimeout((function(){i.trigger("update.dot")}),100))}))}else u=s(i),c=setInterval((function(){if(i.is(":visible")){var t=s(i);u.width==t.width&&u.height==t.height||(i.trigger("update.dot"),u=t)}}),500);return i},i.unwatch=function(){return t(window).unbind("resize.dot"+l.dotId),c&&clearInterval(c),i};var r=i.contents(),a=t.extend(!0,{},t.fn.dotdotdot.defaults,e),l={},u={},c=null,p=null;return a.lastCharacter.remove instanceof Array||(a.lastCharacter.remove=t.fn.dotdotdot.defaultArrays.lastCharacter.remove),a.lastCharacter.noEllipsis instanceof Array||(a.lastCharacter.noEllipsis=t.fn.dotdotdot.defaultArrays.lastCharacter.noEllipsis),l.afterElement=function(e,n){return!!e&&("string"==typeof e?!!(e=t(e,n)).length&&e:!!e.jquery&&e)}(a.after,i),l.isTruncated=!1,l.dotId=d++,i.data("dotdotdot",!0).bind_events().trigger("update.dot"),a.watch&&i.watch(),i},t.fn.dotdotdot.defaults={ellipsis:"... ",wrap:"word",fallbackToLetter:!0,lastCharacter:{},tolerance:0,callback:null,after:null,height:null,watch:!1,windowResizeFix:!0},t.fn.dotdotdot.defaultArrays={lastCharacter:{remove:[" ","　",",",";",".","!","?"],noEllipsis:[]}},t.fn.dotdotdot.debug=function(t){};var d=1,p=t.fn.html;t.fn.html=function(e){return null!=e&&!t.isFunction(e)&&this.data("dotdotdot")?this.trigger("update",[e]):p.apply(this,arguments)};var h=t.fn.text;t.fn.text=function(e){return null!=e&&!t.isFunction(e)&&this.data("dotdotdot")?(e=t("<div />").text(e).html(),this.trigger("update",[e])):h.apply(this,arguments)}}}(jQuery),function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t=t||self).cssVars=e()}(this,(function(){function t(){return(t=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(t[i]=n[i])}return t}).apply(this,arguments)}function e(t){function e(){return!("<"===(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"").trim().charAt(0))}function n(t,e){r.onError(t,s[e],e)}function i(t,e){var n=r.onSuccess(t,s[e],e);t=!1===n?"":n||t,a[e]=t,-1===a.indexOf(null)&&r.onComplete(a)}var o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r={mimeType:o.mimeType||null,onBeforeSend:o.onBeforeSend||Function.prototype,onSuccess:o.onSuccess||Function.prototype,onError:o.onError||Function.prototype,onComplete:o.onComplete||Function.prototype},s=Array.isArray(t)?t:[t],a=Array.apply(null,Array(s.length)).map((function(t){return null})),l=document.createElement("a");s.forEach((function(t,o){if(l.setAttribute("href",t),l.href=String(l.href),Boolean(document.all&&!window.atob)&&l.host.split(":")[0]!==location.host.split(":")[0])if(l.protocol===location.protocol){var s=new XDomainRequest;s.open("GET",t),s.timeout=0,s.onprogress=Function.prototype,s.ontimeout=Function.prototype,s.onload=function(){e(s.responseText)?i(s.responseText,o):n(s,o)},s.onerror=function(t){n(s,o)},setTimeout((function(){s.send()}),0)}else console.warn("Internet Explorer 9 Cross-Origin (CORS) requests must use the same protocol (".concat(t,")")),n(null,o);else{var a=new XMLHttpRequest;a.open("GET",t),r.mimeType&&a.overrideMimeType&&a.overrideMimeType(r.mimeType),r.onBeforeSend(a,t,o),a.onreadystatechange=function(){4===a.readyState&&(200===a.status&&e(a.responseText)?i(a.responseText,o):n(a,o))},a.send()}}))}function n(t){function n(){if(-1===u.indexOf(null)){var t=u.join("");a.onComplete(t,u,l)}}function o(t,i,o,s){var l=a.onSuccess(t,o,s);!function t(n,i,o,s){var l=arguments.length>4&&void 0!==arguments[4]?arguments[4]:[],u=arguments.length>5&&void 0!==arguments[5]?arguments[5]:[],c=r(n,o,u);c.rules.length?e(c.absoluteUrls,{onBeforeSend:function(t,e,n){a.onBeforeSend(t,i,e)},onSuccess:function(t,e,n){var o=a.onSuccess(t,i,e),s=r(t=!1===o?"":o||t,e,u);return s.rules.forEach((function(e,n){t=t.replace(e,s.absoluteRules[n])})),t},onError:function(e,r,a){l.push({xhr:e,url:r}),u.push(c.rules[a]),t(n,i,o,s,l,u)},onComplete:function(e){e.forEach((function(t,e){n=n.replace(c.rules[e],t)})),t(n,i,o,s,l,u)}}):s(n,l)}(t=void 0!==l&&!1===Boolean(l)?"":l||t,o,s,(function(t,e){null===u[i]&&(e.forEach((function(t){return a.onError(t.xhr,o,t.url)})),!a.filter||a.filter.test(t)?u[i]=t:u[i]="",n())}))}function r(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[],o={};return o.rules=(t.replace(s.cssComments,"").match(s.cssImports)||[]).filter((function(t){return-1===n.indexOf(t)})),o.urls=o.rules.map((function(t){return t.replace(s.cssImports,"$1")})),o.absoluteUrls=o.urls.map((function(t){return i(t,e)})),o.absoluteRules=o.rules.map((function(t,n){var r=o.urls[n],s=i(o.absoluteUrls[n],e);return t.replace(r,s)})),o}var s={cssComments:/\/\*[\s\S]+?\*\//g,cssImports:/(?:@import\s*)(?:url\(\s*)?(?:['"])([^'"]*)(?:['"])(?:\s*\))?(?:[^;]*;)/g},a={rootElement:t.rootElement||document,include:t.include||'style,link[rel="stylesheet"]',exclude:t.exclude||null,filter:t.filter||null,useCSSOM:t.useCSSOM||!1,onBeforeSend:t.onBeforeSend||Function.prototype,onSuccess:t.onSuccess||Function.prototype,onError:t.onError||Function.prototype,onComplete:t.onComplete||Function.prototype},l=Array.apply(null,a.rootElement.querySelectorAll(a.include)).filter((function(t){return e=t,n=a.exclude,!(e.matches||e.matchesSelector||e.webkitMatchesSelector||e.mozMatchesSelector||e.msMatchesSelector||e.oMatchesSelector).call(e,n);var e,n})),u=Array.apply(null,Array(l.length)).map((function(t){return null}));l.length?l.forEach((function(t,r){var s=t.getAttribute("href"),l=t.getAttribute("rel"),c="LINK"===t.nodeName&&s&&l&&"stylesheet"===l.toLowerCase(),d="STYLE"===t.nodeName;if(c)e(s,{mimeType:"text/css",onBeforeSend:function(e,n,i){a.onBeforeSend(e,t,n)},onSuccess:function(e,n,a){var l=i(s,location.href);o(e,r,t,l)},onError:function(e,i,o){u[r]="",a.onError(e,t,i),n()}});else if(d){var p=t.textContent;a.useCSSOM&&(p=Array.apply(null,t.sheet.cssRules).map((function(t){return t.cssText})).join("")),o(p,r,t,location.href)}else u[r]="",n()})):a.onComplete("",[])}function i(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:location.href,n=document.implementation.createHTMLDocument(""),i=n.createElement("base"),o=n.createElement("a");return n.head.appendChild(i),n.body.appendChild(o),i.href=e,o.href=t,o.href}function o(t,e,n){t instanceof RegExp&&(t=r(t,n)),e instanceof RegExp&&(e=r(e,n));var i=s(t,e,n);return i&&{start:i[0],end:i[1],pre:n.slice(0,i[0]),body:n.slice(i[0]+t.length,i[1]),post:n.slice(i[1]+e.length)}}function r(t,e){var n=e.match(t);return n?n[0]:null}function s(t,e,n){var i,o,r,s,a,l=n.indexOf(t),u=n.indexOf(e,l+1),c=l;if(l>=0&&u>0){for(i=[],r=n.length;c>=0&&!a;)c==l?(i.push(c),l=n.indexOf(t,c+1)):1==i.length?a=[i.pop(),u]:((o=i.pop())<r&&(r=o,s=u),u=n.indexOf(e,c+1)),c=l<u&&l>=0?l:u;i.length&&(a=[r,s])}return a}function a(e){var n,i,o=t({},{fixNestedCalc:!0,onlyVars:!1,persist:!1,preserve:!1,variables:{},onWarning:function(){}},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{}),r=o.persist?h.dom:h.temp=JSON.parse(JSON.stringify(h.dom)),s=function(e){function n(t){throw new Error("CSS parse error: ".concat(t))}function i(t){var n=t.exec(e);if(n)return e=e.slice(n[0].length),n}function o(){return i(/^{\s*/)}function r(){return i(/^}/)}function s(){i(/^\s*/)}function a(){if(s(),"/"===e[0]&&"*"===e[1]){for(var t=2;e[t]&&("*"!==e[t]||"/"!==e[t+1]);)t++;if(!e[t])return n("end of comment is missing");var i=e.slice(2,t);return e=e.slice(t+2),{type:"comment",comment:i}}}function l(){for(var t,e=[];t=a();)e.push(t);return v.removeComments?[]:e}function u(){for(s();"}"===e[0];)n("extra closing bracket");var t=i(/^(("(?:\\"|[^"])*"|'(?:\\'|[^'])*'|[^{])+)/);if(t)return t[0].trim().replace(/\/\*([^*]|[\r\n]|(\*+([^*\/]|[\r\n])))*\*\/+/g,"").replace(/"(?:\\"|[^"])*"|'(?:\\'|[^'])*'/g,(function(t){return t.replace(/,/g,"‌")})).split(/\s*(?![^(]*\)),\s*/).map((function(t){return t.replace(/\u200C/g,",")}))}function d(){i(/^([;\s]*)+/);var t=/\/\*[^*]*\*+([^\/*][^*]*\*+)*\//g,e=i(/^(\*?[-#\/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/);if(e){if(e=e[0].trim(),!i(/^:\s*/))return n("property missing ':'");var o=i(/^((?:\/\*.*?\*\/|'(?:\\'|.)*?'|"(?:\\"|.)*?"|\((\s*'(?:\\'|.)*?'|"(?:\\"|.)*?"|[^)]*?)\s*\)|[^};])+)/),r={type:"declaration",property:e.replace(t,""),value:o?o[0].replace(t,"").trim():""};return i(/^[;\s]*/),r}}function p(){if(!o())return n("missing '{'");for(var t,e=l();t=d();)e.push(t),e=e.concat(l());return r()?e:n("missing '}'")}function h(){s();for(var t,e=[];t=i(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/);)e.push(t[1]),i(/^,\s*/);if(e.length)return{type:"keyframe",values:e,declarations:p()}}function f(){if(s(),"@"===e[0]){var t=function(){var t=i(/^@([-\w]+)?keyframes\s*/);if(t){var e=t[1];if(!(t=i(/^([-\w]+)\s*/)))return n("@keyframes missing name");var s,a=t[1];if(!o())return n("@keyframes missing '{'");for(var u=l();s=h();)u.push(s),u=u.concat(l());return r()?{type:"keyframes",name:a,vendor:e,keyframes:u}:n("@keyframes missing '}'")}}()||function(){var t=i(/^@supports *([^{]+)/);if(t)return{type:"supports",supports:t[1].trim(),rules:g()}}()||function(){if(i(/^@host\s*/))return{type:"host",rules:g()}}()||function(){var t=i(/^@media *([^{]+)/);if(t)return{type:"media",media:t[1].trim(),rules:g()}}()||function(){var t=i(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/);if(t)return{type:"custom-media",name:t[1].trim(),media:t[2].trim()}}()||function(){if(i(/^@page */))return{type:"page",selectors:u()||[],declarations:p()}}()||function(){var t=i(/^@([-\w]+)?document *([^{]+)/);if(t)return{type:"document",document:t[2].trim(),vendor:t[1]?t[1].trim():null,rules:g()}}()||function(){if(i(/^@font-face\s*/))return{type:"font-face",declarations:p()}}()||function(){var t=i(/^@(import|charset|namespace)\s*([^;]+);/);if(t)return{type:t[1],name:t[2].trim()}}();return t&&v.onlyVars?(t.declarations?t.declarations.some((function(t){return/var\(/.test(t.value)})):(t.keyframes||t.rules||[]).some((function(t){return(t.declarations||[]).some((function(t){return/var\(/.test(t.value)}))})))?t:{}:t}}function m(){if(v.onlyVars){var t=c("{","}",e);if(t){var i=-1!==t.pre.indexOf(":root")&&/--\S*\s*:/.test(t.body),o=/var\(/.test(t.body);if(!i&&!o)return e=e.slice(t.end+1),{}}}var r=u()||[],s=v.onlyVars?p().filter((function(t){var e=r.some((function(t){return-1!==t.indexOf(":root")}))&&/^--\S/.test(t.property),n=/var\(/.test(t.value);return e||n})):p();return r.length||n("selector missing"),{type:"rule",selectors:r,declarations:s}}function g(t){if(!t&&!o())return n("missing '{'");for(var i,s=l();e.length&&(t||"}"!==e[0])&&(i=f()||m());)i.type&&s.push(i),s=s.concat(l());return t||r()?s:n("missing '}'")}var v=t({},{onlyVars:!1,removeComments:!1},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{});return{type:"stylesheet",stylesheet:{rules:g(!0),errors:[]}}}(e,{onlyVars:o.onlyVars});if(s.stylesheet.rules.forEach((function(t){var e=[];if("rule"===t.type&&1===t.selectors.length&&":root"===t.selectors[0]&&(t.declarations.forEach((function(t,n){var i=t.property,o=t.value;i&&0===i.indexOf(d)&&(r[i]=o,e.push(n))})),!o.preserve))for(var n=e.length-1;n>=0;n--)t.declarations.splice(e[n],1)})),Object.keys(h.user).forEach((function(t){r[t]=h.user[t]})),Object.keys(o.variables).length){var a={declarations:[],selectors:[":root"],type:"rule"};Object.keys(o.variables).forEach((function(t){var e="--".concat(t.replace(/^-+/,"")),n=o.variables[t];o.persist&&(h.user[e]=n),r[e]!==n&&(r[e]=n,a.declarations.push({type:"declaration",property:e,value:n}))})),o.preserve&&a.declarations.length&&s.stylesheet.rules.push(a)}return function t(e,n){e.rules.forEach((function(i){i.rules?t(i,n):i.keyframes?i.keyframes.forEach((function(t){"keyframe"===t.type&&n(t.declarations,i)})):i.declarations&&n(i.declarations,e)}))}(s.stylesheet,(function(t,e){for(var n,i,s,a=0;a<t.length;a++)s=(n=t[a]).value,"declaration"===n.type&&s&&-1!==s.indexOf(p+"(")&&(i=l(s,r,o))!==n.value&&(o.preserve?(t.splice(a,0,{type:n.type,property:n.property,value:i}),a++):n.value=i)})),o.fixNestedCalc&&(n=s.stylesheet.rules,i=/(-[a-z]+-)?calc\(/,n.forEach((function(t){t.declarations&&t.declarations.forEach((function(t){for(var e=t.value,n="";i.test(e);){var o=c("calc(",")",e||"");for(e=e.slice(o.end);i.test(o.body);){var r=c(i,")",o.body);o.body="".concat(r.pre,"(").concat(r.body,")").concat(r.post)}n+="".concat(o.pre,"calc(").concat(o.body),n+=i.test(e)?"":")".concat(o.post)}t.value=n||t.value}))}))),function(t){function e(t){for(var e="",r=0;r<t.length;r++){var s=t[r];i&&i(s);var a=o[s.type](s);a&&(e+=a,a.length&&s.selectors&&(e+=n))}return e}var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",i=arguments.length>2?arguments[2]:void 0,o={charset:function(t){return"@charset "+t.name+";"},comment:function(t){return 0===t.comment.indexOf("__CSSVARSPONYFILL")?"/*"+t.comment+"*/":""},"custom-media":function(t){return"@custom-media "+t.name+" "+t.media+";"},declaration:function(t){return t.property+":"+t.value+";"},document:function(t){return"@"+(t.vendor||"")+"document "+t.document+"{"+e(t.rules)+"}"},"font-face":function(t){return"@font-face{"+e(t.declarations)+"}"},host:function(t){return"@host{"+e(t.rules)+"}"},import:function(t){return"@import "+t.name+";"},keyframe:function(t){return t.values.join(",")+"{"+e(t.declarations)+"}"},keyframes:function(t){return"@"+(t.vendor||"")+"keyframes "+t.name+"{"+e(t.keyframes)+"}"},media:function(t){return"@media "+t.media+"{"+e(t.rules)+"}"},namespace:function(t){return"@namespace "+t.name+";"},page:function(t){return"@page "+(t.selectors.length?t.selectors.join(", "):"")+"{"+e(t.declarations)+"}"},rule:function(t){var n=t.declarations;if(n.length)return t.selectors.join(",")+"{"+e(n)+"}"},supports:function(t){return"@supports "+t.supports+"{"+e(t.rules)+"}"}};return e(t.stylesheet.rules)}(s)}function l(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},i=arguments.length>3?arguments[3]:void 0;if(-1===t.indexOf("var("))return t;var o=c("(",")",t),r="CSS transform warning:";return o?"var"===o.pre.slice(-3)?0===o.body.trim().length?(n.onWarning("".concat(r," var() must contain a non-whitespace string")),t):o.pre.slice(0,-3)+function(t){var o=t.split(",")[0].replace(/[\s\n\t]/g,""),s=(t.match(/(?:\s*,\s*){1}(.*)?/)||[])[1],a=e.hasOwnProperty(o)?String(e[o]):void 0,u=a||(s?String(s):void 0),c=i||t;return a||n.onWarning("".concat(r,' variable "').concat(o,'" is undefined')),u&&"undefined"!==u&&u.length>0?l(u,e,n,c):"var(".concat(c,")")}(o.body)+l(o.post,e,n):o.pre+"(".concat(l(o.body,e,n),")")+l(o.post,e,n):(-1!==t.indexOf("var(")&&n.onWarning("".concat(r,' missing closing ")" in the value "').concat(t,'"')),t)}function u(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:location.href,n=document.implementation.createHTMLDocument(""),i=n.createElement("base"),o=n.createElement("a");return n.head.appendChild(i),n.body.appendChild(o),i.href=e,o.href=t,o.href}var c=o;o.range=s;var d="--",p="var",h={dom:{},temp:{},user:{}},f="css-vars-ponyfill",m="undefined"!=typeof window,g=m&&window.CSS&&window.CSS.supports&&window.CSS.supports("(--a: 0)"),v={rootElement:m?document:null,include:"style,link[rel=stylesheet]",exclude:"",fixNestedCalc:!0,onlyLegacy:!0,onlyVars:!1,preserve:!1,shadowDOM:!1,silent:!1,updateDOM:!0,updateURLs:!0,variables:{},watch:null,onBeforeSend:function(){},onSuccess:function(){},onWarning:function(){},onError:function(){},onComplete:function(){}},y={cssComments:/\/\*[\s\S]+?\*\//g,cssKeyframes:/@(?:-\w*-)?keyframes/,cssRootRules:/(?::root\s*{\s*[^}]*})/g,cssUrls:/url\((?!['"]?(?:data|http|\/\/):)['"]?([^'")]*)['"]?\)/g,cssVars:/(?:(?::root\s*{\s*[^;]*;*\s*)|(?:var\(\s*))(--[^:)]+)(?:\s*[:)])/},w=null,b=!1;return function e(){function i(t,e,n,i){s.silent||console.error("".concat(t,"\n"),e),s.onError(t,e,n,i)}function o(t){s.silent||console.warn(t),s.onWarning(t)}var r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},s=t({},v,r),l=f;if(s.exclude="#".concat(l)+(s.exclude?",".concat(s.exclude):""),m)if("loading"!==document.readyState){var c=s.shadowDOM||s.rootElement.shadowRoot||s.rootElement.host;if(g&&s.onlyLegacy){if(s.updateDOM){var d=s.rootElement.host||(s.rootElement===document?document.documentElement:s.rootElement);Object.keys(s.variables).forEach((function(t){var e="--".concat(t.replace(/^-+/,"")),n=s.variables[t];d.style.setProperty(e,n)}))}}else c&&!b?n({rootElement:v.rootElement,include:v.include,exclude:s.exclude,onSuccess:function(t,e,n){return(t.match(y.cssRootRules)||[]).join("")||!1},onComplete:function(t,n,i){a(t,{persist:!0}),b=!0,e(s)}}):(s.watch?function(t,n){if(window.MutationObserver){var i=function(t){return"LINK"===t.tagName&&-1!==(t.getAttribute("rel")||"").indexOf("stylesheet")},o=function(t){return"STYLE"===t.tagName&&(!n||t.id!==n)},r=null;w&&w.disconnect(),t.watch=v.watch,(w=new MutationObserver((function(n){var s=!1;n.forEach((function(n){if("attributes"===n.type)s=i(n.target)||o(n.target);else if("childList"===n.type){var a=Array.apply(null,n.addedNodes),l=Array.apply(null,n.removedNodes);s=[].concat(a,l).some((function(t){var e=i(t)&&!t.disabled,n=o(t)&&!t.disabled&&y.cssVars.test(t.textContent);return e||n}))}s&&(clearTimeout(r),r=setTimeout((function(){e(t)}),1))}))}))).observe(document.documentElement,{attributes:!0,attributeFilter:["disabled","href"],childList:!0,subtree:!0})}}(s,l):!1===s.watch&&w&&w.disconnect(),n({rootElement:s.rootElement,include:s.include,exclude:s.exclude,filter:s.onlyVars?y.cssVars:null,onBeforeSend:s.onBeforeSend,onSuccess:function(t,e,n){var i=s.onSuccess(t,e,n);return t=void 0!==i&&!1===Boolean(i)?"":i||t,s.updateURLs&&(t.replace(y.cssComments,"").match(y.cssUrls)||[]).forEach((function(e){var i=e.replace(y.cssUrls,"$1"),o=u(i,n);t=t.replace(e,e.replace(i,o))})),t},onError:function(t,e,n){var o=t.responseURL||u(n,location.href),r=t.statusText?"(".concat(t.statusText,")"):"Unspecified Error"+(0===t.status?" (possibly CORS related)":"");i("CSS XHR Error: ".concat(o," ").concat(t.status," ").concat(r),e,t,o)},onComplete:function(n,r,u){var c=null;n=r.map((function(t,e){return y.cssVars.test(t)?t:"/*__CSSVARSPONYFILL-".concat(e,"__*/")})).join("");try{n=a(n,{fixNestedCalc:s.fixNestedCalc,onlyVars:s.onlyVars,persist:s.updateDOM,preserve:s.preserve,variables:s.variables,onWarning:o});var d=y.cssKeyframes.test(n);if(n=n.replace(/\/\*__CSSVARSPONYFILL-(\d+)__\*\//g,(function(t,e){return r[e]})),s.updateDOM&&u&&u.length){var p=u[u.length-1];(c=s.rootElement.querySelector("#".concat(l))||document.createElement("style")).setAttribute("id",l),c.textContent!==n&&(c.textContent=n),p.nextSibling!==c&&p.parentNode&&p.parentNode.insertBefore(c,p.nextSibling),d&&function(t){var e=["animation-name","-moz-animation-name","-webkit-animation-name"].filter((function(t){return getComputedStyle(document.body)[t]}))[0];if(e){for(var n=t.getElementsByTagName("*"),i=[],o=0,r=n.length;o<r;o++){var s=n[o];"none"!==getComputedStyle(s)[e]&&(s.style[e]+="__CSSVARSPONYFILL-KEYFRAMES__",i.push(s))}document.body.offsetHeight;for(var a=0,l=i.length;a<l;a++){var u=i[a].style;u[e]=u[e].replace("__CSSVARSPONYFILL-KEYFRAMES__","")}}}(s.rootElement)}}catch(t){var f=!1;r.forEach((function(t,e){try{t=a(t,s)}catch(t){var n=u[e-0];f=!0,i(t.message,n)}})),f||i(t.message||t)}if(s.shadowDOM)for(var m,g=[s.rootElement].concat(function(t){return function(t){if(Array.isArray(t)){for(var e=0,n=new Array(t.length);e<t.length;e++)n[e]=t[e];return n}}(t)||function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}(s.rootElement.querySelectorAll("*"))),v=0;m=g[v];++v)m.shadowRoot&&m.shadowRoot.querySelector("style")&&e(t({},s,{rootElement:m.shadowRoot,variables:h.dom}));s.onComplete(n,c,JSON.parse(JSON.stringify(s.updateDOM?h.dom:h.temp)))}}))}else document.addEventListener("DOMContentLoaded",(function t(n){e(r),document.removeEventListener("DOMContentLoaded",t)}))}})),
/*! jQuery UI - v1.12.1 - 2020-02-11
* http://jqueryui.com
* Includes: focusable.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */
//function(t){"function"==typeof define&&define.amd?define(["jquery"],t):t(jQuery)}((function(t){t.ui=t.ui||{},t.ui.version="1.12.1",
/*!
 * jQuery UI Focusable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */
//t.ui.focusable=function(e,n){var i,o,r,s,a,l=e.nodeName.toLowerCase();return"area"===l?(o=(i=e.parentNode).name,!(!e.href||!o||"map"!==i.nodeName.toLowerCase())&&((r=t("img[usemap='#"+o+"']")).length>0&&r.is(":visible"))):(/^(input|select|textarea|button|object)$/.test(l)?(s=!e.disabled)&&(a=t(e).closest("fieldset")[0])&&(s=!a.disabled):s="a"===l&&e.href||n,s&&t(e).is(":visible")&&function(t){for(var e=t.css("visibility");"inherit"===e;)e=(t=t.parent()).css("visibility");return"hidden"!==e}(t(e)))},t.extend(t.expr[":"],{focusable:function(e){return t.ui.focusable(e,null!=t.attr(e,"tabindex"))}}),t.ui.focusable})),
/*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2006, 2014 Klaus Hartl
 * Released under the MIT license
 */
//function(t){"function"==typeof define&&define.amd?define(["jquery"],t):"object"==typeof exports?module.exports=t(require("jquery")):t(jQuery)}((function(t){function e(t){return s.raw?t:encodeURIComponent(t)}function n(t){return s.raw?t:decodeURIComponent(t)}function i(t){return e(s.json?JSON.stringify(t):String(t))}function o(e,n){var i=s.raw?e:function(t){0===t.indexOf('"')&&(t=t.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return t=decodeURIComponent(t.replace(r," ")),s.json?JSON.parse(t):t}catch(t){}}(e);return t.isFunction(n)?n(i):i}var r=/\+/g,s=t.cookie=function(r,a,l){if(arguments.length>1&&!t.isFunction(a)){if("number"==typeof(l=t.extend({},s.defaults,l)).expires){var u=l.expires,c=l.expires=new Date;c.setMilliseconds(c.getMilliseconds()+864e5*u)}return document.cookie=[e(r),"=",i(a),l.expires?"; expires="+l.expires.toUTCString():"",l.path?"; path="+l.path:"",l.domain?"; domain="+l.domain:"",l.secure?"; secure":""].join("")}for(var d=r?void 0:{},p=document.cookie?document.cookie.split("; "):[],h=0,f=p.length;h<f;h++){var m=p[h].split("="),g=n(m.shift()),v=m.join("=");if(r===g){d=o(v,a);break}r||void 0===(v=o(v))||(d[g]=v)}return d};s.defaults={},t.removeCookie=function(e,n){return t.cookie(e,"",t.extend({},n,{expires:-1})),!t.cookie(e)}})),
/*!
 * Masonry PACKAGED v4.2.2
 * Cascading grid layout library
 * https://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */
//function(t,e){"function"==typeof define&&define.amd?define("jquery-bridget/jquery-bridget",["jquery"],(function(n){return e(t,n)})):"object"==typeof module&&module.exports?module.exports=e(t,require("jquery")):t.jQueryBridget=e(t,t.jQuery)}(window,(function(t,e){function n(n,r,a){(a=a||e||t.jQuery)&&(r.prototype.option||(r.prototype.option=function(t){a.isPlainObject(t)&&(this.options=a.extend(!0,this.options,t))}),a.fn[n]=function(t){return"string"==typeof t?function(t,e,i){var o,r="$()."+n+'("'+e+'")';return t.each((function(t,l){var u=a.data(l,n);if(u){var c=u[e];if(c&&"_"!=e.charAt(0)){var d=c.apply(u,i);o=void 0===o?d:o}else s(r+" is not a valid method")}else s(n+" not initialized. Cannot call methods, i.e. "+r)})),void 0!==o?o:t}(this,t,o.call(arguments,1)):(function(t,e){t.each((function(t,i){var o=a.data(i,n);o?(o.option(e),o._init()):(o=new r(i,e),a.data(i,n,o))}))}(this,t),this)},i(a))}function i(t){!t||t&&t.bridget||(t.bridget=n)}var o=Array.prototype.slice,r=t.console,s=void 0===r?function(){}:function(t){r.error(t)};return i(e||t.jQuery),n})),function(t,e){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",e):"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}("undefined"!=typeof window?window:this,(function(){function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var n=this._events=this._events||{},i=n[t]=n[t]||[];return-1==i.indexOf(e)&&i.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var n=this._onceEvents=this._onceEvents||{};return(n[t]=n[t]||{})[e]=!0,this}},e.off=function(t,e){var n=this._events&&this._events[t];if(n&&n.length){var i=n.indexOf(e);return-1!=i&&n.splice(i,1),this}},e.emitEvent=function(t,e){var n=this._events&&this._events[t];if(n&&n.length){n=n.slice(0),e=e||[];for(var i=this._onceEvents&&this._onceEvents[t],o=0;o<n.length;o++){var r=n[o];i&&i[r]&&(this.off(t,r),delete i[r]),r.apply(this,e)}return this}},e.allOff=function(){delete this._events,delete this._onceEvents},t})),function(t,e){"function"==typeof define&&define.amd?define("get-size/get-size",e):"object"==typeof module&&module.exports?module.exports=e():t.getSize=e()}(window,(function(){function t(t){var e=parseFloat(t);return-1==t.indexOf("%")&&!isNaN(e)&&e}function e(t){var e=getComputedStyle(t);return e||r("Style returned "+e+". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"),e}function n(){if(!l){l=!0;var n=document.createElement("div");n.style.width="200px",n.style.padding="1px 2px 3px 4px",n.style.borderStyle="solid",n.style.borderWidth="1px 2px 3px 4px",n.style.boxSizing="border-box";var r=document.body||document.documentElement;r.appendChild(n);var s=e(n);o=200==Math.round(t(s.width)),i.isBoxSizeOuter=o,r.removeChild(n)}}function i(i){if(n(),"string"==typeof i&&(i=document.querySelector(i)),i&&"object"==typeof i&&i.nodeType){var r=e(i);if("none"==r.display)return function(){for(var t={width:0,height:0,innerWidth:0,innerHeight:0,outerWidth:0,outerHeight:0},e=0;a>e;e++)t[s[e]]=0;return t}();var l={};l.width=i.offsetWidth,l.height=i.offsetHeight;for(var u=l.isBorderBox="border-box"==r.boxSizing,c=0;a>c;c++){var d=s[c],p=r[d],h=parseFloat(p);l[d]=isNaN(h)?0:h}var f=l.paddingLeft+l.paddingRight,m=l.paddingTop+l.paddingBottom,g=l.marginLeft+l.marginRight,v=l.marginTop+l.marginBottom,y=l.borderLeftWidth+l.borderRightWidth,w=l.borderTopWidth+l.borderBottomWidth,b=u&&o,x=t(r.width);!1!==x&&(l.width=x+(b?0:f+y));var _=t(r.height);return!1!==_&&(l.height=_+(b?0:m+w)),l.innerWidth=l.width-(f+y),l.innerHeight=l.height-(m+w),l.outerWidth=l.width+g,l.outerHeight=l.height+v,l}}var o,r="undefined"==typeof console?function(){}:function(t){console.error(t)},s=["paddingLeft","paddingRight","paddingTop","paddingBottom","marginLeft","marginRight","marginTop","marginBottom","borderLeftWidth","borderRightWidth","borderTopWidth","borderBottomWidth"],a=s.length,l=!1;return i})),function(t,e){"function"==typeof define&&define.amd?define("desandro-matches-selector/matches-selector",e):"object"==typeof module&&module.exports?module.exports=e():t.matchesSelector=e()}(window,(function(){var t=function(){var t=window.Element.prototype;if(t.matches)return"matches";if(t.matchesSelector)return"matchesSelector";for(var e=["webkit","moz","ms","o"],n=0;n<e.length;n++){var i=e[n]+"MatchesSelector";if(t[i])return i}}();return function(e,n){return e[t](n)}})),function(t,e){"function"==typeof define&&define.amd?define("fizzy-ui-utils/utils",["desandro-matches-selector/matches-selector"],(function(n){return e(t,n)})):"object"==typeof module&&module.exports?module.exports=e(t,require("desandro-matches-selector")):t.fizzyUIUtils=e(t,t.matchesSelector)}(window,(function(t,e){var n={extend:function(t,e){for(var n in e)t[n]=e[n];return t},modulo:function(t,e){return(t%e+e)%e}},i=Array.prototype.slice;n.makeArray=function(t){return Array.isArray(t)?t:null==t?[]:"object"==typeof t&&"number"==typeof t.length?i.call(t):[t]},n.removeFrom=function(t,e){var n=t.indexOf(e);-1!=n&&t.splice(n,1)},n.getParent=function(t,n){for(;t.parentNode&&t!=document.body;)if(t=t.parentNode,e(t,n))return t},n.getQueryElement=function(t){return"string"==typeof t?document.querySelector(t):t},n.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},n.filterFindElements=function(t,i){t=n.makeArray(t);var o=[];return t.forEach((function(t){if(t instanceof HTMLElement){if(!i)return void o.push(t);e(t,i)&&o.push(t);for(var n=t.querySelectorAll(i),r=0;r<n.length;r++)o.push(n[r])}})),o},n.debounceMethod=function(t,e,n){n=n||100;var i=t.prototype[e],o=e+"Timeout";t.prototype[e]=function(){var t=this[o];clearTimeout(t);var e=arguments,r=this;this[o]=setTimeout((function(){i.apply(r,e),delete r[o]}),n)}},n.docReady=function(t){var e=document.readyState;"complete"==e||"interactive"==e?setTimeout(t):document.addEventListener("DOMContentLoaded",t)},n.toDashed=function(t){return t.replace(/(.)([A-Z])/g,(function(t,e,n){return e+"-"+n})).toLowerCase()};var o=t.console;return n.htmlInit=function(e,i){n.docReady((function(){var r=n.toDashed(i),s="data-"+r,a=document.querySelectorAll("["+s+"]"),l=document.querySelectorAll(".js-"+r),u=n.makeArray(a).concat(n.makeArray(l)),c=s+"-options",d=t.jQuery;u.forEach((function(t){var n,r=t.getAttribute(s)||t.getAttribute(c);try{n=r&&JSON.parse(r)}catch(e){return void(o&&o.error("Error parsing "+s+" on "+t.className+": "+e))}var a=new e(t,n);d&&d.data(t,i,a)}))}))},n})),function(t,e){"function"==typeof define&&define.amd?define("outlayer/item",["ev-emitter/ev-emitter","get-size/get-size"],e):"object"==typeof module&&module.exports?module.exports=e(require("ev-emitter"),require("get-size")):(t.Outlayer={},t.Outlayer.Item=e(t.EvEmitter,t.getSize))}(window,(function(t,e){function n(t,e){t&&(this.element=t,this.layout=e,this.position={x:0,y:0},this._create())}var i=document.documentElement.style,o="string"==typeof i.transition?"transition":"WebkitTransition",r="string"==typeof i.transform?"transform":"WebkitTransform",s={WebkitTransition:"webkitTransitionEnd",transition:"transitionend"}[o],a={transform:r,transition:o,transitionDuration:o+"Duration",transitionProperty:o+"Property",transitionDelay:o+"Delay"},l=n.prototype=Object.create(t.prototype);l.constructor=n,l._create=function(){this._transn={ingProperties:{},clean:{},onEnd:{}},this.css({position:"absolute"})},l.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},l.getSize=function(){this.size=e(this.element)},l.css=function(t){var e=this.element.style;for(var n in t)e[a[n]||n]=t[n]},l.getPosition=function(){var t=getComputedStyle(this.element),e=this.layout._getOption("originLeft"),n=this.layout._getOption("originTop"),i=t[e?"left":"right"],o=t[n?"top":"bottom"],r=parseFloat(i),s=parseFloat(o),a=this.layout.size;-1!=i.indexOf("%")&&(r=r/100*a.width),-1!=o.indexOf("%")&&(s=s/100*a.height),r=isNaN(r)?0:r,s=isNaN(s)?0:s,r-=e?a.paddingLeft:a.paddingRight,s-=n?a.paddingTop:a.paddingBottom,this.position.x=r,this.position.y=s},l.layoutPosition=function(){var t=this.layout.size,e={},n=this.layout._getOption("originLeft"),i=this.layout._getOption("originTop"),o=n?"paddingLeft":"paddingRight",r=n?"left":"right",s=n?"right":"left",a=this.position.x+t[o];e[r]=this.getXValue(a),e[s]="";var l=i?"paddingTop":"paddingBottom",u=i?"top":"bottom",c=i?"bottom":"top",d=this.position.y+t[l];e[u]=this.getYValue(d),e[c]="",this.css(e),this.emitEvent("layout",[this])},l.getXValue=function(t){var e=this.layout._getOption("horizontal");return this.layout.options.percentPosition&&!e?t/this.layout.size.width*100+"%":t+"px"},l.getYValue=function(t){var e=this.layout._getOption("horizontal");return this.layout.options.percentPosition&&e?t/this.layout.size.height*100+"%":t+"px"},l._transitionTo=function(t,e){this.getPosition();var n=this.position.x,i=this.position.y,o=t==this.position.x&&e==this.position.y;if(this.setPosition(t,e),!o||this.isTransitioning){var r=t-n,s=e-i,a={};a.transform=this.getTranslate(r,s),this.transition({to:a,onTransitionEnd:{transform:this.layoutPosition},isCleaning:!0})}else this.layoutPosition()},l.getTranslate=function(t,e){return"translate3d("+(t=this.layout._getOption("originLeft")?t:-t)+"px, "+(e=this.layout._getOption("originTop")?e:-e)+"px, 0)"},l.goTo=function(t,e){this.setPosition(t,e),this.layoutPosition()},l.moveTo=l._transitionTo,l.setPosition=function(t,e){this.position.x=parseFloat(t),this.position.y=parseFloat(e)},l._nonTransition=function(t){for(var e in this.css(t.to),t.isCleaning&&this._removeStyles(t.to),t.onTransitionEnd)t.onTransitionEnd[e].call(this)},l.transition=function(t){if(parseFloat(this.layout.options.transitionDuration)){var e=this._transn;for(var n in t.onTransitionEnd)e.onEnd[n]=t.onTransitionEnd[n];for(n in t.to)e.ingProperties[n]=!0,t.isCleaning&&(e.clean[n]=!0);t.from&&(this.css(t.from),this.element.offsetHeight),this.enableTransition(t.to),this.css(t.to),this.isTransitioning=!0}else this._nonTransition(t)};var u="opacity,"+function(t){return t.replace(/([A-Z])/g,(function(t){return"-"+t.toLowerCase()}))}(r);l.enableTransition=function(){if(!this.isTransitioning){var t=this.layout.options.transitionDuration;t="number"==typeof t?t+"ms":t,this.css({transitionProperty:u,transitionDuration:t,transitionDelay:this.staggerDelay||0}),this.element.addEventListener(s,this,!1)}},l.onwebkitTransitionEnd=function(t){this.ontransitionend(t)},l.onotransitionend=function(t){this.ontransitionend(t)};var c={"-webkit-transform":"transform"};l.ontransitionend=function(t){if(t.target===this.element){var e=this._transn,n=c[t.propertyName]||t.propertyName;delete e.ingProperties[n],function(t){for(var e in t)return!1;return!0}(e.ingProperties)&&this.disableTransition(),n in e.clean&&(this.element.style[t.propertyName]="",delete e.clean[n]),n in e.onEnd&&(e.onEnd[n].call(this),delete e.onEnd[n]),this.emitEvent("transitionEnd",[this])}},l.disableTransition=function(){this.removeTransitionStyles(),this.element.removeEventListener(s,this,!1),this.isTransitioning=!1},l._removeStyles=function(t){var e={};for(var n in t)e[n]="";this.css(e)};var d={transitionProperty:"",transitionDuration:"",transitionDelay:""};return l.removeTransitionStyles=function(){this.css(d)},l.stagger=function(t){t=isNaN(t)?0:t,this.staggerDelay=t+"ms"},l.removeElem=function(){this.element.parentNode.removeChild(this.element),this.css({display:""}),this.emitEvent("remove",[this])},l.remove=function(){return o&&parseFloat(this.layout.options.transitionDuration)?(this.once("transitionEnd",(function(){this.removeElem()})),void this.hide()):void this.removeElem()},l.reveal=function(){delete this.isHidden,this.css({display:""});var t=this.layout.options,e={};e[this.getHideRevealTransitionEndProperty("visibleStyle")]=this.onRevealTransitionEnd,this.transition({from:t.hiddenStyle,to:t.visibleStyle,isCleaning:!0,onTransitionEnd:e})},l.onRevealTransitionEnd=function(){this.isHidden||this.emitEvent("reveal")},l.getHideRevealTransitionEndProperty=function(t){var e=this.layout.options[t];if(e.opacity)return"opacity";for(var n in e)return n},l.hide=function(){this.isHidden=!0,this.css({display:""});var t=this.layout.options,e={};e[this.getHideRevealTransitionEndProperty("hiddenStyle")]=this.onHideTransitionEnd,this.transition({from:t.visibleStyle,to:t.hiddenStyle,isCleaning:!0,onTransitionEnd:e})},l.onHideTransitionEnd=function(){this.isHidden&&(this.css({display:"none"}),this.emitEvent("hide"))},l.destroy=function(){this.css({position:"",left:"",right:"",top:"",bottom:"",transition:"",transform:""})},n})),function(t,e){"function"==typeof define&&define.amd?define("outlayer/outlayer",["ev-emitter/ev-emitter","get-size/get-size","fizzy-ui-utils/utils","./item"],(function(n,i,o,r){return e(t,n,i,o,r)})):"object"==typeof module&&module.exports?module.exports=e(t,require("ev-emitter"),require("get-size"),require("fizzy-ui-utils"),require("./item")):t.Outlayer=e(t,t.EvEmitter,t.getSize,t.fizzyUIUtils,t.Outlayer.Item)}(window,(function(t,e,n,i,o){function r(t,e){var n=i.getQueryElement(t);if(n){this.element=n,l&&(this.$element=l(this.element)),this.options=i.extend({},this.constructor.defaults),this.option(e);var o=++c;this.element.outlayerGUID=o,d[o]=this,this._create(),this._getOption("initLayout")&&this.layout()}else a&&a.error("Bad element for "+this.constructor.namespace+": "+(n||t))}function s(t){function e(){t.apply(this,arguments)}return e.prototype=Object.create(t.prototype),e.prototype.constructor=e,e}var a=t.console,l=t.jQuery,u=function(){},c=0,d={};r.namespace="outlayer",r.Item=o,r.defaults={containerStyle:{position:"relative"},initLayout:!0,originLeft:!0,originTop:!0,resize:!0,resizeContainer:!0,transitionDuration:"0.4s",hiddenStyle:{opacity:0,transform:"scale(0.001)"},visibleStyle:{opacity:1,transform:"scale(1)"}};var p=r.prototype;i.extend(p,e.prototype),p.option=function(t){i.extend(this.options,t)},p._getOption=function(t){var e=this.constructor.compatOptions[t];return e&&void 0!==this.options[e]?this.options[e]:this.options[t]},r.compatOptions={initLayout:"isInitLayout",horizontal:"isHorizontal",layoutInstant:"isLayoutInstant",originLeft:"isOriginLeft",originTop:"isOriginTop",resize:"isResizeBound",resizeContainer:"isResizingContainer"},p._create=function(){this.reloadItems(),this.stamps=[],this.stamp(this.options.stamp),i.extend(this.element.style,this.options.containerStyle),this._getOption("resize")&&this.bindResize()},p.reloadItems=function(){this.items=this._itemize(this.element.children)},p._itemize=function(t){for(var e=this._filterFindItemElements(t),n=this.constructor.Item,i=[],o=0;o<e.length;o++){var r=new n(e[o],this);i.push(r)}return i},p._filterFindItemElements=function(t){return i.filterFindElements(t,this.options.itemSelector)},p.getItemElements=function(){return this.items.map((function(t){return t.element}))},p.layout=function(){this._resetLayout(),this._manageStamps();var t=this._getOption("layoutInstant"),e=void 0!==t?t:!this._isLayoutInited;this.layoutItems(this.items,e),this._isLayoutInited=!0},p._init=p.layout,p._resetLayout=function(){this.getSize()},p.getSize=function(){this.size=n(this.element)},p._getMeasurement=function(t,e){var i,o=this.options[t];o?("string"==typeof o?i=this.element.querySelector(o):o instanceof HTMLElement&&(i=o),this[t]=i?n(i)[e]:o):this[t]=0},p.layoutItems=function(t,e){t=this._getItemsForLayout(t),this._layoutItems(t,e),this._postLayout()},p._getItemsForLayout=function(t){return t.filter((function(t){return!t.isIgnored}))},p._layoutItems=function(t,e){if(this._emitCompleteOnItems("layout",t),t&&t.length){var n=[];t.forEach((function(t){var i=this._getItemLayoutPosition(t);i.item=t,i.isInstant=e||t.isLayoutInstant,n.push(i)}),this),this._processLayoutQueue(n)}},p._getItemLayoutPosition=function(){return{x:0,y:0}},p._processLayoutQueue=function(t){this.updateStagger(),t.forEach((function(t,e){this._positionItem(t.item,t.x,t.y,t.isInstant,e)}),this)},p.updateStagger=function(){var t=this.options.stagger;return null==t?void(this.stagger=0):(this.stagger=function(t){if("number"==typeof t)return t;var e=t.match(/(^\d*\.?\d*)(\w*)/),n=e&&e[1],i=e&&e[2];return n.length?(n=parseFloat(n))*(h[i]||1):0}(t),this.stagger)},p._positionItem=function(t,e,n,i,o){i?t.goTo(e,n):(t.stagger(o*this.stagger),t.moveTo(e,n))},p._postLayout=function(){this.resizeContainer()},p.resizeContainer=function(){if(this._getOption("resizeContainer")){var t=this._getContainerSize();t&&(this._setContainerMeasure(t.width,!0),this._setContainerMeasure(t.height,!1))}},p._getContainerSize=u,p._setContainerMeasure=function(t,e){if(void 0!==t){var n=this.size;n.isBorderBox&&(t+=e?n.paddingLeft+n.paddingRight+n.borderLeftWidth+n.borderRightWidth:n.paddingBottom+n.paddingTop+n.borderTopWidth+n.borderBottomWidth),t=Math.max(t,0),this.element.style[e?"width":"height"]=t+"px"}},p._emitCompleteOnItems=function(t,e){function n(){o.dispatchEvent(t+"Complete",null,[e])}function i(){++s==r&&n()}var o=this,r=e.length;if(e&&r){var s=0;e.forEach((function(e){e.once(t,i)}))}else n()},p.dispatchEvent=function(t,e,n){var i=e?[e].concat(n):n;if(this.emitEvent(t,i),l)if(this.$element=this.$element||l(this.element),e){var o=l.Event(e);o.type=t,this.$element.trigger(o,n)}else this.$element.trigger(t,n)},p.ignore=function(t){var e=this.getItem(t);e&&(e.isIgnored=!0)},p.unignore=function(t){var e=this.getItem(t);e&&delete e.isIgnored},p.stamp=function(t){(t=this._find(t))&&(this.stamps=this.stamps.concat(t),t.forEach(this.ignore,this))},p.unstamp=function(t){(t=this._find(t))&&t.forEach((function(t){i.removeFrom(this.stamps,t),this.unignore(t)}),this)},p._find=function(t){return t?("string"==typeof t&&(t=this.element.querySelectorAll(t)),t=i.makeArray(t)):void 0},p._manageStamps=function(){this.stamps&&this.stamps.length&&(this._getBoundingRect(),this.stamps.forEach(this._manageStamp,this))},p._getBoundingRect=function(){var t=this.element.getBoundingClientRect(),e=this.size;this._boundingRect={left:t.left+e.paddingLeft+e.borderLeftWidth,top:t.top+e.paddingTop+e.borderTopWidth,right:t.right-(e.paddingRight+e.borderRightWidth),bottom:t.bottom-(e.paddingBottom+e.borderBottomWidth)}},p._manageStamp=u,p._getElementOffset=function(t){var e=t.getBoundingClientRect(),i=this._boundingRect,o=n(t);return{left:e.left-i.left-o.marginLeft,top:e.top-i.top-o.marginTop,right:i.right-e.right-o.marginRight,bottom:i.bottom-e.bottom-o.marginBottom}},p.handleEvent=i.handleEvent,p.bindResize=function(){t.addEventListener("resize",this),this.isResizeBound=!0},p.unbindResize=function(){t.removeEventListener("resize",this),this.isResizeBound=!1},p.onresize=function(){this.resize()},i.debounceMethod(r,"onresize",100),p.resize=function(){this.isResizeBound&&this.needsResizeLayout()&&this.layout()},p.needsResizeLayout=function(){var t=n(this.element);return this.size&&t&&t.innerWidth!==this.size.innerWidth},p.addItems=function(t){var e=this._itemize(t);return e.length&&(this.items=this.items.concat(e)),e},p.appended=function(t){var e=this.addItems(t);e.length&&(this.layoutItems(e,!0),this.reveal(e))},p.prepended=function(t){var e=this._itemize(t);if(e.length){var n=this.items.slice(0);this.items=e.concat(n),this._resetLayout(),this._manageStamps(),this.layoutItems(e,!0),this.reveal(e),this.layoutItems(n)}},p.reveal=function(t){if(this._emitCompleteOnItems("reveal",t),t&&t.length){var e=this.updateStagger();t.forEach((function(t,n){t.stagger(n*e),t.reveal()}))}},p.hide=function(t){if(this._emitCompleteOnItems("hide",t),t&&t.length){var e=this.updateStagger();t.forEach((function(t,n){t.stagger(n*e),t.hide()}))}},p.revealItemElements=function(t){var e=this.getItems(t);this.reveal(e)},p.hideItemElements=function(t){var e=this.getItems(t);this.hide(e)},p.getItem=function(t){for(var e=0;e<this.items.length;e++){var n=this.items[e];if(n.element==t)return n}},p.getItems=function(t){t=i.makeArray(t);var e=[];return t.forEach((function(t){var n=this.getItem(t);n&&e.push(n)}),this),e},p.remove=function(t){var e=this.getItems(t);this._emitCompleteOnItems("remove",e),e&&e.length&&e.forEach((function(t){t.remove(),i.removeFrom(this.items,t)}),this)},p.destroy=function(){var t=this.element.style;t.height="",t.position="",t.width="",this.items.forEach((function(t){t.destroy()})),this.unbindResize();var e=this.element.outlayerGUID;delete d[e],delete this.element.outlayerGUID,l&&l.removeData(this.element,this.constructor.namespace)},r.data=function(t){var e=(t=i.getQueryElement(t))&&t.outlayerGUID;return e&&d[e]},r.create=function(t,e){var n=s(r);return n.defaults=i.extend({},r.defaults),i.extend(n.defaults,e),n.compatOptions=i.extend({},r.compatOptions),n.namespace=t,n.data=r.data,n.Item=s(o),i.htmlInit(n,t),l&&l.bridget&&l.bridget(t,n),n};var h={ms:1,s:1e3};return r.Item=o,r})),function(t,e){"function"==typeof define&&define.amd?define(["outlayer/outlayer","get-size/get-size"],e):"object"==typeof module&&module.exports?module.exports=e(require("outlayer"),require("get-size")):t.Masonry=e(t.Outlayer,t.getSize)}(window,(function(t,e){var n=t.create("masonry");n.compatOptions.fitWidth="isFitWidth";var i=n.prototype;return i._resetLayout=function(){this.getSize(),this._getMeasurement("columnWidth","outerWidth"),this._getMeasurement("gutter","outerWidth"),this.measureColumns(),this.colYs=[];for(var t=0;t<this.cols;t++)this.colYs.push(0);this.maxY=0,this.horizontalColIndex=0},i.measureColumns=function(){if(this.getContainerWidth(),!this.columnWidth){var t=this.items[0],n=t&&t.element;this.columnWidth=n&&e(n).outerWidth||this.containerWidth}var i=this.columnWidth+=this.gutter,o=this.containerWidth+this.gutter,r=o/i,s=i-o%i;r=Math[s&&1>s?"round":"floor"](r),this.cols=Math.max(r,1)},i.getContainerWidth=function(){var t=this._getOption("fitWidth")?this.element.parentNode:this.element,n=e(t);this.containerWidth=n&&n.innerWidth},i._getItemLayoutPosition=function(t){t.getSize();var e=t.size.outerWidth%this.columnWidth,n=Math[e&&1>e?"round":"ceil"](t.size.outerWidth/this.columnWidth);n=Math.min(n,this.cols);for(var i=this[this.options.horizontalOrder?"_getHorizontalColPosition":"_getTopColPosition"](n,t),o={x:this.columnWidth*i.col,y:i.y},r=i.y+t.size.outerHeight,s=n+i.col,a=i.col;s>a;a++)this.colYs[a]=r;return o},i._getTopColPosition=function(t){var e=this._getTopColGroup(t),n=Math.min.apply(Math,e);return{col:e.indexOf(n),y:n}},i._getTopColGroup=function(t){if(2>t)return this.colYs;for(var e=[],n=this.cols+1-t,i=0;n>i;i++)e[i]=this._getColGroupY(i,t);return e},i._getColGroupY=function(t,e){if(2>e)return this.colYs[t];var n=this.colYs.slice(t,t+e);return Math.max.apply(Math,n)},i._getHorizontalColPosition=function(t,e){var n=this.horizontalColIndex%this.cols;n=t>1&&n+t>this.cols?0:n;var i=e.size.outerWidth&&e.size.outerHeight;return this.horizontalColIndex=i?n+t:this.horizontalColIndex,{col:n,y:this._getColGroupY(n,t)}},i._manageStamp=function(t){var n=e(t),i=this._getElementOffset(t),o=this._getOption("originLeft")?i.left:i.right,r=o+n.outerWidth,s=Math.floor(o/this.columnWidth);s=Math.max(0,s);var a=Math.floor(r/this.columnWidth);a-=r%this.columnWidth?0:1,a=Math.min(this.cols-1,a);for(var l=(this._getOption("originTop")?i.top:i.bottom)+n.outerHeight,u=s;a>=u;u++)this.colYs[u]=Math.max(l,this.colYs[u])},i._getContainerSize=function(){this.maxY=Math.max.apply(Math,this.colYs);var t={height:this.maxY};return this._getOption("fitWidth")&&(t.width=this._getContainerFitWidth()),t},i._getContainerFitWidth=function(){for(var t=0,e=this.cols;--e&&0===this.colYs[e];)t++;return(this.cols-t)*this.columnWidth-this.gutter},i.needsResizeLayout=function(){var t=this.containerWidth;return this.getContainerWidth(),t!=this.containerWidth},n})),function(t,e,n){function i(t,e){return typeof t===e}function o(){return"function"!=typeof e.createElement?e.createElement(arguments[0]):b?e.createElementNS.call(e,"http://www.w3.org/2000/svg",arguments[0]):e.createElement.apply(e,arguments)}function r(t,n,i,r){var s,a,l,u,c="modernizr",d=o("div"),p=function(){var t=e.body;return t||((t=o(b?"svg":"body")).fake=!0),t}();if(parseInt(i,10))for(;i--;)(l=o("div")).id=r?r[i]:c+(i+1),d.appendChild(l);return(s=o("style")).type="text/css",s.id="s"+c,(p.fake?p:d).appendChild(s),p.appendChild(d),s.styleSheet?s.styleSheet.cssText=t:s.appendChild(e.createTextNode(t)),d.id=c,p.fake&&(p.style.background="",p.style.overflow="hidden",u=w.style.overflow,w.style.overflow="hidden",w.appendChild(p)),a=n(d,t),p.fake?(p.parentNode.removeChild(p),w.style.overflow=u,w.offsetHeight):d.parentNode.removeChild(d),!!a}function s(t,e){return!!~(""+t).indexOf(e)}function a(t){return t.replace(/([a-z])-([a-z])/g,(function(t,e,n){return e+n.toUpperCase()})).replace(/^-/,"")}function l(t,e){return function(){return t.apply(e,arguments)}}function u(t){return t.replace(/([A-Z])/g,(function(t,e){return"-"+e.toLowerCase()})).replace(/^ms-/,"-ms-")}function c(e,n,i){var o;if("getComputedStyle"in t){o=getComputedStyle.call(t,e,n);var r=t.console;if(null!==o)i&&(o=o.getPropertyValue(i));else if(r){r[r.error?"error":"log"].call(r,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else o=!n&&e.currentStyle&&e.currentStyle[i];return o}function d(e,i){var o=e.length;if("CSS"in t&&"supports"in t.CSS){for(;o--;)if(t.CSS.supports(u(e[o]),i))return!0;return!1}if("CSSSupportsRule"in t){for(var s=[];o--;)s.push("("+u(e[o])+":"+i+")");return r("@supports ("+(s=s.join(" or "))+") { #modernizr { position: absolute; } }",(function(t){return"absolute"==c(t,null,"position")}))}return n}function p(t,e,r,l){function u(){p&&(delete E.style,delete E.modElem)}if(l=!i(l,"undefined")&&l,!i(r,"undefined")){var c=d(t,r);if(!i(c,"undefined"))return c}for(var p,h,f,m,g,v=["modernizr","tspan","samp"];!E.style&&v.length;)p=!0,E.modElem=o(v.shift()),E.style=E.modElem.style;for(f=t.length,h=0;f>h;h++)if(m=t[h],g=E.style[m],s(m,"-")&&(m=a(m)),E.style[m]!==n){if(l||i(r,"undefined"))return u(),"pfx"!=e||m;try{E.style[m]=r}catch(t){}if(E.style[m]!=g)return u(),"pfx"!=e||m}return u(),!1}function h(t,e,n,o,r){var s=t.charAt(0).toUpperCase()+t.slice(1),a=(t+" "+k.join(s+" ")+s).split(" ");return i(e,"string")||i(e,"undefined")?p(a,e,o,r):function(t,e,n){var o;for(var r in t)if(t[r]in e)return!1===n?t[r]:i(o=e[t[r]],"function")?l(o,n||e):o;return!1}(a=(t+" "+T.join(s+" ")+s).split(" "),e,n)}function f(t,e,i){return h(t,n,n,e,i)}var m=[],g=[],v={_version:"3.5.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(t,e){var n=this;setTimeout((function(){e(n[t])}),0)},addTest:function(t,e,n){g.push({name:t,fn:e,options:n})},addAsyncTest:function(t){g.push({name:null,fn:t})}},y=function(){};y.prototype=v,(y=new y).addTest("localstorage",(function(){var t="modernizr";try{return localStorage.setItem(t,t),localStorage.removeItem(t),!0}catch(t){return!1}}));var w=e.documentElement,b="svg"===w.nodeName.toLowerCase(),x=v._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];v._prefixes=x;var _=v.testStyles=r;y.addTest("touchevents",(function(){var n;if("ontouchstart"in t||t.DocumentTouch&&e instanceof DocumentTouch)n=!0;else{var i=["@media (",x.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");_(i,(function(t){n=9===t.offsetTop}))}return n}));var C="Moz O ms Webkit",k=v._config.usePrefixes?C.split(" "):[];v._cssomPrefixes=k;var T=v._config.usePrefixes?C.toLowerCase().split(" "):[];v._domPrefixes=T;var S={elem:o("modernizr")};y._q.push((function(){delete S.elem}));var E={style:S.elem.style};y._q.unshift((function(){delete E.style})),v.testAllProps=h,v.testAllProps=f,y.addTest("cssgridlegacy",f("grid-columns","10px",!0)),y.addTest("cssgrid",f("grid-template-rows","none",!0)),function(){var t,e,n,o,r,s;for(var a in g)if(g.hasOwnProperty(a)){if(t=[],(e=g[a]).name&&(t.push(e.name.toLowerCase()),e.options&&e.options.aliases&&e.options.aliases.length))for(n=0;n<e.options.aliases.length;n++)t.push(e.options.aliases[n].toLowerCase());for(o=i(e.fn,"function")?e.fn():e.fn,r=0;r<t.length;r++)1===(s=t[r].split(".")).length?y[s[0]]=o:(!y[s[0]]||y[s[0]]instanceof Boolean||(y[s[0]]=new Boolean(y[s[0]])),y[s[0]][s[1]]=o),m.push((o?"":"no-")+s.join("-"))}}(),function(t){var e=w.className,n=y._config.classPrefix||"";if(b&&(e=e.baseVal),y._config.enableJSClass){var i=new RegExp("(^|\\s)"+n+"no-js(\\s|$)");e=e.replace(i,"$1"+n+"js$2")}y._config.enableClasses&&(e+=" "+n+t.join(" "+n),b?w.className.baseVal=e:w.className=e)}(m),delete v.addTest,delete v.addAsyncTest;for(var I=0;I<y._q.length;I++)y._q[I]();t.Modernizr=y}(window,document),function(){var t,e=function(t,e){return function(){return t.apply(e,arguments)}},n=function(t,e){for(var n in e)i.call(e,n)&&(t[n]=e[n]);function o(){this.constructor=t}return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},i={}.hasOwnProperty;theme.classes.FrameworkA11y=function(){function t(){var t;(t=this).tab_forwards=null,t.focusable_items=null,t.customFocusOrder()}return t.prototype.customFocusOrder=function(){var t,e;return t=this,(e=$(".a11y--focus-trigger")).attr("tabindex","0"),$(document).on("keydown",(function(e){return t.tab_forwards=!0,9===e.which&&e.shiftKey&&(t.tab_forwards=!1),!0})),e.on("focus",(function(){var e,n;return e=$(this),t.getFocusableItems(),t.tab_forwards?(n=e.attr("data-forward-to"),$(n).is(".a11y--focus-trigger")&&(e=$(n)),n=e.attr("data-forward-to")):!1===t.tab_forwards&&(n=e.attr("data-back-to"),$(n).is(".a11y--focus-trigger")&&(e=$(n)),n=e.attr("data-back-to")),t.focus_index=t.focusable_items.index(e),t.moveFocus(n)}))},t.prototype.getFocusableItems=function(){return this,this.focusable_items=$(":focusable")},t.prototype.moveFocus=function(t){var e,n,i,o;return i=!!t,o=(e=this).focusable_items.index($(t+":visible"))>-1,n=e.tab_forwards?1:-1,i&&o?$(t).focus():i&&!o?e.tab_forwards?$(t).find(":focusable:not(.a11y--focus-trigger)").first().focus():$(t).find(":focusable:not(.a11y--focus-trigger)").last().focus():i?void 0:e.focusable_items.eq(e.focus_index+n).focus()},t}(),t=function(){function t(t,n){this.element=t,this.type=n,this.resizeListeners=e(this.resizeListeners,this),this.fillYSpace=e(this.fillYSpace,this),this.checkOverlap=e(this.checkOverlap,this),this.createOverlapDetectors=e(this.createOverlapDetectors,this),this.position=e(this.position,this),this.parent=this.element.parent(),this.left_side_border,this.right_element_width=null,this.position(),this.fillYSpace(),this.createOverlapDetectors(),this.resizeListeners()}return t.prototype.position=function(){if("center-x"===this.type)return this.element.css({"margin-left":-this.element.outerWidth()/2})},t.prototype.createOverlapDetectors=function(){if(this,"right"===this.type)return this.right_element_width=this.element.outerWidth()},t.prototype.checkOverlap=function(){var t,e;if("right"===(t=this).type&&(t.parent.removeClass("overlap"),(e=t.parent.children().eq(t.element.index()-1)).position().left+e.outerWidth()>=t.parent.outerWidth()-t.right_element_width))return t.parent.addClass("overlap")},t.prototype.fillYSpace=function(){var t,e,n;if("fill-y--dynamic"===(t=this).type)return e=t.parent.outerHeight(),n=t.parent.find(".fw--align--fill-y--fixed").outerHeight(),t.element.outerHeight(e-n)},t.prototype.resizeListeners=function(){var t;return t=this,$(window).on("resize.FrameworkAlign",(function(){return t.checkOverlap(),t.fillYSpace()})),setTimeout((function(){return t.checkOverlap()}),1)},t}(),theme.classes.FrameworkAnimation=function(){},theme.classes.FrameworkArticle=function(){function t(t){this.root=t,this.startDisqus=e(this.startDisqus,this),this.hideTagInfo=e(this.hideTagInfo,this),this.load=e(this.load,this),this.load()}return t.prototype.load=function(){var t,e,n;if(this,n=0===$(".article--tag").length,e="true"===$(".article--root").attr("data-enable-disqus"),t="true"===$(".article--root").attr("data-comments-enabled"),n&&this.hideTagInfo(),e&&t)return this.startDisqus()},t.prototype.hideTagInfo=function(){return this,$(".article--tag-info").hide()},t.prototype.startDisqus=function(){var t,e,n;return t=this,function(){return t.page.url=$(".article--root").attr("data-canonical-url"),t.page.identifier=$(".article--root").attr("data-article-id")},e=$(".article--root").attr("data-disqus-shortname"),(n=document.createElement("script")).src="https://"+e+".disqus.com/embed.js",n.setAttribute("data-timestamp",+new Date),(document.head||document.body).appendChild(n)},t}(),theme.classes.FrameworkBlog=function(){function t(t){this.root=t,this.initMasonry=e(this.initMasonry,this),this.eventListeners=e(this.eventListeners,this),this.load=e(this.load,this),this.load()}return t.prototype.load=function(){var t;if((t=this).eventListeners(),t.has_multi_columns="1"!==t.root.attr("data-columns"),!("small"===theme.utils.mqs.current_window)&&t.has_multi_columns)return t.initMasonry(),$(window).on("load",(function(){return t.initMasonry()}))},t.prototype.eventListeners=function(){var t;return t=this,$(window).on("resize.Blog",theme.utils.debounce(100,(function(){return t.has_multi_columns&&"small"!==theme.utils.mqs.current_window?t.initMasonry():$(".blog--list").masonry("destroy")})))},t.prototype.initMasonry=function(){return $(".blog--list").masonry({itemSelector:".blog--list--item",percentPosition:!0,horizontalOrder:!0,columnWidth:".blog--list--item"})},t}(),theme.classes.FrameworkCart=function(){function t(t){var n;this.root=t,this.renderDynamicCheckoutButtons=e(this.renderDynamicCheckoutButtons,this),this.updateTotals=e(this.updateTotals,this),this.updateAllHasItems=e(this.updateAllHasItems,this),this.addItem=e(this.addItem,this),this.swapInImages=e(this.swapInImages,this),this.getHtml=e(this.getHtml,this),this.updateHtml=e(this.updateHtml,this),this.htmlListener=e(this.htmlListener,this),this.updateAllHtml=e(this.updateAllHtml,this),this.updateNote=e(this.updateNote,this),this.noteTypingListener=e(this.noteTypingListener,this),this.updateQuantity=e(this.updateQuantity,this),this.clearRequests=e(this.clearRequests,this),this.removeItem=e(this.removeItem,this),this.removeButtonListener=e(this.removeButtonListener,this),this.minusButtonListener=e(this.minusButtonListener,this),this.plusButtonListener=e(this.plusButtonListener,this),this.inputBoxListener=e(this.inputBoxListener,this),this.eventListeners=e(this.eventListeners,this),this.getAjaxUrl=e(this.getAjaxUrl,this),this.getOtherCarts=e(this.getOtherCarts,this),(n=this).other_carts=n.getOtherCarts(),n.quantity_request={},n.quantity_timer={},n.total_item_count=$(".cart--external--total-items"),n.total_price=$(".cart--external--total-price"),n.view=n.root.attr("data-view"),n.getAjaxUrl(),n.updateTotals(),n.htmlListener(),n.eventListeners(),n.renderDynamicCheckoutButtons()}return t.prototype.getOtherCarts=function(){return this,$('[data-js-class="Cart"]').not(this.root)},t.prototype.getAjaxUrl=function(){var t;return(t=this).ajax_url=window.location.href,t.ajax_url=t.ajax_url.replace(window.location.hostname+window.location.pathname,window.location.hostname+theme.urls.cart),t.ajax_url=t.ajax_url.replace("#",""),t.ajax_url.indexOf("?")>=0?t.ajax_url=t.ajax_url+"&":t.ajax_url=t.ajax_url+"?",t.ajax_desktop_url=t.ajax_url+"view=ajax--desktop",t.ajax_mobile_url=t.ajax_url+"view=ajax--mobile"},t.prototype.eventListeners=function(){var t;return(t=this).inputBoxListener(),t.plusButtonListener(),t.minusButtonListener(),t.removeButtonListener(),t.noteTypingListener()},t.prototype.inputBoxListener=function(){var t,e;return(e=(t=this).root.find(".cart--quantity--input")).on("keydown",(function(t){if((t.which<48||t.which>57)&&8!==t.which&&37!==t.which&&39!==t.which&&9!==t.which)return t.preventDefault()})),e.on("keyup",(function(e){var n,i;if($(this).attr("data-loading","true"),n=$(this).closest(".cart--item").data("item-key"),t.clearRequests(n),8!==e.which||0!==$(this).val().length)return 0!==(i=theme.utils.isNaN(parseInt($(this).val()))?1:parseInt($(this).val()))?t.updateQuantity(n,i,700,(function(e){if(e)return t.updateAllHtml((function(){}))})):t.removeItem(n)}))},t.prototype.plusButtonListener=function(){var t;return(t=this).root.find(".cart--item--quantity .plus").on("click",(function(){var e,n,i;return e=$(this).prev("input"),i=theme.utils.isNaN(parseInt(e.val()))?1:parseInt(e.val())+1,e.val(i),e.attr("data-loading","true"),n=$(this).closest(".cart--item").data("item-key"),t.clearRequests(n),t.updateQuantity(n,i,700,(function(e){if(e)return t.updateAllHtml((function(){}))})),!1}))},t.prototype.minusButtonListener=function(){var t;return(t=this).root.find(".cart--item--quantity .minus").on("click",(function(){var e,n,i;return e=$(this).siblings("input"),(i=theme.utils.isNaN(parseInt(e.val()))?1:parseInt(e.val())-1)<1?(i=1,!1):(e.val(i),e.attr("data-loading","true"),n=$(this).closest(".cart--item").data("item-key"),t.clearRequests(n),t.updateQuantity(n,i,700,(function(e){if(e)return t.updateAllHtml((function(){}))})),!1)}))},t.prototype.removeButtonListener=function(){var t;return(t=this).root.find(".cart--item--remove").on("click",(function(){var e,n;return n=(e=$(this).closest(".cart--item")).data("item-key"),e.find("input").attr("data-loading","true"),t.clearRequests(n),t.removeItem(n),!1}))},t.prototype.removeItem=function(t){var e;return(e=this).updateQuantity(t,0,0,(function(t){if(t)return e.updateAllHtml((function(){}))}))},t.prototype.clearRequests=function(t){var e;if((e=this).quantity_request.item_key&&e.quantity_request.item_key.abort(),e.quantity_timer.item_key)return clearTimeout(e.quantity_timer.item_key)},t.prototype.updateQuantity=function(t,e,n,i){var o,r;return r=function(){return o.quantity_request.item_key=$.ajax({type:"POST",url:"/cart/change.js",dataType:"json",data:"quantity="+e+"&id="+t}).done((function(t,e,n){return i(!0),o.updateTotals()})).fail((function(t,e){return t.responseText&&console.log("Error - ajax update quantity",JSON.parse(t.responseText).description),i(!1)}))},(o=this).quantity_timer.item_key=setTimeout(r,n)},t.prototype.noteTypingListener=function(){var t;return(t=this).root.find(".cart--notes--textarea").on("input",(function(){return t.note_request&&t.note_request.abort(),t.note_timer&&clearTimeout(t.note_timer),t.updateNote($(this).val())}))},t.prototype.updateNote=function(t){var e,n;return n=function(){return e.note_request=$.ajax({type:"POST",url:"/cart/update.js",dataType:"json",data:{note:t}}).done((function(){return e.other_carts.trigger("update-html")})).fail((function(t,e){if(t.responseText)return console.log("Error - ajax update note",JSON.parse(t.responseText).description)}))},(e=this).note_timer=setTimeout(n,350)},t.prototype.updateAllHtml=function(t){return this,this.updateHtml(t),this.other_carts.trigger("update-html")},t.prototype.htmlListener=function(){var t;return(t=this).root.on("update-html",(function(){return t.updateHtml((function(){}))}))},t.prototype.updateHtml=function(t){var e;return(e=this).getHtml(e.view,(function(n){var i,o;return o=e.root.find(".cart--form"),i=n.find(".cart--form"),i=e.swapInImages(o,i),o.replaceWith(i),e.eventListeners(),t(),$(window).trigger("theme.cart.update-complete")}))},t.prototype.getHtml=function(t,e){var n;return this,n=this.ajax_desktop_url,"mobile"===t&&(n=this.ajax_mobile_url),$.ajax({url:n,type:"GET",dataType:"html"}).done((function(t){var n;n=$($.parseHTML(t)),e(n)})).fail((function(t,n,i){console.log("search.json Request Failed: "+n+", "+i),e(!1)}))},t.prototype.swapInImages=function(t,e){return this,e.find(".cart--item").each((function(){var n,i,o,r,s;if(s=$(this).attr("data-variant-id"),n=$(this).find(".cart--item--image"),i=e.find("[data-variant-id='"+s+"'] .cart--item--image").index(n),(r=t.find("[data-variant-id='"+s+"']").eq(i)).length>0)return o=r.find(".cart--item--image"),n.replaceWith(o)})),e},t.prototype.addItem=function(t,e){var n;return n=this,$.ajax({type:"POST",url:"/cart/add.js",dataType:"json",data:t.serialize()}).done((function(t,i,o){return e(!0),n.updateAllHasItems(1,!0),n.updateTotals()})).fail((function(t,n){return console.log("Error - ajax update quantity",JSON.parse(t.responseText).description),e(!1,JSON.parse(t.responseText).description)}))},t.prototype.updateAllHasItems=function(t,e){var n;return null==e&&(e=!1),this,n=!1,(t>0||e)&&(n=!0),this.root.attr("data-has-items",n),this.other_carts.attr("data-has-items",n)},t.prototype.updateTotals=function(){var t;return t=this,$.ajax({type:"GET",url:"/cart.js",dataType:"json"}).done((function(e,n,i){var o,r;return r=theme.utils.formatMoney(e.total_price),o=e.item_count,t.updateAllHasItems(o),t.total_price.html(r),t.total_item_count.text(o),t.updateTotalsComplete(o)})).fail((function(t,e){return console.log("Error - ajax updating totals",JSON.parse(t.responseText).description)}))},t.prototype.renderDynamicCheckoutButtons=function(){if(this,window.location.pathname===theme.urls.cart&&($(".off-canvas--right-sidebar .cart--additional-buttons").remove(),"small"===theme.utils.mqs.current_window))return $('[data-view="desktop"] .cart--additional-buttons').remove()},t}(),theme.classes.FrameworkDisclosure=function(){function t(t){var n;this.root=t,this.optionChangeCallback=e(this.optionChangeCallback,this),this.configureFormDisplay=e(this.configureFormDisplay,this),this.toggleFormDisplay=e(this.toggleFormDisplay,this),this.setOptionOnClick=e(this.setOptionOnClick,this),this.hideFormWhenFocusOut=e(this.hideFormWhenFocusOut,this),this.showFormWhenClick=e(this.showFormWhenClick,this),this.resizeListener=e(this.resizeListener,this),this.load=e(this.load,this),(n=this).current_option=n.root.find(".disclosure--current-option"),n.form=n.root.find(".disclosure--form"),n.input=n.root.find('[data-item="disclosure"]'),n.links=n.root.find(".disclosure--option-link"),n.toggle=n.root.find(".disclosure--toggle"),n.type=n.root.attr("data-type"),n.toggle_and_form_gap=8,n.window_and_form_gap=32,n.form_space_needed=n.form.height()+n.toggle_and_form_gap+n.window_and_form_gap,n.load()}return t.prototype.load=function(){var t;if((t=this).resizeListener(),t.showFormWhenClick(),t.hideFormWhenFocusOut(),t.setOptionOnClick(),t.configureFormDisplay(),"url-redirect"===t.type||"localization"===t.type)return t.optionChangeCallback()},t.prototype.resizeListener=function(){var t;return t=this,$(window).on("resize",theme.utils.debounce(100,(function(){return t.configureFormDisplay()})))},t.prototype.showFormWhenClick=function(){var t;return(t=this).toggle.on("click keydown",(function(e){var n;if("keydown"!==e.type||"Enter"===e.key)return n="true"===$(this).attr("aria-expanded"),t.toggleFormDisplay(!n)}))},t.prototype.hideFormWhenFocusOut=function(){var t;return(t=this).toggle.on("focusout",(function(e){if(0===t.root.has(e.relatedTarget).length)return t.toggleFormDisplay(!1)})),t.form.on("focusout",(function(e){var n;if(n=$(this).has(e.relatedTarget).length>0,"true"===t.toggle.attr("aria-expanded")&&!n)return t.toggleFormDisplay(!1)})),t.root.on("keydown",(function(e){if("Escape"===e.key)return t.toggleFormDisplay(!1),t.toggle.focus()}))},t.prototype.setOptionOnClick=function(){var t;return(t=this).links.on("click keydown",(function(e){var n,i;if("Enter"===e.key)t.toggle.focus();else if("keydown"===e.type)return;return i=$(this).attr("data-value"),n=$(this).text(),t.toggleFormDisplay(!1),t.current_option.text(n),t.links.attr("aria-current",!1),$(this).attr("aria-current",!0),t.input.val(i),t.input.trigger("change")}))},t.prototype.toggleFormDisplay=function(t){return this,this.toggle.attr("aria-expanded",t)},t.prototype.configureFormDisplay=function(){var t,e,n,i,o,r,s,a;return e=(s=(t=this).toggle.outerHeight())+t.toggle_and_form_gap,o=t.root.closest("[class^=off-canvas]").height()-(r=t.root.offset().top)-s,n=t.form_space_needed>o&&o<r,i=t.form_space_needed>r&&o>r,a=$(window).height()-e-t.window_and_form_gap,n?a-=o:i&&(a-=r),t.form.css("max-height",a+"px"),n?t.form.css("top","-"+(t.form.height()+t.toggle_and_form_gap)+"px"):t.form.css("top",e+"px")},t.prototype.optionChangeCallback=function(){var t;return(t=this).input.on("change",(function(){return"url-redirect"===t.type?window.location.href=$(this).val():"localization"===t.type?$(this).closest("form").submit():void 0}))},t}(),theme.classes.FrameworkFeaturedCollections=function(){function t(t){var n;this.root=t,this.resizeListeners=e(this.resizeListeners,this),this.matchImageHeights=e(this.matchImageHeights,this),(n=this).item_container=n.root.find(".featured-collections--body"),n.items=n.root.find(".featured-collections--item"),n.matchImageHeights(),n.resizeListeners()}return t.prototype.matchImageHeights=function(){return this,theme.utils.matchImageHeights(this.item_container,this.items,".featured-collections--image")},t.prototype.resizeListeners=function(){var t;return t=this,$(window).on("resize.FeaturedCollections",theme.utils.debounce(100,(function(){return t.matchImageHeights()})))},t}(),theme.classes.FrameworkFeaturedGrid=function(){function t(t){var n;this.root=t,this.resizeListeners=e(this.resizeListeners,this),this.matchImageHeights=e(this.matchImageHeights,this),(n=this).item_container=n.root.find(".featured-grid--body"),n.items=n.root.find(".featured-grid--item"),n.text_position=n.root.data("text-position"),n.matchImageHeights(),n.resizeListeners()}return t.prototype.matchImageHeights=function(){var t;if((t=this).items.find(".featured-grid--item--image, .placeholder--root").css("height","auto"),"center"!==t.text_position||"small"===theme.utils.mqs.current_window)return theme.utils.matchImageHeights(t.item_container,t.items,".featured-grid--item--image")},t.prototype.resizeListeners=function(){var t;return t=this,$(window).on("resize.FeaturedGrid",theme.utils.debounce(100,(function(){return t.matchImageHeights()})))},t}(),theme.classes.FrameworkFeaturedProduct=function(){function t(t){var n;this.root=t,this.updateVariantImage=e(this.updateVariantImage,this),this.thumbNavigation=e(this.thumbNavigation,this),this.addProductComplete=e(this.addProductComplete,this),this.addToCartListener=e(this.addToCartListener,this),this.updateVariantImage=e(this.updateVariantImage,this),this.variantSelected=e(this.variantSelected,this),this.updateVariantOnOptionChange=e(this.updateVariantOnOptionChange,this),this.load=e(this.load,this),(n=this).add_button=n.root.find(".featured-product--add-to-cart"),n.cart_form=n.root.find(".featured-product--cart-form > form"),n.compare_price=n.root.find(".featured-product--compare-price"),n.main_images=n.root.find(".featured-product--media"),n.onboarding=n.root.data("onboarding"),n.option_inputs=n.root.find('[data-item="disclosure"], [data-item="radio"]'),n.price=n.root.find(".featured-product--actual-price"),n.price_wrapper=n.root.find(".featured-product--price-wrapper"),n.smart_payment_buttons=n.root.find(".featured-product--smart-payment-buttons"),n.thumbs=n.root.find(".featured-product--thumb"),n.unavailable_variant=n.root.find(".featured-product--unavailable-variant"),n.variants=JSON.parse(n.root.find(".featured-product--json").text()).variants,n.variant_listbox=n.root.find(".featured-product--variant-select"),n.variant_sold_out=n.root.find(".featured-product--sold-out--variant"),n.load()}return t.prototype.load=function(){var t;if((t=this).addToCartListener(),t.thumbNavigation(),!1===t.onboarding&&t.variants.length>1)return t.updateVariantOnOptionChange()},t.prototype.updateVariantOnOptionChange=function(){var t;return(t=this).option_inputs.on("change",(function(){var e,n,i,o,r,s,a;for(e=t.root.find('[data-item="disclosure"], [data-item="radio"]:checked'),o=[],e.each((function(){return o.push($(this).val().trim())})),a=o.join(" / "),n=0,i=(r=t.variants).length;n<i;n++)if((s=r[n]).title===a)return t.variantSelected(s);return t.variantSelected(!1)}))},t.prototype.variantSelected=function(t){var e,n,i,o;return n=!1,(e=this).root.find(".featured-product--sold-out--product").length&&(n=!0),e.variant_sold_out.hide(),e.unavailable_variant.hide(),e.add_button.hide(),e.price_wrapper.hide(),e.variant_listbox.find("option[selected]").removeAttr("selected"),t?(t&&t.available?(e.price_wrapper.show(),e.add_button.show(),e.smart_payment_buttons.show(),e.variant_listbox.find("option[value='"+t.id+"']").attr("selected","")):n?(e.variant_sold_out.hide(),e.add_button.hide(),e.smart_payment_buttons.hide()):(e.variant_sold_out.show(),e.smart_payment_buttons.hide()),o=theme.utils.formatMoney(t.price),e.price.text(o),t.compare_at_price>t.price?(i=theme.utils.formatMoney(t.compare_at_price),e.compare_price.text(i),e.compare_price.show()):e.compare_price.hide(),t.featured_media?e.updateVariantImage(t.featured_media.id):void 0):(e.unavailable_variant.show(),e.smart_payment_buttons.hide(),!1)},t.prototype.updateVariantImage=function(t){return this,this.main_images.attr("data-active","false"),this.main_images.filter("[data-id='"+t+"']").attr("data-active","true")},t.prototype.addToCartListener=function(){var t;if((t=this).cart_form.length>0&&"drawer"===theme.settings.cart_type)return t.cart_form.on("submit",(function(){return t.cart_form.find(".error").remove(),t.add_button.attr("data-loading","true"),theme.partials.Cart.addItem($(this),(function(e,n){return e?theme.partials.Cart.updateAllHtml((function(){return t.addProductComplete()})):(t.cart_form.append("<div class='featured-product--error error'>"+n+"</div>"),t.add_button.attr("data-loading","false"))})),!1}))},t.prototype.addProductComplete=function(){return this,this.add_button.attr("data-loading","false"),$('[data-off-canvas--open="right-sidebar"]').first().trigger("click")},t.prototype.thumbNavigation=function(){var t;return(t=this).thumbs.on("keypress click",(function(e){var n,i;if(theme.utils.a11yClick(e)&&(t.root.find('.featured-product--media[data-active="true"] > *').trigger("pause-media"),n=$(this).attr("data-id"),i=t.root.find(".featured-product--media[data-id='"+n+"'] > *:not(.a11y--focus-trigger)"),t.updateVariantImage(n),"small"!==theme.utils.mqs.current_window&&i.trigger("play-media"),"image"!==i.parent().attr("data-media-type")))return i.focus()}))},t.prototype.updateVariantImage=function(t){var e;return(e=this).main_images.attr("data-active","false"),e.main_images.filter("[data-id='"+t+"']").attr("data-active","true"),e.thumbs.attr("data-active","false"),e.thumbs.filter("[data-id='"+t+"']").attr("data-active","true")},t}(),theme.classes.FrameworkFeaturedVideo=function(){function t(t){var n;this.root=t,this.hideThumbnail=e(this.hideThumbnail,this),this.playButtonListener=e(this.playButtonListener,this),this.vimeoEvents=e(this.vimeoEvents,this),this.insertVimeoPlayer=e(this.insertVimeoPlayer,this),this.youtubeEvents=e(this.youtubeEvents,this),this.youtubeReady=e(this.youtubeReady,this),this.insertYoutubePlayer=e(this.insertYoutubePlayer,this),this.insertAPIScript=e(this.insertAPIScript,this),this.playerInit=e(this.playerInit,this),this.checkAPIScriptExists=e(this.checkAPIScriptExists,this),(n=this).video_type=n.root.data("videoType"),n.video_id=n.root.data("videoId"),n.thumbnail=n.root.data("thumbnail"),n.section_id=n.root.data("sectionId"),n.youtubeVars={},n.vimeoVars={id:n.video_id,autopause:0,playsinline:0,title:0},n.thumbnail?n.playButtonListener():n.checkAPIScriptExists()}return t.prototype.checkAPIScriptExists=function(){var t;return"vimeo"===(t=this).video_type?theme.utils.vimeoScriptAdded?t.playerInit():t.insertAPIScript("https://player.vimeo.com/api/player.js"):theme.utils.youtubeScriptAdded?t.playerInit():t.insertAPIScript("https://www.youtube.com/iframe_api")},t.prototype.playerInit=function(){var t;return"vimeo"===(t=this).video_type?t.thumbnail?t.insertVimeoPlayer():($(window).on("load",(function(){return t.insertVimeoPlayer()})),t.root.on("theme:section:load",(function(){return t.insertVimeoPlayer()}))):t.thumbnail?t.insertYoutubePlayer():($(window).on("load",(function(){return t.insertYoutubePlayer()})),t.root.on("theme:section:load",(function(){return t.insertYoutubePlayer()})))},t.prototype.insertAPIScript=function(t){var e,n;return e=this,(n=document.createElement("script")).src=t,"vimeo"===e.video_type?(theme.utils.vimeoScriptAdded=!0,n.onload=function(){return e.insertVimeoPlayer()}):(theme.utils.youtubeScriptAdded=!0,$(window).on("theme.utils.youtubeAPIReady",(function(){return e.insertYoutubePlayer()}))),document.body.appendChild(n)},t.prototype.insertYoutubePlayer=function(){var t;return(t=this).thumbnail||(t.youtubeVars.playsinline=1,t.youtubeVars.fs=0,t.youtubeVars.loop=1,t.youtubeVars.playlist=t.video_id),t.player=new YT.Player("player-"+t.section_id,{videoId:t.video_id,playerVars:t.youtubeVars,events:{onReady:t.youtubeReady,onStateChange:t.youtubeEvents}})},t.prototype.youtubeReady=function(){var t;return(t=this).thumbnail||t.player.mute(),t.player.playVideo()},t.prototype.youtubeEvents=function(t){var e,n,i;if(n=this,e=t.target,n.thumbnail){if(0===t.data)return e.seekTo(0),e.pauseVideo()}else if(1===t.data)return i=e.getDuration()-e.getCurrentTime(),n.rewindTO&&clearTimeout(n.rewindTO),n.rewindTO=setTimeout((function(){e.seekTo(0)}),1e3*(i-.1))},t.prototype.insertVimeoPlayer=function(){var t;return(t=this).thumbnail||(t.vimeoVars.playsinline=1,t.vimeoVars.muted=1,t.vimeoVars.background=1,t.vimeoVars.loop=1),t.player=new Vimeo.Player("player-"+t.section_id,t.vimeoVars),t.thumbnail&&t.vimeoEvents(),t.player.play()},t.prototype.vimeoEvents=function(){var t;return(t=this).player.getDuration().then((function(e){return t.player.addCuePoint(e-.3,{})})),t.player.on("cuepoint",(function(){return t.player.setCurrentTime(0),t.player.pause()}))},t.prototype.playButtonListener=function(){var t;return(t=this).root.find(".feature-video--play svg, .feature-video--play-mobile svg").on("click",(function(){return t.checkAPIScriptExists(),t.hideThumbnail()}))},t.prototype.hideThumbnail=function(){var t;return t=this,setTimeout((function(){return t.root.find(".feature-video--header, .feature-video--thumbnail, .feature-video--play-mobile").hide()}),350)},t}(),theme.classes.FrameworkFeedbackBar=function(){function t(t){var n;this.root=t,this.load=e(this.load,this),(n=this).messages=n.root.find(".feedback-bar--message span"),n.load()}return t.prototype.load=function(){var t,e,n;if((t=this).messages.hide(),e=window.location.hash.substr(1).replace("feedback-bar--",""),(n=t.messages.filter('[data-feedback-bar--message="'+e+'"]')).length)return n.show(),setTimeout((function(){return t.root.attr("data-feedback-bar--open","true")}),200),setTimeout((function(){return t.root.attr("data-feedback-bar--open","false")}),3e3)},t}(),theme.classes.FrameworkFooter=function(){function t(t){this.root=t,this.stickyFooter=e(this.stickyFooter,this),this.addListeners=e(this.addListeners,this),this.load=e(this.load,this),this.load()}return t.prototype.load=function(){return this,this.addListeners(),this.stickyFooter()},t.prototype.addListeners=function(){var t;return t=this,$(window).on("resize",(function(){return t.stickyFooter()}))},t.prototype.stickyFooter=function(){var t;if(this,t=$(".header--root").outerHeight()+$(".main-content").outerHeight()+this.root.outerHeight(),$(window).outerHeight()>t)return $(".main-content").css({"min-height":$(window).outerHeight()-$(".header--root").outerHeight()-this.root.outerHeight()})},t}(),theme.classes.FrameworkLoadingAnimation=function(t){var e;this.root=t,(e=this).root.hasClass("tiny")?e.root.spin("tiny"):e.root.spin("small")},theme.classes.FrameworkMap=function(){function t(t){var n;this.root=t,this.buildStyles=e(this.buildStyles,this),this.buildMap=e(this.buildMap,this),this.geolocate=e(this.geolocate,this),this.loadMapsApi=e(this.loadMapsApi,this),this.load=e(this.load,this),(n=this).api_status=null,n.map_instance=null,n.key=n.root.data("api-key"),n.address=n.root.data("address"),n.theme=n.root.data("theme"),n.styles=null,n.container=n.root.find(".map--google-maps"),n.center=null,n.load()}return t.prototype.load=function(){if(this,this.container.length>0)return this.loadMapsApi()},t.prototype.loadMapsApi=function(){var t,e;return t=this,"loading"===theme.utils.google_map_api_status?e=setInterval((function(){if("loaded"===theme.utils.google_map_api_status)return t.geolocate(),clearInterval(e)}),100):void 0===window.google?(theme.utils.google_map_api_status="loading",$.getScript("https://maps.googleapis.com/maps/api/js?key="+t.key).then((function(){return t.geolocate(),theme.utils.google_map_api_status="loaded"}))):t.geolocate()},t.prototype.geolocate=function(){var t;return t=this,(new google.maps.Geocoder).geocode({address:t.address},(function(e,n){return"OK"===n?(t.center=e[0].geometry.location,t.buildStyles(),t.buildMap()):console.log("couldn't convert address with geocoder")}))},t.prototype.buildMap=function(){var t,e,n,i;return i={zoom:15,center:(t=this).center,disableDefaultUI:!0,zoomControl:!0,scrollwheel:!1,styles:t.styles},n=new google.maps.Map(t.container[0],i),e=n.getCenter(),new google.maps.Marker({map:n,position:n.getCenter()}),t.map_instance=google.maps.event.addDomListener(window,"resize",theme.utils.debounce(500,(function(){google.maps.event.trigger(n,"resize"),n.setCenter(e)})))},t.prototype.buildStyles=function(){var t;return"grayscale"===(t=this).theme?t.styles=[{elementType:"geometry",stylers:[{color:"#f5f5f5"}]},{elementType:"labels.icon",stylers:[{visibility:"off"}]},{elementType:"labels.text.fill",stylers:[{color:"#616161"}]},{elementType:"labels.text.stroke",stylers:[{color:"#f5f5f5"}]},{featureType:"administrative.land_parcel",elementType:"labels.text.fill",stylers:[{color:"#bdbdbd"}]},{featureType:"poi",elementType:"geometry",stylers:[{color:"#eeeeee"}]},{featureType:"poi",elementType:"labels.text.fill",stylers:[{color:"#757575"}]},{featureType:"poi.park",elementType:"geometry",stylers:[{color:"#e5e5e5"}]},{featureType:"poi.park",elementType:"labels.text.fill",stylers:[{color:"#9e9e9e"}]},{featureType:"road",elementType:"geometry",stylers:[{color:"#ffffff"}]},{featureType:"road.arterial",elementType:"labels.text.fill",stylers:[{color:"#757575"}]},{featureType:"road.highway",elementType:"geometry",stylers:[{color:"#dadada"}]},{featureType:"road.highway",elementType:"labels.text.fill",stylers:[{color:"#616161"}]},{featureType:"road.local",elementType:"labels.text.fill",stylers:[{color:"#9e9e9e"}]},{featureType:"transit.line",elementType:"geometry",stylers:[{color:"#e5e5e5"}]},{featureType:"transit.station",elementType:"geometry",stylers:[{color:"#eeeeee"}]},{featureType:"water",elementType:"geometry",stylers:[{color:"#c9c9c9"}]},{featureType:"water",elementType:"labels.text.fill",stylers:[{color:"#9e9e9e"}]}]:"dark"===t.theme?t.styles=[{elementType:"geometry",stylers:[{color:"#212121"}]},{elementType:"labels.icon",stylers:[{visibility:"off"}]},{elementType:"labels.text.fill",stylers:[{color:"#757575"}]},{elementType:"labels.text.stroke",stylers:[{color:"#212121"}]},{featureType:"administrative",elementType:"geometry",stylers:[{color:"#757575"}]},{featureType:"administrative.country",elementType:"labels.text.fill",stylers:[{color:"#9e9e9e"}]},{featureType:"administrative.land_parcel",stylers:[{visibility:"off"}]},{featureType:"administrative.locality",elementType:"labels.text.fill",stylers:[{color:"#bdbdbd"}]},{featureType:"poi",elementType:"labels.text.fill",stylers:[{color:"#757575"}]},{featureType:"poi.park",elementType:"geometry",stylers:[{color:"#181818"}]},{featureType:"poi.park",elementType:"labels.text.fill",stylers:[{color:"#616161"}]},{featureType:"poi.park",elementType:"labels.text.stroke",stylers:[{color:"#1b1b1b"}]},{featureType:"road",elementType:"geometry.fill",stylers:[{color:"#2c2c2c"}]},{featureType:"road",elementType:"labels.text.fill",stylers:[{color:"#8a8a8a"}]},{featureType:"road.arterial",elementType:"geometry",stylers:[{color:"#373737"}]},{featureType:"road.highway",elementType:"geometry",stylers:[{color:"#3c3c3c"}]},{featureType:"road.highway.controlled_access",elementType:"geometry",stylers:[{color:"#4e4e4e"}]},{featureType:"road.local",elementType:"labels.text.fill",stylers:[{color:"#616161"}]},{featureType:"transit",elementType:"labels.text.fill",stylers:[{color:"#757575"}]},{featureType:"water",elementType:"geometry",stylers:[{color:"#000000"}]},{featureType:"water",elementType:"labels.text.fill",stylers:[{color:"#3d3d3d"}]}]:void 0},t}(),theme.classes.FrameworkMediaQueries=function(){function t(){this.screenSizeListener=e(this.screenSizeListener,this),this.getScreenSize=e(this.getScreenSize,this),this.medium_screen=768,this.large_screen=1024,this.current_window=null,this.getScreenSize(),this.screenSizeListener()}return t.prototype.getScreenSize=function(){var t;if(t=this,window.matchMedia("only screen and (min-width: "+t.large_screen+"px)").matches){if("large"!==t.current_window)return t.current_window="large"}else if(window.matchMedia("only screen and (min-width: "+t.medium_screen+"px)").matches){if("medium"!==t.current_window)return t.current_window="medium"}else if("small"!==t.current_window)return t.current_window="small"},t.prototype.screenSizeListener=function(){var t;return t=this,$(window).on("resize",(function(){return t.getScreenSize()}))},t}(),theme.classes.FrameworkModal=function(){function t(t){var e;this.container=t,(e=this).fullscreen=!!e.container.data("modal--fullscreen"),e.container.data("modal--custom-close")?e.custom_close_button=e.container.data("modal--custom-close"):e.custom_close_button="",e.force_view=e.container.data("force-view"),e.view=e.container.data("modal--view"),e.links=e.container.find(".modal--link"),e.content=e.container.find(".modal--content"),e.window=$(".modal--window"),e.window_container=e.window.find(".modal--container"),e.mask=e.window.find(".modal--mask"),e.close_button=e.window.find(".modal--close"),e.next_button=e.window.find(".modal--next"),e.prev_button=e.window.find(".modal--prev"),e.slider=null,e.slides=null,e.main_content_window=$(".off-canvas--main-content"),e.openListeners(),e.modal_state="closed",e.nav_lock=!1}return t.prototype.openListeners=function(){var t;return(t=this).links.on("keypress.FrameworkModal, click.FrameworkModal, quick-open",(function(e){var n;return"keypress"===e.type&&!1===theme.utils.a11yClick(e)||(n=$(this),t.links.each((function(i){if($(this).is(n))return"quick-open"===e.type?t.open(i,!0):t.open(i)}))),!1}))},t.prototype.open=function(t,e){var n,i;if(null==e&&(e=!1),"closed"===(n=this).modal_state)return n.modal_state="opened",$("html").addClass("modal-open"),n.window.attr("data-modal--fullscreen",n.fullscreen),n.window.attr("data-modal--custom-close",n.custom_close_button),n.window.attr("data-modal--view",n.view),n.closeListeners(),n.positionListeners(),i=$(window).scrollTop(),n.main_content_window.css({position:"fixed",top:-i}),n.moveContentToWindow(),n.slides.length>1&&(n.next_button.show(),n.prev_button.show(),n.prevListeners(),n.nextListeners()),n.window.show(),n.window_container.show(),n.renderVideo(n.slides.eq(t)),e?(n.slides.eq(t).addClass("active"),n.position()):(n.mask.fadeIn(),n.loadModal(n.slides.eq(t),(function(){return setTimeout((function(){return n.window_container.find('input[type="text"]').focus()}),0)})))},t.prototype.moveContentToWindow=function(t){var e,n;return n=(e=this).container.find(".modal--content"),e.window_container.append(n),e.slides=e.window_container.find(".modal--content")},t.prototype.detectImageSlide=function(t){return this},t.prototype.renderVideo=function(t){var e,n,i,o,r,s;return e=this,o=(s=t.find(".responsive-video").first()).data("video"),r=e.extractVideoType(o),n=e.extractVideoId(o,r),i=e.createIframe(r,n),"vimeo"===r&&s.addClass("vimeo"),"kickstarter"===r&&s.addClass("kickstarter"),s.append(i)},t.prototype.extractVideoType=function(t){return this,/\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9_\-]+)/i.exec(t)?"youtube":/^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/.exec(t)?"vimeo":!!/^.*(kickstarter)\.com/g.exec(t)&&"kickstarter"},t.prototype.extractVideoId=function(t,e){var n,i;if(this,"youtube"===e){if(i=/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/,(n=t.match(i))&&11===n[2].length)return n[2]}else if("vimeo"===e){if(i=/^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/,n=t.match(i))return n[2]}else if("kickstarter"===e&&(i=/(?:kickstarter\.com\/projects\/)(.*)(|\?)/,n=t.match(i)))return n[1]},t.prototype.createIframe=function(t,e){return this,"youtube"===t?"<iframe src='//www.youtube.com/embed/"+e+"?autoplay=1' frameborder='0' allowfullwidth></iframe>":"vimeo"===t?"<iframe src='//player.vimeo.com/video/"+e+"?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff&amp;autoplay=1?' frameborder='0' webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>":"kickstarter"===t?"<iframe src='//www.kickstarter.com/projects/"+e+"/widget/video.html' frameborder='0' webkitallowfullwidth mozallowfullwidth allowfullwidth></iframe>":void 0},t.prototype.removeVideos=function(){return this,this.slides.find(".responsive-video").each((function(){if($(this).data("video"))return $(this).find("iframe").remove()}))},t.prototype.loadModal=function(t,e){return this,t.addClass("active"),this.position(),e&&e(),this.nav_lock=!1},t.prototype.position=function(){var t,e,n,i;if(null!=(t=this).window_container){if(e=t.content.filter(".active"),t.window_container.attr("style",""),t.positionVideoColumns(e),t.detectImageSlide(e),t.window.removeClass("fixed"),i=e.outerHeight(),e.outerWidth(),n=i+parseInt(t.window.css("padding-top"))+parseInt(t.window.css("padding-bottom")),t.fullscreen)return;return e.hasClass("type--image")&&(n=i),$(window).height()>=n&&"absolute"!==t.force_view?t.window.addClass("fixed"):($("html, body").animate({scrollTop:0},"0"),$("body,html").on("DOMMouseScroll.FrameworkModal mousewheel.FrameworkModal touchmove.FrameworkModal",(function(t){if(t.which>0||"mousewheel"===t.type||"touchmove"===t.type)return $("html,body").stop()})),t.window.removeClass("fixed"))}},t.prototype.positionVideoColumns=function(t){var e,n;if(this,t.find(".responsive-video").length>0&&(e=t.find(".fw--blocks > div").eq(0),n=t.find(".fw--blocks > div").eq(1),e.css({width:""}),n.css({width:""}),e.outerHeight()<n.outerHeight()))return e.css({width:"100%"}),n.css({width:"100%"})},t.prototype.positionListeners=function(){var t;return t=this,$(window).on("resize.FrameworkModal",(function(){return t.position()}))},t.prototype.nextListeners=function(){var t;return t=this,$(document).on("keydown.FrameworkModal",(function(e){if(39===e.keyCode)return t.next()})),t.next_button.on("click.FrameworkModal",(function(){return t.next()}))},t.prototype.next=function(){var t,e,n;if(!(t=this).nav_lock)return t.nav_lock=!0,n=t.slides.filter(".active").index(),t.slides.removeClass("active"),t.removeVideos(),e=n+1===t.slides.length?t.slides.eq(0):t.slides.eq(n+1),t.renderVideo(e),t.loadModal(e)},t.prototype.prevListeners=function(){var t;return t=this,$(document).on("keydown.FrameworkModal",(function(e){if(37===e.keyCode)return t.prev()})),t.prev_button.on("click.FrameworkModal",(function(){return t.prev()}))},t.prototype.prev=function(){var t,e,n;if(!(t=this).nav_lock)return t.nav_lock=!0,n=t.slides.filter(".active").index(),t.slides.removeClass("active"),t.removeVideos(),e=0===n?t.slides.eq(t.slides.length-1):t.slides.eq(n-1),t.renderVideo(e),t.loadModal(e)},t.prototype.closeListeners=function(){var t;return(t=this).container.on("quick-close",(function(){return t.close(!0)})),$(document).on("keydown.FrameworkModal",(function(e){if(27===e.keyCode)return t.close()})),t.mask.on("click.FrameworkModal",(function(){return t.close()})),t.window_container.on("click.FrameworkModal",(function(){return t.close()})),t.content.on("click.FrameworkModal",(function(t){return t.stopPropagation()})),t.close_button.on("click.FrameworkModal",(function(){return t.close()}))},t.prototype.close=function(t){var e,n;return null==t&&(t=!1),e=this,n=-1*parseInt(e.main_content_window.css("top")),e.container.trigger("modalClosed"),e.main_content_window.css({top:"0",position:"relative"}),$(window).scrollTop(n),e.putBackContent(),e.next_button.hide(),e.prev_button.hide(),e.window.hide(),t?(e.mask.hide(),this.window_container.empty(),e.modal_state="closed"):e.mask.fadeOut((function(){return e.window_container.empty(),e.modal_state="closed"})),$("html").removeClass("modal-open"),e.removeListeners(),$(window).trigger("FrameworkModal.afterClose")},t.prototype.putBackContent=function(){var t;return(t=this).removeVideos(),t.slides.removeClass("active").appendTo(t.container)},t.prototype.removeListeners=function(){var t;return t=this,$(document).off("keydown.FrameworkModal"),$(window).off("resize.FrameworkModal"),$("body,html").off("DOMMouseScroll.FrameworkModal mousewheel.FrameworkModal touchmove.FrameworkModal"),t.next_button.off("click.FrameworkModal"),t.prev_button.off("click.FrameworkModal"),t.close_button.off("click.FrameworkModal"),t.mask.off("click.FrameworkModal"),t.window_container.off("click.FrameworkModal")},t}(),theme.classes.FrameworkOffCanvas=function(){function t(t){var n;this.root=t,this.touchListener=e(this.touchListener,this),this.closeRight=e(this.closeRight,this),this.closeLeft=e(this.closeLeft,this),this.fadeInOverlay=e(this.fadeInOverlay,this),this.openRight=e(this.openRight,this),this.openLeft=e(this.openLeft,this),this.toggle=e(this.toggle,this),this.toggleListeners=e(this.toggleListeners,this),this.viewPortHeightListener=e(this.viewPortHeightListener,this),this.setViewPortHeight=e(this.setViewPortHeight,this),this.setState=e(this.setState,this),this.unload=e(this.unload,this),this.load=e(this.load,this),(n=this).viewport=$(".off-canvas--viewport"),n.left_sidebar=$(".off-canvas--left-sidebar"),n.right_sidebar=$(".off-canvas--right-sidebar"),n.main_content=$(".off-canvas--main-content"),n.overlay=$(".off-canvas--overlay"),n.state="closed",n.load()}return t.prototype.load=function(){var t;return(t=this).close=$(".off-canvas--close"),t.triggers=$(".off-canvas--open"),t.setViewPortHeight(),t.viewPortHeightListener(),t.toggleListeners(),t.touchListener()},t.prototype.unload=function(){var t;return(t=this).triggers.off("click"),t.overlay.add(t.close).off("click"),$(document).off("touchstart.OffCanvas"),$(document).off("touchend.OffCanvas")},t.prototype.setState=function(t){return this,this.state=t,this.root.attr("data-off-canvas--state",t)},t.prototype.setViewPortHeight=function(){return this,this.viewport.css({"min-height":$(window).height()})},t.prototype.viewPortHeightListener=function(){var t;return t=this,$(window).on("resize",(function(){return t.setViewPortHeight()}))},t.prototype.toggleListeners=function(){var t;return(t=this).triggers.on("click",(function(){return"left-sidebar"===$(this).data("off-canvas--open")?t.toggle("left-sidebar"):"right-sidebar"===$(this).data("off-canvas--open")&&t.toggle("right-sidebar"),!1})),t.overlay.add(t.close).on("click",(function(){return"left-open"===t.state?t.toggle("left-sidebar"):"right-open"===t.state?t.toggle("right-sidebar"):void 0}))},t.prototype.toggle=function(t){var e;return e=this,"left-sidebar"===t&&"closed"===e.state?e.openLeft():"left-sidebar"===t&&"left-open"===e.state?e.closeLeft():"right-sidebar"===t&&"closed"===e.state?e.openRight():"right-sidebar"===t&&"right-open"===e.state?e.closeRight():void 0},t.prototype.openLeft=function(){var t;return(t=this).setState("left-open"),t.main_content.css({position:"fixed",top:-$(window).scrollTop()}),t.left_sidebar.velocity({translateX:[0,"-100%"]},{complete:function(){return t.left_sidebar.css({position:"relative"})}}),t.fadeInOverlay()},t.prototype.openRight=function(){var t;return(t=this).setState("right-open"),t.main_content.css({position:"fixed",top:-$(window).scrollTop()}),t.right_sidebar.velocity({translateX:["-100%",0]},{complete:function(){return t.right_sidebar.css({position:"relative"})}}),t.fadeInOverlay()},t.prototype.fadeInOverlay=function(){return this,this.overlay.show(),this.overlay.velocity({opacity:"0.3"})},t.prototype.closeLeft=function(){var t,e;return"left-open"===(t=this).state&&(t.setState("closed"),e=-1*parseInt(t.main_content.css("top")),t.left_sidebar.velocity({translateX:["-100%",0]},{complete:function(){return t.left_sidebar.css({position:"absolute"}),t.main_content.css({position:"relative",top:"initial"}),$(window).scrollTop(e)}}),t.overlay.velocity("fadeOut"))},t.prototype.closeRight=function(){var t,e;return"right-open"===(t=this).state&&(t.setState("closed"),e=-1*parseInt(t.main_content.css("top")),t.right_sidebar.velocity({translateX:[0,"-100%"]},{complete:function(){return t.right_sidebar.css({position:"absolute"}),t.main_content.css({position:"relative",top:"initial"}),$(window).scrollTop(e)}}),t.overlay.velocity("fadeOut"))},t.prototype.touchListener=function(){var t,e;return t=this,!!Modernizr.touchevents&&(e={start:{},end:{}},$(document).on("touchstart.OffCanvas",(function(t){e.start.x=t.originalEvent.touches[0].clientX,e.start.y=t.originalEvent.touches[0].clientY})),$(document).on("touchend.OffCanvas",(function(n){return e.end.x=n.originalEvent.changedTouches[0].clientX,e.end.y=n.originalEvent.changedTouches[0].clientY,!(Math.abs(e.start.y-e.end.y)>30)&&(e.start.x>e.end.x+5?t.closeLeft():e.start.x<e.end.x-5?t.closeRight():void 0)})))},t}(),theme.classes.FrameworkProductModel=function(){function t(t){var n;this.root=t,this.loadModel=e(this.loadModel,this),this.loadAssets=e(this.loadAssets,this),this.eventListeners=e(this.eventListeners,this),this.load=e(this.load,this),(n=this).view=n.root.data("view"),n.key=n.root.closest("[data-id]").data("id"),n.cdn="https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui",n.load()}return t.prototype.load=function(){if(this,this.eventListeners(),!theme.utils.modelScriptAdded)return theme.utils.modelScriptAdded=!0,this.loadAssets()},t.prototype.eventListeners=function(){var t;return(t=this).root.on("model-ready",(function(){return t.loadModel()})),t.root.on("theme:section:load",(function(){return t.loadModel()})),t.root.on("pause-media",(function(){if(t.model)return t.model.pause()})),t.root.on("play-media",(function(){if(t.model)return t.model.play()})),$(window).on("resize.ProductModel",theme.utils.debounce(250,(function(){return $(".product-model--root").trigger("pause-media"),$(".product-model--root").trigger("model-ready")})))},t.prototype.loadAssets=function(){return this,theme.utils.insertStylesheet(this.cdn+".css"),theme.utils.insertScript(this.cdn+".en.js",(function(){return $(".product-model--root").trigger("model-ready")}))},t.prototype.loadModel=function(){var t;if(!(t=this).model&&!("small"===theme.utils.mqs.current_window&&"desktop"===t.view||"small"!==theme.utils.mqs.current_window&&"mobile"===t.view))return t.model=new Shopify.ModelViewerUI(t.root.find("model-viewer"))},t}(),theme.classes.FrameworkProductRecommendations=function(){function t(t){this.root=t,this.loadHoverImages=e(this.loadHoverImages,this),this.checkIfEmpty=e(this.checkIfEmpty,this),this.loadProducts=e(this.loadProducts,this),this.resizeListeners=e(this.resizeListeners,this),this.matchImageHeights=e(this.matchImageHeights,this),this.loadProducts(),this.resizeListeners()}return t.prototype.matchImageHeights=function(){var t;return(t=this).item_container=t.root.find(".product-recommendations--body"),t.items=t.root.find(".product--root"),theme.utils.matchImageHeights(t.item_container,t.items,".product--image-wrapper")},t.prototype.resizeListeners=function(){var t;return t=this,$(window).on("resize",theme.utils.debounce(100,(function(){return t.matchImageHeights()})))},t.prototype.loadProducts=function(){var t,e,n,i,o,r;return t=this,n=(i=document.getElementsByClassName("product-recommendations--root")[0]).dataset.productId,e=i.dataset.maxProducts,r=theme.urls.product_recommendations+"?section_id=framework--product-recommendations&limit="+e+"&product_id="+n,(o=new XMLHttpRequest).open("GET",r),o.onload=function(){var e;if(o.status>=200&&o.status<300)return(e=document.createElement("div")).innerHTML=o.response,i.innerHTML=e.querySelector(".product-recommendations--root").innerHTML,t.matchImageHeights(),t.checkIfEmpty(),t.loadHoverImages()},o.send()},t.prototype.checkIfEmpty=function(){var t;return this,t=!($(".product--root").length>0),$(".product-recommendations--root").attr("data-empty",t)},t.prototype.loadHoverImages=function(){return this,$('.product--root[data-hover-image="true"]').each((function(){var t;return t=$(this),theme.utils.imagesLoaded(t,(function(){return t.attr("data-hover-image","loaded")}))}))},t}(),theme.classes.FrameworkProductVideo=function(){function t(t){var n;this.root=t,this.skipVideo=e(this.skipVideo,this),this.loadYoutubeVideo=e(this.loadYoutubeVideo,this),this.loadPlyrVideo=e(this.loadPlyrVideo,this),this.loadYoutubeAsset=e(this.loadYoutubeAsset,this),this.loadPlyrAssets=e(this.loadPlyrAssets,this),this.resizeListener=e(this.resizeListener,this),this.youtubeListeners=e(this.youtubeListeners,this),this.plyrListeners=e(this.plyrListeners,this),this.load=e(this.load,this),(n=this).view=n.root.data("view"),n.type=n.root.data("type"),n.loop_enabled=n.root.data("loop-enabled"),n.load()}return t.prototype.load=function(){var t;return(t=this).resizeListener(),"youtube"===t.type?(t.id=t.root.find(".product-video").attr("id"),t.video_id=t.root.data("video-id"),t.youtubeListeners(),t.loadYoutubeAsset()):(t.plyr_cdn="https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr",t.plyrListeners(),t.loadPlyrAssets())},t.prototype.plyrListeners=function(){var t;return(t=this).root.on("plyr-video-ready",(function(){return t.loadPlyrVideo()})),t.root.on("theme:section:load",(function(){return t.loadPlyrVideo()})),t.root.on("pause-media",(function(){if(t.video)return t.video.pause()})),t.root.on("play-media",(function(){if(t.video)return t.video.play()}))},t.prototype.youtubeListeners=function(){var t;return t=this,$(window).on("theme.utils.youtubeAPIReady",(function(){return t.loadYoutubeVideo()})),t.root.on("theme:section:load",(function(){return t.loadYoutubeVideo()}))},t.prototype.resizeListener=function(){return this,$(window).on("resize.ProductVideo",theme.utils.debounce(250,(function(){return $(".product-video--root").trigger("pause-media"),$(".product-video--root").trigger("plyr-video-ready"),$(".product-video--root").trigger("theme.utils.youtubeAPIReady")})))},t.prototype.loadPlyrAssets=function(){if(this,!theme.utils.plyrScriptAdded)return theme.utils.plyrScriptAdded=!0,theme.utils.insertStylesheet(this.plyr_cdn+".css"),theme.utils.insertScript(this.plyr_cdn+".en.js",(function(){return $(".product-video--root").trigger("plyr-video-ready")}))},t.prototype.loadYoutubeAsset=function(){if(this,!theme.utils.youtubeScriptAdded)return theme.utils.youtubeScriptAdded=!0,theme.utils.insertScript("https://www.youtube.com/iframe_api")},t.prototype.loadPlyrVideo=function(){var t;if(!(t=this).video&&!t.skipVideo())return t.video=new Shopify.Plyr(t.root.find("video"),{iconUrl:t.plyr_cdn+".svg",loop:{active:t.loop_enabled}})},t.prototype.loadYoutubeVideo=function(){var t;if(!(t=this).video&&!t.skipVideo())return t.video=new YT.Player(t.id,{videoId:t.video_id,events:{onReady:function(e){return t.root.on("pause-media",(function(){return e.target.pauseVideo()})),t.root.on("play-media",(function(){return e.target.playVideo()}))},onStateChange:function(e){if(0===e.data&&t.loop_enabled&&e.target.seekTo(0),1===e.data)return $(".product-page--media > *").not(t.root).trigger("pause-media")}}})},t.prototype.skipVideo=function(){return this,"small"===theme.utils.mqs.current_window&&"desktop"===this.view||"small"!==theme.utils.mqs.current_window&&"mobile"===this.view},t}(),theme.classes.FrameworkRadios=function(){function t(t){var n;this.root=t,this.setSwatchAppearance=e(this.setSwatchAppearance,this),this.updateLabelOnChange=e(this.updateLabelOnChange,this),this.preventFormSubmitOnEnter=e(this.preventFormSubmitOnEnter,this),this.load=e(this.load,this),(n=this).current_value=n.root.find(".radios--option-current"),n.inputs=n.root.find('[data-item="radio"]'),n.is_swatches=n.root.data("is-swatches"),n.load()}return t.prototype.load=function(){var t;if((t=this).preventFormSubmitOnEnter(),t.is_swatches)return t.updateLabelOnChange(),t.setSwatchAppearance()},t.prototype.preventFormSubmitOnEnter=function(){return this,this.inputs.on("keydown",(function(t){if("Enter"===t.key)return t.preventDefault()}))},t.prototype.updateLabelOnChange=function(){var t;return(t=this).inputs.on("change",(function(){return t.current_value.text($(this).val())}))},t.prototype.setSwatchAppearance=function(){return this,this.inputs.each((function(){var t,e;return t=$(this).siblings(".radios--swatch-button"),e=$(this).val().toLowerCase().replace(/\s+/g,""),void 0===theme.swatches[e]?t.css("background-color",e):theme.swatches[e].indexOf("cdn.shopify.com")>-1?t.css("background-image","url("+theme.swatches[e]+")"):t.css("background-color",theme.swatches[e])}))},t}(),theme.classes.FrameworkSearch=function(){function t(t){var n;this.root=t,this.resizeListeners=e(this.resizeListeners,this),this.matchImageHeights=e(this.matchImageHeights,this),this.getResults=e(this.getResults,this),this.listenForKeyEntered=e(this.listenForKeyEntered,this),this.getSearchUrl=e(this.getSearchUrl,this),this.searchLinks=e(this.searchLinks,this),this.loadSpinners=e(this.loadSpinners,this),this.onOpen=e(this.onOpen,this),(n=this).articles=n.root.find(".search--articles"),n.form=n.root.find("form"),n.icon=n.root.find(".search--icon"),n.loading=n.root.find(".search--loading"),n.no_results=n.root.find(".search--no-results"),n.products=n.root.find(".search--products"),n.results=n.root.find(".search--results"),n.text_box=n.root.find(".search--textbox"),n.toggle_link=n.root.find(".search--toggle"),n.show_articles=n.root.data("show-articles"),n.show_pages=n.root.data("show-pages"),n.view=n.root.data("view"),n.ajax_request=null,n.search_term=null,n.search_url=null,n.close_results_timer=null,n.typing_timer=null,n.article_page_combination="",n.offCanvas=theme.partials.OffCanvas,n.show_articles&&n.show_pages?n.article_page_combination="article,page":n.show_articles?n.article_page_combination="article":n.show_pages&&(n.article_page_combination="page"),"modal"===n.view&&(n.searchLinks(),n.getSearchUrl(),n.listenForKeyEntered(),n.loadSpinners()),n.resizeListeners(),n.matchImageHeights()}return t.prototype.onOpen=function(){var t,e;return(t=this).text_box.focus(),e=t.text_box.val(),t.text_box.val(""),t.text_box.val(e),t.text_box.trigger("keyup")},t.prototype.loadSpinners=function(){var t;return this,(t=this.loading.find(".animation")).hasClass("tiny")?t.spin("tiny"):t.spin("small")},t.prototype.searchLinks=function(){var t;return t=this,$(".off-canvas--main-content a[href='"+theme.urls.search+"']").on("click",(function(){return $('[data-trigger="search-modal"]').trigger("click"),t.onOpen(),!1})),$(".off-canvas--right-sidebar a[href='"+theme.urls.search+"']").on("click",(function(){return t.offCanvas.closeRight(),setTimeout((function(){return $('[data-trigger="search-modal"]').trigger("click"),t.onOpen()}),450),!1})),$(".off-canvas--left-sidebar a[href='"+theme.urls.search+"']").on("click",(function(){return t.offCanvas.closeLeft(),setTimeout((function(){return $('[data-trigger="search-modal"]').trigger("click"),t.onOpen()}),450),!1}))},t.prototype.getSearchUrl=function(){var t;return(t=this).search_url=window.location.href,t.search_url=t.search_url.replace(window.location.hostname+window.location.pathname,window.location.hostname+theme.urls.search),t.search_url=t.search_url.replace("#",""),t.search_url.indexOf("?")>=0?t.search_url=t.search_url+"&":t.search_url=t.search_url+"?"},t.prototype.listenForKeyEntered=function(){var t;return(t=this).text_box.attr("autocomplete","off").on("keyup paste",(function(e){var n;return clearTimeout(t.typing_timer),(n=$(this).val()).length<2&&"paste"!==e.type?(t.products.empty(),t.articles.empty(),t.loading.hide(),t.icon.show(),!1):(t.loading.show(),t.icon.hide(),t.typing_timer=setTimeout((function(){var e;if(clearTimeout(t.typing_timer),e=t.search_url+"view=ajax-product&type=product&q="+n+"*",t.getResults(e,n,"product"),t.show_articles||t.show_pages)return e=t.search_url+"view=ajax-article-page&type="+t.article_page_combination+"&q="+n+"*",t.getResults(e,n,"article")}),750))}))},t.prototype.getResults=function(t,e,n){var i;(i=this).products.empty(),i.articles.empty(),$.ajax({url:t,type:"GET",dataType:"html",success:function(t){return i.loading.hide(),i.icon.show(),"product"===n?(i.products.empty(),i.products.append(t),i.matchImageHeights()):"article"===n?(i.articles.empty(),i.articles.append(t)):void 0},error:function(t,e,n){var i;return i=e+", "+n,console.log("search.json Request Failed: "+i)}})},t.prototype.matchImageHeights=function(){return this,theme.utils.matchImageHeights(this.products,this.products.find(".product--root"),".product--image-wrapper")},t.prototype.resizeListeners=function(){var t;return t=this,$(window).on("resize.Search",theme.utils.debounce(100,(function(){return t.matchImageHeights()})))},t}(),theme.classes.Sections=function(){function t(){this.unload=e(this.unload,this),this.deselectBlock=e(this.deselectBlock,this),this.selectBlock=e(this.selectBlock,this),this.deselectSection=e(this.deselectSection,this),this.selectSection=e(this.selectSection,this),this.load=e(this.load,this),this.getActiveBlock=e(this.getActiveBlock,this),this.getActiveSection=e(this.getActiveSection,this),this.listeners=e(this.listeners,this),this.listeners()}return t.prototype.listeners=function(){var t;return(t=this).load(),t.unload(),t.selectSection(),t.deselectSection(),t.selectBlock(),t.deselectBlock()},t.prototype.getActiveSection=function(t){return this,$(t.target).find("[data-section-id]")},t.prototype.getActiveBlock=function(t){return this,$(t.target)},t.prototype.load=function(t){var e;return e=this,$(document).on("shopify:section:load",(function(t){var n;return theme.utils.loadJsClasses(),(n=e.getActiveSection(t)).triggerHandler("theme:section:load"),n.find("[data-js-class]").each((function(){return $(this).triggerHandler("theme:section:load")}))}))},t.prototype.selectSection=function(){var t;return t=this,$(document).on("shopify:section:select",(function(e){return t.getActiveSection(e).triggerHandler("theme:section:select")}))},t.prototype.deselectSection=function(){var t;return t=this,$(document).on("shopify:section:deselect",(function(e){return t.getActiveSection(e).triggerHandler("theme:section:deselect")}))},t.prototype.selectBlock=function(){var t;return t=this,$(document).on("shopify:block:select",(function(e){return t.getActiveBlock(e).triggerHandler("theme:block:select")}))},t.prototype.deselectBlock=function(){var t;return t=this,$(document).on("shopify:block:deselect",(function(e){return t.getActiveBlock(e).triggerHandler("theme:block:deselect")}))},t.prototype.unload=function(t){var e;return e=this,$(document).on("shopify:section:unload",(function(t){var n;return(n=e.getActiveSection(t)).triggerHandler("theme:section:unload"),n.find('[data-js-loaded="true"]').each((function(){return $(this).triggerHandler("theme:section:unload")}))}))},t}(),theme.classes.FrameworkServiceList=function(){function t(t){var n;this.root=t,this.balanceColumns=e(this.balanceColumns,this),this.load=e(this.load,this),(n=this).section_id=n.root.data("section-id"),n.block_list=n.root.find(".service-list--blocks"),n.blocks=n.root.find("li"),n.blocks_container=n.root.find(".service-list--container"),n.headers=n.root.find(".service-list--block-header"),n.single_column=n.root.find(".service-list--single-column"),n.left_column=n.root.find(".service-list--left-column"),n.right_column=n.root.find(".service-list--right-column"),n.load()}return t.prototype.load=function(){return this,this.balanceColumns()},t.prototype.balanceColumns=function(){var t,e,n,i,o,r;return i=!0===(t=this).root.data("service-list--show-descriptions")?75:0,r=t.block_list.length>1,e=function(t){return t.hasClass("service-list--block-header")},o=function(){var e,n,o;return o=t.single_column.outerHeight(),e=t.left_column.outerHeight(),n=t.right_column.outerHeight(),e>=parseFloat(n+o-i)},(n=function(){return r?(t.root.attr("data-service-list--has-headers",!0),t.block_list):(t.left_column.append('<ul class="service-list--blocks"></ul>'),t.blocks)}()).each((function(i){if(!o())return r?$(this).appendTo(t.left_column):e($(this))?($(this).find(".service-list--block-header--text").prependTo(t.blocks_container),$(this).remove()):$(this).appendTo(t.left_column.find(".service-list--blocks")),i===n.length-1&&t.right_column.is(":empty")&&t.headers.length>1?t.left_column.find(".service-list--blocks").last().appendTo(t.right_column):void 0;t.single_column.find(".service-list--blocks").appendTo(t.right_column)}))},t}(),theme.classes.FrameworkSlider=function(){function t(t){this.container=t,this.eventListeners=e(this.eventListeners,this),this.pauseMedia=e(this.pauseMedia,this),this.alignPlayButton=e(this.alignPlayButton,this),this.updateContextMenu=e(this.updateContextMenu,this),this.autoplay=e(this.autoplay,this),this.formatPaginationNumbers=e(this.formatPaginationNumbers,this),this.getActiveIndex=e(this.getActiveIndex,this),this.createSlider=e(this.createSlider,this),this.autoplay_enabled=!!this.container.data("autoplay"),this.navigation=!!this.container.data("navigation"),this.pagination_numbers=!!this.container.data("pagination-numbers"),this.autoplay_frequency=3e3,this.slide_length=this.container.children().length,this.active_index=0,this.news_panel=!!this.container.data("news-panel"),this.createSlider(),this.eventListeners(),this.owl=this.container.data("owlCarousel")}return t.prototype.createSlider=function(){var t,e;return t=this,e=this.container.owlCarousel({singleItem:!0,navigation:t.navigation,navigationText:!1,pagination:!!t.container.data("pagination"),paginationNumbers:t.pagination_numbers,scrollPerPageNav:!0,slideSpeed:800,autoHeight:!1,autoPlay:t.autoplay(),afterInit:function(){},afterAction:function(){return t.alignPlayButton(),t.active_index=t.getActiveIndex(),t.updateContextMenu(t.active_index),t.formatPaginationNumbers(),t.pauseMedia()}}),t.navigation&&(e.find(".owl-prev").html('<svg class="icon--root icon--chevron-left" viewBox="0 0 12 20"> <path d="M2.648 10l8.613-8.614L9.99.114.102 10l9.887 9.886 1.272-1.272z" fill-rule="nonzero" /> </svg>'),e.find(".owl-next").html('<svg class="icon--root icon--chevron-right" viewBox="0 0 12 20"> <path d="M8.716 10L.102 18.614l1.273 1.272L11.261 10 1.375.114.102 1.386z" fill-rule="nonzero" /> </svg>')),e},t.prototype.getActiveIndex=function(){return this.container.find(".owl-pagination .owl-page.active").index()},t.prototype.formatPaginationNumbers=function(){return this.container.find(".owl-page.active .owl-numbers").text(this.active_index+1+"/"+this.slide_length)},t.prototype.autoplay=function(){return!!this.autoplay_enabled&&this.autoplay_frequency},t.prototype.updateContextMenu=function(t){var e,n;if(this.news_panel)return n="."+this.container.find(".slide").eq(t).data("feed-type"),(e=this.container.closest(".template--index--news").find(".context-navigation")).find(".item").hide(),e.find(n).show()},t.prototype.alignPlayButton=function(){var t,e,n;if(0!==(t=(e=this.container.find(".owl-item").eq(this.active_index)).find(".play-button")).length)return t.css("visibility","hidden"),PAGE.hasClass("transparent-menu")&&"absolute"===$(".header--root").css("position")?(n=(e.outerHeight()-t.outerHeight())/2,t.css({"margin-top":0,top:n})):t.css({"margin-top":"-40px",top:"50%"}),t.css("visibility","visible")},t.prototype.pauseMedia=function(){var t;return(t=this).media=".product-video--root, .product-model--root",t.container.find(t.media).trigger("pause-media")},t.prototype.eventListeners=function(){var t;return t=this,this.container.find(".play-button").on("click",(function(){return new VideoModal($(this).closest(".video")).open(),t.owl.stop(),!1})),this.container.find(".owl-pagination .owl-page, .skip-to-next").on("click",(function(){return t.owl.next(),!1}))},t}(),theme.classes.FrameworkStickyColumn=function(){function t(t,n,i,o){if(this.container=t,this.column_a=n,this.column_b=i,this.mq=o,this.Listeners=e(this.Listeners,this),this.setColumnPosition=e(this.setColumnPosition,this),this.getAlignment=e(this.getAlignment,this),this.getState=e(this.getState,this),this.resetLargerColumn=e(this.resetLargerColumn,this),this.getSmallerColumn=e(this.getSmallerColumn,this),this.heightsHaveChanged=e(this.heightsHaveChanged,this),this.setHeights=e(this.setHeights,this),this.loadColumns=e(this.loadColumns,this),Modernizr.touchevents)return!1;this.current_state="auto",this.column_a_height=0,this.column_b_height=0,this.loadColumns()}return t.prototype.loadColumns=function(){var t;return t=this,theme.utils.imagesLoaded(t.container,(function(){return t.Listeners(),t.setColumnPosition()}))},t.prototype.setHeights=function(){return this.column_a_height=this.column_a.outerHeight(),this.column_b_height=this.column_b.outerHeight()},t.prototype.heightsHaveChanged=function(){return(this.column_a.outerHeight()!==this.column_a_height||this.column_b.outerHeight()!==this.column_b_height)&&(this.setHeights(),!0)},t.prototype.getSmallerColumn=function(){return this.column_a_height<this.column_b_height?this.column_a:this.column_b},t.prototype.resetLargerColumn=function(){return this.column_a_height>this.column_b_height?this.column_a.css({position:"relative",top:"auto",bottom:"auto"}):this.column_b.css({position:"relative",top:"auto",bottom:"auto"})},t.prototype.getState=function(t,e,n){var i,o,r;return r="auto","small"===this.mq.current_window?"auto":(e>(i=n.outerHeight())&&(o=!0),t<this.container.offset().top&&(r="auto"),t+(o?i:e)>this.container.offset().top+this.container.outerHeight()?r="absolute-bottom":t>this.container.offset().top&&o?r="fixed-top":e<i&&t+e>this.container.offset().top+n.outerHeight()&&(r="fixed-bottom"),r)},t.prototype.getAlignment=function(t){return t.hasClass("column-a")?"left":t.hasClass("column-b")?"right":void 0},t.prototype.setColumnPosition=function(){var t,e,n,i;if((t=this).setHeights(),n=t.getSmallerColumn(),i=t.getState($(window).scrollTop(),$(window).height(),n),e=t.getAlignment(n),"auto"===i&&"auto"!==this.current_state?(this.current_state="auto",n.css({position:"relative",top:"auto",bottom:"auto"})):"fixed-bottom"===i&&"fixed-bottom"!==this.current_state?(this.current_state="fixed-bottom",n.css({position:"fixed",top:"auto",bottom:0})):"fixed-top"===i&&"fixed-top"!==this.current_state?(this.current_state="fixed-top",n.css({position:"fixed",top:0,bottom:"auto"})):"absolute-bottom"===i&&"absolute-bottom"!==this.current_state&&(this.current_state="absolute-bottom",n.css({position:"absolute",top:"auto",bottom:0})),"right"===e)return n.css({right:0})},t.prototype.Listeners=function(){var t;return t=this,$(window).on("scroll",(function(){return t.setColumnPosition()})),setInterval((function(){if(t.heightsHaveChanged())return t.resetLargerColumn(),t.setColumnPosition()}),250),$(window).on("resize",(function(){return t.resetLargerColumn(),t.setColumnPosition()}))},t}(),theme.classes.FrameworkUtils=function(){function t(){this.google_map_api_status=null,cssVars()}return t.prototype.a11yClick=function(t){var e;return"click"===t.type||"keypress"===t.type&&(32===(e=t.charCode||t.keyCode)&&t.preventDefault(),32===e||13===e)},t.prototype.debounce=function(t,e){var n;return n=void 0,function(){n&&clearTimeout(n),n=setTimeout(e.bind(this),t,arguments)}},t.prototype.imagesLoaded=function(t,e){var n,i;if(n=0,!((i=t.find('img[data-sizes="auto"]').length)<1))return t.on("lazybeforeunveil",(function(t){return $(t.target).one("load",(function(){if(++n===i)return e()}))}));e()},t.prototype.matchImageHeights=function(t,e,n){var i,o,r;return this,o=Math.round(t.width()/e.first().outerWidth()),i=0,r=$(),e.find(n).css("height","auto"),e.find(".placeholder--root").css("height","auto"),e.each((function(t){var s;if(s=$(this).find(".image--root").length>0?$(this).find(n+" .image--root").outerHeight():$(this).find(".placeholder--root").outerHeight(),r=r.add($(this)),s>i&&(i=s),t%o==o-1||t+1===e.length)return r.find(n+", .placeholder--root").height(i),i=0,r=$()}))},t.prototype.insertStylesheet=function(t){var e;return this,(e=document.createElement("link")).rel="stylesheet",e.href=t,document.head.appendChild(e)},t.prototype.insertScript=function(t,e){var n;return this,(n=document.createElement("script")).src=t,e&&(n.onload=e),document.body.appendChild(n)},t.prototype.formatMoney=function(t){var e,n,i;switch(this,i=/\{\{\s*(\w+)\s*\}\}/,e=function(t,e,n){var i,o,r,s;return s=n?".":",",r=n?",":".",o=(i=(t/100).toFixed(e).split("."))[1]?r+i[1]:"",i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+s)+o},theme.shop.money_format.match(i)[1]){case"amount":n=e(t,2,!1);break;case"amount_no_decimals":n=e(t,0,!1);break;case"amount_with_comma_separator":n=e(t,2,!0);break;case"amount_no_decimals_with_comma_separator":n=e(t,0,!0)}return theme.shop.money_format.replace(i,n)},t.prototype.isNaN=function(t){return this,t!=t},t}(),theme.classes.FrameworkXMenu=function(){function t(t){var n;this.root=t,this.slideUp=e(this.slideUp,this),this.slideDown=e(this.slideDown,this),this.arrangeMegaNav=e(this.arrangeMegaNav,this),this.resizeListeners=e(this.resizeListeners,this),this.checkOverlap=e(this.checkOverlap,this),this.listeners=e(this.listeners,this),this.load=e(this.load,this),(n=this).debugging=!1,n.state="closed",n.parent_links=n.root.find(".x-menu--level-1--link > a"),n.sub_menu_links=n.root.find('.x-menu--level-1--link:not([data-x-menu--depth="1"]) > a'),n.sub_menu_items=n.sub_menu_links.parent().find("ul a"),n.parents_with_sub_menu=n.sub_menu_links.parent(),n.overlap_parent=n.root.data("x-menu--overlap-parent"),n.load()}return t.prototype.load=function(){var t;return(t=this).arrangeMegaNav(),t.listeners(),t.checkOverlap(),t.resizeListeners()},t.prototype.listeners=function(){var t;return(t=this).parents_with_sub_menu.on("mouseenter.XMenu",(function(e){return t.slideDown($(this).find("> a"))})),t.parents_with_sub_menu.on("mouseleave.XMenu",(function(){return t.slideUp()})),t.parent_links.on("focus",(function(e){return t.slideUp()})),t.sub_menu_links.on("focus",(function(e){return t.slideDown($(this))})),t.sub_menu_links.on("touchstart.XMenu",(function(e){return e.preventDefault(),"true"===$(this).parent().attr("data-x-menu--open")?t.slideUp():t.slideDown($(this))}))},t.prototype.checkOverlap=function(){var t,e,n,i,o,r,s,a,l,u;return t=this,Modernizr.touchevents&&"large"!==theme.utils.mqs.current_window?(t.root.attr("data-x-menu--overlap","true"),!1):(t.root.attr("data-x-menu--overlap","false"),n=t.root,1===t.overlap_parent?n=n.parent():2===t.overlap_parent&&(n=n.parent().parent()),r=n.parent(),l=!1,(e=n.index())>1&&(l=r.children().eq(e-1)),u=!1,e+1<r.children().length&&(u=r.children().eq(e+1)),s=r.width(),o=t.root.outerWidth(),l&&(i=n.find("> :first-child").offset().left-1,(s-o)/2,left_edge>=i&&t.root.attr("data-x-menu--overlap","true")),u&&(a=n.find("> :last-child")).outerWidth()+a.offset().left+1>=u.offset().left?t.root.attr("data-x-menu--overlap","true"):void 0)},t.prototype.resizeListeners=function(){var t;return t=this,$(window).on("resize.XMenu",t.debounce(100,(function(){return t.checkOverlap()})))},t.prototype.debounce=function(t,e){var n;return n=void 0,function(){n&&clearTimeout(n),n=setTimeout(e.bind(this),t,arguments)}},t.prototype.arrangeMegaNav=function(){return this,0!==this.parents_with_sub_menu.length&&this.root.find('[data-x-menu--depth="3"] .x-menu--level-2--container').each((function(){var t,e;if((e=(t=$(this)).find('[data-x-menu--single-parent="true"]')).length>0)return $('<div class="x-menu--single-parents"></div>').insertAfter(t.find(".x-menu--bg")).append("<ul>").find("ul").append(e)}))},t.prototype.slideDown=function(t,e){var n,i,o,r,s;if(null==e&&(e=!1),n=this,clearTimeout(n.timer),"true"===(o=t.parent()).attr("data-x-menu--open")||"closing"===n.state)return!1;n.slideUp(!1),e&&"complete"!==e?n.timer=setTimeout((function(){return n.slideDown(t,"complete")}),e):(t.closest(".x-menu--level-1--link").find(".icon--chevron-up").show(),t.closest(".x-menu--level-1--link").find(".icon--chevron-down").hide(),t.closest(".x-menu--level-1--link").find(".icon--minus").show(),t.closest(".x-menu--level-1--link").find(".icon--plus").hide(),n.state="open",o.attr("data-x-menu--open","true"),t.attr("aria-expanded","true"),s=t.closest(".x-menu--level-1--link").find(".x-menu--level-2--container"),i="block","3"===o.attr("data-x-menu--depth")&&(i="flex"),s.velocity("stop"),s.css({height:"auto",display:i}),s.find(".x-menu--level-2--list").css({display:i}),r=s.outerHeight(),s.css({height:0,opacity:1}),s.velocity({height:[r,0]},{queue:!1,duration:600,easing:"easeOutExpo"}))},t.prototype.slideUp=function(t){var e,n,i,o;return null==t&&(t=300),!(e=this).debugging&&(n=(i=e.parents_with_sub_menu.filter('[data-x-menu--open="true"]')).find("> a"),"false"!==i.attr("data-x-menu--open")&&(t?e.timer=setTimeout((function(){return e.slideUp(!1)}),t):(n.closest(".x-menu--level-1--link").find(".icon--chevron-up").hide(),n.closest(".x-menu--level-1--link").find(".icon--chevron-down").show(),n.closest(".x-menu--level-1--link").find(".icon--minus").hide(),n.closest(".x-menu--level-1--link").find(".icon--plus").show(),o=n.closest(".x-menu--level-1--link").find(".x-menu--level-2--container"),i.attr("data-x-menu--open","false"),n.attr("aria-expanded","false"),o.velocity({opacity:0},{begin:function(){return e.state="closing"},complete:function(){return o.css({display:"none"}),e.state="closed"},duration:200}))))},t}(),theme.classes.FrameworkYMenu=function(){function t(t){var n;this.root=t,this.slideRight=e(this.slideRight,this),this.slideLeft=e(this.slideLeft,this),this.adjustHeight=e(this.adjustHeight,this),this.listeners=e(this.listeners,this),this.load=e(this.load,this),(n=this).state="closed",n.sub_menu_links=n.root.find(".icon--chevron-right--small").parent(),n.back_links=n.root.find(".y-menu--back-link a"),n.regular_links=n.root.find('.y-menu--level-1--link > a:not([data-submenu="true"]), .y-menu--level-2--link > a:not([data-submenu="true"]), .y-menu--level-3--link > a:not([data-submenu="true"])'),n.timer=null,n.load()}return t.prototype.load=function(){return this,this.listeners()},t.prototype.listeners=function(){var t;return(t=this).regular_links.on("click",(function(t){var e;-1!==(e=$(this).attr("href")).indexOf("#")&&("left-open"===theme.partials.OffCanvas.state?theme.partials.OffCanvas.closeLeft():"right-open"===theme.partials.OffCanvas.state&&theme.partials.OffCanvas.closeRight(),setTimeout((function(){return window.location.href=e}),450))})),t.sub_menu_links.on("click",(function(e){return t.slideLeft($(this)),!1})),t.back_links.on("click",(function(e){return t.slideRight($(this)),!1}))},t.prototype.adjustHeight=function(t){var e,n;return(e=this).root.css({height:"auto"}),e.root.outerHeight(),n=t.outerHeight(),"absolute"===t.css("position")&&(t.css("position","relative"),n=t.outerHeight(),t.css("position","absolute")),e.root.velocity({height:n})},t.prototype.slideLeft=function(t){var e;return this,(e=t.closest("li").find("ul").first()).css({display:"block"}),this.adjustHeight(e),e.velocity({translateX:["-100%",0]})},t.prototype.slideRight=function(t){var e,n;return this,n=(e=t.closest("ul")).parent().closest("ul"),this.adjustHeight(n),e.velocity({translateX:[0,"-100%"]})},t}(),theme.classes.Article=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return n(e,t),e}(theme.classes.FrameworkArticle),theme.classes.Cart=function(t){function i(){return this.updateTotalsComplete=e(this.updateTotalsComplete,this),i.__super__.constructor.apply(this,arguments)}return n(i,t),i.prototype.updateTotalsComplete=function(t){var e;return e=this,t>0?(e.total_item_count.css("display","inline-block"),e.total_item_count.parent().show()):(e.total_item_count.not(".header--mobile-cart-count").hide(),e.total_item_count.not(".header--mobile-cart-count").parent().hide())},i}(theme.classes.FrameworkCart),theme.classes.Disclosure=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return n(e,t),e}(theme.classes.FrameworkDisclosure),theme.classes.FeaturedProduct=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return n(e,t),e}(theme.classes.FrameworkFeaturedProduct),theme.classes.FeaturedVideo=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return n(e,t),e}(theme.classes.FrameworkFeaturedVideo),theme.classes.Footer=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return n(e,t),e}(theme.classes.FrameworkFooter),theme.classes.Slideshow=function(){function t(t){var n;this.root=t,this.eventListeners=e(this.eventListeners,this),this.alignPlayButton=e(this.alignPlayButton,this),this.alignCaption=e(this.alignCaption,this),this.isFirstSlider=e(this.isFirstSlider,this),this.getActiveIndex=e(this.getActiveIndex,this),this.autoplay=e(this.autoplay,this),this.createSlider=e(this.createSlider,this),this.el=this.root.find(".slides"),n=this.el.closest(".slider"),this.autoplay_enabled=n.data("autoplay"),n.find(".slide").length<2&&(this.autoplay_enabled=!1),this.autoplay_frequency=n.data("rotateFrequency"),this.transition_style=n.data("transitionStyle"),this.createSlider(),this.owl=$(".owl-carousel").data("owlCarousel")}return t.prototype.createSlider=function(){var t,e;return e={singleItem:!0,navigation:!1,paginationNumbers:!1,scrollPerPageNav:!0,slideSpeed:800,pagination:!0,autoHeight:!0,autoPlay:(t=this).autoplay(),afterInit:function(){return t.eventListeners()},afterAction:function(){return t.alignCaption(),t.alignPlayButton()}},"default"!==this.transition_style&&(e.transitionStyle=this.transition_style),t.el.owlCarousel(e)},t.prototype.autoplay=function(){return!!this.autoplay_enabled&&this.autoplay_frequency},t.prototype.getActiveIndex=function(){return this.el.find(".owl-pagination .owl-page.active").index()},t.prototype.isFirstSlider=function(){var t,e,n;return n=(e=$(".index-sections").children("div:first")).find(".slider").data("sectionId"),t=this.el.closest(".slider").data("sectionId"),!!e.hasClass("section--slideshow")&&t===n},t.prototype.alignCaption=function(){var t,e,n,i,o,r,s,a;return(t=(r=this.el.find(".owl-item").eq(this.getActiveIndex())).find(".caption")).css("visibility","hidden"),e=t.outerHeight(),n=t.outerWidth(),30,s=r.outerHeight(),a=r.outerWidth(),0,t.hasClass("top")?t.css("top",30):t.hasClass("middle")&&(o=0+(s-0-e)/2,t.css("top",o)),t.hasClass("center")&&(i=(a-n)/2,t.css("left",i)),t.css("visibility","visible")},t.prototype.alignPlayButton=function(){var t;return(t=this.el.find(".owl-item").eq(this.getActiveIndex()).find(".play-button")).css("visibility","hidden"),t.css({"margin-top":"-40px",top:"50%"}),t.css("visibility","visible")},t.prototype.eventListeners=function(){var t;return t=this,this.el.find(".owl-pagination .owl-page").on("click",(function(){return t.owl.stop()}))},t}(),theme.classes.Header=function(){function t(t){this.root=t,this.moveYMenu=e(this.moveYMenu,this),this.load=e(this.load,this),this.load()}return t.prototype.load=function(){return this,this.moveYMenu(),"block"===$(".modal.window").css("display")&&$(".modal.window .close").trigger("click"),this.root.on("theme:section:load",(function(){return theme.partials.OffCanvas.unload(),theme.partials.OffCanvas.load()}))},t.prototype.moveYMenu=function(){return this,$(".mobile-nav--menu").empty(),$(".y-menu").appendTo(".mobile-nav--menu")},t}(),theme.classes.OffCanvas=function(t){function e(t){this.root=t,e.__super__.constructor.apply(this,arguments)}return n(e,t),e}(theme.classes.FrameworkOffCanvas),theme.classes.Popup=function(){function t(t){var e;this.root=t,(e=this).container=e.root.find(".popup--container"),e.open_link=$(".popup--open"),e.close_link=e.root.find(".popup--close"),e.show_again_after=e.root.data("show-again-after"),e.mode=e.root.data("mode"),e.newsletter_form=e.root.find("#contact_form"),e.body=$("body"),e.eventListeners(),e.autoPopup()}return t.prototype.eventListeners=function(){var t;return(t=this).open_link.on("keypress.Popup, click.Popup",(function(e){return t.body.hasClass("popup--opened")?t.close():t.open(),!1})),t.close_link.on("keypress.Popup, click.Popup",(function(e){return t.close(),!1})),t.newsletter_form.on("submit",(function(t){var e,n;return n=this,(e=$(this)).find(".error, .success").remove(),t.preventDefault(),0===e.find('input[type="email"]').val().length?(e.prepend("<p class='error'>"+theme.translations.mailing_list_email_blank+"</p>"),!1):(e.find('input[type="email"], input[type="submit"]').hide(),e.prepend("<p class='success'>"+theme.translations.mailing_list_success_message+"</p>").show(),setTimeout((function(){return n.submit()}),500),!1)}))},t.prototype.open=function(t){var e;return(e=this).container.removeClass("popup--closed"),e.container.velocity({translateY:[0,e.container.outerHeight()]},{duration:300}),e.body.addClass("popup--opened"),setTimeout((function(){return e.body.css("padding-bottom",e.container.outerHeight())}),300)},t.prototype.delayUntilValidScrollPosition=function(){var t;return t=this,$(window).on("DOMMouseScroll.Popup mousewheel.Popup touchmove.Popup scroll.Popup touchmove.Popup",(function(e){var n;if(n=$(".header").offset().top,$(window).scrollTop()>n)return t.open(),$(window).off("DOMMouseScroll.Popup mousewheel.Popup touchmove.Popup scroll.Popup touchmove.Popup")}))},t.prototype.close=function(){var t;return(t=this).body.removeClass("popup--opened"),t.body.velocity({paddingBottom:0},{duration:300}),t.container.velocity({translateY:[t.container.outerHeight(),0]},{duration:300,complete:function(){return t.container.addClass("popup--closed")}})},t.prototype.autoPopup=function(){var t;if("manual"!==(t=this).mode)return Modernizr.localstorage&&"test"!==t.mode?void 0===localStorage["troop-themes"]||t.readyToReset()?(t.setResetTime(),setTimeout((function(){return t.open("auto")}),1e3)):void 0:setTimeout((function(){return t.open("auto")}),1e3)},t.prototype.readyToReset=function(){var t,e;return this,t=JSON.parse(localStorage["troop-themes"]).popup_expires,e=(new Date).getTime(),parseFloat(t-e)<=0&&(this.setResetTime(),!0)},t.prototype.setResetTime=function(){var t,e,n;return this,t=new Date,n=864e5*this.show_again_after,e={popup_expires:t.setTime(t.getTime()+n)},localStorage["troop-themes"]=JSON.stringify(e),this},t}(),theme.classes.ProductModel=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return n(e,t),e}(theme.classes.FrameworkProductModel),theme.classes.ProductRecommendations=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return n(e,t),e}(theme.classes.FrameworkProductRecommendations),theme.classes.ProductVideo=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return n(e,t),e}(theme.classes.FrameworkProductVideo),theme.classes.Radios=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return n(e,t),e}(theme.classes.FrameworkRadios),theme.classes.ServiceList=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return n(e,t),e}(theme.classes.FrameworkServiceList),theme.classes.XMenu=function(t){function i(t){this.root=t,this.checkOverlap=e(this.checkOverlap,this),this.alignSubmenus=e(this.alignSubmenus,this),this.load=e(this.load,this),this.cart_count=$(".header--cart-count"),this.hide_when_overlapping=$(".layout--header .layout--login, .layout--header .popup--open, .layout--header .cart-link, .layout--header .header--search"),i.__super__.constructor.apply(this,arguments)}return n(i,t),i.prototype.load=function(){return this,i.__super__.load.apply(this,arguments),this.alignSubmenus()},i.prototype.alignSubmenus=function(){var t,e;return this,t=$(".layout--header .fw--logo"),e=t.outerWidth(),this.root.find('[data-x-menu--depth="3"] .x-menu--level-2--container').each((function(){return $(this).css({left:e,width:"calc(100% - "+e+"px)"})}))},i.prototype.checkOverlap=function(){var t,e;if(t=this,e=$(".layout--header"),t.cart_count.attr("data-menu-overlap","false"),e.attr("data-menu-overlap","false"),t.hide_when_overlapping.css({display:"inline-block"}),i.__super__.checkOverlap.apply(this,arguments),"true"===t.root.attr("data-x-menu--overlap")&&(e.attr("data-menu-overlap","true"),t.hide_when_overlapping.hide(),parseInt(t.cart_count.find(".count").text())>0))return t.cart_count.attr("data-menu-overlap","true")},i}(theme.classes.FrameworkXMenu),theme.classes.Blog=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return n(e,t),e}(theme.classes.FrameworkBlog),theme.classes.CollectionPage=function(){function t(t){var n;this.root=t,this.matchImageHeights=e(this.matchImageHeights,this),(n=this).product_grid=n.root.find(".product-grid"),n.items=n.product_grid.find(".block"),n.load()}return t.prototype.load=function(){return this,this.eventListeners(),this.matchImageHeights()},t.prototype.eventListeners=function(){var t;return t=this,$(window).on("resize.CollectionPage",(function(){return t.matchImageHeights()}))},t.prototype.matchImageHeights=function(){return this,theme.utils.matchImageHeights(this.product_grid,this.items,".product--image-wrapper")},t}(),theme.classes.IndexCollection=function(){function n(t){this.container=t,this.load=e(this.load,this),this.load()}return n.prototype.load=function(){var e;return(e=this).container.on("theme:section:load",(function(){return $(e.container.find(".fw--align--fill-y--dynamic")).each((function(){return new t($(this),"fill-y--dynamic")}))}))},n}(),theme.classes.ProductPage=function(){function t(t){var n;this.root=t,this.pauseOtherMedia=e(this.pauseOtherMedia,this),this.updateVariantMedia=e(this.updateVariantMedia,this),this.variantSelected=e(this.variantSelected,this),this.updateHistoryState=e(this.updateHistoryState,this),this.updateVariantOnOptionChange=e(this.updateVariantOnOptionChange,this),this.swapMedia=e(this.swapMedia,this),this.addProductComplete=e(this.addProductComplete,this),this.addToCartListener=e(this.addToCartListener,this),this.resizeListeners=e(this.resizeListeners,this),this.copyLink=e(this.copyLink,this),this.reorderModalImages=e(this.reorderModalImages,this),this.balanceColumns=e(this.balanceColumns,this),this.indexContentBlocks=e(this.indexContentBlocks,this),this.load=e(this.load,this),(n=this).product=n.root.find(".partial--product"),n.smart_payment_buttons=n.root.find(".product-page--smart-payment-buttons"),n.variant_container=n.root.find(".product-page--variants"),n.actual_price=n.product.find(".actual-price"),n.add_button=n.product.find("button.add"),n.compare_price=n.product.find(".compare-price"),n.form=n.product.find(".add-to-cart form"),n.product_unavailable=n.product.find(".product--unavailable"),n.variant_listbox=n.product.find(".product-page--variant-select"),n.option_inputs=n.variant_container.find('[data-item="disclosure"], [data-item="radio"]'),n.load()}return t.prototype.load=function(){var t;if((t=this).indexContentBlocks(),t.copyLink(),t.balanceColumns(),t.reorderModalImages(),t.resizeListeners(),t.pauseOtherMedia(),"drawer"===theme.settings.cart_type&&t.addToCartListener(),theme.product.variants.length>1)return t.updateVariantOnOptionChange()},t.prototype.indexContentBlocks=function(){return $(".layout--main-content .product .content .block").each((function(t){return $(this).attr("data-block-index",t)}))},t.prototype.balanceColumns=function(){var t,e,n,i,o,r;return this,$(".layout--main-content .product .content .product-page--media"),r=(t=$(".layout--main-content .product .content")).find(".single-column"),e=t.find(".block"),i=t.find(".left-side"),o=t.find(".right-side"),n=t.find(".photo:not(.hidden-variant-image)").length,(!e.find("iframe").length||"small"===theme.utils.mqs.current_window||!i.children().length)&&(e.sort((function(t,e){return+t.getAttribute("data-block-index")-+e.getAttribute("data-block-index")})).appendTo(r),r.show(),i.hide(),o.hide(),n>0&&"small"!==theme.utils.mqs.current_window?(e.each((function(t){return i.outerHeight()<=o.outerHeight()?$(this).appendTo(i):$(this).appendTo(o)})),r.hide(),i.show(),o.show()):void 0)},t.prototype.reorderModalImages=function(){var t,e,n,i;return i=(t=this).root.find(".modal--root >:not(.modal--content-wrapper) .product-page--media"),n=t.root.find(".modal--root .modal--content .product-page--media"),e=t.root.find(".modal--content-wrapper"),i.each((function(){var t;return t=n.filter("[data-id='"+$(this).attr("data-id")+"']").closest(".modal--content"),e.append(t)}))},t.prototype.copyLink=function(){var t,e;return t=$(".partial--social-media .copy-link a"),e=t.parent().find("textarea"),t.on("click",(function(){return e.toggle(),e.focus(),!1})),t.parent().find("textarea").on("focus",(function(){var t;return(t=$(this)).select(),t.on("mouseup",(function(){return t.unbind("mouseup"),!1}))}))},t.prototype.resizeListeners=function(){var t;return t=this,$(window).on("resize.TemplateProduct",(function(){return t.balanceColumns(),t.reorderModalImages()}))},t.prototype.addToCartListener=function(){var t;if((t=this).form.length>0&&"drawer"===theme.settings.cart_type)return t.form.on("submit",(function(){return t.form.find("p.error").remove(),t.add_button.addClass("loading"),theme.partials.Cart.addItem($(this),(function(e,n){return e?theme.partials.Cart.updateAllHtml((function(){return t.addProductComplete()})):(t.form.append("<p class='error'>"+n+"</p>"),t.add_button.removeClass("loading"))})),!1}))},t.prototype.addProductComplete=function(){return this,this.add_button.removeClass("loading"),$('[data-off-canvas--open="right-sidebar"]').first().trigger("click")},t.prototype.swapMedia=function(t,e){var n,i;return this,n=t.clone(),i=e.clone(),t.replaceWith(i),e.replaceWith(n)},t.prototype.updateVariantOnOptionChange=function(){var t;return(t=this).option_inputs.on("change",(function(){var e,n,i,o,r,s,a;for(e=t.variant_container.find('[data-item="disclosure"], [data-item="radio"]:checked'),o=[],e.each((function(){return o.push($(this).val().trim())})),a=o.join(" / "),n=0,i=(r=theme.product.variants).length;n<i;n++)if((s=r[n]).title===a)return t.updateHistoryState(s.id),selectCallback(s);return selectCallback(!1)}))},t.prototype.updateHistoryState=function(t){var e;return this,e=window.location.protocol+"//"+window.location.host+window.location.pathname+"?variant="+t,window.history.replaceState({path:e},"",e)},t.prototype.variantSelected=function(t){var e,n,i;(e=this).compare_price.html(""),e.variant_listbox.find("option[selected]").removeAttr("selected"),t&&t.available?(e.add_button.show(),e.product_unavailable.hide(),e.smart_payment_buttons.show(),e.variant_listbox.find("option[value='"+t.id+"']").attr("selected","")):(e.add_button.hide(),e.smart_payment_buttons.hide(),e.product_unavailable.show()),t&&(n=theme.utils.formatMoney(t.price),e.actual_price.html(n),t.compare_at_price>t.price&&(i=theme.utils.formatMoney(t.compare_at_price),e.compare_price.html(i)),t.featured_media?e.updateVariantMedia(t.featured_media.id):e.updateVariantMedia(0))},t.prototype.updateVariantMedia=function(t){var e,n,i,o,r,s,a;e=this,n=(a=$(".product")).find(".product-page--featured-media .product-page--media"),s=a.find(".content .image-wrapper .product-page--media"),i=a.closest(".modal--root").find(".modal--content .product-page--media"),t&&t!==n.data("id")&&(o=s.filter("[data-id='"+t+"']"),r=i.filter("[data-id='"+t+"']"),e.swapMedia(n,o),e.swapMedia(i.first(),r),e.balanceColumns(),e.reorderModalImages())},t.prototype.pauseOtherMedia=function(){var t;return(t=this).root.find(".product-page--media > *").on("click",(function(){return t.root.find(".product-page--media > *").not(this).trigger("pause-media")}))},t}(),jQuery((function(e){var n,i,o;return n=e("body"),e(".layout--main-content"),e(".template--product .partial--product.view--full .actual-price").addClass("money"),theme.sections=new theme.classes.Sections,i=new theme.classes.FrameworkMediaQueries,theme.utils=new theme.classes.FrameworkUtils,theme.a11y=new theme.classes.FrameworkA11y,theme.utils.mqs=i,theme.utils.a11yClick=function(t){var e;return"click"===t.type||"keypress"===t.type&&(32===(e=t.charCode||t.keyCode)&&t.preventDefault(),32===e||13===e||void 0)},theme.utils.loadJsClasses=function(){return e("[data-js-class]").each((function(){var t,n;if(t=e(this).attr("data-js-class"),"true"!==e(this).attr("data-js-loaded")&&void 0!==(n=theme.classes[t]))return theme.partials[t]=new n(e(this)),e(this).attr("data-js-loaded","true")}))},e("a").each((function(){var t;return t=e(this),this.host===location.host?t.attr("target","_self"):t.attr("target","_blank").attr("rel","noopener")})),"undefined"!=typeof InstallTrigger&&e("img").addClass("image-scale-hack"),e(".fw--align--left").each((function(){return new t(e(this),"left")})),e(".fw--align--center-x").each((function(){return new t(e(this),"center-x")})),e(".fw--align--right").each((function(){return new t(e(this),"right")})),e(".fw--align--top").each((function(){return new t(e(this),"top")})),e(".fw--align--center-y").each((function(){return new t(e(this),"center-y")})),e(".fw--align--bottom").each((function(){return new t(e(this),"bottom")})),e(".partial--popup #mc-embedded-subscribe-form").on("submit",(function(t){return e(".modal .close").click(),!0})),e(".partial--popup #contact_form").on("submit",(function(t){var n,i,o;return n=this,(i=e(this).closest(".partial--popup")).find(".error, .success").remove(),o=i.find(".wrapper"),t.preventDefault(),0===i.find('[type="email"]').val().length||(o.find("*").remove().end().prepend('<p class="success">'+theme.translations.mailing_list_success_message+"</p>").show(),setTimeout((function(){return n.submit()}),500)),!1})),n.hasClass("template--search")&&e(document).on("shopify:section:load",(function(){return checkLogoHeight()})),n.hasClass("template--password")&&(e(document).on("click",".password--login-link",(function(){return e(this).css("visibility","hidden"),e(".password--main > *").hide(),e(".password--login-form").css("visibility","visible"),e('.password--login-form input[type="password"]').focus(),!1})).on("click",".password--login-form .cancel",(function(){return e(".password--login-link").css("visibility","visible"),e(".password--main > *").fadeIn(),e(".password--login-form").css("visibility","hidden"),!1})),e(".password--login-form .errors").size()&&e(".password--login-link").click()),function(){if(e(".sdd-download").length)return e(".sdd-download-button").removeClass("sdd-download-button").css("visibility","visible")}(),theme.utils.loadJsClasses(),o=null,e(window).on("resize",(function(){return clearTimeout(o),o=setTimeout((function(){return e(".fw--align--fill-y--dynamic").each((function(){return new t(e(this),"fill-y--dynamic")}))}),250)})),e("#admin_bar_iframe").on("load",(function(){if("none"===e("#admin_bar_iframe").contents().find("#storefront-bar-minimized").css("display"))return setTimeout((function(){return e("html").css("padding-top","40px")}),10)})),e(".fw--align--fill-y--dynamic").each((function(){return new t(e(this),"fill-y--dynamic")})),e(".fw--align--max-img-height").each((function(){return new t(e(this),"max-img-height")})),e("html").addClass("after-js-loaded"),setTimeout((function(){return e(".owl-carousel").each((function(){return e(this).data("owlCarousel").calculateAll()}))}),0)}))}.call(this);








/* unminified version of theme.min.js*/
/*! jQuery v3.4.1 | (c) JS Foundation and other contributors | jquery.org/license */
/*!
 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
 *
 * @version 1.0.3
 * @codingstandard ftlabs-jsv2
 * @copyright The Financial Times Limited [All Rights Reserved]
 * @license MIT License (see LICENSE.txt)
 */
function t(e, n) {
    var o;
    if (
        ((n = n || {}),
        (this.trackingClick = !1),
        (this.trackingClickStart = 0),
        (this.targetElement = null),
        (this.touchStartX = 0),
        (this.touchStartY = 0),
        (this.lastTouchIdentifier = 0),
        (this.touchBoundary = n.touchBoundary || 10),
        (this.layer = e),
        (this.tapDelay = n.tapDelay || 200),
        !t.notNeeded(e))
    ) {
        for (var r = ["onMouse", "onClick", "onTouchStart", "onTouchMove", "onTouchEnd", "onTouchCancel"], s = this, a = 0, l = r.length; a < l; a++)
            s[r[a]] = (function (t, e) {
                return function () {
                    return t.apply(e, arguments);
                };
            })(s[r[a]], s);
        i && (e.addEventListener("mouseover", this.onMouse, !0), e.addEventListener("mousedown", this.onMouse, !0), e.addEventListener("mouseup", this.onMouse, !0)),
            e.addEventListener("click", this.onClick, !0),
            e.addEventListener("touchstart", this.onTouchStart, !1),
            e.addEventListener("touchmove", this.onTouchMove, !1),
            e.addEventListener("touchend", this.onTouchEnd, !1),
            e.addEventListener("touchcancel", this.onTouchCancel, !1),
            Event.prototype.stopImmediatePropagation ||
                ((e.removeEventListener = function (t, n, i) {
                    var o = Node.prototype.removeEventListener;
                    "click" === t ? o.call(e, t, n.hijacked || n, i) : o.call(e, t, n, i);
                }),
                (e.addEventListener = function (t, n, i) {
                    var o = Node.prototype.addEventListener;
                    "click" === t
                        ? o.call(
                              e,
                              t,
                              n.hijacked ||
                                  (n.hijacked = function (t) {
                                      t.propagationStopped || n(t);
                                  }),
                              i
                          )
                        : o.call(e, t, n, i);
                })),
            "function" == typeof e.onclick &&
                ((o = e.onclick),
                e.addEventListener(
                    "click",
                    function (t) {
                        o(t);
                    },
                    !1
                ),
                (e.onclick = null));
    }
}
var e, n;
(e = "undefined" != typeof window ? window : this),
    (n = function (t, e) {
        function n(t, e, n) {
            var i,
                o,
                r = (n = n || K).createElement("script");
            if (((r.text = t), e)) for (i in pt) (o = e[i] || (e.getAttribute && e.getAttribute(i))) && r.setAttribute(i, o);
            n.head.appendChild(r).parentNode.removeChild(r);
        }
        function i(t) {
            return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? ot[rt.call(t)] || "object" : typeof t;
        }
        function o(t) {
            var e = !!t && "length" in t && t.length,
                n = i(t);
            return !ct(t) && !dt(t) && ("array" === n || 0 === e || ("number" == typeof e && 0 < e && e - 1 in t));
        }
        function r(t, e) {
            return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase();
        }
        function s(t, e, n) {
            return ct(e)
                ? ht.grep(t, function (t, i) {
                      return !!e.call(t, i, t) !== n;
                  })
                : e.nodeType
                ? ht.grep(t, function (t) {
                      return (t === e) !== n;
                  })
                : "string" != typeof e
                ? ht.grep(t, function (t) {
                      return -1 < it.call(e, t) !== n;
                  })
                : ht.filter(e, t, n);
        }
        function a(t, e) {
            for (; (t = t[e]) && 1 !== t.nodeType; );
            return t;
        }
        function l(t) {
            return t;
        }
        function u(t) {
            throw t;
        }
        function c(t, e, n, i) {
            var o;
            try {
                t && ct((o = t.promise)) ? o.call(t).done(e).fail(n) : t && ct((o = t.then)) ? o.call(t, e, n) : e.apply(void 0, [t].slice(i));
            } catch (t) {
                n.apply(void 0, [t]);
            }
        }
        function d() {
            K.removeEventListener("DOMContentLoaded", d), t.removeEventListener("load", d), ht.ready();
        }
        function p(t, e) {
            return e.toUpperCase();
        }
        function h(t) {
            return t.replace(It, "ms-").replace(Pt, p);
        }
        function f() {
            this.expando = ht.expando + f.uid++;
        }
        function m(t, e, n) {
            var i, o;
            if (void 0 === n && 1 === t.nodeType)
                if (((i = "data-" + e.replace(jt, "-$&").toLowerCase()), "string" == typeof (n = t.getAttribute(i)))) {
                    try {
                        n = "true" === (o = n) || ("false" !== o && ("null" === o ? null : o === +o + "" ? +o : Ot.test(o) ? JSON.parse(o) : o));
                    } catch (t) {}
                    $t.set(t, e, n);
                } else n = void 0;
            return n;
        }
        function g(t, e, n, i) {
            var o,
                r,
                s = 20,
                a = i
                    ? function () {
                          return i.cur();
                      }
                    : function () {
                          return ht.css(t, e, "");
                      },
                l = a(),
                u = (n && n[3]) || (ht.cssNumber[e] ? "" : "px"),
                c = t.nodeType && (ht.cssNumber[e] || ("px" !== u && +l)) && Mt.exec(ht.css(t, e));
            if (c && c[3] !== u) {
                for (l /= 2, u = u || c[3], c = +l || 1; s--; ) ht.style(t, e, c + u), (1 - r) * (1 - (r = a() / l || 0.5)) <= 0 && (s = 0), (c /= r);
                (c *= 2), ht.style(t, e, c + u), (n = n || []);
            }
            return n && ((c = +c || +l || 0), (o = n[1] ? c + (n[1] + 1) * n[2] : +n[2]), i && ((i.unit = u), (i.start = c), (i.end = o))), o;
        }
        function v(t, e) {
            for (var n, i, o, r, s, a, l, u = [], c = 0, d = t.length; c < d; c++)
                (i = t[c]).style &&
                    ((n = i.style.display),
                    e
                        ? ("none" === n && ((u[c] = At.get(i, "display") || null), u[c] || (i.style.display = "")),
                          "" === i.style.display &&
                              Vt(i) &&
                              (u[c] =
                                  ((l = s = r = void 0),
                                  (s = (o = i).ownerDocument),
                                  (a = o.nodeName),
                                  (l = Rt[a]) || ((r = s.body.appendChild(s.createElement(a))), (l = ht.css(r, "display")), r.parentNode.removeChild(r), "none" === l && (l = "block"), (Rt[a] = l)))))
                        : "none" !== n && ((u[c] = "none"), At.set(i, "display", n)));
            for (c = 0; c < d; c++) null != u[c] && (t[c].style.display = u[c]);
            return t;
        }
        function y(t, e) {
            var n;
            return (n = void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e || "*") : void 0 !== t.querySelectorAll ? t.querySelectorAll(e || "*") : []), void 0 === e || (e && r(t, e)) ? ht.merge([t], n) : n;
        }
        function w(t, e) {
            for (var n = 0, i = t.length; n < i; n++) At.set(t[n], "globalEval", !e || At.get(e[n], "globalEval"));
        }
        function b(t, e, n, o, r) {
            for (var s, a, l, u, c, d, p = e.createDocumentFragment(), h = [], f = 0, m = t.length; f < m; f++)
                if ((s = t[f]) || 0 === s)
                    if ("object" === i(s)) ht.merge(h, s.nodeType ? [s] : s);
                    else if (Qt.test(s)) {
                        for (a = a || p.appendChild(e.createElement("div")), l = (Bt.exec(s) || ["", ""])[1].toLowerCase(), u = Xt[l] || Xt._default, a.innerHTML = u[1] + ht.htmlPrefilter(s) + u[2], d = u[0]; d--; ) a = a.lastChild;
                        ht.merge(h, a.childNodes), ((a = p.firstChild).textContent = "");
                    } else h.push(e.createTextNode(s));
            for (p.textContent = "", f = 0; (s = h[f++]); )
                if (o && -1 < ht.inArray(s, o)) r && r.push(s);
                else if (((c = Dt(s)), (a = y(p.appendChild(s), "script")), c && w(a), n)) for (d = 0; (s = a[d++]); ) Yt.test(s.type || "") && n.push(s);
            return p;
        }
        function x() {
            return !0;
        }
        function _() {
            return !1;
        }
        function C(t, e) {
            return (
                (t ===
                    (function () {
                        try {
                            return K.activeElement;
                        } catch (t) {}
                    })()) ==
                ("focus" === e)
            );
        }
        function k(t, e, n, i, o, r) {
            var s, a;
            if ("object" == typeof e) {
                for (a in ("string" != typeof n && ((i = i || n), (n = void 0)), e)) k(t, a, n, i, e[a], r);
                return t;
            }
            if ((null == i && null == o ? ((o = n), (i = n = void 0)) : null == o && ("string" == typeof n ? ((o = i), (i = void 0)) : ((o = i), (i = n), (n = void 0))), !1 === o)) o = _;
            else if (!o) return t;
            return (
                1 === r &&
                    ((s = o),
                    ((o = function (t) {
                        return ht().off(t), s.apply(this, arguments);
                    }).guid = s.guid || (s.guid = ht.guid++))),
                t.each(function () {
                    ht.event.add(this, e, o, i, n);
                })
            );
        }
        function T(t, e, n) {
            n
                ? (At.set(t, e, !1),
                  ht.event.add(t, e, {
                      namespace: !1,
                      handler: function (t) {
                          var i,
                              o,
                              r = At.get(this, e);
                          if (1 & t.isTrigger && this[e]) {
                              if (r.length) (ht.event.special[e] || {}).delegateType && t.stopPropagation();
                              else if (((r = tt.call(arguments)), At.set(this, e, r), (i = n(this, e)), this[e](), r !== (o = At.get(this, e)) || i ? At.set(this, e, !1) : (o = {}), r !== o))
                                  return t.stopImmediatePropagation(), t.preventDefault(), o.value;
                          } else r.length && (At.set(this, e, { value: ht.event.trigger(ht.extend(r[0], ht.Event.prototype), r.slice(1), this) }), t.stopImmediatePropagation());
                      },
                  }))
                : void 0 === At.get(t, e) && ht.event.add(t, e, x);
        }
        function S(t, e) {
            return (r(t, "table") && r(11 !== e.nodeType ? e : e.firstChild, "tr") && ht(t).children("tbody")[0]) || t;
        }
        function E(t) {
            return (t.type = (null !== t.getAttribute("type")) + "/" + t.type), t;
        }
        function I(t) {
            return "true/" === (t.type || "").slice(0, 5) ? (t.type = t.type.slice(5)) : t.removeAttribute("type"), t;
        }
        function P(t, e) {
            var n, i, o, r, s, a, l, u;
            if (1 === e.nodeType) {
                if (At.hasData(t) && ((r = At.access(t)), (s = At.set(e, r)), (u = r.events))) for (o in (delete s.handle, (s.events = {}), u)) for (n = 0, i = u[o].length; n < i; n++) ht.event.add(e, o, u[o][n]);
                $t.hasData(t) && ((a = $t.access(t)), (l = ht.extend({}, a)), $t.set(e, l));
            }
        }
        function L(t, e, i, o) {
            e = et.apply([], e);
            var r,
                s,
                a,
                l,
                u,
                c,
                d = 0,
                p = t.length,
                h = p - 1,
                f = e[0],
                m = ct(f);
            if (m || (1 < p && "string" == typeof f && !ut.checkClone && ne.test(f)))
                return t.each(function (n) {
                    var r = t.eq(n);
                    m && (e[0] = f.call(this, n, r.html())), L(r, e, i, o);
                });
            if (p && ((s = (r = b(e, t[0].ownerDocument, !1, t, o)).firstChild), 1 === r.childNodes.length && (r = s), s || o)) {
                for (l = (a = ht.map(y(r, "script"), E)).length; d < p; d++) (u = r), d !== h && ((u = ht.clone(u, !0, !0)), l && ht.merge(a, y(u, "script"))), i.call(t[d], u, d);
                if (l)
                    for (c = a[a.length - 1].ownerDocument, ht.map(a, I), d = 0; d < l; d++)
                        (u = a[d]),
                            Yt.test(u.type || "") &&
                                !At.access(u, "globalEval") &&
                                ht.contains(c, u) &&
                                (u.src && "module" !== (u.type || "").toLowerCase() ? ht._evalUrl && !u.noModule && ht._evalUrl(u.src, { nonce: u.nonce || u.getAttribute("nonce") }) : n(u.textContent.replace(ie, ""), u, c));
            }
            return t;
        }
        function A(t, e, n) {
            for (var i, o = e ? ht.filter(e, t) : t, r = 0; null != (i = o[r]); r++) n || 1 !== i.nodeType || ht.cleanData(y(i)), i.parentNode && (n && Dt(i) && w(y(i, "script")), i.parentNode.removeChild(i));
            return t;
        }
        function $(t, e, n) {
            var i,
                o,
                r,
                s,
                a = t.style;
            return (
                (n = n || re(t)) &&
                    ("" !== (s = n.getPropertyValue(e) || n[e]) || Dt(t) || (s = ht.style(t, e)),
                    !ut.pixelBoxStyles() && oe.test(s) && se.test(e) && ((i = a.width), (o = a.minWidth), (r = a.maxWidth), (a.minWidth = a.maxWidth = a.width = s), (s = n.width), (a.width = i), (a.minWidth = o), (a.maxWidth = r))),
                void 0 !== s ? s + "" : s
            );
        }
        function O(t, e) {
            return {
                get: function () {
                    if (!t()) return (this.get = e).apply(this, arguments);
                    delete this.get;
                },
            };
        }
        function j(t) {
            return (
                ht.cssProps[t] ||
                ue[t] ||
                (t in le
                    ? t
                    : (ue[t] =
                          (function (t) {
                              for (var e = t[0].toUpperCase() + t.slice(1), n = ae.length; n--; ) if ((t = ae[n] + e) in le) return t;
                          })(t) || t))
            );
        }
        function N(t, e, n) {
            var i = Mt.exec(e);
            return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : e;
        }
        function M(t, e, n, i, o, r) {
            var s = "width" === e ? 1 : 0,
                a = 0,
                l = 0;
            if (n === (i ? "border" : "content")) return 0;
            for (; s < 4; s += 2)
                "margin" === n && (l += ht.css(t, n + Ht[s], !0, o)),
                    i
                        ? ("content" === n && (l -= ht.css(t, "padding" + Ht[s], !0, o)), "margin" !== n && (l -= ht.css(t, "border" + Ht[s] + "Width", !0, o)))
                        : ((l += ht.css(t, "padding" + Ht[s], !0, o)), "padding" !== n ? (l += ht.css(t, "border" + Ht[s] + "Width", !0, o)) : (a += ht.css(t, "border" + Ht[s] + "Width", !0, o)));
            return !i && 0 <= r && (l += Math.max(0, Math.ceil(t["offset" + e[0].toUpperCase() + e.slice(1)] - r - l - a - 0.5)) || 0), l;
        }
        function H(t, e, n) {
            var i = re(t),
                o = (!ut.boxSizingReliable() || n) && "border-box" === ht.css(t, "boxSizing", !1, i),
                r = o,
                s = $(t, e, i),
                a = "offset" + e[0].toUpperCase() + e.slice(1);
            if (oe.test(s)) {
                if (!n) return s;
                s = "auto";
            }
            return (
                ((!ut.boxSizingReliable() && o) || "auto" === s || (!parseFloat(s) && "inline" === ht.css(t, "display", !1, i))) &&
                    t.getClientRects().length &&
                    ((o = "border-box" === ht.css(t, "boxSizing", !1, i)), (r = a in t) && (s = t[a])),
                (s = parseFloat(s) || 0) + M(t, e, n || (o ? "border" : "content"), r, i, s) + "px"
            );
        }
        function F(t, e, n, i, o) {
            return new F.prototype.init(t, e, n, i, o);
        }
        function D() {
            me && (!1 === K.hidden && t.requestAnimationFrame ? t.requestAnimationFrame(D) : t.setTimeout(D, ht.fx.interval), ht.fx.tick());
        }
        function z() {
            return (
                t.setTimeout(function () {
                    fe = void 0;
                }),
                (fe = Date.now())
            );
        }
        function V(t, e) {
            var n,
                i = 0,
                o = { height: t };
            for (e = e ? 1 : 0; i < 4; i += 2 - e) o["margin" + (n = Ht[i])] = o["padding" + n] = t;
            return e && (o.opacity = o.width = t), o;
        }
        function q(t, e, n) {
            for (var i, o = (R.tweeners[e] || []).concat(R.tweeners["*"]), r = 0, s = o.length; r < s; r++) if ((i = o[r].call(n, e, t))) return i;
        }
        function R(t, e, n) {
            var i,
                o,
                r = 0,
                s = R.prefilters.length,
                a = ht.Deferred().always(function () {
                    delete l.elem;
                }),
                l = function () {
                    if (o) return !1;
                    for (var e = fe || z(), n = Math.max(0, u.startTime + u.duration - e), i = 1 - (n / u.duration || 0), r = 0, s = u.tweens.length; r < s; r++) u.tweens[r].run(i);
                    return a.notifyWith(t, [u, i, n]), i < 1 && s ? n : (s || a.notifyWith(t, [u, 1, 0]), a.resolveWith(t, [u]), !1);
                },
                u = a.promise({
                    elem: t,
                    props: ht.extend({}, e),
                    opts: ht.extend(!0, { specialEasing: {}, easing: ht.easing._default }, n),
                    originalProperties: e,
                    originalOptions: n,
                    startTime: fe || z(),
                    duration: n.duration,
                    tweens: [],
                    createTween: function (e, n) {
                        var i = ht.Tween(t, u.opts, e, n, u.opts.specialEasing[e] || u.opts.easing);
                        return u.tweens.push(i), i;
                    },
                    stop: function (e) {
                        var n = 0,
                            i = e ? u.tweens.length : 0;
                        if (o) return this;
                        for (o = !0; n < i; n++) u.tweens[n].run(1);
                        return e ? (a.notifyWith(t, [u, 1, 0]), a.resolveWith(t, [u, e])) : a.rejectWith(t, [u, e]), this;
                    },
                }),
                c = u.props;
            for (
                (function (t, e) {
                    var n, i, o, r, s;
                    for (n in t)
                        if (((o = e[(i = h(n))]), (r = t[n]), Array.isArray(r) && ((o = r[1]), (r = t[n] = r[0])), n !== i && ((t[i] = r), delete t[n]), (s = ht.cssHooks[i]) && ("expand" in s)))
                            for (n in ((r = s.expand(r)), delete t[i], r)) (n in t) || ((t[n] = r[n]), (e[n] = o));
                        else e[i] = o;
                })(c, u.opts.specialEasing);
                r < s;
                r++
            )
                if ((i = R.prefilters[r].call(u, t, c, u.opts))) return ct(i.stop) && (ht._queueHooks(u.elem, u.opts.queue).stop = i.stop.bind(i)), i;
            return (
                ht.map(c, q, u),
                ct(u.opts.start) && u.opts.start.call(t, u),
                u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always),
                ht.fx.timer(ht.extend(l, { elem: t, anim: u, queue: u.opts.queue })),
                u
            );
        }
        function W(t) {
            return (t.match(kt) || []).join(" ");
        }
        function B(t) {
            return (t.getAttribute && t.getAttribute("class")) || "";
        }
        function Y(t) {
            return Array.isArray(t) ? t : ("string" == typeof t && t.match(kt)) || [];
        }
        function X(t, e, n, o) {
            var r;
            if (Array.isArray(e))
                ht.each(e, function (e, i) {
                    n || Le.test(t) ? o(t, i) : X(t + "[" + ("object" == typeof i && null != i ? e : "") + "]", i, n, o);
                });
            else if (n || "object" !== i(e)) o(t, e);
            else for (r in e) X(t + "[" + r + "]", e[r], n, o);
        }
        function U(t) {
            return function (e, n) {
                "string" != typeof e && ((n = e), (e = "*"));
                var i,
                    o = 0,
                    r = e.toLowerCase().match(kt) || [];
                if (ct(n)) for (; (i = r[o++]); ) "+" === i[0] ? ((i = i.slice(1) || "*"), (t[i] = t[i] || []).unshift(n)) : (t[i] = t[i] || []).push(n);
            };
        }
        function G(t, e, n, i) {
            function o(a) {
                var l;
                return (
                    (r[a] = !0),
                    ht.each(t[a] || [], function (t, a) {
                        var u = a(e, n, i);
                        return "string" != typeof u || s || r[u] ? (s ? !(l = u) : void 0) : (e.dataTypes.unshift(u), o(u), !1);
                    }),
                    l
                );
            }
            var r = {},
                s = t === Ve;
            return o(e.dataTypes[0]) || (!r["*"] && o("*"));
        }
        function Q(t, e) {
            var n,
                i,
                o = ht.ajaxSettings.flatOptions || {};
            for (n in e) void 0 !== e[n] && ((o[n] ? t : i || (i = {}))[n] = e[n]);
            return i && ht.extend(!0, t, i), t;
        }
        var J = [],
            K = t.document,
            Z = Object.getPrototypeOf,
            tt = J.slice,
            et = J.concat,
            nt = J.push,
            it = J.indexOf,
            ot = {},
            rt = ot.toString,
            st = ot.hasOwnProperty,
            at = st.toString,
            lt = at.call(Object),
            ut = {},
            ct = function (t) {
                return "function" == typeof t && "number" != typeof t.nodeType;
            },
            dt = function (t) {
                return null != t && t === t.window;
            },
            pt = { type: !0, src: !0, nonce: !0, noModule: !0 },
            ht = function (t, e) {
                return new ht.fn.init(t, e);
            },
            ft = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
        (ht.fn = ht.prototype = {
            jquery: "3.4.1",
            constructor: ht,
            length: 0,
            toArray: function () {
                return tt.call(this);
            },
            get: function (t) {
                return null == t ? tt.call(this) : t < 0 ? this[t + this.length] : this[t];
            },
            pushStack: function (t) {
                var e = ht.merge(this.constructor(), t);
                return (e.prevObject = this), e;
            },
            each: function (t) {
                return ht.each(this, t);
            },
            map: function (t) {
                return this.pushStack(
                    ht.map(this, function (e, n) {
                        return t.call(e, n, e);
                    })
                );
            },
            slice: function () {
                return this.pushStack(tt.apply(this, arguments));
            },
            first: function () {
                return this.eq(0);
            },
            last: function () {
                return this.eq(-1);
            },
            eq: function (t) {
                var e = this.length,
                    n = +t + (t < 0 ? e : 0);
                return this.pushStack(0 <= n && n < e ? [this[n]] : []);
            },
            end: function () {
                return this.prevObject || this.constructor();
            },
            push: nt,
            sort: J.sort,
            splice: J.splice,
        }),
            (ht.extend = ht.fn.extend = function () {
                var t,
                    e,
                    n,
                    i,
                    o,
                    r,
                    s = arguments[0] || {},
                    a = 1,
                    l = arguments.length,
                    u = !1;
                for ("boolean" == typeof s && ((u = s), (s = arguments[a] || {}), a++), "object" == typeof s || ct(s) || (s = {}), a === l && ((s = this), a--); a < l; a++)
                    if (null != (t = arguments[a]))
                        for (e in t)
                            (i = t[e]),
                                "__proto__" !== e &&
                                    s !== i &&
                                    (u && i && (ht.isPlainObject(i) || (o = Array.isArray(i)))
                                        ? ((n = s[e]), (r = o && !Array.isArray(n) ? [] : o || ht.isPlainObject(n) ? n : {}), (o = !1), (s[e] = ht.extend(u, r, i)))
                                        : void 0 !== i && (s[e] = i));
                return s;
            }),
            ht.extend({
                expando: "jQuery" + ("3.4.1" + Math.random()).replace(/\D/g, ""),
                isReady: !0,
                error: function (t) {
                    throw new Error(t);
                },
                noop: function () {},
                isPlainObject: function (t) {
                    var e, n;
                    return !(!t || "[object Object]" !== rt.call(t) || ((e = Z(t)) && ("function" != typeof (n = st.call(e, "constructor") && e.constructor) || at.call(n) !== lt)));
                },
                isEmptyObject: function (t) {
                    var e;
                    for (e in t) return !1;
                    return !0;
                },
                globalEval: function (t, e) {
                    n(t, { nonce: e && e.nonce });
                },
                each: function (t, e) {
                    var n,
                        i = 0;
                    if (o(t)) for (n = t.length; i < n && !1 !== e.call(t[i], i, t[i]); i++);
                    else for (i in t) if (!1 === e.call(t[i], i, t[i])) break;
                    return t;
                },
                trim: function (t) {
                    return null == t ? "" : (t + "").replace(ft, "");
                },
                makeArray: function (t, e) {
                    var n = e || [];
                    return null != t && (o(Object(t)) ? ht.merge(n, "string" == typeof t ? [t] : t) : nt.call(n, t)), n;
                },
                inArray: function (t, e, n) {
                    return null == e ? -1 : it.call(e, t, n);
                },
                merge: function (t, e) {
                    for (var n = +e.length, i = 0, o = t.length; i < n; i++) t[o++] = e[i];
                    return (t.length = o), t;
                },
                grep: function (t, e, n) {
                    for (var i = [], o = 0, r = t.length, s = !n; o < r; o++) !e(t[o], o) !== s && i.push(t[o]);
                    return i;
                },
                map: function (t, e, n) {
                    var i,
                        r,
                        s = 0,
                        a = [];
                    if (o(t)) for (i = t.length; s < i; s++) null != (r = e(t[s], s, n)) && a.push(r);
                    else for (s in t) null != (r = e(t[s], s, n)) && a.push(r);
                    return et.apply([], a);
                },
                guid: 1,
                support: ut,
            }),
            "function" == typeof Symbol && (ht.fn[Symbol.iterator] = J[Symbol.iterator]),
            ht.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (t, e) {
                ot["[object " + e + "]"] = e.toLowerCase();
            });
        var mt = (function (t) {
            function e(t, e, n, i) {
                var o,
                    r,
                    s,
                    a,
                    l,
                    c,
                    p,
                    h = e && e.ownerDocument,
                    f = e ? e.nodeType : 9;
                if (((n = n || []), "string" != typeof t || !t || (1 !== f && 9 !== f && 11 !== f))) return n;
                if (!i && ((e ? e.ownerDocument || e : H) !== P && I(e), (e = e || P), A)) {
                    if (11 !== f && (l = mt.exec(t)))
                        if ((o = l[1])) {
                            if (9 === f) {
                                if (!(s = e.getElementById(o))) return n;
                                if (s.id === o) return n.push(s), n;
                            } else if (h && (s = h.getElementById(o)) && N(e, s) && s.id === o) return n.push(s), n;
                        } else {
                            if (l[2]) return G.apply(n, e.getElementsByTagName(t)), n;
                            if ((o = l[3]) && y.getElementsByClassName && e.getElementsByClassName) return G.apply(n, e.getElementsByClassName(o)), n;
                        }
                    if (y.qsa && !R[t + " "] && (!$ || !$.test(t)) && (1 !== f || "object" !== e.nodeName.toLowerCase())) {
                        if (((p = t), (h = e), 1 === f && at.test(t))) {
                            for ((a = e.getAttribute("id")) ? (a = a.replace(wt, bt)) : e.setAttribute("id", (a = M)), r = (c = _(t)).length; r--; ) c[r] = "#" + a + " " + d(c[r]);
                            (p = c.join(",")), (h = (gt.test(t) && u(e.parentNode)) || e);
                        }
                        try {
                            return G.apply(n, h.querySelectorAll(p)), n;
                        } catch (e) {
                            R(t, !0);
                        } finally {
                            a === M && e.removeAttribute("id");
                        }
                    }
                }
                return k(t.replace(ot, "$1"), e, n, i);
            }
            function n() {
                var t = [];
                return function e(n, i) {
                    return t.push(n + " ") > w.cacheLength && delete e[t.shift()], (e[n + " "] = i);
                };
            }
            function i(t) {
                return (t[M] = !0), t;
            }
            function o(t) {
                var e = P.createElement("fieldset");
                try {
                    return !!t(e);
                } catch (t) {
                    return !1;
                } finally {
                    e.parentNode && e.parentNode.removeChild(e), (e = null);
                }
            }
            function r(t, e) {
                for (var n = t.split("|"), i = n.length; i--; ) w.attrHandle[n[i]] = e;
            }
            function s(t, e) {
                var n = e && t,
                    i = n && 1 === t.nodeType && 1 === e.nodeType && t.sourceIndex - e.sourceIndex;
                if (i) return i;
                if (n) for (; (n = n.nextSibling); ) if (n === e) return -1;
                return t ? 1 : -1;
            }
            function a(t) {
                return function (e) {
                    return "form" in e
                        ? e.parentNode && !1 === e.disabled
                            ? "label" in e
                                ? "label" in e.parentNode
                                    ? e.parentNode.disabled === t
                                    : e.disabled === t
                                : e.isDisabled === t || (e.isDisabled !== !t && _t(e) === t)
                            : e.disabled === t
                        : "label" in e && e.disabled === t;
                };
            }
            function l(t) {
                return i(function (e) {
                    return (
                        (e = +e),
                        i(function (n, i) {
                            for (var o, r = t([], n.length, e), s = r.length; s--; ) n[(o = r[s])] && (n[o] = !(i[o] = n[o]));
                        })
                    );
                });
            }
            function u(t) {
                return t && void 0 !== t.getElementsByTagName && t;
            }
            function c() {}
            function d(t) {
                for (var e = 0, n = t.length, i = ""; e < n; e++) i += t[e].value;
                return i;
            }
            function p(t, e, n) {
                var i = e.dir,
                    o = e.next,
                    r = o || i,
                    s = n && "parentNode" === r,
                    a = D++;
                return e.first
                    ? function (e, n, o) {
                          for (; (e = e[i]); ) if (1 === e.nodeType || s) return t(e, n, o);
                          return !1;
                      }
                    : function (e, n, l) {
                          var u,
                              c,
                              d,
                              p = [F, a];
                          if (l) {
                              for (; (e = e[i]); ) if ((1 === e.nodeType || s) && t(e, n, l)) return !0;
                          } else
                              for (; (e = e[i]); )
                                  if (1 === e.nodeType || s)
                                      if (((c = (d = e[M] || (e[M] = {}))[e.uniqueID] || (d[e.uniqueID] = {})), o && o === e.nodeName.toLowerCase())) e = e[i] || e;
                                      else {
                                          if ((u = c[r]) && u[0] === F && u[1] === a) return (p[2] = u[2]);
                                          if (((c[r] = p)[2] = t(e, n, l))) return !0;
                                      }
                          return !1;
                      };
            }
            function h(t) {
                return 1 < t.length
                    ? function (e, n, i) {
                          for (var o = t.length; o--; ) if (!t[o](e, n, i)) return !1;
                          return !0;
                      }
                    : t[0];
            }
            function f(t, e, n, i, o) {
                for (var r, s = [], a = 0, l = t.length, u = null != e; a < l; a++) (r = t[a]) && ((n && !n(r, i, o)) || (s.push(r), u && e.push(a)));
                return s;
            }
            function m(t, n, o, r, s, a) {
                return (
                    r && !r[M] && (r = m(r)),
                    s && !s[M] && (s = m(s, a)),
                    i(function (i, a, l, u) {
                        var c,
                            d,
                            p,
                            h = [],
                            m = [],
                            g = a.length,
                            v =
                                i ||
                                (function (t, n, i) {
                                    for (var o = 0, r = n.length; o < r; o++) e(t, n[o], i);
                                    return i;
                                })(n || "*", l.nodeType ? [l] : l, []),
                            y = !t || (!i && n) ? v : f(v, h, t, l, u),
                            w = o ? (s || (i ? t : g || r) ? [] : a) : y;
                        if ((o && o(y, w, l, u), r)) for (c = f(w, m), r(c, [], l, u), d = c.length; d--; ) (p = c[d]) && (w[m[d]] = !(y[m[d]] = p));
                        if (i) {
                            if (s || t) {
                                if (s) {
                                    for (c = [], d = w.length; d--; ) (p = w[d]) && c.push((y[d] = p));
                                    s(null, (w = []), c, u);
                                }
                                for (d = w.length; d--; ) (p = w[d]) && -1 < (c = s ? J(i, p) : h[d]) && (i[c] = !(a[c] = p));
                            }
                        } else (w = f(w === a ? w.splice(g, w.length) : w)), s ? s(null, a, w, u) : G.apply(a, w);
                    })
                );
            }
            function g(t) {
                for (
                    var e,
                        n,
                        i,
                        o = t.length,
                        r = w.relative[t[0].type],
                        s = r || w.relative[" "],
                        a = r ? 1 : 0,
                        l = p(
                            function (t) {
                                return t === e;
                            },
                            s,
                            !0
                        ),
                        u = p(
                            function (t) {
                                return -1 < J(e, t);
                            },
                            s,
                            !0
                        ),
                        c = [
                            function (t, n, i) {
                                var o = (!r && (i || n !== T)) || ((e = n).nodeType ? l(t, n, i) : u(t, n, i));
                                return (e = null), o;
                            },
                        ];
                    a < o;
                    a++
                )
                    if ((n = w.relative[t[a].type])) c = [p(h(c), n)];
                    else {
                        if ((n = w.filter[t[a].type].apply(null, t[a].matches))[M]) {
                            for (i = ++a; i < o && !w.relative[t[i].type]; i++);
                            return m(1 < a && h(c), 1 < a && d(t.slice(0, a - 1).concat({ value: " " === t[a - 2].type ? "*" : "" })).replace(ot, "$1"), n, a < i && g(t.slice(a, i)), i < o && g((t = t.slice(i))), i < o && d(t));
                        }
                        c.push(n);
                    }
                return h(c);
            }
            var v,
                y,
                w,
                b,
                x,
                _,
                C,
                k,
                T,
                S,
                E,
                I,
                P,
                L,
                A,
                $,
                O,
                j,
                N,
                M = "sizzle" + 1 * new Date(),
                H = t.document,
                F = 0,
                D = 0,
                z = n(),
                V = n(),
                q = n(),
                R = n(),
                W = function (t, e) {
                    return t === e && (E = !0), 0;
                },
                B = {}.hasOwnProperty,
                Y = [],
                X = Y.pop,
                U = Y.push,
                G = Y.push,
                Q = Y.slice,
                J = function (t, e) {
                    for (var n = 0, i = t.length; n < i; n++) if (t[n] === e) return n;
                    return -1;
                },
                K = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                Z = "[\\x20\\t\\r\\n\\f]",
                tt = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
                et = "\\[" + Z + "*(" + tt + ")(?:" + Z + "*([*^$|!~]?=)" + Z + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + tt + "))|)" + Z + "*\\]",
                nt = ":(" + tt + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + et + ")*)|.*)\\)|)",
                it = new RegExp(Z + "+", "g"),
                ot = new RegExp("^" + Z + "+|((?:^|[^\\\\])(?:\\\\.)*)" + Z + "+$", "g"),
                rt = new RegExp("^" + Z + "*," + Z + "*"),
                st = new RegExp("^" + Z + "*([>+~]|" + Z + ")" + Z + "*"),
                at = new RegExp(Z + "|>"),
                lt = new RegExp(nt),
                ut = new RegExp("^" + tt + "$"),
                ct = {
                    ID: new RegExp("^#(" + tt + ")"),
                    CLASS: new RegExp("^\\.(" + tt + ")"),
                    TAG: new RegExp("^(" + tt + "|[*])"),
                    ATTR: new RegExp("^" + et),
                    PSEUDO: new RegExp("^" + nt),
                    CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + Z + "*(even|odd|(([+-]|)(\\d*)n|)" + Z + "*(?:([+-]|)" + Z + "*(\\d+)|))" + Z + "*\\)|)", "i"),
                    bool: new RegExp("^(?:" + K + ")$", "i"),
                    needsContext: new RegExp("^" + Z + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + Z + "*((?:-\\d)?\\d*)" + Z + "*\\)|)(?=[^-]|$)", "i"),
                },
                dt = /HTML$/i,
                pt = /^(?:input|select|textarea|button)$/i,
                ht = /^h\d$/i,
                ft = /^[^{]+\{\s*\[native \w/,
                mt = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                gt = /[+~]/,
                vt = new RegExp("\\\\([\\da-f]{1,6}" + Z + "?|(" + Z + ")|.)", "ig"),
                yt = function (t, e, n) {
                    var i = "0x" + e - 65536;
                    return i != i || n ? e : i < 0 ? String.fromCharCode(i + 65536) : String.fromCharCode((i >> 10) | 55296, (1023 & i) | 56320);
                },
                wt = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                bt = function (t, e) {
                    return e ? ("\0" === t ? "�" : t.slice(0, -1) + "\\" + t.charCodeAt(t.length - 1).toString(16) + " ") : "\\" + t;
                },
                xt = function () {
                    I();
                },
                _t = p(
                    function (t) {
                        return !0 === t.disabled && "fieldset" === t.nodeName.toLowerCase();
                    },
                    { dir: "parentNode", next: "legend" }
                );
            try {
                G.apply((Y = Q.call(H.childNodes)), H.childNodes), Y[H.childNodes.length].nodeType;
            } catch (v) {
                G = {
                    apply: Y.length
                        ? function (t, e) {
                              U.apply(t, Q.call(e));
                          }
                        : function (t, e) {
                              for (var n = t.length, i = 0; (t[n++] = e[i++]); );
                              t.length = n - 1;
                          },
                };
            }
            for (v in ((y = e.support = {}),
            (x = e.isXML = function (t) {
                var e = t.namespaceURI,
                    n = (t.ownerDocument || t).documentElement;
                return !dt.test(e || (n && n.nodeName) || "HTML");
            }),
            (I = e.setDocument = function (t) {
                var e,
                    n,
                    i = t ? t.ownerDocument || t : H;
                return (
                    i !== P &&
                        9 === i.nodeType &&
                        i.documentElement &&
                        ((L = (P = i).documentElement),
                        (A = !x(P)),
                        H !== P && (n = P.defaultView) && n.top !== n && (n.addEventListener ? n.addEventListener("unload", xt, !1) : n.attachEvent && n.attachEvent("onunload", xt)),
                        (y.attributes = o(function (t) {
                            return (t.className = "i"), !t.getAttribute("className");
                        })),
                        (y.getElementsByTagName = o(function (t) {
                            return t.appendChild(P.createComment("")), !t.getElementsByTagName("*").length;
                        })),
                        (y.getElementsByClassName = ft.test(P.getElementsByClassName)),
                        (y.getById = o(function (t) {
                            return (L.appendChild(t).id = M), !P.getElementsByName || !P.getElementsByName(M).length;
                        })),
                        y.getById
                            ? ((w.filter.ID = function (t) {
                                  var e = t.replace(vt, yt);
                                  return function (t) {
                                      return t.getAttribute("id") === e;
                                  };
                              }),
                              (w.find.ID = function (t, e) {
                                  if (void 0 !== e.getElementById && A) {
                                      var n = e.getElementById(t);
                                      return n ? [n] : [];
                                  }
                              }))
                            : ((w.filter.ID = function (t) {
                                  var e = t.replace(vt, yt);
                                  return function (t) {
                                      var n = void 0 !== t.getAttributeNode && t.getAttributeNode("id");
                                      return n && n.value === e;
                                  };
                              }),
                              (w.find.ID = function (t, e) {
                                  if (void 0 !== e.getElementById && A) {
                                      var n,
                                          i,
                                          o,
                                          r = e.getElementById(t);
                                      if (r) {
                                          if ((n = r.getAttributeNode("id")) && n.value === t) return [r];
                                          for (o = e.getElementsByName(t), i = 0; (r = o[i++]); ) if ((n = r.getAttributeNode("id")) && n.value === t) return [r];
                                      }
                                      return [];
                                  }
                              })),
                        (w.find.TAG = y.getElementsByTagName
                            ? function (t, e) {
                                  return void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t) : y.qsa ? e.querySelectorAll(t) : void 0;
                              }
                            : function (t, e) {
                                  var n,
                                      i = [],
                                      o = 0,
                                      r = e.getElementsByTagName(t);
                                  if ("*" === t) {
                                      for (; (n = r[o++]); ) 1 === n.nodeType && i.push(n);
                                      return i;
                                  }
                                  return r;
                              }),
                        (w.find.CLASS =
                            y.getElementsByClassName &&
                            function (t, e) {
                                if (void 0 !== e.getElementsByClassName && A) return e.getElementsByClassName(t);
                            }),
                        (O = []),
                        ($ = []),
                        (y.qsa = ft.test(P.querySelectorAll)) &&
                            (o(function (t) {
                                (L.appendChild(t).innerHTML = "<a id='" + M + "'></a><select id='" + M + "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                                    t.querySelectorAll("[msallowcapture^='']").length && $.push("[*^$]=" + Z + "*(?:''|\"\")"),
                                    t.querySelectorAll("[selected]").length || $.push("\\[" + Z + "*(?:value|" + K + ")"),
                                    t.querySelectorAll("[id~=" + M + "-]").length || $.push("~="),
                                    t.querySelectorAll(":checked").length || $.push(":checked"),
                                    t.querySelectorAll("a#" + M + "+*").length || $.push(".#.+[+~]");
                            }),
                            o(function (t) {
                                t.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                                var e = P.createElement("input");
                                e.setAttribute("type", "hidden"),
                                    t.appendChild(e).setAttribute("name", "D"),
                                    t.querySelectorAll("[name=d]").length && $.push("name" + Z + "*[*^$|!~]?="),
                                    2 !== t.querySelectorAll(":enabled").length && $.push(":enabled", ":disabled"),
                                    (L.appendChild(t).disabled = !0),
                                    2 !== t.querySelectorAll(":disabled").length && $.push(":enabled", ":disabled"),
                                    t.querySelectorAll("*,:x"),
                                    $.push(",.*:");
                            })),
                        (y.matchesSelector = ft.test((j = L.matches || L.webkitMatchesSelector || L.mozMatchesSelector || L.oMatchesSelector || L.msMatchesSelector))) &&
                            o(function (t) {
                                (y.disconnectedMatch = j.call(t, "*")), j.call(t, "[s!='']:x"), O.push("!=", nt);
                            }),
                        ($ = $.length && new RegExp($.join("|"))),
                        (O = O.length && new RegExp(O.join("|"))),
                        (e = ft.test(L.compareDocumentPosition)),
                        (N =
                            e || ft.test(L.contains)
                                ? function (t, e) {
                                      var n = 9 === t.nodeType ? t.documentElement : t,
                                          i = e && e.parentNode;
                                      return t === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : t.compareDocumentPosition && 16 & t.compareDocumentPosition(i)));
                                  }
                                : function (t, e) {
                                      if (e) for (; (e = e.parentNode); ) if (e === t) return !0;
                                      return !1;
                                  }),
                        (W = e
                            ? function (t, e) {
                                  if (t === e) return (E = !0), 0;
                                  var n = !t.compareDocumentPosition - !e.compareDocumentPosition;
                                  return (
                                      n ||
                                      (1 & (n = (t.ownerDocument || t) === (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1) || (!y.sortDetached && e.compareDocumentPosition(t) === n)
                                          ? t === P || (t.ownerDocument === H && N(H, t))
                                              ? -1
                                              : e === P || (e.ownerDocument === H && N(H, e))
                                              ? 1
                                              : S
                                              ? J(S, t) - J(S, e)
                                              : 0
                                          : 4 & n
                                          ? -1
                                          : 1)
                                  );
                              }
                            : function (t, e) {
                                  if (t === e) return (E = !0), 0;
                                  var n,
                                      i = 0,
                                      o = t.parentNode,
                                      r = e.parentNode,
                                      a = [t],
                                      l = [e];
                                  if (!o || !r) return t === P ? -1 : e === P ? 1 : o ? -1 : r ? 1 : S ? J(S, t) - J(S, e) : 0;
                                  if (o === r) return s(t, e);
                                  for (n = t; (n = n.parentNode); ) a.unshift(n);
                                  for (n = e; (n = n.parentNode); ) l.unshift(n);
                                  for (; a[i] === l[i]; ) i++;
                                  return i ? s(a[i], l[i]) : a[i] === H ? -1 : l[i] === H ? 1 : 0;
                              })),
                    P
                );
            }),
            (e.matches = function (t, n) {
                return e(t, null, null, n);
            }),
            (e.matchesSelector = function (t, n) {
                if (((t.ownerDocument || t) !== P && I(t), y.matchesSelector && A && !R[n + " "] && (!O || !O.test(n)) && (!$ || !$.test(n))))
                    try {
                        var i = j.call(t, n);
                        if (i || y.disconnectedMatch || (t.document && 11 !== t.document.nodeType)) return i;
                    } catch (t) {
                        R(n, !0);
                    }
                return 0 < e(n, P, null, [t]).length;
            }),
            (e.contains = function (t, e) {
                return (t.ownerDocument || t) !== P && I(t), N(t, e);
            }),
            (e.attr = function (t, e) {
                (t.ownerDocument || t) !== P && I(t);
                var n = w.attrHandle[e.toLowerCase()],
                    i = n && B.call(w.attrHandle, e.toLowerCase()) ? n(t, e, !A) : void 0;
                return void 0 !== i ? i : y.attributes || !A ? t.getAttribute(e) : (i = t.getAttributeNode(e)) && i.specified ? i.value : null;
            }),
            (e.escape = function (t) {
                return (t + "").replace(wt, bt);
            }),
            (e.error = function (t) {
                throw new Error("Syntax error, unrecognized expression: " + t);
            }),
            (e.uniqueSort = function (t) {
                var e,
                    n = [],
                    i = 0,
                    o = 0;
                if (((E = !y.detectDuplicates), (S = !y.sortStable && t.slice(0)), t.sort(W), E)) {
                    for (; (e = t[o++]); ) e === t[o] && (i = n.push(o));
                    for (; i--; ) t.splice(n[i], 1);
                }
                return (S = null), t;
            }),
            (b = e.getText = function (t) {
                var e,
                    n = "",
                    i = 0,
                    o = t.nodeType;
                if (o) {
                    if (1 === o || 9 === o || 11 === o) {
                        if ("string" == typeof t.textContent) return t.textContent;
                        for (t = t.firstChild; t; t = t.nextSibling) n += b(t);
                    } else if (3 === o || 4 === o) return t.nodeValue;
                } else for (; (e = t[i++]); ) n += b(e);
                return n;
            }),
            ((w = e.selectors = {
                cacheLength: 50,
                createPseudo: i,
                match: ct,
                attrHandle: {},
                find: {},
                relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } },
                preFilter: {
                    ATTR: function (t) {
                        return (t[1] = t[1].replace(vt, yt)), (t[3] = (t[3] || t[4] || t[5] || "").replace(vt, yt)), "~=" === t[2] && (t[3] = " " + t[3] + " "), t.slice(0, 4);
                    },
                    CHILD: function (t) {
                        return (
                            (t[1] = t[1].toLowerCase()),
                            "nth" === t[1].slice(0, 3) ? (t[3] || e.error(t[0]), (t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ("even" === t[3] || "odd" === t[3]))), (t[5] = +(t[7] + t[8] || "odd" === t[3]))) : t[3] && e.error(t[0]),
                            t
                        );
                    },
                    PSEUDO: function (t) {
                        var e,
                            n = !t[6] && t[2];
                        return ct.CHILD.test(t[0])
                            ? null
                            : (t[3] ? (t[2] = t[4] || t[5] || "") : n && lt.test(n) && (e = _(n, !0)) && (e = n.indexOf(")", n.length - e) - n.length) && ((t[0] = t[0].slice(0, e)), (t[2] = n.slice(0, e))), t.slice(0, 3));
                    },
                },
                filter: {
                    TAG: function (t) {
                        var e = t.replace(vt, yt).toLowerCase();
                        return "*" === t
                            ? function () {
                                  return !0;
                              }
                            : function (t) {
                                  return t.nodeName && t.nodeName.toLowerCase() === e;
                              };
                    },
                    CLASS: function (t) {
                        var e = z[t + " "];
                        return (
                            e ||
                            ((e = new RegExp("(^|" + Z + ")" + t + "(" + Z + "|$)")) &&
                                z(t, function (t) {
                                    return e.test(("string" == typeof t.className && t.className) || (void 0 !== t.getAttribute && t.getAttribute("class")) || "");
                                }))
                        );
                    },
                    ATTR: function (t, n, i) {
                        return function (o) {
                            var r = e.attr(o, t);
                            return null == r
                                ? "!=" === n
                                : !n ||
                                      ((r += ""),
                                      "=" === n
                                          ? r === i
                                          : "!=" === n
                                          ? r !== i
                                          : "^=" === n
                                          ? i && 0 === r.indexOf(i)
                                          : "*=" === n
                                          ? i && -1 < r.indexOf(i)
                                          : "$=" === n
                                          ? i && r.slice(-i.length) === i
                                          : "~=" === n
                                          ? -1 < (" " + r.replace(it, " ") + " ").indexOf(i)
                                          : "|=" === n && (r === i || r.slice(0, i.length + 1) === i + "-"));
                        };
                    },
                    CHILD: function (t, e, n, i, o) {
                        var r = "nth" !== t.slice(0, 3),
                            s = "last" !== t.slice(-4),
                            a = "of-type" === e;
                        return 1 === i && 0 === o
                            ? function (t) {
                                  return !!t.parentNode;
                              }
                            : function (e, n, l) {
                                  var u,
                                      c,
                                      d,
                                      p,
                                      h,
                                      f,
                                      m = r !== s ? "nextSibling" : "previousSibling",
                                      g = e.parentNode,
                                      v = a && e.nodeName.toLowerCase(),
                                      y = !l && !a,
                                      w = !1;
                                  if (g) {
                                      if (r) {
                                          for (; m; ) {
                                              for (p = e; (p = p[m]); ) if (a ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) return !1;
                                              f = m = "only" === t && !f && "nextSibling";
                                          }
                                          return !0;
                                      }
                                      if (((f = [s ? g.firstChild : g.lastChild]), s && y)) {
                                          for (
                                              w = (h = (u = (c = (d = (p = g)[M] || (p[M] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[t] || [])[0] === F && u[1]) && u[2], p = h && g.childNodes[h];
                                              (p = (++h && p && p[m]) || (w = h = 0) || f.pop());

                                          )
                                              if (1 === p.nodeType && ++w && p === e) {
                                                  c[t] = [F, h, w];
                                                  break;
                                              }
                                      } else if ((y && (w = h = (u = (c = (d = (p = e)[M] || (p[M] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[t] || [])[0] === F && u[1]), !1 === w))
                                          for (
                                              ;
                                              (p = (++h && p && p[m]) || (w = h = 0) || f.pop()) &&
                                              ((a ? p.nodeName.toLowerCase() !== v : 1 !== p.nodeType) || !++w || (y && ((c = (d = p[M] || (p[M] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[t] = [F, w]), p !== e));

                                          );
                                      return (w -= o) === i || (w % i == 0 && 0 <= w / i);
                                  }
                              };
                    },
                    PSEUDO: function (t, n) {
                        var o,
                            r = w.pseudos[t] || w.setFilters[t.toLowerCase()] || e.error("unsupported pseudo: " + t);
                        return r[M]
                            ? r(n)
                            : 1 < r.length
                            ? ((o = [t, t, "", n]),
                              w.setFilters.hasOwnProperty(t.toLowerCase())
                                  ? i(function (t, e) {
                                        for (var i, o = r(t, n), s = o.length; s--; ) t[(i = J(t, o[s]))] = !(e[i] = o[s]);
                                    })
                                  : function (t) {
                                        return r(t, 0, o);
                                    })
                            : r;
                    },
                },
                pseudos: {
                    not: i(function (t) {
                        var e = [],
                            n = [],
                            o = C(t.replace(ot, "$1"));
                        return o[M]
                            ? i(function (t, e, n, i) {
                                  for (var r, s = o(t, null, i, []), a = t.length; a--; ) (r = s[a]) && (t[a] = !(e[a] = r));
                              })
                            : function (t, i, r) {
                                  return (e[0] = t), o(e, null, r, n), (e[0] = null), !n.pop();
                              };
                    }),
                    has: i(function (t) {
                        return function (n) {
                            return 0 < e(t, n).length;
                        };
                    }),
                    contains: i(function (t) {
                        return (
                            (t = t.replace(vt, yt)),
                            function (e) {
                                return -1 < (e.textContent || b(e)).indexOf(t);
                            }
                        );
                    }),
                    lang: i(function (t) {
                        return (
                            ut.test(t || "") || e.error("unsupported lang: " + t),
                            (t = t.replace(vt, yt).toLowerCase()),
                            function (e) {
                                var n;
                                do {
                                    if ((n = A ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang"))) return (n = n.toLowerCase()) === t || 0 === n.indexOf(t + "-");
                                } while ((e = e.parentNode) && 1 === e.nodeType);
                                return !1;
                            }
                        );
                    }),
                    target: function (e) {
                        var n = t.location && t.location.hash;
                        return n && n.slice(1) === e.id;
                    },
                    root: function (t) {
                        return t === L;
                    },
                    focus: function (t) {
                        return t === P.activeElement && (!P.hasFocus || P.hasFocus()) && !!(t.type || t.href || ~t.tabIndex);
                    },
                    enabled: a(!1),
                    disabled: a(!0),
                    checked: function (t) {
                        var e = t.nodeName.toLowerCase();
                        return ("input" === e && !!t.checked) || ("option" === e && !!t.selected);
                    },
                    selected: function (t) {
                        return t.parentNode && t.parentNode.selectedIndex, !0 === t.selected;
                    },
                    empty: function (t) {
                        for (t = t.firstChild; t; t = t.nextSibling) if (t.nodeType < 6) return !1;
                        return !0;
                    },
                    parent: function (t) {
                        return !w.pseudos.empty(t);
                    },
                    header: function (t) {
                        return ht.test(t.nodeName);
                    },
                    input: function (t) {
                        return pt.test(t.nodeName);
                    },
                    button: function (t) {
                        var e = t.nodeName.toLowerCase();
                        return ("input" === e && "button" === t.type) || "button" === e;
                    },
                    text: function (t) {
                        var e;
                        return "input" === t.nodeName.toLowerCase() && "text" === t.type && (null == (e = t.getAttribute("type")) || "text" === e.toLowerCase());
                    },
                    first: l(function () {
                        return [0];
                    }),
                    last: l(function (t, e) {
                        return [e - 1];
                    }),
                    eq: l(function (t, e, n) {
                        return [n < 0 ? n + e : n];
                    }),
                    even: l(function (t, e) {
                        for (var n = 0; n < e; n += 2) t.push(n);
                        return t;
                    }),
                    odd: l(function (t, e) {
                        for (var n = 1; n < e; n += 2) t.push(n);
                        return t;
                    }),
                    lt: l(function (t, e, n) {
                        for (var i = n < 0 ? n + e : e < n ? e : n; 0 <= --i; ) t.push(i);
                        return t;
                    }),
                    gt: l(function (t, e, n) {
                        for (var i = n < 0 ? n + e : n; ++i < e; ) t.push(i);
                        return t;
                    }),
                },
            }).pseudos.nth = w.pseudos.eq),
            { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
                w.pseudos[v] = (function (t) {
                    return function (e) {
                        return "input" === e.nodeName.toLowerCase() && e.type === t;
                    };
                })(v);
            for (v in { submit: !0, reset: !0 })
                w.pseudos[v] = (function (t) {
                    return function (e) {
                        var n = e.nodeName.toLowerCase();
                        return ("input" === n || "button" === n) && e.type === t;
                    };
                })(v);
            return (
                (c.prototype = w.filters = w.pseudos),
                (w.setFilters = new c()),
                (_ = e.tokenize = function (t, n) {
                    var i,
                        o,
                        r,
                        s,
                        a,
                        l,
                        u,
                        c = V[t + " "];
                    if (c) return n ? 0 : c.slice(0);
                    for (a = t, l = [], u = w.preFilter; a; ) {
                        for (s in ((i && !(o = rt.exec(a))) || (o && (a = a.slice(o[0].length) || a), l.push((r = []))),
                        (i = !1),
                        (o = st.exec(a)) && ((i = o.shift()), r.push({ value: i, type: o[0].replace(ot, " ") }), (a = a.slice(i.length))),
                        w.filter))
                            !(o = ct[s].exec(a)) || (u[s] && !(o = u[s](o))) || ((i = o.shift()), r.push({ value: i, type: s, matches: o }), (a = a.slice(i.length)));
                        if (!i) break;
                    }
                    return n ? a.length : a ? e.error(t) : V(t, l).slice(0);
                }),
                (C = e.compile = function (t, n) {
                    var o,
                        r,
                        s,
                        a,
                        l,
                        u,
                        c = [],
                        d = [],
                        p = q[t + " "];
                    if (!p) {
                        for (n || (n = _(t)), o = n.length; o--; ) (p = g(n[o]))[M] ? c.push(p) : d.push(p);
                        (p = q(
                            t,
                            ((r = d),
                            (a = 0 < (s = c).length),
                            (l = 0 < r.length),
                            (u = function (t, n, i, o, u) {
                                var c,
                                    d,
                                    p,
                                    h = 0,
                                    m = "0",
                                    g = t && [],
                                    v = [],
                                    y = T,
                                    b = t || (l && w.find.TAG("*", u)),
                                    x = (F += null == y ? 1 : Math.random() || 0.1),
                                    _ = b.length;
                                for (u && (T = n === P || n || u); m !== _ && null != (c = b[m]); m++) {
                                    if (l && c) {
                                        for (d = 0, n || c.ownerDocument === P || (I(c), (i = !A)); (p = r[d++]); )
                                            if (p(c, n || P, i)) {
                                                o.push(c);
                                                break;
                                            }
                                        u && (F = x);
                                    }
                                    a && ((c = !p && c) && h--, t && g.push(c));
                                }
                                if (((h += m), a && m !== h)) {
                                    for (d = 0; (p = s[d++]); ) p(g, v, n, i);
                                    if (t) {
                                        if (0 < h) for (; m--; ) g[m] || v[m] || (v[m] = X.call(o));
                                        v = f(v);
                                    }
                                    G.apply(o, v), u && !t && 0 < v.length && 1 < h + s.length && e.uniqueSort(o);
                                }
                                return u && ((F = x), (T = y)), g;
                            }),
                            a ? i(u) : u)
                        )).selector = t;
                    }
                    return p;
                }),
                (k = e.select = function (t, e, n, i) {
                    var o,
                        r,
                        s,
                        a,
                        l,
                        c = "function" == typeof t && t,
                        p = !i && _((t = c.selector || t));
                    if (((n = n || []), 1 === p.length)) {
                        if (2 < (r = p[0] = p[0].slice(0)).length && "ID" === (s = r[0]).type && 9 === e.nodeType && A && w.relative[r[1].type]) {
                            if (!(e = (w.find.ID(s.matches[0].replace(vt, yt), e) || [])[0])) return n;
                            c && (e = e.parentNode), (t = t.slice(r.shift().value.length));
                        }
                        for (o = ct.needsContext.test(t) ? 0 : r.length; o-- && ((s = r[o]), !w.relative[(a = s.type)]); )
                            if ((l = w.find[a]) && (i = l(s.matches[0].replace(vt, yt), (gt.test(r[0].type) && u(e.parentNode)) || e))) {
                                if ((r.splice(o, 1), !(t = i.length && d(r)))) return G.apply(n, i), n;
                                break;
                            }
                    }
                    return (c || C(t, p))(i, e, !A, n, !e || (gt.test(t) && u(e.parentNode)) || e), n;
                }),
                (y.sortStable = M.split("").sort(W).join("") === M),
                (y.detectDuplicates = !!E),
                I(),
                (y.sortDetached = o(function (t) {
                    return 1 & t.compareDocumentPosition(P.createElement("fieldset"));
                })),
                o(function (t) {
                    return (t.innerHTML = "<a href='#'></a>"), "#" === t.firstChild.getAttribute("href");
                }) ||
                    r("type|href|height|width", function (t, e, n) {
                        if (!n) return t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2);
                    }),
                (y.attributes &&
                    o(function (t) {
                        return (t.innerHTML = "<input/>"), t.firstChild.setAttribute("value", ""), "" === t.firstChild.getAttribute("value");
                    })) ||
                    r("value", function (t, e, n) {
                        if (!n && "input" === t.nodeName.toLowerCase()) return t.defaultValue;
                    }),
                o(function (t) {
                    return null == t.getAttribute("disabled");
                }) ||
                    r(K, function (t, e, n) {
                        var i;
                        if (!n) return !0 === t[e] ? e.toLowerCase() : (i = t.getAttributeNode(e)) && i.specified ? i.value : null;
                    }),
                e
            );
        })(t);
        (ht.find = mt), (ht.expr = mt.selectors), (ht.expr[":"] = ht.expr.pseudos), (ht.uniqueSort = ht.unique = mt.uniqueSort), (ht.text = mt.getText), (ht.isXMLDoc = mt.isXML), (ht.contains = mt.contains), (ht.escapeSelector = mt.escape);
        var gt = function (t, e, n) {
                for (var i = [], o = void 0 !== n; (t = t[e]) && 9 !== t.nodeType; )
                    if (1 === t.nodeType) {
                        if (o && ht(t).is(n)) break;
                        i.push(t);
                    }
                return i;
            },
            vt = function (t, e) {
                for (var n = []; t; t = t.nextSibling) 1 === t.nodeType && t !== e && n.push(t);
                return n;
            },
            yt = ht.expr.match.needsContext,
            wt = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
        (ht.filter = function (t, e, n) {
            var i = e[0];
            return (
                n && (t = ":not(" + t + ")"),
                1 === e.length && 1 === i.nodeType
                    ? ht.find.matchesSelector(i, t)
                        ? [i]
                        : []
                    : ht.find.matches(
                          t,
                          ht.grep(e, function (t) {
                              return 1 === t.nodeType;
                          })
                      )
            );
        }),
            ht.fn.extend({
                find: function (t) {
                    var e,
                        n,
                        i = this.length,
                        o = this;
                    if ("string" != typeof t)
                        return this.pushStack(
                            ht(t).filter(function () {
                                for (e = 0; e < i; e++) if (ht.contains(o[e], this)) return !0;
                            })
                        );
                    for (n = this.pushStack([]), e = 0; e < i; e++) ht.find(t, o[e], n);
                    return 1 < i ? ht.uniqueSort(n) : n;
                },
                filter: function (t) {
                    return this.pushStack(s(this, t || [], !1));
                },
                not: function (t) {
                    return this.pushStack(s(this, t || [], !0));
                },
                is: function (t) {
                    return !!s(this, "string" == typeof t && yt.test(t) ? ht(t) : t || [], !1).length;
                },
            });
        var bt,
            xt = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
        ((ht.fn.init = function (t, e, n) {
            var i, o;
            if (!t) return this;
            if (((n = n || bt), "string" == typeof t)) {
                if (!(i = "<" === t[0] && ">" === t[t.length - 1] && 3 <= t.length ? [null, t, null] : xt.exec(t)) || (!i[1] && e)) return !e || e.jquery ? (e || n).find(t) : this.constructor(e).find(t);
                if (i[1]) {
                    if (((e = e instanceof ht ? e[0] : e), ht.merge(this, ht.parseHTML(i[1], e && e.nodeType ? e.ownerDocument || e : K, !0)), wt.test(i[1]) && ht.isPlainObject(e)))
                        for (i in e) ct(this[i]) ? this[i](e[i]) : this.attr(i, e[i]);
                    return this;
                }
                return (o = K.getElementById(i[2])) && ((this[0] = o), (this.length = 1)), this;
            }
            return t.nodeType ? ((this[0] = t), (this.length = 1), this) : ct(t) ? (void 0 !== n.ready ? n.ready(t) : t(ht)) : ht.makeArray(t, this);
        }).prototype = ht.fn),
            (bt = ht(K));
        var _t = /^(?:parents|prev(?:Until|All))/,
            Ct = { children: !0, contents: !0, next: !0, prev: !0 };
        ht.fn.extend({
            has: function (t) {
                var e = ht(t, this),
                    n = e.length;
                return this.filter(function () {
                    for (var t = 0; t < n; t++) if (ht.contains(this, e[t])) return !0;
                });
            },
            closest: function (t, e) {
                var n,
                    i = 0,
                    o = this.length,
                    r = [],
                    s = "string" != typeof t && ht(t);
                if (!yt.test(t))
                    for (; i < o; i++)
                        for (n = this[i]; n && n !== e; n = n.parentNode)
                            if (n.nodeType < 11 && (s ? -1 < s.index(n) : 1 === n.nodeType && ht.find.matchesSelector(n, t))) {
                                r.push(n);
                                break;
                            }
                return this.pushStack(1 < r.length ? ht.uniqueSort(r) : r);
            },
            index: function (t) {
                return t ? ("string" == typeof t ? it.call(ht(t), this[0]) : it.call(this, t.jquery ? t[0] : t)) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            },
            add: function (t, e) {
                return this.pushStack(ht.uniqueSort(ht.merge(this.get(), ht(t, e))));
            },
            addBack: function (t) {
                return this.add(null == t ? this.prevObject : this.prevObject.filter(t));
            },
        }),
            ht.each(
                {
                    parent: function (t) {
                        var e = t.parentNode;
                        return e && 11 !== e.nodeType ? e : null;
                    },
                    parents: function (t) {
                        return gt(t, "parentNode");
                    },
                    parentsUntil: function (t, e, n) {
                        return gt(t, "parentNode", n);
                    },
                    next: function (t) {
                        return a(t, "nextSibling");
                    },
                    prev: function (t) {
                        return a(t, "previousSibling");
                    },
                    nextAll: function (t) {
                        return gt(t, "nextSibling");
                    },
                    prevAll: function (t) {
                        return gt(t, "previousSibling");
                    },
                    nextUntil: function (t, e, n) {
                        return gt(t, "nextSibling", n);
                    },
                    prevUntil: function (t, e, n) {
                        return gt(t, "previousSibling", n);
                    },
                    siblings: function (t) {
                        return vt((t.parentNode || {}).firstChild, t);
                    },
                    children: function (t) {
                        return vt(t.firstChild);
                    },
                    contents: function (t) {
                        return void 0 !== t.contentDocument ? t.contentDocument : (r(t, "template") && (t = t.content || t), ht.merge([], t.childNodes));
                    },
                },
                function (t, e) {
                    ht.fn[t] = function (n, i) {
                        var o = ht.map(this, e, n);
                        return "Until" !== t.slice(-5) && (i = n), i && "string" == typeof i && (o = ht.filter(i, o)), 1 < this.length && (Ct[t] || ht.uniqueSort(o), _t.test(t) && o.reverse()), this.pushStack(o);
                    };
                }
            );
        var kt = /[^\x20\t\r\n\f]+/g;
        (ht.Callbacks = function (t) {
            var e, n;
            t =
                "string" == typeof t
                    ? ((e = t),
                      (n = {}),
                      ht.each(e.match(kt) || [], function (t, e) {
                          n[e] = !0;
                      }),
                      n)
                    : ht.extend({}, t);
            var o,
                r,
                s,
                a,
                l = [],
                u = [],
                c = -1,
                d = function () {
                    for (a = a || t.once, s = o = !0; u.length; c = -1) for (r = u.shift(); ++c < l.length; ) !1 === l[c].apply(r[0], r[1]) && t.stopOnFalse && ((c = l.length), (r = !1));
                    t.memory || (r = !1), (o = !1), a && (l = r ? [] : "");
                },
                p = {
                    add: function () {
                        return (
                            l &&
                                (r && !o && ((c = l.length - 1), u.push(r)),
                                (function e(n) {
                                    ht.each(n, function (n, o) {
                                        ct(o) ? (t.unique && p.has(o)) || l.push(o) : o && o.length && "string" !== i(o) && e(o);
                                    });
                                })(arguments),
                                r && !o && d()),
                            this
                        );
                    },
                    remove: function () {
                        return (
                            ht.each(arguments, function (t, e) {
                                for (var n; -1 < (n = ht.inArray(e, l, n)); ) l.splice(n, 1), n <= c && c--;
                            }),
                            this
                        );
                    },
                    has: function (t) {
                        return t ? -1 < ht.inArray(t, l) : 0 < l.length;
                    },
                    empty: function () {
                        return l && (l = []), this;
                    },
                    disable: function () {
                        return (a = u = []), (l = r = ""), this;
                    },
                    disabled: function () {
                        return !l;
                    },
                    lock: function () {
                        return (a = u = []), r || o || (l = r = ""), this;
                    },
                    locked: function () {
                        return !!a;
                    },
                    fireWith: function (t, e) {
                        return a || ((e = [t, (e = e || []).slice ? e.slice() : e]), u.push(e), o || d()), this;
                    },
                    fire: function () {
                        return p.fireWith(this, arguments), this;
                    },
                    fired: function () {
                        return !!s;
                    },
                };
            return p;
        }),
            ht.extend({
                Deferred: function (e) {
                    var n = [
                            ["notify", "progress", ht.Callbacks("memory"), ht.Callbacks("memory"), 2],
                            ["resolve", "done", ht.Callbacks("once memory"), ht.Callbacks("once memory"), 0, "resolved"],
                            ["reject", "fail", ht.Callbacks("once memory"), ht.Callbacks("once memory"), 1, "rejected"],
                        ],
                        i = "pending",
                        o = {
                            state: function () {
                                return i;
                            },
                            always: function () {
                                return r.done(arguments).fail(arguments), this;
                            },
                            catch: function (t) {
                                return o.then(null, t);
                            },
                            pipe: function () {
                                var t = arguments;
                                return ht
                                    .Deferred(function (e) {
                                        ht.each(n, function (n, i) {
                                            var o = ct(t[i[4]]) && t[i[4]];
                                            r[i[1]](function () {
                                                var t = o && o.apply(this, arguments);
                                                t && ct(t.promise) ? t.promise().progress(e.notify).done(e.resolve).fail(e.reject) : e[i[0] + "With"](this, o ? [t] : arguments);
                                            });
                                        }),
                                            (t = null);
                                    })
                                    .promise();
                            },
                            then: function (e, i, o) {
                                function r(e, n, i, o) {
                                    return function () {
                                        var a = this,
                                            c = arguments,
                                            d = function () {
                                                var t, d;
                                                if (!(e < s)) {
                                                    if ((t = i.apply(a, c)) === n.promise()) throw new TypeError("Thenable self-resolution");
                                                    (d = t && ("object" == typeof t || "function" == typeof t) && t.then),
                                                        ct(d)
                                                            ? o
                                                                ? d.call(t, r(s, n, l, o), r(s, n, u, o))
                                                                : (s++, d.call(t, r(s, n, l, o), r(s, n, u, o), r(s, n, l, n.notifyWith)))
                                                            : (i !== l && ((a = void 0), (c = [t])), (o || n.resolveWith)(a, c));
                                                }
                                            },
                                            p = o
                                                ? d
                                                : function () {
                                                      try {
                                                          d();
                                                      } catch (t) {
                                                          ht.Deferred.exceptionHook && ht.Deferred.exceptionHook(t, p.stackTrace), s <= e + 1 && (i !== u && ((a = void 0), (c = [t])), n.rejectWith(a, c));
                                                      }
                                                  };
                                        e ? p() : (ht.Deferred.getStackHook && (p.stackTrace = ht.Deferred.getStackHook()), t.setTimeout(p));
                                    };
                                }
                                var s = 0;
                                return ht
                                    .Deferred(function (t) {
                                        n[0][3].add(r(0, t, ct(o) ? o : l, t.notifyWith)), n[1][3].add(r(0, t, ct(e) ? e : l)), n[2][3].add(r(0, t, ct(i) ? i : u));
                                    })
                                    .promise();
                            },
                            promise: function (t) {
                                return null != t ? ht.extend(t, o) : o;
                            },
                        },
                        r = {};
                    return (
                        ht.each(n, function (t, e) {
                            var s = e[2],
                                a = e[5];
                            (o[e[1]] = s.add),
                                a &&
                                    s.add(
                                        function () {
                                            i = a;
                                        },
                                        n[3 - t][2].disable,
                                        n[3 - t][3].disable,
                                        n[0][2].lock,
                                        n[0][3].lock
                                    ),
                                s.add(e[3].fire),
                                (r[e[0]] = function () {
                                    return r[e[0] + "With"](this === r ? void 0 : this, arguments), this;
                                }),
                                (r[e[0] + "With"] = s.fireWith);
                        }),
                        o.promise(r),
                        e && e.call(r, r),
                        r
                    );
                },
                when: function (t) {
                    var e = arguments.length,
                        n = e,
                        i = Array(n),
                        o = tt.call(arguments),
                        r = ht.Deferred(),
                        s = function (t) {
                            return function (n) {
                                (i[t] = this), (o[t] = 1 < arguments.length ? tt.call(arguments) : n), --e || r.resolveWith(i, o);
                            };
                        };
                    if (e <= 1 && (c(t, r.done(s(n)).resolve, r.reject, !e), "pending" === r.state() || ct(o[n] && o[n].then))) return r.then();
                    for (; n--; ) c(o[n], s(n), r.reject);
                    return r.promise();
                },
            });
        var Tt = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
        (ht.Deferred.exceptionHook = function (e, n) {
            t.console && t.console.warn && e && Tt.test(e.name) && t.console.warn("jQuery.Deferred exception: " + e.message, e.stack, n);
        }),
            (ht.readyException = function (e) {
                t.setTimeout(function () {
                    throw e;
                });
            });
        var St = ht.Deferred();
        (ht.fn.ready = function (t) {
            return (
                St.then(t).catch(function (t) {
                    ht.readyException(t);
                }),
                this
            );
        }),
            ht.extend({
                isReady: !1,
                readyWait: 1,
                ready: function (t) {
                    (!0 === t ? --ht.readyWait : ht.isReady) || ((ht.isReady = !0) !== t && 0 < --ht.readyWait) || St.resolveWith(K, [ht]);
                },
            }),
            (ht.ready.then = St.then),
            "complete" === K.readyState || ("loading" !== K.readyState && !K.documentElement.doScroll) ? t.setTimeout(ht.ready) : (K.addEventListener("DOMContentLoaded", d), t.addEventListener("load", d));
        var Et = function (t, e, n, o, r, s, a) {
                var l = 0,
                    u = t.length,
                    c = null == n;
                if ("object" === i(n)) for (l in ((r = !0), n)) Et(t, e, l, n[l], !0, s, a);
                else if (
                    void 0 !== o &&
                    ((r = !0),
                    ct(o) || (a = !0),
                    c &&
                        (a
                            ? (e.call(t, o), (e = null))
                            : ((c = e),
                              (e = function (t, e, n) {
                                  return c.call(ht(t), n);
                              }))),
                    e)
                )
                    for (; l < u; l++) e(t[l], n, a ? o : o.call(t[l], l, e(t[l], n)));
                return r ? t : c ? e.call(t) : u ? e(t[0], n) : s;
            },
            It = /^-ms-/,
            Pt = /-([a-z])/g,
            Lt = function (t) {
                return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType;
            };
        (f.uid = 1),
            (f.prototype = {
                cache: function (t) {
                    var e = t[this.expando];
                    return e || ((e = {}), Lt(t) && (t.nodeType ? (t[this.expando] = e) : Object.defineProperty(t, this.expando, { value: e, configurable: !0 }))), e;
                },
                set: function (t, e, n) {
                    var i,
                        o = this.cache(t);
                    if ("string" == typeof e) o[h(e)] = n;
                    else for (i in e) o[h(i)] = e[i];
                    return o;
                },
                get: function (t, e) {
                    return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][h(e)];
                },
                access: function (t, e, n) {
                    return void 0 === e || (e && "string" == typeof e && void 0 === n) ? this.get(t, e) : (this.set(t, e, n), void 0 !== n ? n : e);
                },
                remove: function (t, e) {
                    var n,
                        i = t[this.expando];
                    if (void 0 !== i) {
                        if (void 0 !== e) {
                            n = (e = Array.isArray(e) ? e.map(h) : (e = h(e)) in i ? [e] : e.match(kt) || []).length;
                            for (; n--; ) delete i[e[n]];
                        }
                        (void 0 === e || ht.isEmptyObject(i)) && (t.nodeType ? (t[this.expando] = void 0) : delete t[this.expando]);
                    }
                },
                hasData: function (t) {
                    var e = t[this.expando];
                    return void 0 !== e && !ht.isEmptyObject(e);
                },
            });
        var At = new f(),
            $t = new f(),
            Ot = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            jt = /[A-Z]/g;
        ht.extend({
            hasData: function (t) {
                return $t.hasData(t) || At.hasData(t);
            },
            data: function (t, e, n) {
                return $t.access(t, e, n);
            },
            removeData: function (t, e) {
                $t.remove(t, e);
            },
            _data: function (t, e, n) {
                return At.access(t, e, n);
            },
            _removeData: function (t, e) {
                At.remove(t, e);
            },
        }),
            ht.fn.extend({
                data: function (t, e) {
                    var n,
                        i,
                        o,
                        r = this[0],
                        s = r && r.attributes;
                    if (void 0 === t) {
                        if (this.length && ((o = $t.get(r)), 1 === r.nodeType && !At.get(r, "hasDataAttrs"))) {
                            for (n = s.length; n--; ) s[n] && 0 === (i = s[n].name).indexOf("data-") && ((i = h(i.slice(5))), m(r, i, o[i]));
                            At.set(r, "hasDataAttrs", !0);
                        }
                        return o;
                    }
                    return "object" == typeof t
                        ? this.each(function () {
                              $t.set(this, t);
                          })
                        : Et(
                              this,
                              function (e) {
                                  var n;
                                  if (r && void 0 === e) return void 0 !== (n = $t.get(r, t)) || void 0 !== (n = m(r, t)) ? n : void 0;
                                  this.each(function () {
                                      $t.set(this, t, e);
                                  });
                              },
                              null,
                              e,
                              1 < arguments.length,
                              null,
                              !0
                          );
                },
                removeData: function (t) {
                    return this.each(function () {
                        $t.remove(this, t);
                    });
                },
            }),
            ht.extend({
                queue: function (t, e, n) {
                    var i;
                    if (t) return (e = (e || "fx") + "queue"), (i = At.get(t, e)), n && (!i || Array.isArray(n) ? (i = At.access(t, e, ht.makeArray(n))) : i.push(n)), i || [];
                },
                dequeue: function (t, e) {
                    e = e || "fx";
                    var n = ht.queue(t, e),
                        i = n.length,
                        o = n.shift(),
                        r = ht._queueHooks(t, e);
                    "inprogress" === o && ((o = n.shift()), i--),
                        o &&
                            ("fx" === e && n.unshift("inprogress"),
                            delete r.stop,
                            o.call(
                                t,
                                function () {
                                    ht.dequeue(t, e);
                                },
                                r
                            )),
                        !i && r && r.empty.fire();
                },
                _queueHooks: function (t, e) {
                    var n = e + "queueHooks";
                    return (
                        At.get(t, n) ||
                        At.access(t, n, {
                            empty: ht.Callbacks("once memory").add(function () {
                                At.remove(t, [e + "queue", n]);
                            }),
                        })
                    );
                },
            }),
            ht.fn.extend({
                queue: function (t, e) {
                    var n = 2;
                    return (
                        "string" != typeof t && ((e = t), (t = "fx"), n--),
                        arguments.length < n
                            ? ht.queue(this[0], t)
                            : void 0 === e
                            ? this
                            : this.each(function () {
                                  var n = ht.queue(this, t, e);
                                  ht._queueHooks(this, t), "fx" === t && "inprogress" !== n[0] && ht.dequeue(this, t);
                              })
                    );
                },
                dequeue: function (t) {
                    return this.each(function () {
                        ht.dequeue(this, t);
                    });
                },
                clearQueue: function (t) {
                    return this.queue(t || "fx", []);
                },
                promise: function (t, e) {
                    var n,
                        i = 1,
                        o = ht.Deferred(),
                        r = this,
                        s = this.length,
                        a = function () {
                            --i || o.resolveWith(r, [r]);
                        };
                    for ("string" != typeof t && ((e = t), (t = void 0)), t = t || "fx"; s--; ) (n = At.get(r[s], t + "queueHooks")) && n.empty && (i++, n.empty.add(a));
                    return a(), o.promise(e);
                },
            });
        var Nt = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            Mt = new RegExp("^(?:([+-])=|)(" + Nt + ")([a-z%]*)$", "i"),
            Ht = ["Top", "Right", "Bottom", "Left"],
            Ft = K.documentElement,
            Dt = function (t) {
                return ht.contains(t.ownerDocument, t);
            },
            zt = { composed: !0 };
        Ft.getRootNode &&
            (Dt = function (t) {
                return ht.contains(t.ownerDocument, t) || t.getRootNode(zt) === t.ownerDocument;
            });
        var Vt = function (t, e) {
                return "none" === (t = e || t).style.display || ("" === t.style.display && Dt(t) && "none" === ht.css(t, "display"));
            },
            qt = function (t, e, n, i) {
                var o,
                    r,
                    s = {};
                for (r in e) (s[r] = t.style[r]), (t.style[r] = e[r]);
                for (r in ((o = n.apply(t, i || [])), e)) t.style[r] = s[r];
                return o;
            },
            Rt = {};
        ht.fn.extend({
            show: function () {
                return v(this, !0);
            },
            hide: function () {
                return v(this);
            },
            toggle: function (t) {
                return "boolean" == typeof t
                    ? t
                        ? this.show()
                        : this.hide()
                    : this.each(function () {
                          Vt(this) ? ht(this).show() : ht(this).hide();
                      });
            },
        });
        var Wt = /^(?:checkbox|radio)$/i,
            Bt = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
            Yt = /^$|^module$|\/(?:java|ecma)script/i,
            Xt = {
                option: [1, "<select multiple='multiple'>", "</select>"],
                thead: [1, "<table>", "</table>"],
                col: [2, "<table><colgroup>", "</colgroup></table>"],
                tr: [2, "<table><tbody>", "</tbody></table>"],
                td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
                _default: [0, "", ""],
            };
        (Xt.optgroup = Xt.option), (Xt.tbody = Xt.tfoot = Xt.colgroup = Xt.caption = Xt.thead), (Xt.th = Xt.td);
        var Ut,
            Gt,
            Qt = /<|&#?\w+;/;
        (Ut = K.createDocumentFragment().appendChild(K.createElement("div"))),
            (Gt = K.createElement("input")).setAttribute("type", "radio"),
            Gt.setAttribute("checked", "checked"),
            Gt.setAttribute("name", "t"),
            Ut.appendChild(Gt),
            (ut.checkClone = Ut.cloneNode(!0).cloneNode(!0).lastChild.checked),
            (Ut.innerHTML = "<textarea>x</textarea>"),
            (ut.noCloneChecked = !!Ut.cloneNode(!0).lastChild.defaultValue);
        var Jt = /^key/,
            Kt = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
            Zt = /^([^.]*)(?:\.(.+)|)/;
        (ht.event = {
            global: {},
            add: function (t, e, n, i, o) {
                var r,
                    s,
                    a,
                    l,
                    u,
                    c,
                    d,
                    p,
                    h,
                    f,
                    m,
                    g = At.get(t);
                if (g)
                    for (
                        n.handler && ((n = (r = n).handler), (o = r.selector)),
                            o && ht.find.matchesSelector(Ft, o),
                            n.guid || (n.guid = ht.guid++),
                            (l = g.events) || (l = g.events = {}),
                            (s = g.handle) ||
                                (s = g.handle = function (e) {
                                    return void 0 !== ht && ht.event.triggered !== e.type ? ht.event.dispatch.apply(t, arguments) : void 0;
                                }),
                            u = (e = (e || "").match(kt) || [""]).length;
                        u--;

                    )
                        (h = m = (a = Zt.exec(e[u]) || [])[1]),
                            (f = (a[2] || "").split(".").sort()),
                            h &&
                                ((d = ht.event.special[h] || {}),
                                (h = (o ? d.delegateType : d.bindType) || h),
                                (d = ht.event.special[h] || {}),
                                (c = ht.extend({ type: h, origType: m, data: i, handler: n, guid: n.guid, selector: o, needsContext: o && ht.expr.match.needsContext.test(o), namespace: f.join(".") }, r)),
                                (p = l[h]) || (((p = l[h] = []).delegateCount = 0), (d.setup && !1 !== d.setup.call(t, i, f, s)) || (t.addEventListener && t.addEventListener(h, s))),
                                d.add && (d.add.call(t, c), c.handler.guid || (c.handler.guid = n.guid)),
                                o ? p.splice(p.delegateCount++, 0, c) : p.push(c),
                                (ht.event.global[h] = !0));
            },
            remove: function (t, e, n, i, o) {
                var r,
                    s,
                    a,
                    l,
                    u,
                    c,
                    d,
                    p,
                    h,
                    f,
                    m,
                    g = At.hasData(t) && At.get(t);
                if (g && (l = g.events)) {
                    for (u = (e = (e || "").match(kt) || [""]).length; u--; )
                        if (((h = m = (a = Zt.exec(e[u]) || [])[1]), (f = (a[2] || "").split(".").sort()), h)) {
                            for (d = ht.event.special[h] || {}, p = l[(h = (i ? d.delegateType : d.bindType) || h)] || [], a = a[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), s = r = p.length; r--; )
                                (c = p[r]),
                                    (!o && m !== c.origType) ||
                                        (n && n.guid !== c.guid) ||
                                        (a && !a.test(c.namespace)) ||
                                        (i && i !== c.selector && ("**" !== i || !c.selector)) ||
                                        (p.splice(r, 1), c.selector && p.delegateCount--, d.remove && d.remove.call(t, c));
                            s && !p.length && ((d.teardown && !1 !== d.teardown.call(t, f, g.handle)) || ht.removeEvent(t, h, g.handle), delete l[h]);
                        } else for (h in l) ht.event.remove(t, h + e[u], n, i, !0);
                    ht.isEmptyObject(l) && At.remove(t, "handle events");
                }
            },
            dispatch: function (t) {
                var e,
                    n,
                    i,
                    o,
                    r,
                    s,
                    a = ht.event.fix(t),
                    l = new Array(arguments.length),
                    u = (At.get(this, "events") || {})[a.type] || [],
                    c = ht.event.special[a.type] || {};
                for (l[0] = a, e = 1; e < arguments.length; e++) l[e] = arguments[e];
                if (((a.delegateTarget = this), !c.preDispatch || !1 !== c.preDispatch.call(this, a))) {
                    for (s = ht.event.handlers.call(this, a, u), e = 0; (o = s[e++]) && !a.isPropagationStopped(); )
                        for (a.currentTarget = o.elem, n = 0; (r = o.handlers[n++]) && !a.isImmediatePropagationStopped(); )
                            (a.rnamespace && !1 !== r.namespace && !a.rnamespace.test(r.namespace)) ||
                                ((a.handleObj = r), (a.data = r.data), void 0 !== (i = ((ht.event.special[r.origType] || {}).handle || r.handler).apply(o.elem, l)) && !1 === (a.result = i) && (a.preventDefault(), a.stopPropagation()));
                    return c.postDispatch && c.postDispatch.call(this, a), a.result;
                }
            },
            handlers: function (t, e) {
                var n,
                    i,
                    o,
                    r,
                    s,
                    a = [],
                    l = e.delegateCount,
                    u = t.target;
                if (l && u.nodeType && !("click" === t.type && 1 <= t.button))
                    for (; u !== this; u = u.parentNode || this)
                        if (1 === u.nodeType && ("click" !== t.type || !0 !== u.disabled)) {
                            for (r = [], s = {}, n = 0; n < l; n++) void 0 === s[(o = (i = e[n]).selector + " ")] && (s[o] = i.needsContext ? -1 < ht(o, this).index(u) : ht.find(o, this, null, [u]).length), s[o] && r.push(i);
                            r.length && a.push({ elem: u, handlers: r });
                        }
                return (u = this), l < e.length && a.push({ elem: u, handlers: e.slice(l) }), a;
            },
            addProp: function (t, e) {
                Object.defineProperty(ht.Event.prototype, t, {
                    enumerable: !0,
                    configurable: !0,
                    get: ct(e)
                        ? function () {
                              if (this.originalEvent) return e(this.originalEvent);
                          }
                        : function () {
                              if (this.originalEvent) return this.originalEvent[t];
                          },
                    set: function (e) {
                        Object.defineProperty(this, t, { enumerable: !0, configurable: !0, writable: !0, value: e });
                    },
                });
            },
            fix: function (t) {
                return t[ht.expando] ? t : new ht.Event(t);
            },
            special: {
                load: { noBubble: !0 },
                click: {
                    setup: function (t) {
                        var e = this || t;
                        return Wt.test(e.type) && e.click && r(e, "input") && T(e, "click", x), !1;
                    },
                    trigger: function (t) {
                        var e = this || t;
                        return Wt.test(e.type) && e.click && r(e, "input") && T(e, "click"), !0;
                    },
                    _default: function (t) {
                        var e = t.target;
                        return (Wt.test(e.type) && e.click && r(e, "input") && At.get(e, "click")) || r(e, "a");
                    },
                },
                beforeunload: {
                    postDispatch: function (t) {
                        void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result);
                    },
                },
            },
        }),
            (ht.removeEvent = function (t, e, n) {
                t.removeEventListener && t.removeEventListener(e, n);
            }),
            (ht.Event = function (t, e) {
                if (!(this instanceof ht.Event)) return new ht.Event(t, e);
                t && t.type
                    ? ((this.originalEvent = t),
                      (this.type = t.type),
                      (this.isDefaultPrevented = t.defaultPrevented || (void 0 === t.defaultPrevented && !1 === t.returnValue) ? x : _),
                      (this.target = t.target && 3 === t.target.nodeType ? t.target.parentNode : t.target),
                      (this.currentTarget = t.currentTarget),
                      (this.relatedTarget = t.relatedTarget))
                    : (this.type = t),
                    e && ht.extend(this, e),
                    (this.timeStamp = (t && t.timeStamp) || Date.now()),
                    (this[ht.expando] = !0);
            }),
            (ht.Event.prototype = {
                constructor: ht.Event,
                isDefaultPrevented: _,
                isPropagationStopped: _,
                isImmediatePropagationStopped: _,
                isSimulated: !1,
                preventDefault: function () {
                    var t = this.originalEvent;
                    (this.isDefaultPrevented = x), t && !this.isSimulated && t.preventDefault();
                },
                stopPropagation: function () {
                    var t = this.originalEvent;
                    (this.isPropagationStopped = x), t && !this.isSimulated && t.stopPropagation();
                },
                stopImmediatePropagation: function () {
                    var t = this.originalEvent;
                    (this.isImmediatePropagationStopped = x), t && !this.isSimulated && t.stopImmediatePropagation(), this.stopPropagation();
                },
            }),
            ht.each(
                {
                    altKey: !0,
                    bubbles: !0,
                    cancelable: !0,
                    changedTouches: !0,
                    ctrlKey: !0,
                    detail: !0,
                    eventPhase: !0,
                    metaKey: !0,
                    pageX: !0,
                    pageY: !0,
                    shiftKey: !0,
                    view: !0,
                    char: !0,
                    code: !0,
                    charCode: !0,
                    key: !0,
                    keyCode: !0,
                    button: !0,
                    buttons: !0,
                    clientX: !0,
                    clientY: !0,
                    offsetX: !0,
                    offsetY: !0,
                    pointerId: !0,
                    pointerType: !0,
                    screenX: !0,
                    screenY: !0,
                    targetTouches: !0,
                    toElement: !0,
                    touches: !0,
                    which: function (t) {
                        var e = t.button;
                        return null == t.which && Jt.test(t.type) ? (null != t.charCode ? t.charCode : t.keyCode) : !t.which && void 0 !== e && Kt.test(t.type) ? (1 & e ? 1 : 2 & e ? 3 : 4 & e ? 2 : 0) : t.which;
                    },
                },
                ht.event.addProp
            ),
            ht.each({ focus: "focusin", blur: "focusout" }, function (t, e) {
                ht.event.special[t] = {
                    setup: function () {
                        return T(this, t, C), !1;
                    },
                    trigger: function () {
                        return T(this, t), !0;
                    },
                    delegateType: e,
                };
            }),
            ht.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (t, e) {
                ht.event.special[t] = {
                    delegateType: e,
                    bindType: e,
                    handle: function (t) {
                        var n,
                            i = t.relatedTarget,
                            o = t.handleObj;
                        return (i && (i === this || ht.contains(this, i))) || ((t.type = o.origType), (n = o.handler.apply(this, arguments)), (t.type = e)), n;
                    },
                };
            }),
            ht.fn.extend({
                on: function (t, e, n, i) {
                    return k(this, t, e, n, i);
                },
                one: function (t, e, n, i) {
                    return k(this, t, e, n, i, 1);
                },
                off: function (t, e, n) {
                    var i, o;
                    if (t && t.preventDefault && t.handleObj) return (i = t.handleObj), ht(t.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
                    if ("object" == typeof t) {
                        for (o in t) this.off(o, e, t[o]);
                        return this;
                    }
                    return (
                        (!1 !== e && "function" != typeof e) || ((n = e), (e = void 0)),
                        !1 === n && (n = _),
                        this.each(function () {
                            ht.event.remove(this, t, n, e);
                        })
                    );
                },
            });
        var te = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
            ee = /<script|<style|<link/i,
            ne = /checked\s*(?:[^=]|=\s*.checked.)/i,
            ie = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
        ht.extend({
            htmlPrefilter: function (t) {
                return t.replace(te, "<$1></$2>");
            },
            clone: function (t, e, n) {
                var i,
                    o,
                    r,
                    s,
                    a,
                    l,
                    u,
                    c = t.cloneNode(!0),
                    d = Dt(t);
                if (!(ut.noCloneChecked || (1 !== t.nodeType && 11 !== t.nodeType) || ht.isXMLDoc(t)))
                    for (s = y(c), i = 0, o = (r = y(t)).length; i < o; i++)
                        (a = r[i]), "input" === (u = (l = s[i]).nodeName.toLowerCase()) && Wt.test(a.type) ? (l.checked = a.checked) : ("input" !== u && "textarea" !== u) || (l.defaultValue = a.defaultValue);
                if (e)
                    if (n) for (r = r || y(t), s = s || y(c), i = 0, o = r.length; i < o; i++) P(r[i], s[i]);
                    else P(t, c);
                return 0 < (s = y(c, "script")).length && w(s, !d && y(t, "script")), c;
            },
            cleanData: function (t) {
                for (var e, n, i, o = ht.event.special, r = 0; void 0 !== (n = t[r]); r++)
                    if (Lt(n)) {
                        if ((e = n[At.expando])) {
                            if (e.events) for (i in e.events) o[i] ? ht.event.remove(n, i) : ht.removeEvent(n, i, e.handle);
                            n[At.expando] = void 0;
                        }
                        n[$t.expando] && (n[$t.expando] = void 0);
                    }
            },
        }),
            ht.fn.extend({
                detach: function (t) {
                    return A(this, t, !0);
                },
                remove: function (t) {
                    return A(this, t);
                },
                text: function (t) {
                    return Et(
                        this,
                        function (t) {
                            return void 0 === t
                                ? ht.text(this)
                                : this.empty().each(function () {
                                      (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (this.textContent = t);
                                  });
                        },
                        null,
                        t,
                        arguments.length
                    );
                },
                append: function () {
                    return L(this, arguments, function (t) {
                        (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || S(this, t).appendChild(t);
                    });
                },
                prepend: function () {
                    return L(this, arguments, function (t) {
                        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                            var e = S(this, t);
                            e.insertBefore(t, e.firstChild);
                        }
                    });
                },
                before: function () {
                    return L(this, arguments, function (t) {
                        this.parentNode && this.parentNode.insertBefore(t, this);
                    });
                },
                after: function () {
                    return L(this, arguments, function (t) {
                        this.parentNode && this.parentNode.insertBefore(t, this.nextSibling);
                    });
                },
                empty: function () {
                    for (var t, e = 0; null != (t = this[e]); e++) 1 === t.nodeType && (ht.cleanData(y(t, !1)), (t.textContent = ""));
                    return this;
                },
                clone: function (t, e) {
                    return (
                        (t = null != t && t),
                        (e = null == e ? t : e),
                        this.map(function () {
                            return ht.clone(this, t, e);
                        })
                    );
                },
                html: function (t) {
                    return Et(
                        this,
                        function (t) {
                            var e = this[0] || {},
                                n = 0,
                                i = this.length;
                            if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
                            if ("string" == typeof t && !ee.test(t) && !Xt[(Bt.exec(t) || ["", ""])[1].toLowerCase()]) {
                                t = ht.htmlPrefilter(t);
                                try {
                                    for (; n < i; n++) 1 === (e = this[n] || {}).nodeType && (ht.cleanData(y(e, !1)), (e.innerHTML = t));
                                    e = 0;
                                } catch (t) {}
                            }
                            e && this.empty().append(t);
                        },
                        null,
                        t,
                        arguments.length
                    );
                },
                replaceWith: function () {
                    var t = [];
                    return L(
                        this,
                        arguments,
                        function (e) {
                            var n = this.parentNode;
                            ht.inArray(this, t) < 0 && (ht.cleanData(y(this)), n && n.replaceChild(e, this));
                        },
                        t
                    );
                },
            }),
            ht.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (t, e) {
                ht.fn[t] = function (t) {
                    for (var n, i = [], o = ht(t), r = o.length - 1, s = 0; s <= r; s++) (n = s === r ? this : this.clone(!0)), ht(o[s])[e](n), nt.apply(i, n.get());
                    return this.pushStack(i);
                };
            });
        var oe = new RegExp("^(" + Nt + ")(?!px)[a-z%]+$", "i"),
            re = function (e) {
                var n = e.ownerDocument.defaultView;
                return (n && n.opener) || (n = t), n.getComputedStyle(e);
            },
            se = new RegExp(Ht.join("|"), "i");
        !(function () {
            function e() {
                if (u) {
                    (l.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                        (u.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                        Ft.appendChild(l).appendChild(u);
                    var e = t.getComputedStyle(u);
                    (i = "1%" !== e.top),
                        (a = 12 === n(e.marginLeft)),
                        (u.style.right = "60%"),
                        (s = 36 === n(e.right)),
                        (o = 36 === n(e.width)),
                        (u.style.position = "absolute"),
                        (r = 12 === n(u.offsetWidth / 3)),
                        Ft.removeChild(l),
                        (u = null);
                }
            }
            function n(t) {
                return Math.round(parseFloat(t));
            }
            var i,
                o,
                r,
                s,
                a,
                l = K.createElement("div"),
                u = K.createElement("div");
            u.style &&
                ((u.style.backgroundClip = "content-box"),
                (u.cloneNode(!0).style.backgroundClip = ""),
                (ut.clearCloneStyle = "content-box" === u.style.backgroundClip),
                ht.extend(ut, {
                    boxSizingReliable: function () {
                        return e(), o;
                    },
                    pixelBoxStyles: function () {
                        return e(), s;
                    },
                    pixelPosition: function () {
                        return e(), i;
                    },
                    reliableMarginLeft: function () {
                        return e(), a;
                    },
                    scrollboxSize: function () {
                        return e(), r;
                    },
                }));
        })();
        var ae = ["Webkit", "Moz", "ms"],
            le = K.createElement("div").style,
            ue = {},
            ce = /^(none|table(?!-c[ea]).+)/,
            de = /^--/,
            pe = { position: "absolute", visibility: "hidden", display: "block" },
            he = { letterSpacing: "0", fontWeight: "400" };
        ht.extend({
            cssHooks: {
                opacity: {
                    get: function (t, e) {
                        if (e) {
                            var n = $(t, "opacity");
                            return "" === n ? "1" : n;
                        }
                    },
                },
            },
            cssNumber: {
                animationIterationCount: !0,
                columnCount: !0,
                fillOpacity: !0,
                flexGrow: !0,
                flexShrink: !0,
                fontWeight: !0,
                gridArea: !0,
                gridColumn: !0,
                gridColumnEnd: !0,
                gridColumnStart: !0,
                gridRow: !0,
                gridRowEnd: !0,
                gridRowStart: !0,
                lineHeight: !0,
                opacity: !0,
                order: !0,
                orphans: !0,
                widows: !0,
                zIndex: !0,
                zoom: !0,
            },
            cssProps: {},
            style: function (t, e, n, i) {
                if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
                    var o,
                        r,
                        s,
                        a = h(e),
                        l = de.test(e),
                        u = t.style;
                    if ((l || (e = j(a)), (s = ht.cssHooks[e] || ht.cssHooks[a]), void 0 === n)) return s && "get" in s && void 0 !== (o = s.get(t, !1, i)) ? o : u[e];
                    "string" == (r = typeof n) && (o = Mt.exec(n)) && o[1] && ((n = g(t, e, o)), (r = "number")),
                        null != n &&
                            n == n &&
                            ("number" !== r || l || (n += (o && o[3]) || (ht.cssNumber[a] ? "" : "px")),
                            ut.clearCloneStyle || "" !== n || 0 !== e.indexOf("background") || (u[e] = "inherit"),
                            (s && "set" in s && void 0 === (n = s.set(t, n, i))) || (l ? u.setProperty(e, n) : (u[e] = n)));
                }
            },
            css: function (t, e, n, i) {
                var o,
                    r,
                    s,
                    a = h(e);
                return (
                    de.test(e) || (e = j(a)),
                    (s = ht.cssHooks[e] || ht.cssHooks[a]) && "get" in s && (o = s.get(t, !0, n)),
                    void 0 === o && (o = $(t, e, i)),
                    "normal" === o && e in he && (o = he[e]),
                    "" === n || n ? ((r = parseFloat(o)), !0 === n || isFinite(r) ? r || 0 : o) : o
                );
            },
        }),
            ht.each(["height", "width"], function (t, e) {
                ht.cssHooks[e] = {
                    get: function (t, n, i) {
                        if (n)
                            return !ce.test(ht.css(t, "display")) || (t.getClientRects().length && t.getBoundingClientRect().width)
                                ? H(t, e, i)
                                : qt(t, pe, function () {
                                      return H(t, e, i);
                                  });
                    },
                    set: function (t, n, i) {
                        var o,
                            r = re(t),
                            s = !ut.scrollboxSize() && "absolute" === r.position,
                            a = (s || i) && "border-box" === ht.css(t, "boxSizing", !1, r),
                            l = i ? M(t, e, i, a, r) : 0;
                        return (
                            a && s && (l -= Math.ceil(t["offset" + e[0].toUpperCase() + e.slice(1)] - parseFloat(r[e]) - M(t, e, "border", !1, r) - 0.5)),
                            l && (o = Mt.exec(n)) && "px" !== (o[3] || "px") && ((t.style[e] = n), (n = ht.css(t, e))),
                            N(0, n, l)
                        );
                    },
                };
            }),
            (ht.cssHooks.marginLeft = O(ut.reliableMarginLeft, function (t, e) {
                if (e)
                    return (
                        (parseFloat($(t, "marginLeft")) ||
                            t.getBoundingClientRect().left -
                                qt(t, { marginLeft: 0 }, function () {
                                    return t.getBoundingClientRect().left;
                                })) + "px"
                    );
            })),
            ht.each({ margin: "", padding: "", border: "Width" }, function (t, e) {
                (ht.cssHooks[t + e] = {
                    expand: function (n) {
                        for (var i = 0, o = {}, r = "string" == typeof n ? n.split(" ") : [n]; i < 4; i++) o[t + Ht[i] + e] = r[i] || r[i - 2] || r[0];
                        return o;
                    },
                }),
                    "margin" !== t && (ht.cssHooks[t + e].set = N);
            }),
            ht.fn.extend({
                css: function (t, e) {
                    return Et(
                        this,
                        function (t, e, n) {
                            var i,
                                o,
                                r = {},
                                s = 0;
                            if (Array.isArray(e)) {
                                for (i = re(t), o = e.length; s < o; s++) r[e[s]] = ht.css(t, e[s], !1, i);
                                return r;
                            }
                            return void 0 !== n ? ht.style(t, e, n) : ht.css(t, e);
                        },
                        t,
                        e,
                        1 < arguments.length
                    );
                },
            }),
            (((ht.Tween = F).prototype = {
                constructor: F,
                init: function (t, e, n, i, o, r) {
                    (this.elem = t), (this.prop = n), (this.easing = o || ht.easing._default), (this.options = e), (this.start = this.now = this.cur()), (this.end = i), (this.unit = r || (ht.cssNumber[n] ? "" : "px"));
                },
                cur: function () {
                    var t = F.propHooks[this.prop];
                    return t && t.get ? t.get(this) : F.propHooks._default.get(this);
                },
                run: function (t) {
                    var e,
                        n = F.propHooks[this.prop];
                    return (
                        this.options.duration ? (this.pos = e = ht.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration)) : (this.pos = e = t),
                        (this.now = (this.end - this.start) * e + this.start),
                        this.options.step && this.options.step.call(this.elem, this.now, this),
                        n && n.set ? n.set(this) : F.propHooks._default.set(this),
                        this
                    );
                },
            }).init.prototype = F.prototype),
            ((F.propHooks = {
                _default: {
                    get: function (t) {
                        var e;
                        return 1 !== t.elem.nodeType || (null != t.elem[t.prop] && null == t.elem.style[t.prop]) ? t.elem[t.prop] : (e = ht.css(t.elem, t.prop, "")) && "auto" !== e ? e : 0;
                    },
                    set: function (t) {
                        ht.fx.step[t.prop] ? ht.fx.step[t.prop](t) : 1 !== t.elem.nodeType || (!ht.cssHooks[t.prop] && null == t.elem.style[j(t.prop)]) ? (t.elem[t.prop] = t.now) : ht.style(t.elem, t.prop, t.now + t.unit);
                    },
                },
            }).scrollTop = F.propHooks.scrollLeft = {
                set: function (t) {
                    t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now);
                },
            }),
            (ht.easing = {
                linear: function (t) {
                    return t;
                },
                swing: function (t) {
                    return 0.5 - Math.cos(t * Math.PI) / 2;
                },
                _default: "swing",
            }),
            (ht.fx = F.prototype.init),
            (ht.fx.step = {});
        var fe,
            me,
            ge,
            ve,
            ye = /^(?:toggle|show|hide)$/,
            we = /queueHooks$/;
        (ht.Animation = ht.extend(R, {
            tweeners: {
                "*": [
                    function (t, e) {
                        var n = this.createTween(t, e);
                        return g(n.elem, t, Mt.exec(e), n), n;
                    },
                ],
            },
            tweener: function (t, e) {
                ct(t) ? ((e = t), (t = ["*"])) : (t = t.match(kt));
                for (var n, i = 0, o = t.length; i < o; i++) (n = t[i]), (R.tweeners[n] = R.tweeners[n] || []), R.tweeners[n].unshift(e);
            },
            prefilters: [
                function (t, e, n) {
                    var i,
                        o,
                        r,
                        s,
                        a,
                        l,
                        u,
                        c,
                        d = "width" in e || "height" in e,
                        p = this,
                        h = {},
                        f = t.style,
                        m = t.nodeType && Vt(t),
                        g = At.get(t, "fxshow");
                    for (i in (n.queue ||
                        (null == (s = ht._queueHooks(t, "fx")).unqueued &&
                            ((s.unqueued = 0),
                            (a = s.empty.fire),
                            (s.empty.fire = function () {
                                s.unqueued || a();
                            })),
                        s.unqueued++,
                        p.always(function () {
                            p.always(function () {
                                s.unqueued--, ht.queue(t, "fx").length || s.empty.fire();
                            });
                        })),
                    e))
                        if (((o = e[i]), ye.test(o))) {
                            if ((delete e[i], (r = r || "toggle" === o), o === (m ? "hide" : "show"))) {
                                if ("show" !== o || !g || void 0 === g[i]) continue;
                                m = !0;
                            }
                            h[i] = (g && g[i]) || ht.style(t, i);
                        }
                    if ((l = !ht.isEmptyObject(e)) || !ht.isEmptyObject(h))
                        for (i in (d &&
                            1 === t.nodeType &&
                            ((n.overflow = [f.overflow, f.overflowX, f.overflowY]),
                            null == (u = g && g.display) && (u = At.get(t, "display")),
                            "none" === (c = ht.css(t, "display")) && (u ? (c = u) : (v([t], !0), (u = t.style.display || u), (c = ht.css(t, "display")), v([t]))),
                            ("inline" === c || ("inline-block" === c && null != u)) &&
                                "none" === ht.css(t, "float") &&
                                (l ||
                                    (p.done(function () {
                                        f.display = u;
                                    }),
                                    null == u && ((c = f.display), (u = "none" === c ? "" : c))),
                                (f.display = "inline-block"))),
                        n.overflow &&
                            ((f.overflow = "hidden"),
                            p.always(function () {
                                (f.overflow = n.overflow[0]), (f.overflowX = n.overflow[1]), (f.overflowY = n.overflow[2]);
                            })),
                        (l = !1),
                        h))
                            l ||
                                (g ? "hidden" in g && (m = g.hidden) : (g = At.access(t, "fxshow", { display: u })),
                                r && (g.hidden = !m),
                                m && v([t], !0),
                                p.done(function () {
                                    for (i in (m || v([t]), At.remove(t, "fxshow"), h)) ht.style(t, i, h[i]);
                                })),
                                (l = q(m ? g[i] : 0, i, p)),
                                i in g || ((g[i] = l.start), m && ((l.end = l.start), (l.start = 0)));
                },
            ],
            prefilter: function (t, e) {
                e ? R.prefilters.unshift(t) : R.prefilters.push(t);
            },
        })),
            (ht.speed = function (t, e, n) {
                var i = t && "object" == typeof t ? ht.extend({}, t) : { complete: n || (!n && e) || (ct(t) && t), duration: t, easing: (n && e) || (e && !ct(e) && e) };
                return (
                    ht.fx.off ? (i.duration = 0) : "number" != typeof i.duration && (i.duration in ht.fx.speeds ? (i.duration = ht.fx.speeds[i.duration]) : (i.duration = ht.fx.speeds._default)),
                    (null != i.queue && !0 !== i.queue) || (i.queue = "fx"),
                    (i.old = i.complete),
                    (i.complete = function () {
                        ct(i.old) && i.old.call(this), i.queue && ht.dequeue(this, i.queue);
                    }),
                    i
                );
            }),
            ht.fn.extend({
                fadeTo: function (t, e, n, i) {
                    return this.filter(Vt).css("opacity", 0).show().end().animate({ opacity: e }, t, n, i);
                },
                animate: function (t, e, n, i) {
                    var o = ht.isEmptyObject(t),
                        r = ht.speed(e, n, i),
                        s = function () {
                            var e = R(this, ht.extend({}, t), r);
                            (o || At.get(this, "finish")) && e.stop(!0);
                        };
                    return (s.finish = s), o || !1 === r.queue ? this.each(s) : this.queue(r.queue, s);
                },
                stop: function (t, e, n) {
                    var i = function (t) {
                        var e = t.stop;
                        delete t.stop, e(n);
                    };
                    return (
                        "string" != typeof t && ((n = e), (e = t), (t = void 0)),
                        e && !1 !== t && this.queue(t || "fx", []),
                        this.each(function () {
                            var e = !0,
                                o = null != t && t + "queueHooks",
                                r = ht.timers,
                                s = At.get(this);
                            if (o) s[o] && s[o].stop && i(s[o]);
                            else for (o in s) s[o] && s[o].stop && we.test(o) && i(s[o]);
                            for (o = r.length; o--; ) r[o].elem !== this || (null != t && r[o].queue !== t) || (r[o].anim.stop(n), (e = !1), r.splice(o, 1));
                            (!e && n) || ht.dequeue(this, t);
                        })
                    );
                },
                finish: function (t) {
                    return (
                        !1 !== t && (t = t || "fx"),
                        this.each(function () {
                            var e,
                                n = At.get(this),
                                i = n[t + "queue"],
                                o = n[t + "queueHooks"],
                                r = ht.timers,
                                s = i ? i.length : 0;
                            for (n.finish = !0, ht.queue(this, t, []), o && o.stop && o.stop.call(this, !0), e = r.length; e--; ) r[e].elem === this && r[e].queue === t && (r[e].anim.stop(!0), r.splice(e, 1));
                            for (e = 0; e < s; e++) i[e] && i[e].finish && i[e].finish.call(this);
                            delete n.finish;
                        })
                    );
                },
            }),
            ht.each(["toggle", "show", "hide"], function (t, e) {
                var n = ht.fn[e];
                ht.fn[e] = function (t, i, o) {
                    return null == t || "boolean" == typeof t ? n.apply(this, arguments) : this.animate(V(e, !0), t, i, o);
                };
            }),
            ht.each({ slideDown: V("show"), slideUp: V("hide"), slideToggle: V("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (t, e) {
                ht.fn[t] = function (t, n, i) {
                    return this.animate(e, t, n, i);
                };
            }),
            (ht.timers = []),
            (ht.fx.tick = function () {
                var t,
                    e = 0,
                    n = ht.timers;
                for (fe = Date.now(); e < n.length; e++) (t = n[e])() || n[e] !== t || n.splice(e--, 1);
                n.length || ht.fx.stop(), (fe = void 0);
            }),
            (ht.fx.timer = function (t) {
                ht.timers.push(t), ht.fx.start();
            }),
            (ht.fx.interval = 13),
            (ht.fx.start = function () {
                me || ((me = !0), D());
            }),
            (ht.fx.stop = function () {
                me = null;
            }),
            (ht.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
            (ht.fn.delay = function (e, n) {
                return (
                    (e = (ht.fx && ht.fx.speeds[e]) || e),
                    (n = n || "fx"),
                    this.queue(n, function (n, i) {
                        var o = t.setTimeout(n, e);
                        i.stop = function () {
                            t.clearTimeout(o);
                        };
                    })
                );
            }),
            (ge = K.createElement("input")),
            (ve = K.createElement("select").appendChild(K.createElement("option"))),
            (ge.type = "checkbox"),
            (ut.checkOn = "" !== ge.value),
            (ut.optSelected = ve.selected),
            ((ge = K.createElement("input")).value = "t"),
            (ge.type = "radio"),
            (ut.radioValue = "t" === ge.value);
        var be,
            xe = ht.expr.attrHandle;
        ht.fn.extend({
            attr: function (t, e) {
                return Et(this, ht.attr, t, e, 1 < arguments.length);
            },
            removeAttr: function (t) {
                return this.each(function () {
                    ht.removeAttr(this, t);
                });
            },
        }),
            ht.extend({
                attr: function (t, e, n) {
                    var i,
                        o,
                        r = t.nodeType;
                    if (3 !== r && 8 !== r && 2 !== r)
                        return void 0 === t.getAttribute
                            ? ht.prop(t, e, n)
                            : ((1 === r && ht.isXMLDoc(t)) || (o = ht.attrHooks[e.toLowerCase()] || (ht.expr.match.bool.test(e) ? be : void 0)),
                              void 0 !== n
                                  ? null === n
                                      ? void ht.removeAttr(t, e)
                                      : o && "set" in o && void 0 !== (i = o.set(t, n, e))
                                      ? i
                                      : (t.setAttribute(e, n + ""), n)
                                  : o && "get" in o && null !== (i = o.get(t, e))
                                  ? i
                                  : null == (i = ht.find.attr(t, e))
                                  ? void 0
                                  : i);
                },
                attrHooks: {
                    type: {
                        set: function (t, e) {
                            if (!ut.radioValue && "radio" === e && r(t, "input")) {
                                var n = t.value;
                                return t.setAttribute("type", e), n && (t.value = n), e;
                            }
                        },
                    },
                },
                removeAttr: function (t, e) {
                    var n,
                        i = 0,
                        o = e && e.match(kt);
                    if (o && 1 === t.nodeType) for (; (n = o[i++]); ) t.removeAttribute(n);
                },
            }),
            (be = {
                set: function (t, e, n) {
                    return !1 === e ? ht.removeAttr(t, n) : t.setAttribute(n, n), n;
                },
            }),
            ht.each(ht.expr.match.bool.source.match(/\w+/g), function (t, e) {
                var n = xe[e] || ht.find.attr;
                xe[e] = function (t, e, i) {
                    var o,
                        r,
                        s = e.toLowerCase();
                    return i || ((r = xe[s]), (xe[s] = o), (o = null != n(t, e, i) ? s : null), (xe[s] = r)), o;
                };
            });
        var _e = /^(?:input|select|textarea|button)$/i,
            Ce = /^(?:a|area)$/i;
        ht.fn.extend({
            prop: function (t, e) {
                return Et(this, ht.prop, t, e, 1 < arguments.length);
            },
            removeProp: function (t) {
                return this.each(function () {
                    delete this[ht.propFix[t] || t];
                });
            },
        }),
            ht.extend({
                prop: function (t, e, n) {
                    var i,
                        o,
                        r = t.nodeType;
                    if (3 !== r && 8 !== r && 2 !== r)
                        return (
                            (1 === r && ht.isXMLDoc(t)) || ((e = ht.propFix[e] || e), (o = ht.propHooks[e])),
                            void 0 !== n ? (o && "set" in o && void 0 !== (i = o.set(t, n, e)) ? i : (t[e] = n)) : o && "get" in o && null !== (i = o.get(t, e)) ? i : t[e]
                        );
                },
                propHooks: {
                    tabIndex: {
                        get: function (t) {
                            var e = ht.find.attr(t, "tabindex");
                            return e ? parseInt(e, 10) : _e.test(t.nodeName) || (Ce.test(t.nodeName) && t.href) ? 0 : -1;
                        },
                    },
                },
                propFix: { for: "htmlFor", class: "className" },
            }),
            ut.optSelected ||
                (ht.propHooks.selected = {
                    get: function (t) {
                        var e = t.parentNode;
                        return e && e.parentNode && e.parentNode.selectedIndex, null;
                    },
                    set: function (t) {
                        var e = t.parentNode;
                        e && (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex);
                    },
                }),
            ht.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
                ht.propFix[this.toLowerCase()] = this;
            }),
            ht.fn.extend({
                addClass: function (t) {
                    var e,
                        n,
                        i,
                        o,
                        r,
                        s,
                        a,
                        l = 0;
                    if (ct(t))
                        return this.each(function (e) {
                            ht(this).addClass(t.call(this, e, B(this)));
                        });
                    if ((e = Y(t)).length)
                        for (; (n = this[l++]); )
                            if (((o = B(n)), (i = 1 === n.nodeType && " " + W(o) + " "))) {
                                for (s = 0; (r = e[s++]); ) i.indexOf(" " + r + " ") < 0 && (i += r + " ");
                                o !== (a = W(i)) && n.setAttribute("class", a);
                            }
                    return this;
                },
                removeClass: function (t) {
                    var e,
                        n,
                        i,
                        o,
                        r,
                        s,
                        a,
                        l = 0;
                    if (ct(t))
                        return this.each(function (e) {
                            ht(this).removeClass(t.call(this, e, B(this)));
                        });
                    if (!arguments.length) return this.attr("class", "");
                    if ((e = Y(t)).length)
                        for (; (n = this[l++]); )
                            if (((o = B(n)), (i = 1 === n.nodeType && " " + W(o) + " "))) {
                                for (s = 0; (r = e[s++]); ) for (; -1 < i.indexOf(" " + r + " "); ) i = i.replace(" " + r + " ", " ");
                                o !== (a = W(i)) && n.setAttribute("class", a);
                            }
                    return this;
                },
                toggleClass: function (t, e) {
                    var n = typeof t,
                        i = "string" === n || Array.isArray(t);
                    return "boolean" == typeof e && i
                        ? e
                            ? this.addClass(t)
                            : this.removeClass(t)
                        : ct(t)
                        ? this.each(function (n) {
                              ht(this).toggleClass(t.call(this, n, B(this), e), e);
                          })
                        : this.each(function () {
                              var e, o, r, s;
                              if (i) for (o = 0, r = ht(this), s = Y(t); (e = s[o++]); ) r.hasClass(e) ? r.removeClass(e) : r.addClass(e);
                              else (void 0 !== t && "boolean" !== n) || ((e = B(this)) && At.set(this, "__className__", e), this.setAttribute && this.setAttribute("class", e || !1 === t ? "" : At.get(this, "__className__") || ""));
                          });
                },
                hasClass: function (t) {
                    var e,
                        n,
                        i = 0;
                    for (e = " " + t + " "; (n = this[i++]); ) if (1 === n.nodeType && -1 < (" " + W(B(n)) + " ").indexOf(e)) return !0;
                    return !1;
                },
            });
        var ke = /\r/g;
        ht.fn.extend({
            val: function (t) {
                var e,
                    n,
                    i,
                    o = this[0];
                return arguments.length
                    ? ((i = ct(t)),
                      this.each(function (n) {
                          var o;
                          1 === this.nodeType &&
                              (null == (o = i ? t.call(this, n, ht(this).val()) : t)
                                  ? (o = "")
                                  : "number" == typeof o
                                  ? (o += "")
                                  : Array.isArray(o) &&
                                    (o = ht.map(o, function (t) {
                                        return null == t ? "" : t + "";
                                    })),
                              ((e = ht.valHooks[this.type] || ht.valHooks[this.nodeName.toLowerCase()]) && "set" in e && void 0 !== e.set(this, o, "value")) || (this.value = o));
                      }))
                    : o
                    ? (e = ht.valHooks[o.type] || ht.valHooks[o.nodeName.toLowerCase()]) && "get" in e && void 0 !== (n = e.get(o, "value"))
                        ? n
                        : "string" == typeof (n = o.value)
                        ? n.replace(ke, "")
                        : null == n
                        ? ""
                        : n
                    : void 0;
            },
        }),
            ht.extend({
                valHooks: {
                    option: {
                        get: function (t) {
                            var e = ht.find.attr(t, "value");
                            return null != e ? e : W(ht.text(t));
                        },
                    },
                    select: {
                        get: function (t) {
                            var e,
                                n,
                                i,
                                o = t.options,
                                s = t.selectedIndex,
                                a = "select-one" === t.type,
                                l = a ? null : [],
                                u = a ? s + 1 : o.length;
                            for (i = s < 0 ? u : a ? s : 0; i < u; i++)
                                if (((n = o[i]).selected || i === s) && !n.disabled && (!n.parentNode.disabled || !r(n.parentNode, "optgroup"))) {
                                    if (((e = ht(n).val()), a)) return e;
                                    l.push(e);
                                }
                            return l;
                        },
                        set: function (t, e) {
                            for (var n, i, o = t.options, r = ht.makeArray(e), s = o.length; s--; ) ((i = o[s]).selected = -1 < ht.inArray(ht.valHooks.option.get(i), r)) && (n = !0);
                            return n || (t.selectedIndex = -1), r;
                        },
                    },
                },
            }),
            ht.each(["radio", "checkbox"], function () {
                (ht.valHooks[this] = {
                    set: function (t, e) {
                        if (Array.isArray(e)) return (t.checked = -1 < ht.inArray(ht(t).val(), e));
                    },
                }),
                    ut.checkOn ||
                        (ht.valHooks[this].get = function (t) {
                            return null === t.getAttribute("value") ? "on" : t.value;
                        });
            }),
            (ut.focusin = "onfocusin" in t);
        var Te = /^(?:focusinfocus|focusoutblur)$/,
            Se = function (t) {
                t.stopPropagation();
            };
        ht.extend(ht.event, {
            trigger: function (e, n, i, o) {
                var r,
                    s,
                    a,
                    l,
                    u,
                    c,
                    d,
                    p,
                    h = [i || K],
                    f = st.call(e, "type") ? e.type : e,
                    m = st.call(e, "namespace") ? e.namespace.split(".") : [];
                if (
                    ((s = p = a = i = i || K),
                    3 !== i.nodeType &&
                        8 !== i.nodeType &&
                        !Te.test(f + ht.event.triggered) &&
                        (-1 < f.indexOf(".") && ((f = (m = f.split(".")).shift()), m.sort()),
                        (u = f.indexOf(":") < 0 && "on" + f),
                        ((e = e[ht.expando] ? e : new ht.Event(f, "object" == typeof e && e)).isTrigger = o ? 2 : 3),
                        (e.namespace = m.join(".")),
                        (e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + m.join("\\.(?:.*\\.|)") + "(\\.|$)") : null),
                        (e.result = void 0),
                        e.target || (e.target = i),
                        (n = null == n ? [e] : ht.makeArray(n, [e])),
                        (d = ht.event.special[f] || {}),
                        o || !d.trigger || !1 !== d.trigger.apply(i, n)))
                ) {
                    if (!o && !d.noBubble && !dt(i)) {
                        for (l = d.delegateType || f, Te.test(l + f) || (s = s.parentNode); s; s = s.parentNode) h.push(s), (a = s);
                        a === (i.ownerDocument || K) && h.push(a.defaultView || a.parentWindow || t);
                    }
                    for (r = 0; (s = h[r++]) && !e.isPropagationStopped(); )
                        (p = s),
                            (e.type = 1 < r ? l : d.bindType || f),
                            (c = (At.get(s, "events") || {})[e.type] && At.get(s, "handle")) && c.apply(s, n),
                            (c = u && s[u]) && c.apply && Lt(s) && ((e.result = c.apply(s, n)), !1 === e.result && e.preventDefault());
                    return (
                        (e.type = f),
                        o ||
                            e.isDefaultPrevented() ||
                            (d._default && !1 !== d._default.apply(h.pop(), n)) ||
                            !Lt(i) ||
                            (u &&
                                ct(i[f]) &&
                                !dt(i) &&
                                ((a = i[u]) && (i[u] = null),
                                (ht.event.triggered = f),
                                e.isPropagationStopped() && p.addEventListener(f, Se),
                                i[f](),
                                e.isPropagationStopped() && p.removeEventListener(f, Se),
                                (ht.event.triggered = void 0),
                                a && (i[u] = a))),
                        e.result
                    );
                }
            },
            simulate: function (t, e, n) {
                var i = ht.extend(new ht.Event(), n, { type: t, isSimulated: !0 });
                ht.event.trigger(i, null, e);
            },
        }),
            ht.fn.extend({
                trigger: function (t, e) {
                    return this.each(function () {
                        ht.event.trigger(t, e, this);
                    });
                },
                triggerHandler: function (t, e) {
                    var n = this[0];
                    if (n) return ht.event.trigger(t, e, n, !0);
                },
            }),
            ut.focusin ||
                ht.each({ focus: "focusin", blur: "focusout" }, function (t, e) {
                    var n = function (t) {
                        ht.event.simulate(e, t.target, ht.event.fix(t));
                    };
                    ht.event.special[e] = {
                        setup: function () {
                            var i = this.ownerDocument || this,
                                o = At.access(i, e);
                            o || i.addEventListener(t, n, !0), At.access(i, e, (o || 0) + 1);
                        },
                        teardown: function () {
                            var i = this.ownerDocument || this,
                                o = At.access(i, e) - 1;
                            o ? At.access(i, e, o) : (i.removeEventListener(t, n, !0), At.remove(i, e));
                        },
                    };
                });
        var Ee = t.location,
            Ie = Date.now(),
            Pe = /\?/;
        ht.parseXML = function (e) {
            var n;
            if (!e || "string" != typeof e) return null;
            try {
                n = new t.DOMParser().parseFromString(e, "text/xml");
            } catch (e) {
                n = void 0;
            }
            return (n && !n.getElementsByTagName("parsererror").length) || ht.error("Invalid XML: " + e), n;
        };
        var Le = /\[\]$/,
            Ae = /\r?\n/g,
            $e = /^(?:submit|button|image|reset|file)$/i,
            Oe = /^(?:input|select|textarea|keygen)/i;
        (ht.param = function (t, e) {
            var n,
                i = [],
                o = function (t, e) {
                    var n = ct(e) ? e() : e;
                    i[i.length] = encodeURIComponent(t) + "=" + encodeURIComponent(null == n ? "" : n);
                };
            if (null == t) return "";
            if (Array.isArray(t) || (t.jquery && !ht.isPlainObject(t)))
                ht.each(t, function () {
                    o(this.name, this.value);
                });
            else for (n in t) X(n, t[n], e, o);
            return i.join("&");
        }),
            ht.fn.extend({
                serialize: function () {
                    return ht.param(this.serializeArray());
                },
                serializeArray: function () {
                    return this.map(function () {
                        var t = ht.prop(this, "elements");
                        return t ? ht.makeArray(t) : this;
                    })
                        .filter(function () {
                            var t = this.type;
                            return this.name && !ht(this).is(":disabled") && Oe.test(this.nodeName) && !$e.test(t) && (this.checked || !Wt.test(t));
                        })
                        .map(function (t, e) {
                            var n = ht(this).val();
                            return null == n
                                ? null
                                : Array.isArray(n)
                                ? ht.map(n, function (t) {
                                      return { name: e.name, value: t.replace(Ae, "\r\n") };
                                  })
                                : { name: e.name, value: n.replace(Ae, "\r\n") };
                        })
                        .get();
                },
            });
        var je = /%20/g,
            Ne = /#.*$/,
            Me = /([?&])_=[^&]*/,
            He = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            Fe = /^(?:GET|HEAD)$/,
            De = /^\/\//,
            ze = {},
            Ve = {},
            qe = "*/".concat("*"),
            Re = K.createElement("a");
        (Re.href = Ee.href),
            ht.extend({
                active: 0,
                lastModified: {},
                etag: {},
                ajaxSettings: {
                    url: Ee.href,
                    type: "GET",
                    isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Ee.protocol),
                    global: !0,
                    processData: !0,
                    async: !0,
                    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    accepts: { "*": qe, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" },
                    contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                    responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
                    converters: { "* text": String, "text html": !0, "text json": JSON.parse, "text xml": ht.parseXML },
                    flatOptions: { url: !0, context: !0 },
                },
                ajaxSetup: function (t, e) {
                    return e ? Q(Q(t, ht.ajaxSettings), e) : Q(ht.ajaxSettings, t);
                },
                ajaxPrefilter: U(ze),
                ajaxTransport: U(Ve),
                ajax: function (e, n) {
                    function i(e, n, i, a) {
                        var u,
                            p,
                            h,
                            b,
                            x,
                            _ = n;
                        c ||
                            ((c = !0),
                            l && t.clearTimeout(l),
                            (o = void 0),
                            (s = a || ""),
                            (C.readyState = 0 < e ? 4 : 0),
                            (u = (200 <= e && e < 300) || 304 === e),
                            i &&
                                (b = (function (t, e, n) {
                                    for (var i, o, r, s, a = t.contents, l = t.dataTypes; "*" === l[0]; ) l.shift(), void 0 === i && (i = t.mimeType || e.getResponseHeader("Content-Type"));
                                    if (i)
                                        for (o in a)
                                            if (a[o] && a[o].test(i)) {
                                                l.unshift(o);
                                                break;
                                            }
                                    if (l[0] in n) r = l[0];
                                    else {
                                        for (o in n) {
                                            if (!l[0] || t.converters[o + " " + l[0]]) {
                                                r = o;
                                                break;
                                            }
                                            s || (s = o);
                                        }
                                        r = r || s;
                                    }
                                    if (r) return r !== l[0] && l.unshift(r), n[r];
                                })(f, C, i)),
                            (b = (function (t, e, n, i) {
                                var o,
                                    r,
                                    s,
                                    a,
                                    l,
                                    u = {},
                                    c = t.dataTypes.slice();
                                if (c[1]) for (s in t.converters) u[s.toLowerCase()] = t.converters[s];
                                for (r = c.shift(); r; )
                                    if ((t.responseFields[r] && (n[t.responseFields[r]] = e), !l && i && t.dataFilter && (e = t.dataFilter(e, t.dataType)), (l = r), (r = c.shift())))
                                        if ("*" === r) r = l;
                                        else if ("*" !== l && l !== r) {
                                            if (!(s = u[l + " " + r] || u["* " + r]))
                                                for (o in u)
                                                    if ((a = o.split(" "))[1] === r && (s = u[l + " " + a[0]] || u["* " + a[0]])) {
                                                        !0 === s ? (s = u[o]) : !0 !== u[o] && ((r = a[0]), c.unshift(a[1]));
                                                        break;
                                                    }
                                            if (!0 !== s)
                                                if (s && t.throws) e = s(e);
                                                else
                                                    try {
                                                        e = s(e);
                                                    } catch (t) {
                                                        return { state: "parsererror", error: s ? t : "No conversion from " + l + " to " + r };
                                                    }
                                        }
                                return { state: "success", data: e };
                            })(f, b, C, u)),
                            u
                                ? (f.ifModified && ((x = C.getResponseHeader("Last-Modified")) && (ht.lastModified[r] = x), (x = C.getResponseHeader("etag")) && (ht.etag[r] = x)),
                                  204 === e || "HEAD" === f.type ? (_ = "nocontent") : 304 === e ? (_ = "notmodified") : ((_ = b.state), (p = b.data), (u = !(h = b.error))))
                                : ((h = _), (!e && _) || ((_ = "error"), e < 0 && (e = 0))),
                            (C.status = e),
                            (C.statusText = (n || _) + ""),
                            u ? v.resolveWith(m, [p, _, C]) : v.rejectWith(m, [C, _, h]),
                            C.statusCode(w),
                            (w = void 0),
                            d && g.trigger(u ? "ajaxSuccess" : "ajaxError", [C, f, u ? p : h]),
                            y.fireWith(m, [C, _]),
                            d && (g.trigger("ajaxComplete", [C, f]), --ht.active || ht.event.trigger("ajaxStop")));
                    }
                    "object" == typeof e && ((n = e), (e = void 0)), (n = n || {});
                    var o,
                        r,
                        s,
                        a,
                        l,
                        u,
                        c,
                        d,
                        p,
                        h,
                        f = ht.ajaxSetup({}, n),
                        m = f.context || f,
                        g = f.context && (m.nodeType || m.jquery) ? ht(m) : ht.event,
                        v = ht.Deferred(),
                        y = ht.Callbacks("once memory"),
                        w = f.statusCode || {},
                        b = {},
                        x = {},
                        _ = "canceled",
                        C = {
                            readyState: 0,
                            getResponseHeader: function (t) {
                                var e;
                                if (c) {
                                    if (!a) for (a = {}; (e = He.exec(s)); ) a[e[1].toLowerCase() + " "] = (a[e[1].toLowerCase() + " "] || []).concat(e[2]);
                                    e = a[t.toLowerCase() + " "];
                                }
                                return null == e ? null : e.join(", ");
                            },
                            getAllResponseHeaders: function () {
                                return c ? s : null;
                            },
                            setRequestHeader: function (t, e) {
                                return null == c && ((t = x[t.toLowerCase()] = x[t.toLowerCase()] || t), (b[t] = e)), this;
                            },
                            overrideMimeType: function (t) {
                                return null == c && (f.mimeType = t), this;
                            },
                            statusCode: function (t) {
                                var e;
                                if (t)
                                    if (c) C.always(t[C.status]);
                                    else for (e in t) w[e] = [w[e], t[e]];
                                return this;
                            },
                            abort: function (t) {
                                var e = t || _;
                                return o && o.abort(e), i(0, e), this;
                            },
                        };
                    if (
                        (v.promise(C),
                        (f.url = ((e || f.url || Ee.href) + "").replace(De, Ee.protocol + "//")),
                        (f.type = n.method || n.type || f.method || f.type),
                        (f.dataTypes = (f.dataType || "*").toLowerCase().match(kt) || [""]),
                        null == f.crossDomain)
                    ) {
                        u = K.createElement("a");
                        try {
                            (u.href = f.url), (u.href = u.href), (f.crossDomain = Re.protocol + "//" + Re.host != u.protocol + "//" + u.host);
                        } catch (e) {
                            f.crossDomain = !0;
                        }
                    }
                    if ((f.data && f.processData && "string" != typeof f.data && (f.data = ht.param(f.data, f.traditional)), G(ze, f, n, C), c)) return C;
                    for (p in ((d = ht.event && f.global) && 0 == ht.active++ && ht.event.trigger("ajaxStart"),
                    (f.type = f.type.toUpperCase()),
                    (f.hasContent = !Fe.test(f.type)),
                    (r = f.url.replace(Ne, "")),
                    f.hasContent
                        ? f.data && f.processData && 0 === (f.contentType || "").indexOf("application/x-www-form-urlencoded") && (f.data = f.data.replace(je, "+"))
                        : ((h = f.url.slice(r.length)),
                          f.data && (f.processData || "string" == typeof f.data) && ((r += (Pe.test(r) ? "&" : "?") + f.data), delete f.data),
                          !1 === f.cache && ((r = r.replace(Me, "$1")), (h = (Pe.test(r) ? "&" : "?") + "_=" + Ie++ + h)),
                          (f.url = r + h)),
                    f.ifModified && (ht.lastModified[r] && C.setRequestHeader("If-Modified-Since", ht.lastModified[r]), ht.etag[r] && C.setRequestHeader("If-None-Match", ht.etag[r])),
                    ((f.data && f.hasContent && !1 !== f.contentType) || n.contentType) && C.setRequestHeader("Content-Type", f.contentType),
                    C.setRequestHeader("Accept", f.dataTypes[0] && f.accepts[f.dataTypes[0]] ? f.accepts[f.dataTypes[0]] + ("*" !== f.dataTypes[0] ? ", " + qe + "; q=0.01" : "") : f.accepts["*"]),
                    f.headers))
                        C.setRequestHeader(p, f.headers[p]);
                    if (f.beforeSend && (!1 === f.beforeSend.call(m, C, f) || c)) return C.abort();
                    if (((_ = "abort"), y.add(f.complete), C.done(f.success), C.fail(f.error), (o = G(Ve, f, n, C)))) {
                        if (((C.readyState = 1), d && g.trigger("ajaxSend", [C, f]), c)) return C;
                        f.async &&
                            0 < f.timeout &&
                            (l = t.setTimeout(function () {
                                C.abort("timeout");
                            }, f.timeout));
                        try {
                            (c = !1), o.send(b, i);
                        } catch (e) {
                            if (c) throw e;
                            i(-1, e);
                        }
                    } else i(-1, "No Transport");
                    return C;
                },
                getJSON: function (t, e, n) {
                    return ht.get(t, e, n, "json");
                },
                getScript: function (t, e) {
                    return ht.get(t, void 0, e, "script");
                },
            }),
            ht.each(["get", "post"], function (t, e) {
                ht[e] = function (t, n, i, o) {
                    return ct(n) && ((o = o || i), (i = n), (n = void 0)), ht.ajax(ht.extend({ url: t, type: e, dataType: o, data: n, success: i }, ht.isPlainObject(t) && t));
                };
            }),
            (ht._evalUrl = function (t, e) {
                return ht.ajax({
                    url: t,
                    type: "GET",
                    dataType: "script",
                    cache: !0,
                    async: !1,
                    global: !1,
                    converters: { "text script": function () {} },
                    dataFilter: function (t) {
                        ht.globalEval(t, e);
                    },
                });
            }),
            ht.fn.extend({
                wrapAll: function (t) {
                    var e;
                    return (
                        this[0] &&
                            (ct(t) && (t = t.call(this[0])),
                            (e = ht(t, this[0].ownerDocument).eq(0).clone(!0)),
                            this[0].parentNode && e.insertBefore(this[0]),
                            e
                                .map(function () {
                                    for (var t = this; t.firstElementChild; ) t = t.firstElementChild;
                                    return t;
                                })
                                .append(this)),
                        this
                    );
                },
                wrapInner: function (t) {
                    return ct(t)
                        ? this.each(function (e) {
                              ht(this).wrapInner(t.call(this, e));
                          })
                        : this.each(function () {
                              var e = ht(this),
                                  n = e.contents();
                              n.length ? n.wrapAll(t) : e.append(t);
                          });
                },
                wrap: function (t) {
                    var e = ct(t);
                    return this.each(function (n) {
                        ht(this).wrapAll(e ? t.call(this, n) : t);
                    });
                },
                unwrap: function (t) {
                    return (
                        this.parent(t)
                            .not("body")
                            .each(function () {
                                ht(this).replaceWith(this.childNodes);
                            }),
                        this
                    );
                },
            }),
            (ht.expr.pseudos.hidden = function (t) {
                return !ht.expr.pseudos.visible(t);
            }),
            (ht.expr.pseudos.visible = function (t) {
                return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
            }),
            (ht.ajaxSettings.xhr = function () {
                try {
                    return new t.XMLHttpRequest();
                } catch (t) {}
            });
        var We = { 0: 200, 1223: 204 },
            Be = ht.ajaxSettings.xhr();
        (ut.cors = !!Be && "withCredentials" in Be),
            (ut.ajax = Be = !!Be),
            ht.ajaxTransport(function (e) {
                var n, i;
                if (ut.cors || (Be && !e.crossDomain))
                    return {
                        send: function (o, r) {
                            var s,
                                a = e.xhr();
                            if ((a.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)) for (s in e.xhrFields) a[s] = e.xhrFields[s];
                            for (s in (e.mimeType && a.overrideMimeType && a.overrideMimeType(e.mimeType), e.crossDomain || o["X-Requested-With"] || (o["X-Requested-With"] = "XMLHttpRequest"), o)) a.setRequestHeader(s, o[s]);
                            (n = function (t) {
                                return function () {
                                    n &&
                                        ((n = i = a.onload = a.onerror = a.onabort = a.ontimeout = a.onreadystatechange = null),
                                        "abort" === t
                                            ? a.abort()
                                            : "error" === t
                                            ? "number" != typeof a.status
                                                ? r(0, "error")
                                                : r(a.status, a.statusText)
                                            : r(
                                                  We[a.status] || a.status,
                                                  a.statusText,
                                                  "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? { binary: a.response } : { text: a.responseText },
                                                  a.getAllResponseHeaders()
                                              ));
                                };
                            }),
                                (a.onload = n()),
                                (i = a.onerror = a.ontimeout = n("error")),
                                void 0 !== a.onabort
                                    ? (a.onabort = i)
                                    : (a.onreadystatechange = function () {
                                          4 === a.readyState &&
                                              t.setTimeout(function () {
                                                  n && i();
                                              });
                                      }),
                                (n = n("abort"));
                            try {
                                a.send((e.hasContent && e.data) || null);
                            } catch (o) {
                                if (n) throw o;
                            }
                        },
                        abort: function () {
                            n && n();
                        },
                    };
            }),
            ht.ajaxPrefilter(function (t) {
                t.crossDomain && (t.contents.script = !1);
            }),
            ht.ajaxSetup({
                accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" },
                contents: { script: /\b(?:java|ecma)script\b/ },
                converters: {
                    "text script": function (t) {
                        return ht.globalEval(t), t;
                    },
                },
            }),
            ht.ajaxPrefilter("script", function (t) {
                void 0 === t.cache && (t.cache = !1), t.crossDomain && (t.type = "GET");
            }),
            ht.ajaxTransport("script", function (t) {
                var e, n;
                if (t.crossDomain || t.scriptAttrs)
                    return {
                        send: function (i, o) {
                            (e = ht("<script>")
                                .attr(t.scriptAttrs || {})
                                .prop({ charset: t.scriptCharset, src: t.url })
                                .on(
                                    "load error",
                                    (n = function (t) {
                                        e.remove(), (n = null), t && o("error" === t.type ? 404 : 200, t.type);
                                    })
                                )),
                                K.head.appendChild(e[0]);
                        },
                        abort: function () {
                            n && n();
                        },
                    };
            });
        var Ye,
            Xe = [],
            Ue = /(=)\?(?=&|$)|\?\?/;
        ht.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function () {
                var t = Xe.pop() || ht.expando + "_" + Ie++;
                return (this[t] = !0), t;
            },
        }),
            ht.ajaxPrefilter("json jsonp", function (e, n, i) {
                var o,
                    r,
                    s,
                    a = !1 !== e.jsonp && (Ue.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Ue.test(e.data) && "data");
                if (a || "jsonp" === e.dataTypes[0])
                    return (
                        (o = e.jsonpCallback = ct(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
                        a ? (e[a] = e[a].replace(Ue, "$1" + o)) : !1 !== e.jsonp && (e.url += (Pe.test(e.url) ? "&" : "?") + e.jsonp + "=" + o),
                        (e.converters["script json"] = function () {
                            return s || ht.error(o + " was not called"), s[0];
                        }),
                        (e.dataTypes[0] = "json"),
                        (r = t[o]),
                        (t[o] = function () {
                            s = arguments;
                        }),
                        i.always(function () {
                            void 0 === r ? ht(t).removeProp(o) : (t[o] = r), e[o] && ((e.jsonpCallback = n.jsonpCallback), Xe.push(o)), s && ct(r) && r(s[0]), (s = r = void 0);
                        }),
                        "script"
                    );
            }),
            (ut.createHTMLDocument = (((Ye = K.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>"), 2 === Ye.childNodes.length)),
            (ht.parseHTML = function (t, e, n) {
                return "string" != typeof t
                    ? []
                    : ("boolean" == typeof e && ((n = e), (e = !1)),
                      e || (ut.createHTMLDocument ? (((i = (e = K.implementation.createHTMLDocument("")).createElement("base")).href = K.location.href), e.head.appendChild(i)) : (e = K)),
                      (r = !n && []),
                      (o = wt.exec(t)) ? [e.createElement(o[1])] : ((o = b([t], e, r)), r && r.length && ht(r).remove(), ht.merge([], o.childNodes)));
                var i, o, r;
            }),
            (ht.fn.load = function (t, e, n) {
                var i,
                    o,
                    r,
                    s = this,
                    a = t.indexOf(" ");
                return (
                    -1 < a && ((i = W(t.slice(a))), (t = t.slice(0, a))),
                    ct(e) ? ((n = e), (e = void 0)) : e && "object" == typeof e && (o = "POST"),
                    0 < s.length &&
                        ht
                            .ajax({ url: t, type: o || "GET", dataType: "html", data: e })
                            .done(function (t) {
                                (r = arguments), s.html(i ? ht("<div>").append(ht.parseHTML(t)).find(i) : t);
                            })
                            .always(
                                n &&
                                    function (t, e) {
                                        s.each(function () {
                                            n.apply(this, r || [t.responseText, e, t]);
                                        });
                                    }
                            ),
                    this
                );
            }),
            ht.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (t, e) {
                ht.fn[e] = function (t) {
                    return this.on(e, t);
                };
            }),
            (ht.expr.pseudos.animated = function (t) {
                return ht.grep(ht.timers, function (e) {
                    return t === e.elem;
                }).length;
            }),
            (ht.offset = {
                setOffset: function (t, e, n) {
                    var i,
                        o,
                        r,
                        s,
                        a,
                        l,
                        u = ht.css(t, "position"),
                        c = ht(t),
                        d = {};
                    "static" === u && (t.style.position = "relative"),
                        (a = c.offset()),
                        (r = ht.css(t, "top")),
                        (l = ht.css(t, "left")),
                        ("absolute" === u || "fixed" === u) && -1 < (r + l).indexOf("auto") ? ((s = (i = c.position()).top), (o = i.left)) : ((s = parseFloat(r) || 0), (o = parseFloat(l) || 0)),
                        ct(e) && (e = e.call(t, n, ht.extend({}, a))),
                        null != e.top && (d.top = e.top - a.top + s),
                        null != e.left && (d.left = e.left - a.left + o),
                        "using" in e ? e.using.call(t, d) : c.css(d);
                },
            }),
            ht.fn.extend({
                offset: function (t) {
                    if (arguments.length)
                        return void 0 === t
                            ? this
                            : this.each(function (e) {
                                  ht.offset.setOffset(this, t, e);
                              });
                    var e,
                        n,
                        i = this[0];
                    return i ? (i.getClientRects().length ? ((e = i.getBoundingClientRect()), (n = i.ownerDocument.defaultView), { top: e.top + n.pageYOffset, left: e.left + n.pageXOffset }) : { top: 0, left: 0 }) : void 0;
                },
                position: function () {
                    if (this[0]) {
                        var t,
                            e,
                            n,
                            i = this[0],
                            o = { top: 0, left: 0 };
                        if ("fixed" === ht.css(i, "position")) e = i.getBoundingClientRect();
                        else {
                            for (e = this.offset(), n = i.ownerDocument, t = i.offsetParent || n.documentElement; t && (t === n.body || t === n.documentElement) && "static" === ht.css(t, "position"); ) t = t.parentNode;
                            t && t !== i && 1 === t.nodeType && (((o = ht(t).offset()).top += ht.css(t, "borderTopWidth", !0)), (o.left += ht.css(t, "borderLeftWidth", !0)));
                        }
                        return { top: e.top - o.top - ht.css(i, "marginTop", !0), left: e.left - o.left - ht.css(i, "marginLeft", !0) };
                    }
                },
                offsetParent: function () {
                    return this.map(function () {
                        for (var t = this.offsetParent; t && "static" === ht.css(t, "position"); ) t = t.offsetParent;
                        return t || Ft;
                    });
                },
            }),
            ht.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (t, e) {
                var n = "pageYOffset" === e;
                ht.fn[t] = function (i) {
                    return Et(
                        this,
                        function (t, i, o) {
                            var r;
                            if ((dt(t) ? (r = t) : 9 === t.nodeType && (r = t.defaultView), void 0 === o)) return r ? r[e] : t[i];
                            r ? r.scrollTo(n ? r.pageXOffset : o, n ? o : r.pageYOffset) : (t[i] = o);
                        },
                        t,
                        i,
                        arguments.length
                    );
                };
            }),
            ht.each(["top", "left"], function (t, e) {
                ht.cssHooks[e] = O(ut.pixelPosition, function (t, n) {
                    if (n) return (n = $(t, e)), oe.test(n) ? ht(t).position()[e] + "px" : n;
                });
            }),
            ht.each({ Height: "height", Width: "width" }, function (t, e) {
                ht.each({ padding: "inner" + t, content: e, "": "outer" + t }, function (n, i) {
                    ht.fn[i] = function (o, r) {
                        var s = arguments.length && (n || "boolean" != typeof o),
                            a = n || (!0 === o || !0 === r ? "margin" : "border");
                        return Et(
                            this,
                            function (e, n, o) {
                                var r;
                                return dt(e)
                                    ? 0 === i.indexOf("outer")
                                        ? e["inner" + t]
                                        : e.document.documentElement["client" + t]
                                    : 9 === e.nodeType
                                    ? ((r = e.documentElement), Math.max(e.body["scroll" + t], r["scroll" + t], e.body["offset" + t], r["offset" + t], r["client" + t]))
                                    : void 0 === o
                                    ? ht.css(e, n, a)
                                    : ht.style(e, n, o, a);
                            },
                            e,
                            s ? o : void 0,
                            s
                        );
                    };
                });
            }),
            ht.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (t, e) {
                ht.fn[e] = function (t, n) {
                    return 0 < arguments.length ? this.on(e, null, t, n) : this.trigger(e);
                };
            }),
            ht.fn.extend({
                hover: function (t, e) {
                    return this.mouseenter(t).mouseleave(e || t);
                },
            }),
            ht.fn.extend({
                bind: function (t, e, n) {
                    return this.on(t, null, e, n);
                },
                unbind: function (t, e) {
                    return this.off(t, null, e);
                },
                delegate: function (t, e, n, i) {
                    return this.on(e, t, n, i);
                },
                undelegate: function (t, e, n) {
                    return 1 === arguments.length ? this.off(t, "**") : this.off(e, t || "**", n);
                },
            }),
            (ht.proxy = function (t, e) {
                var n, i, o;
                if (("string" == typeof e && ((n = t[e]), (e = t), (t = n)), ct(t)))
                    return (
                        (i = tt.call(arguments, 2)),
                        ((o = function () {
                            return t.apply(e || this, i.concat(tt.call(arguments)));
                        }).guid = t.guid = t.guid || ht.guid++),
                        o
                    );
            }),
            (ht.holdReady = function (t) {
                t ? ht.readyWait++ : ht.ready(!0);
            }),
            (ht.isArray = Array.isArray),
            (ht.parseJSON = JSON.parse),
            (ht.nodeName = r),
            (ht.isFunction = ct),
            (ht.isWindow = dt),
            (ht.camelCase = h),
            (ht.type = i),
            (ht.now = Date.now),
            (ht.isNumeric = function (t) {
                var e = ht.type(t);
                return ("number" === e || "string" === e) && !isNaN(t - parseFloat(t));
            }),
            "function" == typeof define &&
                define.amd &&
                define("jquery", [], function () {
                    return ht;
                });
        var Ge = t.jQuery,
            Qe = t.$;
        return (
            (ht.noConflict = function (e) {
                return t.$ === ht && (t.$ = Qe), e && t.jQuery === ht && (t.jQuery = Ge), ht;
            }),
            e || (t.jQuery = t.$ = ht),
            ht
        );
    }),
    "object" == typeof module && "object" == typeof module.exports
        ? (module.exports = e.document
              ? n(e, !0)
              : function (t) {
                    if (!t.document) throw new Error("jQuery requires a window with a document");
                    return n(t);
                })
        : n(e);
var i = navigator.userAgent.indexOf("Android") > 0,
    o = /iP(ad|hone|od)/.test(navigator.userAgent),
    r = o && /OS 4_\d(_\d)?/.test(navigator.userAgent),
    s = o && /OS ([6-9]|\d{2})_\d/.test(navigator.userAgent),
    a = navigator.userAgent.indexOf("BB10") > 0;
(t.prototype.needsClick = function (t) {
    switch (t.nodeName.toLowerCase()) {
        case "button":
        case "select":
        case "textarea":
            if (t.disabled) return !0;
            break;
        case "input":
            if ((o && "file" === t.type) || t.disabled) return !0;
            break;
        case "label":
        case "video":
            return !0;
    }
    return /\bneedsclick\b/.test(t.className);
}),
    (t.prototype.needsFocus = function (t) {
        switch (t.nodeName.toLowerCase()) {
            case "textarea":
                return !0;
            case "select":
                return !i;
            case "input":
                switch (t.type) {
                    case "button":
                    case "checkbox":
                    case "file":
                    case "image":
                    case "radio":
                    case "submit":
                        return !1;
                }
                return !t.disabled && !t.readOnly;
            default:
                return /\bneedsfocus\b/.test(t.className);
        }
    }),
    (t.prototype.sendClick = function (t, e) {
        var n, i;
        document.activeElement && document.activeElement !== t && document.activeElement.blur(),
            (i = e.changedTouches[0]),
            (n = document.createEvent("MouseEvents")).initMouseEvent(this.determineEventType(t), !0, !0, window, 1, i.screenX, i.screenY, i.clientX, i.clientY, !1, !1, !1, !1, 0, null),
            (n.forwardedTouchEvent = !0),
            t.dispatchEvent(n);
    }),
    (t.prototype.determineEventType = function (t) {
        return i && "select" === t.tagName.toLowerCase() ? "mousedown" : "click";
    }),
    (t.prototype.focus = function (t) {
        var e;
        o && t.setSelectionRange && 0 !== t.type.indexOf("date") && "time" !== t.type ? ((e = t.value.length), t.setSelectionRange(e, e)) : t.focus();
    }),
    (t.prototype.updateScrollParent = function (t) {
        var e, n;
        if (!(e = t.fastClickScrollParent) || !e.contains(t)) {
            n = t;
            do {
                if (n.scrollHeight > n.offsetHeight) {
                    (e = n), (t.fastClickScrollParent = n);
                    break;
                }
                n = n.parentElement;
            } while (n);
        }
        e && (e.fastClickLastScrollTop = e.scrollTop);
    }),
    (t.prototype.getTargetElementFromEventTarget = function (t) {
        return t.nodeType === Node.TEXT_NODE ? t.parentNode : t;
    }),
    (t.prototype.onTouchStart = function (t) {
        var e, n, i;
        if (t.targetTouches.length > 1) return !0;
        if (((e = this.getTargetElementFromEventTarget(t.target)), (n = t.targetTouches[0]), o)) {
            if ((i = window.getSelection()).rangeCount && !i.isCollapsed) return !0;
            if (!r) {
                if (n.identifier && n.identifier === this.lastTouchIdentifier) return t.preventDefault(), !1;
                (this.lastTouchIdentifier = n.identifier), this.updateScrollParent(e);
            }
        }
        return (
            (this.trackingClick = !0), (this.trackingClickStart = t.timeStamp), (this.targetElement = e), (this.touchStartX = n.pageX), (this.touchStartY = n.pageY), t.timeStamp - this.lastClickTime < this.tapDelay && t.preventDefault(), !0
        );
    }),
    (t.prototype.touchHasMoved = function (t) {
        var e = t.changedTouches[0],
            n = this.touchBoundary;
        return Math.abs(e.pageX - this.touchStartX) > n || Math.abs(e.pageY - this.touchStartY) > n;
    }),
    (t.prototype.onTouchMove = function (t) {
        return !this.trackingClick || ((this.targetElement !== this.getTargetElementFromEventTarget(t.target) || this.touchHasMoved(t)) && ((this.trackingClick = !1), (this.targetElement = null)), !0);
    }),
    (t.prototype.findControl = function (t) {
        return void 0 !== t.control ? t.control : t.htmlFor ? document.getElementById(t.htmlFor) : t.querySelector("button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea");
    }),
    (t.prototype.onTouchEnd = function (t) {
        var e,
            n,
            a,
            l,
            u,
            c = this.targetElement;
        if (!this.trackingClick) return !0;
        if (t.timeStamp - this.lastClickTime < this.tapDelay) return (this.cancelNextClick = !0), !0;
        if (
            ((this.cancelNextClick = !1),
            (this.lastClickTime = t.timeStamp),
            (n = this.trackingClickStart),
            (this.trackingClick = !1),
            (this.trackingClickStart = 0),
            s && ((u = t.changedTouches[0]), ((c = document.elementFromPoint(u.pageX - window.pageXOffset, u.pageY - window.pageYOffset) || c).fastClickScrollParent = this.targetElement.fastClickScrollParent)),
            "label" === (a = c.tagName.toLowerCase()))
        ) {
            if ((e = this.findControl(c))) {
                if ((this.focus(c), i)) return !1;
                c = e;
            }
        } else if (this.needsFocus(c))
            return t.timeStamp - n > 100 || (o && window.top !== window && "input" === a)
                ? ((this.targetElement = null), !1)
                : (this.focus(c), this.sendClick(c, t), (o && "select" === a) || ((this.targetElement = null), t.preventDefault()), !1);
        return !(!o || r || !(l = c.fastClickScrollParent) || l.fastClickLastScrollTop === l.scrollTop) || (this.needsClick(c) || (t.preventDefault(), this.sendClick(c, t)), !1);
    }),
    (t.prototype.onTouchCancel = function () {
        (this.trackingClick = !1), (this.targetElement = null);
    }),
    (t.prototype.onMouse = function (t) {
        return !(
            this.targetElement &&
            !t.forwardedTouchEvent &&
            t.cancelable &&
            (!this.needsClick(this.targetElement) || this.cancelNextClick) &&
            (t.stopImmediatePropagation ? t.stopImmediatePropagation() : (t.propagationStopped = !0), t.stopPropagation(), t.preventDefault(), 1)
        );
    }),
    (t.prototype.onClick = function (t) {
        var e;
        return this.trackingClick ? ((this.targetElement = null), (this.trackingClick = !1), !0) : ("submit" === t.target.type && 0 === t.detail) || ((e = this.onMouse(t)) || (this.targetElement = null), e);
    }),
    (t.prototype.destroy = function () {
        var t = this.layer;
        i && (t.removeEventListener("mouseover", this.onMouse, !0), t.removeEventListener("mousedown", this.onMouse, !0), t.removeEventListener("mouseup", this.onMouse, !0)),
            t.removeEventListener("click", this.onClick, !0),
            t.removeEventListener("touchstart", this.onTouchStart, !1),
            t.removeEventListener("touchmove", this.onTouchMove, !1),
            t.removeEventListener("touchend", this.onTouchEnd, !1),
            t.removeEventListener("touchcancel", this.onTouchCancel, !1);
    }),
    (t.notNeeded = function (t) {
        var e, n, o;
        if (void 0 === window.ontouchstart) return !0;
        if ((n = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1])) {
            if (!i) return !0;
            if ((e = document.querySelector("meta[name=viewport]"))) {
                if (-1 !== e.content.indexOf("user-scalable=no")) return !0;
                if (n > 31 && document.documentElement.scrollWidth <= window.outerWidth) return !0;
            }
        }
        if (a && (o = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/))[1] >= 10 && o[2] >= 3 && (e = document.querySelector("meta[name=viewport]"))) {
            if (-1 !== e.content.indexOf("user-scalable=no")) return !0;
            if (document.documentElement.scrollWidth <= window.outerWidth) return !0;
        }
        return "none" === t.style.msTouchAction;
    }),
    (t.attach = function (e, n) {
        return new t(e, n);
    }),
    "function" == typeof define && "object" == typeof define.amd && define.amd
        ? define(function () {
              return t;
          })
        : "undefined" != typeof module && module.exports
        ? ((module.exports = t.attach), (module.exports.FastClick = t))
        : (window.FastClick = t),
    /*!
     *  jQuery OwlCarousel v1.3.2
     *
     *  Copyright (c) 2013 Bartosz Wojciechowski
     *  http://www.owlgraphic.com/owlcarousel/
     *
     *  Licensed under MIT
     *
     */
    "function" != typeof Object.create &&
        (Object.create = function (t) {
            function e() {}
            return (e.prototype = t), new e();
        }),
    (function (t, e, n) {
        var i = {
            init: function (e, n) {
                var i = this;
                (i.$elem = t(n)), (i.options = t.extend({}, t.fn.owlCarousel.options, i.$elem.data(), e)), (i.userOptions = e), i.loadContent();
            },
            loadContent: function () {
                var e,
                    n = this;
                "function" == typeof n.options.beforeInit && n.options.beforeInit.apply(this, [n.$elem]),
                    "string" == typeof n.options.jsonPath
                        ? ((e = n.options.jsonPath),
                          t.getJSON(e, function (t) {
                              var e,
                                  i = "";
                              if ("function" == typeof n.options.jsonSuccess) n.options.jsonSuccess.apply(this, [t]);
                              else {
                                  for (e in t.owl) t.owl.hasOwnProperty(e) && (i += t.owl[e].item);
                                  n.$elem.html(i);
                              }
                              n.logIn();
                          }))
                        : n.logIn();
            },
            logIn: function () {
                var t = this;
                t.$elem.data("owl-originalStyles", t.$elem.attr("style")).data("owl-originalClasses", t.$elem.attr("class")),
                    t.$elem.css({ opacity: 0 }),
                    (t.orignalItems = t.options.items),
                    t.checkBrowser(),
                    (t.wrapperWidth = 0),
                    (t.checkVisible = null),
                    t.setVars();
            },
            setVars: function () {
                var t = this;
                if (0 === t.$elem.children().length) return !1;
                t.baseClass(),
                    t.eventTypes(),
                    (t.$userItems = t.$elem.children()),
                    (t.itemsAmount = t.$userItems.length),
                    t.wrapItems(),
                    (t.$owlItems = t.$elem.find(".owl-item")),
                    (t.$owlWrapper = t.$elem.find(".owl-wrapper")),
                    (t.playDirection = "next"),
                    (t.prevItem = 0),
                    (t.prevArr = [0]),
                    (t.currentItem = 0),
                    t.customEvents(),
                    t.onStartup();
            },
            onStartup: function () {
                var t = this;
                t.updateItems(),
                    t.calculateAll(),
                    t.buildControls(),
                    t.updateControls(),
                    t.response(),
                    t.moveEvents(),
                    t.stopOnHover(),
                    t.owlStatus(),
                    !1 !== t.options.transitionStyle && t.transitionTypes(t.options.transitionStyle),
                    !0 === t.options.autoPlay && (t.options.autoPlay = 5e3),
                    t.play(),
                    t.$elem.find(".owl-wrapper").css("display", "block"),
                    t.$elem.is(":visible") ? t.$elem.css("opacity", 1) : t.watchVisibility(),
                    (t.onstartup = !1),
                    t.eachMoveUpdate(),
                    "function" == typeof t.options.afterInit && t.options.afterInit.apply(this, [t.$elem]);
            },
            eachMoveUpdate: function () {
                var t = this;
                !0 === t.options.lazyLoad && t.lazyLoad(), !0 === t.options.autoHeight && t.autoHeight(), t.onVisibleItems(), "function" == typeof t.options.afterAction && t.options.afterAction.apply(this, [t.$elem]);
            },
            updateVars: function () {
                var t = this;
                "function" == typeof t.options.beforeUpdate && t.options.beforeUpdate.apply(this, [t.$elem]),
                    t.watchVisibility(),
                    t.updateItems(),
                    t.calculateAll(),
                    t.updatePosition(),
                    t.updateControls(),
                    t.eachMoveUpdate(),
                    "function" == typeof t.options.afterUpdate && t.options.afterUpdate.apply(this, [t.$elem]);
            },
            reload: function () {
                var t = this;
                e.setTimeout(function () {
                    t.updateVars();
                }, 0);
            },
            watchVisibility: function () {
                var t = this;
                if (!1 !== t.$elem.is(":visible")) return !1;
                t.$elem.css({ opacity: 0 }),
                    e.clearInterval(t.autoPlayInterval),
                    e.clearInterval(t.checkVisible),
                    (t.checkVisible = e.setInterval(function () {
                        t.$elem.is(":visible") && (t.reload(), t.$elem.animate({ opacity: 1 }, 200), e.clearInterval(t.checkVisible));
                    }, 500));
            },
            wrapItems: function () {
                var t = this;
                t.$userItems.wrapAll('<div class="owl-wrapper">').wrap('<div class="owl-item"></div>'),
                    t.$elem.find(".owl-wrapper").wrap('<div class="owl-wrapper-outer">'),
                    (t.wrapperOuter = t.$elem.find(".owl-wrapper-outer")),
                    t.$elem.css("display", "block");
            },
            baseClass: function () {
                var t = this,
                    e = t.$elem.hasClass(t.options.baseClass),
                    n = t.$elem.hasClass(t.options.theme);
                e || t.$elem.addClass(t.options.baseClass), n || t.$elem.addClass(t.options.theme);
            },
            updateItems: function () {
                var e,
                    n,
                    i = this;
                if (!1 === i.options.responsive) return !1;
                if (!0 === i.options.singleItem)
                    return (
                        (i.options.items = i.orignalItems = 1),
                        (i.options.itemsCustom = !1),
                        (i.options.itemsDesktop = !1),
                        (i.options.itemsDesktopSmall = !1),
                        (i.options.itemsTablet = !1),
                        (i.options.itemsTabletSmall = !1),
                        (i.options.itemsMobile = !1),
                        !1
                    );
                if (((e = t(i.options.responsiveBaseWidth).width()) > (i.options.itemsDesktop[0] || i.orignalItems) && (i.options.items = i.orignalItems), !1 !== i.options.itemsCustom))
                    for (
                        i.options.itemsCustom.sort(function (t, e) {
                            return t[0] - e[0];
                        }),
                            n = 0;
                        n < i.options.itemsCustom.length;
                        n += 1
                    )
                        i.options.itemsCustom[n][0] <= e && (i.options.items = i.options.itemsCustom[n][1]);
                else
                    e <= i.options.itemsDesktop[0] && !1 !== i.options.itemsDesktop && (i.options.items = i.options.itemsDesktop[1]),
                        e <= i.options.itemsDesktopSmall[0] && !1 !== i.options.itemsDesktopSmall && (i.options.items = i.options.itemsDesktopSmall[1]),
                        e <= i.options.itemsTablet[0] && !1 !== i.options.itemsTablet && (i.options.items = i.options.itemsTablet[1]),
                        e <= i.options.itemsTabletSmall[0] && !1 !== i.options.itemsTabletSmall && (i.options.items = i.options.itemsTabletSmall[1]),
                        e <= i.options.itemsMobile[0] && !1 !== i.options.itemsMobile && (i.options.items = i.options.itemsMobile[1]);
                i.options.items > i.itemsAmount && !0 === i.options.itemsScaleUp && (i.options.items = i.itemsAmount);
            },
            response: function () {
                var n,
                    i,
                    o = this;
                if (!0 !== o.options.responsive) return !1;
                (i = t(e).width()),
                    (o.resizer = function () {
                        t(e).width() !== i &&
                            (!1 !== o.options.autoPlay && e.clearInterval(o.autoPlayInterval),
                            e.clearTimeout(n),
                            (n = e.setTimeout(function () {
                                (i = t(e).width()), o.updateVars();
                            }, o.options.responsiveRefreshRate)));
                    }),
                    t(e).resize(o.resizer);
            },
            updatePosition: function () {
                var t = this;
                t.jumpTo(t.currentItem), !1 !== t.options.autoPlay && t.checkAp();
            },
            appendItemsSizes: function () {
                var e = this,
                    n = 0,
                    i = e.itemsAmount - e.options.items;
                e.$owlItems.each(function (o) {
                    var r = t(this);
                    r.css({ width: e.itemWidth }).data("owl-item", Number(o)), (o % e.options.items != 0 && o !== i) || o > i || (n += 1), r.data("owl-roundPages", n);
                });
            },
            appendWrapperSizes: function () {
                var t = this,
                    e = t.$owlItems.length * t.itemWidth;
                t.$owlWrapper.css({ width: 2 * e, left: 0 }), t.appendItemsSizes();
            },
            calculateAll: function () {
                var t = this;
                t.calculateWidth(), t.appendWrapperSizes(), t.loops(), t.max();
            },
            calculateWidth: function () {
                var t = this;
                t.itemWidth = Math.round(t.$elem.width() / t.options.items);
            },
            max: function () {
                var t = this,
                    e = -1 * (t.itemsAmount * t.itemWidth - t.options.items * t.itemWidth);
                return t.options.items > t.itemsAmount ? ((t.maximumItem = 0), (e = 0), (t.maximumPixels = 0)) : ((t.maximumItem = t.itemsAmount - t.options.items), (t.maximumPixels = e)), e;
            },
            min: function () {
                return 0;
            },
            loops: function () {
                var e,
                    n,
                    i = this,
                    o = 0,
                    r = 0;
                for (i.positionsInArray = [0], i.pagesInArray = [], e = 0; e < i.itemsAmount; e += 1)
                    (r += i.itemWidth), i.positionsInArray.push(-r), !0 === i.options.scrollPerPage && (n = t(i.$owlItems[e]).data("owl-roundPages")) !== o && ((i.pagesInArray[o] = i.positionsInArray[e]), (o = n));
            },
            buildControls: function () {
                var e = this;
                (!0 !== e.options.navigation && !0 !== e.options.pagination) || (e.owlControls = t('<div class="owl-controls"/>').toggleClass("clickable", !e.browser.isTouch).appendTo(e.$elem)),
                    !0 === e.options.pagination && e.buildPagination(),
                    !0 === e.options.navigation && e.buildButtons();
            },
            buildButtons: function () {
                var e = this,
                    n = t('<div class="owl-buttons"/>');
                e.owlControls.append(n),
                    (e.buttonPrev = t("<div/>", { class: "owl-prev", html: e.options.navigationText[0] || "" })),
                    (e.buttonNext = t("<div/>", { class: "owl-next", html: e.options.navigationText[1] || "" })),
                    n.append(e.buttonPrev).append(e.buttonNext),
                    n.on("touchstart.owlControls mousedown.owlControls", 'div[class^="owl"]', function (t) {
                        t.preventDefault();
                    }),
                    n.on("touchend.owlControls mouseup.owlControls", 'div[class^="owl"]', function (n) {
                        n.preventDefault(), t(this).hasClass("owl-next") ? e.next() : e.prev();
                    });
            },
            buildPagination: function () {
                var e = this;
                (e.paginationWrapper = t('<div class="owl-pagination"/>')),
                    e.owlControls.append(e.paginationWrapper),
                    e.paginationWrapper.on("touchend.owlControls mouseup.owlControls", ".owl-page", function (n) {
                        n.preventDefault(), Number(t(this).data("owl-page")) !== e.currentItem && e.goTo(Number(t(this).data("owl-page")), !0);
                    });
            },
            updatePagination: function () {
                var e,
                    n,
                    i,
                    o,
                    r,
                    s,
                    a = this;
                if (!1 === a.options.pagination) return !1;
                for (a.paginationWrapper.html(""), e = 0, n = a.itemsAmount - (a.itemsAmount % a.options.items), o = 0; o < a.itemsAmount; o += 1)
                    o % a.options.items == 0 &&
                        ((e += 1),
                        n === o && (i = a.itemsAmount - a.options.items),
                        (r = t("<div/>", { class: "owl-page" })),
                        (s = t("<span></span>", { text: !0 === a.options.paginationNumbers ? e : "", class: !0 === a.options.paginationNumbers ? "owl-numbers" : "" })),
                        r.append(s),
                        r.data("owl-page", n === o ? i : o),
                        r.data("owl-roundPages", e),
                        a.paginationWrapper.append(r));
                a.checkPagination();
            },
            checkPagination: function () {
                var e = this;
                if (!1 === e.options.pagination) return !1;
                e.paginationWrapper.find(".owl-page").each(function () {
                    t(this).data("owl-roundPages") === t(e.$owlItems[e.currentItem]).data("owl-roundPages") && (e.paginationWrapper.find(".owl-page").removeClass("active"), t(this).addClass("active"));
                });
            },
            checkNavigation: function () {
                var t = this;
                if (!1 === t.options.navigation) return !1;
                !1 === t.options.rewindNav &&
                    (0 === t.currentItem && 0 === t.maximumItem
                        ? (t.buttonPrev.addClass("disabled"), t.buttonNext.addClass("disabled"))
                        : 0 === t.currentItem && 0 !== t.maximumItem
                        ? (t.buttonPrev.addClass("disabled"), t.buttonNext.removeClass("disabled"))
                        : t.currentItem === t.maximumItem
                        ? (t.buttonPrev.removeClass("disabled"), t.buttonNext.addClass("disabled"))
                        : 0 !== t.currentItem && t.currentItem !== t.maximumItem && (t.buttonPrev.removeClass("disabled"), t.buttonNext.removeClass("disabled")));
            },
            updateControls: function () {
                var t = this;
                t.updatePagination(), t.checkNavigation(), t.owlControls && (t.options.items >= t.itemsAmount ? t.owlControls.hide() : t.owlControls.show());
            },
            destroyControls: function () {
                this.owlControls && this.owlControls.remove();
            },
            next: function (t) {
                var e = this;
                if (e.isTransition) return !1;
                if (((e.currentItem += !0 === e.options.scrollPerPage ? e.options.items : 1), e.currentItem > e.maximumItem + (!0 === e.options.scrollPerPage ? e.options.items - 1 : 0))) {
                    if (!0 !== e.options.rewindNav) return (e.currentItem = e.maximumItem), !1;
                    (e.currentItem = 0), (t = "rewind");
                }
                e.goTo(e.currentItem, t);
            },
            prev: function (t) {
                var e = this;
                if (e.isTransition) return !1;
                if ((!0 === e.options.scrollPerPage && e.currentItem > 0 && e.currentItem < e.options.items ? (e.currentItem = 0) : (e.currentItem -= !0 === e.options.scrollPerPage ? e.options.items : 1), e.currentItem < 0)) {
                    if (!0 !== e.options.rewindNav) return (e.currentItem = 0), !1;
                    (e.currentItem = e.maximumItem), (t = "rewind");
                }
                e.goTo(e.currentItem, t);
            },
            goTo: function (t, n, i) {
                var o,
                    r = this;
                return (
                    !r.isTransition &&
                    ("function" == typeof r.options.beforeMove && r.options.beforeMove.apply(this, [r.$elem]),
                    t >= r.maximumItem ? (t = r.maximumItem) : t <= 0 && (t = 0),
                    (r.currentItem = r.owl.currentItem = t),
                    !1 !== r.options.transitionStyle && "drag" !== i && 1 === r.options.items && !0 === r.browser.support3d
                        ? (r.swapSpeed(0), !0 === r.browser.support3d ? r.transition3d(r.positionsInArray[t]) : r.css2slide(r.positionsInArray[t], 1), r.afterGo(), r.singleItemTransition(), !1)
                        : ((o = r.positionsInArray[t]),
                          !0 === r.browser.support3d
                              ? ((r.isCss3Finish = !1),
                                !0 === n
                                    ? (r.swapSpeed("paginationSpeed"),
                                      e.setTimeout(function () {
                                          r.isCss3Finish = !0;
                                      }, r.options.paginationSpeed))
                                    : "rewind" === n
                                    ? (r.swapSpeed(r.options.rewindSpeed),
                                      e.setTimeout(function () {
                                          r.isCss3Finish = !0;
                                      }, r.options.rewindSpeed))
                                    : (r.swapSpeed("slideSpeed"),
                                      e.setTimeout(function () {
                                          r.isCss3Finish = !0;
                                      }, r.options.slideSpeed)),
                                r.transition3d(o))
                              : !0 === n
                              ? r.css2slide(o, r.options.paginationSpeed)
                              : "rewind" === n
                              ? r.css2slide(o, r.options.rewindSpeed)
                              : r.css2slide(o, r.options.slideSpeed),
                          void r.afterGo()))
                );
            },
            jumpTo: function (t) {
                var e = this;
                "function" == typeof e.options.beforeMove && e.options.beforeMove.apply(this, [e.$elem]),
                    t >= e.maximumItem || -1 === t ? (t = e.maximumItem) : t <= 0 && (t = 0),
                    e.swapSpeed(0),
                    !0 === e.browser.support3d ? e.transition3d(e.positionsInArray[t]) : e.css2slide(e.positionsInArray[t], 1),
                    (e.currentItem = e.owl.currentItem = t),
                    e.afterGo();
            },
            afterGo: function () {
                var t = this;
                t.prevArr.push(t.currentItem),
                    (t.prevItem = t.owl.prevItem = t.prevArr[t.prevArr.length - 2]),
                    t.prevArr.shift(0),
                    t.prevItem !== t.currentItem && (t.checkPagination(), t.checkNavigation(), t.eachMoveUpdate(), !1 !== t.options.autoPlay && t.checkAp()),
                    "function" == typeof t.options.afterMove && t.prevItem !== t.currentItem && t.options.afterMove.apply(this, [t.$elem]);
            },
            stop: function () {
                (this.apStatus = "stop"), e.clearInterval(this.autoPlayInterval);
            },
            checkAp: function () {
                "stop" !== this.apStatus && this.play();
            },
            play: function () {
                var t = this;
                if (((t.apStatus = "play"), !1 === t.options.autoPlay)) return !1;
                e.clearInterval(t.autoPlayInterval),
                    (t.autoPlayInterval = e.setInterval(function () {
                        t.next(!0);
                    }, t.options.autoPlay));
            },
            swapSpeed: function (t) {
                var e = this;
                "slideSpeed" === t
                    ? e.$owlWrapper.css(e.addCssSpeed(e.options.slideSpeed))
                    : "paginationSpeed" === t
                    ? e.$owlWrapper.css(e.addCssSpeed(e.options.paginationSpeed))
                    : "string" != typeof t && e.$owlWrapper.css(e.addCssSpeed(t));
            },
            addCssSpeed: function (t) {
                return { "-webkit-transition": "all " + t + "ms ease", "-moz-transition": "all " + t + "ms ease", "-o-transition": "all " + t + "ms ease", transition: "all " + t + "ms ease" };
            },
            removeTransition: function () {
                return { "-webkit-transition": "", "-moz-transition": "", "-o-transition": "", transition: "" };
            },
            doTranslate: function (t) {
                return {
                    "-webkit-transform": "translate3d(" + t + "px, 0px, 0px)",
                    "-moz-transform": "translate3d(" + t + "px, 0px, 0px)",
                    "-o-transform": "translate3d(" + t + "px, 0px, 0px)",
                    "-ms-transform": "translate3d(" + t + "px, 0px, 0px)",
                    transform: "translate3d(" + t + "px, 0px,0px)",
                };
            },
            transition3d: function (t) {
                this.$owlWrapper.css(this.doTranslate(t));
            },
            css2move: function (t) {
                this.$owlWrapper.css({ left: t });
            },
            css2slide: function (t, e) {
                var n = this;
                (n.isCssFinish = !1),
                    n.$owlWrapper.stop(!0, !0).animate(
                        { left: t },
                        {
                            duration: e || n.options.slideSpeed,
                            complete: function () {
                                n.isCssFinish = !0;
                            },
                        }
                    );
            },
            checkBrowser: function () {
                var t,
                    i,
                    o,
                    r,
                    s = "translate3d(0px, 0px, 0px)",
                    a = n.createElement("div");
                (a.style.cssText = "  -moz-transform:" + s + "; -ms-transform:" + s + "; -o-transform:" + s + "; -webkit-transform:" + s + "; transform:" + s),
                    (t = /translate3d\(0px, 0px, 0px\)/g),
                    (o = null !== (i = a.style.cssText.match(t)) && 1 === i.length),
                    (r = "ontouchstart" in e || e.navigator.msMaxTouchPoints),
                    (this.browser = { support3d: o, isTouch: r });
            },
            moveEvents: function () {
                var t = this;
                (!1 === t.options.mouseDrag && !1 === t.options.touchDrag) || (t.gestures(), t.disabledEvents());
            },
            eventTypes: function () {
                var t = this,
                    e = ["s", "e", "x"];
                (t.ev_types = {}),
                    !0 === t.options.mouseDrag && !0 === t.options.touchDrag
                        ? (e = ["touchstart.owl mousedown.owl", "touchmove.owl mousemove.owl", "touchend.owl touchcancel.owl mouseup.owl"])
                        : !1 === t.options.mouseDrag && !0 === t.options.touchDrag
                        ? (e = ["touchstart.owl", "touchmove.owl", "touchend.owl touchcancel.owl"])
                        : !0 === t.options.mouseDrag && !1 === t.options.touchDrag && (e = ["mousedown.owl", "mousemove.owl", "mouseup.owl"]),
                    (t.ev_types.start = e[0]),
                    (t.ev_types.move = e[1]),
                    (t.ev_types.end = e[2]);
            },
            disabledEvents: function () {
                this.$elem.on("dragstart.owl", function (t) {
                    t.preventDefault();
                }),
                    this.$elem.on("mousedown.disableTextSelect", function (e) {
                        return t(e.target).is("input, textarea, select, option");
                    });
            },
            gestures: function () {
                function i(t) {
                    if (void 0 !== t.touches) return { x: t.touches[0].pageX, y: t.touches[0].pageY };
                    if (void 0 === t.touches) {
                        if (void 0 !== t.pageX) return { x: t.pageX, y: t.pageY };
                        if (void 0 === t.pageX) return { x: t.clientX, y: t.clientY };
                    }
                }
                function o(e) {
                    "on" === e ? (t(n).on(a.ev_types.move, r), t(n).on(a.ev_types.end, s)) : "off" === e && (t(n).off(a.ev_types.move), t(n).off(a.ev_types.end));
                }
                function r(o) {
                    var r,
                        s,
                        u = o.originalEvent || o || e.event;
                    (a.newPosX = i(u).x - l.offsetX),
                        (a.newPosY = i(u).y - l.offsetY),
                        (a.newRelativeX = a.newPosX - l.relativePos),
                        "function" == typeof a.options.startDragging && !0 !== l.dragging && 0 !== a.newRelativeX && ((l.dragging = !0), a.options.startDragging.apply(a, [a.$elem])),
                        (a.newRelativeX > 8 || a.newRelativeX < -8) && !0 === a.browser.isTouch && (void 0 !== u.preventDefault ? u.preventDefault() : (u.returnValue = !1), (l.sliding = !0)),
                        (a.newPosY > 10 || a.newPosY < -10) && !1 === l.sliding && t(n).off("touchmove.owl"),
                        (r = function () {
                            return a.newRelativeX / 5;
                        }),
                        (s = function () {
                            return a.maximumPixels + a.newRelativeX / 5;
                        }),
                        (a.newPosX = Math.max(Math.min(a.newPosX, r()), s())),
                        !0 === a.browser.support3d ? a.transition3d(a.newPosX) : a.css2move(a.newPosX);
                }
                function s(n) {
                    var i,
                        r,
                        s,
                        u = n.originalEvent || n || e.event;
                    (u.target = u.target || u.srcElement),
                        (l.dragging = !1),
                        !0 !== a.browser.isTouch && a.$owlWrapper.removeClass("grabbing"),
                        a.newRelativeX < 0 ? (a.dragDirection = a.owl.dragDirection = "left") : (a.dragDirection = a.owl.dragDirection = "right"),
                        0 !== a.newRelativeX &&
                            ((i = a.getNewPosition()),
                            a.goTo(i, !1, "drag"),
                            l.targetElement === u.target &&
                                !0 !== a.browser.isTouch &&
                                (t(u.target).on("click.disable", function (e) {
                                    e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault(), t(e.target).off("click.disable");
                                }),
                                (s = (r = t._data(u.target, "events").click).pop()),
                                r.splice(0, 0, s))),
                        o("off");
                }
                var a = this,
                    l = { offsetX: 0, offsetY: 0, baseElWidth: 0, relativePos: 0, position: null, minSwipe: null, maxSwipe: null, sliding: null, dargging: null, targetElement: null };
                (a.isCssFinish = !0),
                    a.$elem.on(a.ev_types.start, ".owl-wrapper", function (n) {
                        var r,
                            s = n.originalEvent || n || e.event;
                        if (3 === s.which) return !1;
                        if (!(a.itemsAmount <= a.options.items)) {
                            if (!1 === a.isCssFinish && !a.options.dragBeforeAnimFinish) return !1;
                            if (!1 === a.isCss3Finish && !a.options.dragBeforeAnimFinish) return !1;
                            !1 !== a.options.autoPlay && e.clearInterval(a.autoPlayInterval),
                                !0 === a.browser.isTouch || a.$owlWrapper.hasClass("grabbing") || a.$owlWrapper.addClass("grabbing"),
                                (a.newPosX = 0),
                                (a.newRelativeX = 0),
                                t(this).css(a.removeTransition()),
                                (r = t(this).position()),
                                (l.relativePos = r.left),
                                (l.offsetX = i(s).x - r.left),
                                (l.offsetY = i(s).y - r.top),
                                o("on"),
                                (l.sliding = !1),
                                (l.targetElement = s.target || s.srcElement);
                        }
                    });
            },
            getNewPosition: function () {
                var t = this,
                    e = t.closestItem();
                return e > t.maximumItem ? ((t.currentItem = t.maximumItem), (e = t.maximumItem)) : t.newPosX >= 0 && ((e = 0), (t.currentItem = 0)), e;
            },
            closestItem: function () {
                var e = this,
                    n = !0 === e.options.scrollPerPage ? e.pagesInArray : e.positionsInArray,
                    i = e.newPosX,
                    o = null;
                return (
                    t.each(n, function (r, s) {
                        i - e.itemWidth / 20 > n[r + 1] && i - e.itemWidth / 20 < s && "left" === e.moveDirection()
                            ? ((o = s), !0 === e.options.scrollPerPage ? (e.currentItem = t.inArray(o, e.positionsInArray)) : (e.currentItem = r))
                            : i + e.itemWidth / 20 < s &&
                              i + e.itemWidth / 20 > (n[r + 1] || n[r] - e.itemWidth) &&
                              "right" === e.moveDirection() &&
                              (!0 === e.options.scrollPerPage ? ((o = n[r + 1] || n[n.length - 1]), (e.currentItem = t.inArray(o, e.positionsInArray))) : ((o = n[r + 1]), (e.currentItem = r + 1)));
                    }),
                    e.currentItem
                );
            },
            moveDirection: function () {
                var t,
                    e = this;
                return e.newRelativeX < 0 ? ((t = "right"), (e.playDirection = "next")) : ((t = "left"), (e.playDirection = "prev")), t;
            },
            customEvents: function () {
                var t = this;
                t.$elem.on("owl.next", function () {
                    t.next();
                }),
                    t.$elem.on("owl.prev", function () {
                        t.prev();
                    }),
                    t.$elem.on("owl.play", function (e, n) {
                        (t.options.autoPlay = n), t.play(), (t.hoverStatus = "play");
                    }),
                    t.$elem.on("owl.stop", function () {
                        t.stop(), (t.hoverStatus = "stop");
                    }),
                    t.$elem.on("owl.goTo", function (e, n) {
                        t.goTo(n);
                    }),
                    t.$elem.on("owl.jumpTo", function (e, n) {
                        t.jumpTo(n);
                    });
            },
            stopOnHover: function () {
                var t = this;
                !0 === t.options.stopOnHover &&
                    !0 !== t.browser.isTouch &&
                    !1 !== t.options.autoPlay &&
                    (t.$elem.on("mouseover", function () {
                        t.stop();
                    }),
                    t.$elem.on("mouseout", function () {
                        "stop" !== t.hoverStatus && t.play();
                    }));
            },
            lazyLoad: function () {
                var e,
                    n,
                    i,
                    o,
                    r = this;
                if (!1 === r.options.lazyLoad) return !1;
                for (e = 0; e < r.itemsAmount; e += 1)
                    "loaded" !== (n = t(r.$owlItems[e])).data("owl-loaded") &&
                        ((i = n.data("owl-item")),
                        "string" == typeof (o = n.find(".lazyOwl")).data("src")
                            ? (void 0 === n.data("owl-loaded") && (o.hide(), n.addClass("loading").data("owl-loaded", "checked")),
                              (!0 !== r.options.lazyFollow || i >= r.currentItem) && i < r.currentItem + r.options.items && o.length && r.lazyPreload(n, o))
                            : n.data("owl-loaded", "loaded"));
            },
            lazyPreload: function (t, n) {
                function i() {
                    t.data("owl-loaded", "loaded").removeClass("loading"),
                        n.removeAttr("data-src"),
                        "fade" === r.options.lazyEffect ? n.fadeIn(400) : n.show(),
                        "function" == typeof r.options.afterLazyLoad && r.options.afterLazyLoad.apply(this, [r.$elem]);
                }
                var o,
                    r = this,
                    s = 0;
                "DIV" === n.prop("tagName") ? (n.css("background-image", "url(" + n.data("src") + ")"), (o = !0)) : (n[0].src = n.data("src")),
                    (function t() {
                        (s += 1), r.completeImg(n.get(0)) || !0 === o ? i() : s <= 100 ? e.setTimeout(t, 100) : i();
                    })();
            },
            autoHeight: function () {
                function n() {
                    var n = t(o.$owlItems[o.currentItem]).height();
                    o.wrapperOuter.css("height", n + "px"),
                        o.wrapperOuter.hasClass("autoHeight") ||
                            e.setTimeout(function () {
                                o.wrapperOuter.addClass("autoHeight");
                            }, 0);
                }
                var i,
                    o = this,
                    r = t(o.$owlItems[o.currentItem]).find("img");
                void 0 !== r.get(0)
                    ? ((i = 0),
                      (function t() {
                          (i += 1), o.completeImg(r.get(0)) ? n() : i <= 100 ? e.setTimeout(t, 100) : o.wrapperOuter.css("height", "");
                      })())
                    : n();
            },
            completeImg: function (t) {
                return !!t.complete && (void 0 === t.naturalWidth || 0 !== t.naturalWidth);
            },
            onVisibleItems: function () {
                var e,
                    n = this;
                for (!0 === n.options.addClassActive && n.$owlItems.removeClass("active"), n.visibleItems = [], e = n.currentItem; e < n.currentItem + n.options.items; e += 1)
                    n.visibleItems.push(e), !0 === n.options.addClassActive && t(n.$owlItems[e]).addClass("active");
                n.owl.visibleItems = n.visibleItems;
            },
            transitionTypes: function (t) {
                (this.outClass = "owl-" + t + "-out"), (this.inClass = "owl-" + t + "-in");
            },
            singleItemTransition: function () {
                var t = this,
                    e = t.outClass,
                    n = t.inClass,
                    i = t.$owlItems.eq(t.currentItem),
                    o = t.$owlItems.eq(t.prevItem),
                    r = Math.abs(t.positionsInArray[t.currentItem]) + t.positionsInArray[t.prevItem],
                    s = Math.abs(t.positionsInArray[t.currentItem]) + t.itemWidth / 2,
                    a = "webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend";
                (t.isTransition = !0),
                    t.$owlWrapper.addClass("owl-origin").css({ "-webkit-transform-origin": s + "px", "-moz-perspective-origin": s + "px", "perspective-origin": s + "px" }),
                    o
                        .css(
                            (function (t) {
                                return { position: "relative", left: t + "px" };
                            })(r)
                        )
                        .addClass(e)
                        .on(a, function () {
                            (t.endPrev = !0), o.off(a), t.clearTransStyle(o, e);
                        }),
                    i.addClass(n).on(a, function () {
                        (t.endCurrent = !0), i.off(a), t.clearTransStyle(i, n);
                    });
            },
            clearTransStyle: function (t, e) {
                var n = this;
                t.css({ position: "", left: "" }).removeClass(e), n.endPrev && n.endCurrent && (n.$owlWrapper.removeClass("owl-origin"), (n.endPrev = !1), (n.endCurrent = !1), (n.isTransition = !1));
            },
            owlStatus: function () {
                var t = this;
                t.owl = {
                    userOptions: t.userOptions,
                    baseElement: t.$elem,
                    userItems: t.$userItems,
                    owlItems: t.$owlItems,
                    currentItem: t.currentItem,
                    prevItem: t.prevItem,
                    visibleItems: t.visibleItems,
                    isTouch: t.browser.isTouch,
                    browser: t.browser,
                    dragDirection: t.dragDirection,
                };
            },
            clearEvents: function () {
                this.$elem.off(".owl owl mousedown.disableTextSelect"), t(n).off(".owl owl"), t(e).off("resize", this.resizer);
            },
            unWrap: function () {
                var t = this;
                0 !== t.$elem.children().length && (t.$owlWrapper.unwrap(), t.$userItems.unwrap().unwrap(), t.owlControls && t.owlControls.remove()),
                    t.clearEvents(),
                    t.$elem.attr("style", t.$elem.data("owl-originalStyles") || "").attr("class", t.$elem.data("owl-originalClasses"));
            },
            destroy: function () {
                var t = this;
                t.stop(), e.clearInterval(t.checkVisible), t.unWrap(), t.$elem.removeData();
            },
            reinit: function (e) {
                var n = this,
                    i = t.extend({}, n.userOptions, e);
                n.unWrap(), n.init(i, n.$elem);
            },
            addItem: function (t, e) {
                var n,
                    i = this;
                return (
                    !!t &&
                    (0 === i.$elem.children().length
                        ? (i.$elem.append(t), i.setVars(), !1)
                        : (i.unWrap(), (n = void 0 === e || -1 === e ? -1 : e) >= i.$userItems.length || -1 === n ? i.$userItems.eq(-1).after(t) : i.$userItems.eq(n).before(t), void i.setVars()))
                );
            },
            removeItem: function (t) {
                var e,
                    n = this;
                if (0 === n.$elem.children().length) return !1;
                (e = void 0 === t || -1 === t ? -1 : t), n.unWrap(), n.$userItems.eq(e).remove(), n.setVars();
            },
        };
        (t.fn.owlCarousel = function (e) {
            return this.each(function () {
                if (!0 === t(this).data("owl-init")) return !1;
                t(this).data("owl-init", !0);
                var n = Object.create(i);
                n.init(e, this), t.data(this, "owlCarousel", n);
            });
        }),
            (t.fn.owlCarousel.options = {
                items: 5,
                itemsCustom: !1,
                itemsDesktop: [1199, 4],
                itemsDesktopSmall: [979, 3],
                itemsTablet: [768, 2],
                itemsTabletSmall: !1,
                itemsMobile: [479, 1],
                singleItem: !1,
                itemsScaleUp: !1,
                slideSpeed: 200,
                paginationSpeed: 800,
                rewindSpeed: 1e3,
                autoPlay: !1,
                stopOnHover: !1,
                navigation: !1,
                navigationText: ["prev", "next"],
                rewindNav: !0,
                scrollPerPage: !1,
                pagination: !0,
                paginationNumbers: !1,
                responsive: !0,
                responsiveRefreshRate: 200,
                responsiveBaseWidth: e,
                baseClass: "owl-carousel",
                theme: "owl-theme",
                lazyLoad: !1,
                lazyFollow: !0,
                lazyEffect: "fade",
                autoHeight: !1,
                jsonPath: !1,
                jsonSuccess: !1,
                dragBeforeAnimFinish: !0,
                mouseDrag: !0,
                touchDrag: !0,
                addClassActive: !1,
                transitionStyle: !1,
                beforeUpdate: !1,
                afterUpdate: !1,
                beforeInit: !1,
                afterInit: !1,
                beforeMove: !1,
                afterMove: !1,
                afterAction: !1,
                startDragging: !1,
                afterLazyLoad: !1,
            });
    })(jQuery, window, document),
    /*!
     * Spin.js
     * Copyright (c) 2011-2014 Felix Gnass
     * Licensed under the MIT license
     */
    (function (t, e) {
        "object" == typeof exports ? (module.exports = e()) : "function" == typeof define && define.amd ? define(e) : (t.Spinner = e());
    })(this, function () {
        function t(t, e) {
            var n,
                i = document.createElement(t || "div");
            for (n in e) i[n] = e[n];
            return i;
        }
        function e(t) {
            for (var e = 1, n = arguments.length; e < n; e++) t.appendChild(arguments[e]);
            return t;
        }
        function n(t, e, n, i) {
            var o = ["opacity", e, ~~(100 * t), n, i].join("-"),
                r = 0.01 + (n / i) * 100,
                s = Math.max(1 - ((1 - t) / e) * (100 - r), t),
                a = l.substring(0, l.indexOf("Animation")).toLowerCase(),
                u = (a && "-" + a + "-") || "";
            return (
                c[o] ||
                    (d.insertRule("@" + u + "keyframes " + o + "{0%{opacity:" + s + "}" + r + "%{opacity:" + t + "}" + (r + 0.01) + "%{opacity:1}" + ((r + e) % 100) + "%{opacity:" + t + "}100%{opacity:" + s + "}}", d.cssRules.length),
                    (c[o] = 1)),
                o
            );
        }
        function i(t, e) {
            var n,
                i,
                o = t.style;
            for (e = e.charAt(0).toUpperCase() + e.slice(1), i = 0; i < u.length; i++) if (void 0 !== o[(n = u[i] + e)]) return n;
            if (void 0 !== o[e]) return e;
        }
        function o(t, e) {
            for (var n in e) t.style[i(t, n) || n] = e[n];
            return t;
        }
        function r(t) {
            for (var e = 1; e < arguments.length; e++) {
                var n = arguments[e];
                for (var i in n) void 0 === t[i] && (t[i] = n[i]);
            }
            return t;
        }
        function s(t, e) {
            return "string" == typeof t ? t : t[e % t.length];
        }
        function a(t) {
            this.opts = r(t || {}, a.defaults, p);
        }
        var l,
            u = ["webkit", "Moz", "ms", "O"],
            c = {},
            d = (function () {
                var n = t("style", { type: "text/css" });
                return e(document.getElementsByTagName("head")[0], n), n.sheet || n.styleSheet;
            })(),
            p = {
                lines: 12,
                length: 7,
                width: 5,
                radius: 10,
                rotate: 0,
                corners: 1,
                color: "#000",
                direction: 1,
                speed: 1,
                trail: 100,
                opacity: 0.25,
                fps: 20,
                zIndex: 2e9,
                className: "spinner",
                top: "50%",
                left: "50%",
                position: "absolute",
            };
        (a.defaults = {}),
            r(a.prototype, {
                spin: function (e) {
                    this.stop();
                    var n = this,
                        i = n.opts,
                        r = (n.el = o(t(0, { className: i.className }), { position: i.position, width: 0, zIndex: i.zIndex }));
                    if ((i.radius, i.length, i.width, o(r, { left: i.left, top: i.top }), e && e.insertBefore(r, e.firstChild || null), r.setAttribute("role", "progressbar"), n.lines(r, n.opts), !l)) {
                        var s,
                            a = 0,
                            u = ((i.lines - 1) * (1 - i.direction)) / 2,
                            c = i.fps,
                            d = c / i.speed,
                            p = (1 - i.opacity) / ((d * i.trail) / 100),
                            h = d / i.lines;
                        !(function t() {
                            a++;
                            for (var e = 0; e < i.lines; e++) (s = Math.max(1 - ((a + (i.lines - e) * h) % d) * p, i.opacity)), n.opacity(r, e * i.direction + u, s, i);
                            n.timeout = n.el && setTimeout(t, ~~(1e3 / c));
                        })();
                    }
                    return n;
                },
                stop: function () {
                    var t = this.el;
                    return t && (clearTimeout(this.timeout), t.parentNode && t.parentNode.removeChild(t), (this.el = void 0)), this;
                },
                lines: function (i, r) {
                    function a(e, n) {
                        return o(t(), {
                            position: "absolute",
                            width: r.length + r.width + "px",
                            height: r.width + "px",
                            background: e,
                            boxShadow: n,
                            transformOrigin: "left",
                            transform: "rotate(" + ~~((360 / r.lines) * c + r.rotate) + "deg) translate(" + r.radius + "px,0)",
                            borderRadius: ((r.corners * r.width) >> 1) + "px",
                        });
                    }
                    for (var u, c = 0, d = ((r.lines - 1) * (1 - r.direction)) / 2; c < r.lines; c++)
                        (u = o(t(), {
                            position: "absolute",
                            top: 1 + ~(r.width / 2) + "px",
                            transform: r.hwaccel ? "translate3d(0,0,0)" : "",
                            opacity: r.opacity,
                            animation: l && n(r.opacity, r.trail, d + c * r.direction, r.lines) + " " + 1 / r.speed + "s linear infinite",
                        })),
                            r.shadow && e(u, o(a("#000", "0 0 4px #000"), { top: "2px" })),
                            e(i, e(u, a(s(r.color, c), "0 0 1px rgba(0,0,0,.1)")));
                    return i;
                },
                opacity: function (t, e, n) {
                    e < t.childNodes.length && (t.childNodes[e].style.opacity = n);
                },
            });
        var h = o(t("group"), { behavior: "url(#default#VML)" });
        return (
            !i(h, "transform") && h.adj
                ? (function () {
                      function n(e, n) {
                          return t("<" + e + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', n);
                      }
                      d.addRule(".spin-vml", "behavior:url(#default#VML)"),
                          (a.prototype.lines = function (t, i) {
                              function r() {
                                  return o(n("group", { coordsize: c + " " + c, coordorigin: -u + " " + -u }), { width: c, height: c });
                              }
                              function a(t, a, l) {
                                  e(
                                      p,
                                      e(
                                          o(r(), { rotation: (360 / i.lines) * t + "deg", left: ~~a }),
                                          e(
                                              o(n("roundrect", { arcsize: i.corners }), { width: u, height: i.width, left: i.radius, top: -i.width >> 1, filter: l }),
                                              n("fill", { color: s(i.color, t), opacity: i.opacity }),
                                              n("stroke", { opacity: 0 })
                                          )
                                      )
                                  );
                              }
                              var l,
                                  u = i.length + i.width,
                                  c = 2 * u,
                                  d = 2 * -(i.width + i.length) + "px",
                                  p = o(r(), { position: "absolute", top: d, left: d });
                              if (i.shadow) for (l = 1; l <= i.lines; l++) a(l, -2, "progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)");
                              for (l = 1; l <= i.lines; l++) a(l);
                              return e(t, p);
                          }),
                          (a.prototype.opacity = function (t, e, n, i) {
                              var o = t.firstChild;
                              (i = (i.shadow && i.lines) || 0), o && e + i < o.childNodes.length && (o = (o = (o = o.childNodes[e + i]) && o.firstChild) && o.firstChild) && (o.opacity = n);
                          });
                  })()
                : (l = i(h, "animation")),
            a
        );
    }),
    (function (t) {
        if ("object" == typeof exports) t(require("jquery"), require("spin"));
        else if ("function" == typeof define && define.amd) define(["jquery", "spin"], t);
        else {
            if (!window.Spinner) throw new Error("Spin.js not present");
            t(window.jQuery, window.Spinner);
        }
    })(function (t, e) {
        (t.fn.spin = function (n, i) {
            return this.each(function () {
                var o = t(this),
                    r = o.data();
                r.spinner && (r.spinner.stop(), delete r.spinner), !1 !== n && ((n = t.extend({ color: i || o.css("color") }, t.fn.spin.presets[n] || n)), (r.spinner = new e(n).spin(this)));
            });
        }),
            (t.fn.spin.presets = { tiny: { lines: 8, length: 2, width: 2, radius: 3 }, small: { lines: 8, length: 4, width: 3, radius: 5 }, large: { lines: 10, length: 8, width: 4, radius: 8 } });
    }),
    (function (t) {
        function e(t) {
            var e = t.length,
                i = n.type(t);
            return "function" !== i && !n.isWindow(t) && (!(1 !== t.nodeType || !e) || "array" === i || 0 === e || ("number" == typeof e && e > 0 && e - 1 in t));
        }
        if (!t.jQuery) {
            var n = function (t, e) {
                return new n.fn.init(t, e);
            };
            (n.isWindow = function (t) {
                return null != t && t == t.window;
            }),
                (n.type = function (t) {
                    return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? o[s.call(t)] || "object" : typeof t;
                }),
                (n.isArray =
                    Array.isArray ||
                    function (t) {
                        return "array" === n.type(t);
                    }),
                (n.isPlainObject = function (t) {
                    var e;
                    if (!t || "object" !== n.type(t) || t.nodeType || n.isWindow(t)) return !1;
                    try {
                        if (t.constructor && !r.call(t, "constructor") && !r.call(t.constructor.prototype, "isPrototypeOf")) return !1;
                    } catch (t) {
                        return !1;
                    }
                    for (e in t);
                    return void 0 === e || r.call(t, e);
                }),
                (n.each = function (t, n, i) {
                    var o = 0,
                        r = t.length,
                        s = e(t);
                    if (i) {
                        if (s) for (; o < r && !1 !== n.apply(t[o], i); o++);
                        else for (o in t) if (!1 === n.apply(t[o], i)) break;
                    } else if (s) for (; o < r && !1 !== n.call(t[o], o, t[o]); o++);
                    else for (o in t) if (!1 === n.call(t[o], o, t[o])) break;
                    return t;
                }),
                (n.data = function (t, e, o) {
                    if (void 0 === o) {
                        var r = (s = t[n.expando]) && i[s];
                        if (void 0 === e) return r;
                        if (r && e in r) return r[e];
                    } else if (void 0 !== e) {
                        var s = t[n.expando] || (t[n.expando] = ++n.uuid);
                        return (i[s] = i[s] || {}), (i[s][e] = o), o;
                    }
                }),
                (n.removeData = function (t, e) {
                    var o = t[n.expando],
                        r = o && i[o];
                    r &&
                        n.each(e, function (t, e) {
                            delete r[e];
                        });
                }),
                (n.extend = function () {
                    var t,
                        e,
                        i,
                        o,
                        r,
                        s,
                        a = arguments[0] || {},
                        l = 1,
                        u = arguments.length,
                        c = !1;
                    for ("boolean" == typeof a && ((c = a), (a = arguments[l] || {}), l++), "object" != typeof a && "function" !== n.type(a) && (a = {}), l === u && ((a = this), l--); l < u; l++)
                        if (null != (r = arguments[l]))
                            for (o in r)
                                (t = a[o]),
                                    a !== (i = r[o]) &&
                                        (c && i && (n.isPlainObject(i) || (e = n.isArray(i)))
                                            ? (e ? ((e = !1), (s = t && n.isArray(t) ? t : [])) : (s = t && n.isPlainObject(t) ? t : {}), (a[o] = n.extend(c, s, i)))
                                            : void 0 !== i && (a[o] = i));
                    return a;
                }),
                (n.queue = function (t, i, o) {
                    if (t) {
                        i = (i || "fx") + "queue";
                        var r = n.data(t, i);
                        return o
                            ? (!r || n.isArray(o)
                                  ? (r = n.data(
                                        t,
                                        i,
                                        (function (t, n) {
                                            var i = [];
                                            return (
                                                null != t &&
                                                    (e(Object(t))
                                                        ? (function (t, e) {
                                                              for (var n = +e.length, i = 0, o = t.length; i < n; ) t[o++] = e[i++];
                                                              if (n != n) for (; void 0 !== e[i]; ) t[o++] = e[i++];
                                                              t.length = o;
                                                          })(i, "string" == typeof t ? [t] : t)
                                                        : [].push.call(i, t)),
                                                i
                                            );
                                        })(o)
                                    ))
                                  : r.push(o),
                              r)
                            : r || [];
                    }
                }),
                (n.dequeue = function (t, e) {
                    n.each(t.nodeType ? [t] : t, function (t, i) {
                        e = e || "fx";
                        var o = n.queue(i, e),
                            r = o.shift();
                        "inprogress" === r && (r = o.shift()),
                            r &&
                                ("fx" === e && o.unshift("inprogress"),
                                r.call(i, function () {
                                    n.dequeue(i, e);
                                }));
                    });
                }),
                (n.fn = n.prototype = {
                    init: function (t) {
                        if (t.nodeType) return (this[0] = t), this;
                        throw new Error("Not a DOM node.");
                    },
                    offset: function () {
                        var e = this[0].getBoundingClientRect ? this[0].getBoundingClientRect() : { top: 0, left: 0 };
                        return { top: e.top + (t.pageYOffset || document.scrollTop || 0) - (document.clientTop || 0), left: e.left + (t.pageXOffset || document.scrollLeft || 0) - (document.clientLeft || 0) };
                    },
                    position: function () {
                        function t() {
                            for (var t = this.offsetParent || document; t && "html" === !t.nodeType.toLowerCase && "static" === t.style.position; ) t = t.offsetParent;
                            return t || document;
                        }
                        var e = this[0],
                            t = t.apply(e),
                            i = this.offset(),
                            o = /^(?:body|html)$/i.test(t.nodeName) ? { top: 0, left: 0 } : n(t).offset();
                        return (
                            (i.top -= parseFloat(e.style.marginTop) || 0),
                            (i.left -= parseFloat(e.style.marginLeft) || 0),
                            t.style && ((o.top += parseFloat(t.style.borderTopWidth) || 0), (o.left += parseFloat(t.style.borderLeftWidth) || 0)),
                            { top: i.top - o.top, left: i.left - o.left }
                        );
                    },
                });
            var i = {};
            (n.expando = "velocity" + new Date().getTime()), (n.uuid = 0);
            for (var o = {}, r = o.hasOwnProperty, s = o.toString, a = "Boolean Number String Function Array Date RegExp Object Error".split(" "), l = 0; l < a.length; l++) o["[object " + a[l] + "]"] = a[l].toLowerCase();
            (n.fn.init.prototype = n.fn), (t.Velocity = { Utilities: n });
        }
    })(window),
    (function (t) {
        "object" == typeof module && "object" == typeof module.exports ? (module.exports = t()) : "function" == typeof define && define.amd ? define(t) : t();
    })(function () {
        return (function (t, e, n, i) {
            function o(t) {
                return f.isWrapped(t) ? (t = [].slice.call(t)) : f.isNode(t) && (t = [t]), t;
            }
            function r(t) {
                var e = d.data(t, "velocity");
                return null === e ? i : e;
            }
            function s(t) {
                return function (e) {
                    return Math.round(e * t) * (1 / t);
                };
            }
            function a(t, n, i, o) {
                function r(t, e) {
                    return 1 - 3 * e + 3 * t;
                }
                function s(t, e) {
                    return 3 * e - 6 * t;
                }
                function a(t) {
                    return 3 * t;
                }
                function l(t, e, n) {
                    return ((r(e, n) * t + s(e, n)) * t + a(e)) * t;
                }
                function u(t, e, n) {
                    return 3 * r(e, n) * t * t + 2 * s(e, n) * t + a(e);
                }
                function c(e, n) {
                    for (var o = 0; o < h; ++o) {
                        var r = u(n, t, i);
                        if (0 === r) return n;
                        n -= (l(n, t, i) - e) / r;
                    }
                    return n;
                }
                function d(e, n, o) {
                    var r,
                        s,
                        a = 0;
                    do {
                        (r = l((s = n + (o - n) / 2), t, i) - e) > 0 ? (o = s) : (n = s);
                    } while (Math.abs(r) > m && ++a < g);
                    return s;
                }
                function p() {
                    (_ = !0),
                        (t == n && i == o) ||
                            (function () {
                                for (var e = 0; e < v; ++e) x[e] = l(e * y, t, i);
                            })();
                }
                var h = 4,
                    f = 0.001,
                    m = 1e-7,
                    g = 10,
                    v = 11,
                    y = 1 / (v - 1),
                    w = "Float32Array" in e;
                if (4 !== arguments.length) return !1;
                for (var b = 0; b < 4; ++b) if ("number" != typeof arguments[b] || isNaN(arguments[b]) || !isFinite(arguments[b])) return !1;
                (t = Math.min(t, 1)), (i = Math.min(i, 1)), (t = Math.max(t, 0)), (i = Math.max(i, 0));
                var x = w ? new Float32Array(v) : new Array(v),
                    _ = !1,
                    C = function (e) {
                        return (
                            _ || p(),
                            t === n && i === o
                                ? e
                                : 0 === e
                                ? 0
                                : 1 === e
                                ? 1
                                : l(
                                      (function (e) {
                                          for (var n = 0, o = 1, r = v - 1; o != r && x[o] <= e; ++o) n += y;
                                          --o;
                                          var s = n + ((e - x[o]) / (x[o + 1] - x[o])) * y,
                                              a = u(s, t, i);
                                          return a >= f ? c(e, s) : 0 == a ? s : d(e, n, n + y);
                                      })(e),
                                      n,
                                      o
                                  )
                        );
                    };
                C.getControlPoints = function () {
                    return [
                        { x: t, y: n },
                        { x: i, y: o },
                    ];
                };
                var k = "generateBezier(" + [t, n, i, o] + ")";
                return (
                    (C.toString = function () {
                        return k;
                    }),
                    C
                );
            }
            function l(t, e) {
                var n = t;
                return (
                    f.isString(t) ? v.Easings[t] || (n = !1) : (n = f.isArray(t) && 1 === t.length ? s.apply(null, t) : f.isArray(t) && 2 === t.length ? y.apply(null, t.concat([e])) : !(!f.isArray(t) || 4 !== t.length) && a.apply(null, t)),
                    !1 === n && (n = v.Easings[v.defaults.easing] ? v.defaults.easing : g),
                    n
                );
            }
            function u(t) {
                if (t)
                    for (var e = new Date().getTime(), n = 0, o = v.State.calls.length; n < o; n++)
                        if (v.State.calls[n]) {
                            var s = v.State.calls[n],
                                a = s[0],
                                l = s[2],
                                p = s[3],
                                h = !!p;
                            p || (p = v.State.calls[n][3] = e - 16);
                            for (var m = Math.min((e - p) / l.duration, 1), g = 0, y = a.length; g < y; g++) {
                                var b = a[g],
                                    _ = b.element;
                                if (r(_)) {
                                    var C = !1;
                                    if (l.display !== i && null !== l.display && "none" !== l.display) {
                                        if ("flex" === l.display) {
                                            d.each(["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex"], function (t, e) {
                                                w.setPropertyValue(_, "display", e);
                                            });
                                        }
                                        w.setPropertyValue(_, "display", l.display);
                                    }
                                    for (var k in (l.visibility !== i && "hidden" !== l.visibility && w.setPropertyValue(_, "visibility", l.visibility), b))
                                        if ("element" !== k) {
                                            var T,
                                                S = b[k],
                                                E = f.isString(S.easing) ? v.Easings[S.easing] : S.easing;
                                            if (1 === m) T = S.endValue;
                                            else if (((T = S.startValue + (S.endValue - S.startValue) * E(m)), !h && T === S.currentValue)) continue;
                                            if (((S.currentValue = T), w.Hooks.registered[k])) {
                                                var I = w.Hooks.getRoot(k),
                                                    P = r(_).rootPropertyValueCache[I];
                                                P && (S.rootPropertyValue = P);
                                            }
                                            var L = w.setPropertyValue(_, k, S.currentValue + (0 === parseFloat(T) ? "" : S.unitType), S.rootPropertyValue, S.scrollData);
                                            w.Hooks.registered[k] && (w.Normalizations.registered[I] ? (r(_).rootPropertyValueCache[I] = w.Normalizations.registered[I]("extract", null, L[1])) : (r(_).rootPropertyValueCache[I] = L[1])),
                                                "transform" === L[0] && (C = !0);
                                        }
                                    l.mobileHA && r(_).transformCache.translate3d === i && ((r(_).transformCache.translate3d = "(0px, 0px, 0px)"), (C = !0)), C && w.flushTransformCache(_);
                                }
                            }
                            l.display !== i && "none" !== l.display && (v.State.calls[n][2].display = !1),
                                l.visibility !== i && "hidden" !== l.visibility && (v.State.calls[n][2].visibility = !1),
                                l.progress && l.progress.call(s[1], s[1], m, Math.max(0, p + l.duration - e), p),
                                1 === m && c(n);
                        }
                v.State.isTicking && x(u);
            }
            function c(t, e) {
                if (!v.State.calls[t]) return !1;
                for (var n = v.State.calls[t][0], o = v.State.calls[t][1], s = v.State.calls[t][2], a = v.State.calls[t][4], l = !1, u = 0, c = n.length; u < c; u++) {
                    var p = n[u].element;
                    if (
                        (e || s.loop || ("none" === s.display && w.setPropertyValue(p, "display", s.display), "hidden" === s.visibility && w.setPropertyValue(p, "visibility", s.visibility)),
                        !0 !== s.loop && (d.queue(p)[1] === i || !/\.velocityQueueEntryFlag/i.test(d.queue(p)[1])) && r(p))
                    ) {
                        (r(p).isAnimating = !1), (r(p).rootPropertyValueCache = {});
                        var h = !1;
                        d.each(w.Lists.transforms3D, function (t, e) {
                            var n = /^scale/.test(e) ? 1 : 0,
                                o = r(p).transformCache[e];
                            r(p).transformCache[e] !== i && new RegExp("^\\(" + n + "[^.]").test(o) && ((h = !0), delete r(p).transformCache[e]);
                        }),
                            s.mobileHA && ((h = !0), delete r(p).transformCache.translate3d),
                            h && w.flushTransformCache(p),
                            w.Values.removeClass(p, "velocity-animating");
                    }
                    if (!e && s.complete && !s.loop && u === c - 1)
                        try {
                            s.complete.call(o, o);
                        } catch (t) {
                            setTimeout(function () {
                                throw t;
                            }, 1);
                        }
                    a && !0 !== s.loop && a(o),
                        !0 !== s.loop ||
                            e ||
                            (d.each(r(p).tweensContainer, function (t, e) {
                                /^rotate/.test(t) && 360 === parseFloat(e.endValue) && ((e.endValue = 0), (e.startValue = 360));
                            }),
                            v(p, "reverse", { loop: !0, delay: s.delay })),
                        !1 !== s.queue && d.dequeue(p, s.queue);
                }
                v.State.calls[t] = !1;
                for (var f = 0, m = v.State.calls.length; f < m; f++)
                    if (!1 !== v.State.calls[f]) {
                        l = !0;
                        break;
                    }
                !1 === l && ((v.State.isTicking = !1), delete v.State.calls, (v.State.calls = []));
            }
            var d,
                p = (function () {
                    if (n.documentMode) return n.documentMode;
                    for (var t = 7; t > 4; t--) {
                        var e = n.createElement("div");
                        if (((e.innerHTML = "\x3c!--[if IE " + t + "]><span></span><![endif]--\x3e"), e.getElementsByTagName("span").length)) return (e = null), t;
                    }
                    return i;
                })(),
                h = (function () {
                    var t = 0;
                    return (
                        e.webkitRequestAnimationFrame ||
                        e.mozRequestAnimationFrame ||
                        function (e) {
                            var n,
                                i = new Date().getTime();
                            return (
                                (n = Math.max(0, 16 - (i - t))),
                                (t = i + n),
                                setTimeout(function () {
                                    e(i + n);
                                }, n)
                            );
                        }
                    );
                })(),
                f = {
                    isString: function (t) {
                        return "string" == typeof t;
                    },
                    isArray:
                        Array.isArray ||
                        function (t) {
                            return "[object Array]" === Object.prototype.toString.call(t);
                        },
                    isFunction: function (t) {
                        return "[object Function]" === Object.prototype.toString.call(t);
                    },
                    isNode: function (t) {
                        return t && t.nodeType;
                    },
                    isNodeList: function (t) {
                        return "object" == typeof t && /^\[object (HTMLCollection|NodeList|Object)\]$/.test(Object.prototype.toString.call(t)) && t.length !== i && (0 === t.length || ("object" == typeof t[0] && t[0].nodeType > 0));
                    },
                    isWrapped: function (t) {
                        return t && (t.jquery || (e.Zepto && e.Zepto.zepto.isZ(t)));
                    },
                    isSVG: function (t) {
                        return e.SVGElement && t instanceof e.SVGElement;
                    },
                    isEmptyObject: function (t) {
                        for (var e in t) return !1;
                        return !0;
                    },
                },
                m = !1;
            if ((t.fn && t.fn.jquery ? ((d = t), (m = !0)) : (d = e.Velocity.Utilities), p <= 8 && !m)) throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");
            if (!(p <= 7)) {
                var g = "swing",
                    v = {
                        State: {
                            isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
                            isAndroid: /Android/i.test(navigator.userAgent),
                            isGingerbread: /Android 2\.3\.[3-7]/i.test(navigator.userAgent),
                            isChrome: e.chrome,
                            isFirefox: /Firefox/i.test(navigator.userAgent),
                            prefixElement: n.createElement("div"),
                            prefixMatches: {},
                            scrollAnchor: null,
                            scrollPropertyLeft: null,
                            scrollPropertyTop: null,
                            isTicking: !1,
                            calls: [],
                        },
                        CSS: {},
                        Utilities: d,
                        Redirects: {},
                        Easings: {},
                        Promise: e.Promise,
                        defaults: { queue: "", duration: 400, easing: g, begin: i, complete: i, progress: i, display: i, visibility: i, loop: !1, delay: !1, mobileHA: !0, _cacheValues: !0 },
                        init: function (t) {
                            d.data(t, "velocity", { isSVG: f.isSVG(t), isAnimating: !1, computedStyle: null, tweensContainer: null, rootPropertyValueCache: {}, transformCache: {} });
                        },
                        hook: null,
                        mock: !1,
                        version: { major: 1, minor: 1, patch: 0 },
                        debug: !1,
                    };
                e.pageYOffset !== i
                    ? ((v.State.scrollAnchor = e), (v.State.scrollPropertyLeft = "pageXOffset"), (v.State.scrollPropertyTop = "pageYOffset"))
                    : ((v.State.scrollAnchor = n.documentElement || n.body.parentNode || n.body), (v.State.scrollPropertyLeft = "scrollLeft"), (v.State.scrollPropertyTop = "scrollTop"));
                var y = (function () {
                    function t(t) {
                        return -t.tension * t.x - t.friction * t.v;
                    }
                    function e(e, n, i) {
                        var o = { x: e.x + i.dx * n, v: e.v + i.dv * n, tension: e.tension, friction: e.friction };
                        return { dx: o.v, dv: t(o) };
                    }
                    function n(n, i) {
                        var o = { dx: n.v, dv: t(n) },
                            r = e(n, 0.5 * i, o),
                            s = e(n, 0.5 * i, r),
                            a = e(n, i, s),
                            l = (1 / 6) * (o.dx + 2 * (r.dx + s.dx) + a.dx),
                            u = (1 / 6) * (o.dv + 2 * (r.dv + s.dv) + a.dv);
                        return (n.x = n.x + l * i), (n.v = n.v + u * i), n;
                    }
                    return function t(e, i, o) {
                        var r,
                            s,
                            a,
                            l = { x: -1, v: 0, tension: null, friction: null },
                            u = [0],
                            c = 0;
                        for (
                            e = parseFloat(e) || 500, i = parseFloat(i) || 20, o = o || null, l.tension = e, l.friction = i, (r = null !== o) ? (s = ((c = t(e, i)) / o) * 0.016) : (s = 0.016);
                            (a = n(a || l, s)), u.push(1 + a.x), (c += 16), Math.abs(a.x) > 1e-4 && Math.abs(a.v) > 1e-4;

                        );
                        return r
                            ? function (t) {
                                  return u[(t * (u.length - 1)) | 0];
                              }
                            : c;
                    };
                })();
                (v.Easings = {
                    linear: function (t) {
                        return t;
                    },
                    swing: function (t) {
                        return 0.5 - Math.cos(t * Math.PI) / 2;
                    },
                    spring: function (t) {
                        return 1 - Math.cos(4.5 * t * Math.PI) * Math.exp(6 * -t);
                    },
                }),
                    d.each(
                        [
                            ["ease", [0.25, 0.1, 0.25, 1]],
                            ["ease-in", [0.42, 0, 1, 1]],
                            ["ease-out", [0, 0, 0.58, 1]],
                            ["ease-in-out", [0.42, 0, 0.58, 1]],
                            ["easeInSine", [0.47, 0, 0.745, 0.715]],
                            ["easeOutSine", [0.39, 0.575, 0.565, 1]],
                            ["easeInOutSine", [0.445, 0.05, 0.55, 0.95]],
                            ["easeInQuad", [0.55, 0.085, 0.68, 0.53]],
                            ["easeOutQuad", [0.25, 0.46, 0.45, 0.94]],
                            ["easeInOutQuad", [0.455, 0.03, 0.515, 0.955]],
                            ["easeInCubic", [0.55, 0.055, 0.675, 0.19]],
                            ["easeOutCubic", [0.215, 0.61, 0.355, 1]],
                            ["easeInOutCubic", [0.645, 0.045, 0.355, 1]],
                            ["easeInQuart", [0.895, 0.03, 0.685, 0.22]],
                            ["easeOutQuart", [0.165, 0.84, 0.44, 1]],
                            ["easeInOutQuart", [0.77, 0, 0.175, 1]],
                            ["easeInQuint", [0.755, 0.05, 0.855, 0.06]],
                            ["easeOutQuint", [0.23, 1, 0.32, 1]],
                            ["easeInOutQuint", [0.86, 0, 0.07, 1]],
                            ["easeInExpo", [0.95, 0.05, 0.795, 0.035]],
                            ["easeOutExpo", [0.19, 1, 0.22, 1]],
                            ["easeInOutExpo", [1, 0, 0, 1]],
                            ["easeInCirc", [0.6, 0.04, 0.98, 0.335]],
                            ["easeOutCirc", [0.075, 0.82, 0.165, 1]],
                            ["easeInOutCirc", [0.785, 0.135, 0.15, 0.86]],
                        ],
                        function (t, e) {
                            v.Easings[e[0]] = a.apply(null, e[1]);
                        }
                    );
                var w = (v.CSS = {
                    RegEx: { isHex: /^#([A-f\d]{3}){1,2}$/i, valueUnwrap: /^[A-z]+\((.*)\)$/i, wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/, valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/gi },
                    Lists: {
                        colors: ["fill", "stroke", "stopColor", "color", "backgroundColor", "borderColor", "borderTopColor", "borderRightColor", "borderBottomColor", "borderLeftColor", "outlineColor"],
                        transformsBase: ["translateX", "translateY", "scale", "scaleX", "scaleY", "skewX", "skewY", "rotateZ"],
                        transforms3D: ["transformPerspective", "translateZ", "scaleZ", "rotateX", "rotateY"],
                    },
                    Hooks: {
                        templates: {
                            textShadow: ["Color X Y Blur", "black 0px 0px 0px"],
                            boxShadow: ["Color X Y Blur Spread", "black 0px 0px 0px 0px"],
                            clip: ["Top Right Bottom Left", "0px 0px 0px 0px"],
                            backgroundPosition: ["X Y", "0% 0%"],
                            transformOrigin: ["X Y Z", "50% 50% 0px"],
                            perspectiveOrigin: ["X Y", "50% 50%"],
                        },
                        registered: {},
                        register: function () {
                            for (var t = 0; t < w.Lists.colors.length; t++) {
                                var e = "color" === w.Lists.colors[t] ? "0 0 0 1" : "255 255 255 1";
                                w.Hooks.templates[w.Lists.colors[t]] = ["Red Green Blue Alpha", e];
                            }
                            var n, i, o;
                            if (p)
                                for (n in w.Hooks.templates) {
                                    o = (i = w.Hooks.templates[n])[0].split(" ");
                                    var r = i[1].match(w.RegEx.valueSplit);
                                    "Color" === o[0] && (o.push(o.shift()), r.push(r.shift()), (w.Hooks.templates[n] = [o.join(" "), r.join(" ")]));
                                }
                            for (n in w.Hooks.templates)
                                for (var t in (o = (i = w.Hooks.templates[n])[0].split(" "))) {
                                    var s = n + o[t],
                                        a = t;
                                    w.Hooks.registered[s] = [n, a];
                                }
                        },
                        getRoot: function (t) {
                            var e = w.Hooks.registered[t];
                            return e ? e[0] : t;
                        },
                        cleanRootPropertyValue: function (t, e) {
                            return w.RegEx.valueUnwrap.test(e) && (e = e.match(w.RegEx.valueUnwrap)[1]), w.Values.isCSSNullValue(e) && (e = w.Hooks.templates[t][1]), e;
                        },
                        extractValue: function (t, e) {
                            var n = w.Hooks.registered[t];
                            if (n) {
                                var i = n[0],
                                    o = n[1];
                                return (e = w.Hooks.cleanRootPropertyValue(i, e)).toString().match(w.RegEx.valueSplit)[o];
                            }
                            return e;
                        },
                        injectValue: function (t, e, n) {
                            var i = w.Hooks.registered[t];
                            if (i) {
                                var o,
                                    r = i[0],
                                    s = i[1];
                                return ((o = (n = w.Hooks.cleanRootPropertyValue(r, n)).toString().match(w.RegEx.valueSplit))[s] = e), o.join(" ");
                            }
                            return n;
                        },
                    },
                    Normalizations: {
                        registered: {
                            clip: function (t, e, n) {
                                switch (t) {
                                    case "name":
                                        return "clip";
                                    case "extract":
                                        var i;
                                        return w.RegEx.wrappedValueAlreadyExtracted.test(n) ? (i = n) : (i = (i = n.toString().match(w.RegEx.valueUnwrap)) ? i[1].replace(/,(\s+)?/g, " ") : n), i;
                                    case "inject":
                                        return "rect(" + n + ")";
                                }
                            },
                            blur: function (t, e, n) {
                                switch (t) {
                                    case "name":
                                        return "-webkit-filter";
                                    case "extract":
                                        var i = parseFloat(n);
                                        if (!i && 0 !== i) {
                                            var o = n.toString().match(/blur\(([0-9]+[A-z]+)\)/i);
                                            i = o ? o[1] : 0;
                                        }
                                        return i;
                                    case "inject":
                                        return parseFloat(n) ? "blur(" + n + ")" : "none";
                                }
                            },
                            opacity: function (t, e, n) {
                                if (p <= 8)
                                    switch (t) {
                                        case "name":
                                            return "filter";
                                        case "extract":
                                            var i = n.toString().match(/alpha\(opacity=(.*)\)/i);
                                            return i ? i[1] / 100 : 1;
                                        case "inject":
                                            return (e.style.zoom = 1), parseFloat(n) >= 1 ? "" : "alpha(opacity=" + parseInt(100 * parseFloat(n), 10) + ")";
                                    }
                                else
                                    switch (t) {
                                        case "name":
                                            return "opacity";
                                        case "extract":
                                        case "inject":
                                            return n;
                                    }
                            },
                        },
                        register: function () {
                            p <= 9 || v.State.isGingerbread || (w.Lists.transformsBase = w.Lists.transformsBase.concat(w.Lists.transforms3D));
                            for (var t = 0; t < w.Lists.transformsBase.length; t++)
                                !(function () {
                                    var e = w.Lists.transformsBase[t];
                                    w.Normalizations.registered[e] = function (t, n, o) {
                                        switch (t) {
                                            case "name":
                                                return "transform";
                                            case "extract":
                                                return r(n) === i || r(n).transformCache[e] === i ? (/^scale/i.test(e) ? 1 : 0) : r(n).transformCache[e].replace(/[()]/g, "");
                                            case "inject":
                                                var s = !1;
                                                switch (e.substr(0, e.length - 1)) {
                                                    case "translate":
                                                        s = !/(%|px|em|rem|vw|vh|\d)$/i.test(o);
                                                        break;
                                                    case "scal":
                                                    case "scale":
                                                        v.State.isAndroid && r(n).transformCache[e] === i && o < 1 && (o = 1), (s = !/(\d)$/i.test(o));
                                                        break;
                                                    case "skew":
                                                    case "rotate":
                                                        s = !/(deg|\d)$/i.test(o);
                                                }
                                                return s || (r(n).transformCache[e] = "(" + o + ")"), r(n).transformCache[e];
                                        }
                                    };
                                })();
                            for (t = 0; t < w.Lists.colors.length; t++)
                                !(function () {
                                    var e = w.Lists.colors[t];
                                    w.Normalizations.registered[e] = function (t, n, o) {
                                        switch (t) {
                                            case "name":
                                                return e;
                                            case "extract":
                                                var r;
                                                if (w.RegEx.wrappedValueAlreadyExtracted.test(o)) r = o;
                                                else {
                                                    var s,
                                                        a = { black: "rgb(0, 0, 0)", blue: "rgb(0, 0, 255)", gray: "rgb(128, 128, 128)", green: "rgb(0, 128, 0)", red: "rgb(255, 0, 0)", white: "rgb(255, 255, 255)" };
                                                    /^[A-z]+$/i.test(o) ? (s = a[o] !== i ? a[o] : a.black) : w.RegEx.isHex.test(o) ? (s = "rgb(" + w.Values.hexToRgb(o).join(" ") + ")") : /^rgba?\(/i.test(o) || (s = a.black),
                                                        (r = (s || o)
                                                            .toString()
                                                            .match(w.RegEx.valueUnwrap)[1]
                                                            .replace(/,(\s+)?/g, " "));
                                                }
                                                return p <= 8 || 3 !== r.split(" ").length || (r += " 1"), r;
                                            case "inject":
                                                return (
                                                    p <= 8 ? 4 === o.split(" ").length && (o = o.split(/\s+/).slice(0, 3).join(" ")) : 3 === o.split(" ").length && (o += " 1"),
                                                    (p <= 8 ? "rgb" : "rgba") + "(" + o.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") + ")"
                                                );
                                        }
                                    };
                                })();
                        },
                    },
                    Names: {
                        camelCase: function (t) {
                            return t.replace(/-(\w)/g, function (t, e) {
                                return e.toUpperCase();
                            });
                        },
                        SVGAttribute: function (t) {
                            var e = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";
                            return (p || (v.State.isAndroid && !v.State.isChrome)) && (e += "|transform"), new RegExp("^(" + e + ")$", "i").test(t);
                        },
                        prefixCheck: function (t) {
                            if (v.State.prefixMatches[t]) return [v.State.prefixMatches[t], !0];
                            for (var e = ["", "Webkit", "Moz", "ms", "O"], n = 0, i = e.length; n < i; n++) {
                                var o;
                                if (
                                    ((o =
                                        0 === n
                                            ? t
                                            : e[n] +
                                              t.replace(/^\w/, function (t) {
                                                  return t.toUpperCase();
                                              })),
                                    f.isString(v.State.prefixElement.style[o]))
                                )
                                    return (v.State.prefixMatches[t] = o), [o, !0];
                            }
                            return [t, !1];
                        },
                    },
                    Values: {
                        hexToRgb: function (t) {
                            var e;
                            return (
                                (t = t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (t, e, n, i) {
                                    return e + e + n + n + i + i;
                                })),
                                (e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t)) ? [parseInt(e[1], 16), parseInt(e[2], 16), parseInt(e[3], 16)] : [0, 0, 0]
                            );
                        },
                        isCSSNullValue: function (t) {
                            return 0 == t || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(t);
                        },
                        getUnitType: function (t) {
                            return /^(rotate|skew)/i.test(t) ? "deg" : /(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(t) ? "" : "px";
                        },
                        getDisplayType: function (t) {
                            var e = t && t.tagName.toString().toLowerCase();
                            return /^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(e)
                                ? "inline"
                                : /^(li)$/i.test(e)
                                ? "list-item"
                                : /^(tr)$/i.test(e)
                                ? "table-row"
                                : "block";
                        },
                        addClass: function (t, e) {
                            t.classList ? t.classList.add(e) : (t.className += (t.className.length ? " " : "") + e);
                        },
                        removeClass: function (t, e) {
                            t.classList ? t.classList.remove(e) : (t.className = t.className.toString().replace(new RegExp("(^|\\s)" + e.split(" ").join("|") + "(\\s|$)", "gi"), " "));
                        },
                    },
                    getPropertyValue: function (t, n, o, s) {
                        function a(t, n) {
                            function o() {
                                c && w.setPropertyValue(t, "display", "none");
                            }
                            var l = 0;
                            if (p <= 8) l = d.css(t, n);
                            else {
                                var u,
                                    c = !1;
                                if ((/^(width|height)$/.test(n) && 0 === w.getPropertyValue(t, "display") && ((c = !0), w.setPropertyValue(t, "display", w.Values.getDisplayType(t))), !s)) {
                                    if ("height" === n && "border-box" !== w.getPropertyValue(t, "boxSizing").toString().toLowerCase()) {
                                        var h =
                                            t.offsetHeight -
                                            (parseFloat(w.getPropertyValue(t, "borderTopWidth")) || 0) -
                                            (parseFloat(w.getPropertyValue(t, "borderBottomWidth")) || 0) -
                                            (parseFloat(w.getPropertyValue(t, "paddingTop")) || 0) -
                                            (parseFloat(w.getPropertyValue(t, "paddingBottom")) || 0);
                                        return o(), h;
                                    }
                                    if ("width" === n && "border-box" !== w.getPropertyValue(t, "boxSizing").toString().toLowerCase()) {
                                        var f =
                                            t.offsetWidth -
                                            (parseFloat(w.getPropertyValue(t, "borderLeftWidth")) || 0) -
                                            (parseFloat(w.getPropertyValue(t, "borderRightWidth")) || 0) -
                                            (parseFloat(w.getPropertyValue(t, "paddingLeft")) || 0) -
                                            (parseFloat(w.getPropertyValue(t, "paddingRight")) || 0);
                                        return o(), f;
                                    }
                                }
                                (u = r(t) === i ? e.getComputedStyle(t, null) : r(t).computedStyle ? r(t).computedStyle : (r(t).computedStyle = e.getComputedStyle(t, null))),
                                    (p || v.State.isFirefox) && "borderColor" === n && (n = "borderTopColor"),
                                    ("" !== (l = 9 === p && "filter" === n ? u.getPropertyValue(n) : u[n]) && null !== l) || (l = t.style[n]),
                                    o();
                            }
                            if ("auto" === l && /^(top|right|bottom|left)$/i.test(n)) {
                                var m = a(t, "position");
                                ("fixed" === m || ("absolute" === m && /top|left/i.test(n))) && (l = d(t).position()[n] + "px");
                            }
                            return l;
                        }
                        var l;
                        if (w.Hooks.registered[n]) {
                            var u = n,
                                c = w.Hooks.getRoot(u);
                            o === i && (o = w.getPropertyValue(t, w.Names.prefixCheck(c)[0])), w.Normalizations.registered[c] && (o = w.Normalizations.registered[c]("extract", t, o)), (l = w.Hooks.extractValue(u, o));
                        } else if (w.Normalizations.registered[n]) {
                            var h, f;
                            "transform" !== (h = w.Normalizations.registered[n]("name", t)) && ((f = a(t, w.Names.prefixCheck(h)[0])), w.Values.isCSSNullValue(f) && w.Hooks.templates[n] && (f = w.Hooks.templates[n][1])),
                                (l = w.Normalizations.registered[n]("extract", t, f));
                        }
                        return (
                            /^[\d-]/.test(l) || (l = r(t) && r(t).isSVG && w.Names.SVGAttribute(n) ? (/^(height|width)$/i.test(n) ? t.getBBox()[n] : t.getAttribute(n)) : a(t, w.Names.prefixCheck(n)[0])),
                            w.Values.isCSSNullValue(l) && (l = 0),
                            v.debug >= 2 && console.log("Get " + n + ": " + l),
                            l
                        );
                    },
                    setPropertyValue: function (t, n, i, o, s) {
                        var a = n;
                        if ("scroll" === n) s.container ? (s.container["scroll" + s.direction] = i) : "Left" === s.direction ? e.scrollTo(i, s.alternateValue) : e.scrollTo(s.alternateValue, i);
                        else if (w.Normalizations.registered[n] && "transform" === w.Normalizations.registered[n]("name", t)) w.Normalizations.registered[n]("inject", t, i), (a = "transform"), (i = r(t).transformCache[n]);
                        else {
                            if (w.Hooks.registered[n]) {
                                var l = n,
                                    u = w.Hooks.getRoot(n);
                                (o = o || w.getPropertyValue(t, u)), (i = w.Hooks.injectValue(l, i, o)), (n = u);
                            }
                            if ((w.Normalizations.registered[n] && ((i = w.Normalizations.registered[n]("inject", t, i)), (n = w.Normalizations.registered[n]("name", t))), (a = w.Names.prefixCheck(n)[0]), p <= 8))
                                try {
                                    t.style[a] = i;
                                } catch (t) {
                                    v.debug && console.log("Browser does not support [" + i + "] for [" + a + "]");
                                }
                            else r(t) && r(t).isSVG && w.Names.SVGAttribute(n) ? t.setAttribute(n, i) : (t.style[a] = i);
                            v.debug >= 2 && console.log("Set " + n + " (" + a + "): " + i);
                        }
                        return [a, i];
                    },
                    flushTransformCache: function (t) {
                        function e(e) {
                            return parseFloat(w.getPropertyValue(t, e));
                        }
                        var n = "";
                        if ((p || (v.State.isAndroid && !v.State.isChrome)) && r(t).isSVG) {
                            var i = { translate: [e("translateX"), e("translateY")], skewX: [e("skewX")], skewY: [e("skewY")], scale: 1 !== e("scale") ? [e("scale"), e("scale")] : [e("scaleX"), e("scaleY")], rotate: [e("rotateZ"), 0, 0] };
                            d.each(r(t).transformCache, function (t) {
                                /^translate/i.test(t) ? (t = "translate") : /^scale/i.test(t) ? (t = "scale") : /^rotate/i.test(t) && (t = "rotate"), i[t] && ((n += t + "(" + i[t].join(" ") + ") "), delete i[t]);
                            });
                        } else {
                            var o, s;
                            d.each(r(t).transformCache, function (e) {
                                if (((o = r(t).transformCache[e]), "transformPerspective" === e)) return (s = o), !0;
                                9 === p && "rotateZ" === e && (e = "rotate"), (n += e + o + " ");
                            }),
                                s && (n = "perspective" + s + " " + n);
                        }
                        w.setPropertyValue(t, "transform", n);
                    },
                });
                w.Hooks.register(),
                    w.Normalizations.register(),
                    (v.hook = function (t, e, n) {
                        var s = i;
                        return (
                            (t = o(t)),
                            d.each(t, function (t, o) {
                                if ((r(o) === i && v.init(o), n === i)) s === i && (s = v.CSS.getPropertyValue(o, e));
                                else {
                                    var a = v.CSS.setPropertyValue(o, e, n);
                                    "transform" === a[0] && v.CSS.flushTransformCache(o), (s = a);
                                }
                            }),
                            s
                        );
                    });
                var b = function () {
                    function t() {
                        return a ? S.promise || null : p;
                    }
                    function s() {
                        function t(t) {
                            function p(t, e) {
                                var n = i,
                                    o = i,
                                    r = i;
                                return (
                                    f.isArray(t)
                                        ? ((n = t[0]),
                                          (!f.isArray(t[1]) && /^[\d-]/.test(t[1])) || f.isFunction(t[1]) || w.RegEx.isHex.test(t[1])
                                              ? (r = t[1])
                                              : ((f.isString(t[1]) && !w.RegEx.isHex.test(t[1])) || f.isArray(t[1])) && ((o = e ? t[1] : l(t[1], a.duration)), t[2] !== i && (r = t[2])))
                                        : (n = t),
                                    e || (o = o || a.easing),
                                    f.isFunction(n) && (n = n.call(s, C, _)),
                                    f.isFunction(r) && (r = r.call(s, C, _)),
                                    [n || 0, o, r]
                                );
                            }
                            function h(t, e) {
                                var n, i;
                                return (
                                    (i = (e || "0")
                                        .toString()
                                        .toLowerCase()
                                        .replace(/[%A-z]+$/, function (t) {
                                            return (n = t), "";
                                        })),
                                    n || (n = w.Values.getUnitType(t)),
                                    [i, n]
                                );
                            }
                            if (a.begin && 0 === C)
                                try {
                                    a.begin.call(m, m);
                                } catch (t) {
                                    setTimeout(function () {
                                        throw t;
                                    }, 1);
                                }
                            if ("scroll" === T) {
                                var b,
                                    x,
                                    k,
                                    E = /^x$/i.test(a.axis) ? "Left" : "Top",
                                    I = parseFloat(a.offset) || 0;
                                a.container
                                    ? f.isWrapped(a.container) || f.isNode(a.container)
                                        ? ((a.container = a.container[0] || a.container), (k = (b = a.container["scroll" + E]) + d(s).position()[E.toLowerCase()] + I))
                                        : (a.container = null)
                                    : ((b = v.State.scrollAnchor[v.State["scrollProperty" + E]]), (x = v.State.scrollAnchor[v.State["scrollProperty" + ("Left" === E ? "Top" : "Left")]]), (k = d(s).offset()[E.toLowerCase()] + I)),
                                    (c = {
                                        scroll: { rootPropertyValue: !1, startValue: b, currentValue: b, endValue: k, unitType: "", easing: a.easing, scrollData: { container: a.container, direction: E, alternateValue: x } },
                                        element: s,
                                    }),
                                    v.debug && console.log("tweensContainer (scroll): ", c.scroll, s);
                            } else if ("reverse" === T) {
                                if (!r(s).tweensContainer) return void d.dequeue(s, a.queue);
                                "none" === r(s).opts.display && (r(s).opts.display = "auto"),
                                    "hidden" === r(s).opts.visibility && (r(s).opts.visibility = "visible"),
                                    (r(s).opts.loop = !1),
                                    (r(s).opts.begin = null),
                                    (r(s).opts.complete = null),
                                    y.easing || delete a.easing,
                                    y.duration || delete a.duration,
                                    (a = d.extend({}, r(s).opts, a));
                                var P = d.extend(!0, {}, r(s).tweensContainer);
                                for (var L in P)
                                    if ("element" !== L) {
                                        var A = P[L].startValue;
                                        (P[L].startValue = P[L].currentValue = P[L].endValue),
                                            (P[L].endValue = A),
                                            f.isEmptyObject(y) || (P[L].easing = a.easing),
                                            v.debug && console.log("reverse tweensContainer (" + L + "): " + JSON.stringify(P[L]), s);
                                    }
                                c = P;
                            } else if ("start" === T) {
                                for (var $ in (r(s).tweensContainer && !0 === r(s).isAnimating && (P = r(s).tweensContainer),
                                d.each(g, function (t, e) {
                                    if (RegExp("^" + w.Lists.colors.join("$|^") + "$").test(t)) {
                                        var n = p(e, !0),
                                            o = n[0],
                                            r = n[1],
                                            s = n[2];
                                        if (w.RegEx.isHex.test(o)) {
                                            for (var a = ["Red", "Green", "Blue"], l = w.Values.hexToRgb(o), u = s ? w.Values.hexToRgb(s) : i, c = 0; c < a.length; c++) {
                                                var d = [l[c]];
                                                r && d.push(r), u !== i && d.push(u[c]), (g[t + a[c]] = d);
                                            }
                                            delete g[t];
                                        }
                                    }
                                }),
                                g)) {
                                    var N = p(g[$]),
                                        M = N[0],
                                        H = N[1],
                                        F = N[2];
                                    $ = w.Names.camelCase($);
                                    var D = w.Hooks.getRoot($),
                                        z = !1;
                                    if (r(s).isSVG || !1 !== w.Names.prefixCheck(D)[1] || w.Normalizations.registered[D] !== i) {
                                        ((a.display !== i && null !== a.display && "none" !== a.display) || (a.visibility !== i && "hidden" !== a.visibility)) && /opacity|filter/.test($) && !F && 0 !== M && (F = 0),
                                            a._cacheValues && P && P[$]
                                                ? (F === i && (F = P[$].endValue + P[$].unitType), (z = r(s).rootPropertyValueCache[D]))
                                                : w.Hooks.registered[$]
                                                ? F === i
                                                    ? ((z = w.getPropertyValue(s, D)), (F = w.getPropertyValue(s, $, z)))
                                                    : (z = w.Hooks.templates[D][1])
                                                : F === i && (F = w.getPropertyValue(s, $));
                                        var V,
                                            q,
                                            R,
                                            W = !1;
                                        if (
                                            ((F = (V = h($, F))[0]),
                                            (R = V[1]),
                                            (M = (V = h($, M))[0].replace(/^([+-\/*])=/, function (t, e) {
                                                return (W = e), "";
                                            })),
                                            (q = V[1]),
                                            (F = parseFloat(F) || 0),
                                            (M = parseFloat(M) || 0),
                                            "%" === q && (/^(fontSize|lineHeight)$/.test($) ? ((M /= 100), (q = "em")) : /^scale/.test($) ? ((M /= 100), (q = "")) : /(Red|Green|Blue)$/i.test($) && ((M = (M / 100) * 255), (q = ""))),
                                            /[\/*]/.test(W))
                                        )
                                            q = R;
                                        else if (R !== q && 0 !== F)
                                            if (0 === M) q = R;
                                            else {
                                                o =
                                                    o ||
                                                    (function () {
                                                        var t = { myParent: s.parentNode || n.body, position: w.getPropertyValue(s, "position"), fontSize: w.getPropertyValue(s, "fontSize") },
                                                            i = t.position === O.lastPosition && t.myParent === O.lastParent,
                                                            o = t.fontSize === O.lastFontSize;
                                                        (O.lastParent = t.myParent), (O.lastPosition = t.position), (O.lastFontSize = t.fontSize);
                                                        var a = {};
                                                        if (o && i) (a.emToPx = O.lastEmToPx), (a.percentToPxWidth = O.lastPercentToPxWidth), (a.percentToPxHeight = O.lastPercentToPxHeight);
                                                        else {
                                                            var l = r(s).isSVG ? n.createElementNS("http://www.w3.org/2000/svg", "rect") : n.createElement("div");
                                                            v.init(l),
                                                                t.myParent.appendChild(l),
                                                                d.each(["overflow", "overflowX", "overflowY"], function (t, e) {
                                                                    v.CSS.setPropertyValue(l, e, "hidden");
                                                                }),
                                                                v.CSS.setPropertyValue(l, "position", t.position),
                                                                v.CSS.setPropertyValue(l, "fontSize", t.fontSize),
                                                                v.CSS.setPropertyValue(l, "boxSizing", "content-box"),
                                                                d.each(["minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height"], function (t, e) {
                                                                    v.CSS.setPropertyValue(l, e, "100%");
                                                                }),
                                                                v.CSS.setPropertyValue(l, "paddingLeft", "100em"),
                                                                (a.percentToPxWidth = O.lastPercentToPxWidth = (parseFloat(w.getPropertyValue(l, "width", null, !0)) || 1) / 100),
                                                                (a.percentToPxHeight = O.lastPercentToPxHeight = (parseFloat(w.getPropertyValue(l, "height", null, !0)) || 1) / 100),
                                                                (a.emToPx = O.lastEmToPx = (parseFloat(w.getPropertyValue(l, "paddingLeft")) || 1) / 100),
                                                                t.myParent.removeChild(l);
                                                        }
                                                        return (
                                                            null === O.remToPx && (O.remToPx = parseFloat(w.getPropertyValue(n.body, "fontSize")) || 16),
                                                            null === O.vwToPx && ((O.vwToPx = parseFloat(e.innerWidth) / 100), (O.vhToPx = parseFloat(e.innerHeight) / 100)),
                                                            (a.remToPx = O.remToPx),
                                                            (a.vwToPx = O.vwToPx),
                                                            (a.vhToPx = O.vhToPx),
                                                            v.debug >= 1 && console.log("Unit ratios: " + JSON.stringify(a), s),
                                                            a
                                                        );
                                                    })();
                                                var B = /margin|padding|left|right|width|text|word|letter/i.test($) || /X$/.test($) || "x" === $ ? "x" : "y";
                                                switch (R) {
                                                    case "%":
                                                        F *= "x" === B ? o.percentToPxWidth : o.percentToPxHeight;
                                                        break;
                                                    case "px":
                                                        break;
                                                    default:
                                                        F *= o[R + "ToPx"];
                                                }
                                                switch (q) {
                                                    case "%":
                                                        F *= 1 / ("x" === B ? o.percentToPxWidth : o.percentToPxHeight);
                                                        break;
                                                    case "px":
                                                        break;
                                                    default:
                                                        F *= 1 / o[q + "ToPx"];
                                                }
                                            }
                                        switch (W) {
                                            case "+":
                                                M = F + M;
                                                break;
                                            case "-":
                                                M = F - M;
                                                break;
                                            case "*":
                                                M *= F;
                                                break;
                                            case "/":
                                                M = F / M;
                                        }
                                        (c[$] = { rootPropertyValue: z, startValue: F, currentValue: F, endValue: M, unitType: q, easing: H }), v.debug && console.log("tweensContainer (" + $ + "): " + JSON.stringify(c[$]), s);
                                    } else v.debug && console.log("Skipping [" + D + "] due to a lack of browser support.");
                                }
                                c.element = s;
                            }
                            c.element &&
                                (w.Values.addClass(s, "velocity-animating"),
                                j.push(c),
                                "" === a.queue && ((r(s).tweensContainer = c), (r(s).opts = a)),
                                (r(s).isAnimating = !0),
                                C === _ - 1
                                    ? (v.State.calls.length > 1e4 &&
                                          (v.State.calls = (function (t) {
                                              for (var e = -1, n = t ? t.length : 0, i = []; ++e < n; ) {
                                                  var o = t[e];
                                                  o && i.push(o);
                                              }
                                              return i;
                                          })(v.State.calls)),
                                      v.State.calls.push([j, m, a, null, S.resolver]),
                                      !1 === v.State.isTicking && ((v.State.isTicking = !0), u()))
                                    : C++);
                        }
                        var o,
                            s = this,
                            a = d.extend({}, v.defaults, y),
                            c = {};
                        switch (
                            (r(s) === i && v.init(s),
                            parseFloat(a.delay) &&
                                !1 !== a.queue &&
                                d.queue(s, a.queue, function (t) {
                                    (v.velocityQueueEntryFlag = !0), (r(s).delayTimer = { setTimeout: setTimeout(t, parseFloat(a.delay)), next: t });
                                }),
                            a.duration.toString().toLowerCase())
                        ) {
                            case "fast":
                                a.duration = 200;
                                break;
                            case "normal":
                                a.duration = 400;
                                break;
                            case "slow":
                                a.duration = 600;
                                break;
                            default:
                                a.duration = parseFloat(a.duration) || 1;
                        }
                        !1 !== v.mock && (!0 === v.mock ? (a.duration = a.delay = 1) : ((a.duration *= parseFloat(v.mock) || 1), (a.delay *= parseFloat(v.mock) || 1))),
                            (a.easing = l(a.easing, a.duration)),
                            a.begin && !f.isFunction(a.begin) && (a.begin = null),
                            a.progress && !f.isFunction(a.progress) && (a.progress = null),
                            a.complete && !f.isFunction(a.complete) && (a.complete = null),
                            a.display !== i && null !== a.display && ((a.display = a.display.toString().toLowerCase()), "auto" === a.display && (a.display = v.CSS.Values.getDisplayType(s))),
                            a.visibility !== i && null !== a.visibility && (a.visibility = a.visibility.toString().toLowerCase()),
                            (a.mobileHA = a.mobileHA && v.State.isMobile && !v.State.isGingerbread),
                            !1 === a.queue
                                ? a.delay
                                    ? setTimeout(t, a.delay)
                                    : t()
                                : d.queue(s, a.queue, function (e, n) {
                                      if (!0 === n) return S.promise && S.resolver(m), !0;
                                      (v.velocityQueueEntryFlag = !0), t(e);
                                  }),
                            ("" !== a.queue && "fx" !== a.queue) || "inprogress" === d.queue(s)[0] || d.dequeue(s);
                    }
                    var a,
                        p,
                        h,
                        m,
                        g,
                        y,
                        x = arguments[0] && ((d.isPlainObject(arguments[0].properties) && !arguments[0].properties.names) || f.isString(arguments[0].properties));
                    if ((f.isWrapped(this) ? ((a = !1), (h = 0), (m = this), (p = this)) : ((a = !0), (h = 1), (m = x ? arguments[0].elements : arguments[0])), (m = o(m)))) {
                        x ? ((g = arguments[0].properties), (y = arguments[0].options)) : ((g = arguments[h]), (y = arguments[h + 1]));
                        var _ = m.length,
                            C = 0;
                        if ("stop" !== g && !d.isPlainObject(y)) {
                            y = {};
                            for (var k = h + 1; k < arguments.length; k++)
                                f.isArray(arguments[k]) || (!/^(fast|normal|slow)$/i.test(arguments[k]) && !/^\d/.test(arguments[k]))
                                    ? f.isString(arguments[k]) || f.isArray(arguments[k])
                                        ? (y.easing = arguments[k])
                                        : f.isFunction(arguments[k]) && (y.complete = arguments[k])
                                    : (y.duration = arguments[k]);
                        }
                        var T,
                            S = { promise: null, resolver: null, rejecter: null };
                        switch (
                            (a &&
                                v.Promise &&
                                (S.promise = new v.Promise(function (t, e) {
                                    (S.resolver = t), (S.rejecter = e);
                                })),
                            g)
                        ) {
                            case "scroll":
                                T = "scroll";
                                break;
                            case "reverse":
                                T = "reverse";
                                break;
                            case "stop":
                                d.each(m, function (t, e) {
                                    r(e) && r(e).delayTimer && (clearTimeout(r(e).delayTimer.setTimeout), r(e).delayTimer.next && r(e).delayTimer.next(), delete r(e).delayTimer);
                                });
                                var E = [];
                                return (
                                    d.each(v.State.calls, function (t, e) {
                                        e &&
                                            d.each(e[1], function (n, o) {
                                                var s = f.isString(y) ? y : "";
                                                if (y !== i && e[2].queue !== s) return !0;
                                                d.each(m, function (e, n) {
                                                    n === o &&
                                                        (y !== i &&
                                                            (d.each(d.queue(n, s), function (t, e) {
                                                                f.isFunction(e) && e(null, !0);
                                                            }),
                                                            d.queue(n, s, [])),
                                                        r(n) &&
                                                            "" === s &&
                                                            d.each(r(n).tweensContainer, function (t, e) {
                                                                e.endValue = e.currentValue;
                                                            }),
                                                        E.push(t));
                                                });
                                            });
                                    }),
                                    d.each(E, function (t, e) {
                                        c(e, !0);
                                    }),
                                    S.promise && S.resolver(m),
                                    t()
                                );
                            default:
                                if (!d.isPlainObject(g) || f.isEmptyObject(g)) {
                                    if (f.isString(g) && v.Redirects[g]) {
                                        var I = ($ = d.extend({}, y)).duration,
                                            P = $.delay || 0;
                                        return (
                                            !0 === $.backwards && (m = d.extend(!0, [], m).reverse()),
                                            d.each(m, function (t, e) {
                                                parseFloat($.stagger) ? ($.delay = P + parseFloat($.stagger) * t) : f.isFunction($.stagger) && ($.delay = P + $.stagger.call(e, t, _)),
                                                    $.drag &&
                                                        (($.duration = parseFloat(I) || (/^(callout|transition)/.test(g) ? 1e3 : 400)), ($.duration = Math.max($.duration * ($.backwards ? 1 - t / _ : (t + 1) / _), 0.75 * $.duration, 200))),
                                                    v.Redirects[g].call(e, e, $ || {}, t, _, m, S.promise ? S : i);
                                            }),
                                            t()
                                        );
                                    }
                                    var L = "Velocity: First argument (" + g + ") was not a property map, a known action, or a registered redirect. Aborting.";
                                    return S.promise ? S.rejecter(new Error(L)) : console.log(L), t();
                                }
                                T = "start";
                        }
                        var A,
                            $,
                            O = { lastParent: null, lastPosition: null, lastFontSize: null, lastPercentToPxWidth: null, lastPercentToPxHeight: null, lastEmToPx: null, remToPx: null, vwToPx: null, vhToPx: null },
                            j = [];
                        if (
                            (d.each(m, function (t, e) {
                                f.isNode(e) && s.call(e);
                            }),
                            (($ = d.extend({}, v.defaults, y)).loop = parseInt($.loop)),
                            (A = 2 * $.loop - 1),
                            $.loop)
                        )
                            for (var N = 0; N < A; N++) {
                                var M = { delay: $.delay, progress: $.progress };
                                N === A - 1 && ((M.display = $.display), (M.visibility = $.visibility), (M.complete = $.complete)), b(m, "reverse", M);
                            }
                        return t();
                    }
                };
                (v = d.extend(b, v)).animate = b;
                var x = e.requestAnimationFrame || h;
                return (
                    v.State.isMobile ||
                        n.hidden === i ||
                        n.addEventListener("visibilitychange", function () {
                            n.hidden
                                ? ((x = function (t) {
                                      return setTimeout(function () {
                                          t(!0);
                                      }, 16);
                                  }),
                                  u())
                                : (x = e.requestAnimationFrame || h);
                        }),
                    (t.Velocity = v),
                    t !== e && ((t.fn.velocity = b), (t.fn.velocity.defaults = v.defaults)),
                    d.each(["Down", "Up"], function (t, e) {
                        v.Redirects["slide" + e] = function (t, n, o, r, s, a) {
                            var l = d.extend({}, n),
                                u = l.begin,
                                c = l.complete,
                                p = { height: "", marginTop: "", marginBottom: "", paddingTop: "", paddingBottom: "" },
                                h = {};
                            l.display === i && (l.display = "Down" === e ? ("inline" === v.CSS.Values.getDisplayType(t) ? "inline-block" : "block") : "none"),
                                (l.begin = function () {
                                    for (var n in (u && u.call(s, s), p)) {
                                        h[n] = t.style[n];
                                        var i = v.CSS.getPropertyValue(t, n);
                                        p[n] = "Down" === e ? [i, 0] : [0, i];
                                    }
                                    (h.overflow = t.style.overflow), (t.style.overflow = "hidden");
                                }),
                                (l.complete = function () {
                                    for (var e in h) t.style[e] = h[e];
                                    c && c.call(s, s), a && a.resolver(s);
                                }),
                                v(t, p, l);
                        };
                    }),
                    d.each(["In", "Out"], function (t, e) {
                        v.Redirects["fade" + e] = function (t, n, o, r, s, a) {
                            var l = d.extend({}, n),
                                u = { opacity: "In" === e ? 1 : 0 },
                                c = l.complete;
                            (l.complete =
                                o !== r - 1
                                    ? (l.begin = null)
                                    : function () {
                                          c && c.call(s, s), a && a.resolver(s);
                                      }),
                                l.display === i && (l.display = "In" === e ? "auto" : "none"),
                                v(this, u, l);
                        };
                    }),
                    v
                );
            }
            jQuery.fn.velocity = jQuery.fn.animate;
        })(window.jQuery || window.Zepto || window, window, document);
    }),
    (function (t) {
        (t.fn.fitVids = function (e) {
            var n = { customSelector: null, ignore: null };
            if (!document.getElementById("fit-vids-style")) {
                var i = document.head || document.getElementsByTagName("head")[0],
                    o = document.createElement("div");
                (o.innerHTML =
                    '<p>x</p><style id="fit-vids-style">.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}</style>'),
                    i.appendChild(o.childNodes[1]);
            }
            return (
                e && t.extend(n, e),
                this.each(function () {
                    var e = ['iframe[src*="player.vimeo.com"]', 'iframe[src*="youtube.com"]', 'iframe[src*="youtube-nocookie.com"]', 'iframe[src*="kickstarter.com"][src*="video.html"]', "object", "embed"];
                    n.customSelector && e.push(n.customSelector);
                    var i = ".fitvidsignore";
                    n.ignore && (i = i + ", " + n.ignore);
                    var o = t(this).find(e.join(","));
                    (o = (o = o.not("object object")).not(i)).each(function () {
                        var e = t(this);
                        if (!(e.parents(i).length > 0 || ("embed" === this.tagName.toLowerCase() && e.parent("object").length) || e.parent(".fluid-width-video-wrapper").length)) {
                            e.css("height") || e.css("width") || (!isNaN(e.attr("height")) && !isNaN(e.attr("width"))) || (e.attr("height", 9), e.attr("width", 16));
                            var n =
                                ("object" === this.tagName.toLowerCase() || (e.attr("height") && !isNaN(parseInt(e.attr("height"), 10))) ? parseInt(e.attr("height"), 10) : e.height()) /
                                (isNaN(parseInt(e.attr("width"), 10)) ? e.width() : parseInt(e.attr("width"), 10));
                            if (!e.attr("name")) {
                                var o = "fitvid" + t.fn.fitVids._count;
                                e.attr("name", o), t.fn.fitVids._count++;
                            }
                            e
                                .wrap('<div class="fluid-width-video-wrapper"></div>')
                                .parent(".fluid-width-video-wrapper")
                                .css("padding-top", 100 * n + "%"),
                                e.removeAttr("height").removeAttr("width");
                        }
                    });
                })
            );
        }),
            (t.fn.fitVids._count = 0);
    })(window.jQuery || window.Zepto),
    (function (t, e) {
        function n(e, r, s, a, l) {
            var u = !1,
                c = function (t) {
                    l && t[t.is("table, thead, tbody, tfoot, tr, col, colgroup, object, embed, param, ol, ul, dl, blockquote, select, optgroup, option, textarea, script, style") ? "after" : "append"](l);
                };
            return (
                e
                    .contents()
                    .detach()
                    .each(function () {
                        var d = this,
                            p = t(d);
                        if (void 0 === d || (3 == d.nodeType && 0 == t.trim(d.data).length)) return !0;
                        if (p.is("script, .dotdotdot-keep")) e.append(p);
                        else {
                            if (u) return !0;
                            e.append(p), c(e), o(s, a) && ((u = 3 == d.nodeType ? i(p, r, s, a, l) : n(p, r, s, a, l)) || (c(t(e.contents().last())), (u = !0))), u || (l && l.detach());
                        }
                    }),
                u
            );
        }
        function i(e, n, i, s, u) {
            var d = e[0];
            if (!d) return !1;
            var p = l(d),
                h = -1 !== p.indexOf(" ") ? " " : "　",
                f = "letter" == s.wrap ? "" : h,
                m = p.split(f),
                g = -1,
                v = -1,
                y = 0,
                w = m.length - 1;
            for (s.fallbackToLetter && 0 == y && 0 == w && ((f = ""), (w = (m = p.split(f)).length - 1)); y <= w && (0 != y || 0 != w); ) {
                var b = Math.floor((y + w) / 2);
                if (b == v) break;
                (v = b), a(d, m.slice(0, v + 1).join(f) + s.ellipsis), o(i, s) ? ((w = v), s.fallbackToLetter && 0 == y && 0 == w && ((f = ""), (g = -1), (v = -1), (y = 0), (w = (m = m[0].split(f)).length - 1))) : ((g = v), (y = v));
            }
            if (-1 == g || (1 == m.length && 0 == m[0].length)) {
                var x = e.parent();
                e.detach();
                var _ = u && u.closest(x).length ? u.length : 0;
                x.contents().length > _ ? (d = c(x.contents().eq(-1 - _), n)) : ((d = c(x, n, !0)), _ || x.detach()), d && (a(d, (p = r(l(d), s))), _ && u && t(d).parent().append(u));
            } else a(d, (p = r(m.slice(0, g + 1).join(f), s)));
            return !0;
        }
        function o(t, e) {
            return t.innerHeight() > e.maxHeight;
        }
        function r(e, n) {
            for (; t.inArray(e.slice(-1), n.lastCharacter.remove) > -1; ) e = e.slice(0, -1);
            return t.inArray(e.slice(-1), n.lastCharacter.noEllipsis) < 0 && (e += n.ellipsis), e;
        }
        function s(t) {
            return { width: t.innerWidth(), height: t.innerHeight() };
        }
        function a(t, e) {
            t.innerText ? (t.innerText = e) : t.nodeValue ? (t.nodeValue = e) : t.textContent && (t.textContent = e);
        }
        function l(t) {
            return t.innerText ? t.innerText : t.nodeValue ? t.nodeValue : t.textContent ? t.textContent : "";
        }
        function u(t) {
            do {
                t = t.previousSibling;
            } while (t && 1 !== t.nodeType && 3 !== t.nodeType);
            return t;
        }
        function c(e, n, i) {
            var o,
                r = e && e[0];
            if (r) {
                if (!i) {
                    if (3 === r.nodeType) return r;
                    if (t.trim(e.text())) return c(e.contents().last(), n);
                }
                for (o = u(r); !o; ) {
                    if ((e = e.parent()).is(n) || !e.length) return !1;
                    o = u(e[0]);
                }
                if (o) return c(t(o), n);
            }
            return !1;
        }
        if (!t.fn.dotdotdot) {
            (t.fn.dotdotdot = function (e) {
                if (0 == this.length) return t.fn.dotdotdot.debug('No element found for "' + this.selector + '".'), this;
                if (this.length > 1)
                    return this.each(function () {
                        t(this).dotdotdot(e);
                    });
                var i = this;
                i.data("dotdotdot") && i.trigger("destroy.dot"),
                    i.data("dotdotdot-style", i.attr("style") || ""),
                    i.css("word-wrap", "break-word"),
                    "nowrap" === i.css("white-space") && i.css("white-space", "normal"),
                    (i.bind_events = function () {
                        return (
                            i
                                .bind("update.dot", function (e, s) {
                                    e.preventDefault(),
                                        e.stopPropagation(),
                                        (a.maxHeight =
                                            "number" == typeof a.height
                                                ? a.height
                                                : (function (t) {
                                                      for (var e = t.innerHeight(), n = ["paddingTop", "paddingBottom"], i = 0, o = n.length; i < o; i++) {
                                                          var r = parseInt(t.css(n[i]), 10);
                                                          isNaN(r) && (r = 0), (e -= r);
                                                      }
                                                      return e;
                                                  })(i)),
                                        (a.maxHeight += a.tolerance),
                                        void 0 !== s && (("string" == typeof s || s instanceof HTMLElement) && (s = t("<div />").append(s).contents()), s instanceof t && (r = s)),
                                        (p = i.wrapInner('<div class="dotdotdot" />').children())
                                            .contents()
                                            .detach()
                                            .end()
                                            .append(r.clone(!0))
                                            .find("br")
                                            .replaceWith("  <br />  ")
                                            .end()
                                            .css({ height: "auto", width: "auto", border: "none", padding: 0, margin: 0 });
                                    var u = !1,
                                        c = !1;
                                    return (
                                        l.afterElement && ((u = l.afterElement.clone(!0)).show(), l.afterElement.detach()),
                                        o(p, a) &&
                                            (c =
                                                "children" == a.wrap
                                                    ? (function (t, e, n) {
                                                          var i = t.children(),
                                                              r = !1;
                                                          t.empty();
                                                          for (var s = 0, a = i.length; s < a; s++) {
                                                              var l = i.eq(s);
                                                              if ((t.append(l), n && t.append(n), o(t, e))) {
                                                                  l.remove(), (r = !0);
                                                                  break;
                                                              }
                                                              n && n.detach();
                                                          }
                                                          return r;
                                                      })(p, a, u)
                                                    : n(p, i, p, a, u)),
                                        p.replaceWith(p.contents()),
                                        (p = null),
                                        t.isFunction(a.callback) && a.callback.call(i[0], c, r),
                                        (l.isTruncated = c),
                                        c
                                    );
                                })
                                .bind("isTruncated.dot", function (t, e) {
                                    return t.preventDefault(), t.stopPropagation(), "function" == typeof e && e.call(i[0], l.isTruncated), l.isTruncated;
                                })
                                .bind("originalContent.dot", function (t, e) {
                                    return t.preventDefault(), t.stopPropagation(), "function" == typeof e && e.call(i[0], r), r;
                                })
                                .bind("destroy.dot", function (t) {
                                    t.preventDefault(),
                                        t.stopPropagation(),
                                        i
                                            .unwatch()
                                            .unbind_events()
                                            .contents()
                                            .detach()
                                            .end()
                                            .append(r)
                                            .attr("style", i.data("dotdotdot-style") || "")
                                            .data("dotdotdot", !1);
                                }),
                            i
                        );
                    }),
                    (i.unbind_events = function () {
                        return i.unbind(".dot"), i;
                    }),
                    (i.watch = function () {
                        if ((i.unwatch(), "window" == a.watch)) {
                            var e = t(window),
                                n = e.width(),
                                o = e.height();
                            e.bind("resize.dot" + l.dotId, function () {
                                (n == e.width() && o == e.height() && a.windowResizeFix) ||
                                    ((n = e.width()),
                                    (o = e.height()),
                                    c && clearInterval(c),
                                    (c = setTimeout(function () {
                                        i.trigger("update.dot");
                                    }, 100)));
                            });
                        } else
                            (u = s(i)),
                                (c = setInterval(function () {
                                    if (i.is(":visible")) {
                                        var t = s(i);
                                        (u.width == t.width && u.height == t.height) || (i.trigger("update.dot"), (u = t));
                                    }
                                }, 500));
                        return i;
                    }),
                    (i.unwatch = function () {
                        return t(window).unbind("resize.dot" + l.dotId), c && clearInterval(c), i;
                    });
                var r = i.contents(),
                    a = t.extend(!0, {}, t.fn.dotdotdot.defaults, e),
                    l = {},
                    u = {},
                    c = null,
                    p = null;
                return (
                    a.lastCharacter.remove instanceof Array || (a.lastCharacter.remove = t.fn.dotdotdot.defaultArrays.lastCharacter.remove),
                    a.lastCharacter.noEllipsis instanceof Array || (a.lastCharacter.noEllipsis = t.fn.dotdotdot.defaultArrays.lastCharacter.noEllipsis),
                    (l.afterElement = (function (e, n) {
                        return !!e && ("string" == typeof e ? !!(e = t(e, n)).length && e : !!e.jquery && e);
                    })(a.after, i)),
                    (l.isTruncated = !1),
                    (l.dotId = d++),
                    i.data("dotdotdot", !0).bind_events().trigger("update.dot"),
                    a.watch && i.watch(),
                    i
                );
            }),
                (t.fn.dotdotdot.defaults = { ellipsis: "... ", wrap: "word", fallbackToLetter: !0, lastCharacter: {}, tolerance: 0, callback: null, after: null, height: null, watch: !1, windowResizeFix: !0 }),
                (t.fn.dotdotdot.defaultArrays = { lastCharacter: { remove: [" ", "　", ",", ";", ".", "!", "?"], noEllipsis: [] } }),
                (t.fn.dotdotdot.debug = function (t) {});
            var d = 1,
                p = t.fn.html;
            t.fn.html = function (e) {
                return null != e && !t.isFunction(e) && this.data("dotdotdot") ? this.trigger("update", [e]) : p.apply(this, arguments);
            };
            var h = t.fn.text;
            t.fn.text = function (e) {
                return null != e && !t.isFunction(e) && this.data("dotdotdot") ? ((e = t("<div />").text(e).html()), this.trigger("update", [e])) : h.apply(this, arguments);
            };
        }
    })(jQuery),
    (function (t, e) {
        "object" == typeof exports && "undefined" != typeof module ? (module.exports = e()) : "function" == typeof define && define.amd ? define(e) : ((t = t || self).cssVars = e());
    })(this, function () {
        function t() {
            return (t =
                Object.assign ||
                function (t) {
                    for (var e = 1; e < arguments.length; e++) {
                        var n = arguments[e];
                        for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
                    }
                    return t;
                }).apply(this, arguments);
        }
        function e(t) {
            function e() {
                return !("<" === (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").trim().charAt(0));
            }
            function n(t, e) {
                r.onError(t, s[e], e);
            }
            function i(t, e) {
                var n = r.onSuccess(t, s[e], e);
                (t = !1 === n ? "" : n || t), (a[e] = t), -1 === a.indexOf(null) && r.onComplete(a);
            }
            var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                r = {
                    mimeType: o.mimeType || null,
                    onBeforeSend: o.onBeforeSend || Function.prototype,
                    onSuccess: o.onSuccess || Function.prototype,
                    onError: o.onError || Function.prototype,
                    onComplete: o.onComplete || Function.prototype,
                },
                s = Array.isArray(t) ? t : [t],
                a = Array.apply(null, Array(s.length)).map(function (t) {
                    return null;
                }),
                l = document.createElement("a");
            s.forEach(function (t, o) {
                if ((l.setAttribute("href", t), (l.href = String(l.href)), Boolean(document.all && !window.atob) && l.host.split(":")[0] !== location.host.split(":")[0]))
                    if (l.protocol === location.protocol) {
                        var s = new XDomainRequest();
                        s.open("GET", t),
                            (s.timeout = 0),
                            (s.onprogress = Function.prototype),
                            (s.ontimeout = Function.prototype),
                            (s.onload = function () {
                                e(s.responseText) ? i(s.responseText, o) : n(s, o);
                            }),
                            (s.onerror = function (t) {
                                n(s, o);
                            }),
                            setTimeout(function () {
                                s.send();
                            }, 0);
                    } else console.warn("Internet Explorer 9 Cross-Origin (CORS) requests must use the same protocol (".concat(t, ")")), n(null, o);
                else {
                    var a = new XMLHttpRequest();
                    a.open("GET", t),
                        r.mimeType && a.overrideMimeType && a.overrideMimeType(r.mimeType),
                        r.onBeforeSend(a, t, o),
                        (a.onreadystatechange = function () {
                            4 === a.readyState && (200 === a.status && e(a.responseText) ? i(a.responseText, o) : n(a, o));
                        }),
                        a.send();
                }
            });
        }
        function n(t) {
            function n() {
                if (-1 === u.indexOf(null)) {
                    var t = u.join("");
                    a.onComplete(t, u, l);
                }
            }
            function o(t, i, o, s) {
                var l = a.onSuccess(t, o, s);
                !(function t(n, i, o, s) {
                    var l = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : [],
                        u = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : [],
                        c = r(n, o, u);
                    c.rules.length
                        ? e(c.absoluteUrls, {
                              onBeforeSend: function (t, e, n) {
                                  a.onBeforeSend(t, i, e);
                              },
                              onSuccess: function (t, e, n) {
                                  var o = a.onSuccess(t, i, e),
                                      s = r((t = !1 === o ? "" : o || t), e, u);
                                  return (
                                      s.rules.forEach(function (e, n) {
                                          t = t.replace(e, s.absoluteRules[n]);
                                      }),
                                      t
                                  );
                              },
                              onError: function (e, r, a) {
                                  l.push({ xhr: e, url: r }), u.push(c.rules[a]), t(n, i, o, s, l, u);
                              },
                              onComplete: function (e) {
                                  e.forEach(function (t, e) {
                                      n = n.replace(c.rules[e], t);
                                  }),
                                      t(n, i, o, s, l, u);
                              },
                          })
                        : s(n, l);
                })((t = void 0 !== l && !1 === Boolean(l) ? "" : l || t), o, s, function (t, e) {
                    null === u[i] &&
                        (e.forEach(function (t) {
                            return a.onError(t.xhr, o, t.url);
                        }),
                        !a.filter || a.filter.test(t) ? (u[i] = t) : (u[i] = ""),
                        n());
                });
            }
            function r(t, e) {
                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
                    o = {};
                return (
                    (o.rules = (t.replace(s.cssComments, "").match(s.cssImports) || []).filter(function (t) {
                        return -1 === n.indexOf(t);
                    })),
                    (o.urls = o.rules.map(function (t) {
                        return t.replace(s.cssImports, "$1");
                    })),
                    (o.absoluteUrls = o.urls.map(function (t) {
                        return i(t, e);
                    })),
                    (o.absoluteRules = o.rules.map(function (t, n) {
                        var r = o.urls[n],
                            s = i(o.absoluteUrls[n], e);
                        return t.replace(r, s);
                    })),
                    o
                );
            }
            var s = { cssComments: /\/\*[\s\S]+?\*\//g, cssImports: /(?:@import\s*)(?:url\(\s*)?(?:['"])([^'"]*)(?:['"])(?:\s*\))?(?:[^;]*;)/g },
                a = {
                    rootElement: t.rootElement || document,
                    include: t.include || 'style,link[rel="stylesheet"]',
                    exclude: t.exclude || null,
                    filter: t.filter || null,
                    useCSSOM: t.useCSSOM || !1,
                    onBeforeSend: t.onBeforeSend || Function.prototype,
                    onSuccess: t.onSuccess || Function.prototype,
                    onError: t.onError || Function.prototype,
                    onComplete: t.onComplete || Function.prototype,
                },
                l = Array.apply(null, a.rootElement.querySelectorAll(a.include)).filter(function (t) {
                    return (e = t), (n = a.exclude), !(e.matches || e.matchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector || e.msMatchesSelector || e.oMatchesSelector).call(e, n);
                    var e, n;
                }),
                u = Array.apply(null, Array(l.length)).map(function (t) {
                    return null;
                });
            l.length
                ? l.forEach(function (t, r) {
                      var s = t.getAttribute("href"),
                          l = t.getAttribute("rel"),
                          c = "LINK" === t.nodeName && s && l && "stylesheet" === l.toLowerCase(),
                          d = "STYLE" === t.nodeName;
                      if (c)
                          e(s, {
                              mimeType: "text/css",
                              onBeforeSend: function (e, n, i) {
                                  a.onBeforeSend(e, t, n);
                              },
                              onSuccess: function (e, n, a) {
                                  var l = i(s, location.href);
                                  o(e, r, t, l);
                              },
                              onError: function (e, i, o) {
                                  (u[r] = ""), a.onError(e, t, i), n();
                              },
                          });
                      else if (d) {
                          var p = t.textContent;
                          a.useCSSOM &&
                              (p = Array.apply(null, t.sheet.cssRules)
                                  .map(function (t) {
                                      return t.cssText;
                                  })
                                  .join("")),
                              o(p, r, t, location.href);
                      } else (u[r] = ""), n();
                  })
                : a.onComplete("", []);
        }
        function i(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : location.href,
                n = document.implementation.createHTMLDocument(""),
                i = n.createElement("base"),
                o = n.createElement("a");
            return n.head.appendChild(i), n.body.appendChild(o), (i.href = e), (o.href = t), o.href;
        }
        function o(t, e, n) {
            t instanceof RegExp && (t = r(t, n)), e instanceof RegExp && (e = r(e, n));
            var i = s(t, e, n);
            return i && { start: i[0], end: i[1], pre: n.slice(0, i[0]), body: n.slice(i[0] + t.length, i[1]), post: n.slice(i[1] + e.length) };
        }
        function r(t, e) {
            var n = e.match(t);
            return n ? n[0] : null;
        }
        function s(t, e, n) {
            var i,
                o,
                r,
                s,
                a,
                l = n.indexOf(t),
                u = n.indexOf(e, l + 1),
                c = l;
            if (l >= 0 && u > 0) {
                for (i = [], r = n.length; c >= 0 && !a; )
                    c == l ? (i.push(c), (l = n.indexOf(t, c + 1))) : 1 == i.length ? (a = [i.pop(), u]) : ((o = i.pop()) < r && ((r = o), (s = u)), (u = n.indexOf(e, c + 1))), (c = l < u && l >= 0 ? l : u);
                i.length && (a = [r, s]);
            }
            return a;
        }
        function a(e) {
            var n,
                i,
                o = t({}, { fixNestedCalc: !0, onlyVars: !1, persist: !1, preserve: !1, variables: {}, onWarning: function () {} }, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}),
                r = o.persist ? h.dom : (h.temp = JSON.parse(JSON.stringify(h.dom))),
                s = (function (e) {
                    function n(t) {
                        throw new Error("CSS parse error: ".concat(t));
                    }
                    function i(t) {
                        var n = t.exec(e);
                        if (n) return (e = e.slice(n[0].length)), n;
                    }
                    function o() {
                        return i(/^{\s*/);
                    }
                    function r() {
                        return i(/^}/);
                    }
                    function s() {
                        i(/^\s*/);
                    }
                    function a() {
                        if ((s(), "/" === e[0] && "*" === e[1])) {
                            for (var t = 2; e[t] && ("*" !== e[t] || "/" !== e[t + 1]); ) t++;
                            if (!e[t]) return n("end of comment is missing");
                            var i = e.slice(2, t);
                            return (e = e.slice(t + 2)), { type: "comment", comment: i };
                        }
                    }
                    function l() {
                        for (var t, e = []; (t = a()); ) e.push(t);
                        return v.removeComments ? [] : e;
                    }
                    function u() {
                        for (s(); "}" === e[0]; ) n("extra closing bracket");
                        var t = i(/^(("(?:\\"|[^"])*"|'(?:\\'|[^'])*'|[^{])+)/);
                        if (t)
                            return t[0]
                                .trim()
                                .replace(/\/\*([^*]|[\r\n]|(\*+([^*\/]|[\r\n])))*\*\/+/g, "")
                                .replace(/"(?:\\"|[^"])*"|'(?:\\'|[^'])*'/g, function (t) {
                                    return t.replace(/,/g, "‌");
                                })
                                .split(/\s*(?![^(]*\)),\s*/)
                                .map(function (t) {
                                    return t.replace(/\u200C/g, ",");
                                });
                    }
                    function d() {
                        i(/^([;\s]*)+/);
                        var t = /\/\*[^*]*\*+([^\/*][^*]*\*+)*\//g,
                            e = i(/^(\*?[-#\/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/);
                        if (e) {
                            if (((e = e[0].trim()), !i(/^:\s*/))) return n("property missing ':'");
                            var o = i(/^((?:\/\*.*?\*\/|'(?:\\'|.)*?'|"(?:\\"|.)*?"|\((\s*'(?:\\'|.)*?'|"(?:\\"|.)*?"|[^)]*?)\s*\)|[^};])+)/),
                                r = { type: "declaration", property: e.replace(t, ""), value: o ? o[0].replace(t, "").trim() : "" };
                            return i(/^[;\s]*/), r;
                        }
                    }
                    function p() {
                        if (!o()) return n("missing '{'");
                        for (var t, e = l(); (t = d()); ) e.push(t), (e = e.concat(l()));
                        return r() ? e : n("missing '}'");
                    }
                    function h() {
                        s();
                        for (var t, e = []; (t = i(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/)); ) e.push(t[1]), i(/^,\s*/);
                        if (e.length) return { type: "keyframe", values: e, declarations: p() };
                    }
                    function f() {
                        if ((s(), "@" === e[0])) {
                            var t =
                                (function () {
                                    var t = i(/^@([-\w]+)?keyframes\s*/);
                                    if (t) {
                                        var e = t[1];
                                        if (!(t = i(/^([-\w]+)\s*/))) return n("@keyframes missing name");
                                        var s,
                                            a = t[1];
                                        if (!o()) return n("@keyframes missing '{'");
                                        for (var u = l(); (s = h()); ) u.push(s), (u = u.concat(l()));
                                        return r() ? { type: "keyframes", name: a, vendor: e, keyframes: u } : n("@keyframes missing '}'");
                                    }
                                })() ||
                                (function () {
                                    var t = i(/^@supports *([^{]+)/);
                                    if (t) return { type: "supports", supports: t[1].trim(), rules: g() };
                                })() ||
                                (function () {
                                    if (i(/^@host\s*/)) return { type: "host", rules: g() };
                                })() ||
                                (function () {
                                    var t = i(/^@media *([^{]+)/);
                                    if (t) return { type: "media", media: t[1].trim(), rules: g() };
                                })() ||
                                (function () {
                                    var t = i(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/);
                                    if (t) return { type: "custom-media", name: t[1].trim(), media: t[2].trim() };
                                })() ||
                                (function () {
                                    if (i(/^@page */)) return { type: "page", selectors: u() || [], declarations: p() };
                                })() ||
                                (function () {
                                    var t = i(/^@([-\w]+)?document *([^{]+)/);
                                    if (t) return { type: "document", document: t[2].trim(), vendor: t[1] ? t[1].trim() : null, rules: g() };
                                })() ||
                                (function () {
                                    if (i(/^@font-face\s*/)) return { type: "font-face", declarations: p() };
                                })() ||
                                (function () {
                                    var t = i(/^@(import|charset|namespace)\s*([^;]+);/);
                                    if (t) return { type: t[1], name: t[2].trim() };
                                })();
                            return t && v.onlyVars
                                ? (
                                      t.declarations
                                          ? t.declarations.some(function (t) {
                                                return /var\(/.test(t.value);
                                            })
                                          : (t.keyframes || t.rules || []).some(function (t) {
                                                return (t.declarations || []).some(function (t) {
                                                    return /var\(/.test(t.value);
                                                });
                                            })
                                  )
                                    ? t
                                    : {}
                                : t;
                        }
                    }
                    function m() {
                        if (v.onlyVars) {
                            var t = c("{", "}", e);
                            if (t) {
                                var i = -1 !== t.pre.indexOf(":root") && /--\S*\s*:/.test(t.body),
                                    o = /var\(/.test(t.body);
                                if (!i && !o) return (e = e.slice(t.end + 1)), {};
                            }
                        }
                        var r = u() || [],
                            s = v.onlyVars
                                ? p().filter(function (t) {
                                      var e =
                                              r.some(function (t) {
                                                  return -1 !== t.indexOf(":root");
                                              }) && /^--\S/.test(t.property),
                                          n = /var\(/.test(t.value);
                                      return e || n;
                                  })
                                : p();
                        return r.length || n("selector missing"), { type: "rule", selectors: r, declarations: s };
                    }
                    function g(t) {
                        if (!t && !o()) return n("missing '{'");
                        for (var i, s = l(); e.length && (t || "}" !== e[0]) && (i = f() || m()); ) i.type && s.push(i), (s = s.concat(l()));
                        return t || r() ? s : n("missing '}'");
                    }
                    var v = t({}, { onlyVars: !1, removeComments: !1 }, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {});
                    return { type: "stylesheet", stylesheet: { rules: g(!0), errors: [] } };
                })(e, { onlyVars: o.onlyVars });
            if (
                (s.stylesheet.rules.forEach(function (t) {
                    var e = [];
                    if (
                        "rule" === t.type &&
                        1 === t.selectors.length &&
                        ":root" === t.selectors[0] &&
                        (t.declarations.forEach(function (t, n) {
                            var i = t.property,
                                o = t.value;
                            i && 0 === i.indexOf(d) && ((r[i] = o), e.push(n));
                        }),
                        !o.preserve)
                    )
                        for (var n = e.length - 1; n >= 0; n--) t.declarations.splice(e[n], 1);
                }),
                Object.keys(h.user).forEach(function (t) {
                    r[t] = h.user[t];
                }),
                Object.keys(o.variables).length)
            ) {
                var a = { declarations: [], selectors: [":root"], type: "rule" };
                Object.keys(o.variables).forEach(function (t) {
                    var e = "--".concat(t.replace(/^-+/, "")),
                        n = o.variables[t];
                    o.persist && (h.user[e] = n), r[e] !== n && ((r[e] = n), a.declarations.push({ type: "declaration", property: e, value: n }));
                }),
                    o.preserve && a.declarations.length && s.stylesheet.rules.push(a);
            }
            return (
                (function t(e, n) {
                    e.rules.forEach(function (i) {
                        i.rules
                            ? t(i, n)
                            : i.keyframes
                            ? i.keyframes.forEach(function (t) {
                                  "keyframe" === t.type && n(t.declarations, i);
                              })
                            : i.declarations && n(i.declarations, e);
                    });
                })(s.stylesheet, function (t, e) {
                    for (var n, i, s, a = 0; a < t.length; a++)
                        (s = (n = t[a]).value),
                            "declaration" === n.type && s && -1 !== s.indexOf(p + "(") && (i = l(s, r, o)) !== n.value && (o.preserve ? (t.splice(a, 0, { type: n.type, property: n.property, value: i }), a++) : (n.value = i));
                }),
                o.fixNestedCalc &&
                    ((n = s.stylesheet.rules),
                    (i = /(-[a-z]+-)?calc\(/),
                    n.forEach(function (t) {
                        t.declarations &&
                            t.declarations.forEach(function (t) {
                                for (var e = t.value, n = ""; i.test(e); ) {
                                    var o = c("calc(", ")", e || "");
                                    for (e = e.slice(o.end); i.test(o.body); ) {
                                        var r = c(i, ")", o.body);
                                        o.body = "".concat(r.pre, "(").concat(r.body, ")").concat(r.post);
                                    }
                                    (n += "".concat(o.pre, "calc(").concat(o.body)), (n += i.test(e) ? "" : ")".concat(o.post));
                                }
                                t.value = n || t.value;
                            });
                    })),
                (function (t) {
                    function e(t) {
                        for (var e = "", r = 0; r < t.length; r++) {
                            var s = t[r];
                            i && i(s);
                            var a = o[s.type](s);
                            a && ((e += a), a.length && s.selectors && (e += n));
                        }
                        return e;
                    }
                    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
                        i = arguments.length > 2 ? arguments[2] : void 0,
                        o = {
                            charset: function (t) {
                                return "@charset " + t.name + ";";
                            },
                            comment: function (t) {
                                return 0 === t.comment.indexOf("__CSSVARSPONYFILL") ? "/*" + t.comment + "*/" : "";
                            },
                            "custom-media": function (t) {
                                return "@custom-media " + t.name + " " + t.media + ";";
                            },
                            declaration: function (t) {
                                return t.property + ":" + t.value + ";";
                            },
                            document: function (t) {
                                return "@" + (t.vendor || "") + "document " + t.document + "{" + e(t.rules) + "}";
                            },
                            "font-face": function (t) {
                                return "@font-face{" + e(t.declarations) + "}";
                            },
                            host: function (t) {
                                return "@host{" + e(t.rules) + "}";
                            },
                            import: function (t) {
                                return "@import " + t.name + ";";
                            },
                            keyframe: function (t) {
                                return t.values.join(",") + "{" + e(t.declarations) + "}";
                            },
                            keyframes: function (t) {
                                return "@" + (t.vendor || "") + "keyframes " + t.name + "{" + e(t.keyframes) + "}";
                            },
                            media: function (t) {
                                return "@media " + t.media + "{" + e(t.rules) + "}";
                            },
                            namespace: function (t) {
                                return "@namespace " + t.name + ";";
                            },
                            page: function (t) {
                                return "@page " + (t.selectors.length ? t.selectors.join(", ") : "") + "{" + e(t.declarations) + "}";
                            },
                            rule: function (t) {
                                var n = t.declarations;
                                if (n.length) return t.selectors.join(",") + "{" + e(n) + "}";
                            },
                            supports: function (t) {
                                return "@supports " + t.supports + "{" + e(t.rules) + "}";
                            },
                        };
                    return e(t.stylesheet.rules);
                })(s)
            );
        }
        function l(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                i = arguments.length > 3 ? arguments[3] : void 0;
            if (-1 === t.indexOf("var(")) return t;
            var o = c("(", ")", t),
                r = "CSS transform warning:";
            return o
                ? "var" === o.pre.slice(-3)
                    ? 0 === o.body.trim().length
                        ? (n.onWarning("".concat(r, " var() must contain a non-whitespace string")), t)
                        : o.pre.slice(0, -3) +
                          (function (t) {
                              var o = t.split(",")[0].replace(/[\s\n\t]/g, ""),
                                  s = (t.match(/(?:\s*,\s*){1}(.*)?/) || [])[1],
                                  a = e.hasOwnProperty(o) ? String(e[o]) : void 0,
                                  u = a || (s ? String(s) : void 0),
                                  c = i || t;
                              return a || n.onWarning("".concat(r, ' variable "').concat(o, '" is undefined')), u && "undefined" !== u && u.length > 0 ? l(u, e, n, c) : "var(".concat(c, ")");
                          })(o.body) +
                          l(o.post, e, n)
                    : o.pre + "(".concat(l(o.body, e, n), ")") + l(o.post, e, n)
                : (-1 !== t.indexOf("var(") && n.onWarning("".concat(r, ' missing closing ")" in the value "').concat(t, '"')), t);
        }
        function u(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : location.href,
                n = document.implementation.createHTMLDocument(""),
                i = n.createElement("base"),
                o = n.createElement("a");
            return n.head.appendChild(i), n.body.appendChild(o), (i.href = e), (o.href = t), o.href;
        }
        var c = o;
        o.range = s;
        var d = "--",
            p = "var",
            h = { dom: {}, temp: {}, user: {} },
            f = "css-vars-ponyfill",
            m = "undefined" != typeof window,
            g = m && window.CSS && window.CSS.supports && window.CSS.supports("(--a: 0)"),
            v = {
                rootElement: m ? document : null,
                include: "style,link[rel=stylesheet]",
                exclude: "",
                fixNestedCalc: !0,
                onlyLegacy: !0,
                onlyVars: !1,
                preserve: !1,
                shadowDOM: !1,
                silent: !1,
                updateDOM: !0,
                updateURLs: !0,
                variables: {},
                watch: null,
                onBeforeSend: function () {},
                onSuccess: function () {},
                onWarning: function () {},
                onError: function () {},
                onComplete: function () {},
            },
            y = {
                cssComments: /\/\*[\s\S]+?\*\//g,
                cssKeyframes: /@(?:-\w*-)?keyframes/,
                cssRootRules: /(?::root\s*{\s*[^}]*})/g,
                cssUrls: /url\((?!['"]?(?:data|http|\/\/):)['"]?([^'")]*)['"]?\)/g,
                cssVars: /(?:(?::root\s*{\s*[^;]*;*\s*)|(?:var\(\s*))(--[^:)]+)(?:\s*[:)])/,
            },
            w = null,
            b = !1;
        return function e() {
            function i(t, e, n, i) {
                s.silent || console.error("".concat(t, "\n"), e), s.onError(t, e, n, i);
            }
            function o(t) {
                s.silent || console.warn(t), s.onWarning(t);
            }
            var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                s = t({}, v, r),
                l = f;
            if (((s.exclude = "#".concat(l) + (s.exclude ? ",".concat(s.exclude) : "")), m))
                if ("loading" !== document.readyState) {
                    var c = s.shadowDOM || s.rootElement.shadowRoot || s.rootElement.host;
                    if (g && s.onlyLegacy) {
                        if (s.updateDOM) {
                            var d = s.rootElement.host || (s.rootElement === document ? document.documentElement : s.rootElement);
                            Object.keys(s.variables).forEach(function (t) {
                                var e = "--".concat(t.replace(/^-+/, "")),
                                    n = s.variables[t];
                                d.style.setProperty(e, n);
                            });
                        }
                    } else
                        c && !b
                            ? n({
                                  rootElement: v.rootElement,
                                  include: v.include,
                                  exclude: s.exclude,
                                  onSuccess: function (t, e, n) {
                                      return (t.match(y.cssRootRules) || []).join("") || !1;
                                  },
                                  onComplete: function (t, n, i) {
                                      a(t, { persist: !0 }), (b = !0), e(s);
                                  },
                              })
                            : (s.watch
                                  ? (function (t, n) {
                                        if (window.MutationObserver) {
                                            var i = function (t) {
                                                    return "LINK" === t.tagName && -1 !== (t.getAttribute("rel") || "").indexOf("stylesheet");
                                                },
                                                o = function (t) {
                                                    return "STYLE" === t.tagName && (!n || t.id !== n);
                                                },
                                                r = null;
                                            w && w.disconnect(),
                                                (t.watch = v.watch),
                                                (w = new MutationObserver(function (n) {
                                                    var s = !1;
                                                    n.forEach(function (n) {
                                                        if ("attributes" === n.type) s = i(n.target) || o(n.target);
                                                        else if ("childList" === n.type) {
                                                            var a = Array.apply(null, n.addedNodes),
                                                                l = Array.apply(null, n.removedNodes);
                                                            s = [].concat(a, l).some(function (t) {
                                                                var e = i(t) && !t.disabled,
                                                                    n = o(t) && !t.disabled && y.cssVars.test(t.textContent);
                                                                return e || n;
                                                            });
                                                        }
                                                        s &&
                                                            (clearTimeout(r),
                                                            (r = setTimeout(function () {
                                                                e(t);
                                                            }, 1)));
                                                    });
                                                })).observe(document.documentElement, { attributes: !0, attributeFilter: ["disabled", "href"], childList: !0, subtree: !0 });
                                        }
                                    })(s, l)
                                  : !1 === s.watch && w && w.disconnect(),
                              n({
                                  rootElement: s.rootElement,
                                  include: s.include,
                                  exclude: s.exclude,
                                  filter: s.onlyVars ? y.cssVars : null,
                                  onBeforeSend: s.onBeforeSend,
                                  onSuccess: function (t, e, n) {
                                      var i = s.onSuccess(t, e, n);
                                      return (
                                          (t = void 0 !== i && !1 === Boolean(i) ? "" : i || t),
                                          s.updateURLs &&
                                              (t.replace(y.cssComments, "").match(y.cssUrls) || []).forEach(function (e) {
                                                  var i = e.replace(y.cssUrls, "$1"),
                                                      o = u(i, n);
                                                  t = t.replace(e, e.replace(i, o));
                                              }),
                                          t
                                      );
                                  },
                                  onError: function (t, e, n) {
                                      var o = t.responseURL || u(n, location.href),
                                          r = t.statusText ? "(".concat(t.statusText, ")") : "Unspecified Error" + (0 === t.status ? " (possibly CORS related)" : "");
                                      i("CSS XHR Error: ".concat(o, " ").concat(t.status, " ").concat(r), e, t, o);
                                  },
                                  onComplete: function (n, r, u) {
                                      var c = null;
                                      n = r
                                          .map(function (t, e) {
                                              return y.cssVars.test(t) ? t : "/*__CSSVARSPONYFILL-".concat(e, "__*/");
                                          })
                                          .join("");
                                      try {
                                          n = a(n, { fixNestedCalc: s.fixNestedCalc, onlyVars: s.onlyVars, persist: s.updateDOM, preserve: s.preserve, variables: s.variables, onWarning: o });
                                          var d = y.cssKeyframes.test(n);
                                          if (
                                              ((n = n.replace(/\/\*__CSSVARSPONYFILL-(\d+)__\*\//g, function (t, e) {
                                                  return r[e];
                                              })),
                                              s.updateDOM && u && u.length)
                                          ) {
                                              var p = u[u.length - 1];
                                              (c = s.rootElement.querySelector("#".concat(l)) || document.createElement("style")).setAttribute("id", l),
                                                  c.textContent !== n && (c.textContent = n),
                                                  p.nextSibling !== c && p.parentNode && p.parentNode.insertBefore(c, p.nextSibling),
                                                  d &&
                                                      (function (t) {
                                                          var e = ["animation-name", "-moz-animation-name", "-webkit-animation-name"].filter(function (t) {
                                                              return getComputedStyle(document.body)[t];
                                                          })[0];
                                                          if (e) {
                                                              for (var n = t.getElementsByTagName("*"), i = [], o = 0, r = n.length; o < r; o++) {
                                                                  var s = n[o];
                                                                  "none" !== getComputedStyle(s)[e] && ((s.style[e] += "__CSSVARSPONYFILL-KEYFRAMES__"), i.push(s));
                                                              }
                                                              document.body.offsetHeight;
                                                              for (var a = 0, l = i.length; a < l; a++) {
                                                                  var u = i[a].style;
                                                                  u[e] = u[e].replace("__CSSVARSPONYFILL-KEYFRAMES__", "");
                                                              }
                                                          }
                                                      })(s.rootElement);
                                          }
                                      } catch (t) {
                                          var f = !1;
                                          r.forEach(function (t, e) {
                                              try {
                                                  t = a(t, s);
                                              } catch (t) {
                                                  var n = u[e - 0];
                                                  (f = !0), i(t.message, n);
                                              }
                                          }),
                                              f || i(t.message || t);
                                      }
                                      if (s.shadowDOM)
                                          for (
                                              var m,
                                                  g = [s.rootElement].concat(
                                                      (function (t) {
                                                          return (
                                                              (function (t) {
                                                                  if (Array.isArray(t)) {
                                                                      for (var e = 0, n = new Array(t.length); e < t.length; e++) n[e] = t[e];
                                                                      return n;
                                                                  }
                                                              })(t) ||
                                                              (function (t) {
                                                                  if ((Symbol.iterator in Object(t)) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
                                                              })(t) ||
                                                              (function () {
                                                                  throw new TypeError("Invalid attempt to spread non-iterable instance");
                                                              })()
                                                          );
                                                      })(s.rootElement.querySelectorAll("*"))
                                                  ),
                                                  v = 0;
                                              (m = g[v]);
                                              ++v
                                          )
                                              m.shadowRoot && m.shadowRoot.querySelector("style") && e(t({}, s, { rootElement: m.shadowRoot, variables: h.dom }));
                                      s.onComplete(n, c, JSON.parse(JSON.stringify(s.updateDOM ? h.dom : h.temp)));
                                  },
                              }));
                } else
                    document.addEventListener("DOMContentLoaded", function t(n) {
                        e(r), document.removeEventListener("DOMContentLoaded", t);
                    });
        };
    }),
    /*! jQuery UI - v1.12.1 - 2020-02-11
     * http://jqueryui.com
     * Includes: focusable.js
     * Copyright jQuery Foundation and other contributors; Licensed MIT */
    (function (t) {
        "function" == typeof define && define.amd ? define(["jquery"], t) : t(jQuery);
    })(function (t) {
        (t.ui = t.ui || {}),
            (t.ui.version = "1.12.1"),
            /*!
             * jQuery UI Focusable 1.12.1
             * http://jqueryui.com
             *
             * Copyright jQuery Foundation and other contributors
             * Released under the MIT license.
             * http://jquery.org/license
             */
            (t.ui.focusable = function (e, n) {
                var i,
                    o,
                    r,
                    s,
                    a,
                    l = e.nodeName.toLowerCase();
                return "area" === l
                    ? ((o = (i = e.parentNode).name), !(!e.href || !o || "map" !== i.nodeName.toLowerCase()) && (r = t("img[usemap='#" + o + "']")).length > 0 && r.is(":visible"))
                    : (/^(input|select|textarea|button|object)$/.test(l) ? (s = !e.disabled) && (a = t(e).closest("fieldset")[0]) && (s = !a.disabled) : (s = ("a" === l && e.href) || n),
                      s &&
                          t(e).is(":visible") &&
                          (function (t) {
                              for (var e = t.css("visibility"); "inherit" === e; ) e = (t = t.parent()).css("visibility");
                              return "hidden" !== e;
                          })(t(e)));
            }),
            t.extend(t.expr[":"], {
                focusable: function (e) {
                    return t.ui.focusable(e, null != t.attr(e, "tabindex"));
                },
            }),
            t.ui.focusable;
    }),
    /*!
     * jQuery Cookie Plugin v1.4.1
     * https://github.com/carhartl/jquery-cookie
     *
     * Copyright 2006, 2014 Klaus Hartl
     * Released under the MIT license
     */
    (function (t) {
        "function" == typeof define && define.amd ? define(["jquery"], t) : "object" == typeof exports ? (module.exports = t(require("jquery"))) : t(jQuery);
    })(function (t) {
        function e(t) {
            return s.raw ? t : encodeURIComponent(t);
        }
        function n(t) {
            return s.raw ? t : decodeURIComponent(t);
        }
        function i(t) {
            return e(s.json ? JSON.stringify(t) : String(t));
        }
        function o(e, n) {
            var i = s.raw
                ? e
                : (function (t) {
                      0 === t.indexOf('"') && (t = t.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\"));
                      try {
                          return (t = decodeURIComponent(t.replace(r, " "))), s.json ? JSON.parse(t) : t;
                      } catch (t) {}
                  })(e);
            return t.isFunction(n) ? n(i) : i;
        }
        var r = /\+/g,
            s = (t.cookie = function (r, a, l) {
                if (arguments.length > 1 && !t.isFunction(a)) {
                    if ("number" == typeof (l = t.extend({}, s.defaults, l)).expires) {
                        var u = l.expires,
                            c = (l.expires = new Date());
                        c.setMilliseconds(c.getMilliseconds() + 864e5 * u);
                    }
                    return (document.cookie = [e(r), "=", i(a), l.expires ? "; expires=" + l.expires.toUTCString() : "", l.path ? "; path=" + l.path : "", l.domain ? "; domain=" + l.domain : "", l.secure ? "; secure" : ""].join(""));
                }
                for (var d = r ? void 0 : {}, p = document.cookie ? document.cookie.split("; ") : [], h = 0, f = p.length; h < f; h++) {
                    var m = p[h].split("="),
                        g = n(m.shift()),
                        v = m.join("=");
                    if (r === g) {
                        d = o(v, a);
                        break;
                    }
                    r || void 0 === (v = o(v)) || (d[g] = v);
                }
                return d;
            });
        (s.defaults = {}),
            (t.removeCookie = function (e, n) {
                return t.cookie(e, "", t.extend({}, n, { expires: -1 })), !t.cookie(e);
            });
    }),
    /*!
     * Masonry PACKAGED v4.2.2
     * Cascading grid layout library
     * https://masonry.desandro.com
     * MIT License
     * by David DeSandro
     */

    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("jquery-bridget/jquery-bridget", ["jquery"], function (n) {
                  return e(t, n);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = e(t, require("jquery")))
            : (t.jQueryBridget = e(t, t.jQuery));
    })(window, function (t, e) {
        function n(n, r, a) {
            (a = a || e || t.jQuery) &&
                (r.prototype.option ||
                    (r.prototype.option = function (t) {
                        a.isPlainObject(t) && (this.options = a.extend(!0, this.options, t));
                    }),
                (a.fn[n] = function (t) {
                    return "string" == typeof t
                        ? (function (t, e, i) {
                              var o,
                                  r = "$()." + n + '("' + e + '")';
                              return (
                                  t.each(function (t, l) {
                                      var u = a.data(l, n);
                                      if (u) {
                                          var c = u[e];
                                          if (c && "_" != e.charAt(0)) {
                                              var d = c.apply(u, i);
                                              o = void 0 === o ? d : o;
                                          } else s(r + " is not a valid method");
                                      } else s(n + " not initialized. Cannot call methods, i.e. " + r);
                                  }),
                                  void 0 !== o ? o : t
                              );
                          })(this, t, o.call(arguments, 1))
                        : ((function (t, e) {
                              t.each(function (t, i) {
                                  var o = a.data(i, n);
                                  o ? (o.option(e), o._init()) : ((o = new r(i, e)), a.data(i, n, o));
                              });
                          })(this, t),
                          this);
                }),
                i(a));
        }
        function i(t) {
            !t || (t && t.bridget) || (t.bridget = n);
        }
        var o = Array.prototype.slice,
            r = t.console,
            s =
                void 0 === r
                    ? function () {}
                    : function (t) {
                          r.error(t);
                      };
        return i(e || t.jQuery), n;
    }),
    (function (t, e) {
        "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? (module.exports = e()) : (t.EvEmitter = e());
    })("undefined" != typeof window ? window : this, function () {
        function t() {}
        var e = t.prototype;
        return (
            (e.on = function (t, e) {
                if (t && e) {
                    var n = (this._events = this._events || {}),
                        i = (n[t] = n[t] || []);
                    return -1 == i.indexOf(e) && i.push(e), this;
                }
            }),
            (e.once = function (t, e) {
                if (t && e) {
                    this.on(t, e);
                    var n = (this._onceEvents = this._onceEvents || {});
                    return ((n[t] = n[t] || {})[e] = !0), this;
                }
            }),
            (e.off = function (t, e) {
                var n = this._events && this._events[t];
                if (n && n.length) {
                    var i = n.indexOf(e);
                    return -1 != i && n.splice(i, 1), this;
                }
            }),
            (e.emitEvent = function (t, e) {
                var n = this._events && this._events[t];
                if (n && n.length) {
                    (n = n.slice(0)), (e = e || []);
                    for (var i = this._onceEvents && this._onceEvents[t], o = 0; o < n.length; o++) {
                        var r = n[o];
                        i && i[r] && (this.off(t, r), delete i[r]), r.apply(this, e);
                    }
                    return this;
                }
            }),
            (e.allOff = function () {
                delete this._events, delete this._onceEvents;
            }),
            t
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd ? define("get-size/get-size", e) : "object" == typeof module && module.exports ? (module.exports = e()) : (t.getSize = e());
    })(window, function () {
        function t(t) {
            var e = parseFloat(t);
            return -1 == t.indexOf("%") && !isNaN(e) && e;
        }
        function e(t) {
            var e = getComputedStyle(t);
            return e || r("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), e;
        }
        function n() {
            if (!l) {
                l = !0;
                var n = document.createElement("div");
                (n.style.width = "200px"), (n.style.padding = "1px 2px 3px 4px"), (n.style.borderStyle = "solid"), (n.style.borderWidth = "1px 2px 3px 4px"), (n.style.boxSizing = "border-box");
                var r = document.body || document.documentElement;
                r.appendChild(n);
                var s = e(n);
                (o = 200 == Math.round(t(s.width))), (i.isBoxSizeOuter = o), r.removeChild(n);
            }
        }
        function i(i) {
            if ((n(), "string" == typeof i && (i = document.querySelector(i)), i && "object" == typeof i && i.nodeType)) {
                var r = e(i);
                if ("none" == r.display)
                    return (function () {
                        for (var t = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 }, e = 0; a > e; e++) t[s[e]] = 0;
                        return t;
                    })();
                var l = {};
                (l.width = i.offsetWidth), (l.height = i.offsetHeight);
                for (var u = (l.isBorderBox = "border-box" == r.boxSizing), c = 0; a > c; c++) {
                    var d = s[c],
                        p = r[d],
                        h = parseFloat(p);
                    l[d] = isNaN(h) ? 0 : h;
                }
                var f = l.paddingLeft + l.paddingRight,
                    m = l.paddingTop + l.paddingBottom,
                    g = l.marginLeft + l.marginRight,
                    v = l.marginTop + l.marginBottom,
                    y = l.borderLeftWidth + l.borderRightWidth,
                    w = l.borderTopWidth + l.borderBottomWidth,
                    b = u && o,
                    x = t(r.width);
                !1 !== x && (l.width = x + (b ? 0 : f + y));
                var _ = t(r.height);
                return !1 !== _ && (l.height = _ + (b ? 0 : m + w)), (l.innerWidth = l.width - (f + y)), (l.innerHeight = l.height - (m + w)), (l.outerWidth = l.width + g), (l.outerHeight = l.height + v), l;
            }
        }
        var o,
            r =
                "undefined" == typeof console
                    ? function () {}
                    : function (t) {
                          console.error(t);
                      },
            s = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
            a = s.length,
            l = !1;
        return i;
    }),
    (function (t, e) {
        "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == typeof module && module.exports ? (module.exports = e()) : (t.matchesSelector = e());
    })(window, function () {
        var t = (function () {
            var t = window.Element.prototype;
            if (t.matches) return "matches";
            if (t.matchesSelector) return "matchesSelector";
            for (var e = ["webkit", "moz", "ms", "o"], n = 0; n < e.length; n++) {
                var i = e[n] + "MatchesSelector";
                if (t[i]) return i;
            }
        })();
        return function (e, n) {
            return e[t](n);
        };
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function (n) {
                  return e(t, n);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = e(t, require("desandro-matches-selector")))
            : (t.fizzyUIUtils = e(t, t.matchesSelector));
    })(window, function (t, e) {
        var n = {
                extend: function (t, e) {
                    for (var n in e) t[n] = e[n];
                    return t;
                },
                modulo: function (t, e) {
                    return ((t % e) + e) % e;
                },
            },
            i = Array.prototype.slice;
        (n.makeArray = function (t) {
            return Array.isArray(t) ? t : null == t ? [] : "object" == typeof t && "number" == typeof t.length ? i.call(t) : [t];
        }),
            (n.removeFrom = function (t, e) {
                var n = t.indexOf(e);
                -1 != n && t.splice(n, 1);
            }),
            (n.getParent = function (t, n) {
                for (; t.parentNode && t != document.body; ) if (((t = t.parentNode), e(t, n))) return t;
            }),
            (n.getQueryElement = function (t) {
                return "string" == typeof t ? document.querySelector(t) : t;
            }),
            (n.handleEvent = function (t) {
                var e = "on" + t.type;
                this[e] && this[e](t);
            }),
            (n.filterFindElements = function (t, i) {
                t = n.makeArray(t);
                var o = [];
                return (
                    t.forEach(function (t) {
                        if (t instanceof HTMLElement) {
                            if (!i) return void o.push(t);
                            e(t, i) && o.push(t);
                            for (var n = t.querySelectorAll(i), r = 0; r < n.length; r++) o.push(n[r]);
                        }
                    }),
                    o
                );
            }),
            (n.debounceMethod = function (t, e, n) {
                n = n || 100;
                var i = t.prototype[e],
                    o = e + "Timeout";
                t.prototype[e] = function () {
                    var t = this[o];
                    clearTimeout(t);
                    var e = arguments,
                        r = this;
                    this[o] = setTimeout(function () {
                        i.apply(r, e), delete r[o];
                    }, n);
                };
            }),
            (n.docReady = function (t) {
                var e = document.readyState;
                "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t);
            }),
            (n.toDashed = function (t) {
                return t
                    .replace(/(.)([A-Z])/g, function (t, e, n) {
                        return e + "-" + n;
                    })
                    .toLowerCase();
            });
        var o = t.console;
        return (
            (n.htmlInit = function (e, i) {
                n.docReady(function () {
                    var r = n.toDashed(i),
                        s = "data-" + r,
                        a = document.querySelectorAll("[" + s + "]"),
                        l = document.querySelectorAll(".js-" + r),
                        u = n.makeArray(a).concat(n.makeArray(l)),
                        c = s + "-options",
                        d = t.jQuery;
                    u.forEach(function (t) {
                        var n,
                            r = t.getAttribute(s) || t.getAttribute(c);
                        try {
                            n = r && JSON.parse(r);
                        } catch (e) {
                            return void (o && o.error("Error parsing " + s + " on " + t.className + ": " + e));
                        }
                        var a = new e(t, n);
                        d && d.data(t, i, a);
                    });
                });
            }),
            n
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("outlayer/item", ["ev-emitter/ev-emitter", "get-size/get-size"], e)
            : "object" == typeof module && module.exports
            ? (module.exports = e(require("ev-emitter"), require("get-size")))
            : ((t.Outlayer = {}), (t.Outlayer.Item = e(t.EvEmitter, t.getSize)));
    })(window, function (t, e) {
        function n(t, e) {
            t && ((this.element = t), (this.layout = e), (this.position = { x: 0, y: 0 }), this._create());
        }
        var i = document.documentElement.style,
            o = "string" == typeof i.transition ? "transition" : "WebkitTransition",
            r = "string" == typeof i.transform ? "transform" : "WebkitTransform",
            s = { WebkitTransition: "webkitTransitionEnd", transition: "transitionend" }[o],
            a = { transform: r, transition: o, transitionDuration: o + "Duration", transitionProperty: o + "Property", transitionDelay: o + "Delay" },
            l = (n.prototype = Object.create(t.prototype));
        (l.constructor = n),
            (l._create = function () {
                (this._transn = { ingProperties: {}, clean: {}, onEnd: {} }), this.css({ position: "absolute" });
            }),
            (l.handleEvent = function (t) {
                var e = "on" + t.type;
                this[e] && this[e](t);
            }),
            (l.getSize = function () {
                this.size = e(this.element);
            }),
            (l.css = function (t) {
                var e = this.element.style;
                for (var n in t) e[a[n] || n] = t[n];
            }),
            (l.getPosition = function () {
                var t = getComputedStyle(this.element),
                    e = this.layout._getOption("originLeft"),
                    n = this.layout._getOption("originTop"),
                    i = t[e ? "left" : "right"],
                    o = t[n ? "top" : "bottom"],
                    r = parseFloat(i),
                    s = parseFloat(o),
                    a = this.layout.size;
                -1 != i.indexOf("%") && (r = (r / 100) * a.width),
                    -1 != o.indexOf("%") && (s = (s / 100) * a.height),
                    (r = isNaN(r) ? 0 : r),
                    (s = isNaN(s) ? 0 : s),
                    (r -= e ? a.paddingLeft : a.paddingRight),
                    (s -= n ? a.paddingTop : a.paddingBottom),
                    (this.position.x = r),
                    (this.position.y = s);
            }),
            (l.layoutPosition = function () {
                var t = this.layout.size,
                    e = {},
                    n = this.layout._getOption("originLeft"),
                    i = this.layout._getOption("originTop"),
                    o = n ? "paddingLeft" : "paddingRight",
                    r = n ? "left" : "right",
                    s = n ? "right" : "left",
                    a = this.position.x + t[o];
                (e[r] = this.getXValue(a)), (e[s] = "");
                var l = i ? "paddingTop" : "paddingBottom",
                    u = i ? "top" : "bottom",
                    c = i ? "bottom" : "top",
                    d = this.position.y + t[l];
                (e[u] = this.getYValue(d)), (e[c] = ""), this.css(e), this.emitEvent("layout", [this]);
            }),
            (l.getXValue = function (t) {
                var e = this.layout._getOption("horizontal");
                return this.layout.options.percentPosition && !e ? (t / this.layout.size.width) * 100 + "%" : t + "px";
            }),
            (l.getYValue = function (t) {
                var e = this.layout._getOption("horizontal");
                return this.layout.options.percentPosition && e ? (t / this.layout.size.height) * 100 + "%" : t + "px";
            }),
            (l._transitionTo = function (t, e) {
                this.getPosition();
                var n = this.position.x,
                    i = this.position.y,
                    o = t == this.position.x && e == this.position.y;
                if ((this.setPosition(t, e), !o || this.isTransitioning)) {
                    var r = t - n,
                        s = e - i,
                        a = {};
                    (a.transform = this.getTranslate(r, s)), this.transition({ to: a, onTransitionEnd: { transform: this.layoutPosition }, isCleaning: !0 });
                } else this.layoutPosition();
            }),
            (l.getTranslate = function (t, e) {
                return "translate3d(" + (t = this.layout._getOption("originLeft") ? t : -t) + "px, " + (e = this.layout._getOption("originTop") ? e : -e) + "px, 0)";
            }),
            (l.goTo = function (t, e) {
                this.setPosition(t, e), this.layoutPosition();
            }),
            (l.moveTo = l._transitionTo),
            (l.setPosition = function (t, e) {
                (this.position.x = parseFloat(t)), (this.position.y = parseFloat(e));
            }),
            (l._nonTransition = function (t) {
                for (var e in (this.css(t.to), t.isCleaning && this._removeStyles(t.to), t.onTransitionEnd)) t.onTransitionEnd[e].call(this);
            }),
            (l.transition = function (t) {
                if (parseFloat(this.layout.options.transitionDuration)) {
                    var e = this._transn;
                    for (var n in t.onTransitionEnd) e.onEnd[n] = t.onTransitionEnd[n];
                    for (n in t.to) (e.ingProperties[n] = !0), t.isCleaning && (e.clean[n] = !0);
                    t.from && (this.css(t.from), this.element.offsetHeight), this.enableTransition(t.to), this.css(t.to), (this.isTransitioning = !0);
                } else this._nonTransition(t);
            });
        var u =
            "opacity," +
            (function (t) {
                return t.replace(/([A-Z])/g, function (t) {
                    return "-" + t.toLowerCase();
                });
            })(r);
        (l.enableTransition = function () {
            if (!this.isTransitioning) {
                var t = this.layout.options.transitionDuration;
                (t = "number" == typeof t ? t + "ms" : t), this.css({ transitionProperty: u, transitionDuration: t, transitionDelay: this.staggerDelay || 0 }), this.element.addEventListener(s, this, !1);
            }
        }),
            (l.onwebkitTransitionEnd = function (t) {
                this.ontransitionend(t);
            }),
            (l.onotransitionend = function (t) {
                this.ontransitionend(t);
            });
        var c = { "-webkit-transform": "transform" };
        (l.ontransitionend = function (t) {
            if (t.target === this.element) {
                var e = this._transn,
                    n = c[t.propertyName] || t.propertyName;
                delete e.ingProperties[n],
                    (function (t) {
                        for (var e in t) return !1;
                        return !0;
                    })(e.ingProperties) && this.disableTransition(),
                    n in e.clean && ((this.element.style[t.propertyName] = ""), delete e.clean[n]),
                    n in e.onEnd && (e.onEnd[n].call(this), delete e.onEnd[n]),
                    this.emitEvent("transitionEnd", [this]);
            }
        }),
            (l.disableTransition = function () {
                this.removeTransitionStyles(), this.element.removeEventListener(s, this, !1), (this.isTransitioning = !1);
            }),
            (l._removeStyles = function (t) {
                var e = {};
                for (var n in t) e[n] = "";
                this.css(e);
            });
        var d = { transitionProperty: "", transitionDuration: "", transitionDelay: "" };
        return (
            (l.removeTransitionStyles = function () {
                this.css(d);
            }),
            (l.stagger = function (t) {
                (t = isNaN(t) ? 0 : t), (this.staggerDelay = t + "ms");
            }),
            (l.removeElem = function () {
                this.element.parentNode.removeChild(this.element), this.css({ display: "" }), this.emitEvent("remove", [this]);
            }),
            (l.remove = function () {
                return o && parseFloat(this.layout.options.transitionDuration)
                    ? (this.once("transitionEnd", function () {
                          this.removeElem();
                      }),
                      void this.hide())
                    : void this.removeElem();
            }),
            (l.reveal = function () {
                delete this.isHidden, this.css({ display: "" });
                var t = this.layout.options,
                    e = {};
                (e[this.getHideRevealTransitionEndProperty("visibleStyle")] = this.onRevealTransitionEnd), this.transition({ from: t.hiddenStyle, to: t.visibleStyle, isCleaning: !0, onTransitionEnd: e });
            }),
            (l.onRevealTransitionEnd = function () {
                this.isHidden || this.emitEvent("reveal");
            }),
            (l.getHideRevealTransitionEndProperty = function (t) {
                var e = this.layout.options[t];
                if (e.opacity) return "opacity";
                for (var n in e) return n;
            }),
            (l.hide = function () {
                (this.isHidden = !0), this.css({ display: "" });
                var t = this.layout.options,
                    e = {};
                (e[this.getHideRevealTransitionEndProperty("hiddenStyle")] = this.onHideTransitionEnd), this.transition({ from: t.visibleStyle, to: t.hiddenStyle, isCleaning: !0, onTransitionEnd: e });
            }),
            (l.onHideTransitionEnd = function () {
                this.isHidden && (this.css({ display: "none" }), this.emitEvent("hide"));
            }),
            (l.destroy = function () {
                this.css({ position: "", left: "", right: "", top: "", bottom: "", transition: "", transform: "" });
            }),
            n
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("outlayer/outlayer", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item"], function (n, i, o, r) {
                  return e(t, n, i, o, r);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = e(t, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./item")))
            : (t.Outlayer = e(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, t.Outlayer.Item));
    })(window, function (t, e, n, i, o) {
        function r(t, e) {
            var n = i.getQueryElement(t);
            if (n) {
                (this.element = n), l && (this.$element = l(this.element)), (this.options = i.extend({}, this.constructor.defaults)), this.option(e);
                var o = ++c;
                (this.element.outlayerGUID = o), (d[o] = this), this._create(), this._getOption("initLayout") && this.layout();
            } else a && a.error("Bad element for " + this.constructor.namespace + ": " + (n || t));
        }
        function s(t) {
            function e() {
                t.apply(this, arguments);
            }
            return (e.prototype = Object.create(t.prototype)), (e.prototype.constructor = e), e;
        }
        var a = t.console,
            l = t.jQuery,
            u = function () {},
            c = 0,
            d = {};
        (r.namespace = "outlayer"),
            (r.Item = o),
            (r.defaults = {
                containerStyle: { position: "relative" },
                initLayout: !0,
                originLeft: !0,
                originTop: !0,
                resize: !0,
                resizeContainer: !0,
                transitionDuration: "0.4s",
                hiddenStyle: { opacity: 0, transform: "scale(0.001)" },
                visibleStyle: { opacity: 1, transform: "scale(1)" },
            });
        var p = r.prototype;
        i.extend(p, e.prototype),
            (p.option = function (t) {
                i.extend(this.options, t);
            }),
            (p._getOption = function (t) {
                var e = this.constructor.compatOptions[t];
                return e && void 0 !== this.options[e] ? this.options[e] : this.options[t];
            }),
            (r.compatOptions = {
                initLayout: "isInitLayout",
                horizontal: "isHorizontal",
                layoutInstant: "isLayoutInstant",
                originLeft: "isOriginLeft",
                originTop: "isOriginTop",
                resize: "isResizeBound",
                resizeContainer: "isResizingContainer",
            }),
            (p._create = function () {
                this.reloadItems(), (this.stamps = []), this.stamp(this.options.stamp), i.extend(this.element.style, this.options.containerStyle), this._getOption("resize") && this.bindResize();
            }),
            (p.reloadItems = function () {
                this.items = this._itemize(this.element.children);
            }),
            (p._itemize = function (t) {
                for (var e = this._filterFindItemElements(t), n = this.constructor.Item, i = [], o = 0; o < e.length; o++) {
                    var r = new n(e[o], this);
                    i.push(r);
                }
                return i;
            }),
            (p._filterFindItemElements = function (t) {
                return i.filterFindElements(t, this.options.itemSelector);
            }),
            (p.getItemElements = function () {
                return this.items.map(function (t) {
                    return t.element;
                });
            }),
            (p.layout = function () {
                this._resetLayout(), this._manageStamps();
                var t = this._getOption("layoutInstant"),
                    e = void 0 !== t ? t : !this._isLayoutInited;
                this.layoutItems(this.items, e), (this._isLayoutInited = !0);
            }),
            (p._init = p.layout),
            (p._resetLayout = function () {
                this.getSize();
            }),
            (p.getSize = function () {
                this.size = n(this.element);
            }),
            (p._getMeasurement = function (t, e) {
                var i,
                    o = this.options[t];
                o ? ("string" == typeof o ? (i = this.element.querySelector(o)) : o instanceof HTMLElement && (i = o), (this[t] = i ? n(i)[e] : o)) : (this[t] = 0);
            }),
            (p.layoutItems = function (t, e) {
                (t = this._getItemsForLayout(t)), this._layoutItems(t, e), this._postLayout();
            }),
            (p._getItemsForLayout = function (t) {
                return t.filter(function (t) {
                    return !t.isIgnored;
                });
            }),
            (p._layoutItems = function (t, e) {
                if ((this._emitCompleteOnItems("layout", t), t && t.length)) {
                    var n = [];
                    t.forEach(function (t) {
                        var i = this._getItemLayoutPosition(t);
                        (i.item = t), (i.isInstant = e || t.isLayoutInstant), n.push(i);
                    }, this),
                        this._processLayoutQueue(n);
                }
            }),
            (p._getItemLayoutPosition = function () {
                return { x: 0, y: 0 };
            }),
            (p._processLayoutQueue = function (t) {
                this.updateStagger(),
                    t.forEach(function (t, e) {
                        this._positionItem(t.item, t.x, t.y, t.isInstant, e);
                    }, this);
            }),
            (p.updateStagger = function () {
                var t = this.options.stagger;
                return null == t
                    ? void (this.stagger = 0)
                    : ((this.stagger = (function (t) {
                          if ("number" == typeof t) return t;
                          var e = t.match(/(^\d*\.?\d*)(\w*)/),
                              n = e && e[1],
                              i = e && e[2];
                          return n.length ? (n = parseFloat(n)) * (h[i] || 1) : 0;
                      })(t)),
                      this.stagger);
            }),
            (p._positionItem = function (t, e, n, i, o) {
                i ? t.goTo(e, n) : (t.stagger(o * this.stagger), t.moveTo(e, n));
            }),
            (p._postLayout = function () {
                this.resizeContainer();
            }),
            (p.resizeContainer = function () {
                if (this._getOption("resizeContainer")) {
                    var t = this._getContainerSize();
                    t && (this._setContainerMeasure(t.width, !0), this._setContainerMeasure(t.height, !1));
                }
            }),
            (p._getContainerSize = u),
            (p._setContainerMeasure = function (t, e) {
                if (void 0 !== t) {
                    var n = this.size;
                    n.isBorderBox && (t += e ? n.paddingLeft + n.paddingRight + n.borderLeftWidth + n.borderRightWidth : n.paddingBottom + n.paddingTop + n.borderTopWidth + n.borderBottomWidth),
                        (t = Math.max(t, 0)),
                        (this.element.style[e ? "width" : "height"] = t + "px");
                }
            }),
            (p._emitCompleteOnItems = function (t, e) {
                function n() {
                    o.dispatchEvent(t + "Complete", null, [e]);
                }
                function i() {
                    ++s == r && n();
                }
                var o = this,
                    r = e.length;
                if (e && r) {
                    var s = 0;
                    e.forEach(function (e) {
                        e.once(t, i);
                    });
                } else n();
            }),
            (p.dispatchEvent = function (t, e, n) {
                var i = e ? [e].concat(n) : n;
                if ((this.emitEvent(t, i), l))
                    if (((this.$element = this.$element || l(this.element)), e)) {
                        var o = l.Event(e);
                        (o.type = t), this.$element.trigger(o, n);
                    } else this.$element.trigger(t, n);
            }),
            (p.ignore = function (t) {
                var e = this.getItem(t);
                e && (e.isIgnored = !0);
            }),
            (p.unignore = function (t) {
                var e = this.getItem(t);
                e && delete e.isIgnored;
            }),
            (p.stamp = function (t) {
                (t = this._find(t)) && ((this.stamps = this.stamps.concat(t)), t.forEach(this.ignore, this));
            }),
            (p.unstamp = function (t) {
                (t = this._find(t)) &&
                    t.forEach(function (t) {
                        i.removeFrom(this.stamps, t), this.unignore(t);
                    }, this);
            }),
            (p._find = function (t) {
                return t ? ("string" == typeof t && (t = this.element.querySelectorAll(t)), (t = i.makeArray(t))) : void 0;
            }),
            (p._manageStamps = function () {
                this.stamps && this.stamps.length && (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this));
            }),
            (p._getBoundingRect = function () {
                var t = this.element.getBoundingClientRect(),
                    e = this.size;
                this._boundingRect = {
                    left: t.left + e.paddingLeft + e.borderLeftWidth,
                    top: t.top + e.paddingTop + e.borderTopWidth,
                    right: t.right - (e.paddingRight + e.borderRightWidth),
                    bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth),
                };
            }),
            (p._manageStamp = u),
            (p._getElementOffset = function (t) {
                var e = t.getBoundingClientRect(),
                    i = this._boundingRect,
                    o = n(t);
                return { left: e.left - i.left - o.marginLeft, top: e.top - i.top - o.marginTop, right: i.right - e.right - o.marginRight, bottom: i.bottom - e.bottom - o.marginBottom };
            }),
            (p.handleEvent = i.handleEvent),
            (p.bindResize = function () {
                t.addEventListener("resize", this), (this.isResizeBound = !0);
            }),
            (p.unbindResize = function () {
                t.removeEventListener("resize", this), (this.isResizeBound = !1);
            }),
            (p.onresize = function () {
                this.resize();
            }),
            i.debounceMethod(r, "onresize", 100),
            (p.resize = function () {
                this.isResizeBound && this.needsResizeLayout() && this.layout();
            }),
            (p.needsResizeLayout = function () {
                var t = n(this.element);
                return this.size && t && t.innerWidth !== this.size.innerWidth;
            }),
            (p.addItems = function (t) {
                var e = this._itemize(t);
                return e.length && (this.items = this.items.concat(e)), e;
            }),
            (p.appended = function (t) {
                var e = this.addItems(t);
                e.length && (this.layoutItems(e, !0), this.reveal(e));
            }),
            (p.prepended = function (t) {
                var e = this._itemize(t);
                if (e.length) {
                    var n = this.items.slice(0);
                    (this.items = e.concat(n)), this._resetLayout(), this._manageStamps(), this.layoutItems(e, !0), this.reveal(e), this.layoutItems(n);
                }
            }),
            (p.reveal = function (t) {
                if ((this._emitCompleteOnItems("reveal", t), t && t.length)) {
                    var e = this.updateStagger();
                    t.forEach(function (t, n) {
                        t.stagger(n * e), t.reveal();
                    });
                }
            }),
            (p.hide = function (t) {
                if ((this._emitCompleteOnItems("hide", t), t && t.length)) {
                    var e = this.updateStagger();
                    t.forEach(function (t, n) {
                        t.stagger(n * e), t.hide();
                    });
                }
            }),
            (p.revealItemElements = function (t) {
                var e = this.getItems(t);
                this.reveal(e);
            }),
            (p.hideItemElements = function (t) {
                var e = this.getItems(t);
                this.hide(e);
            }),
            (p.getItem = function (t) {
                for (var e = 0; e < this.items.length; e++) {
                    var n = this.items[e];
                    if (n.element == t) return n;
                }
            }),
            (p.getItems = function (t) {
                t = i.makeArray(t);
                var e = [];
                return (
                    t.forEach(function (t) {
                        var n = this.getItem(t);
                        n && e.push(n);
                    }, this),
                    e
                );
            }),
            (p.remove = function (t) {
                var e = this.getItems(t);
                this._emitCompleteOnItems("remove", e),
                    e &&
                        e.length &&
                        e.forEach(function (t) {
                            t.remove(), i.removeFrom(this.items, t);
                        }, this);
            }),
            (p.destroy = function () {
                var t = this.element.style;
                (t.height = ""),
                    (t.position = ""),
                    (t.width = ""),
                    this.items.forEach(function (t) {
                        t.destroy();
                    }),
                    this.unbindResize();
                var e = this.element.outlayerGUID;
                delete d[e], delete this.element.outlayerGUID, l && l.removeData(this.element, this.constructor.namespace);
            }),
            (r.data = function (t) {
                var e = (t = i.getQueryElement(t)) && t.outlayerGUID;
                return e && d[e];
            }),
            (r.create = function (t, e) {
                var n = s(r);
                return (
                    (n.defaults = i.extend({}, r.defaults)),
                    i.extend(n.defaults, e),
                    (n.compatOptions = i.extend({}, r.compatOptions)),
                    (n.namespace = t),
                    (n.data = r.data),
                    (n.Item = s(o)),
                    i.htmlInit(n, t),
                    l && l.bridget && l.bridget(t, n),
                    n
                );
            });
        var h = { ms: 1, s: 1e3 };
        return (r.Item = o), r;
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define(["outlayer/outlayer", "get-size/get-size"], e)
            : "object" == typeof module && module.exports
            ? (module.exports = e(require("outlayer"), require("get-size")))
            : (t.Masonry = e(t.Outlayer, t.getSize));
    })(window, function (t, e) {
        var n = t.create("masonry");
        n.compatOptions.fitWidth = "isFitWidth";
        var i = n.prototype;
        return (
            (i._resetLayout = function () {
                this.getSize(), this._getMeasurement("columnWidth", "outerWidth"), this._getMeasurement("gutter", "outerWidth"), this.measureColumns(), (this.colYs = []);
                for (var t = 0; t < this.cols; t++) this.colYs.push(0);
                (this.maxY = 0), (this.horizontalColIndex = 0);
            }),
            (i.measureColumns = function () {
                if ((this.getContainerWidth(), !this.columnWidth)) {
                    var t = this.items[0],
                        n = t && t.element;
                    this.columnWidth = (n && e(n).outerWidth) || this.containerWidth;
                }
                var i = (this.columnWidth += this.gutter),
                    o = this.containerWidth + this.gutter,
                    r = o / i,
                    s = i - (o % i);
                (r = Math[s && 1 > s ? "round" : "floor"](r)), (this.cols = Math.max(r, 1));
            }),
            (i.getContainerWidth = function () {
                var t = this._getOption("fitWidth") ? this.element.parentNode : this.element,
                    n = e(t);
                this.containerWidth = n && n.innerWidth;
            }),
            (i._getItemLayoutPosition = function (t) {
                t.getSize();
                var e = t.size.outerWidth % this.columnWidth,
                    n = Math[e && 1 > e ? "round" : "ceil"](t.size.outerWidth / this.columnWidth);
                n = Math.min(n, this.cols);
                for (var i = this[this.options.horizontalOrder ? "_getHorizontalColPosition" : "_getTopColPosition"](n, t), o = { x: this.columnWidth * i.col, y: i.y }, r = i.y + t.size.outerHeight, s = n + i.col, a = i.col; s > a; a++)
                    this.colYs[a] = r;
                return o;
            }),
            (i._getTopColPosition = function (t) {
                var e = this._getTopColGroup(t),
                    n = Math.min.apply(Math, e);
                return { col: e.indexOf(n), y: n };
            }),
            (i._getTopColGroup = function (t) {
                if (2 > t) return this.colYs;
                for (var e = [], n = this.cols + 1 - t, i = 0; n > i; i++) e[i] = this._getColGroupY(i, t);
                return e;
            }),
            (i._getColGroupY = function (t, e) {
                if (2 > e) return this.colYs[t];
                var n = this.colYs.slice(t, t + e);
                return Math.max.apply(Math, n);
            }),
            (i._getHorizontalColPosition = function (t, e) {
                var n = this.horizontalColIndex % this.cols;
                n = t > 1 && n + t > this.cols ? 0 : n;
                var i = e.size.outerWidth && e.size.outerHeight;
                return (this.horizontalColIndex = i ? n + t : this.horizontalColIndex), { col: n, y: this._getColGroupY(n, t) };
            }),
            (i._manageStamp = function (t) {
                var n = e(t),
                    i = this._getElementOffset(t),
                    o = this._getOption("originLeft") ? i.left : i.right,
                    r = o + n.outerWidth,
                    s = Math.floor(o / this.columnWidth);
                s = Math.max(0, s);
                var a = Math.floor(r / this.columnWidth);
                (a -= r % this.columnWidth ? 0 : 1), (a = Math.min(this.cols - 1, a));
                for (var l = (this._getOption("originTop") ? i.top : i.bottom) + n.outerHeight, u = s; a >= u; u++) this.colYs[u] = Math.max(l, this.colYs[u]);
            }),
            (i._getContainerSize = function () {
                this.maxY = Math.max.apply(Math, this.colYs);
                var t = { height: this.maxY };
                return this._getOption("fitWidth") && (t.width = this._getContainerFitWidth()), t;
            }),
            (i._getContainerFitWidth = function () {
                for (var t = 0, e = this.cols; --e && 0 === this.colYs[e]; ) t++;
                return (this.cols - t) * this.columnWidth - this.gutter;
            }),
            (i.needsResizeLayout = function () {
                var t = this.containerWidth;
                return this.getContainerWidth(), t != this.containerWidth;
            }),
            n
        );
    }),
    (function (t, e, n) {
        function i(t, e) {
            return typeof t === e;
        }
        function o() {
            return "function" != typeof e.createElement ? e.createElement(arguments[0]) : b ? e.createElementNS.call(e, "http://www.w3.org/2000/svg", arguments[0]) : e.createElement.apply(e, arguments);
        }
        function r(t, n, i, r) {
            var s,
                a,
                l,
                u,
                c = "modernizr",
                d = o("div"),
                p = (function () {
                    var t = e.body;
                    return t || ((t = o(b ? "svg" : "body")).fake = !0), t;
                })();
            if (parseInt(i, 10)) for (; i--; ) ((l = o("div")).id = r ? r[i] : c + (i + 1)), d.appendChild(l);
            return (
                ((s = o("style")).type = "text/css"),
                (s.id = "s" + c),
                (p.fake ? p : d).appendChild(s),
                p.appendChild(d),
                s.styleSheet ? (s.styleSheet.cssText = t) : s.appendChild(e.createTextNode(t)),
                (d.id = c),
                p.fake && ((p.style.background = ""), (p.style.overflow = "hidden"), (u = w.style.overflow), (w.style.overflow = "hidden"), w.appendChild(p)),
                (a = n(d, t)),
                p.fake ? (p.parentNode.removeChild(p), (w.style.overflow = u), w.offsetHeight) : d.parentNode.removeChild(d),
                !!a
            );
        }
        function s(t, e) {
            return !!~("" + t).indexOf(e);
        }
        function a(t) {
            return t
                .replace(/([a-z])-([a-z])/g, function (t, e, n) {
                    return e + n.toUpperCase();
                })
                .replace(/^-/, "");
        }
        function l(t, e) {
            return function () {
                return t.apply(e, arguments);
            };
        }
        function u(t) {
            return t
                .replace(/([A-Z])/g, function (t, e) {
                    return "-" + e.toLowerCase();
                })
                .replace(/^ms-/, "-ms-");
        }
        function c(e, n, i) {
            var o;
            if ("getComputedStyle" in t) {
                o = getComputedStyle.call(t, e, n);
                var r = t.console;
                if (null !== o) i && (o = o.getPropertyValue(i));
                else if (r) {
                    r[r.error ? "error" : "log"].call(r, "getComputedStyle returning null, its possible modernizr test results are inaccurate");
                }
            } else o = !n && e.currentStyle && e.currentStyle[i];
            return o;
        }
        function d(e, i) {
            var o = e.length;
            if ("CSS" in t && "supports" in t.CSS) {
                for (; o--; ) if (t.CSS.supports(u(e[o]), i)) return !0;
                return !1;
            }
            if ("CSSSupportsRule" in t) {
                for (var s = []; o--; ) s.push("(" + u(e[o]) + ":" + i + ")");
                return r("@supports (" + (s = s.join(" or ")) + ") { #modernizr { position: absolute; } }", function (t) {
                    return "absolute" == c(t, null, "position");
                });
            }
            return n;
        }
        function p(t, e, r, l) {
            function u() {
                p && (delete E.style, delete E.modElem);
            }
            if (((l = !i(l, "undefined") && l), !i(r, "undefined"))) {
                var c = d(t, r);
                if (!i(c, "undefined")) return c;
            }
            for (var p, h, f, m, g, v = ["modernizr", "tspan", "samp"]; !E.style && v.length; ) (p = !0), (E.modElem = o(v.shift())), (E.style = E.modElem.style);
            for (f = t.length, h = 0; f > h; h++)
                if (((m = t[h]), (g = E.style[m]), s(m, "-") && (m = a(m)), E.style[m] !== n)) {
                    if (l || i(r, "undefined")) return u(), "pfx" != e || m;
                    try {
                        E.style[m] = r;
                    } catch (t) {}
                    if (E.style[m] != g) return u(), "pfx" != e || m;
                }
            return u(), !1;
        }
        function h(t, e, n, o, r) {
            var s = t.charAt(0).toUpperCase() + t.slice(1),
                a = (t + " " + k.join(s + " ") + s).split(" ");
            return i(e, "string") || i(e, "undefined")
                ? p(a, e, o, r)
                : (function (t, e, n) {
                      var o;
                      for (var r in t) if (t[r] in e) return !1 === n ? t[r] : i((o = e[t[r]]), "function") ? l(o, n || e) : o;
                      return !1;
                  })((a = (t + " " + T.join(s + " ") + s).split(" ")), e, n);
        }
        function f(t, e, i) {
            return h(t, n, n, e, i);
        }
        var m = [],
            g = [],
            v = {
                _version: "3.5.0",
                _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 },
                _q: [],
                on: function (t, e) {
                    var n = this;
                    setTimeout(function () {
                        e(n[t]);
                    }, 0);
                },
                addTest: function (t, e, n) {
                    g.push({ name: t, fn: e, options: n });
                },
                addAsyncTest: function (t) {
                    g.push({ name: null, fn: t });
                },
            },
            y = function () {};
        (y.prototype = v),
            (y = new y()).addTest("localstorage", function () {
                var t = "modernizr";
                try {
                    return localStorage.setItem(t, t), localStorage.removeItem(t), !0;
                } catch (t) {
                    return !1;
                }
            });
        var w = e.documentElement,
            b = "svg" === w.nodeName.toLowerCase(),
            x = v._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
        v._prefixes = x;
        var _ = (v.testStyles = r);
        y.addTest("touchevents", function () {
            var n;
            if ("ontouchstart" in t || (t.DocumentTouch && e instanceof DocumentTouch)) n = !0;
            else {
                var i = ["@media (", x.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");
                _(i, function (t) {
                    n = 9 === t.offsetTop;
                });
            }
            return n;
        });
        var C = "Moz O ms Webkit",
            k = v._config.usePrefixes ? C.split(" ") : [];
        v._cssomPrefixes = k;
        var T = v._config.usePrefixes ? C.toLowerCase().split(" ") : [];
        v._domPrefixes = T;
        var S = { elem: o("modernizr") };
        y._q.push(function () {
            delete S.elem;
        });
        var E = { style: S.elem.style };
        y._q.unshift(function () {
            delete E.style;
        }),
            (v.testAllProps = h),
            (v.testAllProps = f),
            y.addTest("cssgridlegacy", f("grid-columns", "10px", !0)),
            y.addTest("cssgrid", f("grid-template-rows", "none", !0)),
            (function () {
                var t, e, n, o, r, s;
                for (var a in g)
                    if (g.hasOwnProperty(a)) {
                        if (((t = []), (e = g[a]).name && (t.push(e.name.toLowerCase()), e.options && e.options.aliases && e.options.aliases.length)))
                            for (n = 0; n < e.options.aliases.length; n++) t.push(e.options.aliases[n].toLowerCase());
                        for (o = i(e.fn, "function") ? e.fn() : e.fn, r = 0; r < t.length; r++)
                            1 === (s = t[r].split(".")).length ? (y[s[0]] = o) : (!y[s[0]] || y[s[0]] instanceof Boolean || (y[s[0]] = new Boolean(y[s[0]])), (y[s[0]][s[1]] = o)), m.push((o ? "" : "no-") + s.join("-"));
                    }
            })(),
            (function (t) {
                var e = w.className,
                    n = y._config.classPrefix || "";
                if ((b && (e = e.baseVal), y._config.enableJSClass)) {
                    var i = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
                    e = e.replace(i, "$1" + n + "js$2");
                }
                y._config.enableClasses && ((e += " " + n + t.join(" " + n)), b ? (w.className.baseVal = e) : (w.className = e));
            })(m),
            delete v.addTest,
            delete v.addAsyncTest;
        for (var I = 0; I < y._q.length; I++) y._q[I]();
        t.Modernizr = y;
    })(window, document),
    function () {
        var t,
            e = function (t, e) {
                return function () {
                    return t.apply(e, arguments);
                };
            },
            n = function (t, e) {
                function n() {
                    this.constructor = t;
                }
                for (var o in e) i.call(e, o) && (t[o] = e[o]);
                return (n.prototype = e.prototype), (t.prototype = new n()), (t.__super__ = e.prototype), t;
            },
            i = {}.hasOwnProperty;
        (theme.classes.FrameworkA11y = (function () {
            function t() {
                var t;
                ((t = this).tab_forwards = null), (t.focusable_items = null), t.customFocusOrder();
            }
            return (
                (t.prototype.customFocusOrder = function () {
                    var t, e;
                    return (
                        (t = this),
                        (e = $(".a11y--focus-trigger")).attr("tabindex", "0"),
                        $(document).on("keydown", function (e) {
                            return (t.tab_forwards = !0), 9 === e.which && e.shiftKey && (t.tab_forwards = !1), !0;
                        }),
                        e.on("focus", function () {
                            var e, n;
                            return (
                                (e = $(this)),
                                t.getFocusableItems(),
                                t.tab_forwards
                                    ? ((n = e.attr("data-forward-to")), $(n).is(".a11y--focus-trigger") && (e = $(n)), (n = e.attr("data-forward-to")))
                                    : !1 === t.tab_forwards && ((n = e.attr("data-back-to")), $(n).is(".a11y--focus-trigger") && (e = $(n)), (n = e.attr("data-back-to"))),
                                (t.focus_index = t.focusable_items.index(e)),
                                t.moveFocus(n)
                            );
                        })
                    );
                }),
                (t.prototype.getFocusableItems = function () {
                    return this, (this.focusable_items = $(":focusable"));
                }),
                (t.prototype.moveFocus = function (t) {
                    var e, n, i, o;
                    return (
                        (i = !!t),
                        (o = (e = this).focusable_items.index($(t + ":visible")) > -1),
                        (n = e.tab_forwards ? 1 : -1),
                        i && o
                            ? $(t).focus()
                            : i && !o
                            ? e.tab_forwards
                                ? $(t).find(":focusable:not(.a11y--focus-trigger)").first().focus()
                                : $(t).find(":focusable:not(.a11y--focus-trigger)").last().focus()
                            : i
                            ? void 0
                            : e.focusable_items.eq(e.focus_index + n).focus()
                    );
                }),
                t
            );
        })()),
            (t = (function () {
                function t(t, n) {
                    (this.element = t),
                        (this.type = n),
                        (this.resizeListeners = e(this.resizeListeners, this)),
                        (this.fillYSpace = e(this.fillYSpace, this)),
                        (this.checkOverlap = e(this.checkOverlap, this)),
                        (this.createOverlapDetectors = e(this.createOverlapDetectors, this)),
                        (this.position = e(this.position, this)),
                        (this.parent = this.element.parent()),
                        this.left_side_border,
                        (this.right_element_width = null),
                        this.position(),
                        this.fillYSpace(),
                        this.createOverlapDetectors(),
                        this.resizeListeners();
                }
                return (
                    (t.prototype.position = function () {
                        if ("center-x" === this.type) return this.element.css({ "margin-left": -this.element.outerWidth() / 2 });
                    }),
                    (t.prototype.createOverlapDetectors = function () {
                        if ((this, "right" === this.type)) return (this.right_element_width = this.element.outerWidth());
                    }),
                    (t.prototype.checkOverlap = function () {
                        var t, e;
                        if ("right" === (t = this).type && (t.parent.removeClass("overlap"), (e = t.parent.children().eq(t.element.index() - 1)).position().left + e.outerWidth() >= t.parent.outerWidth() - t.right_element_width))
                            return t.parent.addClass("overlap");
                    }),
                    (t.prototype.fillYSpace = function () {
                        var t, e, n;
                        if ("fill-y--dynamic" === (t = this).type) return (e = t.parent.outerHeight()), (n = t.parent.find(".fw--align--fill-y--fixed").outerHeight()), t.element.outerHeight(e - n);
                    }),
                    (t.prototype.resizeListeners = function () {
                        var t;
                        return (
                            (t = this),
                            $(window).on("resize.FrameworkAlign", function () {
                                return t.checkOverlap(), t.fillYSpace();
                            }),
                            setTimeout(function () {
                                return t.checkOverlap();
                            }, 1)
                        );
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkAnimation = function () {}),
            (theme.classes.FrameworkArticle = (function () {
                function t(t) {
                    (this.root = t), (this.startDisqus = e(this.startDisqus, this)), (this.hideTagInfo = e(this.hideTagInfo, this)), (this.load = e(this.load, this)), this.load();
                }
                return (
                    (t.prototype.load = function () {
                        var t, e, n;
                        if ((this, (n = 0 === $(".article--tag").length), (e = "true" === $(".article--root").attr("data-enable-disqus")), (t = "true" === $(".article--root").attr("data-comments-enabled")), n && this.hideTagInfo(), e && t))
                            return this.startDisqus();
                    }),
                    (t.prototype.hideTagInfo = function () {
                        return $(".article--tag-info").hide();
                    }),
                    (t.prototype.startDisqus = function () {
                        var t;
                        return (
                            this,
                            (t = $(".article--root").attr("data-disqus-shortname")),
                            (function () {
                                var e;
                                return ((e = document.createElement("script")).src = "https://" + t + ".disqus.com/embed.js"), e.setAttribute("data-timestamp", +new Date()), (document.head || document.body).appendChild(e);
                            })()
                        );
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkBlog = (function () {
                function t(t) {
                    (this.root = t), (this.initMasonry = e(this.initMasonry, this)), (this.eventListeners = e(this.eventListeners, this)), (this.load = e(this.load, this)), this.load();
                }
                return (
                    (t.prototype.load = function () {
                        var t;
                        if (((t = this).eventListeners(), (t.has_multi_columns = "1" !== t.root.attr("data-columns")), "small" !== theme.utils.mqs.current_window && t.has_multi_columns))
                            return (
                                t.initMasonry(),
                                $(window).on("load", function () {
                                    return t.initMasonry();
                                })
                            );
                    }),
                    (t.prototype.eventListeners = function () {
                        var t;
                        return (
                            (t = this),
                            $(window).on(
                                "resize.Blog",
                                theme.utils.debounce(100, function () {
                                    return t.has_multi_columns && "small" !== theme.utils.mqs.current_window ? t.initMasonry() : $(".blog--list").masonry("destroy");
                                })
                            )
                        );
                    }),
                    (t.prototype.initMasonry = function () {
                        return $(".blog--list").masonry({ itemSelector: ".blog--list--item", percentPosition: !0, horizontalOrder: !0, columnWidth: ".blog--list--item" });
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkCart = (function () {
                function t(t) {
                    var n;
                    (this.root = t),
                        (this.renderDynamicCheckoutButtons = e(this.renderDynamicCheckoutButtons, this)),
                        (this.updateTotals = e(this.updateTotals, this)),
                        (this.updateAllHasItems = e(this.updateAllHasItems, this)),
                        (this.addItem = e(this.addItem, this)),
                        (this.swapInImages = e(this.swapInImages, this)),
                        (this.getHtml = e(this.getHtml, this)),
                        (this.updateHtml = e(this.updateHtml, this)),
                        (this.htmlListener = e(this.htmlListener, this)),
                        (this.updateAllHtml = e(this.updateAllHtml, this)),
                        (this.updateNote = e(this.updateNote, this)),
                        (this.noteTypingListener = e(this.noteTypingListener, this)),
                        (this.updateQuantity = e(this.updateQuantity, this)),
                        (this.clearRequests = e(this.clearRequests, this)),
                        (this.removeItem = e(this.removeItem, this)),
                        (this.removeButtonListener = e(this.removeButtonListener, this)),
                        (this.minusButtonListener = e(this.minusButtonListener, this)),
                        (this.plusButtonListener = e(this.plusButtonListener, this)),
                        (this.inputBoxListener = e(this.inputBoxListener, this)),
                        (this.frequencyListener = e(this.frequencyListener, this)),
                        (this.eventListeners = e(this.eventListeners, this)),
                        (this.getAjaxUrl = e(this.getAjaxUrl, this)),
                        (this.getOtherCarts = e(this.getOtherCarts, this)),
                        ((n = this).other_carts = n.getOtherCarts()),
                        (n.quantity_request = {}),
                        (n.quantity_timer = {}),
                        (n.total_item_count = $(".cart--external--total-items")),
                        (n.total_price = $(".cart--external--total-price")),
                        (n.view = n.root.attr("data-view")),
                        n.getAjaxUrl(),
                        n.updateTotals(),
                        n.htmlListener(),
                        n.eventListeners(),
                        n.renderDynamicCheckoutButtons();
                }
                return (
                    (t.prototype.getOtherCarts = function () {
                        return this, $('[data-js-class="Cart"]').not(this.root);
                    }),
                    (t.prototype.getAjaxUrl = function () {
                        var t;
                        return (
                            ((t = this).ajax_url = window.location.href),
                            (t.ajax_url = t.ajax_url.replace(window.location.hostname + window.location.pathname, window.location.hostname + theme.urls.cart)),
                            (t.ajax_url = t.ajax_url.replace("#", "")),
                            t.ajax_url.indexOf("?") >= 0 ? (t.ajax_url = t.ajax_url + "&") : (t.ajax_url = t.ajax_url + "?"),
                            (t.ajax_desktop_url = t.ajax_url + "view=ajax--desktop"),
                            (t.ajax_mobile_url = t.ajax_url + "view=ajax--mobile")
                        );
                    }),
                    (t.prototype.eventListeners = function () {
                        var t;
                        return (t = this).inputBoxListener(), t.plusButtonListener(), t.minusButtonListener(), t.removeButtonListener(), t.noteTypingListener(), t.frequencyListener();
                    }),
                    (t.prototype.inputBoxListener = function () {
                        var t, e;
                        return (
                            (e = (t = this).root.find(".cart--quantity--input")).on("keydown", function (t) {
                                if ((t.which < 48 || t.which > 57) && 8 !== t.which && 37 !== t.which && 39 !== t.which && 9 !== t.which) return t.preventDefault();
                            }),
                            e.on("keyup", function (e) {
                                var n, i;
                                if (($(this).attr("data-loading", "true"), (n = $(this).closest(".cart--item").data("item-key")), t.clearRequests(n), 8 !== e.which || 0 !== $(this).val().length))
                                    return 0 !== (i = theme.utils.isNaN(parseInt($(this).val())) ? 1 : parseInt($(this).val()))
                                        ? t.updateQuantity(n, i, 700, function (e) {
                                              if (e) return t.updateAllHtml(function () {});
                                          })
                                        : t.removeItem(n);
                            })
                        );
                    }),
                    (t.prototype.plusButtonListener = function () {
                        var t;
                        return (t = this).root.find(".cart--item--quantity .plus").on("click", function () {
                            var e, n, i;
                            return (
                                (e = $(this).prev("input")),
                                (i = theme.utils.isNaN(parseInt(e.val())) ? 1 : parseInt(e.val()) + 1),
                                e.val(i),
                                e.attr("data-loading", "true"),
                                (n = $(this).closest(".cart--item").data("item-key")),
                                t.clearRequests(n),
                                t.updateQuantity(n, i, 700, function (e) {
                                    if (e) return t.updateAllHtml(function () {});
                                }),
                                !1
                            );
                        });
                    }),
                    (t.prototype.minusButtonListener = function () {
                        var t;
                        return (t = this).root.find(".cart--item--quantity .minus").on("click", function () {
                            var e, n, i;
                            return (
                                (e = $(this).siblings("input")),
                                (i = theme.utils.isNaN(parseInt(e.val())) ? 1 : parseInt(e.val()) - 1) < 1
                                    ? ((i = 1), !1)
                                    : (e.val(i),
                                      e.attr("data-loading", "true"),
                                      (n = $(this).closest(".cart--item").data("item-key")),
                                      t.clearRequests(n),
                                      t.updateQuantity(n, i, 700, function (e) {
                                          if (e) return t.updateAllHtml(function () {});
                                      }),
                                      !1)
                            );
                        });
                    }),
                    (t.prototype.frequencyListener = function () {
                        var t;
                        return (t = this).root.find(".frequency-selector").on("change", function () {
                            var e, n, i;
                            return (
                                (e = $(this).closest(".cart--item").find("input[name='updates[]']")),
                                (i = theme.utils.isNaN(parseInt(e.val())) ? 1 : parseInt(e.val())) < 1
                                    ? ((i = 1), !1)
                                    : (e.val(i),
                                      e.attr("data-loading", "true"),
                                      (n = $(this).closest(".cart--item").data("item-key")),
                                      t.clearRequests(n),
                                      t.updateQuantity(n, i, 700, function (e) {
                                          if (e) return t.updateAllHtml(function () {});
                                      }, $(this).val()),
                                      !1)
                            );
                        });
                    }),
                    (t.prototype.removeButtonListener = function () {
                        var t;
                        return (t = this).root.find(".cart--item--remove").on("click", function () {
                            var e, n;
                            return (n = (e = $(this).closest(".cart--item")).data("item-key")), e.find("input").attr("data-loading", "true"), t.clearRequests(n), t.removeItem(n), !1;
                        });
                    }),
                    (t.prototype.removeItem = function (t) {
                        var e;
                        return (e = this).updateQuantity(t, 0, 0, function (t) {
                            if (t) return e.updateAllHtml(function () {});
                        });
                    }),
                    (t.prototype.clearRequests = function (t) {
                        var e;
                        if (((e = this).quantity_request.item_key && e.quantity_request.item_key.abort(), e.quantity_timer.item_key)) return clearTimeout(e.quantity_timer.item_key);
                    }),
                    (t.prototype.updateQuantity = function (t, e, n, i, selling_plan= 0) {
                        var o, r;
                        const dataObj = {};
                        dataObj.type = "POST";
                        dataObj.url = "/cart/change.js";
                        dataObj.dataType = "json";
                      
                        if(selling_plan){
                          dataObj.data = "quantity=" + e + "&id=" + t + "&selling_plan=" + selling_plan;
                        }else{
                          dataObj.data = "quantity=" + e + "&id=" + t;
                        }
                        return (
                            (r = function () {
                                return (o.quantity_request.item_key = $.ajax(dataObj)
                                    .done(function (t, e, n) {
                                        return i(!0), o.updateTotals();
                                    })
                                    .fail(function (t, e) {
                                        return t.responseText && console.log("Error - ajax update quantity", JSON.parse(t.responseText).description), i(!1);
                                    }));
                            }),
                            ((o = this).quantity_timer.item_key = setTimeout(r, n))
                        );
                    }),
                    (t.prototype.noteTypingListener = function () {
                        var t;
                        return (t = this).root.find(".cart--notes--textarea").on("input", function () {
                            return t.note_request && t.note_request.abort(), t.note_timer && clearTimeout(t.note_timer), t.updateNote($(this).val());
                        });
                    }),
                    (t.prototype.updateNote = function (t) {
                        var e, n;
                        return (
                            (n = function () {
                                return (e.note_request = $.ajax({ type: "POST", url: "/cart/update.js", dataType: "json", data: { note: t } })
                                    .done(function () {
                                        return e.other_carts.trigger("update-html");
                                    })
                                    .fail(function (t, e) {
                                        if (t.responseText) return console.log("Error - ajax update note", JSON.parse(t.responseText).description);
                                    }));
                            }),
                            ((e = this).note_timer = setTimeout(n, 350))
                        );
                    }),
                    (t.prototype.updateAllHtml = function (t) {
                        return this, this.updateHtml(t), this.other_carts.trigger("update-html");
                    }),
                    (t.prototype.htmlListener = function () {
                        var t;
                        return (t = this).root.on("update-html", function () {
                            return t.updateHtml(function () {});
                        });
                    }),
                    (t.prototype.updateHtml = function (t) {
                        var e;
                        return (e = this).getHtml(e.view, function (n) {
                            var i, o;
                            return (o = e.root.find(".cart--form")), (i = n.find(".cart--form")), (i = e.swapInImages(o, i)), o.replaceWith(i), e.eventListeners(), t(), $(window).trigger("theme.cart.update-complete");
                        });
                    }),
                    (t.prototype.getHtml = function (t, e) {
                        var n;
                        return (
                            this,
                            (n = this.ajax_desktop_url),
                            "mobile" === t && (n = this.ajax_mobile_url),
                            $.ajax({ url: n, type: "GET", dataType: "html" })
                                .done(function (t) {
                                    var n;
                                    (n = $($.parseHTML(t))), e(n);
                                })
                                .fail(function (t, n, i) {
                                    console.log("search.json Request Failed: " + n + ", " + i), e(!1);
                                })
                        );
                    }),
                    (t.prototype.swapInImages = function (t, e) {
                        return (
                            e.find(".cart--item").each(function () {
                                var n, i, o, r, s;
                                if (
                                    ((s = $(this).attr("data-variant-id")),
                                    (n = $(this).find(".cart--item--image")),
                                    (i = e.find("[data-variant-id='" + s + "'] .cart--item--image").index(n)),
                                    (r = t.find("[data-variant-id='" + s + "']").eq(i)).length > 0)
                                )
                                    return (o = r.find(".cart--item--image")), n.replaceWith(o);
                            }),
                            e
                        );
                    }),
                    (t.prototype.addItem = function (t, e) {
                        var n;
                        return (
                            (n = this),
                            $.ajax({ type: "POST", url: "/cart/add.js", dataType: "json", data: t.serialize() })
                                .done(function (t, i, o) {
                                    return e(!0), n.updateAllHasItems(1, !0), n.updateTotals();
                                })
                                .fail(function (t, n) {
                                    return console.log("Error - ajax update quantity", JSON.parse(t.responseText).description), e(!1, JSON.parse(t.responseText).description);
                                })
                        );
                    }),
                    (t.prototype.updateAllHasItems = function (t, e) {
                        var n;
                        return null == e && (e = !1), this, (n = !1), (t > 0 || e) && (n = !0), this.root.attr("data-has-items", n), this.other_carts.attr("data-has-items", n);
                    }),
                    (t.prototype.updateTotals = function () {
                        var t;
                        return (
                            (t = this),
                            $.ajax({ type: "GET", url: "/cart.js", dataType: "json" })
                                .done(function (e, n, i) {
                                    var o, r;
                                    return (r = theme.utils.formatMoney(e.total_price)), (o = e.item_count), t.updateAllHasItems(o), t.total_price.html(r), t.total_item_count.text(o), t.updateTotalsComplete(o);
                                })
                                .fail(function (t, e) {
                                    return console.log("Error - ajax updating totals", JSON.parse(t.responseText).description);
                                })
                        );
                    }),
                    (t.prototype.renderDynamicCheckoutButtons = function () {
                        if (window.location.pathname === theme.urls.cart && ($(".off-canvas--right-sidebar .cart--additional-buttons").remove(), "small" === theme.utils.mqs.current_window))
                            return $('[data-view="desktop"] .cart--additional-buttons').remove();
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkDisclosure = (function () {
                function t(t) {
                    var n;
                    (this.root = t),
                        (this.optionChangeCallback = e(this.optionChangeCallback, this)),
                        (this.configureFormDisplay = e(this.configureFormDisplay, this)),
                        (this.toggleFormDisplay = e(this.toggleFormDisplay, this)),
                        (this.setOptionOnClick = e(this.setOptionOnClick, this)),
                        (this.hideFormWhenFocusOut = e(this.hideFormWhenFocusOut, this)),
                        (this.showFormWhenClick = e(this.showFormWhenClick, this)),
                        (this.resizeListener = e(this.resizeListener, this)),
                        (this.load = e(this.load, this)),
                        ((n = this).current_option = n.root.find(".disclosure--current-option")),
                        (n.form = n.root.find(".disclosure--form")),
                        (n.input = n.root.find('[data-item="disclosure"]')),
                        (n.links = n.root.find(".disclosure--option-link")),
                        (n.toggle = n.root.find(".disclosure--toggle")),
                        (n.type = n.root.attr("data-type")),
                        (n.toggle_and_form_gap = 8),
                        (n.window_and_form_gap = 32),
                        (n.form_space_needed = n.form.height() + n.toggle_and_form_gap + n.window_and_form_gap),
                        n.load();
                }
                return (
                    (t.prototype.load = function () {
                        var t;
                        if (((t = this).resizeListener(), t.showFormWhenClick(), t.hideFormWhenFocusOut(), t.setOptionOnClick(), t.configureFormDisplay(), "url-redirect" === t.type || "localization" === t.type))
                            return t.optionChangeCallback();
                    }),
                    (t.prototype.resizeListener = function () {
                        var t;
                        return (
                            (t = this),
                            $(window).on(
                                "resize",
                                theme.utils.debounce(100, function () {
                                    return t.configureFormDisplay();
                                })
                            )
                        );
                    }),
                    (t.prototype.showFormWhenClick = function () {
                        var t;
                        return (t = this).toggle.on("click keydown", function (e) {
                            var n;
                            if ("keydown" !== e.type || "Enter" === e.key) return (n = "true" === $(this).attr("aria-expanded")), t.toggleFormDisplay(!n);
                        });
                    }),
                    (t.prototype.hideFormWhenFocusOut = function () {
                        var t;
                        return (
                            (t = this).toggle.on("focusout", function (e) {
                                if (0 === t.root.has(e.relatedTarget).length) return t.toggleFormDisplay(!1);
                            }),
                            t.form.on("focusout", function (e) {
                                var n;
                                if (((n = $(this).has(e.relatedTarget).length > 0), "true" === t.toggle.attr("aria-expanded") && !n)) return t.toggleFormDisplay(!1);
                            }),
                            t.root.on("keydown", function (e) {
                                if ("Escape" === e.key) return t.toggleFormDisplay(!1), t.toggle.focus();
                            })
                        );
                    }),
                    (t.prototype.setOptionOnClick = function () {
                        var t;
                        return (t = this).links.on("click keydown", function (e) {
                            var n, i;
                            if ("Enter" === e.key) t.toggle.focus();
                            else if ("keydown" === e.type) return;
                            return (
                                (i = $(this).attr("data-value")),
                                (n = $(this).text()),
                                t.toggleFormDisplay(!1),
                                t.current_option.text(n),
                                t.links.attr("aria-current", !1),
                                $(this).attr("aria-current", !0),
                                t.input.val(i),
                                t.input.trigger("change")
                            );
                        });
                    }),
                    (t.prototype.toggleFormDisplay = function (t) {
                        return this, this.toggle.attr("aria-expanded", t);
                    }),
                    (t.prototype.configureFormDisplay = function () {
                        var t, e, n, i, o, r, s, a;
                        return (
                            (e = (s = (t = this).toggle.outerHeight()) + t.toggle_and_form_gap),
                            (o = t.root.closest("[class^=off-canvas]").height() - (r = t.root.offset().top) - s),
                            (n = t.form_space_needed > o && o < r),
                            (i = t.form_space_needed > r && o > r),
                            (a = $(window).height() - e - t.window_and_form_gap),
                            n ? (a -= o) : i && (a -= r),
                            t.form.css("max-height", a + "px"),
                            n ? t.form.css("top", "-" + (t.form.height() + t.toggle_and_form_gap) + "px") : t.form.css("top", e + "px")
                        );
                    }),
                    (t.prototype.optionChangeCallback = function () {
                        var t;
                        return (t = this).input.on("change", function () {
                            return "url-redirect" === t.type ? (window.location.href = $(this).val()) : "localization" === t.type ? $(this).closest("form").submit() : void 0;
                        });
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkFeaturedCollections = (function () {
                function t(t) {
                    var n;
                    (this.root = t),
                        (this.resizeListeners = e(this.resizeListeners, this)),
                        (this.matchImageHeights = e(this.matchImageHeights, this)),
                        ((n = this).item_container = n.root.find(".featured-collections--body")),
                        (n.items = n.root.find(".featured-collections--item")),
                        n.matchImageHeights(),
                        n.resizeListeners();
                }
                return (
                    (t.prototype.matchImageHeights = function () {
                        return this, theme.utils.matchImageHeights(this.item_container, this.items, ".featured-collections--image");
                    }),
                    (t.prototype.resizeListeners = function () {
                        var t;
                        return (
                            (t = this),
                            $(window).on(
                                "resize.FeaturedCollections",
                                theme.utils.debounce(100, function () {
                                    return t.matchImageHeights();
                                })
                            )
                        );
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkFeaturedGrid = (function () {
                function t(t) {
                    var n;
                    (this.root = t),
                        (this.resizeListeners = e(this.resizeListeners, this)),
                        (this.matchImageHeights = e(this.matchImageHeights, this)),
                        ((n = this).item_container = n.root.find(".featured-grid--body")),
                        (n.items = n.root.find(".featured-grid--item")),
                        (n.text_position = n.root.data("text-position")),
                        n.matchImageHeights(),
                        n.resizeListeners();
                }
                return (
                    (t.prototype.matchImageHeights = function () {
                        var t;
                        if (((t = this).items.find(".featured-grid--item--image, .placeholder--root").css("height", "auto"), "center" !== t.text_position || "small" === theme.utils.mqs.current_window))
                            return theme.utils.matchImageHeights(t.item_container, t.items, ".featured-grid--item--image");
                    }),
                    (t.prototype.resizeListeners = function () {
                        var t;
                        return (
                            (t = this),
                            $(window).on(
                                "resize.FeaturedGrid",
                                theme.utils.debounce(100, function () {
                                    return t.matchImageHeights();
                                })
                            )
                        );
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkFeaturedProduct = (function () {
                function t(t) {
                    var n;
                    (this.root = t),
                        (this.updateVariantImage = e(this.updateVariantImage, this)),
                        (this.thumbNavigation = e(this.thumbNavigation, this)),
                        (this.addProductComplete = e(this.addProductComplete, this)),
                        (this.addToCartListener = e(this.addToCartListener, this)),
                        (this.updateVariantImage = e(this.updateVariantImage, this)),
                        (this.variantSelected = e(this.variantSelected, this)),
                        (this.updateVariantOnOptionChange = e(this.updateVariantOnOptionChange, this)),
                        (this.load = e(this.load, this)),
                        ((n = this).add_button = n.root.find(".featured-product--add-to-cart")),
                        (n.cart_form = n.root.find(".featured-product--cart-form > form")),
                        (n.compare_price = n.root.find(".featured-product--compare-price")),
                        (n.main_images = n.root.find(".featured-product--media")),
                        (n.onboarding = n.root.data("onboarding")),
                        (n.option_inputs = n.root.find('[data-item="disclosure"], [data-item="radio"]')),
                        (n.price = n.root.find(".featured-product--actual-price")),
                        (n.price_wrapper = n.root.find(".featured-product--price-wrapper")),
                        (n.smart_payment_buttons = n.root.find(".featured-product--smart-payment-buttons")),
                        (n.thumbs = n.root.find(".featured-product--thumb")),
                        (n.unavailable_variant = n.root.find(".featured-product--unavailable-variant")),
                        (n.variants = JSON.parse(n.root.find(".featured-product--json").text()).variants),
                        (n.variant_listbox = n.root.find(".featured-product--variant-select")),
                        (n.variant_sold_out = n.root.find(".featured-product--sold-out--variant")),
                        n.load();
                }
                return (
                    (t.prototype.load = function () {
                        var t;
                        if (((t = this).addToCartListener(), t.thumbNavigation(), !1 === t.onboarding && t.variants.length > 1)) return t.updateVariantOnOptionChange();
                    }),
                    (t.prototype.updateVariantOnOptionChange = function () {
                        var t;
                        return (t = this).option_inputs.on("change", function () {
                            var e, n, i, o, r, s, a;
                            for (
                                e = t.root.find('[data-item="disclosure"], [data-item="radio"]:checked'),
                                    o = [],
                                    e.each(function () {
                                        return o.push($(this).val().trim());
                                    }),
                                    a = o.join(" / "),
                                    n = 0,
                                    i = (r = t.variants).length;
                                n < i;
                                n++
                            )
                                if ((s = r[n]).title === a) return t.variantSelected(s);
                            return t.variantSelected(!1);
                        });
                    }),
                    (t.prototype.variantSelected = function (t) {
                        var e, n, i, o;
                        return (
                            (n = !1),
                            (e = this).root.find(".featured-product--sold-out--product").length && (n = !0),
                            e.variant_sold_out.hide(),
                            e.unavailable_variant.hide(),
                            e.add_button.hide(),
                            e.price_wrapper.hide(),
                            e.variant_listbox.find("option[selected]").removeAttr("selected"),
                            t
                                ? (t && t.available
                                      ? (e.price_wrapper.show(), e.add_button.show(), e.smart_payment_buttons.show(), e.variant_listbox.find("option[value='" + t.id + "']").attr("selected", ""))
                                      : n
                                      ? (e.variant_sold_out.hide(), e.add_button.hide(), e.smart_payment_buttons.hide())
                                      : (e.variant_sold_out.show(), e.smart_payment_buttons.hide()),
                                  (o = theme.utils.formatMoney(t.price)),
                                  e.price.text(o),
                                  t.compare_at_price > t.price ? ((i = theme.utils.formatMoney(t.compare_at_price)), e.compare_price.text(i), e.compare_price.show()) : e.compare_price.hide(),
                                  t.featured_media ? e.updateVariantImage(t.featured_media.id) : void 0)
                                : (e.unavailable_variant.show(), e.smart_payment_buttons.hide(), !1)
                        );
                    }),
                    (t.prototype.updateVariantImage = function (t) {
                        return this, this.main_images.attr("data-active", "false"), this.main_images.filter("[data-id='" + t + "']").attr("data-active", "true");
                    }),
                    (t.prototype.addToCartListener = function () {
                        var t;
                        if ((t = this).cart_form.length > 0 && "drawer" === theme.settings.cart_type)
                            return t.cart_form.on("submit", function () {
                                return (
                                    t.cart_form.find(".error").remove(),
                                    t.add_button.attr("data-loading", "true"),
                                    theme.partials.Cart.addItem($(this), function (e, n) {
                                        return e
                                            ? theme.partials.Cart.updateAllHtml(function () {
                                                  return t.addProductComplete();
                                              })
                                            : (t.cart_form.append("<div class='featured-product--error error'>" + n + "</div>"), t.add_button.attr("data-loading", "false"));
                                    }),
                                    !1
                                );
                            });
                    }),
                    (t.prototype.addProductComplete = function () {
                        return this, this.add_button.attr("data-loading", "false"), $('[data-off-canvas--open="right-sidebar"]').first().trigger("click");
                    }),
                    (t.prototype.thumbNavigation = function () {
                        var t;
                        return (t = this).thumbs.on("keypress click", function (e) {
                            var n, i;
                            if (
                                theme.utils.a11yClick(e) &&
                                (t.root.find('.featured-product--media[data-active="true"] > *').trigger("pause-media"),
                                (n = $(this).attr("data-id")),
                                (i = t.root.find(".featured-product--media[data-id='" + n + "'] > *:not(.a11y--focus-trigger)")),
                                t.updateVariantImage(n),
                                "small" !== theme.utils.mqs.current_window && i.trigger("play-media"),
                                "image" !== i.parent().attr("data-media-type"))
                            )
                                return i.focus();
                        });
                    }),
                    (t.prototype.updateVariantImage = function (t) {
                        var e;
                        return (
                            (e = this).main_images.attr("data-active", "false"),
                            e.main_images.filter("[data-id='" + t + "']").attr("data-active", "true"),
                            e.thumbs.attr("data-active", "false"),
                            e.thumbs.filter("[data-id='" + t + "']").attr("data-active", "true")
                        );
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkFeaturedProductNew = (function () {
                function t(t) {
                    var n;
                    (this.root = t),
                        (this.updateVariantImage = e(this.updateVariantImage, this)),
                        (this.thumbNavigation = e(this.thumbNavigation, this)),
                        (this.addProductComplete = e(this.addProductComplete, this)),
                        (this.addToCartListener = e(this.addToCartListener, this)),
                        (this.updateVariantImage = e(this.updateVariantImage, this)),
                        (this.variantSelected = e(this.variantSelected, this)),
                        (this.updateVariantOnOptionChange = e(this.updateVariantOnOptionChange, this)),
                        (this.load = e(this.load, this)),
                        ((n = this).add_button = n.root.find("button.add")),
                        (n.cart_form = n.root.find(".add-to-cart form")),
                        (n.compare_price = n.root.find(".compare-price")),
                        (n.main_images = n.root.find(".featured-product--media")),
                        (n.onboarding = n.root.data("onboarding")),
                        (n.option_inputs = n.root.find('[data-item="disclosure"], [data-item="radio"]')),
                        (n.price = n.root.find(".actual-price")),
                        (n.price_wrapper = n.root.find(".featured-product--price-wrapper")),
                        (n.smart_payment_buttons = n.root.find(".featured-product--smart-payment-buttons")),
                        (n.thumbs = n.root.find(".featured-product--thumb")),
                        (n.unavailable_variant = n.root.find(".featured-product--unavailable-variant")),
                        (n.variants = JSON.parse(n.root.find(".featured-product--json").text()).variants),
                        (n.variant_listbox = n.root.find(".featured-product--variant-select")),
                        (n.variant_sold_out = n.root.find(".featured-product--sold-out--variant")),
                        n.load();
                }
                return (
                    (t.prototype.load = function () {
                        var t;
                        if (((t = this).addToCartListener(), t.thumbNavigation(), !1 === t.onboarding && t.variants.length > 1)) return t.updateVariantOnOptionChange();
                    }),
                    (t.prototype.updateVariantOnOptionChange = function () {
                        var t;
                        return (t = this).option_inputs.on("change", function () {
                            var e, n, i, o, r, s, a;
                            for (
                                e = t.root.find('[data-item="disclosure"], [data-item="radio"]:checked'),
                                    o = [],
                                    e.each(function () {
                                        return o.push($(this).val().trim());
                                    }),
                                    a = o.join(" / "),
                                    n = 0,
                                    i = (r = t.variants).length;
                                n < i;
                                n++
                            )
                                if ((s = r[n]).title === a) return t.variantSelected(s);
                            return t.variantSelected(!1);
                        });
                    }),
                    (t.prototype.variantSelected = function (t) {
                        var e, n, i, o;
                        return (
                            (n = !1),
                            (e = this).root.find(".featured-product--sold-out--product").length && (n = !0),
                            e.variant_sold_out.hide(),
                            e.unavailable_variant.hide(),
                            e.add_button.hide(),
                            e.price_wrapper.hide(),
                            e.variant_listbox.find("option[selected]").removeAttr("selected"),
                            t
                                ? (t && t.available
                                      ? (e.price_wrapper.show(), e.add_button.show(), e.smart_payment_buttons.show(), e.variant_listbox.find("option[value='" + t.id + "']").attr("selected", ""))
                                      : n
                                      ? (e.variant_sold_out.hide(), e.add_button.hide(), e.smart_payment_buttons.hide())
                                      : (e.variant_sold_out.show(), e.smart_payment_buttons.hide()),
                                  (o = theme.utils.formatMoney(t.price)),
                                  e.price.text(o),
                                  t.compare_at_price > t.price ? ((i = theme.utils.formatMoney(t.compare_at_price)), e.compare_price.text(i), e.compare_price.show()) : e.compare_price.hide(),
                                  t.featured_media ? e.updateVariantImage(t.featured_media.id) : void 0)
                                : (e.unavailable_variant.show(), e.smart_payment_buttons.hide(), !1)
                        );
                    }),
                    (t.prototype.updateVariantImage = function (t) {
                        return this, this.main_images.attr("data-active", "false"), this.main_images.filter("[data-id='" + t + "']").attr("data-active", "true");
                    }),
                    (t.prototype.addToCartListener = function () {
                        var t;
                        if ((t = this).cart_form.length > 0 && "drawer" === theme.settings.cart_type)
                            return t.cart_form.on("submit", function () {
                                return (
                                    t.cart_form.find(".error").remove(),
                                    t.add_button.attr("data-loading", "true"),
                                    theme.partials.Cart.addItem($(this), function (e, n) {
                                        return e
                                            ? theme.partials.Cart.updateAllHtml(function () {
                                                  return t.addProductComplete();
                                              })
                                            : (t.cart_form.append("<div class='featured-product--error error'>" + n + "</div>"), t.add_button.attr("data-loading", "false"));
                                    }),
                                    !1
                                );
                            });
                    }),
                    (t.prototype.addProductComplete = function () {
                        return this, this.add_button.attr("data-loading", "false"), $('[data-off-canvas--open="right-sidebar"]').first().trigger("click");
                    }),
                    (t.prototype.thumbNavigation = function () {
                        var t;
                        return (t = this).thumbs.on("keypress click", function (e) {
                            var n, i;
                            if (
                                theme.utils.a11yClick(e) &&
                                (t.root.find('.featured-product--media[data-active="true"] > *').trigger("pause-media"),
                                (n = $(this).attr("data-id")),
                                (i = t.root.find(".featured-product--media[data-id='" + n + "'] > *:not(.a11y--focus-trigger)")),
                                t.updateVariantImage(n),
                                "small" !== theme.utils.mqs.current_window && i.trigger("play-media"),
                                "image" !== i.parent().attr("data-media-type"))
                            )
                                return i.focus();
                        });
                    }),
                    (t.prototype.updateVariantImage = function (t) {
                        var e;
                        return (
                            (e = this).main_images.attr("data-active", "false"),
                            e.main_images.filter("[data-id='" + t + "']").attr("data-active", "true"),
                            e.thumbs.attr("data-active", "false"),
                            e.thumbs.filter("[data-id='" + t + "']").attr("data-active", "true")
                        );
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkFeaturedVideo = (function () {
                function t(t) {
                    var n;
                    (this.root = t),
                        (this.hideThumbnail = e(this.hideThumbnail, this)),
                        (this.playButtonListener = e(this.playButtonListener, this)),
                        (this.vimeoEvents = e(this.vimeoEvents, this)),
                        (this.insertVimeoPlayer = e(this.insertVimeoPlayer, this)),
                        (this.youtubeEvents = e(this.youtubeEvents, this)),
                        (this.youtubeReady = e(this.youtubeReady, this)),
                        (this.insertYoutubePlayer = e(this.insertYoutubePlayer, this)),
                        (this.insertAPIScript = e(this.insertAPIScript, this)),
                        (this.playerInit = e(this.playerInit, this)),
                        (this.checkAPIScriptExists = e(this.checkAPIScriptExists, this)),
                        ((n = this).video_type = n.root.data("videoType")),
                        (n.video_id = n.root.data("videoId")),
                        (n.thumbnail = n.root.data("thumbnail")),
                        (n.section_id = n.root.data("sectionId")),
                        (n.youtubeVars = {}),
                        (n.vimeoVars = { id: n.video_id, autopause: 0, playsinline: 0, title: 0 }),
                        n.thumbnail ? n.playButtonListener() : n.checkAPIScriptExists();
                }
                return (
                    (t.prototype.checkAPIScriptExists = function () {
                        var t;
                        return "vimeo" === (t = this).video_type
                            ? theme.utils.vimeoScriptAdded
                                ? t.playerInit()
                                : t.insertAPIScript("https://player.vimeo.com/api/player.js")
                            : theme.utils.youtubeScriptAdded
                            ? t.playerInit()
                            : t.insertAPIScript("https://www.youtube.com/iframe_api");
                    }),
                    (t.prototype.playerInit = function () {
                        var t;
                        return "vimeo" === (t = this).video_type
                            ? t.thumbnail
                                ? t.insertVimeoPlayer()
                                : ($(window).on("load", function () {
                                      return t.insertVimeoPlayer();
                                  }),
                                  t.root.on("theme:section:load", function () {
                                      return t.insertVimeoPlayer();
                                  }))
                            : t.thumbnail
                            ? t.insertYoutubePlayer()
                            : ($(window).on("load", function () {
                                  return t.insertYoutubePlayer();
                              }),
                              t.root.on("theme:section:load", function () {
                                  return t.insertYoutubePlayer();
                              }));
                    }),
                    (t.prototype.insertAPIScript = function (t) {
                        var e, n;
                        return (
                            (e = this),
                            ((n = document.createElement("script")).src = t),
                            "vimeo" === e.video_type
                                ? ((theme.utils.vimeoScriptAdded = !0),
                                  (n.onload = function () {
                                      return e.insertVimeoPlayer();
                                  }))
                                : ((theme.utils.youtubeScriptAdded = !0),
                                  $(window).on("theme.utils.youtubeAPIReady", function () {
                                      return e.insertYoutubePlayer();
                                  })),
                            document.body.appendChild(n)
                        );
                    }),
                    (t.prototype.insertYoutubePlayer = function () {
                        var t;
                        return (
                            (t = this).thumbnail || ((t.youtubeVars.playsinline = 1), (t.youtubeVars.fs = 0), (t.youtubeVars.loop = 1), (t.youtubeVars.playlist = t.video_id)),
                            (t.player = new YT.Player("player-" + t.section_id, { videoId: t.video_id, playerVars: t.youtubeVars, events: { onReady: t.youtubeReady, onStateChange: t.youtubeEvents } }))
                        );
                    }),
                    (t.prototype.youtubeReady = function () {
                        var t;
                        return (t = this).thumbnail || t.player.mute(), t.player.playVideo();
                    }),
                    (t.prototype.youtubeEvents = function (t) {
                        var e, n, i;
                        if (((n = this), (e = t.target), n.thumbnail)) {
                            if (0 === t.data) return e.seekTo(0), e.pauseVideo();
                        } else if (1 === t.data)
                            return (
                                (i = e.getDuration() - e.getCurrentTime()),
                                n.rewindTO && clearTimeout(n.rewindTO),
                                (n.rewindTO = setTimeout(function () {
                                    e.seekTo(0);
                                }, 1e3 * (i - 0.1)))
                            );
                    }),
                    (t.prototype.insertVimeoPlayer = function () {
                        var t;
                        return (
                            (t = this).thumbnail || ((t.vimeoVars.playsinline = 1), (t.vimeoVars.muted = 1), (t.vimeoVars.background = 1), (t.vimeoVars.loop = 1)),
                            (t.player = new Vimeo.Player("player-" + t.section_id, t.vimeoVars)),
                            t.thumbnail && t.vimeoEvents(),
                            t.player.play()
                        );
                    }),
                    (t.prototype.vimeoEvents = function () {
                        var t;
                        return (
                            (t = this).player.getDuration().then(function (e) {
                                return t.player.addCuePoint(e - 0.3, {});
                            }),
                            t.player.on("cuepoint", function () {
                                return t.player.setCurrentTime(0), t.player.pause();
                            })
                        );
                    }),
                    (t.prototype.playButtonListener = function () {
                        var t;
                        return (t = this).root.find(".feature-video--play svg, .feature-video--play-mobile svg").on("click", function () {
                            return t.checkAPIScriptExists(), t.hideThumbnail();
                        });
                    }),
                    (t.prototype.hideThumbnail = function () {
                        var t;
                        return (
                            (t = this),
                            setTimeout(function () {
                                return t.root.find(".feature-video--header, .feature-video--thumbnail, .feature-video--play-mobile").hide();
                            }, 350)
                        );
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkFeedbackBar = (function () {
                function t(t) {
                    var n;
                    (this.root = t), (this.load = e(this.load, this)), ((n = this).messages = n.root.find(".feedback-bar--message span")), n.load();
                }
                return (
                    (t.prototype.load = function () {
                        var t, e, n;
                        if (((t = this).messages.hide(), (e = window.location.hash.substr(1).replace("feedback-bar--", "")), (n = t.messages.filter('[data-feedback-bar--message="' + e + '"]')).length))
                            return (
                                n.show(),
                                setTimeout(function () {
                                    return t.root.attr("data-feedback-bar--open", "true");
                                }, 200),
                                setTimeout(function () {
                                    return t.root.attr("data-feedback-bar--open", "false");
                                }, 3e3)
                            );
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkFooter = (function () {
                function t(t) {
                    (this.root = t), (this.stickyFooter = e(this.stickyFooter, this)), (this.addListeners = e(this.addListeners, this)), (this.load = e(this.load, this)), this.load();
                }
                return (
                    (t.prototype.load = function () {
                        return this, this.addListeners(), this.stickyFooter();
                    }),
                    (t.prototype.addListeners = function () {
                        var t;
                        return (
                            (t = this),
                            $(window).on("resize", function () {
                                return t.stickyFooter();
                            })
                        );
                    }),
                    (t.prototype.stickyFooter = function () {
                        var t;
                        if ((this, (t = $(".header--root").outerHeight() + $(".main-content").outerHeight() + this.root.outerHeight()), $(window).outerHeight() > t))
                            return $(".main-content").css({ "min-height": $(window).outerHeight() - $(".header--root").outerHeight() - this.root.outerHeight() });
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkLoadingAnimation = function (t) {
                var e;
                (this.root = t), (e = this).root.hasClass("tiny") ? e.root.spin("tiny") : e.root.spin("small");
            }),
            (theme.classes.FrameworkMap = (function () {
                function t(t) {
                    var n;
                    (this.root = t),
                        (this.buildStyles = e(this.buildStyles, this)),
                        (this.buildMap = e(this.buildMap, this)),
                        (this.geolocate = e(this.geolocate, this)),
                        (this.loadMapsApi = e(this.loadMapsApi, this)),
                        (this.load = e(this.load, this)),
                        ((n = this).api_status = null),
                        (n.map_instance = null),
                        (n.key = n.root.data("api-key")),
                        (n.address = n.root.data("address")),
                        (n.theme = n.root.data("theme")),
                        (n.styles = null),
                        (n.container = n.root.find(".map--google-maps")),
                        (n.center = null),
                        n.load();
                }
                return (
                    (t.prototype.load = function () {
                        if ((this, this.container.length > 0)) return this.loadMapsApi();
                    }),
                    (t.prototype.loadMapsApi = function () {
                        var t, e;
                        return (
                            (t = this),
                            "loading" === theme.utils.google_map_api_status
                                ? (e = setInterval(function () {
                                      if ("loaded" === theme.utils.google_map_api_status) return t.geolocate(), clearInterval(e);
                                  }, 100))
                                : void 0 === window.google
                                ? ((theme.utils.google_map_api_status = "loading"),
                                  $.getScript("https://maps.googleapis.com/maps/api/js?key=" + t.key).then(function () {
                                      return t.geolocate(), (theme.utils.google_map_api_status = "loaded");
                                  }))
                                : t.geolocate()
                        );
                    }),
                    (t.prototype.geolocate = function () {
                        var t;
                        return (
                            (t = this),
                            new google.maps.Geocoder().geocode({ address: t.address }, function (e, n) {
                                return "OK" === n ? ((t.center = e[0].geometry.location), t.buildStyles(), t.buildMap()) : console.log("couldn't convert address with geocoder");
                            })
                        );
                    }),
                    (t.prototype.buildMap = function () {
                        var t, e, n, i;
                        return (
                            (i = { zoom: 15, center: (t = this).center, disableDefaultUI: !0, zoomControl: !0, scrollwheel: !1, styles: t.styles }),
                            (n = new google.maps.Map(t.container[0], i)),
                            (e = n.getCenter()),
                            new google.maps.Marker({ map: n, position: n.getCenter() }),
                            (t.map_instance = google.maps.event.addDomListener(
                                window,
                                "resize",
                                theme.utils.debounce(500, function () {
                                    google.maps.event.trigger(n, "resize"), n.setCenter(e);
                                })
                            ))
                        );
                    }),
                    (t.prototype.buildStyles = function () {
                        var t;
                        return "grayscale" === (t = this).theme
                            ? (t.styles = [
                                  { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
                                  { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
                                  { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                                  { elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
                                  { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
                                  { featureType: "poi", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
                                  { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                                  { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
                                  { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                                  { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
                                  { featureType: "road.arterial", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                                  { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#dadada" }] },
                                  { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                                  { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                                  { featureType: "transit.line", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
                                  { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
                                  { featureType: "water", elementType: "geometry", stylers: [{ color: "#c9c9c9" }] },
                                  { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                              ])
                            : "dark" === t.theme
                            ? (t.styles = [
                                  { elementType: "geometry", stylers: [{ color: "#212121" }] },
                                  { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
                                  { elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                                  { elementType: "labels.text.stroke", stylers: [{ color: "#212121" }] },
                                  { featureType: "administrative", elementType: "geometry", stylers: [{ color: "#757575" }] },
                                  { featureType: "administrative.country", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                                  { featureType: "administrative.land_parcel", stylers: [{ visibility: "off" }] },
                                  { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
                                  { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                                  { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#181818" }] },
                                  { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                                  { featureType: "poi.park", elementType: "labels.text.stroke", stylers: [{ color: "#1b1b1b" }] },
                                  { featureType: "road", elementType: "geometry.fill", stylers: [{ color: "#2c2c2c" }] },
                                  { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#8a8a8a" }] },
                                  { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#373737" }] },
                                  { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#3c3c3c" }] },
                                  { featureType: "road.highway.controlled_access", elementType: "geometry", stylers: [{ color: "#4e4e4e" }] },
                                  { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                                  { featureType: "transit", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                                  { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }] },
                                  { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#3d3d3d" }] },
                              ])
                            : void 0;
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkMediaQueries = (function () {
                function t() {
                    (this.screenSizeListener = e(this.screenSizeListener, this)),
                        (this.getScreenSize = e(this.getScreenSize, this)),
                        (this.medium_screen = 768),
                        (this.large_screen = 1024),
                        (this.current_window = null),
                        this.getScreenSize(),
                        this.screenSizeListener();
                }
                return (
                    (t.prototype.getScreenSize = function () {
                        var t;
                        if (((t = this), window.matchMedia("only screen and (min-width: " + t.large_screen + "px)").matches)) {
                            if ("large" !== t.current_window) return (t.current_window = "large");
                        } else if (window.matchMedia("only screen and (min-width: " + t.medium_screen + "px)").matches) {
                            if ("medium" !== t.current_window) return (t.current_window = "medium");
                        } else if ("small" !== t.current_window) return (t.current_window = "small");
                    }),
                    (t.prototype.screenSizeListener = function () {
                        var t;
                        return (
                            (t = this),
                            $(window).on("resize", function () {
                                return t.getScreenSize();
                            })
                        );
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkModal = (function () {
                function t(t) {
                    var e;
                    (this.container = t),
                        ((e = this).fullscreen = !!e.container.data("modal--fullscreen")),
                        e.container.data("modal--custom-close") ? (e.custom_close_button = e.container.data("modal--custom-close")) : (e.custom_close_button = ""),
                        (e.force_view = e.container.data("force-view")),
                        (e.view = e.container.data("modal--view")),
                        (e.links = e.container.find(".modal--link")),
                        (e.content = e.container.find(".modal--content")),
                        (e.window = $(".modal--window")),
                        (e.window_container = e.window.find(".modal--container")),
                        (e.mask = e.window.find(".modal--mask")),
                        (e.close_button = e.window.find(".modal--close")),
                        (e.next_button = e.window.find(".modal--next")),
                        (e.prev_button = e.window.find(".modal--prev")),
                        (e.slider = null),
                        (e.slides = null),
                        (e.main_content_window = $(".off-canvas--main-content")),
                        e.openListeners(),
                        (e.modal_state = "closed"),
                        (e.nav_lock = !1);
                }
                return (
                    (t.prototype.openListeners = function () {
                        var t;
                        return (t = this).links.on("keypress.FrameworkModal, click.FrameworkModal, quick-open", function (e) {
                            var n;
                            return (
                                ("keypress" !== e.type || !1 !== theme.utils.a11yClick(e)) &&
                                ((n = $(this)),
                                t.links.each(function (i) {
                                    if ($(this).is(n)) return "quick-open" === e.type ? t.open(i, !0) : t.open(i);
                                }),
                                !1)
                            );
                        });
                    }),
                    (t.prototype.open = function (t, e) {
                        var n, i;
                        if ((null == e && (e = !1), "closed" === (n = this).modal_state))
                            return (
                                (n.modal_state = "opened"),
                                $("html").addClass("modal-open"),
                                n.window.attr("data-modal--fullscreen", n.fullscreen),
                                n.window.attr("data-modal--custom-close", n.custom_close_button),
                                n.window.attr("data-modal--view", n.view),
                                n.closeListeners(),
                                n.positionListeners(),
                                (i = $(window).scrollTop()),
                                n.main_content_window.css({ position: "fixed", top: -i }),
                                n.moveContentToWindow(),
                                n.slides.length > 1 && (n.next_button.show(), n.prev_button.show(), n.prevListeners(), n.nextListeners()),
                                n.window.show(),
                                n.window_container.show(),
                                n.renderVideo(n.slides.eq(t)),
                                e
                                    ? (n.slides.eq(t).addClass("active"), n.position())
                                    : (n.mask.fadeIn(),
                                      n.loadModal(n.slides.eq(t), function () {
                                          return setTimeout(function () {
                                              return n.window_container.find('input[type="text"]').focus();
                                          }, 0);
                                      }))
                            );
                    }),
                    (t.prototype.moveContentToWindow = function (t) {
                        var e, n;
                        return (n = (e = this).container.find(".modal--content")), e.window_container.append(n), (e.slides = e.window_container.find(".modal--content"));
                    }),
                    (t.prototype.detectImageSlide = function (t) {
                        return this;
                    }),
                    (t.prototype.renderVideo = function (t) {
                        var e, n, i, o, r, s;
                        return (
                            (e = this),
                            (o = (s = t.find(".responsive-video").first()).data("video")),
                            (r = e.extractVideoType(o)),
                            (n = e.extractVideoId(o, r)),
                            (i = e.createIframe(r, n)),
                            "vimeo" === r && s.addClass("vimeo"),
                            "kickstarter" === r && s.addClass("kickstarter"),
                            s.append(i)
                        );
                    }),
                    (t.prototype.extractVideoType = function (t) {
                        return /\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9_\-]+)/i.exec(t)
                            ? "youtube"
                            : /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/.exec(t)
                            ? "vimeo"
                            : !!/^.*(kickstarter)\.com/g.exec(t) && "kickstarter";
                    }),
                    (t.prototype.extractVideoId = function (t, e) {
                        var n, i;
                        if ("youtube" === e) {
                            if (((i = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/), (n = t.match(i)) && 11 === n[2].length)) return n[2];
                        } else if ("vimeo" === e) {
                            if (((i = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/), (n = t.match(i)))) return n[2];
                        } else if ("kickstarter" === e && ((i = /(?:kickstarter\.com\/projects\/)(.*)(|\?)/), (n = t.match(i)))) return n[1];
                    }),
                    (t.prototype.createIframe = function (t, e) {
                        return "youtube" === t
                            ? "<iframe src='//www.youtube.com/embed/" + e + "?autoplay=1' frameborder='0' allowfullwidth></iframe>"
                            : "vimeo" === t
                            ? "<iframe src='//player.vimeo.com/video/" + e + "?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff&amp;autoplay=1?' frameborder='0' webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>"
                            : "kickstarter" === t
                            ? "<iframe src='//www.kickstarter.com/projects/" + e + "/widget/video.html' frameborder='0' webkitallowfullwidth mozallowfullwidth allowfullwidth></iframe>"
                            : void 0;
                    }),
                    (t.prototype.removeVideos = function () {
                        return (
                            this,
                            this.slides.find(".responsive-video").each(function () {
                                if ($(this).data("video")) return $(this).find("iframe").remove();
                            })
                        );
                    }),
                    (t.prototype.loadModal = function (t, e) {
                        return this, t.addClass("active"), this.position(), e && e(), (this.nav_lock = !1);
                    }),
                    (t.prototype.position = function () {
                        var t, e, n, i;
                        if (null != (t = this).window_container) {
                            if (
                                ((e = t.content.filter(".active")),
                                t.window_container.attr("style", ""),
                                t.positionVideoColumns(e),
                                t.detectImageSlide(e),
                                t.window.removeClass("fixed"),
                                (i = e.outerHeight()),
                                e.outerWidth(),
                                (n = i + parseInt(t.window.css("padding-top")) + parseInt(t.window.css("padding-bottom"))),
                                t.fullscreen)
                            )
                                return;
                            return (
                                e.hasClass("type--image") && (n = i),
                                $(window).height() >= n && "absolute" !== t.force_view
                                    ? t.window.addClass("fixed")
                                    : ($("html, body").animate({ scrollTop: 0 }, "0"),
                                      $("body,html").on("DOMMouseScroll.FrameworkModal mousewheel.FrameworkModal touchmove.FrameworkModal", function (t) {
                                          if (t.which > 0 || "mousewheel" === t.type || "touchmove" === t.type) return $("html,body").stop();
                                      }),
                                      t.window.removeClass("fixed"))
                            );
                        }
                    }),
                    (t.prototype.positionVideoColumns = function (t) {
                        var e, n;
                        if (t.find(".responsive-video").length > 0 && ((e = t.find(".fw--blocks > div").eq(0)), (n = t.find(".fw--blocks > div").eq(1)), e.css({ width: "" }), n.css({ width: "" }), e.outerHeight() < n.outerHeight()))
                            return e.css({ width: "100%" }), n.css({ width: "100%" });
                    }),
                    (t.prototype.positionListeners = function () {
                        var t;
                        return (
                            (t = this),
                            $(window).on("resize.FrameworkModal", function () {
                                return t.position();
                            })
                        );
                    }),
                    (t.prototype.nextListeners = function () {
                        var t;
                        return (
                            (t = this),
                            $(document).on("keydown.FrameworkModal", function (e) {
                                if (39 === e.keyCode) return t.next();
                            }),
                            t.next_button.on("click.FrameworkModal", function () {
                                return t.next();
                            })
                        );
                    }),
                    (t.prototype.next = function () {
                        var t, e, n;
                        if (!(t = this).nav_lock)
                            return (
                                (t.nav_lock = !0),
                                (n = t.slides.filter(".active").index()),
                                t.slides.removeClass("active"),
                                t.removeVideos(),
                                (e = n + 1 === t.slides.length ? t.slides.eq(0) : t.slides.eq(n + 1)),
                                t.renderVideo(e),
                                t.loadModal(e)
                            );
                    }),
                    (t.prototype.prevListeners = function () {
                        var t;
                        return (
                            (t = this),
                            $(document).on("keydown.FrameworkModal", function (e) {
                                if (37 === e.keyCode) return t.prev();
                            }),
                            t.prev_button.on("click.FrameworkModal", function () {
                                return t.prev();
                            })
                        );
                    }),
                    (t.prototype.prev = function () {
                        var t, e, n;
                        if (!(t = this).nav_lock)
                            return (
                                (t.nav_lock = !0),
                                (n = t.slides.filter(".active").index()),
                                t.slides.removeClass("active"),
                                t.removeVideos(),
                                (e = 0 === n ? t.slides.eq(t.slides.length - 1) : t.slides.eq(n - 1)),
                                t.renderVideo(e),
                                t.loadModal(e)
                            );
                    }),
                    (t.prototype.closeListeners = function () {
                        var t;
                        return (
                            (t = this).container.on("quick-close", function () {
                                return t.close(!0);
                            }),
                            $(document).on("keydown.FrameworkModal", function (e) {
                                if (27 === e.keyCode) return t.close();
                            }),
                            t.mask.on("click.FrameworkModal", function () {
                                return t.close();
                            }),
                            t.window_container.on("click.FrameworkModal", function () {
                                return t.close();
                            }),
                            t.content.on("click.FrameworkModal", function (t) {
                                return t.stopPropagation();
                            }),
                            t.close_button.on("click.FrameworkModal", function () {
                                return t.close();
                            })
                        );
                    }),
                    (t.prototype.close = function (t) {
                        var e, n;
                        return (
                            null == t && (t = !1),
                            (e = this),
                            (n = -1 * parseInt(e.main_content_window.css("top"))),
                            e.container.trigger("modalClosed"),
                            e.main_content_window.css({ top: "0", position: "relative" }),
                            $(window).scrollTop(n),
                            e.putBackContent(),
                            e.next_button.hide(),
                            e.prev_button.hide(),
                            e.window.hide(),
                            t
                                ? (e.mask.hide(), this.window_container.empty(), (e.modal_state = "closed"))
                                : e.mask.fadeOut(function () {
                                      return e.window_container.empty(), (e.modal_state = "closed");
                                  }),
                            $("html").removeClass("modal-open"),
                            e.removeListeners(),
                            $(window).trigger("FrameworkModal.afterClose")
                        );
                    }),
                    (t.prototype.putBackContent = function () {
                        var t;
                        return (t = this).removeVideos(), t.slides.removeClass("active").appendTo(t.container);
                    }),
                    (t.prototype.removeListeners = function () {
                        var t;
                        return (
                            (t = this),
                            $(document).off("keydown.FrameworkModal"),
                            $(window).off("resize.FrameworkModal"),
                            $("body,html").off("DOMMouseScroll.FrameworkModal mousewheel.FrameworkModal touchmove.FrameworkModal"),
                            t.next_button.off("click.FrameworkModal"),
                            t.prev_button.off("click.FrameworkModal"),
                            t.close_button.off("click.FrameworkModal"),
                            t.mask.off("click.FrameworkModal"),
                            t.window_container.off("click.FrameworkModal")
                        );
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkOffCanvas = (function () {
                function t(t) {
                    var n;
                    (this.root = t),
                        (this.touchListener = e(this.touchListener, this)),
                        (this.closeRight = e(this.closeRight, this)),
                        (this.closeLeft = e(this.closeLeft, this)),
                        (this.fadeInOverlay = e(this.fadeInOverlay, this)),
                        (this.openRight = e(this.openRight, this)),
                        (this.openLeft = e(this.openLeft, this)),
                        (this.toggle = e(this.toggle, this)),
                        (this.toggleListeners = e(this.toggleListeners, this)),
                        (this.viewPortHeightListener = e(this.viewPortHeightListener, this)),
                        (this.setViewPortHeight = e(this.setViewPortHeight, this)),
                        (this.setState = e(this.setState, this)),
                        (this.unload = e(this.unload, this)),
                        (this.load = e(this.load, this)),
                        ((n = this).viewport = $(".off-canvas--viewport")),
                        (n.left_sidebar = $(".off-canvas--left-sidebar")),
                        (n.right_sidebar = $(".off-canvas--right-sidebar")),
                        (n.main_content = $(".off-canvas--main-content")),
                        (n.overlay = $(".off-canvas--overlay")),
                        (n.state = "closed"),
                        n.load();
                }
                return (
                    (t.prototype.load = function () {
                        var t;
                        return ((t = this).close = $(".off-canvas--close")), (t.triggers = $(".off-canvas--open")), t.setViewPortHeight(), t.viewPortHeightListener(), t.toggleListeners(), t.touchListener();
                    }),
                    (t.prototype.unload = function () {
                        var t;
                        return (t = this).triggers.off("click"), t.overlay.add(t.close).off("click"), $(document).off("touchstart.OffCanvas"), $(document).off("touchend.OffCanvas");
                    }),
                    (t.prototype.setState = function (t) {
                        return this, (this.state = t), this.root.attr("data-off-canvas--state", t);
                    }),
                    (t.prototype.setViewPortHeight = function () {
                        return this, this.viewport.css({ "min-height": $(window).height() });
                    }),
                    (t.prototype.viewPortHeightListener = function () {
                        var t;
                        return (
                            (t = this),
                            $(window).on("resize", function () {
                                return t.setViewPortHeight();
                            })
                        );
                    }),
                    (t.prototype.toggleListeners = function () {
                        var t;
                        return (
                            (t = this).triggers.on("click", function () {
                                return "left-sidebar" === $(this).data("off-canvas--open") ? t.toggle("left-sidebar") : "right-sidebar" === $(this).data("off-canvas--open") && t.toggle("right-sidebar"), !1;
                            }),
                            t.overlay.add(t.close).on("click", function () {
                                return "left-open" === t.state ? t.toggle("left-sidebar") : "right-open" === t.state ? t.toggle("right-sidebar") : void 0;
                            })
                        );
                    }),
                    (t.prototype.toggle = function (t) {
                        var e;
                        return (
                            (e = this),
                            "left-sidebar" === t && "closed" === e.state
                                ? e.openLeft()
                                : "left-sidebar" === t && "left-open" === e.state
                                ? e.closeLeft()
                                : "right-sidebar" === t && "closed" === e.state
                                ? e.openRight()
                                : "right-sidebar" === t && "right-open" === e.state
                                ? e.closeRight()
                                : void 0
                        );
                    }),
                    (t.prototype.openLeft = function () {
                        var t;
                        return (
                            (t = this).setState("left-open"),
                            t.main_content.css({ position: "fixed", top: -$(window).scrollTop() }),
                            t.left_sidebar.velocity(
                                { translateX: [0, "-100%"] },
                                {
                                    complete: function () {
                                        return t.left_sidebar.css({ position: "relative" });
                                    },
                                }
                            ),
                            t.fadeInOverlay()
                        );
                    }),
                    (t.prototype.openRight = function () {
                        var t;
                        return (
                            (t = this).setState("right-open"),
                            t.main_content.css({ position: "fixed", top: -$(window).scrollTop() }),
                            t.right_sidebar.velocity(
                                { translateX: ["-100%", 0] },
                                {
                                    complete: function () {
                                        return t.right_sidebar.css({ position: "relative" });
                                    },
                                }
                            ),
                            t.fadeInOverlay()
                        );
                    }),
                    (t.prototype.fadeInOverlay = function () {
                        return this, this.overlay.show(), this.overlay.velocity({ opacity: "0.3" });
                    }),
                    (t.prototype.closeLeft = function () {
                        var t, e;
                        return (
                            "left-open" === (t = this).state &&
                            (t.setState("closed"),
                            (e = -1 * parseInt(t.main_content.css("top"))),
                            t.left_sidebar.velocity(
                                { translateX: ["-100%", 0] },
                                {
                                    complete: function () {
                                        return t.left_sidebar.css({ position: "absolute" }), t.main_content.css({ position: "relative", top: "initial" }), $(window).scrollTop(e);
                                    },
                                }
                            ),
                            t.overlay.velocity("fadeOut"))
                        );
                    }),
                    (t.prototype.closeRight = function () {
                        var t, e;
                        return (
                            "right-open" === (t = this).state &&
                            (t.setState("closed"),
                            (e = -1 * parseInt(t.main_content.css("top"))),
                            t.right_sidebar.velocity(
                                { translateX: [0, "-100%"] },
                                {
                                    complete: function () {
                                        return t.right_sidebar.css({ position: "absolute" }), t.main_content.css({ position: "relative", top: "initial" }), $(window).scrollTop(e);
                                    },
                                }
                            ),
                            t.overlay.velocity("fadeOut"))
                        );
                    }),
                    (t.prototype.touchListener = function () {
                        var t, e;
                        return (
                            (t = this),
                            !!Modernizr.touchevents &&
                                ((e = { start: {}, end: {} }),
                                $(document).on("touchstart.OffCanvas", function (t) {
                                    (e.start.x = t.originalEvent.touches[0].clientX), (e.start.y = t.originalEvent.touches[0].clientY);
                                }),
                                $(document).on("touchend.OffCanvas", function (n) {
                                    return (
                                        (e.end.x = n.originalEvent.changedTouches[0].clientX),
                                        (e.end.y = n.originalEvent.changedTouches[0].clientY),
                                        !(Math.abs(e.start.y - e.end.y) > 30) && (e.start.x > e.end.x + 5 ? t.closeLeft() : e.start.x < e.end.x - 5 ? t.closeRight() : void 0)
                                    );
                                }))
                        );
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkProductModel = (function () {
                function t(t) {
                    var n;
                    (this.root = t),
                        (this.loadModel = e(this.loadModel, this)),
                        (this.loadAssets = e(this.loadAssets, this)),
                        (this.eventListeners = e(this.eventListeners, this)),
                        (this.load = e(this.load, this)),
                        ((n = this).view = n.root.data("view")),
                        (n.key = n.root.closest("[data-id]").data("id")),
                        (n.cdn = "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui"),
                        n.load();
                }
                return (
                    (t.prototype.load = function () {
                        if ((this, this.eventListeners(), !theme.utils.modelScriptAdded)) return (theme.utils.modelScriptAdded = !0), this.loadAssets();
                    }),
                    (t.prototype.eventListeners = function () {
                        var t;
                        return (
                            (t = this).root.on("model-ready", function () {
                                return t.loadModel();
                            }),
                            t.root.on("theme:section:load", function () {
                                return t.loadModel();
                            }),
                            t.root.on("pause-media", function () {
                                if (t.model) return t.model.pause();
                            }),
                            t.root.on("play-media", function () {
                                if (t.model) return t.model.play();
                            }),
                            $(window).on(
                                "resize.ProductModel",
                                theme.utils.debounce(250, function () {
                                    return $(".product-model--root").trigger("pause-media"), $(".product-model--root").trigger("model-ready");
                                })
                            )
                        );
                    }),
                    (t.prototype.loadAssets = function () {
                        return (
                            this,
                            theme.utils.insertStylesheet(this.cdn + ".css"),
                            theme.utils.insertScript(this.cdn + ".en.js", function () {
                                return $(".product-model--root").trigger("model-ready");
                            })
                        );
                    }),
                    (t.prototype.loadModel = function () {
                        var t;
                        if (!(t = this).model && !(("small" === theme.utils.mqs.current_window && "desktop" === t.view) || ("small" !== theme.utils.mqs.current_window && "mobile" === t.view)))
                            return (t.model = new Shopify.ModelViewerUI(t.root.find("model-viewer")));
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkProductRecommendations = (function () {
                function t(t) {
                    (this.root = t),
                        (this.loadHoverImages = e(this.loadHoverImages, this)),
                        (this.checkIfEmpty = e(this.checkIfEmpty, this)),
                        (this.loadProducts = e(this.loadProducts, this)),
                        (this.resizeListeners = e(this.resizeListeners, this)),
                        (this.matchImageHeights = e(this.matchImageHeights, this)),
                        this.loadProducts(),
                        this.resizeListeners();
                }
                return (
                    (t.prototype.matchImageHeights = function () {
                        var t;
                        return ((t = this).item_container = t.root.find(".product-recommendations--body")), (t.items = t.root.find(".product--root")), theme.utils.matchImageHeights(t.item_container, t.items, ".product--image-wrapper");
                    }),
                    (t.prototype.resizeListeners = function () {
                        var t;
                        return (
                            (t = this),
                            $(window).on(
                                "resize",
                                theme.utils.debounce(100, function () {
                                    return t.matchImageHeights();
                                })
                            )
                        );
                    }),
                    (t.prototype.loadProducts = function () {
                        var t, e, n, i, o, r;
                        return (
                            (t = this),
                            (n = (i = document.getElementsByClassName("product-recommendations--root")[0]).dataset.productId),
                            (e = i.dataset.maxProducts),
                            (r = theme.urls.product_recommendations + "?section_id=framework--product-recommendations&limit=" + e + "&product_id=" + n),
                            (o = new XMLHttpRequest()).open("GET", r),
                            (o.onload = function () {
                                var e;
                                if (o.status >= 200 && o.status < 300)
                                    return (
                                        ((e = document.createElement("div")).innerHTML = o.response), (i.innerHTML = e.querySelector(".product-recommendations--root").innerHTML), t.matchImageHeights(), t.checkIfEmpty(), t.loadHoverImages()
                                    );
                            }),
                            o.send()
                        );
                    }),
                    (t.prototype.checkIfEmpty = function () {
                        var t;
                        return (t = !($(".product--root").length > 0)), $(".product-recommendations--root").attr("data-empty", t);
                    }),
                    (t.prototype.loadHoverImages = function () {
                        return $('.product--root[data-hover-image="true"]').each(function () {
                            var t;
                            return (
                                (t = $(this)),
                                theme.utils.imagesLoaded(t, function () {
                                    return t.attr("data-hover-image", "loaded");
                                })
                            );
                        });
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkProductVideo = (function () {
                function t(t) {
                    var n;
                    (this.root = t),
                        (this.skipVideo = e(this.skipVideo, this)),
                        (this.loadYoutubeVideo = e(this.loadYoutubeVideo, this)),
                        (this.loadPlyrVideo = e(this.loadPlyrVideo, this)),
                        (this.loadYoutubeAsset = e(this.loadYoutubeAsset, this)),
                        (this.loadPlyrAssets = e(this.loadPlyrAssets, this)),
                        (this.resizeListener = e(this.resizeListener, this)),
                        (this.youtubeListeners = e(this.youtubeListeners, this)),
                        (this.plyrListeners = e(this.plyrListeners, this)),
                        (this.load = e(this.load, this)),
                        ((n = this).view = n.root.data("view")),
                        (n.type = n.root.data("type")),
                        (n.loop_enabled = n.root.data("loop-enabled")),
                        n.load();
                }
                return (
                    (t.prototype.load = function () {
                        var t;
                        return (
                            (t = this).resizeListener(),
                            "youtube" === t.type
                                ? ((t.id = t.root.find(".product-video").attr("id")), (t.video_id = t.root.data("video-id")), t.youtubeListeners(), t.loadYoutubeAsset())
                                : ((t.plyr_cdn = "https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr"), t.plyrListeners(), t.loadPlyrAssets())
                        );
                    }),
                    (t.prototype.plyrListeners = function () {
                        var t;
                        return (
                            (t = this).root.on("plyr-video-ready", function () {
                                return t.loadPlyrVideo();
                            }),
                            t.root.on("theme:section:load", function () {
                                return t.loadPlyrVideo();
                            }),
                            t.root.on("pause-media", function () {
                                if (t.video) return t.video.pause();
                            }),
                            t.root.on("play-media", function () {
                                if (t.video) return t.video.play();
                            })
                        );
                    }),
                    (t.prototype.youtubeListeners = function () {
                        var t;
                        return (
                            (t = this),
                            $(window).on("theme.utils.youtubeAPIReady", function () {
                                return t.loadYoutubeVideo();
                            }),
                            t.root.on("theme:section:load", function () {
                                return t.loadYoutubeVideo();
                            })
                        );
                    }),
                    (t.prototype.resizeListener = function () {
                        return $(window).on(
                            "resize.ProductVideo",
                            theme.utils.debounce(250, function () {
                                return $(".product-video--root").trigger("pause-media"), $(".product-video--root").trigger("plyr-video-ready"), $(".product-video--root").trigger("theme.utils.youtubeAPIReady");
                            })
                        );
                    }),
                    (t.prototype.loadPlyrAssets = function () {
                        if ((this, !theme.utils.plyrScriptAdded))
                            return (
                                (theme.utils.plyrScriptAdded = !0),
                                theme.utils.insertStylesheet(this.plyr_cdn + ".css"),
                                theme.utils.insertScript(this.plyr_cdn + ".en.js", function () {
                                    return $(".product-video--root").trigger("plyr-video-ready");
                                })
                            );
                    }),
                    (t.prototype.loadYoutubeAsset = function () {
                        if (!theme.utils.youtubeScriptAdded) return (theme.utils.youtubeScriptAdded = !0), theme.utils.insertScript("https://www.youtube.com/iframe_api");
                    }),
                    (t.prototype.loadPlyrVideo = function () {
                        var t;
                        if (!(t = this).video && !t.skipVideo()) return (t.video = new Shopify.Plyr(t.root.find("video"), { iconUrl: t.plyr_cdn + ".svg", loop: { active: t.loop_enabled } }));
                    }),
                    (t.prototype.loadYoutubeVideo = function () {
                        var t;
                        if (!(t = this).video && !t.skipVideo())
                            return (t.video = new YT.Player(t.id, {
                                videoId: t.video_id,
                                events: {
                                    onReady: function (e) {
                                        return (
                                            t.root.on("pause-media", function () {
                                                return e.target.pauseVideo();
                                            }),
                                            t.root.on("play-media", function () {
                                                return e.target.playVideo();
                                            })
                                        );
                                    },
                                    onStateChange: function (e) {
                                        if ((0 === e.data && t.loop_enabled && e.target.seekTo(0), 1 === e.data)) return $(".product-page--media > *").not(t.root).trigger("pause-media");
                                    },
                                },
                            }));
                    }),
                    (t.prototype.skipVideo = function () {
                        return this, ("small" === theme.utils.mqs.current_window && "desktop" === this.view) || ("small" !== theme.utils.mqs.current_window && "mobile" === this.view);
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkRadios = (function () {
                function t(t) {
                    var n;
                    (this.root = t),
                        (this.setSwatchAppearance = e(this.setSwatchAppearance, this)),
                        (this.updateLabelOnChange = e(this.updateLabelOnChange, this)),
                        (this.preventFormSubmitOnEnter = e(this.preventFormSubmitOnEnter, this)),
                        (this.load = e(this.load, this)),
                        ((n = this).current_value = n.root.find(".radios--option-current")),
                        (n.inputs = n.root.find('[data-item="radio"]')),
                        (n.is_swatches = n.root.data("is-swatches")),
                        n.load();
                }
                return (
                    (t.prototype.load = function () {
                        var t;
                        if (((t = this).preventFormSubmitOnEnter(), t.is_swatches)) return t.updateLabelOnChange(), t.setSwatchAppearance();
                    }),
                    (t.prototype.preventFormSubmitOnEnter = function () {
                        return (
                            this,
                            this.inputs.on("keydown", function (t) {
                                if ("Enter" === t.key) return t.preventDefault();
                            })
                        );
                    }),
                    (t.prototype.updateLabelOnChange = function () {
                        var t;
                        return (t = this).inputs.on("change", function () {
                            return t.current_value.text($(this).val());
                        });
                    }),
                    (t.prototype.setSwatchAppearance = function () {
                        return (
                            this,
                            this.inputs.each(function () {
                                var t, e;
                                return (
                                    (t = $(this).siblings(".radios--swatch-button")),
                                    (e = $(this).val().toLowerCase().replace(/\s+/g, "")),
                                    void 0 === theme.swatches[e]
                                        ? t.css("background-color", e)
                                        : theme.swatches[e].indexOf("cdn.shopify.com") > -1
                                        ? t.css("background-image", "url(" + theme.swatches[e] + ")")
                                        : t.css("background-color", theme.swatches[e])
                                );
                            })
                        );
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkSearch = (function () {
                function t(t) {
                    var n;
                    (this.root = t),
                        (this.resizeListeners = e(this.resizeListeners, this)),
                        (this.matchImageHeights = e(this.matchImageHeights, this)),
                        (this.getResults = e(this.getResults, this)),
                        (this.listenForKeyEntered = e(this.listenForKeyEntered, this)),
                        (this.getSearchUrl = e(this.getSearchUrl, this)),
                        (this.searchLinks = e(this.searchLinks, this)),
                        (this.loadSpinners = e(this.loadSpinners, this)),
                        (this.onOpen = e(this.onOpen, this)),
                        ((n = this).articles = n.root.find(".search--articles")),
                        (n.form = n.root.find("form")),
                        (n.icon = n.root.find(".search--icon")),
                        (n.loading = n.root.find(".search--loading")),
                        (n.no_results = n.root.find(".search--no-results")),
                        (n.products = n.root.find(".search--products")),
                        (n.results = n.root.find(".search--results")),
                        (n.text_box = n.root.find(".search--textbox")),
                        (n.toggle_link = n.root.find(".search--toggle")),
                        (n.show_articles = n.root.data("show-articles")),
                        (n.show_pages = n.root.data("show-pages")),
                        (n.view = n.root.data("view")),
                        (n.ajax_request = null),
                        (n.search_term = null),
                        (n.search_url = null),
                        (n.close_results_timer = null),
                        (n.typing_timer = null),
                        (n.article_page_combination = ""),
                        (n.offCanvas = theme.partials.OffCanvas),
                        n.show_articles && n.show_pages ? (n.article_page_combination = "article,page") : n.show_articles ? (n.article_page_combination = "article") : n.show_pages && (n.article_page_combination = "page"),
                        "modal" === n.view && (n.searchLinks(), n.getSearchUrl(), n.listenForKeyEntered(), n.loadSpinners()),
                        n.resizeListeners(),
                        n.matchImageHeights();
                }
                return (
                    (t.prototype.onOpen = function () {
                        var t, e;
                        return (t = this).text_box.focus(), (e = t.text_box.val()), t.text_box.val(""), t.text_box.val(e), t.text_box.trigger("keyup");
                    }),
                    (t.prototype.loadSpinners = function () {
                        var t;
                        return this, (t = this.loading.find(".animation")).hasClass("tiny") ? t.spin("tiny") : t.spin("small");
                    }),
                    (t.prototype.searchLinks = function () {
                        var t;
                        return (
                            (t = this),
                            $(".off-canvas--main-content a[href='" + theme.urls.search + "']").on("click", function () {
                                return $('[data-trigger="search-modal"]').trigger("click"), t.onOpen(), !1;
                            }),
                            $(".off-canvas--right-sidebar a[href='" + theme.urls.search + "']").on("click", function () {
                                return (
                                    t.offCanvas.closeRight(),
                                    setTimeout(function () {
                                        return $('[data-trigger="search-modal"]').trigger("click"), t.onOpen();
                                    }, 450),
                                    !1
                                );
                            }),
                            $(".off-canvas--left-sidebar a[href='" + theme.urls.search + "']").on("click", function () {
                                return (
                                    t.offCanvas.closeLeft(),
                                    setTimeout(function () {
                                        return $('[data-trigger="search-modal"]').trigger("click"), t.onOpen();
                                    }, 450),
                                    !1
                                );
                            })
                        );
                    }),
                    (t.prototype.getSearchUrl = function () {
                        var t;
                        return (
                            ((t = this).search_url = window.location.href),
                            (t.search_url = t.search_url.replace(window.location.hostname + window.location.pathname, window.location.hostname + theme.urls.search)),
                            (t.search_url = t.search_url.replace("#", "")),
                            t.search_url.indexOf("?") >= 0 ? (t.search_url = t.search_url + "&") : (t.search_url = t.search_url + "?")
                        );
                    }),
                    (t.prototype.listenForKeyEntered = function () {
                        var t;
                        return (t = this).text_box.attr("autocomplete", "off").on("keyup paste", function (e) {
                            var n;
                            return (
                                clearTimeout(t.typing_timer),
                                (n = $(this).val()).length < 2 && "paste" !== e.type
                                    ? (t.products.empty(), t.articles.empty(), t.loading.hide(), t.icon.show(), !1)
                                    : (t.loading.show(),
                                      t.icon.hide(),
                                      (t.typing_timer = setTimeout(function () {
                                          var e;
                                          if ((clearTimeout(t.typing_timer), (e = t.search_url + "view=ajax-product&type=product&q=" + n + "*"), t.getResults(e, n, "product"), t.show_articles || t.show_pages))
                                              return (e = t.search_url + "view=ajax-article-page&type=" + t.article_page_combination + "&q=" + n + "*"), t.getResults(e, n, "article");
                                      }, 750)))
                            );
                        });
                    }),
                    (t.prototype.getResults = function (t, e, n) {
                        var i;
                        (i = this).products.empty(),
                            i.articles.empty(),
                            $.ajax({
                                url: t,
                                type: "GET",
                                dataType: "html",
                                success: function (t) {
                                    return i.loading.hide(), i.icon.show(), "product" === n ? (i.products.empty(), i.products.append(t), i.matchImageHeights()) : "article" === n ? (i.articles.empty(), i.articles.append(t)) : void 0;
                                },
                                error: function (t, e, n) {
                                    var i;
                                    return (i = e + ", " + n), console.log("search.json Request Failed: " + i);
                                },
                            });
                    }),
                    (t.prototype.matchImageHeights = function () {
                        return this, theme.utils.matchImageHeights(this.products, this.products.find(".product--root"), ".product--image-wrapper");
                    }),
                    (t.prototype.resizeListeners = function () {
                        var t;
                        return (
                            (t = this),
                            $(window).on(
                                "resize.Search",
                                theme.utils.debounce(100, function () {
                                    return t.matchImageHeights();
                                })
                            )
                        );
                    }),
                    t
                );
            })()),
            (theme.classes.Sections = (function () {
                function t() {
                    (this.unload = e(this.unload, this)),
                        (this.deselectBlock = e(this.deselectBlock, this)),
                        (this.selectBlock = e(this.selectBlock, this)),
                        (this.deselectSection = e(this.deselectSection, this)),
                        (this.selectSection = e(this.selectSection, this)),
                        (this.load = e(this.load, this)),
                        (this.getActiveBlock = e(this.getActiveBlock, this)),
                        (this.getActiveSection = e(this.getActiveSection, this)),
                        (this.listeners = e(this.listeners, this)),
                        this.listeners();
                }
                return (
                    (t.prototype.listeners = function () {
                        var t;
                        return (t = this).load(), t.unload(), t.selectSection(), t.deselectSection(), t.selectBlock(), t.deselectBlock();
                    }),
                    (t.prototype.getActiveSection = function (t) {
                        return $(t.target).find("[data-section-id]");
                    }),
                    (t.prototype.getActiveBlock = function (t) {
                        return $(t.target);
                    }),
                    (t.prototype.load = function (t) {
                        var e;
                        return (
                            (e = this),
                            $(document).on("shopify:section:load", function (t) {
                                var n;
                                return (
                                    theme.utils.loadJsClasses(),
                                    (n = e.getActiveSection(t)).triggerHandler("theme:section:load"),
                                    n.find("[data-js-class]").each(function () {
                                        return $(this).triggerHandler("theme:section:load");
                                    })
                                );
                            })
                        );
                    }),
                    (t.prototype.selectSection = function () {
                        var t;
                        return (
                            (t = this),
                            $(document).on("shopify:section:select", function (e) {
                                return t.getActiveSection(e).triggerHandler("theme:section:select");
                            })
                        );
                    }),
                    (t.prototype.deselectSection = function () {
                        var t;
                        return (
                            (t = this),
                            $(document).on("shopify:section:deselect", function (e) {
                                return t.getActiveSection(e).triggerHandler("theme:section:deselect");
                            })
                        );
                    }),
                    (t.prototype.selectBlock = function () {
                        var t;
                        return (
                            (t = this),
                            $(document).on("shopify:block:select", function (e) {
                                return t.getActiveBlock(e).triggerHandler("theme:block:select");
                            })
                        );
                    }),
                    (t.prototype.deselectBlock = function () {
                        var t;
                        return (
                            (t = this),
                            $(document).on("shopify:block:deselect", function (e) {
                                return t.getActiveBlock(e).triggerHandler("theme:block:deselect");
                            })
                        );
                    }),
                    (t.prototype.unload = function (t) {
                        var e;
                        return (
                            (e = this),
                            $(document).on("shopify:section:unload", function (t) {
                                var n;
                                return (
                                    (n = e.getActiveSection(t)).triggerHandler("theme:section:unload"),
                                    n.find('[data-js-loaded="true"]').each(function () {
                                        return $(this).triggerHandler("theme:section:unload");
                                    })
                                );
                            })
                        );
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkServiceList = (function () {
                function t(t) {
                    var n;
                    (this.root = t),
                        (this.balanceColumns = e(this.balanceColumns, this)),
                        (this.load = e(this.load, this)),
                        ((n = this).section_id = n.root.data("section-id")),
                        (n.block_list = n.root.find(".service-list--blocks")),
                        (n.blocks = n.root.find("li")),
                        (n.blocks_container = n.root.find(".service-list--container")),
                        (n.headers = n.root.find(".service-list--block-header")),
                        (n.single_column = n.root.find(".service-list--single-column")),
                        (n.left_column = n.root.find(".service-list--left-column")),
                        (n.right_column = n.root.find(".service-list--right-column")),
                        n.load();
                }
                return (
                    (t.prototype.load = function () {
                        return this, this.balanceColumns();
                    }),
                    (t.prototype.balanceColumns = function () {
                        var t, e, n, i, o, r;
                        return (
                            (i = !0 === (t = this).root.data("service-list--show-descriptions") ? 75 : 0),
                            (r = t.block_list.length > 1),
                            (e = function (t) {
                                return t.hasClass("service-list--block-header");
                            }),
                            (o = function () {
                                var e, n, o;
                                return (o = t.single_column.outerHeight()), (e = t.left_column.outerHeight()), (n = t.right_column.outerHeight()), e >= parseFloat(n + o - i);
                            }),
                            (n = (function () {
                                return r ? (t.root.attr("data-service-list--has-headers", !0), t.block_list) : (t.left_column.append('<ul class="service-list--blocks"></ul>'), t.blocks);
                            })()).each(function (i) {
                                return o()
                                    ? void t.single_column.find(".service-list--blocks").appendTo(t.right_column)
                                    : (r
                                          ? $(this).appendTo(t.left_column)
                                          : e($(this))
                                          ? ($(this).find(".service-list--block-header--text").prependTo(t.blocks_container), $(this).remove())
                                          : $(this).appendTo(t.left_column.find(".service-list--blocks")),
                                      i === n.length - 1 && t.right_column.is(":empty") && t.headers.length > 1 ? t.left_column.find(".service-list--blocks").last().appendTo(t.right_column) : void 0);
                            })
                        );
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkSlider = (function () {
                function t(t) {
                    (this.container = t),
                        (this.eventListeners = e(this.eventListeners, this)),
                        (this.pauseMedia = e(this.pauseMedia, this)),
                        (this.alignPlayButton = e(this.alignPlayButton, this)),
                        (this.updateContextMenu = e(this.updateContextMenu, this)),
                        (this.autoplay = e(this.autoplay, this)),
                        (this.formatPaginationNumbers = e(this.formatPaginationNumbers, this)),
                        (this.getActiveIndex = e(this.getActiveIndex, this)),
                        (this.createSlider = e(this.createSlider, this)),
                        (this.autoplay_enabled = !!this.container.data("autoplay")),
                        (this.navigation = !!this.container.data("navigation")),
                        (this.pagination_numbers = !!this.container.data("pagination-numbers")),
                        (this.autoplay_frequency = 3e3),
                        (this.slide_length = this.container.children().length),
                        (this.active_index = 0),
                        (this.news_panel = !!this.container.data("news-panel")),
                        this.createSlider(),
                        this.eventListeners(),
                        (this.owl = this.container.data("owlCarousel"));
                }
                return (
                    (t.prototype.createSlider = function () {
                        var t, e;
                        return (
                            (t = this),
                            (e = this.container.owlCarousel({
                                singleItem: !0,
                                navigation: t.navigation,
                                navigationText: !1,
                                pagination: !!t.container.data("pagination"),
                                paginationNumbers: t.pagination_numbers,
                                scrollPerPageNav: !0,
                                slideSpeed: 800,
                                autoHeight: !1,
                                autoPlay: t.autoplay(),
                                afterInit: function () {},
                                afterAction: function () {
                                    return t.alignPlayButton(), (t.active_index = t.getActiveIndex()), t.updateContextMenu(t.active_index), t.formatPaginationNumbers(), t.pauseMedia();
                                },
                            })),
                            t.navigation &&
                                (e.find(".owl-prev").html('<svg class="icon--root icon--chevron-left" viewBox="0 0 12 20"> <path d="M2.648 10l8.613-8.614L9.99.114.102 10l9.887 9.886 1.272-1.272z" fill-rule="nonzero" /> </svg>'),
                                e.find(".owl-next").html('<svg class="icon--root icon--chevron-right" viewBox="0 0 12 20"> <path d="M8.716 10L.102 18.614l1.273 1.272L11.261 10 1.375.114.102 1.386z" fill-rule="nonzero" /> </svg>')),
                            e
                        );
                    }),
                    (t.prototype.getActiveIndex = function () {
                        return this.container.find(".owl-pagination .owl-page.active").index();
                    }),
                    (t.prototype.formatPaginationNumbers = function () {
                        return this.container.find(".owl-page.active .owl-numbers").text(this.active_index + 1 + "/" + this.slide_length);
                    }),
                    (t.prototype.autoplay = function () {
                        return !!this.autoplay_enabled && this.autoplay_frequency;
                    }),
                    (t.prototype.updateContextMenu = function (t) {
                        var e, n;
                        if (this.news_panel)
                            return (n = "." + this.container.find(".slide").eq(t).data("feed-type")), (e = this.container.closest(".template--index--news").find(".context-navigation")).find(".item").hide(), e.find(n).show();
                    }),
                    (t.prototype.alignPlayButton = function () {
                        var t, e, n;
                        if (0 !== (t = (e = this.container.find(".owl-item").eq(this.active_index)).find(".play-button")).length)
                            return (
                                t.css("visibility", "hidden"),
                                PAGE.hasClass("transparent-menu") && "absolute" === $(".header--root").css("position")
                                    ? ((n = (e.outerHeight() - t.outerHeight()) / 2), t.css({ "margin-top": 0, top: n }))
                                    : t.css({ "margin-top": "-40px", top: "50%" }),
                                t.css("visibility", "visible")
                            );
                    }),
                    (t.prototype.pauseMedia = function () {
                        var t;
                        return ((t = this).media = ".product-video--root, .product-model--root"), t.container.find(t.media).trigger("pause-media");
                    }),
                    (t.prototype.eventListeners = function () {
                        var t;
                        return (
                            (t = this),
                            this.container.find(".play-button").on("click", function () {
                                return new VideoModal($(this).closest(".video")).open(), t.owl.stop(), !1;
                            }),
                            this.container.find(".owl-pagination .owl-page, .skip-to-next").on("click", function () {
                                return t.owl.next(), !1;
                            })
                        );
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkStickyColumn = (function () {
                function t(t, n, i, o) {
                    if (
                        ((this.container = t),
                        (this.column_a = n),
                        (this.column_b = i),
                        (this.mq = o),
                        (this.Listeners = e(this.Listeners, this)),
                        (this.setColumnPosition = e(this.setColumnPosition, this)),
                        (this.getAlignment = e(this.getAlignment, this)),
                        (this.getState = e(this.getState, this)),
                        (this.resetLargerColumn = e(this.resetLargerColumn, this)),
                        (this.getSmallerColumn = e(this.getSmallerColumn, this)),
                        (this.heightsHaveChanged = e(this.heightsHaveChanged, this)),
                        (this.setHeights = e(this.setHeights, this)),
                        (this.loadColumns = e(this.loadColumns, this)),
                        Modernizr.touchevents)
                    )
                        return !1;
                    (this.current_state = "auto"), (this.column_a_height = 0), (this.column_b_height = 0), this.loadColumns();
                }
                return (
                    (t.prototype.loadColumns = function () {
                        var t;
                        return (
                            (t = this),
                            theme.utils.imagesLoaded(t.container, function () {
                                return t.Listeners(), t.setColumnPosition();
                            })
                        );
                    }),
                    (t.prototype.setHeights = function () {
                        return (this.column_a_height = this.column_a.outerHeight()), (this.column_b_height = this.column_b.outerHeight());
                    }),
                    (t.prototype.heightsHaveChanged = function () {
                        return (this.column_a.outerHeight() !== this.column_a_height || this.column_b.outerHeight() !== this.column_b_height) && (this.setHeights(), !0);
                    }),
                    (t.prototype.getSmallerColumn = function () {
                        return this.column_a_height < this.column_b_height ? this.column_a : this.column_b;
                    }),
                    (t.prototype.resetLargerColumn = function () {
                        return this.column_a_height > this.column_b_height ? this.column_a.css({ position: "relative", top: "auto", bottom: "auto" }) : this.column_b.css({ position: "relative", top: "auto", bottom: "auto" });
                    }),
                    (t.prototype.getState = function (t, e, n) {
                        var i, o, r;
                        return (
                            (r = "auto"),
                            "small" === this.mq.current_window
                                ? "auto"
                                : (e > (i = n.outerHeight()) && (o = !0),
                                  t < this.container.offset().top && (r = "auto"),
                                  t + (o ? i : e) > this.container.offset().top + this.container.outerHeight()
                                      ? (r = "absolute-bottom")
                                      : t > this.container.offset().top && o
                                      ? (r = "fixed-top")
                                      : e < i && t + e > this.container.offset().top + n.outerHeight() && (r = "fixed-bottom"),
                                  r)
                        );
                    }),
                    (t.prototype.getAlignment = function (t) {
                        return t.hasClass("column-a") ? "left" : t.hasClass("column-b") ? "right" : void 0;
                    }),
                    (t.prototype.setColumnPosition = function () {
                        var t, e, n, i;
                        if (
                            ((t = this).setHeights(),
                            (n = t.getSmallerColumn()),
                            (i = t.getState($(window).scrollTop(), $(window).height(), n)),
                            (e = t.getAlignment(n)),
                            "auto" === i && "auto" !== this.current_state
                                ? ((this.current_state = "auto"), n.css({ position: "relative", top: "auto", bottom: "auto" }))
                                : "fixed-bottom" === i && "fixed-bottom" !== this.current_state
                                ? ((this.current_state = "fixed-bottom"), n.css({ position: "fixed", top: "auto", bottom: 0 }))
                                : "fixed-top" === i && "fixed-top" !== this.current_state
                                ? ((this.current_state = "fixed-top"), n.css({ position: "fixed", top: 0, bottom: "auto" }))
                                : "absolute-bottom" === i && "absolute-bottom" !== this.current_state && ((this.current_state = "absolute-bottom"), n.css({ position: "absolute", top: "auto", bottom: 0 })),
                            "right" === e)
                        )
                            return n.css({ right: 0 });
                    }),
                    (t.prototype.Listeners = function () {
                        var t;
                        return (
                            (t = this),
                            $(window).on("scroll", function () {
                                return t.setColumnPosition();
                            }),
                            setInterval(function () {
                                if (t.heightsHaveChanged()) return t.resetLargerColumn(), t.setColumnPosition();
                            }, 250),
                            $(window).on("resize", function () {
                                return t.resetLargerColumn(), t.setColumnPosition();
                            })
                        );
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkUtils = (function () {
                function t() {
                    (this.google_map_api_status = null), cssVars();
                }
                return (
                    (t.prototype.a11yClick = function (t) {
                        var e;
                        return "click" === t.type || ("keypress" === t.type && (32 === (e = t.charCode || t.keyCode) && t.preventDefault(), 32 === e || 13 === e));
                    }),
                    (t.prototype.debounce = function (t, e) {
                        var n;
                        return (
                            (n = void 0),
                            function () {
                                n && clearTimeout(n), (n = setTimeout(e.bind(this), t, arguments));
                            }
                        );
                    }),
                    (t.prototype.imagesLoaded = function (t, e) {
                        var n, i;
                        return (
                            (n = 0),
                            (i = t.find('img[data-sizes="auto"]').length) < 1
                                ? void e()
                                : t.on("lazybeforeunveil", function (t) {
                                      return $(t.target).one("load", function () {
                                          if (++n === i) return e();
                                      });
                                  })
                        );
                    }),
                    (t.prototype.matchImageHeights = function (t, e, n) {
                        var i, o, r;
                        return (
                            (o = Math.round(t.width() / e.first().outerWidth())),
                            (i = 0),
                            (r = $()),
                            e.find(n).css("height", "auto"),
                            e.find(".placeholder--root").css("height", "auto"),
                            e.each(function (t) {
                                var s;
                                if (
                                    ((s =
                                        $(this).find(".image--root").length > 0
                                            ? $(this)
                                                  .find(n + " .image--root")
                                                  .outerHeight()
                                            : $(this).find(".placeholder--root").outerHeight()),
                                    (r = r.add($(this))),
                                    s > i && (i = s),
                                    t % o == o - 1 || t + 1 === e.length)
                                )
                                    return r.find(n + ", .placeholder--root").height(i), (i = 0), (r = $());
                            })
                        );
                    }),
                    (t.prototype.insertStylesheet = function (t) {
                        var e;
                        return ((e = document.createElement("link")).rel = "stylesheet"), (e.href = t), document.head.appendChild(e);
                    }),
                    (t.prototype.insertScript = function (t, e) {
                        var n;
                        return ((n = document.createElement("script")).src = t), e && (n.onload = e), document.body.appendChild(n);
                    }),
                    (t.prototype.formatMoney = function (t) {
                        var e, n, i;
                        switch (
                            ((i = /\{\{\s*(\w+)\s*\}\}/),
                            (e = function (t, e, n) {
                                var i, o, r, s;
                                return (s = n ? "." : ","), (r = n ? "," : "."), (o = (i = (t / 100).toFixed(e).split("."))[1] ? r + i[1] : ""), i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + s) + o;
                            }),
                            theme.shop.money_format.match(i)[1])
                        ) {
                            case "amount":
                                n = e(t, 2, !1);
                                break;
                            case "amount_no_decimals":
                                n = e(t, 0, !1);
                                break;
                            case "amount_with_comma_separator":
                                n = e(t, 2, !0);
                                break;
                            case "amount_no_decimals_with_comma_separator":
                                n = e(t, 0, !0);
                        }
                        return theme.shop.money_format.replace(i, n);
                    }),
                    (t.prototype.isNaN = function (t) {
                        return t != t;
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkXMenu = (function () {
                function t(t) {
                    var n;
                    (this.root = t),
                        (this.slideUp = e(this.slideUp, this)),
                        (this.slideDown = e(this.slideDown, this)),
                        (this.arrangeMegaNav = e(this.arrangeMegaNav, this)),
                        (this.resizeListeners = e(this.resizeListeners, this)),
                        (this.checkOverlap = e(this.checkOverlap, this)),
                        (this.listeners = e(this.listeners, this)),
                        (this.load = e(this.load, this)),
                        ((n = this).debugging = !1),
                        (n.state = "closed"),
                        (n.parent_links = n.root.find(".x-menu--level-1--link > a")),
                        (n.sub_menu_links = n.root.find('.x-menu--level-1--link:not([data-x-menu--depth="1"]) > a')),
                        (n.sub_menu_items = n.sub_menu_links.parent().find("ul a")),
                        (n.parents_with_sub_menu = n.sub_menu_links.parent()),
                        (n.overlap_parent = n.root.data("x-menu--overlap-parent")),
                        n.load();
                }
                return (
                    (t.prototype.load = function () {
                        var t;
                        return (t = this).arrangeMegaNav(), t.listeners(), t.checkOverlap(), t.resizeListeners();
                    }),
                    (t.prototype.listeners = function () {
                        var t;
                        return (
                            (t = this).parents_with_sub_menu.on("mouseenter.XMenu", function (e) {
                                return t.slideDown($(this).find("> a"));
                            }),
                            t.parents_with_sub_menu.on("mouseleave.XMenu", function () {
                                return t.slideUp();
                            }),
                            t.parent_links.on("focus", function (e) {
                                return t.slideUp();
                            }),
                            t.sub_menu_links.on("focus", function (e) {
                                return t.slideDown($(this));
                            }),
                            t.sub_menu_links.on("touchstart.XMenu", function (e) {
                                return e.preventDefault(), "true" === $(this).parent().attr("data-x-menu--open") ? t.slideUp() : t.slideDown($(this));
                            })
                        );
                    }),
                    (t.prototype.checkOverlap = function () {
                        var t, e, n, i, o, r, s, a;
                        return (
                            (t = this),
                            Modernizr.touchevents && "large" !== theme.utils.mqs.current_window
                                ? (t.root.attr("data-x-menu--overlap", "true"), !1)
                                : (t.root.attr("data-x-menu--overlap", "false"),
                                  (n = t.root),
                                  1 === t.overlap_parent ? (n = n.parent()) : 2 === t.overlap_parent && (n = n.parent().parent()),
                                  (o = n.parent()),
                                  (s = !1),
                                  (e = n.index()) > 1 && (s = o.children().eq(e - 1)),
                                  (a = !1),
                                  e + 1 < o.children().length && (a = o.children().eq(e + 1)),
                                  o.width(),
                                  t.root.outerWidth(),
                                  s && ((i = n.find("> :first-child").offset().left - 1), left_edge >= i && t.root.attr("data-x-menu--overlap", "true")),
                                  a && (r = n.find("> :last-child")).outerWidth() + r.offset().left + 1 >= a.offset().left ? t.root.attr("data-x-menu--overlap", "true") : void 0)
                        );
                    }),
                    (t.prototype.resizeListeners = function () {
                        var t;
                        return (
                            (t = this),
                            $(window).on(
                                "resize.XMenu",
                                t.debounce(100, function () {
                                    return t.checkOverlap();
                                })
                            )
                        );
                    }),
                    (t.prototype.debounce = function (t, e) {
                        var n;
                        return (
                            (n = void 0),
                            function () {
                                n && clearTimeout(n), (n = setTimeout(e.bind(this), t, arguments));
                            }
                        );
                    }),
                    (t.prototype.arrangeMegaNav = function () {
                        return (
                            this,
                            0 !== this.parents_with_sub_menu.length &&
                                this.root.find('[data-x-menu--depth="3"] .x-menu--level-2--container').each(function () {
                                    var t, e;
                                    if ((e = (t = $(this)).find('[data-x-menu--single-parent="true"]')).length > 0)
                                        return $('<div class="x-menu--single-parents"></div>').insertAfter(t.find(".x-menu--bg")).append("<ul>").find("ul").append(e);
                                })
                        );
                    }),
                    (t.prototype.slideDown = function (t, e) {
                        var n, i, o, r, s;
                        if ((null == e && (e = !1), (n = this), clearTimeout(n.timer), "true" === (o = t.parent()).attr("data-x-menu--open") || "closing" === n.state)) return !1;
                        n.slideUp(!1),
                            e && "complete" !== e
                                ? (n.timer = setTimeout(function () {
                                      return n.slideDown(t, "complete");
                                  }, e))
                                : (t.closest(".x-menu--level-1--link").find(".icon--chevron-up").show(),
                                  t.closest(".x-menu--level-1--link").find(".icon--chevron-down").hide(),
                                  t.closest(".x-menu--level-1--link").find(".icon--minus").show(),
                                  t.closest(".x-menu--level-1--link").find(".icon--plus").hide(),
                                  (n.state = "open"),
                                  o.attr("data-x-menu--open", "true"),
                                  t.attr("aria-expanded", "true"),
                                  (s = t.closest(".x-menu--level-1--link").find(".x-menu--level-2--container")),
                                  (i = "block"),
                                  "3" === o.attr("data-x-menu--depth") && (i = "flex"),
                                  s.velocity("stop"),
                                  s.css({ height: "auto", display: i }),
                                  s.find(".x-menu--level-2--list").css({ display: i }),
                                  (r = s.outerHeight()),
                                  s.css({ height: 0, opacity: 1 }),
                                  s.velocity({ height: [r, 0] }, { queue: !1, duration: 600, easing: "easeOutExpo" }));
                    }),
                    (t.prototype.slideUp = function (t) {
                        var e, n, i, o;
                        return (
                            null == t && (t = 300),
                            !(e = this).debugging &&
                                ((n = (i = e.parents_with_sub_menu.filter('[data-x-menu--open="true"]')).find("> a")),
                                "false" !== i.attr("data-x-menu--open") &&
                                    (t
                                        ? (e.timer = setTimeout(function () {
                                              return e.slideUp(!1);
                                          }, t))
                                        : (n.closest(".x-menu--level-1--link").find(".icon--chevron-up").hide(),
                                          n.closest(".x-menu--level-1--link").find(".icon--chevron-down").show(),
                                          n.closest(".x-menu--level-1--link").find(".icon--minus").hide(),
                                          n.closest(".x-menu--level-1--link").find(".icon--plus").show(),
                                          (o = n.closest(".x-menu--level-1--link").find(".x-menu--level-2--container")),
                                          i.attr("data-x-menu--open", "false"),
                                          n.attr("aria-expanded", "false"),
                                          o.velocity(
                                              { opacity: 0 },
                                              {
                                                  begin: function () {
                                                      return (e.state = "closing");
                                                  },
                                                  complete: function () {
                                                      return o.css({ display: "none" }), (e.state = "closed");
                                                  },
                                                  duration: 200,
                                              }
                                          ))))
                        );
                    }),
                    t
                );
            })()),
            (theme.classes.FrameworkYMenu = (function () {
                function t(t) {
                    var n;
                    (this.root = t),
                        (this.slideRight = e(this.slideRight, this)),
                        (this.slideLeft = e(this.slideLeft, this)),
                        (this.adjustHeight = e(this.adjustHeight, this)),
                        (this.listeners = e(this.listeners, this)),
                        (this.load = e(this.load, this)),
                        ((n = this).state = "closed"),
                        (n.sub_menu_links = n.root.find(".icon--chevron-right--small").parent()),
                        (n.back_links = n.root.find(".y-menu--back-link a")),
                        (n.regular_links = n.root.find('.y-menu--level-1--link > a:not([data-submenu="true"]), .y-menu--level-2--link > a:not([data-submenu="true"]), .y-menu--level-3--link > a:not([data-submenu="true"])')),
                        (n.timer = null),
                        n.load();
                }
                return (
                    (t.prototype.load = function () {
                        return this, this.listeners();
                    }),
                    (t.prototype.listeners = function () {
                        var t;
                        return (
                            (t = this).regular_links.on("click", function (t) {
                                var e;
                                -1 !== (e = $(this).attr("href")).indexOf("#") &&
                                    ("left-open" === theme.partials.OffCanvas.state ? theme.partials.OffCanvas.closeLeft() : "right-open" === theme.partials.OffCanvas.state && theme.partials.OffCanvas.closeRight(),
                                    setTimeout(function () {
                                        return (window.location.href = e);
                                    }, 450));
                            }),
                            t.sub_menu_links.on("click", function (e) {
                                return t.slideLeft($(this)), !1;
                            }),
                            t.back_links.on("click", function (e) {
                                return t.slideRight($(this)), !1;
                            })
                        );
                    }),
                    (t.prototype.adjustHeight = function (t) {
                        var e, n;
                        return (
                            (e = this).root.css({ height: "auto" }),
                            e.root.outerHeight(),
                            (n = t.outerHeight()),
                            "absolute" === t.css("position") && (t.css("position", "relative"), (n = t.outerHeight()), t.css("position", "absolute")),
                            e.root.velocity({ height: n })
                        );
                    }),
                    (t.prototype.slideLeft = function (t) {
                        var e;
                        return this, (e = t.closest("li").find("ul").first()).css({ display: "block" }), this.adjustHeight(e), e.velocity({ translateX: ["-100%", 0] });
                    }),
                    (t.prototype.slideRight = function (t) {
                        var e, n;
                        return this, (n = (e = t.closest("ul")).parent().closest("ul")), this.adjustHeight(n), e.velocity({ translateX: [0, "-100%"] });
                    }),
                    t
                );
            })()),
            (theme.classes.Article = (function (t) {
                function e() {
                    return e.__super__.constructor.apply(this, arguments);
                }
                return n(e, t), e;
            })(theme.classes.FrameworkArticle)),
            (theme.classes.Cart = (function (t) {
                function i() {
                    return (this.updateTotalsComplete = e(this.updateTotalsComplete, this)), i.__super__.constructor.apply(this, arguments);
                }
                return (
                    n(i, t),
                    (i.prototype.updateTotalsComplete = function (t) {
                        var e;
                        return (
                            (e = this),
                            t > 0
                                ? (e.total_item_count.css("display", "inline-block"), e.total_item_count.parent().show())
                                : (e.total_item_count.not(".header--mobile-cart-count").hide(), e.total_item_count.not(".header--mobile-cart-count").parent().hide())
                        );
                    }),
                    i
                );
            })(theme.classes.FrameworkCart)),
            (theme.classes.Disclosure = (function (t) {
                function e() {
                    return e.__super__.constructor.apply(this, arguments);
                }
                return n(e, t), e;
            })(theme.classes.FrameworkDisclosure)),
            (theme.classes.FeaturedProduct = (function (t) {
                function e() {
                    return e.__super__.constructor.apply(this, arguments);
                }
                return n(e, t), e;
            })(theme.classes.FrameworkFeaturedProduct)),
            (theme.classes.FeaturedProductNew = (function (t) {
                function e() {
                    return e.__super__.constructor.apply(this, arguments);
                }
                return n(e, t), e;
            })(theme.classes.FrameworkFeaturedProductNew)),
            (theme.classes.FeaturedVideo = (function (t) {
                function e() {
                    return e.__super__.constructor.apply(this, arguments);
                }
                return n(e, t), e;
            })(theme.classes.FrameworkFeaturedVideo)),
            (theme.classes.Footer = (function (t) {
                function e() {
                    return e.__super__.constructor.apply(this, arguments);
                }
                return n(e, t), e;
            })(theme.classes.FrameworkFooter)),
            (theme.classes.Slideshow = (function () {
                function t(t) {
                    var n;
                    (this.root = t),
                        (this.eventListeners = e(this.eventListeners, this)),
                        (this.alignPlayButton = e(this.alignPlayButton, this)),
                        (this.alignCaption = e(this.alignCaption, this)),
                        (this.isFirstSlider = e(this.isFirstSlider, this)),
                        (this.getActiveIndex = e(this.getActiveIndex, this)),
                        (this.autoplay = e(this.autoplay, this)),
                        (this.createSlider = e(this.createSlider, this)),
                        (this.el = this.root.find(".slides")),
                        (n = this.el.closest(".slider")),
                        (this.autoplay_enabled = n.data("autoplay")),
                        n.find(".slide").length < 2 && (this.autoplay_enabled = !1),
                        (this.autoplay_frequency = n.data("rotateFrequency")),
                        (this.transition_style = n.data("transitionStyle")),
                        this.createSlider(),
                        (this.owl = $(".owl-carousel").data("owlCarousel"));
                }
                return (
                    (t.prototype.createSlider = function () {
                        var t, e;
                        return (
                            (e = {
                                singleItem: !0,
                                navigation: !1,
                                paginationNumbers: !1,
                                scrollPerPageNav: !0,
                                slideSpeed: 800,
                                pagination: !0,
                                autoHeight: !0,
                                autoPlay: (t = this).autoplay(),
                                afterInit: function () {
                                    return t.eventListeners();
                                },
                                afterAction: function () {
                                    return t.alignCaption(), t.alignPlayButton();
                                },
                            }),
                            "default" !== this.transition_style && (e.transitionStyle = this.transition_style),
                            t.el.owlCarousel(e)
                        );
                    }),
                    (t.prototype.autoplay = function () {
                        return !!this.autoplay_enabled && this.autoplay_frequency;
                    }),
                    (t.prototype.getActiveIndex = function () {
                        return this.el.find(".owl-pagination .owl-page.active").index();
                    }),
                    (t.prototype.isFirstSlider = function () {
                        var t, e, n;
                        return (n = (e = $(".index-sections").children("div:first")).find(".slider").data("sectionId")), (t = this.el.closest(".slider").data("sectionId")), !!e.hasClass("section--slideshow") && t === n;
                    }),
                    (t.prototype.alignCaption = function () {
                        var t, e, n, i, o, r, s, a;
                        return (
                            (t = (r = this.el.find(".owl-item").eq(this.getActiveIndex())).find(".caption")).css("visibility", "hidden"),
                            (e = t.outerHeight()),
                            (n = t.outerWidth()),
                            30,
                            (s = r.outerHeight()),
                            (a = r.outerWidth()),
                            0,
                            t.hasClass("top") ? t.css("top", 30) : t.hasClass("middle") && ((o = 0 + (s - 0 - e) / 2), t.css("top", o)),
                            t.hasClass("center") && ((i = (a - n) / 2), t.css("left", i)),
                            t.css("visibility", "visible")
                        );
                    }),
                    (t.prototype.alignPlayButton = function () {
                        var t;
                        return (t = this.el.find(".owl-item").eq(this.getActiveIndex()).find(".play-button")).css("visibility", "hidden"), t.css({ "margin-top": "-40px", top: "50%" }), t.css("visibility", "visible");
                    }),
                    (t.prototype.eventListeners = function () {
                        var t;
                        return (
                            (t = this),
                            this.el.find(".owl-pagination .owl-page").on("click", function () {
                                return t.owl.stop();
                            })
                        );
                    }),
                    t
                );
            })()),
            (theme.classes.Header = (function () {
                function t(t) {
                    (this.root = t), (this.moveYMenu = e(this.moveYMenu, this)), (this.load = e(this.load, this)), this.load();
                }
                return (
                    (t.prototype.load = function () {
                        return (
                            this,
                            this.moveYMenu(),
                            "block" === $(".modal.window").css("display") && $(".modal.window .close").trigger("click"),
                            this.root.on("theme:section:load", function () {
                                return theme.partials.OffCanvas.unload(), theme.partials.OffCanvas.load();
                            })
                        );
                    }),
                    (t.prototype.moveYMenu = function () {
                        return $(".mobile-nav--menu").empty(), $(".y-menu").appendTo(".mobile-nav--menu");
                    }),
                    t
                );
            })()),
            (theme.classes.OffCanvas = (function (t) {
                function e(t) {
                    (this.root = t), e.__super__.constructor.apply(this, arguments);
                }
                return n(e, t), e;
            })(theme.classes.FrameworkOffCanvas)),
            (theme.classes.Popup = (function () {
                function t(t) {
                    var e;
                    (this.root = t),
                        ((e = this).container = e.root.find(".popup--container")),
                        (e.open_link = $(".popup--open")),
                        (e.close_link = e.root.find(".popup--close")),
                        (e.show_again_after = e.root.data("show-again-after")),
                        (e.mode = e.root.data("mode")),
                        (e.newsletter_form = e.root.find("#contact_form")),
                        (e.body = $("body")),
                        e.eventListeners(),
                        e.autoPopup();
                }
                return (
                    (t.prototype.eventListeners = function () {
                        var t;
                        return (
                            (t = this).open_link.on("keypress.Popup, click.Popup", function (e) {
                                return t.body.hasClass("popup--opened") ? t.close() : t.open(), !1;
                            }),
                            t.close_link.on("keypress.Popup, click.Popup", function (e) {
                                return t.close(), !1;
                            }),
                            t.newsletter_form.on("submit", function (t) {
                                var e, n;
                                return (
                                    (n = this),
                                    (e = $(this)).find(".error, .success").remove(),
                                    t.preventDefault(),
                                    0 === e.find('input[type="email"]').val().length
                                        ? (e.prepend("<p class='error'>" + theme.translations.mailing_list_email_blank + "</p>"), !1)
                                        : (e.find('input[type="email"], input[type="submit"]').hide(),
                                          e.prepend("<p class='success'>" + theme.translations.mailing_list_success_message + "</p>").show(),
                                          setTimeout(function () {
                                              return n.submit();
                                          }, 500),
                                          !1)
                                );
                            })
                        );
                    }),
                    (t.prototype.open = function (t) {
                        var e;
                        return (
                            (e = this).container.removeClass("popup--closed"),
                            e.container.velocity({ translateY: [0, e.container.outerHeight()] }, { duration: 300 }),
                            e.body.addClass("popup--opened"),
                            setTimeout(function () {
                                return e.body.css("padding-bottom", e.container.outerHeight());
                            }, 300)
                        );
                    }),
                    (t.prototype.delayUntilValidScrollPosition = function () {
                        var t;
                        return (
                            (t = this),
                            $(window).on("DOMMouseScroll.Popup mousewheel.Popup touchmove.Popup scroll.Popup touchmove.Popup", function (e) {
                                var n;
                                if (((n = $(".header").offset().top), $(window).scrollTop() > n)) return t.open(), $(window).off("DOMMouseScroll.Popup mousewheel.Popup touchmove.Popup scroll.Popup touchmove.Popup");
                            })
                        );
                    }),
                    (t.prototype.close = function () {
                        var t;
                        return (
                            (t = this).body.removeClass("popup--opened"),
                            t.body.velocity({ paddingBottom: 0 }, { duration: 300 }),
                            t.container.velocity(
                                { translateY: [t.container.outerHeight(), 0] },
                                {
                                    duration: 300,
                                    complete: function () {
                                        return t.container.addClass("popup--closed");
                                    },
                                }
                            )
                        );
                    }),
                    (t.prototype.autoPopup = function () {
                        var t;
                        if ("manual" !== (t = this).mode)
                            return Modernizr.localstorage && "test" !== t.mode
                                ? void 0 === localStorage["troop-themes"] || t.readyToReset()
                                    ? (t.setResetTime(),
                                      setTimeout(function () {
                                          return t.open("auto");
                                      }, 1e3))
                                    : void 0
                                : setTimeout(function () {
                                      return t.open("auto");
                                  }, 1e3);
                    }),
                    (t.prototype.readyToReset = function () {
                        var t, e;
                        return this, (t = JSON.parse(localStorage["troop-themes"]).popup_expires), (e = new Date().getTime()), parseFloat(t - e) <= 0 && (this.setResetTime(), !0);
                    }),
                    (t.prototype.setResetTime = function () {
                        var t, e, n;
                        return this, (t = new Date()), (n = 864e5 * this.show_again_after), (e = { popup_expires: t.setTime(t.getTime() + n) }), (localStorage["troop-themes"] = JSON.stringify(e)), this;
                    }),
                    t
                );
            })()),
            (theme.classes.ProductModel = (function (t) {
                function e() {
                    return e.__super__.constructor.apply(this, arguments);
                }
                return n(e, t), e;
            })(theme.classes.FrameworkProductModel)),
            (theme.classes.ProductRecommendations = (function (t) {
                function e() {
                    return e.__super__.constructor.apply(this, arguments);
                }
                return n(e, t), e;
            })(theme.classes.FrameworkProductRecommendations)),
            (theme.classes.ProductVideo = (function (t) {
                function e() {
                    return e.__super__.constructor.apply(this, arguments);
                }
                return n(e, t), e;
            })(theme.classes.FrameworkProductVideo)),
            (theme.classes.Radios = (function (t) {
                function e() {
                    return e.__super__.constructor.apply(this, arguments);
                }
                return n(e, t), e;
            })(theme.classes.FrameworkRadios)),
            (theme.classes.ServiceList = (function (t) {
                function e() {
                    return e.__super__.constructor.apply(this, arguments);
                }
                return n(e, t), e;
            })(theme.classes.FrameworkServiceList)),
            (theme.classes.XMenu = (function (t) {
                function i(t) {
                    (this.root = t),
                        (this.checkOverlap = e(this.checkOverlap, this)),
                        (this.alignSubmenus = e(this.alignSubmenus, this)),
                        (this.load = e(this.load, this)),
                        (this.cart_count = $(".header--cart-count")),
                        (this.hide_when_overlapping = $(".layout--header .layout--login, .layout--header .popup--open, .layout--header .cart-link, .layout--header .header--search")),
                        i.__super__.constructor.apply(this, arguments);
                }
                return (
                    n(i, t),
                    (i.prototype.load = function () {
                        return this, i.__super__.load.apply(this, arguments), this.alignSubmenus();
                    }),
                    (i.prototype.alignSubmenus = function () {
                        var t, e;
                        return (
                            this,
                            (t = $(".layout--header .fw--logo")),
                            (e = t.outerWidth()),
                            this.root.find('[data-x-menu--depth="3"] .x-menu--level-2--container').each(function () {
                                return $(this).css({ left: e, width: "calc(100% - " + e + "px)" });
                            })
                        );
                    }),
                    (i.prototype.checkOverlap = function () {
                        var t, e;
                        if (
                            ((t = this),
                            (e = $(".layout--header")),
                            t.cart_count.attr("data-menu-overlap", "false"),
                            e.attr("data-menu-overlap", "false"),
                            t.hide_when_overlapping.css({ display: "inline-block" }),
                            i.__super__.checkOverlap.apply(this, arguments),
                            "true" === t.root.attr("data-x-menu--overlap") && (e.attr("data-menu-overlap", "true"), t.hide_when_overlapping.hide(), parseInt(t.cart_count.find(".count").text()) > 0))
                        )
                            return t.cart_count.attr("data-menu-overlap", "true");
                    }),
                    i
                );
            })(theme.classes.FrameworkXMenu)),
            (theme.classes.Blog = (function (t) {
                function e() {
                    return e.__super__.constructor.apply(this, arguments);
                }
                return n(e, t), e;
            })(theme.classes.FrameworkBlog)),
            (theme.classes.CollectionPage = (function () {
                function t(t) {
                    var n;
                    (this.root = t), (this.matchImageHeights = e(this.matchImageHeights, this)), ((n = this).product_grid = n.root.find(".product-grid")), (n.items = n.product_grid.find(".block")), n.load();
                }
                return (
                    (t.prototype.load = function () {
                        return this, this.eventListeners(), this.matchImageHeights();
                    }),
                    (t.prototype.eventListeners = function () {
                        var t;
                        return (
                            (t = this),
                            $(window).on("resize.CollectionPage", function () {
                                return t.matchImageHeights();
                            })
                        );
                    }),
                    (t.prototype.matchImageHeights = function () {
                        return this, theme.utils.matchImageHeights(this.product_grid, this.items, ".product--image-wrapper");
                    }),
                    t
                );
            })()),
            (theme.classes.IndexCollection = (function () {
                function n(t) {
                    (this.container = t), (this.load = e(this.load, this)), this.load();
                }
                return (
                    (n.prototype.load = function () {
                        var e;
                        return (e = this).container.on("theme:section:load", function () {
                            return $(e.container.find(".fw--align--fill-y--dynamic")).each(function () {
                                return new t($(this), "fill-y--dynamic");
                            });
                        });
                    }),
                    n
                );
            })()),
            (theme.classes.ProductPage = (function () {
                function t(t) {
                    var n;
                    (this.root = t),
                        (this.pauseOtherMedia = e(this.pauseOtherMedia, this)),
                        (this.updateVariantMedia = e(this.updateVariantMedia, this)),
                        (this.variantSelected = e(this.variantSelected, this)),
                        (this.updateHistoryState = e(this.updateHistoryState, this)),
                        (this.updateVariantOnOptionChange = e(this.updateVariantOnOptionChange, this)),
                        (this.swapMedia = e(this.swapMedia, this)),
                        (this.addProductComplete = e(this.addProductComplete, this)),
                        (this.addToCartListener = e(this.addToCartListener, this)),
                        (this.resizeListeners = e(this.resizeListeners, this)),
                        (this.copyLink = e(this.copyLink, this)),
                        (this.reorderModalImages = e(this.reorderModalImages, this)),
                        (this.balanceColumns = e(this.balanceColumns, this)),
                        (this.indexContentBlocks = e(this.indexContentBlocks, this)),
                        (this.load = e(this.load, this)),
                        ((n = this).product = n.root.find(".partial--product")),
                        (n.smart_payment_buttons = n.root.find(".product-page--smart-payment-buttons")),
                        (n.variant_container = n.root.find(".product-page--variants")),
                        (n.actual_price = n.product.find(".actual-price")),
                        (n.add_button = n.product.find("button.add")),
                        (n.compare_price = n.product.find(".compare-price")),
                         (n.subscription_price = n.product.find(".subscription-price")),
                        (n.form = n.product.find(".add-to-cart form")),
                        (n.product_unavailable = n.product.find(".product--unavailable")),
                        (n.variant_listbox = n.product.find(".product-page--variant-select")),
                        (n.option_inputs = n.variant_container.find('[data-item="disclosure"], [data-item="radio"]')),
                        n.load();
                }
                return (
                    (t.prototype.load = function () {
                        var t;
                        if (
                            ((t = this).indexContentBlocks(),
                            t.copyLink(),
                            t.balanceColumns(),
                            t.reorderModalImages(),
                            t.resizeListeners(),
                            t.pauseOtherMedia(),
                            "drawer" === theme.settings.cart_type && t.addToCartListener(),
                            theme.product.variants.length > 1)
                        )
                            return t.updateVariantOnOptionChange();
                    }),
                    (t.prototype.indexContentBlocks = function () {
                        return $(".layout--main-content .product .content .block").each(function (t) {
                            return $(this).attr("data-block-index", t);
                        });
                    }),
                    (t.prototype.balanceColumns = function () {
                        var t, e, n, i, o, r;
                        return (
                            $(".layout--main-content .product .content .product-page--media"),
                            (r = (t = $(".layout--main-content .product .content")).find(".single-column")),
                            (e = t.find(".block")),
                            (i = t.find(".left-side")),
                            (o = t.find(".right-side")),
                            (n = t.find(".photo:not(.hidden-variant-image)").length),
                            (!e.find("iframe").length || "small" === theme.utils.mqs.current_window || !i.children().length) &&
                                (e
                                    .sort(function (t, e) {
                                        return +t.getAttribute("data-block-index") - +e.getAttribute("data-block-index");
                                    })
                                    .appendTo(r),
                                r.show(),
                                i.hide(),
                                o.hide(),
                                n > 0 && "small" !== theme.utils.mqs.current_window
                                    ? (e.each(function (t) {
                                          return i.outerHeight() <= o.outerHeight() ? $(this).appendTo(i) : $(this).appendTo(o);
                                      }),
                                      r.hide(),
                                      i.show(),
                                      o.show())
                                    : void 0)
                        );
                    }),
                    (t.prototype.reorderModalImages = function () {
                        var t, e, n, i;
                        return (
                            (i = (t = this).root.find(".modal--root >:not(.modal--content-wrapper) .product-page--media")),
                            (n = t.root.find(".modal--root .modal--content .product-page--media")),
                            (e = t.root.find(".modal--content-wrapper")),
                            i.each(function () {
                                var t;
                                return (t = n.filter("[data-id='" + $(this).attr("data-id") + "']").closest(".modal--content")), e.append(t);
                            })
                        );
                    }),
                    (t.prototype.copyLink = function () {
                        var t, e;
                        return (
                            (t = $(".partial--social-media .copy-link a")),
                            (e = t.parent().find("textarea")),
                            t.on("click", function () {
                                return e.toggle(), e.focus(), !1;
                            }),
                            t
                                .parent()
                                .find("textarea")
                                .on("focus", function () {
                                    var t;
                                    return (
                                        (t = $(this)).select(),
                                        t.on("mouseup", function () {
                                            return t.unbind("mouseup"), !1;
                                        })
                                    );
                                })
                        );
                    }),
                    (t.prototype.resizeListeners = function () {
                        var t;
                        return (
                            (t = this),
                            $(window).on("resize.TemplateProduct", function () {
                                return t.balanceColumns(), t.reorderModalImages();
                            })
                        );
                    }),
                    (t.prototype.addToCartListener = function () {
                        var t;
                        if ((t = this).form.length > 0 && "drawer" === theme.settings.cart_type)
                            return t.form.on("submit", function () {
                                return (
                                    t.form.find("p.error").remove(),
                                    t.add_button.addClass("loading"),
                                    theme.partials.Cart.addItem($(this), function (e, n) {
                                        return e
                                            ? theme.partials.Cart.updateAllHtml(function () {
                                                  return t.addProductComplete();
                                              })
                                            : (t.form.append("<p class='error'>" + n + "</p>"), t.add_button.removeClass("loading"));
                                    }),
                                    !1
                                );
                            });
                    }),
                    (t.prototype.addProductComplete = function () {
                        return this, this.add_button.removeClass("loading"), $('[data-off-canvas--open="right-sidebar"]').first().trigger("click");
                    }),
                    (t.prototype.swapMedia = function (t, e) {
                        var n, i;
                        return (n = t.clone()), (i = e.clone()), t.replaceWith(i), e.replaceWith(n);
                    }),
                    (t.prototype.updateVariantOnOptionChange = function () {
                        var t;
                        return (t = this).option_inputs.on("change", function () {
                            var e, n, i, o, r, s, a;
                            for (
                                e = t.variant_container.find('[data-item="disclosure"], [data-item="radio"]:checked'),
                                    o = [],
                                    e.each(function () {
                                        return o.push($(this).val().trim());
                                    }),
                                    a = o.join(" / "),
                                    n = 0,
                                    i = (r = theme.product.variants).length;
                                n < i;
                                n++
                            )
                                if ((s = r[n]).title === a) return t.updateHistoryState(s.id), selectCallback(s);
                            return selectCallback(!1);
                        });
                    }),
                    (t.prototype.updateHistoryState = function (t) {
                        var e;
                        return (e = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + t), window.history.replaceState({ path: e }, "", e);
                    }),
                    (t.prototype.variantSelected = function (t) {
                        var e, n, i;
                        (e = this).compare_price.html(""),
                            e.variant_listbox.find("option[selected]").removeAttr("selected"),
                            t && t.available
                                ? (e.add_button.show(), e.product_unavailable.hide(), e.smart_payment_buttons.show(), e.variant_listbox.find("option[value='" + t.id + "']").attr("selected", ""))
                                : (e.add_button.hide(), e.smart_payment_buttons.hide(), e.product_unavailable.show()),
                            t &&
                                ((n = theme.utils.formatMoney(t.price)),
                                e.actual_price.html(n),
                                t.compare_at_price > t.price && ((i = theme.utils.formatMoney(t.compare_at_price)), e.compare_price.html(i)),
                                t.selling_plan_allocations[0]?.price !== 'undefined' && (e.subscription_price.html(theme.utils.formatMoney(t.selling_plan_allocations[0]?.price))),
                                t.featured_media ? e.updateVariantMedia(t.featured_media.id) : e.updateVariantMedia(0));
                    }),
                    (t.prototype.updateVariantMedia = function (t) {
                        var e, n, i, o, r, s, a;
                        (e = this),
                            (n = (a = $(".product")).find(".product-page--featured-media .product-page--media")),
                            (s = a.find(".content .image-wrapper .product-page--media")),
                            (i = a.closest(".modal--root").find(".modal--content .product-page--media")),
                            t && t !== n.data("id") && ((o = s.filter("[data-id='" + t + "']")), (r = i.filter("[data-id='" + t + "']")), e.swapMedia(n, o), e.swapMedia(i.first(), r), e.balanceColumns(), e.reorderModalImages());
                    }),
                    (t.prototype.pauseOtherMedia = function () {
                        var t;
                        return (t = this).root.find(".product-page--media > *").on("click", function () {
                            return t.root.find(".product-page--media > *").not(this).trigger("pause-media");
                        });
                    }),
                    t
                );
            })()),
            (theme.classes.ProductPageNew = (function () {
                function t(t) {
                    var n;
                    (this.root = t),
                        (this.pauseOtherMedia = e(this.pauseOtherMedia, this)),
                        (this.updateVariantMedia = e(this.updateVariantMedia, this)),
                        (this.variantSelected = e(this.variantSelected, this)),
                        (this.updateHistoryState = e(this.updateHistoryState, this)),
                        (this.updateVariantOnOptionChange = e(this.updateVariantOnOptionChange, this)),
                        (this.swapMedia = e(this.swapMedia, this)),
                        (this.addProductComplete = e(this.addProductComplete, this)),
                        (this.addToCartListener = e(this.addToCartListener, this)),
                        (this.resizeListeners = e(this.resizeListeners, this)),
                        (this.copyLink = e(this.copyLink, this)),
                        (this.reorderModalImages = e(this.reorderModalImages, this)),
                        (this.balanceColumns = e(this.balanceColumns, this)),
                        (this.indexContentBlocks = e(this.indexContentBlocks, this)),
                        (this.load = e(this.load, this)),
                        ((n = this).product = n.root.find(".partial--product")),
                        (n.smart_payment_buttons = n.root.find(".product-page--smart-payment-buttons")),
                        (n.variant_container = n.root.find(".product-page--variants")),
                        (n.actual_price = n.product.find(".actual-price")),
                        (n.add_button = n.product.find("button.add")),
                        (n.compare_price = n.product.find(".compare-price")),
                        (n.form = n.product.find(".add-to-cart form")),
                        (n.subscription_price = n.product.find(".subscription-price")),
                        (n.in_stock_text = n.product.find(".in-stock-text")),
                        (n.product_unavailable = n.product.find(".product--unavailable")),
                        (n.variant_listbox = n.product.find("[name='id']")),
                        (n.option_inputs = n.variant_container.find('[data-item="disclosure"], [data-item="radio"]')),
                        n.load();
                }
                return (
                    (t.prototype.load = function () {
                        var t;
                        if (
                            ((t = this).indexContentBlocks(),
                            t.copyLink(),
                            t.balanceColumns(),
                            t.reorderModalImages(),
                            t.resizeListeners(),
                            t.pauseOtherMedia(),
                            "drawer" === theme.settings.cart_type && t.addToCartListener(),
                            theme.product.variants.length > 1)
                        )
                            return t.updateVariantOnOptionChange();
                    }),
                    (t.prototype.indexContentBlocks = function () {
                        return $(".layout--main-content .product .content .block").each(function (t) {
                            return $(this).attr("data-block-index", t);
                        });
                    }),
                    (t.prototype.balanceColumns = function () {
                        var t, e, n, i, o, r;
                        return (
                            $(".layout--main-content .product .content .product-page--media"),
                            (r = (t = $(".layout--main-content .product .content")).find(".single-column")),
                            (e = t.find(".block")),
                            (i = t.find(".left-side")),
                            (o = t.find(".right-side")),
                            (n = t.find(".photo:not(.hidden-variant-image)").length),
                            (!e.find("iframe").length || "small" === theme.utils.mqs.current_window || !i.children().length) &&
                                (e
                                    .sort(function (t, e) {
                                        return +t.getAttribute("data-block-index") - +e.getAttribute("data-block-index");
                                    })
                                    .appendTo(r),
                                r.show(),
                                i.hide(),
                                o.hide(),
                                n > 0 && "small" !== theme.utils.mqs.current_window
                                    ? (e.each(function (t) {
                                          return i.outerHeight() <= o.outerHeight() ? $(this).appendTo(i) : $(this).appendTo(o);
                                      }),
                                      r.hide(),
                                      i.show(),
                                      o.show())
                                    : void 0)
                        );
                    }),
                    (t.prototype.reorderModalImages = function () {
                        var t, e, n, i;
                        return (
                            (i = (t = this).root.find(".modal--root >:not(.modal--content-wrapper) .product-page--media")),
                            (n = t.root.find(".modal--root .modal--content .product-page--media")),
                            (e = t.root.find(".modal--content-wrapper")),
                            i.each(function () {
                                var t;
                                return (t = n.filter("[data-id='" + $(this).attr("data-id") + "']").closest(".modal--content")), e.append(t);
                            })
                        );
                    }),
                    (t.prototype.copyLink = function () {
                        var t, e;
                        return (
                            (t = $(".partial--social-media .copy-link a")),
                            (e = t.parent().find("textarea")),
                            t.on("click", function () {
                                return e.toggle(), e.focus(), !1;
                            }),
                            t
                                .parent()
                                .find("textarea")
                                .on("focus", function () {
                                    var t;
                                    return (
                                        (t = $(this)).select(),
                                        t.on("mouseup", function () {
                                            return t.unbind("mouseup"), !1;
                                        })
                                    );
                                })
                        );
                    }),
                    (t.prototype.resizeListeners = function () {
                        var t;
                        return (
                            (t = this),
                            $(window).on("resize.TemplateProduct", function () {
                                return t.balanceColumns(), t.reorderModalImages();
                            })
                        );
                    }),
                    (t.prototype.addToCartListener = function () {
                        var t;
                        if ((t = this).form.length > 0 && "drawer" === theme.settings.cart_type)
                            return t.form.on("submit", function () {
                                return (
                                    t.form.find("p.error").remove(),
                                    t.add_button.addClass("loading"),
                                    theme.partials.Cart.addItem($(this), function (e, n) {
                                        return e
                                            ? theme.partials.Cart.updateAllHtml(function () {
                                                  return t.addProductComplete();
                                              })
                                            : (t.form.append("<p class='error'>" + n + "</p>"), t.add_button.removeClass("loading"));
                                    }),
                                    !1
                                );
                            });
                    }),
                    (t.prototype.addProductComplete = function () {
                        return this, this.add_button.removeClass("loading"), $('[data-off-canvas--open="right-sidebar"]').first().trigger("click");
                    }),
                    (t.prototype.swapMedia = function (t, e) {
                        var n, i;
                        return (n = t.clone()), (i = e.clone()), t.replaceWith(i), e.replaceWith(n);
                    }),
                    (t.prototype.updateVariantOnOptionChange = function () {
                        var t;
                        return (t = this).option_inputs.on("change", function () {
                            var e, n, i, o, r, s, a;
                            for (
                                e = t.variant_container.find('[data-item="disclosure"], [data-item="radio"]:checked'),
                                    o = [],
                                    e.each(function () {
                                        return o.push($(this).val().trim());
                                    }),
                                    a = o.join(" / "),
                                    n = 0,
                                    i = (r = theme.product.variants).length;
                                n < i;
                                n++
                            )
                                if ((s = r[n]).title === a) return t.updateHistoryState(s.id), selectCallback(s);
                            return selectCallback(!1);
                        });
                    }),
                    (t.prototype.updateHistoryState = function (t) {
                        var e;
                        return (e = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + t), window.history.replaceState({ path: e }, "", e);
                    }),
                    (t.prototype.variantSelected = function (t) {
                        var e, n, i;
                      
                      
                        (e = this).compare_price.html(""),
                            t ? e.variant_listbox.each(function(){$(this).val(t.id);}) : '';
                            t && t.available
                                ? (e.add_button.find('.text').html(window.variantStrings.addToCart), e.smart_payment_buttons.show(), e.add_button.removeAttr('disabled'), e.in_stock_text.show())
                                : (t ? (e.add_button.find('.text').html(window.variantStrings.soldOut), e.smart_payment_buttons.hide(), e.add_button.attr('disabled','disabled'), e.in_stock_text.hide()) : (e.add_button.find('.text').html(window.variantStrings.unavailable), e.smart_payment_buttons.hide(), e.add_button.attr('disabled','disabled'), e.in_stock_text.hide())),
                            t &&
                                ((n = theme.utils.formatMoney(t.price)),
                                e.actual_price.html(n),
                                t.compare_at_price > t.price && ((i = theme.utils.formatMoney(t.compare_at_price)), e.compare_price.html(i)),
                                t.selling_plan_allocations[0]?.price !== 'undefined' && (e.subscription_price.html(theme.utils.formatMoney(t.selling_plan_allocations[0]?.price))),
                                t.featured_media ? e.updateVariantMedia(t.featured_media.id) : e.updateVariantMedia(0));
                    }),
                    (t.prototype.updateVariantMedia = function (t) {
                        var e, n, i, o, r, s, a;
                        (e = this),
                            (n = (a = $(".product")).find(".product-page--featured-media .product-page--media")),
                            (s = a.find(".content .image-wrapper .product-page--media")),
                            (i = a.closest(".modal--root").find(".modal--content .product-page--media")),
                            t && t !== n.data("id") && ((o = s.filter("[data-id='" + t + "']")), (r = i.filter("[data-id='" + t + "']")), e.swapMedia(n, o), e.swapMedia(i.first(), r), e.balanceColumns(), e.reorderModalImages());
                    }),
                    (t.prototype.pauseOtherMedia = function () {
                        var t;
                        return (t = this).root.find(".product-page--media > *").on("click", function () {
                            return t.root.find(".product-page--media > *").not(this).trigger("pause-media");
                        });
                    }),
                    t
                );
            })()),
            jQuery(function (e) {
                var n, i, o;
                return (
                    (n = e("body")),
                    e(".layout--main-content"),
                    e(".template--product .partial--product.view--full .actual-price").addClass("money"),
                    (theme.sections = new theme.classes.Sections()),
                    (i = new theme.classes.FrameworkMediaQueries()),
                    (theme.utils = new theme.classes.FrameworkUtils()),
                    (theme.a11y = new theme.classes.FrameworkA11y()),
                    (theme.utils.mqs = i),
                    (theme.utils.a11yClick = function (t) {
                        var e;
                        return "click" === t.type || ("keypress" === t.type && (32 === (e = t.charCode || t.keyCode) && t.preventDefault(), 32 === e || 13 === e || void 0));
                    }),
                    (theme.utils.loadJsClasses = function () {
                        return e("[data-js-class]").each(function () {
                            var t, n;
                            if (((t = e(this).attr("data-js-class")), "true" !== e(this).attr("data-js-loaded") && void 0 !== (n = theme.classes[t]))) return (theme.partials[t] = new n(e(this))), e(this).attr("data-js-loaded", "true");
                        });
                    }),
                    e("a").each(function () {
                        var t;
                        return (
                            (t = e(this)),
                            this.host === location.host
                                ? t.attr("target", "_self")
                                : t.attr("target", "_blank").attr("rel", function (t, e) {
                                      return [e || "", "noopener"].join(" ");
                                  })
                        );
                    }),
                    "undefined" != typeof InstallTrigger && e("img").addClass("image-scale-hack"),
                    e(".fw--align--left").each(function () {
                        return new t(e(this), "left");
                    }),
                    e(".fw--align--center-x").each(function () {
                        return new t(e(this), "center-x");
                    }),
                    e(".fw--align--right").each(function () {
                        return new t(e(this), "right");
                    }),
                    e(".fw--align--top").each(function () {
                        return new t(e(this), "top");
                    }),
                    e(".fw--align--center-y").each(function () {
                        return new t(e(this), "center-y");
                    }),
                    e(".fw--align--bottom").each(function () {
                        return new t(e(this), "bottom");
                    }),
                    e(".partial--popup #mc-embedded-subscribe-form").on("submit", function (t) {
                        return e(".modal .close").click(), !0;
                    }),
                    e(".partial--popup #contact_form").on("submit", function (t) {
                        var n, i, o;
                        return (
                            (n = this),
                            (i = e(this).closest(".partial--popup")).find(".error, .success").remove(),
                            (o = i.find(".wrapper")),
                            t.preventDefault(),
                            0 !== i.find('[type="email"]').val().length &&
                                (o
                                    .find("*")
                                    .remove()
                                    .end()
                                    .prepend('<p class="success">' + theme.translations.mailing_list_success_message + "</p>")
                                    .show(),
                                setTimeout(function () {
                                    return n.submit();
                                }, 500),
                                !1)
                        );
                    }),
                    n.hasClass("template--search") &&
                        e(document).on("shopify:section:load", function () {
                            return checkLogoHeight();
                        }),
                    n.hasClass("template--password") &&
                        (e(document)
                            .on("click", ".password--login-link", function () {
                                return e(this).css("visibility", "hidden"), e(".password--main > *").hide(), e(".password--login-form").css("visibility", "visible"), e('.password--login-form input[type="password"]').focus(), !1;
                            })
                            .on("click", ".password--login-form .cancel", function () {
                                return e(".password--login-link").css("visibility", "visible"), e(".password--main > *").fadeIn(), e(".password--login-form").css("visibility", "hidden"), !1;
                            }),
                        e(".password--login-form .errors").size() && e(".password--login-link").click()),
                    (function () {
                        if (e(".sdd-download").length) return e(".sdd-download-button").removeClass("sdd-download-button").css("visibility", "visible");
                    })(),
                    theme.utils.loadJsClasses(),
                    (o = null),
                    e(window).on("resize", function () {
                        return (
                            clearTimeout(o),
                            (o = setTimeout(function () {
                                return e(".fw--align--fill-y--dynamic").each(function () {
                                    return new t(e(this), "fill-y--dynamic");
                                });
                            }, 250))
                        );
                    }),
                    e("#admin_bar_iframe").on("load", function () {
                        if ("none" === e("#admin_bar_iframe").contents().find("#storefront-bar-minimized").css("display"))
                            return setTimeout(function () {
                                return e("html").css("padding-top", "40px");
                            }, 10);
                    }),
                    e(".fw--align--fill-y--dynamic").each(function () {
                        return new t(e(this), "fill-y--dynamic");
                    }),
                    e(".fw--align--max-img-height").each(function () {
                        return new t(e(this), "max-img-height");
                    }),
                    e("html").addClass("after-js-loaded"),
                    setTimeout(function () {
                        return e(".owl-carousel").each(function () {
                            return e(this).data("owlCarousel").calculateAll();
                        });
                    }, 0)
                );
            });
    }.call(this);

$(document).ready(function(){
   $("body").on("click", ".faq-acc-header", function (f) {
    f.preventDefault();
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".faq-acc-body").slideUp(200);
    } else {
      $(".faq-acc-header").removeClass("active");
      $(this).addClass("active");
      $(".faq-acc-body").slideUp(200);
      $(this).siblings(".faq-acc-body").slideDown(200);
    }
  });

  //subscription change
  $('body').on('change' , '.subscribe-check-input , .subscribe-select' , function(){
    let selling_plans_div = $(this).closest('[data-product-subscription]');
    let selling_plan_input = $(this).closest('.product-info').find('[name="selling_plan"]');
    if(selling_plans_div.find('[data-radio-type="selling_plan"]').prop('checked') == true){
      selling_plan_input.val(selling_plans_div.find('[name="product-selling_plan"]').val());
      $(this).closest('.product-info').find('button[name="add"]').addClass('on-subscription');
    }else{
      selling_plan_input.val('');
      $(this).closest('.product-info').find('button[name="add"]').removeClass('on-subscription');
    }
  });
  //jump to subscription on load
  $('[data-radio-type="selling_plan"]').trigger('click');

});

